
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
let $8863cd8fe199f948$var$taskIdCounter = 1, $8863cd8fe199f948$var$isCallbackScheduled = false, $8863cd8fe199f948$var$isPerformingWork = false, $8863cd8fe199f948$var$taskQueue = [], $8863cd8fe199f948$var$currentTask = null, $8863cd8fe199f948$var$shouldYieldToHost = null, $8863cd8fe199f948$var$yieldInterval = 5, $8863cd8fe199f948$var$deadline = 0, $8863cd8fe199f948$var$maxYieldInterval = 300, $8863cd8fe199f948$var$maxDeadline = 0, $8863cd8fe199f948$var$scheduleCallback = null, $8863cd8fe199f948$var$scheduledCallback = null;
const $8863cd8fe199f948$var$maxSigned31BitInt = 1073741823;
function $8863cd8fe199f948$var$setupScheduler() {
    const channel = new MessageChannel(), port1 = channel.port1, port = channel.port2;
    if (typeof port1.unref === "function") port1.unref();
    if (typeof port.unref === "function") port.unref();
    $8863cd8fe199f948$var$scheduleCallback = ()=>port.postMessage(null);
    port1.onmessage = ()=>{
        if ($8863cd8fe199f948$var$scheduledCallback !== null) {
            const currentTime = performance.now();
            $8863cd8fe199f948$var$deadline = currentTime + $8863cd8fe199f948$var$yieldInterval;
            $8863cd8fe199f948$var$maxDeadline = currentTime + $8863cd8fe199f948$var$maxYieldInterval;
            try {
                const hasMoreWork = $8863cd8fe199f948$var$scheduledCallback(currentTime);
                if (!hasMoreWork) $8863cd8fe199f948$var$scheduledCallback = null;
                else port.postMessage(null);
            } catch (error) {
                port.postMessage(null);
                throw error;
            }
        }
    };
    if (navigator && navigator.scheduling && navigator.scheduling.isInputPending) {
        const scheduling = navigator.scheduling;
        $8863cd8fe199f948$var$shouldYieldToHost = ()=>{
            const currentTime = performance.now();
            if (currentTime >= $8863cd8fe199f948$var$deadline) {
                if (scheduling.isInputPending()) return true;
                return currentTime >= $8863cd8fe199f948$var$maxDeadline;
            } else return false;
        };
    } else $8863cd8fe199f948$var$shouldYieldToHost = ()=>performance.now() >= $8863cd8fe199f948$var$deadline;
}
function $8863cd8fe199f948$var$enqueue(taskQueue, task) {
    function findIndex() {
        let m = 0;
        let n = taskQueue.length - 1;
        while(m <= n){
            const k = n + m >> 1;
            const cmp = task.expirationTime - taskQueue[k].expirationTime;
            if (cmp > 0) m = k + 1;
            else if (cmp < 0) n = k - 1;
            else return k;
        }
        return m;
    }
    taskQueue.splice(findIndex(), 0, task);
}
function $8863cd8fe199f948$export$4b5e076b3a2fbe0a(fn, options) {
    if (!$8863cd8fe199f948$var$scheduleCallback) $8863cd8fe199f948$var$setupScheduler();
    let startTime = performance.now(), timeout = $8863cd8fe199f948$var$maxSigned31BitInt;
    if (options && options.timeout) timeout = options.timeout;
    const newTask = {
        id: $8863cd8fe199f948$var$taskIdCounter++,
        fn: fn,
        startTime: startTime,
        expirationTime: startTime + timeout
    };
    $8863cd8fe199f948$var$enqueue($8863cd8fe199f948$var$taskQueue, newTask);
    if (!$8863cd8fe199f948$var$isCallbackScheduled && !$8863cd8fe199f948$var$isPerformingWork) {
        $8863cd8fe199f948$var$isCallbackScheduled = true;
        $8863cd8fe199f948$var$scheduledCallback = $8863cd8fe199f948$var$flushWork;
        $8863cd8fe199f948$var$scheduleCallback();
    }
    return newTask;
}
function $8863cd8fe199f948$export$b888d8f981c07a46(task) {
    task.fn = null;
}
function $8863cd8fe199f948$var$flushWork(initialTime) {
    $8863cd8fe199f948$var$isCallbackScheduled = false;
    $8863cd8fe199f948$var$isPerformingWork = true;
    try {
        return $8863cd8fe199f948$var$workLoop(initialTime);
    } finally{
        $8863cd8fe199f948$var$currentTask = null;
        $8863cd8fe199f948$var$isPerformingWork = false;
    }
}
function $8863cd8fe199f948$var$workLoop(initialTime) {
    let currentTime = initialTime;
    $8863cd8fe199f948$var$currentTask = $8863cd8fe199f948$var$taskQueue[0] || null;
    while($8863cd8fe199f948$var$currentTask !== null){
        if ($8863cd8fe199f948$var$currentTask.expirationTime > currentTime && $8863cd8fe199f948$var$shouldYieldToHost()) break;
        const callback = $8863cd8fe199f948$var$currentTask.fn;
        if (callback !== null) {
            $8863cd8fe199f948$var$currentTask.fn = null;
            const didUserCallbackTimeout = $8863cd8fe199f948$var$currentTask.expirationTime <= currentTime;
            callback(didUserCallbackTimeout);
            currentTime = performance.now();
            if ($8863cd8fe199f948$var$currentTask === $8863cd8fe199f948$var$taskQueue[0]) $8863cd8fe199f948$var$taskQueue.shift();
        } else $8863cd8fe199f948$var$taskQueue.shift();
        $8863cd8fe199f948$var$currentTask = $8863cd8fe199f948$var$taskQueue[0] || null;
    }
    return $8863cd8fe199f948$var$currentTask !== null;
}
const $8863cd8fe199f948$export$2cb4986bed338027 = {
    context: undefined,
    registry: undefined,
    effects: undefined,
    done: false,
    getContextId () {
        return $8863cd8fe199f948$var$getContextId(this.context.count);
    },
    getNextContextId () {
        return $8863cd8fe199f948$var$getContextId(this.context.count++);
    }
};
function $8863cd8fe199f948$var$getContextId(count) {
    const num = String(count), len = num.length - 1;
    return $8863cd8fe199f948$export$2cb4986bed338027.context.id + (len ? String.fromCharCode(96 + len) : "") + num;
}
function $8863cd8fe199f948$var$setHydrateContext(context) {
    $8863cd8fe199f948$export$2cb4986bed338027.context = context;
}
function $8863cd8fe199f948$var$nextHydrateContext() {
    return {
        ...$8863cd8fe199f948$export$2cb4986bed338027.context,
        id: $8863cd8fe199f948$export$2cb4986bed338027.getNextContextId(),
        count: 0
    };
}
const $8863cd8fe199f948$var$IS_DEV = false;
const $8863cd8fe199f948$export$34b67c27f2ca7498 = (a, b)=>a === b;
const $8863cd8fe199f948$export$5cd89106e2f6c2c5 = Symbol("solid-proxy");
const $8863cd8fe199f948$var$SUPPORTS_PROXY = typeof Proxy === "function";
const $8863cd8fe199f948$export$17a675b7c02a7b1d = Symbol("solid-track");
const $8863cd8fe199f948$export$f5625ae0b78e5b20 = Symbol("solid-dev-component");
const $8863cd8fe199f948$var$signalOptions = {
    equals: $8863cd8fe199f948$export$34b67c27f2ca7498
};
let $8863cd8fe199f948$var$ERROR = null;
let $8863cd8fe199f948$var$runEffects = $8863cd8fe199f948$var$runQueue;
const $8863cd8fe199f948$var$STALE = 1;
const $8863cd8fe199f948$var$PENDING = 2;
const $8863cd8fe199f948$var$UNOWNED = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
const $8863cd8fe199f948$var$NO_INIT = {};
var $8863cd8fe199f948$var$Owner = null;
let $8863cd8fe199f948$var$Transition = null;
let $8863cd8fe199f948$var$Scheduler = null;
let $8863cd8fe199f948$var$ExternalSourceConfig = null;
let $8863cd8fe199f948$var$Listener = null;
let $8863cd8fe199f948$var$Updates = null;
let $8863cd8fe199f948$var$Effects = null;
let $8863cd8fe199f948$var$ExecCount = 0;
function $8863cd8fe199f948$export$882461b6382ed46c(fn, detachedOwner) {
    const listener = $8863cd8fe199f948$var$Listener, owner = $8863cd8fe199f948$var$Owner, unowned = fn.length === 0, current = detachedOwner === undefined ? owner : detachedOwner, root = unowned ? $8863cd8fe199f948$var$UNOWNED : {
        owned: null,
        cleanups: null,
        context: current ? current.context : null,
        owner: current
    }, updateFn = unowned ? fn : ()=>fn(()=>$8863cd8fe199f948$export$363ebc4b78b8f807(()=>$8863cd8fe199f948$var$cleanNode(root)));
    $8863cd8fe199f948$var$Owner = root;
    $8863cd8fe199f948$var$Listener = null;
    try {
        return $8863cd8fe199f948$var$runUpdates(updateFn, true);
    } finally{
        $8863cd8fe199f948$var$Listener = listener;
        $8863cd8fe199f948$var$Owner = owner;
    }
}
function $8863cd8fe199f948$export$c1e1e1ecbbe76a5(value, options) {
    options = options ? Object.assign({}, $8863cd8fe199f948$var$signalOptions, options) : $8863cd8fe199f948$var$signalOptions;
    const s = {
        value: value,
        observers: null,
        observerSlots: null,
        comparator: options.equals || undefined
    };
    const setter = (value)=>{
        if (typeof value === "function") {
            if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(s)) value = value(s.tValue);
            else value = value(s.value);
        }
        return $8863cd8fe199f948$var$writeSignal(s, value);
    };
    return [
        $8863cd8fe199f948$var$readSignal.bind(s),
        setter
    ];
}
function $8863cd8fe199f948$export$234a23cdc77e6a3d(fn, value, options) {
    const c = $8863cd8fe199f948$var$createComputation(fn, value, true, $8863cd8fe199f948$var$STALE);
    if ($8863cd8fe199f948$var$Scheduler && $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) $8863cd8fe199f948$var$Updates.push(c);
    else $8863cd8fe199f948$var$updateComputation(c);
}
function $8863cd8fe199f948$export$314dade334ae905d(fn, value, options) {
    const c = $8863cd8fe199f948$var$createComputation(fn, value, false, $8863cd8fe199f948$var$STALE);
    if ($8863cd8fe199f948$var$Scheduler && $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) $8863cd8fe199f948$var$Updates.push(c);
    else $8863cd8fe199f948$var$updateComputation(c);
}
function $8863cd8fe199f948$export$7ea7134f704deda4(fn, value, options) {
    $8863cd8fe199f948$var$runEffects = $8863cd8fe199f948$var$runUserEffects;
    const c = $8863cd8fe199f948$var$createComputation(fn, value, false, $8863cd8fe199f948$var$STALE), s = $8863cd8fe199f948$var$SuspenseContext && $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseContext);
    if (s) c.suspense = s;
    if (!options || !options.render) c.user = true;
    $8863cd8fe199f948$var$Effects ? $8863cd8fe199f948$var$Effects.push(c) : $8863cd8fe199f948$var$updateComputation(c);
}
function $8863cd8fe199f948$export$5ce14d95ebb45542(onInvalidate, options) {
    let fn;
    const c = $8863cd8fe199f948$var$createComputation(()=>{
        fn ? fn() : $8863cd8fe199f948$export$363ebc4b78b8f807(onInvalidate);
        fn = undefined;
    }, undefined, false, 0), s = $8863cd8fe199f948$var$SuspenseContext && $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseContext);
    if (s) c.suspense = s;
    c.user = true;
    return (tracking)=>{
        fn = tracking;
        $8863cd8fe199f948$var$updateComputation(c);
    };
}
function $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(fn, value, options) {
    options = options ? Object.assign({}, $8863cd8fe199f948$var$signalOptions, options) : $8863cd8fe199f948$var$signalOptions;
    const c = $8863cd8fe199f948$var$createComputation(fn, value, true, 0);
    c.observers = null;
    c.observerSlots = null;
    c.comparator = options.equals || undefined;
    if ($8863cd8fe199f948$var$Scheduler && $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
        c.tState = $8863cd8fe199f948$var$STALE;
        $8863cd8fe199f948$var$Updates.push(c);
    } else $8863cd8fe199f948$var$updateComputation(c);
    return $8863cd8fe199f948$var$readSignal.bind(c);
}
function $8863cd8fe199f948$var$isPromise(v) {
    return v && typeof v === "object" && "then" in v;
}
function $8863cd8fe199f948$export$edd172c6c83c39cc(pSource, pFetcher, pOptions) {
    let source;
    let fetcher;
    let options;
    if (typeof pFetcher === "function") {
        source = pSource;
        fetcher = pFetcher;
        options = pOptions || {};
    } else {
        source = true;
        fetcher = pSource;
        options = pFetcher || {};
    }
    let pr = null, initP = $8863cd8fe199f948$var$NO_INIT, id = null, loadedUnderTransition = false, scheduled = false, resolved = "initialValue" in options, dynamic = typeof source === "function" && $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(source);
    const contexts = new Set(), [value, setValue] = (options.storage || $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(options.initialValue), [error, setError] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined), [track, trigger] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined, {
        equals: false
    }), [state, setState] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(resolved ? "ready" : "unresolved");
    if ($8863cd8fe199f948$var$Owner) $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>{
        for (const c of contexts.keys())c.decrement();
        contexts.clear();
        if ($8863cd8fe199f948$var$Transition && pr) $8863cd8fe199f948$var$Transition.promises.delete(pr);
        pr = null;
    });
    if ($8863cd8fe199f948$export$2cb4986bed338027.context) {
        id = $8863cd8fe199f948$export$2cb4986bed338027.getNextContextId();
        if (options.ssrLoadFrom === "initial") initP = options.initialValue;
        else if ($8863cd8fe199f948$export$2cb4986bed338027.load && $8863cd8fe199f948$export$2cb4986bed338027.has(id)) initP = $8863cd8fe199f948$export$2cb4986bed338027.load(id);
    }
    function loadEnd(p, v, error, key) {
        if (pr === p) {
            pr = null;
            key !== undefined && (resolved = true);
            if ((p === initP || v === initP) && options.onHydrated) queueMicrotask(()=>options.onHydrated(key, {
                    value: v
                }));
            initP = $8863cd8fe199f948$var$NO_INIT;
            if ($8863cd8fe199f948$var$Transition && p && loadedUnderTransition) {
                $8863cd8fe199f948$var$Transition.promises.delete(p);
                loadedUnderTransition = false;
                $8863cd8fe199f948$var$runUpdates(()=>{
                    $8863cd8fe199f948$var$Transition.running = true;
                    completeLoad(v, error);
                }, false);
            } else completeLoad(v, error);
        }
        return v;
    }
    function completeLoad(v, err) {
        $8863cd8fe199f948$var$runUpdates(()=>{
            if (err === undefined) setValue(()=>v);
            setState(err !== undefined ? "errored" : resolved ? "ready" : "unresolved");
            setError(err);
            for (const c of contexts.keys())c.decrement();
            contexts.clear();
        }, false);
    }
    function read() {
        const c = $8863cd8fe199f948$var$SuspenseContext && $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseContext), v = value(), err = error();
        if (err !== undefined && !pr) throw err;
        if ($8863cd8fe199f948$var$Listener && !$8863cd8fe199f948$var$Listener.user && c) $8863cd8fe199f948$export$234a23cdc77e6a3d(()=>{
            track();
            if (pr) {
                if (c.resolved && $8863cd8fe199f948$var$Transition && loadedUnderTransition) $8863cd8fe199f948$var$Transition.promises.add(pr);
                else if (!contexts.has(c)) {
                    c.increment();
                    contexts.add(c);
                }
            }
        });
        return v;
    }
    function load(refetching = true) {
        if (refetching !== false && scheduled) return;
        scheduled = false;
        const lookup = dynamic ? dynamic() : source;
        loadedUnderTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
        if (lookup == null || lookup === false) {
            loadEnd(pr, $8863cd8fe199f948$export$363ebc4b78b8f807(value));
            return;
        }
        if ($8863cd8fe199f948$var$Transition && pr) $8863cd8fe199f948$var$Transition.promises.delete(pr);
        let error;
        const p = initP !== $8863cd8fe199f948$var$NO_INIT ? initP : $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
            try {
                return fetcher(lookup, {
                    value: value(),
                    refetching: refetching
                });
            } catch (fetcherError) {
                error = fetcherError;
            }
        });
        if (error !== undefined) {
            loadEnd(pr, undefined, $8863cd8fe199f948$var$castError(error), lookup);
            return;
        } else if (!$8863cd8fe199f948$var$isPromise(p)) {
            loadEnd(pr, p, undefined, lookup);
            return p;
        }
        pr = p;
        if ("v" in p) {
            if (p.s === 1) loadEnd(pr, p.v, undefined, lookup);
            else loadEnd(pr, undefined, $8863cd8fe199f948$var$castError(p.v), lookup);
            return p;
        }
        scheduled = true;
        queueMicrotask(()=>scheduled = false);
        $8863cd8fe199f948$var$runUpdates(()=>{
            setState(resolved ? "refreshing" : "pending");
            trigger();
        }, false);
        return p.then((v)=>loadEnd(p, v, undefined, lookup), (e)=>loadEnd(p, undefined, $8863cd8fe199f948$var$castError(e), lookup));
    }
    Object.defineProperties(read, {
        state: {
            get: ()=>state()
        },
        error: {
            get: ()=>error()
        },
        loading: {
            get () {
                const s = state();
                return s === "pending" || s === "refreshing";
            }
        },
        latest: {
            get () {
                if (!resolved) return read();
                const err = error();
                if (err && !pr) throw err;
                return value();
            }
        }
    });
    let owner = $8863cd8fe199f948$var$Owner;
    if (dynamic) $8863cd8fe199f948$export$234a23cdc77e6a3d(()=>(owner = $8863cd8fe199f948$var$Owner, load(false)));
    else load(false);
    return [
        read,
        {
            refetch: (info)=>$8863cd8fe199f948$export$c14f3e3abbc7d6b5(owner, ()=>load(info)),
            mutate: setValue
        }
    ];
}
function $8863cd8fe199f948$export$e673efccd97e4223(source, options) {
    let t, timeout = options ? options.timeoutMs : undefined;
    const node = $8863cd8fe199f948$var$createComputation(()=>{
        if (!t || !t.fn) t = $8863cd8fe199f948$export$4b5e076b3a2fbe0a(()=>setDeferred(()=>node.value), timeout !== undefined ? {
            timeout: timeout
        } : undefined);
        return source();
    }, undefined, true);
    const [deferred, setDeferred] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value, options);
    $8863cd8fe199f948$var$updateComputation(node);
    setDeferred(()=>$8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value);
    return deferred;
}
function $8863cd8fe199f948$export$595d22ed68ca2841(source, fn = $8863cd8fe199f948$export$34b67c27f2ca7498, options) {
    const subs = new Map();
    const node = $8863cd8fe199f948$var$createComputation((p)=>{
        const v = source();
        for (const [key, val] of subs.entries())if (fn(key, v) !== fn(key, p)) for (const c of val.values()){
            if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) c.tState = $8863cd8fe199f948$var$STALE;
            else c.state = $8863cd8fe199f948$var$STALE;
            if (c.pure) $8863cd8fe199f948$var$Updates.push(c);
            else $8863cd8fe199f948$var$Effects.push(c);
        }
        return v;
    }, undefined, true, $8863cd8fe199f948$var$STALE);
    $8863cd8fe199f948$var$updateComputation(node);
    return (key)=>{
        const listener = $8863cd8fe199f948$var$Listener;
        if (listener) {
            let l;
            if (l = subs.get(key)) l.add(listener);
            else subs.set(key, l = new Set([
                listener
            ]));
            $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>{
                l.delete(listener);
                !l.size && subs.delete(key);
            });
        }
        return fn(key, $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value);
    };
}
function $8863cd8fe199f948$export$712ea50be43a7858(fn) {
    return $8863cd8fe199f948$var$runUpdates(fn, false);
}
function $8863cd8fe199f948$export$363ebc4b78b8f807(fn) {
    if (!$8863cd8fe199f948$var$ExternalSourceConfig && $8863cd8fe199f948$var$Listener === null) return fn();
    const listener = $8863cd8fe199f948$var$Listener;
    $8863cd8fe199f948$var$Listener = null;
    try {
        if ($8863cd8fe199f948$var$ExternalSourceConfig) return $8863cd8fe199f948$var$ExternalSourceConfig.untrack(fn);
        return fn();
    } finally{
        $8863cd8fe199f948$var$Listener = listener;
    }
}
function $8863cd8fe199f948$export$af631764ddc44097(deps, fn, options) {
    const isArray = Array.isArray(deps);
    let prevInput;
    let defer = options && options.defer;
    return (prevValue)=>{
        let input;
        if (isArray) {
            input = Array(deps.length);
            for(let i = 0; i < deps.length; i++)input[i] = deps[i]();
        } else input = deps();
        if (defer) {
            defer = false;
            return prevValue;
        }
        const result = $8863cd8fe199f948$export$363ebc4b78b8f807(()=>fn(input, prevInput, prevValue));
        prevInput = input;
        return result;
    };
}
function $8863cd8fe199f948$export$1e848a9e87980bd5(fn) {
    $8863cd8fe199f948$export$7ea7134f704deda4(()=>$8863cd8fe199f948$export$363ebc4b78b8f807(fn));
}
function $8863cd8fe199f948$export$b36e5eaa3e8c43ab(fn) {
    if ($8863cd8fe199f948$var$Owner === null) ;
    else if ($8863cd8fe199f948$var$Owner.cleanups === null) $8863cd8fe199f948$var$Owner.cleanups = [
        fn
    ];
    else $8863cd8fe199f948$var$Owner.cleanups.push(fn);
    return fn;
}
function $8863cd8fe199f948$export$3dede90624df3ba9(fn, handler) {
    $8863cd8fe199f948$var$ERROR || ($8863cd8fe199f948$var$ERROR = Symbol("error"));
    $8863cd8fe199f948$var$Owner = $8863cd8fe199f948$var$createComputation(undefined, undefined, true);
    $8863cd8fe199f948$var$Owner.context = {
        ...$8863cd8fe199f948$var$Owner.context,
        [$8863cd8fe199f948$var$ERROR]: [
            handler
        ]
    };
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) $8863cd8fe199f948$var$Transition.sources.add($8863cd8fe199f948$var$Owner);
    try {
        return fn();
    } catch (err) {
        $8863cd8fe199f948$var$handleError(err);
    } finally{
        $8863cd8fe199f948$var$Owner = $8863cd8fe199f948$var$Owner.owner;
    }
}
function $8863cd8fe199f948$export$12abb5141c6fdc9c() {
    return $8863cd8fe199f948$var$Listener;
}
function $8863cd8fe199f948$export$5f4ed0d56c2c0edf() {
    return $8863cd8fe199f948$var$Owner;
}
function $8863cd8fe199f948$export$c14f3e3abbc7d6b5(o, fn) {
    const prev = $8863cd8fe199f948$var$Owner;
    const prevListener = $8863cd8fe199f948$var$Listener;
    $8863cd8fe199f948$var$Owner = o;
    $8863cd8fe199f948$var$Listener = null;
    try {
        return $8863cd8fe199f948$var$runUpdates(fn, true);
    } catch (err) {
        $8863cd8fe199f948$var$handleError(err);
    } finally{
        $8863cd8fe199f948$var$Owner = prev;
        $8863cd8fe199f948$var$Listener = prevListener;
    }
}
function $8863cd8fe199f948$export$45e8540700504e87(scheduler = $8863cd8fe199f948$export$4b5e076b3a2fbe0a) {
    $8863cd8fe199f948$var$Scheduler = scheduler;
}
function $8863cd8fe199f948$export$7568632d0d33d16d(fn) {
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
        fn();
        return $8863cd8fe199f948$var$Transition.done;
    }
    const l = $8863cd8fe199f948$var$Listener;
    const o = $8863cd8fe199f948$var$Owner;
    return Promise.resolve().then(()=>{
        $8863cd8fe199f948$var$Listener = l;
        $8863cd8fe199f948$var$Owner = o;
        let t;
        if ($8863cd8fe199f948$var$Scheduler || $8863cd8fe199f948$var$SuspenseContext) {
            t = $8863cd8fe199f948$var$Transition || ($8863cd8fe199f948$var$Transition = {
                sources: new Set(),
                effects: [],
                promises: new Set(),
                disposed: new Set(),
                queue: new Set(),
                running: true
            });
            t.done || (t.done = new Promise((res)=>t.resolve = res));
            t.running = true;
        }
        $8863cd8fe199f948$var$runUpdates(fn, false);
        $8863cd8fe199f948$var$Listener = $8863cd8fe199f948$var$Owner = null;
        return t ? t.done : undefined;
    });
}
const [$8863cd8fe199f948$var$transPending, $8863cd8fe199f948$var$setTransPending] = /*@__PURE__*/ $8863cd8fe199f948$export$c1e1e1ecbbe76a5(false);
function $8863cd8fe199f948$export$7b286972b8d8ccbf() {
    return [
        $8863cd8fe199f948$var$transPending,
        $8863cd8fe199f948$export$7568632d0d33d16d
    ];
}
function $8863cd8fe199f948$var$resumeEffects(e) {
    $8863cd8fe199f948$var$Effects.push.apply($8863cd8fe199f948$var$Effects, e);
    e.length = 0;
}
function $8863cd8fe199f948$export$fd42f52fd3ae1109(defaultValue, options) {
    const id = Symbol("context");
    return {
        id: id,
        Provider: $8863cd8fe199f948$var$createProvider(id),
        defaultValue: defaultValue
    };
}
function $8863cd8fe199f948$export$fae74005e78b1a27(context) {
    let value;
    return $8863cd8fe199f948$var$Owner && $8863cd8fe199f948$var$Owner.context && (value = $8863cd8fe199f948$var$Owner.context[context.id]) !== undefined ? value : context.defaultValue;
}
function $8863cd8fe199f948$export$bacb5cc5a11aef16(fn) {
    const children = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(fn);
    const memo = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>$8863cd8fe199f948$var$resolveChildren(children()));
    memo.toArray = ()=>{
        const c = memo();
        return Array.isArray(c) ? c : c != null ? [
            c
        ] : [];
    };
    return memo;
}
let $8863cd8fe199f948$var$SuspenseContext;
function $8863cd8fe199f948$var$getSuspenseContext() {
    return $8863cd8fe199f948$var$SuspenseContext || ($8863cd8fe199f948$var$SuspenseContext = $8863cd8fe199f948$export$fd42f52fd3ae1109());
}
function $8863cd8fe199f948$export$315ab94ce87a624f(factory, untrack = (fn)=>fn()) {
    if ($8863cd8fe199f948$var$ExternalSourceConfig) {
        const { factory: oldFactory, untrack: oldUntrack } = $8863cd8fe199f948$var$ExternalSourceConfig;
        $8863cd8fe199f948$var$ExternalSourceConfig = {
            factory: (fn, trigger)=>{
                const oldSource = oldFactory(fn, trigger);
                const source = factory((x)=>oldSource.track(x), trigger);
                return {
                    track: (x)=>source.track(x),
                    dispose () {
                        source.dispose();
                        oldSource.dispose();
                    }
                };
            },
            untrack: (fn)=>oldUntrack(()=>untrack(fn))
        };
    } else $8863cd8fe199f948$var$ExternalSourceConfig = {
        factory: factory,
        untrack: untrack
    };
}
function $8863cd8fe199f948$var$readSignal() {
    const runningTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
    if (this.sources && (runningTransition ? this.tState : this.state)) {
        if ((runningTransition ? this.tState : this.state) === $8863cd8fe199f948$var$STALE) $8863cd8fe199f948$var$updateComputation(this);
        else {
            const updates = $8863cd8fe199f948$var$Updates;
            $8863cd8fe199f948$var$Updates = null;
            $8863cd8fe199f948$var$runUpdates(()=>$8863cd8fe199f948$var$lookUpstream(this), false);
            $8863cd8fe199f948$var$Updates = updates;
        }
    }
    if ($8863cd8fe199f948$var$Listener) {
        const observers = this.observers;
        if (!observers || observers[observers.length - 1] !== $8863cd8fe199f948$var$Listener) {
            const sSlot = observers ? observers.length : 0;
            if (!$8863cd8fe199f948$var$Listener.sources) {
                $8863cd8fe199f948$var$Listener.sources = [
                    this
                ];
                $8863cd8fe199f948$var$Listener.sourceSlots = [
                    sSlot
                ];
            } else {
                $8863cd8fe199f948$var$Listener.sources.push(this);
                $8863cd8fe199f948$var$Listener.sourceSlots.push(sSlot);
            }
            if (!observers) {
                this.observers = [
                    $8863cd8fe199f948$var$Listener
                ];
                this.observerSlots = [
                    $8863cd8fe199f948$var$Listener.sources.length - 1
                ];
            } else {
                observers.push($8863cd8fe199f948$var$Listener);
                this.observerSlots.push($8863cd8fe199f948$var$Listener.sources.length - 1);
            }
        }
    }
    if (runningTransition && $8863cd8fe199f948$var$Transition.sources.has(this)) return this.tValue;
    return this.value;
}
function $8863cd8fe199f948$var$writeSignal(node, value, isComp) {
    let current = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value;
    if (!node.comparator || !node.comparator(current, value)) {
        if ($8863cd8fe199f948$var$Transition) {
            const TransitionRunning = $8863cd8fe199f948$var$Transition.running;
            if (TransitionRunning || !isComp && $8863cd8fe199f948$var$Transition.sources.has(node)) {
                $8863cd8fe199f948$var$Transition.sources.add(node);
                node.tValue = value;
            }
            if (!TransitionRunning) node.value = value;
        } else node.value = value;
        if (node.observers && node.observers.length) $8863cd8fe199f948$var$runUpdates(()=>{
            for(let i = 0; i < node.observers.length; i += 1){
                const o = node.observers[i];
                const TransitionRunning = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
                if (TransitionRunning && $8863cd8fe199f948$var$Transition.disposed.has(o)) continue;
                if (TransitionRunning ? !o.tState : !o.state) {
                    if (o.pure) $8863cd8fe199f948$var$Updates.push(o);
                    else $8863cd8fe199f948$var$Effects.push(o);
                    if (o.observers) $8863cd8fe199f948$var$markDownstream(o);
                }
                if (!TransitionRunning) o.state = $8863cd8fe199f948$var$STALE;
                else o.tState = $8863cd8fe199f948$var$STALE;
            }
            if ($8863cd8fe199f948$var$Updates.length > 10e5) {
                $8863cd8fe199f948$var$Updates = [];
                $8863cd8fe199f948$var$IS_DEV;
                throw new Error();
            }
        }, false);
    }
    return value;
}
function $8863cd8fe199f948$var$updateComputation(node) {
    if (!node.fn) return;
    $8863cd8fe199f948$var$cleanNode(node);
    const time = $8863cd8fe199f948$var$ExecCount;
    $8863cd8fe199f948$var$runComputation(node, $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value, time);
    if ($8863cd8fe199f948$var$Transition && !$8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node)) queueMicrotask(()=>{
        $8863cd8fe199f948$var$runUpdates(()=>{
            $8863cd8fe199f948$var$Transition && ($8863cd8fe199f948$var$Transition.running = true);
            $8863cd8fe199f948$var$Listener = $8863cd8fe199f948$var$Owner = node;
            $8863cd8fe199f948$var$runComputation(node, node.tValue, time);
            $8863cd8fe199f948$var$Listener = $8863cd8fe199f948$var$Owner = null;
        }, false);
    });
}
function $8863cd8fe199f948$var$runComputation(node, value, time) {
    let nextValue;
    const owner = $8863cd8fe199f948$var$Owner, listener = $8863cd8fe199f948$var$Listener;
    $8863cd8fe199f948$var$Listener = $8863cd8fe199f948$var$Owner = node;
    try {
        nextValue = node.fn(value);
    } catch (err) {
        if (node.pure) {
            if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
                node.tState = $8863cd8fe199f948$var$STALE;
                node.tOwned && node.tOwned.forEach($8863cd8fe199f948$var$cleanNode);
                node.tOwned = undefined;
            } else {
                node.state = $8863cd8fe199f948$var$STALE;
                node.owned && node.owned.forEach($8863cd8fe199f948$var$cleanNode);
                node.owned = null;
            }
        }
        node.updatedAt = time + 1;
        return $8863cd8fe199f948$var$handleError(err);
    } finally{
        $8863cd8fe199f948$var$Listener = listener;
        $8863cd8fe199f948$var$Owner = owner;
    }
    if (!node.updatedAt || node.updatedAt <= time) {
        if (node.updatedAt != null && "observers" in node) $8863cd8fe199f948$var$writeSignal(node, nextValue, true);
        else if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && node.pure) {
            if (!$8863cd8fe199f948$var$Transition.sources.has(node)) node.value = nextValue;
            $8863cd8fe199f948$var$Transition.sources.add(node);
            node.tValue = nextValue;
        } else node.value = nextValue;
        node.updatedAt = time;
    }
}
function $8863cd8fe199f948$var$createComputation(fn, init, pure, state = $8863cd8fe199f948$var$STALE, options) {
    const c = {
        fn: fn,
        state: state,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: init,
        owner: $8863cd8fe199f948$var$Owner,
        context: $8863cd8fe199f948$var$Owner ? $8863cd8fe199f948$var$Owner.context : null,
        pure: pure
    };
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
        c.state = 0;
        c.tState = state;
    }
    if ($8863cd8fe199f948$var$Owner === null) ;
    else if ($8863cd8fe199f948$var$Owner !== $8863cd8fe199f948$var$UNOWNED) {
        if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Owner.pure) {
            if (!$8863cd8fe199f948$var$Owner.tOwned) $8863cd8fe199f948$var$Owner.tOwned = [
                c
            ];
            else $8863cd8fe199f948$var$Owner.tOwned.push(c);
        } else if (!$8863cd8fe199f948$var$Owner.owned) $8863cd8fe199f948$var$Owner.owned = [
            c
        ];
        else $8863cd8fe199f948$var$Owner.owned.push(c);
    }
    if ($8863cd8fe199f948$var$ExternalSourceConfig && c.fn) {
        const sourceFn = c.fn;
        const [track, trigger] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined, {
            equals: false
        });
        const ordinary = $8863cd8fe199f948$var$ExternalSourceConfig.factory(sourceFn, trigger);
        $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>ordinary.dispose());
        let inTransition;
        let trackedOrdinary = false;
        const triggerInTransition = ()=>$8863cd8fe199f948$export$7568632d0d33d16d(trigger).then(()=>{
                if (inTransition) {
                    inTransition.dispose();
                    inTransition = undefined;
                    if (!trackedOrdinary) trigger();
                }
            });
        c.fn = (x)=>{
            track();
            if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
                if (!inTransition) inTransition = $8863cd8fe199f948$var$ExternalSourceConfig.factory(sourceFn, triggerInTransition);
                return inTransition.track(x);
            }
            trackedOrdinary = true;
            return ordinary.track(x);
        };
    }
    return c;
}
function $8863cd8fe199f948$var$runTop(node) {
    const runningTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
    if ((runningTransition ? node.tState : node.state) === 0) return;
    if ((runningTransition ? node.tState : node.state) === $8863cd8fe199f948$var$PENDING) return $8863cd8fe199f948$var$lookUpstream(node);
    if (node.suspense && $8863cd8fe199f948$export$363ebc4b78b8f807(node.suspense.inFallback)) return node.suspense.effects.push(node);
    const ancestors = [
        node
    ];
    while((node = node.owner) && (!node.updatedAt || node.updatedAt < $8863cd8fe199f948$var$ExecCount)){
        if (runningTransition && $8863cd8fe199f948$var$Transition.disposed.has(node)) return;
        if (runningTransition ? node.tState : node.state) ancestors.push(node);
    }
    for(let i = ancestors.length - 1; i >= 0; i--){
        node = ancestors[i];
        if (runningTransition) {
            let top = node, prev = ancestors[i + 1];
            while((top = top.owner) && top !== prev){
                if ($8863cd8fe199f948$var$Transition.disposed.has(top)) return;
            }
        }
        if ((runningTransition ? node.tState : node.state) === $8863cd8fe199f948$var$STALE) $8863cd8fe199f948$var$updateComputation(node);
        else if ((runningTransition ? node.tState : node.state) === $8863cd8fe199f948$var$PENDING) {
            const updates = $8863cd8fe199f948$var$Updates;
            $8863cd8fe199f948$var$Updates = null;
            $8863cd8fe199f948$var$runUpdates(()=>$8863cd8fe199f948$var$lookUpstream(node, ancestors[0]), false);
            $8863cd8fe199f948$var$Updates = updates;
        }
    }
}
function $8863cd8fe199f948$var$runUpdates(fn, init) {
    if ($8863cd8fe199f948$var$Updates) return fn();
    let wait = false;
    if (!init) $8863cd8fe199f948$var$Updates = [];
    if ($8863cd8fe199f948$var$Effects) wait = true;
    else $8863cd8fe199f948$var$Effects = [];
    $8863cd8fe199f948$var$ExecCount++;
    try {
        const res = fn();
        $8863cd8fe199f948$var$completeUpdates(wait);
        return res;
    } catch (err) {
        if (!wait) $8863cd8fe199f948$var$Effects = null;
        $8863cd8fe199f948$var$Updates = null;
        $8863cd8fe199f948$var$handleError(err);
    }
}
function $8863cd8fe199f948$var$completeUpdates(wait) {
    if ($8863cd8fe199f948$var$Updates) {
        if ($8863cd8fe199f948$var$Scheduler && $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) $8863cd8fe199f948$var$scheduleQueue($8863cd8fe199f948$var$Updates);
        else $8863cd8fe199f948$var$runQueue($8863cd8fe199f948$var$Updates);
        $8863cd8fe199f948$var$Updates = null;
    }
    if (wait) return;
    let res;
    if ($8863cd8fe199f948$var$Transition) {
        if (!$8863cd8fe199f948$var$Transition.promises.size && !$8863cd8fe199f948$var$Transition.queue.size) {
            const sources = $8863cd8fe199f948$var$Transition.sources;
            const disposed = $8863cd8fe199f948$var$Transition.disposed;
            $8863cd8fe199f948$var$Effects.push.apply($8863cd8fe199f948$var$Effects, $8863cd8fe199f948$var$Transition.effects);
            res = $8863cd8fe199f948$var$Transition.resolve;
            for (const e of $8863cd8fe199f948$var$Effects){
                "tState" in e && (e.state = e.tState);
                delete e.tState;
            }
            $8863cd8fe199f948$var$Transition = null;
            $8863cd8fe199f948$var$runUpdates(()=>{
                for (const d of disposed)$8863cd8fe199f948$var$cleanNode(d);
                for (const v of sources){
                    v.value = v.tValue;
                    if (v.owned) for(let i = 0, len = v.owned.length; i < len; i++)$8863cd8fe199f948$var$cleanNode(v.owned[i]);
                    if (v.tOwned) v.owned = v.tOwned;
                    delete v.tValue;
                    delete v.tOwned;
                    v.tState = 0;
                }
                $8863cd8fe199f948$var$setTransPending(false);
            }, false);
        } else if ($8863cd8fe199f948$var$Transition.running) {
            $8863cd8fe199f948$var$Transition.running = false;
            $8863cd8fe199f948$var$Transition.effects.push.apply($8863cd8fe199f948$var$Transition.effects, $8863cd8fe199f948$var$Effects);
            $8863cd8fe199f948$var$Effects = null;
            $8863cd8fe199f948$var$setTransPending(true);
            return;
        }
    }
    const e = $8863cd8fe199f948$var$Effects;
    $8863cd8fe199f948$var$Effects = null;
    if (e.length) $8863cd8fe199f948$var$runUpdates(()=>$8863cd8fe199f948$var$runEffects(e), false);
    if (res) res();
}
function $8863cd8fe199f948$var$runQueue(queue) {
    for(let i = 0; i < queue.length; i++)$8863cd8fe199f948$var$runTop(queue[i]);
}
function $8863cd8fe199f948$var$scheduleQueue(queue) {
    for(let i = 0; i < queue.length; i++){
        const item = queue[i];
        const tasks = $8863cd8fe199f948$var$Transition.queue;
        if (!tasks.has(item)) {
            tasks.add(item);
            $8863cd8fe199f948$var$Scheduler(()=>{
                tasks.delete(item);
                $8863cd8fe199f948$var$runUpdates(()=>{
                    $8863cd8fe199f948$var$Transition.running = true;
                    $8863cd8fe199f948$var$runTop(item);
                }, false);
                $8863cd8fe199f948$var$Transition && ($8863cd8fe199f948$var$Transition.running = false);
            });
        }
    }
}
function $8863cd8fe199f948$var$runUserEffects(queue) {
    let i, userLength = 0;
    for(i = 0; i < queue.length; i++){
        const e = queue[i];
        if (!e.user) $8863cd8fe199f948$var$runTop(e);
        else queue[userLength++] = e;
    }
    if ($8863cd8fe199f948$export$2cb4986bed338027.context) {
        if ($8863cd8fe199f948$export$2cb4986bed338027.count) {
            $8863cd8fe199f948$export$2cb4986bed338027.effects || ($8863cd8fe199f948$export$2cb4986bed338027.effects = []);
            $8863cd8fe199f948$export$2cb4986bed338027.effects.push(...queue.slice(0, userLength));
            return;
        }
        $8863cd8fe199f948$var$setHydrateContext();
    }
    if ($8863cd8fe199f948$export$2cb4986bed338027.effects && ($8863cd8fe199f948$export$2cb4986bed338027.done || !$8863cd8fe199f948$export$2cb4986bed338027.count)) {
        queue = [
            ...$8863cd8fe199f948$export$2cb4986bed338027.effects,
            ...queue
        ];
        userLength += $8863cd8fe199f948$export$2cb4986bed338027.effects.length;
        delete $8863cd8fe199f948$export$2cb4986bed338027.effects;
    }
    for(i = 0; i < userLength; i++)$8863cd8fe199f948$var$runTop(queue[i]);
}
function $8863cd8fe199f948$var$lookUpstream(node, ignore) {
    const runningTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
    if (runningTransition) node.tState = 0;
    else node.state = 0;
    for(let i = 0; i < node.sources.length; i += 1){
        const source = node.sources[i];
        if (source.sources) {
            const state = runningTransition ? source.tState : source.state;
            if (state === $8863cd8fe199f948$var$STALE) {
                if (source !== ignore && (!source.updatedAt || source.updatedAt < $8863cd8fe199f948$var$ExecCount)) $8863cd8fe199f948$var$runTop(source);
            } else if (state === $8863cd8fe199f948$var$PENDING) $8863cd8fe199f948$var$lookUpstream(source, ignore);
        }
    }
}
function $8863cd8fe199f948$var$markDownstream(node) {
    const runningTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
    for(let i = 0; i < node.observers.length; i += 1){
        const o = node.observers[i];
        if (runningTransition ? !o.tState : !o.state) {
            if (runningTransition) o.tState = $8863cd8fe199f948$var$PENDING;
            else o.state = $8863cd8fe199f948$var$PENDING;
            if (o.pure) $8863cd8fe199f948$var$Updates.push(o);
            else $8863cd8fe199f948$var$Effects.push(o);
            o.observers && $8863cd8fe199f948$var$markDownstream(o);
        }
    }
}
function $8863cd8fe199f948$var$cleanNode(node) {
    let i;
    if (node.sources) while(node.sources.length){
        const source = node.sources.pop(), index = node.sourceSlots.pop(), obs = source.observers;
        if (obs && obs.length) {
            const n = obs.pop(), s = source.observerSlots.pop();
            if (index < obs.length) {
                n.sourceSlots[s] = index;
                obs[index] = n;
                source.observerSlots[index] = s;
            }
        }
    }
    if (node.tOwned) {
        for(i = node.tOwned.length - 1; i >= 0; i--)$8863cd8fe199f948$var$cleanNode(node.tOwned[i]);
        delete node.tOwned;
    }
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && node.pure) $8863cd8fe199f948$var$reset(node, true);
    else if (node.owned) {
        for(i = node.owned.length - 1; i >= 0; i--)$8863cd8fe199f948$var$cleanNode(node.owned[i]);
        node.owned = null;
    }
    if (node.cleanups) {
        for(i = node.cleanups.length - 1; i >= 0; i--)node.cleanups[i]();
        node.cleanups = null;
    }
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) node.tState = 0;
    else node.state = 0;
}
function $8863cd8fe199f948$var$reset(node, top) {
    if (!top) {
        node.tState = 0;
        $8863cd8fe199f948$var$Transition.disposed.add(node);
    }
    if (node.owned) for(let i = 0; i < node.owned.length; i++)$8863cd8fe199f948$var$reset(node.owned[i]);
}
function $8863cd8fe199f948$var$castError(err) {
    if (err instanceof Error) return err;
    return new Error(typeof err === "string" ? err : "Unknown error", {
        cause: err
    });
}
function $8863cd8fe199f948$var$runErrors(err, fns, owner) {
    try {
        for (const f of fns)f(err);
    } catch (e) {
        $8863cd8fe199f948$var$handleError(e, owner && owner.owner || null);
    }
}
function $8863cd8fe199f948$var$handleError(err, owner = $8863cd8fe199f948$var$Owner) {
    const fns = $8863cd8fe199f948$var$ERROR && owner && owner.context && owner.context[$8863cd8fe199f948$var$ERROR];
    const error = $8863cd8fe199f948$var$castError(err);
    if (!fns) throw error;
    if ($8863cd8fe199f948$var$Effects) $8863cd8fe199f948$var$Effects.push({
        fn () {
            $8863cd8fe199f948$var$runErrors(error, fns, owner);
        },
        state: $8863cd8fe199f948$var$STALE
    });
    else $8863cd8fe199f948$var$runErrors(error, fns, owner);
}
function $8863cd8fe199f948$var$resolveChildren(children) {
    if (typeof children === "function" && !children.length) return $8863cd8fe199f948$var$resolveChildren(children());
    if (Array.isArray(children)) {
        const results = [];
        for(let i = 0; i < children.length; i++){
            const result = $8863cd8fe199f948$var$resolveChildren(children[i]);
            if (Array.isArray(result)) {
                if (result.length < 32768) results.push.apply(results, result);
                else for(let j = 0; j < result.length; j++)results.push(result[j]);
            } else results.push(result);
        }
        return results;
    }
    return children;
}
function $8863cd8fe199f948$var$createProvider(id, options) {
    return function provider(props) {
        let res;
        $8863cd8fe199f948$export$314dade334ae905d(()=>res = $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
                $8863cd8fe199f948$var$Owner.context = {
                    ...$8863cd8fe199f948$var$Owner.context,
                    [id]: props.value
                };
                return $8863cd8fe199f948$export$bacb5cc5a11aef16(()=>props.children);
            }), undefined);
        return res;
    };
}
function $8863cd8fe199f948$export$2288787135a8f66e(fn) {
    $8863cd8fe199f948$var$ERROR || ($8863cd8fe199f948$var$ERROR = Symbol("error"));
    if ($8863cd8fe199f948$var$Owner === null) ;
    else if ($8863cd8fe199f948$var$Owner.context === null || !$8863cd8fe199f948$var$Owner.context[$8863cd8fe199f948$var$ERROR]) {
        $8863cd8fe199f948$var$Owner.context = {
            ...$8863cd8fe199f948$var$Owner.context,
            [$8863cd8fe199f948$var$ERROR]: [
                fn
            ]
        };
        $8863cd8fe199f948$var$mutateContext($8863cd8fe199f948$var$Owner, $8863cd8fe199f948$var$ERROR, [
            fn
        ]);
    } else $8863cd8fe199f948$var$Owner.context[$8863cd8fe199f948$var$ERROR].push(fn);
}
function $8863cd8fe199f948$var$mutateContext(o, key, value) {
    if (o.owned) for(let i = 0; i < o.owned.length; i++){
        if (o.owned[i].context === o.context) $8863cd8fe199f948$var$mutateContext(o.owned[i], key, value);
        if (!o.owned[i].context) {
            o.owned[i].context = o.context;
            $8863cd8fe199f948$var$mutateContext(o.owned[i], key, value);
        } else if (!o.owned[i].context[key]) {
            o.owned[i].context[key] = value;
            $8863cd8fe199f948$var$mutateContext(o.owned[i], key, value);
        }
    }
}
function $8863cd8fe199f948$export$5ab46cbf6120b33a(input) {
    return {
        subscribe (observer) {
            if (!(observer instanceof Object) || observer == null) throw new TypeError("Expected the observer to be an object.");
            const handler = typeof observer === "function" ? observer : observer.next && observer.next.bind(observer);
            if (!handler) return {
                unsubscribe () {}
            };
            const dispose = $8863cd8fe199f948$export$882461b6382ed46c((disposer)=>{
                $8863cd8fe199f948$export$7ea7134f704deda4(()=>{
                    const v = input();
                    $8863cd8fe199f948$export$363ebc4b78b8f807(()=>handler(v));
                });
                return disposer;
            });
            if ($8863cd8fe199f948$export$5f4ed0d56c2c0edf()) $8863cd8fe199f948$export$b36e5eaa3e8c43ab(dispose);
            return {
                unsubscribe () {
                    dispose();
                }
            };
        },
        [Symbol.observable || "@@observable"] () {
            return this;
        }
    };
}
function $8863cd8fe199f948$export$6788812c4e6611e6(producer, initalValue) {
    const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(initalValue, {
        equals: false
    });
    if ("subscribe" in producer) {
        const unsub = producer.subscribe((v)=>set(()=>v));
        $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>"unsubscribe" in unsub ? unsub.unsubscribe() : unsub());
    } else {
        const clean = producer(set);
        $8863cd8fe199f948$export$b36e5eaa3e8c43ab(clean);
    }
    return s;
}
const $8863cd8fe199f948$var$FALLBACK = Symbol("fallback");
function $8863cd8fe199f948$var$dispose(d) {
    for(let i = 0; i < d.length; i++)d[i]();
}
function $8863cd8fe199f948$export$4c9116dcf1374231(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], len = 0, indexes = mapFn.length > 1 ? [] : null;
    $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>$8863cd8fe199f948$var$dispose(disposers));
    return ()=>{
        let newItems = list() || [], newLen = newItems.length, i, j;
        newItems[$8863cd8fe199f948$export$17a675b7c02a7b1d];
        return $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
            let newIndices, newIndicesNext, temp, tempdisposers, tempIndexes, start, end, newEnd, item;
            if (newLen === 0) {
                if (len !== 0) {
                    $8863cd8fe199f948$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    indexes && (indexes = []);
                }
                if (options.fallback) {
                    items = [
                        $8863cd8fe199f948$var$FALLBACK
                    ];
                    mapped[0] = $8863cd8fe199f948$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
            } else if (len === 0) {
                mapped = new Array(newLen);
                for(j = 0; j < newLen; j++){
                    items[j] = newItems[j];
                    mapped[j] = $8863cd8fe199f948$export$882461b6382ed46c(mapper);
                }
                len = newLen;
            } else {
                temp = new Array(newLen);
                tempdisposers = new Array(newLen);
                indexes && (tempIndexes = new Array(newLen));
                for(start = 0, end = Math.min(len, newLen); start < end && items[start] === newItems[start]; start++);
                for(end = len - 1, newEnd = newLen - 1; end >= start && newEnd >= start && items[end] === newItems[newEnd]; end--, newEnd--){
                    temp[newEnd] = mapped[end];
                    tempdisposers[newEnd] = disposers[end];
                    indexes && (tempIndexes[newEnd] = indexes[end]);
                }
                newIndices = new Map();
                newIndicesNext = new Array(newEnd + 1);
                for(j = newEnd; j >= start; j--){
                    item = newItems[j];
                    i = newIndices.get(item);
                    newIndicesNext[j] = i === undefined ? -1 : i;
                    newIndices.set(item, j);
                }
                for(i = start; i <= end; i++){
                    item = items[i];
                    j = newIndices.get(item);
                    if (j !== undefined && j !== -1) {
                        temp[j] = mapped[i];
                        tempdisposers[j] = disposers[i];
                        indexes && (tempIndexes[j] = indexes[i]);
                        j = newIndicesNext[j];
                        newIndices.set(item, j);
                    } else disposers[i]();
                }
                for(j = start; j < newLen; j++)if (j in temp) {
                    mapped[j] = temp[j];
                    disposers[j] = tempdisposers[j];
                    if (indexes) {
                        indexes[j] = tempIndexes[j];
                        indexes[j](j);
                    }
                } else mapped[j] = $8863cd8fe199f948$export$882461b6382ed46c(mapper);
                mapped = mapped.slice(0, len = newLen);
                items = newItems.slice(0);
            }
            return mapped;
        });
        function mapper(disposer) {
            disposers[j] = disposer;
            if (indexes) {
                const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(j);
                indexes[j] = set;
                return mapFn(newItems[j], s);
            }
            return mapFn(newItems[j]);
        }
    };
}
function $8863cd8fe199f948$export$2cd1c249765cd0a4(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], signals = [], len = 0, i;
    $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>$8863cd8fe199f948$var$dispose(disposers));
    return ()=>{
        const newItems = list() || [], newLen = newItems.length;
        newItems[$8863cd8fe199f948$export$17a675b7c02a7b1d];
        return $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
            if (newLen === 0) {
                if (len !== 0) {
                    $8863cd8fe199f948$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    signals = [];
                }
                if (options.fallback) {
                    items = [
                        $8863cd8fe199f948$var$FALLBACK
                    ];
                    mapped[0] = $8863cd8fe199f948$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
                return mapped;
            }
            if (items[0] === $8863cd8fe199f948$var$FALLBACK) {
                disposers[0]();
                disposers = [];
                items = [];
                mapped = [];
                len = 0;
            }
            for(i = 0; i < newLen; i++){
                if (i < items.length && items[i] !== newItems[i]) signals[i](()=>newItems[i]);
                else if (i >= items.length) mapped[i] = $8863cd8fe199f948$export$882461b6382ed46c(mapper);
            }
            for(; i < items.length; i++)disposers[i]();
            len = signals.length = disposers.length = newLen;
            items = newItems.slice(0);
            return mapped = mapped.slice(0, len);
        });
        function mapper(disposer) {
            disposers[i] = disposer;
            const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(newItems[i]);
            signals[i] = set;
            return mapFn(s, i);
        }
    };
}
let $8863cd8fe199f948$var$hydrationEnabled = false;
function $8863cd8fe199f948$export$849801d35d2160c9() {
    $8863cd8fe199f948$var$hydrationEnabled = true;
}
function $8863cd8fe199f948$export$60e54eaca7e7fb38(Comp, props) {
    if ($8863cd8fe199f948$var$hydrationEnabled) {
        if ($8863cd8fe199f948$export$2cb4986bed338027.context) {
            const c = $8863cd8fe199f948$export$2cb4986bed338027.context;
            $8863cd8fe199f948$var$setHydrateContext($8863cd8fe199f948$var$nextHydrateContext());
            const r = $8863cd8fe199f948$export$363ebc4b78b8f807(()=>Comp(props || {}));
            $8863cd8fe199f948$var$setHydrateContext(c);
            return r;
        }
    }
    return $8863cd8fe199f948$export$363ebc4b78b8f807(()=>Comp(props || {}));
}
function $8863cd8fe199f948$var$trueFn() {
    return true;
}
const $8863cd8fe199f948$var$propTraps = {
    get (_, property, receiver) {
        if (property === $8863cd8fe199f948$export$5cd89106e2f6c2c5) return receiver;
        return _.get(property);
    },
    has (_, property) {
        if (property === $8863cd8fe199f948$export$5cd89106e2f6c2c5) return true;
        return _.has(property);
    },
    set: $8863cd8fe199f948$var$trueFn,
    deleteProperty: $8863cd8fe199f948$var$trueFn,
    getOwnPropertyDescriptor (_, property) {
        return {
            configurable: true,
            enumerable: true,
            get () {
                return _.get(property);
            },
            set: $8863cd8fe199f948$var$trueFn,
            deleteProperty: $8863cd8fe199f948$var$trueFn
        };
    },
    ownKeys (_) {
        return _.keys();
    }
};
function $8863cd8fe199f948$var$resolveSource(s) {
    return !(s = typeof s === "function" ? s() : s) ? {} : s;
}
function $8863cd8fe199f948$var$resolveSources() {
    for(let i = 0, length = this.length; i < length; ++i){
        const v = this[i]();
        if (v !== undefined) return v;
    }
}
function $8863cd8fe199f948$export$9d1611c77c2fe928(...sources) {
    let proxy = false;
    for(let i = 0; i < sources.length; i++){
        const s = sources[i];
        proxy = proxy || !!s && $8863cd8fe199f948$export$5cd89106e2f6c2c5 in s;
        sources[i] = typeof s === "function" ? (proxy = true, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(s)) : s;
    }
    if ($8863cd8fe199f948$var$SUPPORTS_PROXY && proxy) return new Proxy({
        get (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                const v = $8863cd8fe199f948$var$resolveSource(sources[i])[property];
                if (v !== undefined) return v;
            }
        },
        has (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                if (property in $8863cd8fe199f948$var$resolveSource(sources[i])) return true;
            }
            return false;
        },
        keys () {
            const keys = [];
            for(let i = 0; i < sources.length; i++)keys.push(...Object.keys($8863cd8fe199f948$var$resolveSource(sources[i])));
            return [
                ...new Set(keys)
            ];
        }
    }, $8863cd8fe199f948$var$propTraps);
    const sourcesMap = {};
    const defined = Object.create(null);
    for(let i = sources.length - 1; i >= 0; i--){
        const source = sources[i];
        if (!source) continue;
        const sourceKeys = Object.getOwnPropertyNames(source);
        for(let i = sourceKeys.length - 1; i >= 0; i--){
            const key = sourceKeys[i];
            if (key === "__proto__" || key === "constructor") continue;
            const desc = Object.getOwnPropertyDescriptor(source, key);
            if (!defined[key]) defined[key] = desc.get ? {
                enumerable: true,
                configurable: true,
                get: $8863cd8fe199f948$var$resolveSources.bind(sourcesMap[key] = [
                    desc.get.bind(source)
                ])
            } : desc.value !== undefined ? desc : undefined;
            else {
                const sources = sourcesMap[key];
                if (sources) {
                    if (desc.get) sources.push(desc.get.bind(source));
                    else if (desc.value !== undefined) sources.push(()=>desc.value);
                }
            }
        }
    }
    const target = {};
    const definedKeys = Object.keys(defined);
    for(let i = definedKeys.length - 1; i >= 0; i--){
        const key = definedKeys[i], desc = defined[key];
        if (desc && desc.get) Object.defineProperty(target, key, desc);
        else target[key] = desc ? desc.value : undefined;
    }
    return target;
}
function $8863cd8fe199f948$export$45029c61b0073d87(props, ...keys) {
    const len = keys.length;
    if ($8863cd8fe199f948$var$SUPPORTS_PROXY && $8863cd8fe199f948$export$5cd89106e2f6c2c5 in props) {
        const blocked = len > 1 ? keys.flat() : keys[0];
        const claimed = new Set();
        const res = keys.map((k)=>{
            const owned = k.filter((property)=>!claimed.has(property) && (claimed.add(property), true));
            return new Proxy({
                get (property) {
                    return owned.includes(property) ? props[property] : undefined;
                },
                has (property) {
                    return owned.includes(property) && property in props;
                },
                keys () {
                    return owned.filter((property)=>property in props);
                }
            }, $8863cd8fe199f948$var$propTraps);
        });
        res.push(new Proxy({
            get (property) {
                return blocked.includes(property) ? undefined : props[property];
            },
            has (property) {
                return blocked.includes(property) ? false : property in props;
            },
            keys () {
                return Object.keys(props).filter((k)=>!blocked.includes(k));
            }
        }, $8863cd8fe199f948$var$propTraps));
        return res;
    }
    const objects = [];
    for(let i = 0; i <= len; i++)objects[i] = {};
    for (const propName of Object.getOwnPropertyNames(props)){
        let keyIndex = len;
        for(let i = 0; i < keys.length; i++)if (keys[i].includes(propName)) {
            keyIndex = i;
            break;
        }
        const desc = Object.getOwnPropertyDescriptor(props, propName);
        const isDefaultDesc = !desc.get && !desc.set && desc.enumerable && desc.writable && desc.configurable;
        isDefaultDesc ? objects[keyIndex][propName] = desc.value : Object.defineProperty(objects[keyIndex], propName, desc);
    }
    return objects;
}
function $8863cd8fe199f948$export$488013bae63b21da(fn) {
    let comp;
    let p;
    const load = ()=>{
        if (!p) {
            const cur = p = fn();
            cur.then((mod)=>{
                comp = ()=>mod.default;
            }, ()=>{
                if (p === cur) p = undefined;
            });
        }
        return p;
    };
    const wrap = (props)=>{
        const ctx = $8863cd8fe199f948$export$2cb4986bed338027.context;
        if (ctx) {
            const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5();
            $8863cd8fe199f948$export$2cb4986bed338027.count || ($8863cd8fe199f948$export$2cb4986bed338027.count = 0);
            $8863cd8fe199f948$export$2cb4986bed338027.count++;
            load().then((mod)=>{
                !$8863cd8fe199f948$export$2cb4986bed338027.done && $8863cd8fe199f948$var$setHydrateContext(ctx);
                $8863cd8fe199f948$export$2cb4986bed338027.count--;
                set(()=>mod.default);
                $8863cd8fe199f948$var$setHydrateContext();
            }, (err)=>{
                !$8863cd8fe199f948$export$2cb4986bed338027.done && $8863cd8fe199f948$var$setHydrateContext(ctx);
                $8863cd8fe199f948$export$2cb4986bed338027.count--;
                set(()=>()=>{
                        throw err;
                    });
                $8863cd8fe199f948$var$setHydrateContext();
            });
            comp = s;
        } else if (!comp) {
            const [s] = $8863cd8fe199f948$export$edd172c6c83c39cc(()=>load().then((mod)=>mod.default));
            comp = s;
            $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>comp = undefined);
        }
        let Comp;
        return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>(Comp = comp?.()) ? $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
                $8863cd8fe199f948$var$IS_DEV;
                if (!ctx || $8863cd8fe199f948$export$2cb4986bed338027.done) return Comp(props);
                const c = $8863cd8fe199f948$export$2cb4986bed338027.context;
                $8863cd8fe199f948$var$setHydrateContext(ctx);
                const r = Comp(props);
                $8863cd8fe199f948$var$setHydrateContext(c);
                return r;
            }) : "");
    };
    wrap.preload = ()=>load();
    return wrap;
}
let $8863cd8fe199f948$var$counter = 0;
function $8863cd8fe199f948$export$33208d63bc845a83() {
    const ctx = $8863cd8fe199f948$export$2cb4986bed338027.context;
    return ctx ? $8863cd8fe199f948$export$2cb4986bed338027.getNextContextId() : `cl-${$8863cd8fe199f948$var$counter++}`;
}
const $8863cd8fe199f948$var$narrowedError = (name)=>`Stale read from <${name}>.`;
function $8863cd8fe199f948$export$bdf530073099ce9f(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa($8863cd8fe199f948$export$4c9116dcf1374231(()=>props.each, props.children, fallback || undefined));
}
function $8863cd8fe199f948$export$cf17b003b6192af3(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa($8863cd8fe199f948$export$2cd1c249765cd0a4(()=>props.each, props.children, fallback || undefined));
}
function $8863cd8fe199f948$export$f6a3d19be20f5819(props) {
    const keyed = props.keyed;
    const conditionValue = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>props.when, undefined, undefined);
    const condition = keyed ? conditionValue : $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(conditionValue, undefined, {
        equals: (a, b)=>!a === !b
    });
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
        const c = condition();
        if (c) {
            const child = props.children;
            const fn = typeof child === "function" && child.length > 0;
            return fn ? $8863cd8fe199f948$export$363ebc4b78b8f807(()=>child(keyed ? c : ()=>{
                    if (!$8863cd8fe199f948$export$363ebc4b78b8f807(condition)) throw $8863cd8fe199f948$var$narrowedError("Show");
                    return conditionValue();
                })) : child;
        }
        return props.fallback;
    }, undefined, undefined);
}
function $8863cd8fe199f948$export$b5d5cf8927ab7262(props) {
    const chs = $8863cd8fe199f948$export$bacb5cc5a11aef16(()=>props.children);
    const switchFunc = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
        const ch = chs();
        const mps = Array.isArray(ch) ? ch : [
            ch
        ];
        let func = ()=>undefined;
        for(let i = 0; i < mps.length; i++){
            const index = i;
            const mp = mps[i];
            const prevFunc = func;
            const conditionValue = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>prevFunc() ? undefined : mp.when, undefined, undefined);
            const condition = mp.keyed ? conditionValue : $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(conditionValue, undefined, {
                equals: (a, b)=>!a === !b
            });
            func = ()=>prevFunc() || (condition() ? [
                    index,
                    conditionValue,
                    mp
                ] : undefined);
        }
        return func;
    });
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
        const sel = switchFunc()();
        if (!sel) return props.fallback;
        const [index, conditionValue, mp] = sel;
        const child = mp.children;
        const fn = typeof child === "function" && child.length > 0;
        return fn ? $8863cd8fe199f948$export$363ebc4b78b8f807(()=>child(mp.keyed ? conditionValue() : ()=>{
                if ($8863cd8fe199f948$export$363ebc4b78b8f807(switchFunc)()?.[0] !== index) throw $8863cd8fe199f948$var$narrowedError("Match");
                return conditionValue();
            })) : child;
    }, undefined, undefined);
}
function $8863cd8fe199f948$export$f421feb8fad20413(props) {
    return props;
}
let $8863cd8fe199f948$var$Errors;
function $8863cd8fe199f948$export$4eaee74ee7a14dca() {
    $8863cd8fe199f948$var$Errors && [
        ...$8863cd8fe199f948$var$Errors
    ].forEach((fn)=>fn());
}
function $8863cd8fe199f948$export$e926676385687eaf(props) {
    let err;
    if ($8863cd8fe199f948$export$2cb4986bed338027.context && $8863cd8fe199f948$export$2cb4986bed338027.load) err = $8863cd8fe199f948$export$2cb4986bed338027.load($8863cd8fe199f948$export$2cb4986bed338027.getContextId());
    const [errored, setErrored] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(err, undefined);
    $8863cd8fe199f948$var$Errors || ($8863cd8fe199f948$var$Errors = new Set());
    $8863cd8fe199f948$var$Errors.add(setErrored);
    $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>$8863cd8fe199f948$var$Errors.delete(setErrored));
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
        let e;
        if (e = errored()) {
            const f = props.fallback;
            return typeof f === "function" && f.length ? $8863cd8fe199f948$export$363ebc4b78b8f807(()=>f(e, ()=>setErrored())) : f;
        }
        return $8863cd8fe199f948$export$3dede90624df3ba9(()=>props.children, setErrored);
    }, undefined, undefined);
}
const $8863cd8fe199f948$var$suspenseListEquals = (a, b)=>a.showContent === b.showContent && a.showFallback === b.showFallback;
const $8863cd8fe199f948$var$SuspenseListContext = /* #__PURE__ */ $8863cd8fe199f948$export$fd42f52fd3ae1109();
function $8863cd8fe199f948$export$998bcd577473dd93(props) {
    let [wrapper, setWrapper] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(()=>({
            inFallback: false
        })), show;
    const listContext = $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseListContext);
    const [registry, setRegistry] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5([]);
    if (listContext) show = listContext.register($8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>wrapper()().inFallback));
    const resolved = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa((prev)=>{
        const reveal = props.revealOrder, tail = props.tail, { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {}, reg = registry(), reverse = reveal === "backwards";
        if (reveal === "together") {
            const all = reg.every((inFallback)=>!inFallback());
            const res = reg.map(()=>({
                    showContent: all && showContent,
                    showFallback: showFallback
                }));
            res.inFallback = !all;
            return res;
        }
        let stop = false;
        let inFallback = prev.inFallback;
        const res = [];
        for(let i = 0, len = reg.length; i < len; i++){
            const n = reverse ? len - i - 1 : i, s = reg[n]();
            if (!stop && !s) res[n] = {
                showContent: showContent,
                showFallback: showFallback
            };
            else {
                const next = !stop;
                if (next) inFallback = true;
                res[n] = {
                    showContent: next,
                    showFallback: !tail || next && tail === "collapsed" ? showFallback : false
                };
                stop = true;
            }
        }
        if (!stop) inFallback = false;
        res.inFallback = inFallback;
        return res;
    }, {
        inFallback: false
    });
    setWrapper(()=>resolved);
    return $8863cd8fe199f948$export$60e54eaca7e7fb38($8863cd8fe199f948$var$SuspenseListContext.Provider, {
        value: {
            register: (inFallback)=>{
                let index;
                setRegistry((registry)=>{
                    index = registry.length;
                    return [
                        ...registry,
                        inFallback
                    ];
                });
                return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>resolved()[index], undefined, {
                    equals: $8863cd8fe199f948$var$suspenseListEquals
                });
            }
        },
        get children () {
            return props.children;
        }
    });
}
function $8863cd8fe199f948$export$74bf444e3cd11ea5(props) {
    let counter = 0, show, ctx, p, flicker, error;
    const [inFallback, setFallback] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(false), SuspenseContext = $8863cd8fe199f948$var$getSuspenseContext(), store = {
        increment: ()=>{
            if (++counter === 1) setFallback(true);
        },
        decrement: ()=>{
            if (--counter === 0) setFallback(false);
        },
        inFallback: inFallback,
        effects: [],
        resolved: false
    }, owner = $8863cd8fe199f948$export$5f4ed0d56c2c0edf();
    if ($8863cd8fe199f948$export$2cb4986bed338027.context && $8863cd8fe199f948$export$2cb4986bed338027.load) {
        const key = $8863cd8fe199f948$export$2cb4986bed338027.getContextId();
        let ref = $8863cd8fe199f948$export$2cb4986bed338027.load(key);
        if (ref) {
            if (typeof ref !== "object" || ref.s !== 1) p = ref;
            else $8863cd8fe199f948$export$2cb4986bed338027.gather(key);
        }
        if (p && p !== "$$f") {
            const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined, {
                equals: false
            });
            flicker = s;
            p.then(()=>{
                if ($8863cd8fe199f948$export$2cb4986bed338027.done) return set();
                $8863cd8fe199f948$export$2cb4986bed338027.gather(key);
                $8863cd8fe199f948$var$setHydrateContext(ctx);
                set();
                $8863cd8fe199f948$var$setHydrateContext();
            }, (err)=>{
                error = err;
                set();
            });
        }
    }
    const listContext = $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseListContext);
    if (listContext) show = listContext.register(store.inFallback);
    let dispose;
    $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>dispose && dispose());
    return $8863cd8fe199f948$export$60e54eaca7e7fb38(SuspenseContext.Provider, {
        value: store,
        get children () {
            return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
                if (error) throw error;
                ctx = $8863cd8fe199f948$export$2cb4986bed338027.context;
                if (flicker) {
                    flicker();
                    return flicker = undefined;
                }
                if (ctx && p === "$$f") $8863cd8fe199f948$var$setHydrateContext();
                const rendered = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>props.children);
                return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa((prev)=>{
                    const inFallback = store.inFallback(), { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {};
                    if ((!inFallback || p && p !== "$$f") && showContent) {
                        store.resolved = true;
                        dispose && dispose();
                        dispose = ctx = p = undefined;
                        $8863cd8fe199f948$var$resumeEffects(store.effects);
                        return rendered();
                    }
                    if (!showFallback) return;
                    if (dispose) return prev;
                    return $8863cd8fe199f948$export$882461b6382ed46c((disposer)=>{
                        dispose = disposer;
                        if (ctx) {
                            $8863cd8fe199f948$var$setHydrateContext({
                                id: ctx.id + "F",
                                count: 0
                            });
                            ctx = undefined;
                        }
                        return props.fallback;
                    }, owner);
                });
            });
        }
    });
}
const $8863cd8fe199f948$export$404582bc18fe4d9e = undefined;


const $6258376c5c54faa9$var$booleans = [
    "allowfullscreen",
    "async",
    "alpha",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "disabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "seamless",
    "selected",
    "adauctionheaders",
    "browsingtopics",
    "credentialless",
    "defaultchecked",
    "defaultmuted",
    "defaultselected",
    "defer",
    "disablepictureinpicture",
    "disableremoteplayback",
    "preservespitch",
    "shadowrootclonable",
    "shadowrootcustomelementregistry",
    "shadowrootdelegatesfocus",
    "shadowrootserializable",
    "sharedstoragewritable"
];
const $6258376c5c54faa9$export$8714badcfa4caafb = /*#__PURE__*/ new Set([
    "className",
    "value",
    "readOnly",
    "noValidate",
    "formNoValidate",
    "isMap",
    "noModule",
    "playsInline",
    "adAuctionHeaders",
    "allowFullscreen",
    "browsingTopics",
    "defaultChecked",
    "defaultMuted",
    "defaultSelected",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "preservesPitch",
    "shadowRootClonable",
    "shadowRootCustomElementRegistry",
    "shadowRootDelegatesFocus",
    "shadowRootSerializable",
    "sharedStorageWritable",
    ...$6258376c5c54faa9$var$booleans
]);
const $6258376c5c54faa9$export$2c72a9edec54d5d9 = /*#__PURE__*/ new Set([
    "innerHTML",
    "textContent",
    "innerText",
    "children"
]);
const $6258376c5c54faa9$export$8915b7db7f70cfed = /*#__PURE__*/ Object.assign(Object.create(null), {
    className: "class",
    htmlFor: "for"
});
const $6258376c5c54faa9$var$PropAliases = /*#__PURE__*/ Object.assign(Object.create(null), {
    class: "className",
    novalidate: {
        $: "noValidate",
        FORM: 1
    },
    formnovalidate: {
        $: "formNoValidate",
        BUTTON: 1,
        INPUT: 1
    },
    ismap: {
        $: "isMap",
        IMG: 1
    },
    nomodule: {
        $: "noModule",
        SCRIPT: 1
    },
    playsinline: {
        $: "playsInline",
        VIDEO: 1
    },
    readonly: {
        $: "readOnly",
        INPUT: 1,
        TEXTAREA: 1
    },
    adauctionheaders: {
        $: "adAuctionHeaders",
        IFRAME: 1
    },
    allowfullscreen: {
        $: "allowFullscreen",
        IFRAME: 1
    },
    browsingtopics: {
        $: "browsingTopics",
        IMG: 1
    },
    defaultchecked: {
        $: "defaultChecked",
        INPUT: 1
    },
    defaultmuted: {
        $: "defaultMuted",
        AUDIO: 1,
        VIDEO: 1
    },
    defaultselected: {
        $: "defaultSelected",
        OPTION: 1
    },
    disablepictureinpicture: {
        $: "disablePictureInPicture",
        VIDEO: 1
    },
    disableremoteplayback: {
        $: "disableRemotePlayback",
        AUDIO: 1,
        VIDEO: 1
    },
    preservespitch: {
        $: "preservesPitch",
        AUDIO: 1,
        VIDEO: 1
    },
    shadowrootclonable: {
        $: "shadowRootClonable",
        TEMPLATE: 1
    },
    shadowrootdelegatesfocus: {
        $: "shadowRootDelegatesFocus",
        TEMPLATE: 1
    },
    shadowrootserializable: {
        $: "shadowRootSerializable",
        TEMPLATE: 1
    },
    sharedstoragewritable: {
        $: "sharedStorageWritable",
        IFRAME: 1,
        IMG: 1
    }
});
function $6258376c5c54faa9$export$72dcdd3761a309a9(prop, tagName) {
    const a = $6258376c5c54faa9$var$PropAliases[prop];
    return typeof a === "object" ? a[tagName] ? a["$"] : undefined : a;
}
const $6258376c5c54faa9$export$389d7c657d123a81 = /*#__PURE__*/ new Set([
    "beforeinput",
    "click",
    "dblclick",
    "contextmenu",
    "focusin",
    "focusout",
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "touchend",
    "touchmove",
    "touchstart"
]);
const $6258376c5c54faa9$export$ccaf9b9a82de4b98 = /*#__PURE__*/ new Set([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "set",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
]);
const $6258376c5c54faa9$export$fa927d1d0495a67d = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
const $6258376c5c54faa9$export$87d0e790667228e9 = /*#__PURE__*/ new Set([
    "html",
    "base",
    "head",
    "link",
    "meta",
    "style",
    "title",
    "body",
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "main",
    "nav",
    "section",
    "body",
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "ol",
    "p",
    "pre",
    "ul",
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    "area",
    "audio",
    "img",
    "map",
    "track",
    "video",
    "embed",
    "iframe",
    "object",
    "param",
    "picture",
    "portal",
    "source",
    "svg",
    "math",
    "canvas",
    "noscript",
    "script",
    "del",
    "ins",
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "button",
    "datalist",
    "fieldset",
    "form",
    "input",
    "label",
    "legend",
    "meter",
    "optgroup",
    "option",
    "output",
    "progress",
    "select",
    "textarea",
    "details",
    "dialog",
    "menu",
    "summary",
    "details",
    "slot",
    "template",
    "acronym",
    "applet",
    "basefont",
    "bgsound",
    "big",
    "blink",
    "center",
    "content",
    "dir",
    "font",
    "frame",
    "frameset",
    "hgroup",
    "image",
    "keygen",
    "marquee",
    "menuitem",
    "nobr",
    "noembed",
    "noframes",
    "plaintext",
    "rb",
    "rtc",
    "shadow",
    "spacer",
    "strike",
    "tt",
    "xmp",
    "a",
    "abbr",
    "acronym",
    "address",
    "applet",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "basefont",
    "bdi",
    "bdo",
    "bgsound",
    "big",
    "blink",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "center",
    "cite",
    "code",
    "col",
    "colgroup",
    "content",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "font",
    "footer",
    "form",
    "frame",
    "frameset",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "image",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "nobr",
    "noembed",
    "noframes",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "plaintext",
    "portal",
    "pre",
    "progress",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "shadow",
    "slot",
    "small",
    "source",
    "spacer",
    "span",
    "strike",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "xmp",
    "input",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "webview",
    "isindex",
    "listing",
    "multicol",
    "nextid",
    "noindex",
    "search"
]);
const $6258376c5c54faa9$export$7c73462e0d25e514 = (fn)=>(0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>fn());
function $6258376c5c54faa9$var$reconcileArrays(parentNode, a, b) {
    let bLength = b.length, aEnd = a.length, bEnd = bLength, aStart = 0, bStart = 0, after = a[aEnd - 1].nextSibling, map = null;
    while(aStart < aEnd || bStart < bEnd){
        if (a[aStart] === b[bStart]) {
            aStart++;
            bStart++;
            continue;
        }
        while(a[aEnd - 1] === b[bEnd - 1]){
            aEnd--;
            bEnd--;
        }
        if (aEnd === aStart) {
            const node = bEnd < bLength ? bStart ? b[bStart - 1].nextSibling : b[bEnd - bStart] : after;
            while(bStart < bEnd)parentNode.insertBefore(b[bStart++], node);
        } else if (bEnd === bStart) while(aStart < aEnd){
            if (!map || !map.has(a[aStart])) a[aStart].remove();
            aStart++;
        }
        else if (a[aStart] === b[bEnd - 1] && b[bStart] === a[aEnd - 1]) {
            const node = a[--aEnd].nextSibling;
            parentNode.insertBefore(b[bStart++], a[aStart++].nextSibling);
            parentNode.insertBefore(b[--bEnd], node);
            a[aEnd] = b[bEnd];
        } else {
            if (!map) {
                map = new Map();
                let i = bStart;
                while(i < bEnd)map.set(b[i], i++);
            }
            const index = map.get(a[aStart]);
            if (index != null) {
                if (bStart < index && index < bEnd) {
                    let i = aStart, sequence = 1, t;
                    while(++i < aEnd && i < bEnd){
                        if ((t = map.get(a[i])) == null || t !== index + sequence) break;
                        sequence++;
                    }
                    if (sequence > index - bStart) {
                        const node = a[aStart];
                        while(bStart < index)parentNode.insertBefore(b[bStart++], node);
                    } else parentNode.replaceChild(b[bStart++], a[aStart++]);
                } else aStart++;
            } else a[aStart++].remove();
        }
    }
}
const $6258376c5c54faa9$var$$$EVENTS = "_$DX_DELEGATE";
function $6258376c5c54faa9$export$b3890eb0ae9dca99(code, element, init, options = {}) {
    let disposer;
    (0, $8863cd8fe199f948$export$882461b6382ed46c)((dispose)=>{
        disposer = dispose;
        element === document ? code() : $6258376c5c54faa9$export$21a5ca8aa77d35ff(element, code(), element.firstChild ? null : undefined, init);
    }, options.owner);
    return ()=>{
        disposer();
        element.textContent = "";
    };
}
function $6258376c5c54faa9$export$ce69bd05624d0c48(html, isImportNode, isSVG, isMathML) {
    let node;
    const create = ()=>{
        const t = isMathML ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
        t.innerHTML = html;
        return isSVG ? t.content.firstChild.firstChild : isMathML ? t.firstChild : t.content.firstChild;
    };
    const fn = isImportNode ? ()=>(0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>document.importNode(node || (node = create()), true)) : ()=>(node || (node = create())).cloneNode(true);
    fn.cloneNode = fn;
    return fn;
}
function $6258376c5c54faa9$export$ad0f7f87f67e17d6(eventNames, document1 = window.document) {
    const e = document1[$6258376c5c54faa9$var$$$EVENTS] || (document1[$6258376c5c54faa9$var$$$EVENTS] = new Set());
    for(let i = 0, l = eventNames.length; i < l; i++){
        const name = eventNames[i];
        if (!e.has(name)) {
            e.add(name);
            document1.addEventListener(name, $6258376c5c54faa9$var$eventHandler);
        }
    }
}
function $6258376c5c54faa9$export$aedd29ca2033b694(document1 = window.document) {
    if (document1[$6258376c5c54faa9$var$$$EVENTS]) {
        for (let name of document1[$6258376c5c54faa9$var$$$EVENTS].keys())document1.removeEventListener(name, $6258376c5c54faa9$var$eventHandler);
        delete document1[$6258376c5c54faa9$var$$$EVENTS];
    }
}
function $6258376c5c54faa9$export$a41c68a4eb5ff164(node, name, value) {
    if ($6258376c5c54faa9$var$isHydrating(node)) return;
    if ((name === "value" || name === "defaultValue") && (node.nodeName === "INPUT" || node.nodeName === "TEXTAREA")) node[name] = value ?? "";
    else node[name] = value;
}
function $6258376c5c54faa9$export$9fec4d97f1922e0b(node, name, value) {
    if ($6258376c5c54faa9$var$isHydrating(node)) return;
    if (value == null) node.removeAttribute(name);
    else node.setAttribute(name, value);
}
function $6258376c5c54faa9$export$75900142c9e21800(node, namespace, name, value) {
    if ($6258376c5c54faa9$var$isHydrating(node)) return;
    if (value == null) node.removeAttributeNS(namespace, name);
    else node.setAttributeNS(namespace, name, value);
}
function $6258376c5c54faa9$export$248913d9a30bef7a(node, name, value) {
    if ($6258376c5c54faa9$var$isHydrating(node)) return;
    value ? node.setAttribute(name, "") : node.removeAttribute(name);
}
function $6258376c5c54faa9$export$2913c0c0b5623090(node, value) {
    if ($6258376c5c54faa9$var$isHydrating(node)) return;
    if (value == null) node.removeAttribute("class");
    else node.className = value;
}
function $6258376c5c54faa9$export$3f65cefe8380dbea(node, name, handler, delegate) {
    if (delegate) {
        if (Array.isArray(handler)) {
            node[`$$${name}`] = handler[0];
            node[`$$${name}Data`] = handler[1];
        } else node[`$$${name}`] = handler;
    } else if (Array.isArray(handler)) {
        const handlerFn = handler[0];
        node.addEventListener(name, handler[0] = (e)=>handlerFn.call(node, handler[1], e));
    } else node.addEventListener(name, handler, typeof handler !== "function" && handler);
}
function $6258376c5c54faa9$export$11c615ce16f87241(node, value, prev = {}) {
    const classKeys = Object.keys(value || {}), prevKeys = Object.keys(prev);
    let i, len;
    for(i = 0, len = prevKeys.length; i < len; i++){
        const key = prevKeys[i];
        if (!key || key === "undefined" || value[key]) continue;
        $6258376c5c54faa9$var$toggleClassKey(node, key, false);
        delete prev[key];
    }
    for(i = 0, len = classKeys.length; i < len; i++){
        const key = classKeys[i], classValue = !!value[key];
        if (!key || key === "undefined" || prev[key] === classValue || !classValue) continue;
        $6258376c5c54faa9$var$toggleClassKey(node, key, true);
        prev[key] = classValue;
    }
    return prev;
}
function $6258376c5c54faa9$export$1d567c320f4763bc(node, value, prev) {
    if (!value) return prev ? $6258376c5c54faa9$export$9fec4d97f1922e0b(node, "style") : value;
    const nodeStyle = node.style;
    if (typeof value === "string") return nodeStyle.cssText = value;
    typeof prev === "string" && (nodeStyle.cssText = prev = undefined);
    prev || (prev = {});
    value || (value = {});
    let v, s;
    for(s in prev){
        value[s] == null && nodeStyle.removeProperty(s);
        delete prev[s];
    }
    for(s in value){
        v = value[s];
        if (v !== prev[s]) {
            nodeStyle.setProperty(s, v);
            prev[s] = v;
        }
    }
    return prev;
}
function $6258376c5c54faa9$export$36a7c0615a5a1a31(node, name, value) {
    value != null ? node.style.setProperty(name, value) : node.style.removeProperty(name);
}
function $6258376c5c54faa9$export$3ae0fd4797ed47c8(node, props = {}, isSVG, skipChildren) {
    const prevProps = {};
    if (!skipChildren) (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>prevProps.children = $6258376c5c54faa9$var$insertExpression(node, props.children, prevProps.children));
    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>typeof props.ref === "function" && $6258376c5c54faa9$export$1f96ae73734a86cc(props.ref, node));
    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>$6258376c5c54faa9$export$e6e34fd1f2686227(node, props, isSVG, true, prevProps, true));
    return prevProps;
}
function $6258376c5c54faa9$export$2810486c22c942e9(props, key) {
    const src = props[key];
    Object.defineProperty(props, key, {
        get () {
            return src();
        },
        enumerable: true
    });
    return props;
}
function $6258376c5c54faa9$export$1f96ae73734a86cc(fn, element, arg) {
    return (0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>fn(element, arg));
}
function $6258376c5c54faa9$export$21a5ca8aa77d35ff(parent, accessor, marker, initial) {
    if (marker !== undefined && !initial) initial = [];
    if (typeof accessor !== "function") return $6258376c5c54faa9$var$insertExpression(parent, accessor, initial, marker);
    (0, $8863cd8fe199f948$export$314dade334ae905d)((current)=>$6258376c5c54faa9$var$insertExpression(parent, accessor(), current, marker), initial);
}
function $6258376c5c54faa9$export$e6e34fd1f2686227(node, props, isSVG, skipChildren, prevProps = {}, skipRef = false) {
    props || (props = {});
    for(const prop in prevProps)if (!(prop in props)) {
        if (prop === "children") continue;
        prevProps[prop] = $6258376c5c54faa9$var$assignProp(node, prop, null, prevProps[prop], isSVG, skipRef, props);
    }
    for(const prop in props){
        if (prop === "children") {
            if (!skipChildren) $6258376c5c54faa9$var$insertExpression(node, props.children);
            continue;
        }
        const value = props[prop];
        prevProps[prop] = $6258376c5c54faa9$var$assignProp(node, prop, value, prevProps[prop], isSVG, skipRef, props);
    }
}
function $6258376c5c54faa9$var$hydrate$1(code, element, options = {}) {
    if (globalThis._$HY.done) return $6258376c5c54faa9$export$b3890eb0ae9dca99(code, element, [
        ...element.childNodes
    ], options);
    (0, $8863cd8fe199f948$export$2cb4986bed338027).completed = globalThis._$HY.completed;
    (0, $8863cd8fe199f948$export$2cb4986bed338027).events = globalThis._$HY.events;
    (0, $8863cd8fe199f948$export$2cb4986bed338027).load = (id)=>globalThis._$HY.r[id];
    (0, $8863cd8fe199f948$export$2cb4986bed338027).has = (id)=>id in globalThis._$HY.r;
    (0, $8863cd8fe199f948$export$2cb4986bed338027).gather = (root)=>$6258376c5c54faa9$var$gatherHydratable(element, root);
    (0, $8863cd8fe199f948$export$2cb4986bed338027).registry = new Map();
    (0, $8863cd8fe199f948$export$2cb4986bed338027).context = {
        id: options.renderId || "",
        count: 0
    };
    try {
        $6258376c5c54faa9$var$gatherHydratable(element, options.renderId);
        return $6258376c5c54faa9$export$b3890eb0ae9dca99(code, element, [
            ...element.childNodes
        ], options);
    } finally{
        (0, $8863cd8fe199f948$export$2cb4986bed338027).context = null;
    }
}
function $6258376c5c54faa9$export$4109ed81edd7716d(template) {
    let node, key, hydrating = $6258376c5c54faa9$var$isHydrating();
    if (!hydrating || !(node = (0, $8863cd8fe199f948$export$2cb4986bed338027).registry.get(key = $6258376c5c54faa9$export$a5a9dff0691837de()))) return template();
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).completed) (0, $8863cd8fe199f948$export$2cb4986bed338027).completed.add(node);
    (0, $8863cd8fe199f948$export$2cb4986bed338027).registry.delete(key);
    return node;
}
function $6258376c5c54faa9$export$c19731b2c49ee4c9(el, nodeName) {
    while(el && el.localName !== nodeName)el = el.nextSibling;
    return el;
}
function $6258376c5c54faa9$export$5cf9b6f37b7c0802(start) {
    let end = start, count = 0, current = [];
    if ($6258376c5c54faa9$var$isHydrating(start)) while(end){
        if (end.nodeType === 8) {
            const v = end.nodeValue;
            if (v === "$") count++;
            else if (v === "/") {
                if (count === 0) return [
                    end,
                    current
                ];
                count--;
            }
        }
        current.push(end);
        end = end.nextSibling;
    }
    return [
        end,
        current
    ];
}
function $6258376c5c54faa9$export$6fef5763b6d3688d() {
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).events && !(0, $8863cd8fe199f948$export$2cb4986bed338027).events.queued) {
        queueMicrotask(()=>{
            const { completed: completed, events: events } = (0, $8863cd8fe199f948$export$2cb4986bed338027);
            if (!events) return;
            events.queued = false;
            while(events.length){
                const [el, e] = events[0];
                if (!completed.has(el)) return;
                events.shift();
                $6258376c5c54faa9$var$eventHandler(e);
            }
            if ((0, $8863cd8fe199f948$export$2cb4986bed338027).done) {
                (0, $8863cd8fe199f948$export$2cb4986bed338027).events = _$HY.events = null;
                (0, $8863cd8fe199f948$export$2cb4986bed338027).completed = _$HY.completed = null;
            }
        });
        (0, $8863cd8fe199f948$export$2cb4986bed338027).events.queued = true;
    }
}
function $6258376c5c54faa9$var$isHydrating(node) {
    return !!(0, $8863cd8fe199f948$export$2cb4986bed338027).context && !(0, $8863cd8fe199f948$export$2cb4986bed338027).done && (!node || node.isConnected);
}
function $6258376c5c54faa9$var$toPropertyName(name) {
    return name.toLowerCase().replace(/-([a-z])/g, (_, w)=>w.toUpperCase());
}
function $6258376c5c54faa9$var$toggleClassKey(node, key, value) {
    const classNames = key.trim().split(/\s+/);
    for(let i = 0, nameLen = classNames.length; i < nameLen; i++)node.classList.toggle(classNames[i], value);
}
function $6258376c5c54faa9$var$assignProp(node, prop, value, prev, isSVG, skipRef, props) {
    let isCE, isProp, isChildProp, propAlias, forceProp;
    if (prop === "style") return $6258376c5c54faa9$export$1d567c320f4763bc(node, value, prev);
    if (prop === "classList") return $6258376c5c54faa9$export$11c615ce16f87241(node, value, prev);
    if (value === prev) return prev;
    if (prop === "ref") {
        if (!skipRef) value(node);
    } else if (prop.slice(0, 3) === "on:") {
        const e = prop.slice(3);
        prev && node.removeEventListener(e, prev, typeof prev !== "function" && prev);
        value && node.addEventListener(e, value, typeof value !== "function" && value);
    } else if (prop.slice(0, 10) === "oncapture:") {
        const e = prop.slice(10);
        prev && node.removeEventListener(e, prev, true);
        value && node.addEventListener(e, value, true);
    } else if (prop.slice(0, 2) === "on") {
        const name = prop.slice(2).toLowerCase();
        const delegate = $6258376c5c54faa9$export$389d7c657d123a81.has(name);
        if (!delegate && prev) {
            const h = Array.isArray(prev) ? prev[0] : prev;
            node.removeEventListener(name, h);
        }
        if (delegate || value) {
            $6258376c5c54faa9$export$3f65cefe8380dbea(node, name, value, delegate);
            delegate && $6258376c5c54faa9$export$ad0f7f87f67e17d6([
                name
            ]);
        }
    } else if (prop.slice(0, 5) === "attr:") $6258376c5c54faa9$export$9fec4d97f1922e0b(node, prop.slice(5), value);
    else if (prop.slice(0, 5) === "bool:") $6258376c5c54faa9$export$248913d9a30bef7a(node, prop.slice(5), value);
    else if ((forceProp = prop.slice(0, 5) === "prop:") || (isChildProp = $6258376c5c54faa9$export$2c72a9edec54d5d9.has(prop)) || !isSVG && ((propAlias = $6258376c5c54faa9$export$72dcdd3761a309a9(prop, node.tagName)) || (isProp = $6258376c5c54faa9$export$8714badcfa4caafb.has(prop))) || (isCE = node.nodeName.includes("-") || "is" in props)) {
        if (forceProp) {
            prop = prop.slice(5);
            isProp = true;
        } else if ($6258376c5c54faa9$var$isHydrating(node)) return value;
        if (prop === "class" || prop === "className") $6258376c5c54faa9$export$2913c0c0b5623090(node, value);
        else if (isCE && !isProp && !isChildProp) node[$6258376c5c54faa9$var$toPropertyName(prop)] = value;
        else if ((prop === "value" || prop === "defaultValue") && (node.nodeName === "INPUT" || node.nodeName === "TEXTAREA")) node[propAlias || prop] = value ?? "";
        else node[propAlias || prop] = value;
    } else {
        const ns = isSVG && prop.indexOf(":") > -1 && $6258376c5c54faa9$export$fa927d1d0495a67d[prop.split(":")[0]];
        if (ns) $6258376c5c54faa9$export$75900142c9e21800(node, ns, prop, value);
        else $6258376c5c54faa9$export$9fec4d97f1922e0b(node, $6258376c5c54faa9$export$8915b7db7f70cfed[prop] || prop, value);
    }
    return value;
}
function $6258376c5c54faa9$var$eventHandler(e) {
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).registry && (0, $8863cd8fe199f948$export$2cb4986bed338027).events) {
        if ((0, $8863cd8fe199f948$export$2cb4986bed338027).events.find(([el, ev])=>ev === e)) return;
    }
    let node = e.target;
    const key = `$$${e.type}`;
    const oriTarget = e.target;
    const oriCurrentTarget = e.currentTarget;
    const retarget = (value)=>Object.defineProperty(e, "target", {
            configurable: true,
            value: value
        });
    const handleNode = ()=>{
        const handler = node[key];
        if (handler && !node.disabled) {
            const data = node[`${key}Data`];
            data !== undefined ? handler.call(node, data, e) : handler.call(node, e);
            if (e.cancelBubble) return;
        }
        node.host && typeof node.host !== "string" && !node.host._$host && node.contains(e.target) && retarget(node.host);
        return true;
    };
    const walkUpTree = ()=>{
        while(handleNode() && (node = node._$host || node.parentNode || node.host));
    };
    Object.defineProperty(e, "currentTarget", {
        configurable: true,
        get () {
            return node || document;
        }
    });
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).registry && !(0, $8863cd8fe199f948$export$2cb4986bed338027).done) (0, $8863cd8fe199f948$export$2cb4986bed338027).done = _$HY.done = true;
    if (e.composedPath) {
        const path = e.composedPath();
        retarget(path[0]);
        for(let i = 0; i < path.length - 2; i++){
            node = path[i];
            if (!handleNode()) break;
            if (node._$host) {
                node = node._$host;
                walkUpTree();
                break;
            }
            if (node.parentNode === oriCurrentTarget) break;
        }
    } else walkUpTree();
    retarget(oriTarget);
}
function $6258376c5c54faa9$var$insertExpression(parent, value, current, marker, unwrapArray) {
    const hydrating = $6258376c5c54faa9$var$isHydrating(parent);
    if (hydrating) {
        !current && (current = [
            ...parent.childNodes
        ]);
        let cleaned = [];
        for(let i = 0; i < current.length; i++){
            const node = current[i];
            if (node.nodeType === 8 && node.data.slice(0, 2) === "!$") node.remove();
            else cleaned.push(node);
        }
        current = cleaned;
    }
    while(typeof current === "function")current = current();
    if (value === current) return current;
    const t = typeof value, multi = marker !== undefined;
    parent = multi && current[0] && current[0].parentNode || parent;
    if (t === "string" || t === "number") {
        if (hydrating) return current;
        if (t === "number") {
            value = value.toString();
            if (value === current) return current;
        }
        if (multi) {
            let node = current[0];
            if (node && node.nodeType === 3) node.data !== value && (node.data = value);
            else node = document.createTextNode(value);
            current = $6258376c5c54faa9$var$cleanChildren(parent, current, marker, node);
        } else if (current !== "" && typeof current === "string") current = parent.firstChild.data = value;
        else current = parent.textContent = value;
    } else if (value == null || t === "boolean") {
        if (hydrating) return current;
        current = $6258376c5c54faa9$var$cleanChildren(parent, current, marker);
    } else if (t === "function") {
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>{
            let v = value();
            while(typeof v === "function")v = v();
            current = $6258376c5c54faa9$var$insertExpression(parent, v, current, marker);
        });
        return ()=>current;
    } else if (Array.isArray(value)) {
        const array = [];
        const currentArray = current && Array.isArray(current);
        if ($6258376c5c54faa9$var$normalizeIncomingArray(array, value, current, unwrapArray)) {
            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>current = $6258376c5c54faa9$var$insertExpression(parent, array, current, marker, true));
            return ()=>current;
        }
        if (hydrating) {
            if (!array.length) return current;
            if (marker === undefined) return current = [
                ...parent.childNodes
            ];
            let node = array[0];
            if (node.parentNode !== parent) return current;
            const nodes = [
                node
            ];
            while((node = node.nextSibling) !== marker)nodes.push(node);
            return current = nodes;
        }
        if (array.length === 0) {
            current = $6258376c5c54faa9$var$cleanChildren(parent, current, marker);
            if (multi) return current;
        } else if (currentArray) {
            if (current.length === 0) $6258376c5c54faa9$var$appendNodes(parent, array, marker);
            else $6258376c5c54faa9$var$reconcileArrays(parent, current, array);
        } else {
            current && $6258376c5c54faa9$var$cleanChildren(parent);
            $6258376c5c54faa9$var$appendNodes(parent, array);
        }
        current = array;
    } else if (value.nodeType) {
        if (hydrating && value.parentNode) return current = multi ? [
            value
        ] : value;
        if (Array.isArray(current)) {
            if (multi) return current = $6258376c5c54faa9$var$cleanChildren(parent, current, marker, value);
            $6258376c5c54faa9$var$cleanChildren(parent, current, null, value);
        } else if (current == null || current === "" || !parent.firstChild) parent.appendChild(value);
        else parent.replaceChild(value, parent.firstChild);
        current = value;
    }
    return current;
}
function $6258376c5c54faa9$var$normalizeIncomingArray(normalized, array, current, unwrap) {
    let dynamic = false;
    for(let i = 0, len = array.length; i < len; i++){
        let item = array[i], prev = current && current[normalized.length], t;
        if (item == null || item === true || item === false) ;
        else if ((t = typeof item) === "object" && item.nodeType) normalized.push(item);
        else if (Array.isArray(item)) dynamic = $6258376c5c54faa9$var$normalizeIncomingArray(normalized, item, prev) || dynamic;
        else if (t === "function") {
            if (unwrap) {
                while(typeof item === "function")item = item();
                dynamic = $6258376c5c54faa9$var$normalizeIncomingArray(normalized, Array.isArray(item) ? item : [
                    item
                ], Array.isArray(prev) ? prev : [
                    prev
                ]) || dynamic;
            } else {
                normalized.push(item);
                dynamic = true;
            }
        } else {
            const value = String(item);
            if (prev && prev.nodeType === 3 && prev.data === value) normalized.push(prev);
            else normalized.push(document.createTextNode(value));
        }
    }
    return dynamic;
}
function $6258376c5c54faa9$var$appendNodes(parent, array, marker = null) {
    for(let i = 0, len = array.length; i < len; i++)parent.insertBefore(array[i], marker);
}
function $6258376c5c54faa9$var$cleanChildren(parent, current, marker, replacement) {
    if (marker === undefined) return parent.textContent = "";
    const node = replacement || document.createTextNode("");
    if (current.length) {
        let inserted = false;
        for(let i = current.length - 1; i >= 0; i--){
            const el = current[i];
            if (node !== el) {
                const isParent = el.parentNode === parent;
                if (!inserted && !i) isParent ? parent.replaceChild(node, el) : parent.insertBefore(node, marker);
                else isParent && el.remove();
            } else inserted = true;
        }
    } else parent.insertBefore(node, marker);
    return [
        node
    ];
}
function $6258376c5c54faa9$var$gatherHydratable(element, root) {
    const templates = element.querySelectorAll(`*[data-hk]`);
    for(let i = 0; i < templates.length; i++){
        const node = templates[i];
        const key = node.getAttribute("data-hk");
        if ((!root || key.startsWith(root)) && !(0, $8863cd8fe199f948$export$2cb4986bed338027).registry.has(key)) (0, $8863cd8fe199f948$export$2cb4986bed338027).registry.set(key, node);
    }
}
function $6258376c5c54faa9$export$a5a9dff0691837de() {
    return (0, $8863cd8fe199f948$export$2cb4986bed338027).getNextContextId();
}
function $6258376c5c54faa9$export$36143b7c9c07dd39(props) {
    return (0, $8863cd8fe199f948$export$2cb4986bed338027).context ? undefined : props.children;
}
function $6258376c5c54faa9$export$da8cca6e5dfa3577(props) {
    return props.children;
}
const $6258376c5c54faa9$export$c8eca95e306f7116 = ()=>undefined;
const $6258376c5c54faa9$export$5df49ba75ba1c1f9 = Symbol();
function $6258376c5c54faa9$export$8bd3fff6c675ca8d(parent, content) {
    !(0, $8863cd8fe199f948$export$2cb4986bed338027).context && (parent.innerHTML = content);
}
function $6258376c5c54faa9$var$throwInBrowser(func) {
    const err = new Error(`${func.name} is not supported in the browser, returning undefined`);
    console.error(err);
}
function $6258376c5c54faa9$export$80e7718417253a51(fn, options) {
    $6258376c5c54faa9$var$throwInBrowser($6258376c5c54faa9$export$80e7718417253a51);
}
function $6258376c5c54faa9$export$f3aefc4196cd5f3e(fn, options) {
    $6258376c5c54faa9$var$throwInBrowser($6258376c5c54faa9$export$f3aefc4196cd5f3e);
}
function $6258376c5c54faa9$export$97f86213fef5749d(fn, options) {
    $6258376c5c54faa9$var$throwInBrowser($6258376c5c54faa9$export$97f86213fef5749d);
}
function $6258376c5c54faa9$export$ea2375f6c0c9ffdc(template, ...nodes) {}
function $6258376c5c54faa9$export$1844beb7faeb4553(name, props, children, needsId) {}
function $6258376c5c54faa9$export$e92e0c287593a882(value) {}
function $6258376c5c54faa9$export$9e97f11b9d683d7a(value) {}
function $6258376c5c54faa9$export$9ab8bdc1e27e51e1(key, value) {}
function $6258376c5c54faa9$export$7e66a08c0b8ab2aa() {}
function $6258376c5c54faa9$export$755e9f954b4fd36e(node) {}
function $6258376c5c54faa9$export$4e7f196112fea3c5(html) {}
function $6258376c5c54faa9$export$8c2b042ce8153017(props, isSVG, skipChildren) {}
const $6258376c5c54faa9$export$6acf61af03e62db = false;
const $6258376c5c54faa9$export$40edfb7eeb78c4e8 = false;
const $6258376c5c54faa9$var$SVG_NAMESPACE = "http://www.w3.org/2000/svg";
function $6258376c5c54faa9$var$createElement(tagName, isSVG = false, is) {
    return isSVG ? document.createElementNS($6258376c5c54faa9$var$SVG_NAMESPACE, tagName) : document.createElement(tagName, {
        is: is
    });
}
const $6258376c5c54faa9$export$fa8d919ba61d84db = (...args)=>{
    (0, $8863cd8fe199f948$export$849801d35d2160c9)();
    return $6258376c5c54faa9$var$hydrate$1(...args);
};
function $6258376c5c54faa9$export$602eac185826482c(props) {
    const { useShadow: useShadow } = props, marker = document.createTextNode(""), mount = ()=>props.mount || document.body, owner = (0, $8863cd8fe199f948$export$5f4ed0d56c2c0edf)();
    let content;
    let hydrating = !!(0, $8863cd8fe199f948$export$2cb4986bed338027).context;
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        if (hydrating) (0, $8863cd8fe199f948$export$5f4ed0d56c2c0edf)().user = hydrating = false;
        content || (content = (0, $8863cd8fe199f948$export$c14f3e3abbc7d6b5)(owner, ()=>(0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>props.children)));
        const el = mount();
        if (el instanceof HTMLHeadElement) {
            const [clean, setClean] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
            const cleanup = ()=>setClean(true);
            (0, $8863cd8fe199f948$export$882461b6382ed46c)((dispose)=>$6258376c5c54faa9$export$21a5ca8aa77d35ff(el, ()=>!clean() ? content() : dispose(), null));
            (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(cleanup);
        } else {
            const container = $6258376c5c54faa9$var$createElement(props.isSVG ? "g" : "div", props.isSVG), renderRoot = useShadow && container.attachShadow ? container.attachShadow({
                mode: "open"
            }) : container;
            Object.defineProperty(container, "_$host", {
                get () {
                    return marker.parentNode;
                },
                configurable: true
            });
            $6258376c5c54faa9$export$21a5ca8aa77d35ff(renderRoot, content);
            el.appendChild(container);
            props.ref && props.ref(container);
            (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>el.contains(container) && el.removeChild(container));
        }
    }, undefined, {
        render: !hydrating
    });
    return marker;
}
function $6258376c5c54faa9$export$9a3ff77bac07eb26(component, props) {
    const cached = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(component);
    return (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const component = cached();
        switch(typeof component){
            case "function":
                return (0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>component(props));
            case "string":
                const isSvg = $6258376c5c54faa9$export$ccaf9b9a82de4b98.has(component);
                const el = (0, $8863cd8fe199f948$export$2cb4986bed338027).context ? $6258376c5c54faa9$export$4109ed81edd7716d() : $6258376c5c54faa9$var$createElement(component, isSvg, (0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>props.is));
                $6258376c5c54faa9$export$3ae0fd4797ed47c8(el, props, isSvg);
                return el;
        }
    });
}
function $6258376c5c54faa9$export$e18282e419e46834(props) {
    const [, others] = (0, $8863cd8fe199f948$export$45029c61b0073d87)(props, [
        "component"
    ]);
    return $6258376c5c54faa9$export$9a3ff77bac07eb26(()=>props.component, others);
}






const $caa70d287a6ddb62$export$9f4df9bfaca7e3b7 = Symbol("store-raw"), $caa70d287a6ddb62$var$$NODE = Symbol("store-node"), $caa70d287a6ddb62$var$$HAS = Symbol("store-has"), $caa70d287a6ddb62$var$$SELF = Symbol("store-self");
function $caa70d287a6ddb62$var$wrap$1(value) {
    let p = value[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5];
    if (!p) {
        Object.defineProperty(value, (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5), {
            value: p = new Proxy(value, $caa70d287a6ddb62$var$proxyTraps$1)
        });
        if (!Array.isArray(value)) {
            const keys = Object.keys(value), desc = Object.getOwnPropertyDescriptors(value), proto = Object.getPrototypeOf(value);
            const isClass = proto !== null && value !== null && typeof value === "object" && !Array.isArray(value) && proto !== Object.prototype;
            if (isClass) {
                const descriptors = Object.getOwnPropertyDescriptors(proto);
                keys.push(...Object.keys(descriptors));
                Object.assign(desc, descriptors);
            }
            for(let i = 0, l = keys.length; i < l; i++){
                const prop = keys[i];
                if (isClass && prop === "constructor") continue;
                if (desc[prop].get) Object.defineProperty(value, prop, {
                    configurable: true,
                    enumerable: desc[prop].enumerable,
                    get: desc[prop].get.bind(p)
                });
            }
        }
    }
    return p;
}
function $caa70d287a6ddb62$var$isWrappable(obj) {
    let proto;
    return obj != null && typeof obj === "object" && (obj[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5] || !(proto = Object.getPrototypeOf(obj)) || proto === Object.prototype || Array.isArray(obj));
}
function $caa70d287a6ddb62$export$debb760848ca95a(item, set = new Set()) {
    let result, unwrapped, v, prop;
    if (result = item != null && item[$caa70d287a6ddb62$export$9f4df9bfaca7e3b7]) return result;
    if (!$caa70d287a6ddb62$var$isWrappable(item) || set.has(item)) return item;
    if (Array.isArray(item)) {
        if (Object.isFrozen(item)) item = item.slice(0);
        else set.add(item);
        for(let i = 0, l = item.length; i < l; i++){
            v = item[i];
            if ((unwrapped = $caa70d287a6ddb62$export$debb760848ca95a(v, set)) !== v) item[i] = unwrapped;
        }
    } else {
        if (Object.isFrozen(item)) item = Object.assign({}, item);
        else set.add(item);
        const keys = Object.keys(item), desc = Object.getOwnPropertyDescriptors(item);
        for(let i = 0, l = keys.length; i < l; i++){
            prop = keys[i];
            if (desc[prop].get) continue;
            v = item[prop];
            if ((unwrapped = $caa70d287a6ddb62$export$debb760848ca95a(v, set)) !== v) item[prop] = unwrapped;
        }
    }
    return item;
}
function $caa70d287a6ddb62$var$getNodes(target, symbol) {
    let nodes = target[symbol];
    if (!nodes) Object.defineProperty(target, symbol, {
        value: nodes = Object.create(null)
    });
    return nodes;
}
function $caa70d287a6ddb62$var$getNode(nodes, property, value) {
    if (nodes[property]) return nodes[property];
    const [s, set] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(value, {
        equals: false,
        internal: true
    });
    s.$ = set;
    return nodes[property] = s;
}
function $caa70d287a6ddb62$var$proxyDescriptor$1(target, property) {
    const desc = Reflect.getOwnPropertyDescriptor(target, property);
    if (!desc || desc.get || !desc.configurable || property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === $caa70d287a6ddb62$var$$NODE) return desc;
    delete desc.value;
    delete desc.writable;
    desc.get = ()=>target[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5][property];
    return desc;
}
function $caa70d287a6ddb62$var$trackSelf(target) {
    (0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && $caa70d287a6ddb62$var$getNode($caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$NODE), $caa70d287a6ddb62$var$$SELF)();
}
function $caa70d287a6ddb62$var$ownKeys(target) {
    $caa70d287a6ddb62$var$trackSelf(target);
    return Reflect.ownKeys(target);
}
const $caa70d287a6ddb62$var$proxyTraps$1 = {
    get (target, property, receiver) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7) return target;
        if (property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5)) return receiver;
        if (property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d)) {
            $caa70d287a6ddb62$var$trackSelf(target);
            return receiver;
        }
        const nodes = $caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$NODE);
        const tracked = nodes[property];
        let value = tracked ? tracked() : target[property];
        if (property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return value;
        if (!tracked) {
            const desc = Object.getOwnPropertyDescriptor(target, property);
            if ((0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && (typeof value !== "function" || Object.prototype.hasOwnProperty.call(target, property)) && !(desc && desc.get)) value = $caa70d287a6ddb62$var$getNode(nodes, property, value)();
        }
        return $caa70d287a6ddb62$var$isWrappable(value) ? $caa70d287a6ddb62$var$wrap$1(value) : value;
    },
    has (target, property) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7 || property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d) || property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return true;
        (0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && $caa70d287a6ddb62$var$getNode($caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$HAS), property)();
        return property in target;
    },
    set () {
        return true;
    },
    deleteProperty () {
        return true;
    },
    ownKeys: $caa70d287a6ddb62$var$ownKeys,
    getOwnPropertyDescriptor: $caa70d287a6ddb62$var$proxyDescriptor$1
};
function $caa70d287a6ddb62$var$setProperty(state, property, value, deleting = false) {
    if (property === "__proto__") return;
    if (!deleting && state[property] === value) return;
    const prev = state[property], len = state.length;
    if (value === undefined) {
        delete state[property];
        if (state[$caa70d287a6ddb62$var$$HAS] && state[$caa70d287a6ddb62$var$$HAS][property] && prev !== undefined) state[$caa70d287a6ddb62$var$$HAS][property].$();
    } else {
        state[property] = value;
        if (state[$caa70d287a6ddb62$var$$HAS] && state[$caa70d287a6ddb62$var$$HAS][property] && prev === undefined) state[$caa70d287a6ddb62$var$$HAS][property].$();
    }
    let nodes = $caa70d287a6ddb62$var$getNodes(state, $caa70d287a6ddb62$var$$NODE), node;
    if (node = $caa70d287a6ddb62$var$getNode(nodes, property, prev)) node.$(()=>value);
    if (Array.isArray(state) && state.length !== len) {
        for(let i = state.length; i < len; i++)(node = nodes[i]) && node.$();
        (node = $caa70d287a6ddb62$var$getNode(nodes, "length", len)) && node.$(state.length);
    }
    (node = nodes[$caa70d287a6ddb62$var$$SELF]) && node.$();
}
function $caa70d287a6ddb62$var$mergeStoreNode(state, value) {
    const keys = Object.keys(value);
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        if ($caa70d287a6ddb62$var$isUnsafeKey$1(key)) continue;
        $caa70d287a6ddb62$var$setProperty(state, key, value[key]);
    }
}
function $caa70d287a6ddb62$var$isUnsafeKey$1(property) {
    return property === "__proto__" || property === "constructor" || property === "prototype";
}
function $caa70d287a6ddb62$var$updateArray(current, next) {
    if (typeof next === "function") next = next(current);
    next = $caa70d287a6ddb62$export$debb760848ca95a(next);
    if (Array.isArray(next)) {
        if (current === next) return;
        let i = 0, len = next.length;
        for(; i < len; i++){
            const value = next[i];
            if (current[i] !== value) $caa70d287a6ddb62$var$setProperty(current, i, value);
        }
        $caa70d287a6ddb62$var$setProperty(current, "length", len);
    } else $caa70d287a6ddb62$var$mergeStoreNode(current, next);
}
function $caa70d287a6ddb62$var$updatePath(current, path, traversed = []) {
    let part, prev = current;
    if (path.length > 1) {
        part = path.shift();
        const partType = typeof part, isArray = Array.isArray(current);
        if (partType === "string" && (part === "__proto__" || path.length > 1 && $caa70d287a6ddb62$var$isUnsafeKey$1(part))) return;
        if (Array.isArray(part)) {
            for(let i = 0; i < part.length; i++)$caa70d287a6ddb62$var$updatePath(current, [
                part[i]
            ].concat(path), traversed);
            return;
        } else if (isArray && partType === "function") {
            for(let i = 0; i < current.length; i++)if (part(current[i], i)) $caa70d287a6ddb62$var$updatePath(current, [
                i
            ].concat(path), traversed);
            return;
        } else if (isArray && partType === "object") {
            const { from: from = 0, to: to = current.length - 1, by: by = 1 } = part;
            for(let i = from; i <= to; i += by)$caa70d287a6ddb62$var$updatePath(current, [
                i
            ].concat(path), traversed);
            return;
        } else if (path.length > 1) {
            $caa70d287a6ddb62$var$updatePath(current[part], path, [
                part
            ].concat(traversed));
            return;
        }
        prev = current[part];
        traversed = [
            part
        ].concat(traversed);
    }
    let value = path[0];
    if (typeof value === "function") {
        value = value(prev, traversed);
        if (value === prev) return;
    }
    if (part === undefined && value == undefined) return;
    value = $caa70d287a6ddb62$export$debb760848ca95a(value);
    if (part === undefined || $caa70d287a6ddb62$var$isWrappable(prev) && $caa70d287a6ddb62$var$isWrappable(value) && !Array.isArray(value)) $caa70d287a6ddb62$var$mergeStoreNode(prev, value);
    else $caa70d287a6ddb62$var$setProperty(current, part, value);
}
function $caa70d287a6ddb62$export$f51a9068ac82ea43(...[store, options]) {
    const unwrappedStore = $caa70d287a6ddb62$export$debb760848ca95a(store || {});
    const isArray = Array.isArray(unwrappedStore);
    const wrappedStore = $caa70d287a6ddb62$var$wrap$1(unwrappedStore);
    function setStore(...args) {
        (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>{
            isArray && args.length === 1 ? $caa70d287a6ddb62$var$updateArray(unwrappedStore, args[0]) : $caa70d287a6ddb62$var$updatePath(unwrappedStore, args);
        });
    }
    return [
        wrappedStore,
        setStore
    ];
}
function $caa70d287a6ddb62$var$proxyDescriptor(target, property) {
    const desc = Reflect.getOwnPropertyDescriptor(target, property);
    if (!desc || desc.get || desc.set || !desc.configurable || property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === $caa70d287a6ddb62$var$$NODE) return desc;
    delete desc.value;
    delete desc.writable;
    desc.get = ()=>target[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5][property];
    desc.set = (v)=>target[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5][property] = v;
    return desc;
}
const $caa70d287a6ddb62$var$proxyTraps = {
    get (target, property, receiver) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7) return target;
        if (property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5)) return receiver;
        if (property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d)) {
            $caa70d287a6ddb62$var$trackSelf(target);
            return receiver;
        }
        const nodes = $caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$NODE);
        const tracked = nodes[property];
        let value = tracked ? tracked() : target[property];
        if (property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return value;
        if (!tracked) {
            const desc = Object.getOwnPropertyDescriptor(target, property);
            const isFunction = typeof value === "function";
            if ((0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && (!isFunction || Object.prototype.hasOwnProperty.call(target, property)) && !(desc && desc.get)) value = $caa70d287a6ddb62$var$getNode(nodes, property, value)();
            else if (value != null && isFunction && value === Array.prototype[property]) return (...args)=>(0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>Array.prototype[property].apply(receiver, args));
        }
        return $caa70d287a6ddb62$var$isWrappable(value) ? $caa70d287a6ddb62$var$wrap(value) : value;
    },
    has (target, property) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7 || property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d) || property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return true;
        (0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && $caa70d287a6ddb62$var$getNode($caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$HAS), property)();
        return property in target;
    },
    set (target, property, value) {
        (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>$caa70d287a6ddb62$var$setProperty(target, property, $caa70d287a6ddb62$export$debb760848ca95a(value)));
        return true;
    },
    deleteProperty (target, property) {
        (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>$caa70d287a6ddb62$var$setProperty(target, property, undefined, true));
        return true;
    },
    ownKeys: $caa70d287a6ddb62$var$ownKeys,
    getOwnPropertyDescriptor: $caa70d287a6ddb62$var$proxyDescriptor
};
function $caa70d287a6ddb62$var$wrap(value) {
    let p = value[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5];
    if (!p) {
        Object.defineProperty(value, (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5), {
            value: p = new Proxy(value, $caa70d287a6ddb62$var$proxyTraps)
        });
        const keys = Object.keys(value), desc = Object.getOwnPropertyDescriptors(value);
        const proto = Object.getPrototypeOf(value);
        const isClass = proto !== null && value !== null && typeof value === "object" && !Array.isArray(value) && proto !== Object.prototype;
        if (isClass) {
            let curProto = proto;
            while(curProto != null){
                const descriptors = Object.getOwnPropertyDescriptors(curProto);
                keys.push(...Object.keys(descriptors));
                Object.assign(desc, descriptors);
                curProto = Object.getPrototypeOf(curProto);
            }
        }
        for(let i = 0, l = keys.length; i < l; i++){
            const prop = keys[i];
            if (isClass && prop === "constructor") continue;
            if (desc[prop].get) {
                const get = desc[prop].get.bind(p);
                Object.defineProperty(value, prop, {
                    get: get,
                    configurable: true
                });
            }
            if (desc[prop].set) {
                const og = desc[prop].set, set = (v)=>(0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>og.call(p, v));
                Object.defineProperty(value, prop, {
                    set: set,
                    configurable: true
                });
            }
        }
    }
    return p;
}
function $caa70d287a6ddb62$export$ab7224b136d4492e(state, options) {
    const unwrappedStore = $caa70d287a6ddb62$export$debb760848ca95a(state || {});
    const wrappedStore = $caa70d287a6ddb62$var$wrap(unwrappedStore);
    return wrappedStore;
}
function $caa70d287a6ddb62$export$4939f032d60167b6(state, modifier) {
    (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>modifier($caa70d287a6ddb62$export$debb760848ca95a(state)));
}
const $caa70d287a6ddb62$var$$ROOT = Symbol("store-root");
function $caa70d287a6ddb62$var$isUnsafeKey(property) {
    return property === "__proto__" || property === "constructor" || property === "prototype";
}
function $caa70d287a6ddb62$var$applyState(target, parent, property, merge, key) {
    if ($caa70d287a6ddb62$var$isUnsafeKey(property)) return;
    const previous = parent[property];
    if (target === previous) return;
    const isArray = Array.isArray(target);
    if (property !== $caa70d287a6ddb62$var$$ROOT && (!$caa70d287a6ddb62$var$isWrappable(target) || !$caa70d287a6ddb62$var$isWrappable(previous) || isArray !== Array.isArray(previous) || key && target[key] !== previous[key])) {
        $caa70d287a6ddb62$var$setProperty(parent, property, target);
        return;
    }
    if (isArray) {
        if (target.length && previous.length && (!merge || key && target[0] && target[0][key] != null)) {
            let i, j, start, end, newEnd, item, newIndicesNext, keyVal;
            for(start = 0, end = Math.min(previous.length, target.length); start < end && (previous[start] === target[start] || key && previous[start] && target[start] && previous[start][key] && previous[start][key] === target[start][key]); start++)$caa70d287a6ddb62$var$applyState(target[start], previous, start, merge, key);
            const temp = new Array(target.length), newIndices = new Map();
            for(end = previous.length - 1, newEnd = target.length - 1; end >= start && newEnd >= start && (previous[end] === target[newEnd] || key && previous[end] && target[newEnd] && previous[end][key] && previous[end][key] === target[newEnd][key]); end--, newEnd--)temp[newEnd] = previous[end];
            if (start > newEnd || start > end) {
                for(j = start; j <= newEnd; j++)$caa70d287a6ddb62$var$setProperty(previous, j, target[j]);
                for(; j < target.length; j++){
                    $caa70d287a6ddb62$var$setProperty(previous, j, temp[j]);
                    $caa70d287a6ddb62$var$applyState(target[j], previous, j, merge, key);
                }
                if (previous.length > target.length) $caa70d287a6ddb62$var$setProperty(previous, "length", target.length);
                return;
            }
            newIndicesNext = new Array(newEnd + 1);
            for(j = newEnd; j >= start; j--){
                item = target[j];
                keyVal = key && item ? item[key] : item;
                i = newIndices.get(keyVal);
                newIndicesNext[j] = i === undefined ? -1 : i;
                newIndices.set(keyVal, j);
            }
            for(i = start; i <= end; i++){
                item = previous[i];
                keyVal = key && item ? item[key] : item;
                j = newIndices.get(keyVal);
                if (j !== undefined && j !== -1) {
                    temp[j] = previous[i];
                    j = newIndicesNext[j];
                    newIndices.set(keyVal, j);
                }
            }
            for(j = start; j < target.length; j++)if (j in temp) {
                $caa70d287a6ddb62$var$setProperty(previous, j, temp[j]);
                $caa70d287a6ddb62$var$applyState(target[j], previous, j, merge, key);
            } else $caa70d287a6ddb62$var$setProperty(previous, j, target[j]);
        } else for(let i = 0, len = target.length; i < len; i++)$caa70d287a6ddb62$var$applyState(target[i], previous, i, merge, key);
        if (previous.length > target.length) $caa70d287a6ddb62$var$setProperty(previous, "length", target.length);
        return;
    }
    const targetKeys = Object.keys(target);
    for(let i = 0, len = targetKeys.length; i < len; i++){
        if ($caa70d287a6ddb62$var$isUnsafeKey(targetKeys[i])) continue;
        $caa70d287a6ddb62$var$applyState(target[targetKeys[i]], previous, targetKeys[i], merge, key);
    }
    const previousKeys = Object.keys(previous);
    for(let i = 0, len = previousKeys.length; i < len; i++)if (target[previousKeys[i]] === undefined) $caa70d287a6ddb62$var$setProperty(previous, previousKeys[i], undefined);
}
function $caa70d287a6ddb62$export$38319cad1f6d89e0(value, options = {}) {
    const { merge: merge, key: key = "id" } = options, v = $caa70d287a6ddb62$export$debb760848ca95a(value);
    return (state)=>{
        if (!$caa70d287a6ddb62$var$isWrappable(state) || !$caa70d287a6ddb62$var$isWrappable(v)) return v;
        const res = $caa70d287a6ddb62$var$applyState(v, {
            [$caa70d287a6ddb62$var$$ROOT]: state
        }, $caa70d287a6ddb62$var$$ROOT, merge, key);
        return res === undefined ? state : res;
    };
}
const $caa70d287a6ddb62$var$producers = new WeakMap();
const $caa70d287a6ddb62$var$setterTraps = {
    get (target, property) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7) return target;
        const value = target[property];
        if (property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d) || property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return value;
        let proxy;
        return $caa70d287a6ddb62$var$isWrappable(value) ? $caa70d287a6ddb62$var$producers.get(value) || ($caa70d287a6ddb62$var$producers.set(value, proxy = new Proxy(value, $caa70d287a6ddb62$var$setterTraps)), proxy) : value;
    },
    set (target, property, value) {
        $caa70d287a6ddb62$var$setProperty(target, property, $caa70d287a6ddb62$export$debb760848ca95a(value));
        return true;
    },
    deleteProperty (target, property) {
        $caa70d287a6ddb62$var$setProperty(target, property, undefined, true);
        return true;
    }
};
function $caa70d287a6ddb62$export$b46cabe22e78bc00(fn) {
    return (state)=>{
        if ($caa70d287a6ddb62$var$isWrappable(state)) {
            let proxy;
            if (!(proxy = $caa70d287a6ddb62$var$producers.get(state))) $caa70d287a6ddb62$var$producers.set(state, proxy = new Proxy(state, $caa70d287a6ddb62$var$setterTraps));
            fn(proxy);
        }
        return state;
    };
}
const $caa70d287a6ddb62$export$404582bc18fe4d9e = undefined;


function $68cd7f618e77dd88$export$6fd28b3773c73787() {
    let listeners = new Set();
    function subscribe(listener) {
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }
    let ignore = false;
    function confirm(to, options) {
        if (ignore) return ignore = false, true;
        const e = {
            to: to,
            options: options,
            defaultPrevented: false,
            preventDefault: ()=>e.defaultPrevented = true
        };
        for (const l of listeners)l.listener({
            ...e,
            from: l.location,
            retry: (force)=>{
                force && (ignore = true);
                l.navigate(to, {
                    ...options,
                    resolve: false
                });
            }
        });
        return !e.defaultPrevented;
    }
    return {
        subscribe: subscribe,
        confirm: confirm
    };
}
// The following supports browser initiated blocking (eg back/forward)
let $68cd7f618e77dd88$var$depth;
function $68cd7f618e77dd88$export$1e81c4bafc9fc5b3() {
    if (!window.history.state || window.history.state._depth == null) window.history.replaceState({
        ...window.history.state,
        _depth: window.history.length - 1
    }, "");
    $68cd7f618e77dd88$var$depth = window.history.state._depth;
}
if (!(0, $6258376c5c54faa9$export$6acf61af03e62db)) $68cd7f618e77dd88$export$1e81c4bafc9fc5b3();
function $68cd7f618e77dd88$export$392f332fe0cbca16(state) {
    return {
        ...state,
        _depth: window.history.state && window.history.state._depth
    };
}
function $68cd7f618e77dd88$export$75d38aa30ad5e3c8(notify, block) {
    let ignore = false;
    return ()=>{
        const prevDepth = $68cd7f618e77dd88$var$depth;
        $68cd7f618e77dd88$export$1e81c4bafc9fc5b3();
        const delta = prevDepth == null ? null : $68cd7f618e77dd88$var$depth - prevDepth;
        if (ignore) {
            ignore = false;
            return;
        }
        if (delta && block(delta)) {
            ignore = true;
            window.history.go(-delta);
        } else notify();
    };
}
const $68cd7f618e77dd88$var$hasSchemeRegex = /^(?:[a-z0-9]+:)?\/\//i;
const $68cd7f618e77dd88$var$trimPathRegex = /^\/+|(\/)\/+$/g;
const $68cd7f618e77dd88$var$mockBase = "http://sr";
function $68cd7f618e77dd88$var$normalizePath(path, omitSlash = false) {
    const s = path.replace($68cd7f618e77dd88$var$trimPathRegex, "$1");
    return s ? omitSlash || /^[?#]/.test(s) ? s : "/" + s : "";
}
function $68cd7f618e77dd88$var$resolvePath(base, path, from) {
    if ($68cd7f618e77dd88$var$hasSchemeRegex.test(path)) return undefined;
    const basePath = $68cd7f618e77dd88$var$normalizePath(base);
    const fromPath = from && $68cd7f618e77dd88$var$normalizePath(from);
    let result = "";
    if (!fromPath || path.startsWith("/")) result = basePath;
    else if (fromPath.toLowerCase().indexOf(basePath.toLowerCase()) !== 0) result = basePath + fromPath;
    else result = fromPath;
    return (result || "/") + $68cd7f618e77dd88$var$normalizePath(path, !result);
}
function $68cd7f618e77dd88$var$invariant(value, message) {
    if (value == null) throw new Error(message);
    return value;
}
function $68cd7f618e77dd88$var$joinPaths(from, to) {
    return $68cd7f618e77dd88$var$normalizePath(from).replace(/\/*(\*.*)?$/g, "") + $68cd7f618e77dd88$var$normalizePath(to);
}
function $68cd7f618e77dd88$var$extractSearchParams(url) {
    const params = {};
    url.searchParams.forEach((value, key)=>{
        if (key in params) {
            if (Array.isArray(params[key])) params[key].push(value);
            else params[key] = [
                params[key],
                value
            ];
        } else params[key] = value;
    });
    return params;
}
function $68cd7f618e77dd88$var$createMatcher(path, partial, matchFilters) {
    const [pattern, splat] = path.split("/*", 2);
    const segments = pattern.split("/").filter(Boolean);
    const len = segments.length;
    return (location)=>{
        const locSegments = location.split("/").filter(Boolean);
        const lenDiff = locSegments.length - len;
        if (lenDiff < 0 || lenDiff > 0 && splat === undefined && !partial) return null;
        const match = {
            path: len ? "" : "/",
            params: {}
        };
        const matchFilter = (s)=>matchFilters === undefined ? undefined : matchFilters[s];
        for(let i = 0; i < len; i++){
            const segment = segments[i];
            const dynamic = segment[0] === ":";
            const locSegment = dynamic ? locSegments[i] : locSegments[i].toLowerCase();
            const key = dynamic ? segment.slice(1) : segment.toLowerCase();
            if (dynamic && $68cd7f618e77dd88$var$matchSegment(locSegment, matchFilter(key))) match.params[key] = locSegment;
            else if (dynamic || !$68cd7f618e77dd88$var$matchSegment(locSegment, key)) return null;
            match.path += `/${locSegment}`;
        }
        if (splat) {
            const remainder = lenDiff ? locSegments.slice(-lenDiff).join("/") : "";
            if ($68cd7f618e77dd88$var$matchSegment(remainder, matchFilter(splat))) match.params[splat] = remainder;
            else return null;
        }
        return match;
    };
}
function $68cd7f618e77dd88$var$matchSegment(input, filter) {
    const isEqual = (s)=>s === input;
    if (filter === undefined) return true;
    else if (typeof filter === "string") return isEqual(filter);
    else if (typeof filter === "function") return filter(input);
    else if (Array.isArray(filter)) return filter.some(isEqual);
    else if (filter instanceof RegExp) return filter.test(input);
    return false;
}
function $68cd7f618e77dd88$var$scoreRoute(route) {
    const [pattern, splat] = route.pattern.split("/*", 2);
    const segments = pattern.split("/").filter(Boolean);
    return segments.reduce((score, segment)=>score + (segment.startsWith(":") ? 2 : 3), segments.length - (splat === undefined ? 0 : 1));
}
function $68cd7f618e77dd88$var$createMemoObject(fn) {
    const map = new Map();
    const owner = (0, $8863cd8fe199f948$export$5f4ed0d56c2c0edf)();
    return new Proxy({}, {
        get (_, property) {
            if (!map.has(property)) (0, $8863cd8fe199f948$export$c14f3e3abbc7d6b5)(owner, ()=>map.set(property, (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>fn()[property])));
            return map.get(property)();
        },
        getOwnPropertyDescriptor () {
            return {
                enumerable: true,
                configurable: true
            };
        },
        ownKeys () {
            return Reflect.ownKeys(fn());
        },
        has (_, property) {
            return property in fn();
        }
    });
}
function $68cd7f618e77dd88$export$a0789f322479da52(search, params) {
    const merged = new URLSearchParams(search);
    Object.entries(params).forEach(([key, value])=>{
        if (value == null || value === "" || value instanceof Array && !value.length) merged.delete(key);
        else if (value instanceof Array) {
            // Delete all instances of the key before appending
            merged.delete(key);
            value.forEach((v)=>{
                merged.append(key, String(v));
            });
        } else merged.set(key, String(value));
    });
    const s = merged.toString();
    return s ? `?${s}` : "";
}
function $68cd7f618e77dd88$var$expandOptionals(pattern) {
    let match = /(\/?\:[^\/]+)\?/.exec(pattern);
    if (!match) return [
        pattern
    ];
    let prefix = pattern.slice(0, match.index);
    let suffix = pattern.slice(match.index + match[0].length);
    const prefixes = [
        prefix,
        prefix += match[1]
    ];
    // This section handles adjacent optional params. We don't actually want all permuations since
    // that will lead to equivalent routes which have the same number of params. For example
    // `/:a?/:b?/:c`? only has the unique expansion: `/`, `/:a`, `/:a/:b`, `/:a/:b/:c` and we can
    // discard `/:b`, `/:c`, `/:b/:c` by building them up in order and not recursing. This also helps
    // ensure predictability where earlier params have precidence.
    while(match = /^(\/\:[^\/]+)\?/.exec(suffix)){
        prefixes.push(prefix += match[1]);
        suffix = suffix.slice(match[0].length);
    }
    return $68cd7f618e77dd88$var$expandOptionals(suffix).reduce((results, expansion)=>[
            ...results,
            ...prefixes.map((p)=>p + expansion)
        ], []);
}
const $68cd7f618e77dd88$var$MAX_REDIRECTS = 100;
const $68cd7f618e77dd88$var$RouterContextObj = (0, $8863cd8fe199f948$export$fd42f52fd3ae1109)();
const $68cd7f618e77dd88$var$RouteContextObj = (0, $8863cd8fe199f948$export$fd42f52fd3ae1109)();
const $68cd7f618e77dd88$var$useRouter = ()=>$68cd7f618e77dd88$var$invariant((0, $8863cd8fe199f948$export$fae74005e78b1a27)($68cd7f618e77dd88$var$RouterContextObj), "<A> and 'use' router primitives can be only used inside a Route.");
const $68cd7f618e77dd88$var$useRoute = ()=>(0, $8863cd8fe199f948$export$fae74005e78b1a27)($68cd7f618e77dd88$var$RouteContextObj) || $68cd7f618e77dd88$var$useRouter().base;
const $68cd7f618e77dd88$export$e75d2a2d1b3c245b = (path)=>{
    const route = $68cd7f618e77dd88$var$useRoute();
    return (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>route.resolvePath(path()));
};
const $68cd7f618e77dd88$export$b66bb29c5006f12f = (to)=>{
    const router = $68cd7f618e77dd88$var$useRouter();
    return (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const to_ = to();
        return to_ !== undefined ? router.renderPath(to_) : to_;
    });
};
/**
 * Retrieves method to do navigation. The method accepts a path to navigate to and an optional object with the following options:
 * 
 * - resolve (*boolean*, default `true`): resolve the path against the current route
 * - replace (*boolean*, default `false`): replace the history entry
 * - scroll (*boolean*, default `true`): scroll to top after navigation
 * - state (*any*, default `undefined`): pass custom state to `location.state`
 * 
 * **Note**: The state is serialized using the structured clone algorithm which does not support all object types.
 * 
 * @example
 * ```js
 * const navigate = useNavigate();
 * 
 * if (unauthorized) {
 *   navigate("/login", { replace: true });
 * }
 * ```
 */ const $68cd7f618e77dd88$export$9770f232ac06a008 = ()=>$68cd7f618e77dd88$var$useRouter().navigatorFactory();
/**
 * Retrieves reactive `location` object useful for getting things like `pathname`.
 * 
 * @example
 * ```js
 * const location = useLocation();
 * 
 * const pathname = createMemo(() => parsePath(location.pathname));
 * ```
 */ const $68cd7f618e77dd88$export$45d76561a5302f2b = ()=>$68cd7f618e77dd88$var$useRouter().location;
/**
 * Retrieves signal that indicates whether the route is currently in a *Transition*.
 * Useful for showing stale/pending state when the route resolution is *Suspended* during concurrent rendering.
 * 
 * @example
 * ```js
 * const isRouting = useIsRouting();
 * 
 * return (
 *   <div classList={{ "grey-out": isRouting() }}>
 *     <MyAwesomeContent />
 *   </div>
 * );
 * ```
 */ const $68cd7f618e77dd88$export$f2eec64eca530862 = ()=>$68cd7f618e77dd88$var$useRouter().isRouting;
/**
 * usePreloadRoute returns a function that can be used to preload a route manual.
 * This is what happens automatically with link hovering and similar focus based behavior, but it is available here as an API.
 * 
 * @example
 * ```js
 * const preload = usePreloadRoute();
 * 
 * preload(`/users/settings`, { preloadData: true });
 * ```
 */ const $68cd7f618e77dd88$export$c4521eca3d536357 = ()=>{
    const pre = $68cd7f618e77dd88$var$useRouter().preloadRoute;
    return (url, options = {})=>pre(url instanceof URL ? url : new URL(url, $68cd7f618e77dd88$var$mockBase), options.preloadData);
};
/**
 * `useMatch` takes an accessor that returns the path and creates a `Memo` that returns match information if the current path matches the provided path.
 * Useful for determining if a given path matches the current route.
 * 
 * @example
 * ```js
 * const match = useMatch(() => props.href);
 * 
 * return <div classList={{ active: Boolean(match()) }} />;
 * ```
 */ const $68cd7f618e77dd88$export$6c330e8992e8a295 = (path, matchFilters)=>{
    const location = $68cd7f618e77dd88$export$45d76561a5302f2b();
    const matchers = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>$68cd7f618e77dd88$var$expandOptionals(path()).map((path)=>$68cd7f618e77dd88$var$createMatcher(path, undefined, matchFilters)));
    return (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        for (const matcher of matchers()){
            const match = matcher(location.pathname);
            if (match) return match;
        }
    });
};
/**
 * `useCurrentMatches` returns all the matches for the current matched route.
 * Useful for getting all the route information.
 * 
 * @example
 * ```js
 * const matches = useCurrentMatches();
 * 
 * const breadcrumbs = createMemo(() => matches().map(m => m.route.info.breadcrumb))
 * ```
 */ const $68cd7f618e77dd88$export$fead1b47e398a5ec = ()=>$68cd7f618e77dd88$var$useRouter().matches;
/**
 * Retrieves a reactive, store-like object containing the current route path parameters as defined in the Route.
 * 
 * @example
 * ```js
 * const params = useParams();
 * 
 * // fetch user based on the id path parameter
 * const [user] = createResource(() => params.id, fetchUser);
 * ```
 */ const $68cd7f618e77dd88$export$99eaa27ddbbb95ef = ()=>$68cd7f618e77dd88$var$useRouter().params;
/**
 * Retrieves a tuple containing a reactive object to read the current location's query parameters and a method to update them.
 * The object is a proxy so you must access properties to subscribe to reactive updates.
 * **Note** that values will be strings and property names will retain their casing.
 * 
 * The setter method accepts an object whose entries will be merged into the current query string.
 * Values `''`, `undefined` and `null` will remove the key from the resulting query string.
 * Updates will behave just like a navigation and the setter accepts the same optional second parameter as `navigate` and auto-scrolling is disabled by default.
 * 
 * @examples
 * ```js
 * const [searchParams, setSearchParams] = useSearchParams();
 * 
 * return (
 *   <div>
 *     <span>Page: {searchParams.page}</span>
 *     <button
 *       onClick={() =>
 *         setSearchParams({ page: (parseInt(searchParams.page) || 0) + 1 })
 *       }
 *     >
 *       Next Page
 *     </button>
 *   </div>
 * );
 * ```
 */ const $68cd7f618e77dd88$export$f1a78c17382fe22a = ()=>{
    const location = $68cd7f618e77dd88$export$45d76561a5302f2b();
    const navigate = $68cd7f618e77dd88$export$9770f232ac06a008();
    const setSearchParams = (params, options)=>{
        const searchString = (0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>$68cd7f618e77dd88$export$a0789f322479da52(location.search, params) + location.hash);
        navigate(searchString, {
            scroll: false,
            resolve: false,
            ...options
        });
    };
    return [
        location.query,
        setSearchParams
    ];
};
/**
 * useBeforeLeave takes a function that will be called prior to leaving a route.
 * The function will be called with:
 * 
 * - from (*Location*): current location (before change).
 * - to (*string | number*): path passed to `navigate`.
 * - options (*NavigateOptions*): options passed to navigate.
 * - preventDefault (*function*): call to block the route change.
 * - defaultPrevented (*readonly boolean*): `true` if any previously called leave handlers called `preventDefault`.
 * - retry (*function*, force?: boolean ): call to retry the same navigation, perhaps after confirming with the user. Pass `true` to skip running the leave handlers again (i.e. force navigate without confirming).
 * 
 * @example
 * ```js
 * useBeforeLeave((e: BeforeLeaveEventArgs) => {
 *   if (form.isDirty && !e.defaultPrevented) {
 *     // preventDefault to block immediately and prompt user async
 *     e.preventDefault();
 *     setTimeout(() => {
 *       if (window.confirm("Discard unsaved changes - are you sure?")) {
 *         // user wants to proceed anyway so retry with force=true
 *         e.retry(true);
 *       }
 *     }, 100);
 *   }
 * });
 * ```
 */ const $68cd7f618e77dd88$export$f6b873dd5b622e4b = (listener)=>{
    const s = $68cd7f618e77dd88$var$useRouter().beforeLeave.subscribe({
        listener: listener,
        location: $68cd7f618e77dd88$export$45d76561a5302f2b(),
        navigate: $68cd7f618e77dd88$export$9770f232ac06a008()
    });
    (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(s);
};
function $68cd7f618e77dd88$var$createRoutes(routeDef, base = "") {
    const { component: component, preload: preload, load: load, children: children, info: info } = routeDef;
    const isLeaf = !children || Array.isArray(children) && !children.length;
    const shared = {
        key: routeDef,
        component: component,
        preload: preload || load,
        info: info
    };
    return $68cd7f618e77dd88$var$asArray(routeDef.path).reduce((acc, originalPath)=>{
        for (const expandedPath of $68cd7f618e77dd88$var$expandOptionals(originalPath)){
            const path = $68cd7f618e77dd88$var$joinPaths(base, expandedPath);
            let pattern = isLeaf ? path : path.split("/*", 1)[0];
            pattern = pattern.split("/").map((s)=>{
                return s.startsWith(":") || s.startsWith("*") ? s : encodeURIComponent(s);
            }).join("/");
            acc.push({
                ...shared,
                originalPath: originalPath,
                pattern: pattern,
                matcher: $68cd7f618e77dd88$var$createMatcher(pattern, !isLeaf, routeDef.matchFilters)
            });
        }
        return acc;
    }, []);
}
function $68cd7f618e77dd88$var$createBranch(routes, index = 0) {
    return {
        routes: routes,
        score: $68cd7f618e77dd88$var$scoreRoute(routes[routes.length - 1]) * 10000 - index,
        matcher (location) {
            const matches = [];
            for(let i = routes.length - 1; i >= 0; i--){
                const route = routes[i];
                const match = route.matcher(location);
                if (!match) return null;
                matches.unshift({
                    ...match,
                    route: route
                });
            }
            return matches;
        }
    };
}
function $68cd7f618e77dd88$var$asArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $68cd7f618e77dd88$var$createBranches(routeDef, base = "", stack = [], branches = []) {
    const routeDefs = $68cd7f618e77dd88$var$asArray(routeDef);
    for(let i = 0, len = routeDefs.length; i < len; i++){
        const def = routeDefs[i];
        if (def && typeof def === "object") {
            if (!def.hasOwnProperty("path")) def.path = "";
            const routes = $68cd7f618e77dd88$var$createRoutes(def, base);
            for (const route of routes){
                stack.push(route);
                const isEmptyArray = Array.isArray(def.children) && def.children.length === 0;
                if (def.children && !isEmptyArray) $68cd7f618e77dd88$var$createBranches(def.children, route.pattern, stack, branches);
                else {
                    const branch = $68cd7f618e77dd88$var$createBranch([
                        ...stack
                    ], branches.length);
                    branches.push(branch);
                }
                stack.pop();
            }
        }
    }
    // Stack will be empty on final return
    return stack.length ? branches : branches.sort((a, b)=>b.score - a.score);
}
function $68cd7f618e77dd88$var$getRouteMatches(branches, location) {
    for(let i = 0, len = branches.length; i < len; i++){
        const match = branches[i].matcher(location);
        if (match) return match;
    }
    return [];
}
function $68cd7f618e77dd88$var$createLocation(path, state, queryWrapper) {
    const origin = new URL($68cd7f618e77dd88$var$mockBase);
    const url = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)((prev)=>{
        const path_ = path();
        try {
            return new URL(path_, origin);
        } catch (err) {
            console.error(`Invalid path ${path_}`);
            return prev;
        }
    }, origin, {
        equals: (a, b)=>a.href === b.href
    });
    const pathname = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>url().pathname);
    const search = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>url().search, true);
    const hash = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>url().hash);
    const key = ()=>"";
    const queryFn = (0, $8863cd8fe199f948$export$af631764ddc44097)(search, ()=>$68cd7f618e77dd88$var$extractSearchParams(url()));
    return {
        get pathname () {
            return pathname();
        },
        get search () {
            return search();
        },
        get hash () {
            return hash();
        },
        get state () {
            return state();
        },
        get key () {
            return key();
        },
        query: queryWrapper ? queryWrapper(queryFn) : $68cd7f618e77dd88$var$createMemoObject(queryFn)
    };
}
let $68cd7f618e77dd88$var$intent;
function $68cd7f618e77dd88$var$getIntent() {
    return $68cd7f618e77dd88$var$intent;
}
let $68cd7f618e77dd88$var$inPreloadFn = false;
function $68cd7f618e77dd88$var$getInPreloadFn() {
    return $68cd7f618e77dd88$var$inPreloadFn;
}
function $68cd7f618e77dd88$var$setInPreloadFn(value) {
    $68cd7f618e77dd88$var$inPreloadFn = value;
}
function $68cd7f618e77dd88$var$createRouterContext(integration, branches, getContext, options = {}) {
    const { signal: [source, setSource], utils: utils = {} } = integration;
    const parsePath = utils.parsePath || ((p)=>p);
    const renderPath = utils.renderPath || ((p)=>p);
    const beforeLeave = utils.beforeLeave || $68cd7f618e77dd88$export$6fd28b3773c73787();
    const basePath = $68cd7f618e77dd88$var$resolvePath("", options.base || "");
    if (basePath === undefined) throw new Error(`${basePath} is not a valid base path`);
    else if (basePath && !source().value) setSource({
        value: basePath,
        replace: true,
        scroll: false
    });
    const [isRouting, setIsRouting] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    // Keep track of last target, so that last call to transition wins
    let lastTransitionTarget;
    // Transition the location to a new value
    const transition = (newIntent, newTarget)=>{
        if (newTarget.value === reference() && newTarget.state === state()) return;
        if (lastTransitionTarget === undefined) setIsRouting(true);
        $68cd7f618e77dd88$var$intent = newIntent;
        lastTransitionTarget = newTarget;
        (0, $8863cd8fe199f948$export$7568632d0d33d16d)(()=>{
            if (lastTransitionTarget !== newTarget) return;
            setReference(lastTransitionTarget.value);
            setState(lastTransitionTarget.state);
            (0, $8863cd8fe199f948$export$4eaee74ee7a14dca)();
            if (!(0, $6258376c5c54faa9$export$6acf61af03e62db)) submissions[1]((subs)=>subs.filter((s)=>s.pending));
        }).finally(()=>{
            if (lastTransitionTarget !== newTarget) return;
            // Batch, in order for isRouting and final source update to happen together
            (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>{
                $68cd7f618e77dd88$var$intent = undefined;
                if (newIntent === "navigate") navigateEnd(lastTransitionTarget);
                setIsRouting(false);
                lastTransitionTarget = undefined;
            });
        });
    };
    const [reference, setReference] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(source().value);
    const [state, setState] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(source().state);
    const location = $68cd7f618e77dd88$var$createLocation(reference, state, utils.queryWrapper);
    const referrers = [];
    const submissions = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)((0, $6258376c5c54faa9$export$6acf61af03e62db) ? initFromFlash() : []);
    const matches = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        if (typeof options.transformUrl === "function") return $68cd7f618e77dd88$var$getRouteMatches(branches(), options.transformUrl(location.pathname));
        return $68cd7f618e77dd88$var$getRouteMatches(branches(), location.pathname);
    });
    const buildParams = ()=>{
        const m = matches();
        const params = {};
        for(let i = 0; i < m.length; i++)Object.assign(params, m[i].params);
        return params;
    };
    const params = utils.paramsWrapper ? utils.paramsWrapper(buildParams, branches) : $68cd7f618e77dd88$var$createMemoObject(buildParams);
    const baseRoute = {
        pattern: basePath,
        path: ()=>basePath,
        outlet: ()=>null,
        resolvePath (to) {
            return $68cd7f618e77dd88$var$resolvePath(basePath, to);
        }
    };
    // Create a native transition, when source updates
    (0, $8863cd8fe199f948$export$314dade334ae905d)((0, $8863cd8fe199f948$export$af631764ddc44097)(source, (source)=>transition("native", source), {
        defer: true
    }));
    return {
        base: baseRoute,
        location: location,
        params: params,
        isRouting: isRouting,
        renderPath: renderPath,
        parsePath: parsePath,
        navigatorFactory: navigatorFactory,
        matches: matches,
        beforeLeave: beforeLeave,
        preloadRoute: preloadRoute,
        singleFlight: options.singleFlight === undefined ? true : options.singleFlight,
        submissions: submissions
    };
    function navigateFromRoute(route, to, options) {
        // Untrack in case someone navigates in an effect - don't want to track `reference` or route paths
        (0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>{
            if (typeof to === "number") {
                if (!to) ;
                else if (utils.go) utils.go(to);
                else console.warn("Router integration does not support relative routing");
                return;
            }
            const queryOnly = !to || to[0] === "?";
            const { replace: replace, resolve: resolve, scroll: scroll, state: nextState } = {
                replace: false,
                resolve: !queryOnly,
                scroll: true,
                ...options
            };
            const resolvedTo = resolve ? route.resolvePath(to) : $68cd7f618e77dd88$var$resolvePath(queryOnly && location.pathname || "", to);
            if (resolvedTo === undefined) throw new Error(`Path '${to}' is not a routable path`);
            else if (referrers.length >= $68cd7f618e77dd88$var$MAX_REDIRECTS) throw new Error("Too many redirects");
            const current = reference();
            if (resolvedTo !== current || nextState !== state()) {
                if (0, $6258376c5c54faa9$export$6acf61af03e62db) {
                    const e = (0, $6258376c5c54faa9$export$c8eca95e306f7116)();
                    e && (e.response = {
                        status: 302,
                        headers: new Headers({
                            Location: resolvedTo
                        })
                    });
                    setSource({
                        value: resolvedTo,
                        replace: replace,
                        scroll: scroll,
                        state: nextState
                    });
                } else if (beforeLeave.confirm(resolvedTo, options)) {
                    referrers.push({
                        value: current,
                        replace: replace,
                        scroll: scroll,
                        state: state()
                    });
                    transition("navigate", {
                        value: resolvedTo,
                        state: nextState
                    });
                }
            }
        });
    }
    function navigatorFactory(route) {
        // Workaround for vite issue (https://github.com/vitejs/vite/issues/3803)
        route = route || (0, $8863cd8fe199f948$export$fae74005e78b1a27)($68cd7f618e77dd88$var$RouteContextObj) || baseRoute;
        return (to, options)=>navigateFromRoute(route, to, options);
    }
    function navigateEnd(next) {
        const first = referrers[0];
        if (first) {
            setSource({
                ...next,
                replace: first.replace,
                scroll: first.scroll
            });
            referrers.length = 0;
        }
    }
    function preloadRoute(url, preloadData) {
        const matches = $68cd7f618e77dd88$var$getRouteMatches(branches(), url.pathname);
        const prevIntent = $68cd7f618e77dd88$var$intent;
        $68cd7f618e77dd88$var$intent = "preload";
        for(let match in matches){
            const { route: route, params: params } = matches[match];
            route.component && route.component.preload && route.component.preload();
            const { preload: preload } = route;
            $68cd7f618e77dd88$var$inPreloadFn = true;
            preloadData && preload && (0, $8863cd8fe199f948$export$c14f3e3abbc7d6b5)(getContext(), ()=>preload({
                    params: params,
                    location: {
                        pathname: url.pathname,
                        search: url.search,
                        hash: url.hash,
                        query: $68cd7f618e77dd88$var$extractSearchParams(url),
                        state: null,
                        key: ""
                    },
                    intent: "preload"
                }));
            $68cd7f618e77dd88$var$inPreloadFn = false;
        }
        $68cd7f618e77dd88$var$intent = prevIntent;
    }
    function initFromFlash() {
        const e = (0, $6258376c5c54faa9$export$c8eca95e306f7116)();
        return e && e.router && e.router.submission ? [
            e.router.submission
        ] : [];
    }
}
function $68cd7f618e77dd88$var$createRouteContext(router, parent, outlet, match) {
    const { base: base, location: location, params: params } = router;
    const { pattern: pattern, component: component, preload: preload } = match().route;
    const path = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>match().path);
    component && component.preload && component.preload();
    $68cd7f618e77dd88$var$inPreloadFn = true;
    const data = preload ? preload({
        params: params,
        location: location,
        intent: $68cd7f618e77dd88$var$intent || "initial"
    }) : undefined;
    $68cd7f618e77dd88$var$inPreloadFn = false;
    const route = {
        parent: parent,
        pattern: pattern,
        path: path,
        outlet: ()=>component ? (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)(component, {
                params: params,
                location: location,
                data: data,
                get children () {
                    return outlet();
                }
            }) : outlet(),
        resolvePath (to) {
            return $68cd7f618e77dd88$var$resolvePath(base.path(), to, path());
        }
    };
    return route;
}
const $68cd7f618e77dd88$var$createRouterComponent = (router)=>(props)=>{
        const { base: base } = props;
        const routeDefs = (0, $8863cd8fe199f948$export$bacb5cc5a11aef16)(()=>props.children);
        const branches = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>$68cd7f618e77dd88$var$createBranches(routeDefs(), props.base || ""));
        let context;
        const routerState = $68cd7f618e77dd88$var$createRouterContext(router, branches, ()=>context, {
            base: base,
            singleFlight: props.singleFlight,
            transformUrl: props.transformUrl
        });
        router.create && router.create(routerState);
        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($68cd7f618e77dd88$var$RouterContextObj.Provider, {
            value: routerState,
            get children () {
                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($68cd7f618e77dd88$var$Root, {
                    routerState: routerState,
                    get root () {
                        return props.root;
                    },
                    get preload () {
                        return props.rootPreload || props.rootLoad;
                    },
                    get children () {
                        return [
                            (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>(context = (0, $8863cd8fe199f948$export$5f4ed0d56c2c0edf)()) && null),
                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($68cd7f618e77dd88$var$Routes, {
                                routerState: routerState,
                                get branches () {
                                    return branches();
                                }
                            })
                        ];
                    }
                });
            }
        });
    };
function $68cd7f618e77dd88$var$Root(props) {
    const location = props.routerState.location;
    const params = props.routerState.params;
    const data = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>props.preload && (0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>{
            $68cd7f618e77dd88$var$setInPreloadFn(true);
            props.preload({
                params: params,
                location: location,
                intent: $68cd7f618e77dd88$var$getIntent() || "initial"
            });
            $68cd7f618e77dd88$var$setInPreloadFn(false);
        }));
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
        get when () {
            return props.root;
        },
        keyed: true,
        get fallback () {
            return props.children;
        },
        children: (Root)=>(0, $8863cd8fe199f948$export$60e54eaca7e7fb38)(Root, {
                params: params,
                location: location,
                get data () {
                    return data();
                },
                get children () {
                    return props.children;
                }
            })
    });
}
function $68cd7f618e77dd88$var$Routes(props) {
    if (0, $6258376c5c54faa9$export$6acf61af03e62db) {
        const e = (0, $6258376c5c54faa9$export$c8eca95e306f7116)();
        if (e && e.router && e.router.dataOnly) {
            $68cd7f618e77dd88$var$dataOnly(e, props.routerState, props.branches);
            return;
        }
        e && ((e.router || (e.router = {})).matches || (e.router.matches = props.routerState.matches().map(({ route: route, path: path, params: params })=>({
                path: route.originalPath,
                pattern: route.pattern,
                match: path,
                params: params,
                info: route.info
            }))));
    }
    const disposers = [];
    let root;
    const routeStates = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)((0, $8863cd8fe199f948$export$af631764ddc44097)(props.routerState.matches, (nextMatches, prevMatches, prev)=>{
        let equal = prevMatches && nextMatches.length === prevMatches.length;
        const next = [];
        for(let i = 0, len = nextMatches.length; i < len; i++){
            const prevMatch = prevMatches && prevMatches[i];
            const nextMatch = nextMatches[i];
            if (prev && prevMatch && nextMatch.route.key === prevMatch.route.key) next[i] = prev[i];
            else {
                equal = false;
                if (disposers[i]) disposers[i]();
                (0, $8863cd8fe199f948$export$882461b6382ed46c)((dispose)=>{
                    disposers[i] = dispose;
                    next[i] = $68cd7f618e77dd88$var$createRouteContext(props.routerState, next[i - 1] || props.routerState.base, $68cd7f618e77dd88$var$createOutlet(()=>routeStates()[i + 1]), ()=>{
                        const routeMatches = props.routerState.matches();
                        return routeMatches[i] ?? routeMatches[0];
                    });
                });
            }
        }
        disposers.splice(nextMatches.length).forEach((dispose)=>dispose());
        if (prev && equal) return prev;
        root = next[0];
        return next;
    }));
    return $68cd7f618e77dd88$var$createOutlet(()=>routeStates() && root)();
}
const $68cd7f618e77dd88$var$createOutlet = (child)=>{
    return ()=>(0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return child();
            },
            keyed: true,
            children: (child)=>(0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($68cd7f618e77dd88$var$RouteContextObj.Provider, {
                    value: child,
                    get children () {
                        return child.outlet();
                    }
                })
        });
};
const $68cd7f618e77dd88$export$e7b0ac011bb776c6 = (props)=>{
    const childRoutes = (0, $8863cd8fe199f948$export$bacb5cc5a11aef16)(()=>props.children);
    return (0, $8863cd8fe199f948$export$9d1611c77c2fe928)(props, {
        get children () {
            return childRoutes();
        }
    });
};
// for data only mode with single flight mutations
function $68cd7f618e77dd88$var$dataOnly(event, routerState, branches) {
    const url = new URL(event.request.url);
    const prevMatches = $68cd7f618e77dd88$var$getRouteMatches(branches, new URL(event.router.previousUrl || event.request.url).pathname);
    const matches = $68cd7f618e77dd88$var$getRouteMatches(branches, url.pathname);
    for(let match = 0; match < matches.length; match++){
        if (!prevMatches[match] || matches[match].route !== prevMatches[match].route) event.router.dataOnly = true;
        const { route: route, params: params } = matches[match];
        route.preload && route.preload({
            params: params,
            location: routerState.location,
            intent: "preload"
        });
    }
}
function $68cd7f618e77dd88$var$intercept([value, setValue], get, set) {
    return [
        value,
        set ? (v)=>setValue(set(v)) : setValue
    ];
}
function $68cd7f618e77dd88$export$baddd0131ee8c05b(config) {
    let ignore = false;
    const wrap = (value)=>typeof value === "string" ? {
            value: value
        } : value;
    const signal = $68cd7f618e77dd88$var$intercept((0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(wrap(config.get()), {
        equals: (a, b)=>a.value === b.value && a.state === b.state
    }), undefined, (next)=>{
        !ignore && config.set(next);
        if ((0, $8863cd8fe199f948$export$2cb4986bed338027).registry && !(0, $8863cd8fe199f948$export$2cb4986bed338027).done) (0, $8863cd8fe199f948$export$2cb4986bed338027).done = true;
        return next;
    });
    config.init && (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(config.init((value = config.get())=>{
        ignore = true;
        signal[1](wrap(value));
        ignore = false;
    }));
    return $68cd7f618e77dd88$var$createRouterComponent({
        signal: signal,
        create: config.create,
        utils: config.utils
    });
}
function $68cd7f618e77dd88$var$bindEvent(target, type, handler) {
    target.addEventListener(type, handler);
    return ()=>target.removeEventListener(type, handler);
}
function $68cd7f618e77dd88$var$scrollToHash(hash, fallbackTop) {
    const el = hash && document.getElementById(hash);
    if (el) el.scrollIntoView();
    else if (fallbackTop) window.scrollTo(0, 0);
}
function $68cd7f618e77dd88$var$getPath(url) {
    const u = new URL(url);
    return u.pathname + u.search;
}
function $68cd7f618e77dd88$export$cac06da4d76d935b(props) {
    let e;
    const obj = {
        value: props.url || (e = (0, $6258376c5c54faa9$export$c8eca95e306f7116)()) && $68cd7f618e77dd88$var$getPath(e.request.url) || ""
    };
    return $68cd7f618e77dd88$var$createRouterComponent({
        signal: [
            ()=>obj,
            (next)=>Object.assign(obj, next)
        ]
    })(props);
}
const $68cd7f618e77dd88$var$LocationHeader = "Location";
const $68cd7f618e77dd88$var$PRELOAD_TIMEOUT = 5000;
const $68cd7f618e77dd88$var$CACHE_TIMEOUT = 180000;
let $68cd7f618e77dd88$var$cacheMap = new Map();
// cleanup forward/back cache
if (!(0, $6258376c5c54faa9$export$6acf61af03e62db)) setInterval(()=>{
    const now = Date.now();
    for (let [k, v] of $68cd7f618e77dd88$var$cacheMap.entries())if (!v[4].count && now - v[0] > $68cd7f618e77dd88$var$CACHE_TIMEOUT) $68cd7f618e77dd88$var$cacheMap.delete(k);
}, 300000);
function $68cd7f618e77dd88$var$getCache() {
    if (!(0, $6258376c5c54faa9$export$6acf61af03e62db)) return $68cd7f618e77dd88$var$cacheMap;
    const req = (0, $6258376c5c54faa9$export$c8eca95e306f7116)();
    if (!req) throw new Error("Cannot find cache context");
    return (req.router || (req.router = {})).cache || (req.router.cache = new Map());
}
/**
 * Revalidates the given cache entry/entries.
 */ function $68cd7f618e77dd88$export$b409ca198cd12e26(key, force = true) {
    return (0, $8863cd8fe199f948$export$7568632d0d33d16d)(()=>{
        const now = Date.now();
        $68cd7f618e77dd88$var$cacheKeyOp(key, (entry)=>{
            force && (entry[0] = 0); //force cache miss
            entry[4][1](now); // retrigger live signals
        });
    });
}
function $68cd7f618e77dd88$var$cacheKeyOp(key, fn) {
    key && !Array.isArray(key) && (key = [
        key
    ]);
    for (let k of $68cd7f618e77dd88$var$cacheMap.keys())if (key === undefined || $68cd7f618e77dd88$var$matchKey(k, key)) fn($68cd7f618e77dd88$var$cacheMap.get(k));
}
function $68cd7f618e77dd88$export$2fa187e846a241c4(fn, name) {
    // prioritize GET for server functions
    if (fn.GET) fn = fn.GET;
    const cachedFn = (...args)=>{
        const cache = $68cd7f618e77dd88$var$getCache();
        const intent = $68cd7f618e77dd88$var$getIntent();
        const inPreloadFn = $68cd7f618e77dd88$var$getInPreloadFn();
        const owner = (0, $8863cd8fe199f948$export$5f4ed0d56c2c0edf)();
        const navigate = owner ? $68cd7f618e77dd88$export$9770f232ac06a008() : undefined;
        const now = Date.now();
        const key = name + $68cd7f618e77dd88$var$hashKey(args);
        let cached = cache.get(key);
        let tracking;
        if (0, $6258376c5c54faa9$export$6acf61af03e62db) {
            const e = (0, $6258376c5c54faa9$export$c8eca95e306f7116)();
            if (e) {
                const dataOnly = (e.router || (e.router = {})).dataOnly;
                if (dataOnly) {
                    const data = e && (e.router.data || (e.router.data = {}));
                    if (data && key in data) return data[key];
                    if (Array.isArray(dataOnly) && !$68cd7f618e77dd88$var$matchKey(key, dataOnly)) {
                        data[key] = undefined;
                        return Promise.resolve();
                    }
                }
            }
        }
        if ((0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && !(0, $6258376c5c54faa9$export$6acf61af03e62db)) {
            tracking = true;
            (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>cached[4].count--);
        }
        if (cached && cached[0] && ((0, $6258376c5c54faa9$export$6acf61af03e62db) || intent === "native" || cached[4].count || Date.now() - cached[0] < $68cd7f618e77dd88$var$PRELOAD_TIMEOUT)) {
            if (tracking) {
                cached[4].count++;
                cached[4][0](); // track
            }
            if (cached[3] === "preload" && intent !== "preload") cached[0] = now;
            let res = cached[1];
            if (intent !== "preload") {
                res = "then" in cached[1] ? cached[1].then(handleResponse(false), handleResponse(true)) : handleResponse(false)(cached[1]);
                !(0, $6258376c5c54faa9$export$6acf61af03e62db) && intent === "navigate" && (0, $8863cd8fe199f948$export$7568632d0d33d16d)(()=>cached[4][1](cached[0])); // update version
            }
            inPreloadFn && "then" in res && res.catch(()=>{});
            return res;
        }
        let res;
        if (!(0, $6258376c5c54faa9$export$6acf61af03e62db) && (0, $8863cd8fe199f948$export$2cb4986bed338027).has && (0, $8863cd8fe199f948$export$2cb4986bed338027).has(key)) {
            res = (0, $8863cd8fe199f948$export$2cb4986bed338027).load(key); // hydrating
            // @ts-ignore at least until we add a delete method to sharedConfig
            delete globalThis._$HY.r[key];
        } else res = fn(...args);
        if (cached) {
            cached[0] = now;
            cached[1] = res;
            cached[3] = intent;
            !(0, $6258376c5c54faa9$export$6acf61af03e62db) && intent === "navigate" && (0, $8863cd8fe199f948$export$7568632d0d33d16d)(()=>cached[4][1](cached[0])); // update version
        } else {
            cache.set(key, cached = [
                now,
                res,
                ,
                intent,
                (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(now)
            ]);
            cached[4].count = 0;
        }
        if (tracking) {
            cached[4].count++;
            cached[4][0](); // track
        }
        if (0, $6258376c5c54faa9$export$6acf61af03e62db) {
            const e = (0, $6258376c5c54faa9$export$c8eca95e306f7116)();
            if (e && e.router.dataOnly) return e.router.data[key] = res;
        }
        if (intent !== "preload") res = "then" in res ? res.then(handleResponse(false), handleResponse(true)) : handleResponse(false)(res);
        inPreloadFn && "then" in res && res.catch(()=>{});
        // serialize on server
        if ((0, $6258376c5c54faa9$export$6acf61af03e62db) && (0, $8863cd8fe199f948$export$2cb4986bed338027).context && (0, $8863cd8fe199f948$export$2cb4986bed338027).context.async && !(0, $8863cd8fe199f948$export$2cb4986bed338027).context.noHydrate) {
            const e = (0, $6258376c5c54faa9$export$c8eca95e306f7116)();
            (!e || !e.serverOnly) && (0, $8863cd8fe199f948$export$2cb4986bed338027).context.serialize(key, res);
        }
        return res;
        function handleResponse(error) {
            return async (v)=>{
                if (v instanceof Response) {
                    const e = (0, $6258376c5c54faa9$export$c8eca95e306f7116)();
                    if (e) {
                        for (const [key, value] of v.headers)if (key == "set-cookie") e.response.headers.append("set-cookie", value);
                        else e.response.headers.set(key, value);
                    }
                    const url = v.headers.get($68cd7f618e77dd88$var$LocationHeader);
                    if (url !== null) {
                        // client + server relative redirect
                        if (navigate && url.startsWith("/")) (0, $8863cd8fe199f948$export$7568632d0d33d16d)(()=>{
                            navigate(url, {
                                replace: true
                            });
                        });
                        else if (!(0, $6258376c5c54faa9$export$6acf61af03e62db)) window.location.href = url;
                        else if (e) e.response.status = 302;
                        return;
                    }
                    if (v.customBody) v = await v.customBody();
                }
                if (error) throw v;
                cached[2] = v;
                return v;
            };
        }
    };
    cachedFn.keyFor = (...args)=>name + $68cd7f618e77dd88$var$hashKey(args);
    cachedFn.key = name;
    return cachedFn;
}
$68cd7f618e77dd88$export$2fa187e846a241c4.get = (key)=>{
    const cached = $68cd7f618e77dd88$var$getCache().get(key);
    return cached[2];
};
$68cd7f618e77dd88$export$2fa187e846a241c4.set = (key, value)=>{
    const cache = $68cd7f618e77dd88$var$getCache();
    const now = Date.now();
    let cached = cache.get(key);
    if (cached) {
        cached[0] = now;
        cached[1] = Promise.resolve(value);
        cached[2] = value;
        cached[3] = "preload";
    } else {
        cache.set(key, cached = [
            now,
            Promise.resolve(value),
            value,
            "preload",
            (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(now)
        ]);
        cached[4].count = 0;
    }
};
$68cd7f618e77dd88$export$2fa187e846a241c4.delete = (key)=>$68cd7f618e77dd88$var$getCache().delete(key);
$68cd7f618e77dd88$export$2fa187e846a241c4.clear = ()=>$68cd7f618e77dd88$var$getCache().clear();
/** @deprecated use query instead */ const $68cd7f618e77dd88$export$69a3209f1a06c04d = $68cd7f618e77dd88$export$2fa187e846a241c4;
function $68cd7f618e77dd88$var$matchKey(key, keys) {
    for (let k of keys){
        if (k && key.startsWith(k)) return true;
    }
    return false;
}
// Modified from the amazing Tanstack Query library (MIT)
// https://github.com/TanStack/query/blob/main/packages/query-core/src/utils.ts#L168
function $68cd7f618e77dd88$var$hashKey(args) {
    return JSON.stringify(args, (_, val)=>$68cd7f618e77dd88$var$isPlainObject(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $68cd7f618e77dd88$var$isPlainObject(obj) {
    let proto;
    return obj != null && typeof obj === "object" && (!(proto = Object.getPrototypeOf(obj)) || proto === Object.prototype);
}
const $68cd7f618e77dd88$var$actions = /* #__PURE__ */ new Map();
function $68cd7f618e77dd88$export$4321edd2591ba5fc(fn, filter) {
    const router = $68cd7f618e77dd88$var$useRouter();
    const subs = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>router.submissions[0]().filter((s)=>s.url === fn.base && (!filter || filter(s.input))));
    return new Proxy([], {
        get (_, property) {
            if (property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d)) return subs();
            if (property === "pending") return subs().some((sub)=>!sub.result);
            return subs()[property];
        },
        has (_, property) {
            return property in subs();
        }
    });
}
function $68cd7f618e77dd88$export$6a9bc7ec8fddbf5(fn, filter) {
    const submissions = $68cd7f618e77dd88$export$4321edd2591ba5fc(fn, filter);
    return new Proxy({}, {
        get (_, property) {
            if (submissions.length === 0 && property === "clear" || property === "retry") return ()=>{};
            return submissions[submissions.length - 1]?.[property];
        }
    });
}
function $68cd7f618e77dd88$export$2c2d2f5bd2673(action) {
    const r = $68cd7f618e77dd88$var$useRouter();
    return (...args)=>action.apply({
            r: r
        }, args);
}
function $68cd7f618e77dd88$export$31eb53bd5b582a97(fn, options = {}) {
    function mutate(...variables) {
        const router = this.r;
        const form = this.f;
        const p = (router.singleFlight && fn.withOptions ? fn.withOptions({
            headers: {
                "X-Single-Flight": "true"
            }
        }) : fn)(...variables);
        const [result, setResult] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)();
        let submission;
        function handler(error) {
            return async (res)=>{
                const result = await $68cd7f618e77dd88$var$handleResponse(res, error, router.navigatorFactory());
                let retry = null;
                o.onComplete?.({
                    ...submission,
                    result: result?.data,
                    error: result?.error,
                    pending: false,
                    retry () {
                        return retry = submission.retry();
                    }
                });
                if (retry) return retry;
                if (!result) return submission.clear();
                setResult(result);
                if (result.error && !form) throw result.error;
                return result.data;
            };
        }
        router.submissions[1]((s)=>[
                ...s,
                submission = {
                    input: variables,
                    url: url,
                    get result () {
                        return result()?.data;
                    },
                    get error () {
                        return result()?.error;
                    },
                    get pending () {
                        return !result();
                    },
                    clear () {
                        router.submissions[1]((v)=>v.filter((i)=>i !== submission));
                    },
                    retry () {
                        setResult(undefined);
                        const p = fn(...variables);
                        return p.then(handler(), handler(true));
                    }
                }
            ]);
        return p.then(handler(), handler(true));
    }
    const o = typeof options === "string" ? {
        name: options
    } : options;
    const url = fn.url || o.name && `https://action/${o.name}` || (!(0, $6258376c5c54faa9$export$6acf61af03e62db) ? `https://action/${$68cd7f618e77dd88$var$hashString(fn.toString())}` : "");
    mutate.base = url;
    return $68cd7f618e77dd88$var$toAction(mutate, url);
}
function $68cd7f618e77dd88$var$toAction(fn, url) {
    fn.toString = ()=>{
        if (!url) throw new Error("Client Actions need explicit names if server rendered");
        return url;
    };
    fn.with = function(...args) {
        const newFn = function(...passedArgs) {
            return fn.call(this, ...args, ...passedArgs);
        };
        newFn.base = fn.base;
        const uri = new URL(url, $68cd7f618e77dd88$var$mockBase);
        uri.searchParams.set("args", $68cd7f618e77dd88$var$hashKey(args));
        return $68cd7f618e77dd88$var$toAction(newFn, (uri.origin === "https://action" ? uri.origin : "") + uri.pathname + uri.search);
    };
    fn.url = url;
    if (!(0, $6258376c5c54faa9$export$6acf61af03e62db)) {
        $68cd7f618e77dd88$var$actions.set(url, fn);
        (0, $8863cd8fe199f948$export$5f4ed0d56c2c0edf)() && (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>$68cd7f618e77dd88$var$actions.delete(url));
    }
    return fn;
}
const $68cd7f618e77dd88$var$hashString = (s)=>s.split("").reduce((a, b)=>(a << 5) - a + b.charCodeAt(0) | 0, 0);
async function $68cd7f618e77dd88$var$handleResponse(response, error, navigate) {
    let data;
    let custom;
    let keys;
    let flightKeys;
    if (response instanceof Response) {
        if (response.headers.has("X-Revalidate")) keys = response.headers.get("X-Revalidate").split(",");
        if (response.customBody) {
            data = custom = await response.customBody();
            if (response.headers.has("X-Single-Flight")) {
                data = data._$value;
                delete custom._$value;
                flightKeys = Object.keys(custom);
            }
        }
        if (response.headers.has("Location")) {
            const locationUrl = response.headers.get("Location") || "/";
            if (locationUrl.startsWith("http")) window.location.href = locationUrl;
            else navigate(locationUrl);
        }
    } else if (error) return {
        error: response
    };
    else data = response;
    // invalidate
    $68cd7f618e77dd88$var$cacheKeyOp(keys, (entry)=>entry[0] = 0);
    // set cache
    flightKeys && flightKeys.forEach((k)=>$68cd7f618e77dd88$export$2fa187e846a241c4.set(k, custom[k]));
    // trigger revalidation
    await $68cd7f618e77dd88$export$b409ca198cd12e26(keys, false);
    return data != null ? {
        data: data
    } : undefined;
}
function $68cd7f618e77dd88$var$setupNativeEvents(preload = true, explicitLinks = false, actionBase = "/_server", transformUrl) {
    return (router)=>{
        const basePath = router.base.path();
        const navigateFromRoute = router.navigatorFactory(router.base);
        let preloadTimeout;
        let lastElement;
        function isSvg(el) {
            return el.namespaceURI === "http://www.w3.org/2000/svg";
        }
        function handleAnchor(evt) {
            if (evt.defaultPrevented || evt.button !== 0 || evt.metaKey || evt.altKey || evt.ctrlKey || evt.shiftKey) return;
            const a = evt.composedPath().find((el)=>el instanceof Node && el.nodeName.toUpperCase() === "A");
            if (!a || explicitLinks && !a.hasAttribute("link")) return;
            const svg = isSvg(a);
            const href = svg ? a.href.baseVal : a.href;
            const target = svg ? a.target.baseVal : a.target;
            if (target || !href && !a.hasAttribute("state")) return;
            const rel = (a.getAttribute("rel") || "").split(/\s+/);
            if (a.hasAttribute("download") || rel && rel.includes("external")) return;
            const url = svg ? new URL(href, document.baseURI) : new URL(href);
            if (url.origin !== window.location.origin || basePath && url.pathname && !url.pathname.toLowerCase().startsWith(basePath.toLowerCase())) return;
            return [
                a,
                url
            ];
        }
        function handleAnchorClick(evt) {
            const res = handleAnchor(evt);
            if (!res) return;
            const [a, url] = res;
            const to = router.parsePath(url.pathname + url.search + url.hash);
            const state = a.getAttribute("state");
            evt.preventDefault();
            navigateFromRoute(to, {
                resolve: false,
                replace: a.hasAttribute("replace"),
                scroll: !a.hasAttribute("noscroll"),
                state: state ? JSON.parse(state) : undefined
            });
        }
        function handleAnchorPreload(evt) {
            const res = handleAnchor(evt);
            if (!res) return;
            const [a, url] = res;
            transformUrl && (url.pathname = transformUrl(url.pathname));
            router.preloadRoute(url, a.getAttribute("preload") !== "false");
        }
        function handleAnchorMove(evt) {
            clearTimeout(preloadTimeout);
            const res = handleAnchor(evt);
            if (!res) return lastElement = null;
            const [a, url] = res;
            if (lastElement === a) return;
            transformUrl && (url.pathname = transformUrl(url.pathname));
            preloadTimeout = setTimeout(()=>{
                router.preloadRoute(url, a.getAttribute("preload") !== "false");
                lastElement = a;
            }, 20);
        }
        function handleFormSubmit(evt) {
            if (evt.defaultPrevented) return;
            let actionRef = evt.submitter && evt.submitter.hasAttribute("formaction") ? evt.submitter.getAttribute("formaction") : evt.target.getAttribute("action");
            if (!actionRef) return;
            if (!actionRef.startsWith("https://action/")) {
                // normalize server actions
                const url = new URL(actionRef, $68cd7f618e77dd88$var$mockBase);
                actionRef = router.parsePath(url.pathname + url.search);
                if (!actionRef.startsWith(actionBase)) return;
            }
            if (evt.target.method.toUpperCase() !== "POST") throw new Error("Only POST forms are supported for Actions");
            const handler = $68cd7f618e77dd88$var$actions.get(actionRef);
            if (handler) {
                evt.preventDefault();
                const data = new FormData(evt.target, evt.submitter);
                handler.call({
                    r: router,
                    f: evt.target
                }, evt.target.enctype === "multipart/form-data" ? data : new URLSearchParams(data));
            }
        }
        // ensure delegated event run first
        (0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
            "click",
            "submit"
        ]);
        document.addEventListener("click", handleAnchorClick);
        if (preload) {
            document.addEventListener("mousemove", handleAnchorMove, {
                passive: true
            });
            document.addEventListener("focusin", handleAnchorPreload, {
                passive: true
            });
            document.addEventListener("touchstart", handleAnchorPreload, {
                passive: true
            });
        }
        document.addEventListener("submit", handleFormSubmit);
        (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>{
            document.removeEventListener("click", handleAnchorClick);
            if (preload) {
                document.removeEventListener("mousemove", handleAnchorMove);
                document.removeEventListener("focusin", handleAnchorPreload);
                document.removeEventListener("touchstart", handleAnchorPreload);
            }
            document.removeEventListener("submit", handleFormSubmit);
        });
    };
}
function $68cd7f618e77dd88$export$55185c17a0fcbe46(props) {
    if (0, $6258376c5c54faa9$export$6acf61af03e62db) return $68cd7f618e77dd88$export$cac06da4d76d935b(props);
    const getSource = ()=>{
        const url = window.location.pathname.replace(/^\/+/, "/") + window.location.search;
        const state = window.history.state && window.history.state._depth && Object.keys(window.history.state).length === 1 ? undefined : window.history.state;
        return {
            value: url + window.location.hash,
            state: state
        };
    };
    const beforeLeave = $68cd7f618e77dd88$export$6fd28b3773c73787();
    return $68cd7f618e77dd88$export$baddd0131ee8c05b({
        get: getSource,
        set ({ value: value, replace: replace, scroll: scroll, state: state }) {
            if (replace) window.history.replaceState($68cd7f618e77dd88$export$392f332fe0cbca16(state), "", value);
            else window.history.pushState(state, "", value);
            $68cd7f618e77dd88$var$scrollToHash(decodeURIComponent(window.location.hash.slice(1)), scroll);
            $68cd7f618e77dd88$export$1e81c4bafc9fc5b3();
        },
        init: (notify)=>$68cd7f618e77dd88$var$bindEvent(window, "popstate", $68cd7f618e77dd88$export$75d38aa30ad5e3c8(notify, (delta)=>{
                if (delta) return !beforeLeave.confirm(delta);
                else {
                    const s = getSource();
                    return !beforeLeave.confirm(s.value, {
                        state: s.state
                    });
                }
            })),
        create: $68cd7f618e77dd88$var$setupNativeEvents(props.preload, props.explicitLinks, props.actionBase, props.transformUrl),
        utils: {
            go: (delta)=>window.history.go(delta),
            beforeLeave: beforeLeave
        }
    })(props);
}
function $68cd7f618e77dd88$var$hashParser(str) {
    const to = str.replace(/^.*?#/, "");
    // Hash-only hrefs like `#foo` from plain anchors will come in as `/#foo` whereas a link to
    // `/foo` will be `/#/foo`. Check if the to starts with a `/` and if not append it as a hash
    // to the current path so we can handle these in-page anchors correctly.
    if (!to.startsWith("/")) {
        const [, path = "/"] = window.location.hash.split("#", 2);
        return `${path}#${to}`;
    }
    return to;
}
function $68cd7f618e77dd88$export$7221d69dcfc8e36b(props) {
    const getSource = ()=>window.location.hash.slice(1);
    const beforeLeave = $68cd7f618e77dd88$export$6fd28b3773c73787();
    return $68cd7f618e77dd88$export$baddd0131ee8c05b({
        get: getSource,
        set ({ value: value, replace: replace, scroll: scroll, state: state }) {
            if (replace) window.history.replaceState($68cd7f618e77dd88$export$392f332fe0cbca16(state), "", "#" + value);
            else window.history.pushState(state, "", "#" + value);
            const hashIndex = value.indexOf("#");
            const hash = hashIndex >= 0 ? value.slice(hashIndex + 1) : "";
            $68cd7f618e77dd88$var$scrollToHash(hash, scroll);
            $68cd7f618e77dd88$export$1e81c4bafc9fc5b3();
        },
        init: (notify)=>$68cd7f618e77dd88$var$bindEvent(window, "hashchange", $68cd7f618e77dd88$export$75d38aa30ad5e3c8(notify, (delta)=>!beforeLeave.confirm(delta && delta < 0 ? delta : getSource()))),
        create: $68cd7f618e77dd88$var$setupNativeEvents(props.preload, props.explicitLinks, props.actionBase),
        utils: {
            go: (delta)=>window.history.go(delta),
            renderPath: (path)=>`#${path}`,
            parsePath: $68cd7f618e77dd88$var$hashParser,
            beforeLeave: beforeLeave
        }
    })(props);
}
function $68cd7f618e77dd88$export$2b76ad033c6e6d08() {
    const entries = [
        "/"
    ];
    let index = 0;
    const listeners = [];
    const go = (n)=>{
        // https://github.com/remix-run/react-router/blob/682810ca929d0e3c64a76f8d6e465196b7a2ac58/packages/router/history.ts#L245
        index = Math.max(0, Math.min(index + n, entries.length - 1));
        const value = entries[index];
        listeners.forEach((listener)=>listener(value));
    };
    return {
        get: ()=>entries[index],
        set: ({ value: value, scroll: scroll, replace: replace })=>{
            if (replace) entries[index] = value;
            else {
                entries.splice(index + 1, entries.length - index, value);
                index++;
            }
            listeners.forEach((listener)=>listener(value));
            setTimeout(()=>{
                if (scroll) $68cd7f618e77dd88$var$scrollToHash(value.split("#")[1] || "", true);
            }, 0);
        },
        back: ()=>{
            go(-1);
        },
        forward: ()=>{
            go(1);
        },
        go: go,
        listen: (listener)=>{
            listeners.push(listener);
            return ()=>{
                const index = listeners.indexOf(listener);
                listeners.splice(index, 1);
            };
        }
    };
}
function $68cd7f618e77dd88$export$ae46f04cfaffe093(props) {
    const memoryHistory = props.history || $68cd7f618e77dd88$export$2b76ad033c6e6d08();
    return $68cd7f618e77dd88$export$baddd0131ee8c05b({
        get: memoryHistory.get,
        set: memoryHistory.set,
        init: memoryHistory.listen,
        create: $68cd7f618e77dd88$var$setupNativeEvents(props.preload, props.explicitLinks, props.actionBase),
        utils: {
            go: memoryHistory.go
        }
    })(props);
}
var $68cd7f618e77dd88$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<a>`);
function $68cd7f618e77dd88$export$ebd11618f299a286(props) {
    props = (0, $8863cd8fe199f948$export$9d1611c77c2fe928)({
        inactiveClass: "inactive",
        activeClass: "active"
    }, props);
    const [, rest] = (0, $8863cd8fe199f948$export$45029c61b0073d87)(props, [
        "href",
        "state",
        "class",
        "activeClass",
        "inactiveClass",
        "end"
    ]);
    const to = $68cd7f618e77dd88$export$e75d2a2d1b3c245b(()=>props.href);
    const href = $68cd7f618e77dd88$export$b66bb29c5006f12f(to);
    const location = $68cd7f618e77dd88$export$45d76561a5302f2b();
    const isActive = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const to_ = to();
        if (to_ === undefined) return [
            false,
            false
        ];
        const path = $68cd7f618e77dd88$var$normalizePath(to_.split(/[?#]/, 1)[0]).toLowerCase();
        const loc = decodeURI($68cd7f618e77dd88$var$normalizePath(location.pathname).toLowerCase());
        return [
            props.end ? path === loc : loc.startsWith(path + "/") || loc === path,
            path === loc
        ];
    });
    return (()=>{
        var _el$ = $68cd7f618e77dd88$var$_tmpl$();
        (0, $6258376c5c54faa9$export$3ae0fd4797ed47c8)(_el$, (0, $8863cd8fe199f948$export$9d1611c77c2fe928)(rest, {
            get href () {
                return href() || props.href;
            },
            get state () {
                return JSON.stringify(props.state);
            },
            get classList () {
                return {
                    ...props.class && {
                        [props.class]: true
                    },
                    [props.inactiveClass]: !isActive()[0],
                    [props.activeClass]: isActive()[0],
                    ...rest.classList
                };
            },
            "link": "",
            get ["aria-current"] () {
                return isActive()[1] ? "page" : undefined;
            }
        }), false, false);
        return _el$;
    })();
}
function $68cd7f618e77dd88$export$444b3ab0cb9aec40(props) {
    const navigate = $68cd7f618e77dd88$export$9770f232ac06a008();
    const location = $68cd7f618e77dd88$export$45d76561a5302f2b();
    const { href: href, state: state } = props;
    const path = typeof href === "function" ? href({
        navigate: navigate,
        location: location
    }) : href;
    navigate(path, {
        replace: true,
        state: state
    });
    return null;
}
/**
 * This is mock of the eventual Solid 2.0 primitive. It is not fully featured.
 */ /**
 * As `createAsync` and `createAsyncStore` are wrappers for `createResource`,
 * this type allows to support `latest` field for these primitives.
 * It will be removed in the future.
 */ function $68cd7f618e77dd88$export$fa0abf86dcc47d66(fn, options) {
    let resource;
    let prev = ()=>!resource || resource.state === "unresolved" ? undefined : resource.latest;
    [resource] = (0, $8863cd8fe199f948$export$edd172c6c83c39cc)(()=>$68cd7f618e77dd88$var$subFetch(fn, (0, $8863cd8fe199f948$export$3dede90624df3ba9)(()=>(0, $8863cd8fe199f948$export$363ebc4b78b8f807)(prev), ()=>undefined)), (v)=>v, options);
    const resultAccessor = ()=>resource();
    Object.defineProperty(resultAccessor, "latest", {
        get () {
            return resource.latest;
        }
    });
    return resultAccessor;
}
function $68cd7f618e77dd88$export$a0582b40408b3d09(fn, options = {}) {
    let resource;
    let prev = ()=>!resource || resource.state === "unresolved" ? undefined : (0, $caa70d287a6ddb62$export$debb760848ca95a)(resource.latest);
    [resource] = (0, $8863cd8fe199f948$export$edd172c6c83c39cc)(()=>$68cd7f618e77dd88$var$subFetch(fn, (0, $8863cd8fe199f948$export$3dede90624df3ba9)(()=>(0, $8863cd8fe199f948$export$363ebc4b78b8f807)(prev), ()=>undefined)), (v)=>v, {
        ...options,
        storage: (init)=>$68cd7f618e77dd88$var$createDeepSignal(init, options.reconcile)
    });
    const resultAccessor = ()=>resource();
    Object.defineProperty(resultAccessor, "latest", {
        get () {
            return resource.latest;
        }
    });
    return resultAccessor;
}
function $68cd7f618e77dd88$var$createDeepSignal(value, options) {
    const [store, setStore] = (0, $caa70d287a6ddb62$export$f51a9068ac82ea43)({
        value: structuredClone(value)
    });
    return [
        ()=>store.value,
        (v)=>{
            typeof v === "function" && (v = v());
            setStore("value", (0, $caa70d287a6ddb62$export$38319cad1f6d89e0)(structuredClone(v), options));
            return store.value;
        }
    ];
}
// mock promise while hydrating to prevent fetching
class $68cd7f618e77dd88$var$MockPromise {
    static all() {
        return new $68cd7f618e77dd88$var$MockPromise();
    }
    static allSettled() {
        return new $68cd7f618e77dd88$var$MockPromise();
    }
    static any() {
        return new $68cd7f618e77dd88$var$MockPromise();
    }
    static race() {
        return new $68cd7f618e77dd88$var$MockPromise();
    }
    static reject() {
        return new $68cd7f618e77dd88$var$MockPromise();
    }
    static resolve() {
        return new $68cd7f618e77dd88$var$MockPromise();
    }
    catch() {
        return new $68cd7f618e77dd88$var$MockPromise();
    }
    then() {
        return new $68cd7f618e77dd88$var$MockPromise();
    }
    finally() {
        return new $68cd7f618e77dd88$var$MockPromise();
    }
}
function $68cd7f618e77dd88$var$subFetch(fn, prev) {
    if ((0, $6258376c5c54faa9$export$6acf61af03e62db) || !(0, $8863cd8fe199f948$export$2cb4986bed338027).context) return fn(prev);
    const ogFetch = fetch;
    const ogPromise = Promise;
    try {
        window.fetch = ()=>new $68cd7f618e77dd88$var$MockPromise();
        Promise = $68cd7f618e77dd88$var$MockPromise;
        return fn(prev);
    } finally{
        window.fetch = ogFetch;
        Promise = ogPromise;
    }
}
function $68cd7f618e77dd88$export$89e12c5b50f7529d(url, init = 302) {
    let responseInit;
    let revalidate;
    if (typeof init === "number") responseInit = {
        status: init
    };
    else {
        ({ revalidate: revalidate, ...responseInit } = init);
        if (typeof responseInit.status === "undefined") responseInit.status = 302;
    }
    const headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    revalidate !== undefined && headers.set("X-Revalidate", revalidate.toString());
    const response = new Response(null, {
        ...responseInit,
        headers: headers
    });
    return response;
}
function $68cd7f618e77dd88$export$32da5b5043dcd88c(init = {}) {
    const { revalidate: revalidate, ...responseInit } = init;
    const headers = new Headers(responseInit.headers);
    revalidate !== undefined && headers.set("X-Revalidate", revalidate.toString());
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
}
function $68cd7f618e77dd88$export$7b419323e6ed4f31(data, init = {}) {
    const { revalidate: revalidate, ...responseInit } = init;
    const headers = new Headers(responseInit.headers);
    revalidate !== undefined && headers.set("X-Revalidate", revalidate.toString());
    headers.set("Content-Type", "application/json");
    const response = new Response(JSON.stringify(data), {
        ...responseInit,
        headers: headers
    });
    response.customBody = ()=>data;
    return response;
}







const $b417fd17fc84e4e3$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$b417fd17fc84e4e3$export$c169aefb7330cccb["open"] = "0";
$b417fd17fc84e4e3$export$c169aefb7330cccb["close"] = "1";
$b417fd17fc84e4e3$export$c169aefb7330cccb["ping"] = "2";
$b417fd17fc84e4e3$export$c169aefb7330cccb["pong"] = "3";
$b417fd17fc84e4e3$export$c169aefb7330cccb["message"] = "4";
$b417fd17fc84e4e3$export$c169aefb7330cccb["upgrade"] = "5";
$b417fd17fc84e4e3$export$c169aefb7330cccb["noop"] = "6";
const $b417fd17fc84e4e3$export$47791e8004edd485 = Object.create(null);
Object.keys($b417fd17fc84e4e3$export$c169aefb7330cccb).forEach((key)=>{
    $b417fd17fc84e4e3$export$47791e8004edd485[$b417fd17fc84e4e3$export$c169aefb7330cccb[key]] = key;
});
const $b417fd17fc84e4e3$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $8a3662315a48cdbd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $8a3662315a48cdbd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $8a3662315a48cdbd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $8a3662315a48cdbd$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($8a3662315a48cdbd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(data, callback);
    } else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $b417fd17fc84e4e3$export$c169aefb7330cccb)[type] + (data || ""));
};
const $8a3662315a48cdbd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $8a3662315a48cdbd$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $8a3662315a48cdbd$var$TEXT_ENCODER;
function $8a3662315a48cdbd$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($8a3662315a48cdbd$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($8a3662315a48cdbd$var$toArray).then(callback);
    else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(packet.data))) return callback($8a3662315a48cdbd$var$toArray(packet.data));
    $8a3662315a48cdbd$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$8a3662315a48cdbd$var$TEXT_ENCODER) $8a3662315a48cdbd$var$TEXT_ENCODER = new TextEncoder();
        callback($8a3662315a48cdbd$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $7f4e842ae29bcbc5$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $7f4e842ae29bcbc5$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $7f4e842ae29bcbc5$var$chars.length; i++)$7f4e842ae29bcbc5$var$lookup[$7f4e842ae29bcbc5$var$chars.charCodeAt(i)] = i;
const $7f4e842ae29bcbc5$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i] >> 2];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $7f4e842ae29bcbc5$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i)];
        encoded2 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $a9bf3da28855a34f$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a9bf3da28855a34f$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a9bf3da28855a34f$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a9bf3da28855a34f$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $b417fd17fc84e4e3$export$47791e8004edd485)[type];
    if (!packetType) return 0, $b417fd17fc84e4e3$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $b417fd17fc84e4e3$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $b417fd17fc84e4e3$export$47791e8004edd485)[type]
    };
};
const $a9bf3da28855a34f$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a9bf3da28855a34f$var$withNativeArrayBuffer) {
        const decoded = (0, $7f4e842ae29bcbc5$export$2f872c0f2117be69)(data);
        return $a9bf3da28855a34f$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a9bf3da28855a34f$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $0736208648dc8bae$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $0736208648dc8bae$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $8a3662315a48cdbd$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($0736208648dc8bae$var$SEPARATOR));
        });
    });
};
const $0736208648dc8bae$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($0736208648dc8bae$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $a9bf3da28855a34f$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $0736208648dc8bae$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $8a3662315a48cdbd$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $0736208648dc8bae$var$TEXT_DECODER;
function $0736208648dc8bae$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $0736208648dc8bae$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $0736208648dc8bae$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$0736208648dc8bae$var$TEXT_DECODER) $0736208648dc8bae$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 1) break;
                    const header = $0736208648dc8bae$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 2) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 8) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $b417fd17fc84e4e3$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($0736208648dc8bae$var$totalLength(chunks) < expectedLength) break;
                    const data = $0736208648dc8bae$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $a9bf3da28855a34f$export$4647901878f33f31)(isBinary ? data : $0736208648dc8bae$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $b417fd17fc84e4e3$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $0736208648dc8bae$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $3d905a8ca243a015$export$4293555f241ae35a(obj) {
    if (obj) return $3d905a8ca243a015$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $3d905a8ca243a015$var$mixin(obj) {
    for(var key in $3d905a8ca243a015$export$4293555f241ae35a.prototype)obj[key] = $3d905a8ca243a015$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.on = $3d905a8ca243a015$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.off = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeListener = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeAllListeners = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$3d905a8ca243a015$export$4293555f241ae35a.prototype.emitReserved = $3d905a8ca243a015$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $8959bb304e43f43f$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $8959bb304e43f43f$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $8959bb304e43f43f$export$790dcbc41e2d75d5 = "arraybuffer";
function $8959bb304e43f43f$export$19413efcf2fac759() {}


function $4028d5a20a4526d1$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT = (0, $8959bb304e43f43f$export$394f9358f6231289).setTimeout;
const $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT = (0, $8959bb304e43f43f$export$394f9358f6231289).clearTimeout;
function $4028d5a20a4526d1$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT.bind((0, $8959bb304e43f43f$export$394f9358f6231289));
        obj.clearTimeoutFn = $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT.bind((0, $8959bb304e43f43f$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $8959bb304e43f43f$export$394f9358f6231289).setTimeout.bind((0, $8959bb304e43f43f$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $8959bb304e43f43f$export$394f9358f6231289).clearTimeout.bind((0, $8959bb304e43f43f$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $4028d5a20a4526d1$var$BASE64_OVERHEAD = 1.33;
function $4028d5a20a4526d1$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $4028d5a20a4526d1$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $4028d5a20a4526d1$var$BASE64_OVERHEAD);
}
function $4028d5a20a4526d1$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $4028d5a20a4526d1$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $19744bce3c183d10$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $19744bce3c183d10$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $4a78f487f5bb98d8$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $4a78f487f5bb98d8$export$86495b081fef8e52 extends (0, $3d905a8ca243a015$export$4293555f241ae35a) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $4028d5a20a4526d1$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $4a78f487f5bb98d8$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $a9bf3da28855a34f$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $19744bce3c183d10$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}




class $56534be56e5aa809$export$265ee5eefd4c309b extends (0, $4a78f487f5bb98d8$export$86495b081fef8e52) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $0736208648dc8bae$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $0736208648dc8bae$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $4028d5a20a4526d1$export$7fa8378418b4411e)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}





// imported from https://github.com/component/has-cors
let $ef3f42a25dd224af$var$value = false;
try {
    $ef3f42a25dd224af$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $ef3f42a25dd224af$export$5235bbd4a1ef06e = $ef3f42a25dd224af$var$value;


function $2ddd02863faa1587$var$empty() {}
class $2ddd02863faa1587$export$c959f2344155d309 extends (0, $56534be56e5aa809$export$265ee5eefd4c309b) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $2ddd02863faa1587$export$7fa6c5b6f8193917 extends (0, $3d905a8ca243a015$export$4293555f241ae35a) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $4028d5a20a4526d1$export$2f67576668b97183)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $4028d5a20a4526d1$export$357523c63a2253b9)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $2ddd02863faa1587$export$7fa6c5b6f8193917.requestsCount++;
            $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $2ddd02863faa1587$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$2ddd02863faa1587$export$7fa6c5b6f8193917.requestsCount = 0;
$2ddd02863faa1587$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $2ddd02863faa1587$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $8959bb304e43f43f$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $2ddd02863faa1587$var$unloadHandler, false);
    }
}
function $2ddd02863faa1587$var$unloadHandler() {
    for(let i in $2ddd02863faa1587$export$7fa6c5b6f8193917.requests)if ($2ddd02863faa1587$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[i].abort();
}
const $2ddd02863faa1587$var$hasXHR2 = function() {
    const xhr = $2ddd02863faa1587$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $2ddd02863faa1587$export$a2d42eb087c10497 extends $2ddd02863faa1587$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $2ddd02863faa1587$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $2ddd02863faa1587$export$7fa6c5b6f8193917($2ddd02863faa1587$var$newRequest, this.uri(), opts);
    }
}
function $2ddd02863faa1587$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $ef3f42a25dd224af$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $8959bb304e43f43f$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}






// detect ReactNative environment
const $9ab7b46a38551fa4$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $9ab7b46a38551fa4$export$570bf71d2367e261 extends (0, $4a78f487f5bb98d8$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $9ab7b46a38551fa4$var$isReactNative ? {} : (0, $4028d5a20a4526d1$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $8a3662315a48cdbd$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $8959bb304e43f43f$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $4028d5a20a4526d1$export$7fa8378418b4411e)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $9ab7b46a38551fa4$var$WebSocketCtor = (0, $8959bb304e43f43f$export$394f9358f6231289).WebSocket || (0, $8959bb304e43f43f$export$394f9358f6231289).MozWebSocket;
class $9ab7b46a38551fa4$export$911baa0677ac404c extends $9ab7b46a38551fa4$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$9ab7b46a38551fa4$var$isReactNative ? protocols ? new $9ab7b46a38551fa4$var$WebSocketCtor(uri, protocols) : new $9ab7b46a38551fa4$var$WebSocketCtor(uri) : new $9ab7b46a38551fa4$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}





class $cea1ad415a07b478$export$961c930859384407 extends (0, $4a78f487f5bb98d8$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $0736208648dc8bae$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $0736208648dc8bae$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $8959bb304e43f43f$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}


const $c1f726e793763466$export$46dec00755c1153b = {
    websocket: (0, $9ab7b46a38551fa4$export$911baa0677ac404c),
    webtransport: (0, $cea1ad415a07b478$export$961c930859384407),
    polling: (0, $2ddd02863faa1587$export$a2d42eb087c10497)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $f603c1892ffe9e8b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $f603c1892ffe9e8b$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $f603c1892ffe9e8b$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $f603c1892ffe9e8b$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$f603c1892ffe9e8b$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $f603c1892ffe9e8b$var$pathNames(uri, uri['path']);
    uri.queryKey = $f603c1892ffe9e8b$var$queryKey(uri, uri['query']);
    return uri;
}
function $f603c1892ffe9e8b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $f603c1892ffe9e8b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





const $787375aed2c43820$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS = [];
if ($787375aed2c43820$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $787375aed2c43820$export$3874118029a0ee0d extends (0, $3d905a8ca243a015$export$4293555f241ae35a) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $8959bb304e43f43f$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $f603c1892ffe9e8b$export$98e6a39c04603d36)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $f603c1892ffe9e8b$export$98e6a39c04603d36)(opts.host).host;
        (0, $4028d5a20a4526d1$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $19744bce3c183d10$export$2f872c0f2117be69)(this.opts.query);
        if ($787375aed2c43820$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $8959bb304e43f43f$export$19413efcf2fac759)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $0736208648dc8bae$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $4028d5a20a4526d1$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $8959bb304e43f43f$export$bdd553fddd433dcb)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($787375aed2c43820$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$787375aed2c43820$export$3874118029a0ee0d.protocol = (0, $0736208648dc8bae$export$a51d6b395ff4c65a);
class $787375aed2c43820$export$cc521fcb1004e85c extends $787375aed2c43820$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $787375aed2c43820$export$4798917dbf149b79 extends $787375aed2c43820$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $c1f726e793763466$export$46dec00755c1153b)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}








class $d25cf4f3df002b9c$export$1e7deca84b429035 extends (0, $56534be56e5aa809$export$265ee5eefd4c309b) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}







const $16df97babd1aadf1$export$a51d6b395ff4c65a = (0, $787375aed2c43820$export$4798917dbf149b79).protocol;


function $efe27346e00da8a8$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $f603c1892ffe9e8b$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $1e4e6e6cc3958162$exports = {};

$parcel$export($1e4e6e6cc3958162$exports, "protocol", () => $1e4e6e6cc3958162$export$a51d6b395ff4c65a);
$parcel$export($1e4e6e6cc3958162$exports, "PacketType", () => $1e4e6e6cc3958162$export$84d4095e16c6fc19);
$parcel$export($1e4e6e6cc3958162$exports, "Encoder", () => $1e4e6e6cc3958162$export$a50aceb0e02a00aa);
$parcel$export($1e4e6e6cc3958162$exports, "Decoder", () => $1e4e6e6cc3958162$export$f9de6ca0bc043724);
$parcel$export($1e4e6e6cc3958162$exports, "isPacketValid", () => $1e4e6e6cc3958162$export$1a38ed17dcb5458e);

const $ab192732c3780e48$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $ab192732c3780e48$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $ab192732c3780e48$var$toString = Object.prototype.toString;
const $ab192732c3780e48$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $ab192732c3780e48$var$toString.call(Blob) === "[object BlobConstructor]";
const $ab192732c3780e48$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $ab192732c3780e48$var$toString.call(File) === "[object FileConstructor]";
function $ab192732c3780e48$export$37488ff1135b1696(obj) {
    return $ab192732c3780e48$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $ab192732c3780e48$var$isView(obj)) || $ab192732c3780e48$var$withNativeBlob && obj instanceof Blob || $ab192732c3780e48$var$withNativeFile && obj instanceof File;
}
function $ab192732c3780e48$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($ab192732c3780e48$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($ab192732c3780e48$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $ab192732c3780e48$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $ab192732c3780e48$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $67dd224d5a131c9e$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $67dd224d5a131c9e$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $67dd224d5a131c9e$var$_deconstructPacket(data, buffers, toJSON) {
    if (!data) return data;
    if ((0, $ab192732c3780e48$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $67dd224d5a131c9e$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        if (data.toJSON && typeof data.toJSON === "function" && !toJSON) return $67dd224d5a131c9e$var$_deconstructPacket(data.toJSON(), buffers, true);
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $67dd224d5a131c9e$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $67dd224d5a131c9e$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $67dd224d5a131c9e$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $67dd224d5a131c9e$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $67dd224d5a131c9e$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $67dd224d5a131c9e$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $1e4e6e6cc3958162$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $1e4e6e6cc3958162$export$a51d6b395ff4c65a = 5;
var $1e4e6e6cc3958162$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($1e4e6e6cc3958162$export$84d4095e16c6fc19 || ($1e4e6e6cc3958162$export$84d4095e16c6fc19 = {}));
class $1e4e6e6cc3958162$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK) {
            if ((0, $ab192732c3780e48$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $67dd224d5a131c9e$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
class $1e4e6e6cc3958162$export$f9de6ca0bc043724 extends (0, $3d905a8ca243a015$export$4293555f241ae35a) {
    /**
     * Decoder constructor
     */ constructor(opts){
        super();
        this.opts = Object.assign({
            reviver: undefined,
            maxAttachments: 10
        }, typeof opts === "function" ? {
            reviver: opts
        } : opts);
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $1e4e6e6cc3958162$var$BinaryReconstructor(packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $ab192732c3780e48$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($1e4e6e6cc3958162$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            const n = Number(buf);
            if (!$1e4e6e6cc3958162$var$isInteger(n) || n < 1) throw new Error("Illegal attachments");
            else if (n > this.opts.maxAttachments) throw new Error("too many attachments");
            p.attachments = n;
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($1e4e6e6cc3958162$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.opts.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
                return $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $1e4e6e6cc3958162$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $67dd224d5a131c9e$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}
function $1e4e6e6cc3958162$var$isNamespaceValid(nsp) {
    return typeof nsp === "string";
}
// see https://caniuse.com/mdn-javascript_builtins_number_isinteger
const $1e4e6e6cc3958162$var$isInteger = Number.isInteger || function(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
function $1e4e6e6cc3958162$var$isAckIdValid(id) {
    return id === undefined || $1e4e6e6cc3958162$var$isInteger(id);
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $1e4e6e6cc3958162$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
function $1e4e6e6cc3958162$var$isDataValid(type, payload) {
    switch(type){
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
            return payload === undefined || $1e4e6e6cc3958162$var$isObject(payload);
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
            return payload === undefined;
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            return Array.isArray(payload);
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
            return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
        default:
            return false;
    }
}
function $1e4e6e6cc3958162$export$1a38ed17dcb5458e(packet) {
    return $1e4e6e6cc3958162$var$isNamespaceValid(packet.nsp) && $1e4e6e6cc3958162$var$isAckIdValid(packet.id) && $1e4e6e6cc3958162$var$isDataValid(packet.type, packet.data);
}


function $05fb321879039179$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $fcab49da21a6222a$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $fcab49da21a6222a$export$4798917dbf149b79 extends (0, $3d905a8ca243a015$export$4293555f241ae35a) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $05fb321879039179$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $05fb321879039179$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $05fb321879039179$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $05fb321879039179$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($fcab49da21a6222a$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            this._queue[0];
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).EVENT:
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).ACK:
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this._drainQueue(true);
        this.emitReserved("connect");
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3f0f0eae169725b6$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $b78f1c3cb524f77d$export$d0d38e7dec7a1a61 extends (0, $3d905a8ca243a015$export$4293555f241ae35a) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $4028d5a20a4526d1$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $3f0f0eae169725b6$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $1e4e6e6cc3958162$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $787375aed2c43820$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $05fb321879039179$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $05fb321879039179$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $05fb321879039179$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $05fb321879039179$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $05fb321879039179$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $05fb321879039179$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $05fb321879039179$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $8959bb304e43f43f$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $fcab49da21a6222a$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}





/**
 * Managers cache.
 */ const $523eaa49d3f99bf8$var$cache = {};
function $523eaa49d3f99bf8$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $efe27346e00da8a8$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $523eaa49d3f99bf8$var$cache[id] && path in $523eaa49d3f99bf8$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $b78f1c3cb524f77d$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$523eaa49d3f99bf8$var$cache[id]) $523eaa49d3f99bf8$var$cache[id] = new (0, $b78f1c3cb524f77d$export$d0d38e7dec7a1a61)(source, opts);
        io = $523eaa49d3f99bf8$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($523eaa49d3f99bf8$export$841407ceb083bd74, {
    Manager: $b78f1c3cb524f77d$export$d0d38e7dec7a1a61,
    Socket: $fcab49da21a6222a$export$4798917dbf149b79,
    io: $523eaa49d3f99bf8$export$841407ceb083bd74,
    connect: $523eaa49d3f99bf8$export$841407ceb083bd74
});



const $b0a42ae73c325226$export$1b1fb4c7e01569c9 = 'https://git.unistra.fr';
const $b0a42ae73c325226$export$923ea8233b386e99 = '';


var $a26018a1d2174fbf$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=socket-status><div class="alert alert-danger"role=alert><div class=spinner-border role=status><span class=visually-hidden>Loading...</span></div>Connexion au serveur perdue...`);
const $a26018a1d2174fbf$var$socket = (0, $523eaa49d3f99bf8$export$841407ceb083bd74)((0, $b0a42ae73c325226$export$923ea8233b386e99), {
    transports: [
        "websocket",
        "polling"
    ] // use WebSocket first, if available
});
var $a26018a1d2174fbf$export$2e2bcd8739ae039 = $a26018a1d2174fbf$var$socket;
const $a26018a1d2174fbf$export$d049364d16567d0d = ()=>{
    const [status, setStatus] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)('disconnected');
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        if ($a26018a1d2174fbf$var$socket.connected) setStatus('connected');
        $a26018a1d2174fbf$var$socket.on('connect', ()=>{
            console.log('connected');
            setStatus('connected');
        });
        $a26018a1d2174fbf$var$socket.on('disconnect', ()=>{
            setStatus('disconnected');
            console.log('disconnect');
        });
    });
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
        get when () {
            return status() == 'disconnected';
        },
        get children () {
            return $a26018a1d2174fbf$var$_tmpl$();
        }
    });
};


const $c3b276e29c1ce2f2$var$defaultUserStore = {
    isAuthenticated: false,
    isConnected: false,
    isAuthenticating: false,
    username: null,
    role: null,
    userType: null,
    clientId: null,
    authStage: 'choose-method'
};
const $c3b276e29c1ce2f2$var$UserContext = (0, $8863cd8fe199f948$export$fd42f52fd3ae1109)();
// Generate a new client ID for a localStorage key (do not create automatically at startup)
function $c3b276e29c1ce2f2$var$generateClientId(storageKey = 'clientId') {
    const clientId = 'client_' + crypto.randomUUID().replaceAll('-', '');
    localStorage.setItem(storageKey, clientId);
    return clientId;
}
// retrieve query params 'jwt'
const $c3b276e29c1ce2f2$var$urlParams = new URLSearchParams(window.location.search);
const $c3b276e29c1ce2f2$var$jwt = $c3b276e29c1ce2f2$var$urlParams.get('jwt') || localStorage.getItem('jwt');
if ($c3b276e29c1ce2f2$var$jwt) localStorage.setItem('jwt', $c3b276e29c1ce2f2$var$jwt);
if ($c3b276e29c1ce2f2$var$urlParams.get('jwt')) {
    // Remove jwt from URL and restore page where CAS login was initiated.
    const postLoginRedirect = localStorage.getItem('postLoginRedirect');
    if (postLoginRedirect) {
        localStorage.removeItem('postLoginRedirect');
        window.history.replaceState({}, document.title, postLoginRedirect);
    } else window.history.replaceState({}, document.title, "/");
}
function $c3b276e29c1ce2f2$export$2e7f18b06f26b111(props) {
    const [userStore, setUserStore] = (0, $caa70d287a6ddb62$export$f51a9068ac82ea43)($c3b276e29c1ce2f2$var$defaultUserStore);
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        console.log('Mounted UserContext');
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("connect", ()=>{
            setUserStore({
                isConnected: true
            });
            console.log("connected");
            if ($c3b276e29c1ce2f2$var$jwt) {
                // Authenticate via CAS token
                setUserStore({
                    authStage: 'authenticating',
                    isAuthenticating: true
                });
                (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("authenticate", $c3b276e29c1ce2f2$var$jwt);
            } else {
                const isDirectQuizJoinPage = window.location.pathname.startsWith('/q/');
                const existingClientId = localStorage.getItem('clientId');
                const storedName = localStorage.getItem('studentName');
                if (userStore.isAuthenticated && userStore.userType === 'external-student' && existingClientId && storedName) (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('authenticate-student', {
                    clientId: existingClientId,
                    name: storedName,
                    studentToken: localStorage.getItem('studentToken')
                });
                else if (userStore.isAuthenticated && userStore.userType === 'anonymous-student') (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('authenticate-student', {
                    clientId: localStorage.getItem('anonymousClientId'),
                    anonymous: true,
                    studentToken: localStorage.getItem('anonymousStudentToken')
                });
                else if (existingClientId && storedName && !isDirectQuizJoinPage) {
                    // Auto external authentication (returning student)
                    setUserStore({
                        clientId: existingClientId,
                        authStage: 'authenticating',
                        isAuthenticating: true
                    });
                    (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('authenticate-student', {
                        clientId: existingClientId,
                        name: storedName,
                        studentToken: localStorage.getItem('studentToken')
                    });
                } else // Let the user choose between CAS and External
                setUserStore({
                    clientId: existingClientId,
                    authStage: 'choose-method'
                });
            }
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("authenticated", (data)=>{
            console.log('connected as', data);
            setUserStore({
                username: data.type === 'external-student' || data.type === 'anonymous-student' ? data.fullName || '' : data.username,
                role: data.role,
                isAuthenticating: false,
                isAuthenticated: true,
                userType: data.type,
                clientId: data.clientId || userStore.clientId,
                authStage: 'authenticated'
            });
            if (data.type === 'external-student' && data.fullName) // Persist name after successful auth
            localStorage.setItem('studentName', data.fullName);
            if (data.studentToken) localStorage.setItem(data.type === 'anonymous-student' ? 'anonymousStudentToken' : 'studentToken', data.studentToken);
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('student-reauth-required', (data)=>{
            const anonymous = data.authType === 'anonymous';
            localStorage.removeItem(anonymous ? 'anonymousClientId' : 'clientId');
            localStorage.removeItem(anonymous ? 'anonymousStudentToken' : 'studentToken');
            setUserStore({
                isAuthenticated: false,
                isAuthenticating: false,
                username: null,
                role: null,
                userType: null,
                clientId: null,
                authStage: anonymous ? 'choose-method' : 'enter-external-name'
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("student-updated", (data)=>{
            console.log('student updated', data);
            const display = data.fullName || data.username || '';
            setUserStore({
                username: display
            });
            localStorage.setItem('studentName', display);
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("unauthorized", (error)=>{
            console.log({
                error: error
            });
            localStorage.removeItem('jwt');
            setUserStore({
                isAuthenticated: false,
                username: null,
                role: null,
                isAuthenticating: false,
                userType: null,
                authStage: 'choose-method'
            });
        });
    });
    const actions = {
        updateStudentName: (name)=>{
            if (userStore.clientId && userStore.userType === 'external-student') (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('update-student-name', {
                name: name
            });
        },
        chooseCAS: ()=>{
            localStorage.setItem('postLoginRedirect', window.location.pathname + window.location.search);
            window.location.href = '/login';
        },
        chooseExternal: ()=>{
            // Move to name entry stage; pre-fill clientId if exists
            const existingClientId = localStorage.getItem('clientId');
            setUserStore({
                isAuthenticated: false,
                isAuthenticating: false,
                username: null,
                role: null,
                userType: null,
                authStage: 'enter-external-name',
                clientId: existingClientId || null
            });
        },
        chooseAnonymous: ()=>{
            actions.submitAnonymousLogin();
        },
        submitExternalName: (name)=>{
            const trimmed = (name || '').trim();
            if (!trimmed) return;
            // Ensure clientId exists
            let clientId = userStore.clientId;
            if (!clientId) {
                clientId = $c3b276e29c1ce2f2$var$generateClientId();
                setUserStore({
                    clientId: clientId
                });
            }
            setUserStore({
                isAuthenticated: false,
                username: null,
                role: null,
                userType: null,
                authStage: 'authenticating',
                isAuthenticating: true
            });
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('authenticate-student', {
                clientId: clientId,
                name: trimmed,
                studentToken: localStorage.getItem('studentToken')
            });
        },
        submitAnonymousLogin: ()=>{
            let clientId = localStorage.getItem('anonymousClientId');
            if (!clientId) clientId = $c3b276e29c1ce2f2$var$generateClientId('anonymousClientId');
            setUserStore({
                isAuthenticated: false,
                username: null,
                role: null,
                userType: null,
                clientId: clientId,
                authStage: 'authenticating',
                isAuthenticating: true
            });
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('authenticate-student', {
                clientId: clientId,
                anonymous: true,
                studentToken: localStorage.getItem('anonymousStudentToken')
            });
        }
    };
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($c3b276e29c1ce2f2$var$UserContext.Provider, {
        value: [
            userStore,
            setUserStore,
            actions
        ],
        get children () {
            return props.children;
        }
    });
}
function $c3b276e29c1ce2f2$export$87c54b525b914dab() {
    return (0, $8863cd8fe199f948$export$fae74005e78b1a27)($c3b276e29c1ce2f2$var$UserContext);
}





var $b1a355c10f370609$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=loader>`), $b1a355c10f370609$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li><a class="nav-link dropdown-toggle"href=# id=navbarDropdownMenuLink role=button data-bs-toggle=dropdown aria-expanded=false></a><ul aria-labelledby=navbarDropdownMenuLink>`);
const $b1a355c10f370609$export$3b0d6d7590275603 = ()=>$b1a355c10f370609$var$_tmpl$();
const $b1a355c10f370609$export$461cb598b7fcff7b = (props)=>{
    const [showMenu, setShowMenu] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    let menuDropdown;
    const handleDropdownClick = (event)=>{
        if (event.target == menuDropdown) setShowMenu(!showMenu());
        else setShowMenu(false);
    };
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        document.addEventListener('click', handleDropdownClick);
    });
    (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>{
        document.removeEventListener('click', handleDropdownClick);
    });
    return (()=>{
        var _el$2 = $b1a355c10f370609$var$_tmpl$2(), _el$3 = _el$2.firstChild, _el$4 = _el$3.nextSibling;
        var _ref$ = menuDropdown;
        typeof _ref$ === "function" ? (0, $6258376c5c54faa9$export$1f96ae73734a86cc)(_ref$, _el$3) : menuDropdown = _el$3;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$3, ()=>props.label);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$4, ()=>props.children);
        (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
            var _v$ = "nav-item dropdown" + (showMenu() ? ' show' : ''), _v$2 = "dropdown-menu" + (showMenu() ? ' show' : '');
            _v$ !== _p$.e && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$2, _p$.e = _v$);
            _v$2 !== _p$.t && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$4, _p$.t = _v$2);
            return _p$;
        }, {
            e: undefined,
            t: undefined
        });
        return _el$2;
    })();
};



var $e4c7899627fd74c8$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li>`);
function $e4c7899627fd74c8$export$2e2bcd8739ae039() {
    return null;
}
const $e4c7899627fd74c8$export$fd88fd0f00d26ab7 = ()=>{
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $b1a355c10f370609$export$461cb598b7fcff7b), {
        label: "Admin",
        get children () {
            var _el$ = $e4c7899627fd74c8$var$_tmpl$();
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$ebd11618f299a286), {
                "class": "dropdown-item",
                href: "/manage-users",
                children: "Manage Users"
            }));
            return _el$;
        }
    });
};




var $b7c5bf68baf10222$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li class=nav-item>`), $b7c5bf68baf10222$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li>`), $b7c5bf68baf10222$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<nav class="navbar navbar-expand-lg sticky-top navbar-light bg-light"><div class=container-fluid><button class=navbar-toggler type=button data-bs-toggle=collapse data-bs-target=#navbarNavDropdown aria-controls=navbarNavDropdown aria-expanded=false aria-label="Toggle navigation"><span class=navbar-toggler-icon></span></button><div class="collapse navbar-collapse"id=navbarNavDropdown><ul class=navbar-nav><li class=nav-item>`), $b7c5bf68baf10222$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><div>`);
function $b7c5bf68baf10222$export$2e2bcd8739ae039(props) {
    const [userStore] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const location = (0, $68cd7f618e77dd88$export$45d76561a5302f2b)();
    // Check if we're on a public page or student quiz (no navigation needed)
    const isPublicPage = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>location.pathname.startsWith('/public/'));
    const isStudentQuiz = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>location.pathname.startsWith('/q/'));
    const hideNavbar = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>isPublicPage() || isStudentQuiz());
    const [collapsed, setCollapsed] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(true);
    return (()=>{
        var _el$ = $b7c5bf68baf10222$var$_tmpl$4(), _el$0 = _el$.firstChild;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return !hideNavbar();
            },
            get children () {
                var _el$2 = $b7c5bf68baf10222$var$_tmpl$3(), _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$5.firstChild, _el$7 = _el$6.firstChild;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$3, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$ebd11618f299a286), {
                    "class": "navbar-brand",
                    href: "/",
                    children: "Live Quiz"
                }), _el$4);
                _el$4.$$click = ()=>setCollapsed(!collapsed());
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$ebd11618f299a286), {
                    "class": "nav-link",
                    end: true,
                    href: "/",
                    children: "Home"
                }));
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return userStore.role === 'admin';
                    },
                    get children () {
                        var _el$8 = $b7c5bf68baf10222$var$_tmpl$();
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$ebd11618f299a286), {
                            "class": "nav-link",
                            href: "/manage-quizzes",
                            children: "Manage Quizzes"
                        }));
                        return _el$8;
                    }
                }), null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $b1a355c10f370609$export$461cb598b7fcff7b), {
                    get label () {
                        return userStore.username || "Non connect\xe9";
                    },
                    get children () {
                        var _el$9 = $b7c5bf68baf10222$var$_tmpl$2();
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$ebd11618f299a286), {
                            "class": "nav-link",
                            href: "/user-settings",
                            children: "Settings"
                        }));
                        return _el$9;
                    }
                }), null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return userStore.role === 'admin';
                    },
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $e4c7899627fd74c8$export$fd88fd0f00d26ab7), {});
                    }
                }), null);
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$5.classList.toggle("show", !collapsed()));
                return _el$2;
            }
        }), _el$0);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$0, ()=>props.children);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return !hideNavbar();
            },
            get children () {
                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $a26018a1d2174fbf$export$d049364d16567d0d), {});
            }
        }), null);
        (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
            var _v$ = hideNavbar() ? '' : 'container', _v$2 = hideNavbar() ? '' : 'py-3';
            _v$ !== _p$.e && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$, _p$.e = _v$);
            _v$2 !== _p$.t && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$0, _p$.t = _v$2);
            return _p$;
        }, {
            e: undefined,
            t: undefined
        });
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);








var $c21c9bfd7d6ea3c3$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<form class="card p-3"><h5 class=card-title>Continue as Student</h5><div class=mb-3><label class=form-label>Your name</label><input type=text class=form-control placeholder="Enter your name"maxlength=50 autofocus></div><div class="d-flex gap-2"><button type=submit class="btn btn-primary">Continue</button></div><div class="form-text mt-2">Your name will be visible to the teacher and used to attribute your answers.`), $c21c9bfd7d6ea3c3$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="text-danger mt-1">`), $c21c9bfd7d6ea3c3$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-secondary">Use CAS instead`);
function $c21c9bfd7d6ea3c3$export$2e2bcd8739ae039(props) {
    const [_userStore, _setUserStore, userActions] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [name, setName] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(localStorage.getItem('studentName') || '');
    const [error, setError] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const allowCASFallback = ()=>props.allowCASFallback ?? true;
    const submit = (e)=>{
        e?.preventDefault();
        const trimmed = name().trim();
        if (!trimmed) {
            setError('Please enter your name');
            return;
        }
        if (trimmed.length > 50) {
            setError('Name is too long (max 50 characters)');
            return;
        }
        setError(null);
        userActions.submitExternalName(trimmed);
    };
    return (()=>{
        var _el$ = $c21c9bfd7d6ea3c3$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$3.nextSibling, _el$7 = _el$6.firstChild;
        _el$.addEventListener("submit", submit);
        _el$5.$$input = (e)=>setName(e.currentTarget.value);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$3, (()=>{
            var _c$ = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!error());
            return ()=>_c$() && (()=>{
                    var _el$8 = $c21c9bfd7d6ea3c3$var$_tmpl$2();
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, error);
                    return _el$8;
                })();
        })(), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, (()=>{
            var _c$2 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!allowCASFallback());
            return ()=>_c$2() && (()=>{
                    var _el$9 = $c21c9bfd7d6ea3c3$var$_tmpl$3();
                    _el$9.$$click = ()=>userActions.chooseCAS();
                    return _el$9;
                })();
        })(), null);
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$5.value = name());
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "input",
    "click"
]);




var $c76c7b1e9b0586b2$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<h1>Welcome`), $c76c7b1e9b0586b2$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p>Choose how you want to sign in:`), $c76c7b1e9b0586b2$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="d-flex gap-2 mt-3"><button type=button class="btn btn-primary">Sign in with CAS</button><button type=button class="btn btn-secondary">Continue as Student (no CAS)`), $c76c7b1e9b0586b2$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<h1>Welcome to the Live Quiz Platform!`), $c76c7b1e9b0586b2$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="card mt-3"style=max-width:520px><div class=card-body><h5 class=card-title>Join a Quiz</h5><form class="row g-2"><div class=col-8><input type=text class=form-control placeholder="Enter quiz code (e.g. ABC123)"pattern=[A-Z0-9]\{4,10} required></div><div class="col-4 d-grid"><button type=submit class="btn btn-primary">Join</button></div></form><div class="form-text mt-1">Your teacher will give you the quiz code.`), $c76c7b1e9b0586b2$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>`);
function $c76c7b1e9b0586b2$export$2e2bcd8739ae039() {
    const [userStore, _setUserStore, userActions] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const navigate = (0, $68cd7f618e77dd88$export$9770f232ac06a008)();
    const [joinCode, setJoinCode] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    const joinSubmit = (e)=>{
        e.preventDefault();
        const value = joinCode().trim().toUpperCase();
        if (!value) return;
        navigate(`/q/${value}`);
    };
    return (()=>{
        var _el$ = $c76c7b1e9b0586b2$var$_tmpl$6();
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return !userStore.isAuthenticated;
            },
            get children () {
                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return !userStore.isAuthenticating;
                    },
                    get fallback () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $b1a355c10f370609$export$3b0d6d7590275603), {});
                    },
                    get children () {
                        return [
                            $c76c7b1e9b0586b2$var$_tmpl$(),
                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                get when () {
                                    return userStore.authStage === 'choose-method';
                                },
                                get children () {
                                    return [
                                        $c76c7b1e9b0586b2$var$_tmpl$2(),
                                        (()=>{
                                            var _el$4 = $c76c7b1e9b0586b2$var$_tmpl$3(), _el$5 = _el$4.firstChild, _el$6 = _el$5.nextSibling;
                                            _el$5.$$click = ()=>userActions.chooseCAS();
                                            _el$6.$$click = ()=>userActions.chooseExternal();
                                            return _el$4;
                                        })()
                                    ];
                                }
                            }),
                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                get when () {
                                    return userStore.authStage === 'enter-external-name';
                                },
                                get children () {
                                    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $c21c9bfd7d6ea3c3$export$2e2bcd8739ae039), {});
                                }
                            }),
                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                get when () {
                                    return userStore.authStage === 'authenticating';
                                },
                                get children () {
                                    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $b1a355c10f370609$export$3b0d6d7590275603), {});
                                }
                            })
                        ];
                    }
                });
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return userStore.isAuthenticated;
            },
            get children () {
                return [
                    $c76c7b1e9b0586b2$var$_tmpl$4(),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return userStore.userType === 'external-student' || userStore.role !== 'admin';
                        },
                        get children () {
                            var _el$8 = $c76c7b1e9b0586b2$var$_tmpl$5(), _el$9 = _el$8.firstChild, _el$0 = _el$9.firstChild, _el$1 = _el$0.nextSibling, _el$10 = _el$1.firstChild, _el$11 = _el$10.firstChild;
                            _el$1.addEventListener("submit", joinSubmit);
                            _el$11.$$input = (e)=>setJoinCode(e.currentTarget.value.toUpperCase());
                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$11.value = joinCode());
                            return _el$8;
                        }
                    })
                ];
            }
        }), null);
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click",
    "input"
]);





var $5de580f0a4763066$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="d-flex align-items-center"><span class=me-3></span><button class="btn btn-sm btn-outline-primary">Edit`), $5de580f0a4763066$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=input-group><input type=text class=form-control placeholder="Enter your name"><button class="btn btn-success"></button><button class="btn btn-secondary">Cancel`), $5de580f0a4763066$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-warning"role=alert><strong>Note:</strong> A Client ID by itself cannot be used to recover or impersonate a student identity.`), $5de580f0a4763066$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=student-dashboard><h2>Settings</h2><div class="card mt-4"><div class=card-body><h5 class=card-title>Your Information</h5><div class=mb-3><label class=form-label><strong>Your Name:</strong></label></div><div class=mb-3><label class=form-label><strong>Client ID:</strong></label><div><code></code><small class="text-muted d-block mt-1">This public ID is stored with a separate protected identity token in your browser.</small></div></div><div class=mb-3><label class=form-label><strong>User Type:</strong></label><div><span class="badge bg-info">External Student</span></div></div></div></div><div class="card mt-4"><div class=card-body><h5 class=card-title>About External Student Access</h5><p class=card-text>You're connected as an external student. This means:</p><ul><li>You don't need to log in via CAS authentication</li><li>Your identity and its protected token are stored locally in your browser</li><li>You can participate in quizzes using quiz codes</li><li>Your name and responses are associated with your Client ID</li></ul><div class="alert alert-warning"role=alert><strong>Note:</strong> Clearing browser data removes the protected identity token and creates a new student identity.</div></div></div><div class="card mt-4"><div class=card-body><button type=button class="btn btn-primary">Logout`);
function $5de580f0a4763066$export$2e2bcd8739ae039() {
    const [userStore, _setUserStore, userActions] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [editingName, setEditingName] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [newName, setNewName] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(userStore.username || '');
    const [isSaving, setIsSaving] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const handleSaveName = ()=>{
        const name = newName().trim();
        if (!name) {
            alert('Please enter a valid name');
            return;
        }
        setIsSaving(true);
        userActions.updateStudentName(name);
        // Give some time for the update to complete
        setTimeout(()=>{
            setEditingName(false);
            setIsSaving(false);
        }, 500);
    };
    const handleCancelEdit = ()=>{
        setNewName(userStore.username || '');
        setEditingName(false);
    };
    return (()=>{
        var _el$ = $5de580f0a4763066$var$_tmpl$4(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$3.firstChild, _el$5 = _el$4.firstChild, _el$6 = _el$5.nextSibling, _el$7 = _el$6.firstChild, _el$13 = _el$6.nextSibling, _el$14 = _el$13.firstChild, _el$15 = _el$14.nextSibling, _el$16 = _el$15.firstChild, _el$17 = _el$3.nextSibling, _el$18 = _el$17.nextSibling, _el$19 = _el$18.firstChild, _el$20 = _el$19.firstChild;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return !editingName();
            },
            get children () {
                var _el$8 = $5de580f0a4763066$var$_tmpl$(), _el$9 = _el$8.firstChild, _el$0 = _el$9.nextSibling;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, ()=>userStore.username);
                _el$0.$$click = ()=>setEditingName(true);
                return _el$8;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return editingName();
            },
            get children () {
                var _el$1 = $5de580f0a4763066$var$_tmpl$2(), _el$10 = _el$1.firstChild, _el$11 = _el$10.nextSibling, _el$12 = _el$11.nextSibling;
                _el$10.$$input = (e)=>setNewName(e.currentTarget.value);
                _el$11.$$click = handleSaveName;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$11, ()=>isSaving() ? 'Saving...' : 'Save');
                _el$12.$$click = handleCancelEdit;
                (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                    var _v$ = isSaving(), _v$2 = isSaving(), _v$3 = isSaving();
                    _v$ !== _p$.e && (_el$10.disabled = _p$.e = _v$);
                    _v$2 !== _p$.t && (_el$11.disabled = _p$.t = _v$2);
                    _v$3 !== _p$.a && (_el$12.disabled = _p$.a = _v$3);
                    return _p$;
                }, {
                    e: undefined,
                    t: undefined,
                    a: undefined
                });
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$10.value = newName());
                return _el$1;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$16, ()=>userStore.clientId);
        _el$20.$$click = ()=>{
            localStorage.removeItem('jwt');
            location.reload();
        };
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$19, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return userStore.clientId;
            },
            get children () {
                return $5de580f0a4763066$var$_tmpl$3();
            }
        }), null);
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click",
    "input"
]);








const $059fd204a72364ff$var$defaultStore = {
    users: [],
    results: false,
    resultsFetching: false
};
const $059fd204a72364ff$var$AdminContext = (0, $8863cd8fe199f948$export$fd42f52fd3ae1109)();
function $059fd204a72364ff$export$66cafb854a568b29(props) {
    const [adminStore, setAdminStore] = (0, $caa70d287a6ddb62$export$f51a9068ac82ea43)($059fd204a72364ff$var$defaultStore);
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        console.log('Mounted AdminContext');
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("user-list", (users)=>{
            setAdminStore({
                users: users
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('results', (results)=>{
            setAdminStore({
                results: results,
                resultsFetching: false
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('user-operation-error', (data)=>{
            alert(data.error || 'User operation failed');
        });
    });
    const actions = {
        editUser: (index)=>{
            const user = adminStore.users[index];
            const fields = {
                role: user.roleInput,
                email: user.emailInput
            };
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('update-user', {
                id: user.id,
                fields: fields
            });
            setAdminStore('users', index, 'editing', false);
        },
        deleteUser: (user_id)=>{
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('delete-user', user_id);
            setAdminStore('users', (u)=>u.filter((user)=>user.id !== user_id));
        },
        addUser: (fields)=>{
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('add-user', fields);
        }
    };
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($059fd204a72364ff$var$AdminContext.Provider, {
        value: [
            adminStore,
            setAdminStore,
            actions
        ],
        get children () {
            return props.children;
        }
    });
}
function $059fd204a72364ff$export$b3189d039b00bb0c() {
    return (0, $8863cd8fe199f948$export$fae74005e78b1a27)($059fd204a72364ff$var$AdminContext);
}


var $dd67cc782607ead6$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><button type=button class="btn btn btn-primary btn-sm">Add User`), $dd67cc782607ead6$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<table class="table table-striped table-hover"><thead><tr><th scope=col>Id</th><th scope=col>Username</th><th scope=col>Full name</th><th scope=col>Email</th><th scope=col>Role</th><th scope=col>Auth</th><th scope=col>Actions</th></tr></thead><tbody>`), $dd67cc782607ead6$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<input class=form-control>`), $dd67cc782607ead6$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn btn-outline-primary btn-sm">save`), $dd67cc782607ead6$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn btn-outline-info btn-sm">edit`), $dd67cc782607ead6$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td scope=row></td><td></td><td></td><td></td><td></td><td></td><td> <button type=button class="btn btn btn-outline-danger btn-sm">delete`);
var $dd67cc782607ead6$export$2e2bcd8739ae039 = ()=>{
    const [adminStore, setAdminStore, actions] = (0, $059fd204a72364ff$export$b3189d039b00bb0c)();
    const { editUser: editUser, deleteUser: deleteUser, addUser: addUser } = actions;
    //console.log(adminStore, setAdminStore);
    return [
        (()=>{
            var _el$ = $dd67cc782607ead6$var$_tmpl$(), _el$2 = _el$.firstChild;
            _el$2.$$click = ()=>{
                const username = prompt("username", "");
                addUser({
                    username: username,
                    role: 'student'
                });
            };
            return _el$;
        })(),
        (()=>{
            var _el$3 = $dd67cc782607ead6$var$_tmpl$2(), _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling;
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                get each () {
                    return adminStore.users;
                },
                children: (user, index)=>(()=>{
                        var _el$6 = $dd67cc782607ead6$var$_tmpl$6(), _el$7 = _el$6.firstChild, _el$8 = _el$7.nextSibling, _el$9 = _el$8.nextSibling, _el$0 = _el$9.nextSibling, _el$10 = _el$0.nextSibling, _el$12 = _el$10.nextSibling, _el$13 = _el$12.nextSibling, _el$16 = _el$13.firstChild, _el$17 = _el$16.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, ()=>user.id);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, ()=>user.username);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, ()=>user.fullName || '');
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$0, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return user.editing;
                            },
                            get fallback () {
                                return user.email;
                            },
                            get children () {
                                var _el$1 = $dd67cc782607ead6$var$_tmpl$3();
                                _el$1.$$input = (e)=>setAdminStore('users', index(), {
                                        emailInput: e.target.value
                                    });
                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$1.value = user.emailInput || '');
                                return _el$1;
                            }
                        }));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return user.editing;
                            },
                            get fallback () {
                                return user.role;
                            },
                            get children () {
                                var _el$11 = $dd67cc782607ead6$var$_tmpl$3();
                                _el$11.$$input = (e)=>setAdminStore('users', index(), {
                                        roleInput: e.target.value
                                    });
                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$11.value = user.roleInput || '');
                                return _el$11;
                            }
                        }));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$12, ()=>user.authType);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return user.editing;
                            },
                            get children () {
                                var _el$14 = $dd67cc782607ead6$var$_tmpl$4();
                                _el$14.$$click = ()=>editUser(index());
                                return _el$14;
                            }
                        }), _el$16);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return !user.editing;
                            },
                            get children () {
                                var _el$15 = $dd67cc782607ead6$var$_tmpl$5();
                                _el$15.$$click = ()=>setAdminStore('users', index(), {
                                        editing: true,
                                        roleInput: user.role
                                    });
                                return _el$15;
                            }
                        }), _el$16);
                        _el$17.$$click = ()=>{
                            if (confirm('Confirm deletion')) deleteUser(user.id);
                        };
                        return _el$6;
                    })()
            }));
            return _el$3;
        })()
    ];
};
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click",
    "input"
]);









const $69ccc3a2d8e0157f$var$QuizContext = (0, $8863cd8fe199f948$export$fd42f52fd3ae1109)();
function $69ccc3a2d8e0157f$export$bacd9ee556842089(props) {
    const [quizStore, setQuizStore] = (0, $caa70d287a6ddb62$export$f51a9068ac82ea43)({
        quizzes: [],
        loading: false
    });
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        console.log('Mounted QuizContext');
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("quiz-list", (quizzes)=>{
            setQuizStore({
                quizzes: quizzes,
                loading: false
            });
        });
    });
    const runOperation = (event, data)=>new Promise((resolve, reject)=>{
            const send = (attempt)=>{
                (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).timeout(8000).emit(event, data, (timeoutError, result)=>{
                    if (timeoutError && attempt === 0 && event === 'create-quiz') {
                        send(1); // The same request ID makes a create retry safe.
                        return;
                    }
                    if (timeoutError) {
                        setQuizStore({
                            loading: false
                        });
                        reject(new Error('The server did not acknowledge the operation'));
                        return;
                    }
                    if (!result?.ok) {
                        setQuizStore({
                            loading: false
                        });
                        reject(new Error(result?.error || 'Operation failed'));
                        return;
                    }
                    resolve({
                        quizId: result.quizId
                    });
                });
            };
            send(0);
        });
    const actions = {
        createQuiz: (fields)=>{
            setQuizStore({
                loading: true
            });
            return runOperation('create-quiz', {
                ...fields,
                requestId: crypto.randomUUID().replaceAll('-', '')
            });
        },
        updateQuiz: (id, fields)=>{
            setQuizStore({
                loading: true
            });
            return runOperation('update-quiz', {
                id: id,
                fields: fields
            });
        },
        deleteQuiz: (id)=>{
            if (confirm('Are you sure you want to permanently delete this quiz? This cannot be undone.')) {
                setQuizStore({
                    loading: true
                });
                return runOperation('delete-quiz', id);
            }
            return Promise.resolve();
        },
        archiveQuiz: (id)=>{
            setQuizStore({
                loading: true
            });
            return runOperation('archive-quiz', id);
        },
        unarchiveQuiz: (id)=>{
            setQuizStore({
                loading: true
            });
            return runOperation('unarchive-quiz', id);
        },
        markQuizDeleted: (id)=>{
            if (confirm('Are you sure you want to delete this quiz? You can recover it later.')) {
                setQuizStore({
                    loading: true
                });
                return runOperation('mark-quiz-deleted', id);
            }
            return Promise.resolve();
        },
        downloadCSV: (quizId, quizTitle)=>{
            return new Promise((resolve, reject)=>{
                const handleCSV = (data)=>{
                    // Create a blob and download it
                    const blob = new Blob([
                        data.csv
                    ], {
                        type: 'text/csv;charset=utf-8;'
                    });
                    const link = document.createElement('a');
                    const url = URL.createObjectURL(blob);
                    const fileName = (data.quizTitle || quizTitle).replace(/[^a-z0-9]/gi, '_');
                    link.setAttribute('href', url);
                    link.setAttribute('download', `${fileName}_results.csv`);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('quiz-results-csv', handleCSV);
                    (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('quiz-results-csv-error', handleError);
                    resolve();
                };
                const handleError = (data)=>{
                    (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('quiz-results-csv', handleCSV);
                    (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('quiz-results-csv-error', handleError);
                    reject(new Error(data.error));
                };
                (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('quiz-results-csv', handleCSV);
                (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('quiz-results-csv-error', handleError);
                (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('get-quiz-results-csv', {
                    quizId: quizId
                });
            });
        }
    };
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($69ccc3a2d8e0157f$var$QuizContext.Provider, {
        value: [
            quizStore,
            setQuizStore,
            actions
        ],
        get children () {
            return props.children;
        }
    });
}
function $69ccc3a2d8e0157f$export$3467042c26dd6dce() {
    return (0, $8863cd8fe199f948$export$fae74005e78b1a27)($69ccc3a2d8e0157f$var$QuizContext);
}


var $0fa86f4b51f343a5$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=spinner-border role=status><span class=visually-hidden>Loading...`), $0fa86f4b51f343a5$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info">`), $0fa86f4b51f343a5$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><div class="d-flex justify-content-between align-items-center mb-3"><h2>Manage Quizzes</h2><div><button type=button> Archived</button><button type=button> Deleted</button><button type=button class="btn btn-primary">Create New Quiz</button></div></div><table class="table table-striped table-hover"><thead><tr><th scope=col>Quiz Code</th><th scope=col>Title</th><th scope=col>State</th><th scope=col>Updated</th><th scope=col>Actions</th></tr></thead><tbody>`), $0fa86f4b51f343a5$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-sm btn-outline-info me-2"title="Download quiz results as CSV">CSV`), $0fa86f4b51f343a5$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-sm btn-outline-success me-2">Unarchive`), $0fa86f4b51f343a5$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-sm btn-outline-warning me-2">Archive`), $0fa86f4b51f343a5$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-sm btn-outline-danger">Delete`), $0fa86f4b51f343a5$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-sm btn-outline-danger">Delete Forever`), $0fa86f4b51f343a5$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td><code></code></td><td></td><td><span></span></td><td></td><td>`), $0fa86f4b51f343a5$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span>No quizzes match the current filters.`);
function $0fa86f4b51f343a5$export$2e2bcd8739ae039() {
    const [quizStore, _setQuizStore, quizActions] = (0, $69ccc3a2d8e0157f$export$3467042c26dd6dce)();
    const [showArchived, setShowArchived] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [showDeleted, setShowDeleted] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const filteredQuizzes = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        return quizStore.quizzes.filter((quiz)=>{
            if (quiz.state === 'archived' && !showArchived()) return false;
            if (quiz.state === 'deleted' && !showDeleted()) return false;
            return true;
        });
    });
    const handleCreate = async ()=>{
        const title = prompt("Quiz title:");
        if (!title?.trim()) return;
        const defaultMarkdown = `# Question 1

What is the capital of France?

:choice:
- London
X Paris
- Berlin

---

# Question 2

Select all that apply:

:choices:
- Option A
X Option B
X Option C
- Option D`;
        try {
            await quizActions.createQuiz({
                title: title.trim(),
                markdown: defaultMarkdown,
                state: 'hidden'
            });
        } catch (error) {
            alert('Error creating quiz: ' + (error.message || 'Unknown error'));
        }
    };
    const runQuizAction = async (operation)=>{
        try {
            await operation;
        } catch (error) {
            alert('Quiz operation failed: ' + (error.message || 'Unknown error'));
        }
    };
    const handleDownloadCSV = async (quiz)=>{
        try {
            await quizActions.downloadCSV(quiz.id, quiz.title);
        } catch (error) {
            alert('Error downloading CSV: ' + (error.message || 'Unknown error'));
        }
    };
    return (()=>{
        var _el$ = $0fa86f4b51f343a5$var$_tmpl$3(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$3.nextSibling, _el$5 = _el$4.firstChild, _el$6 = _el$5.firstChild, _el$7 = _el$5.nextSibling, _el$8 = _el$7.firstChild, _el$9 = _el$7.nextSibling, _el$1 = _el$2.nextSibling, _el$10 = _el$1.firstChild, _el$11 = _el$10.nextSibling;
        _el$5.$$click = ()=>setShowArchived(!showArchived());
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, ()=>showArchived() ? 'Hide' : 'Show', _el$6);
        _el$7.$$click = ()=>setShowDeleted(!showDeleted());
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, ()=>showDeleted() ? 'Hide' : 'Show', _el$8);
        _el$9.$$click = handleCreate;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return quizStore.loading;
            },
            get children () {
                return $0fa86f4b51f343a5$var$_tmpl$();
            }
        }), _el$1);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$11, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
            get each () {
                return filteredQuizzes();
            },
            children: (quiz)=>(()=>{
                    var _el$13 = $0fa86f4b51f343a5$var$_tmpl$9(), _el$14 = _el$13.firstChild, _el$15 = _el$14.firstChild, _el$16 = _el$14.nextSibling, _el$17 = _el$16.nextSibling, _el$18 = _el$17.firstChild, _el$19 = _el$17.nextSibling, _el$20 = _el$19.nextSibling;
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$15, ()=>quiz.quizId);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$16, ()=>quiz.title);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$18, ()=>quiz.state);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$19, ()=>new Date(quiz.updatedAt).toLocaleDateString());
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return quiz.state !== 'deleted';
                        },
                        get children () {
                            return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$ebd11618f299a286), {
                                get href () {
                                    return `/quiz/${quiz.id}/edit`;
                                },
                                "class": "btn btn-sm btn-outline-primary me-2",
                                children: "Edit"
                            });
                        }
                    }), null);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>quiz.state !== 'archived')() && quiz.state !== 'deleted';
                        },
                        get children () {
                            return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$ebd11618f299a286), {
                                get href () {
                                    return `/admin/live/${quiz.id}`;
                                },
                                "class": "btn btn-sm btn-outline-success me-2",
                                children: "Go Live"
                            });
                        }
                    }), null);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return quiz.state !== 'deleted';
                        },
                        get children () {
                            var _el$21 = $0fa86f4b51f343a5$var$_tmpl$4();
                            _el$21.$$click = ()=>handleDownloadCSV(quiz);
                            return _el$21;
                        }
                    }), null);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return quiz.state === 'archived';
                        },
                        get children () {
                            var _el$22 = $0fa86f4b51f343a5$var$_tmpl$5();
                            _el$22.$$click = ()=>runQuizAction(quizActions.unarchiveQuiz(quiz.id));
                            return _el$22;
                        }
                    }), null);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>quiz.state !== 'archived')() && quiz.state !== 'deleted';
                        },
                        get children () {
                            var _el$23 = $0fa86f4b51f343a5$var$_tmpl$6();
                            _el$23.$$click = ()=>runQuizAction(quizActions.archiveQuiz(quiz.id));
                            return _el$23;
                        }
                    }), null);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return quiz.state !== 'deleted';
                        },
                        get children () {
                            var _el$24 = $0fa86f4b51f343a5$var$_tmpl$7();
                            _el$24.$$click = ()=>runQuizAction(quizActions.markQuizDeleted(quiz.id));
                            return _el$24;
                        }
                    }), null);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return quiz.state === 'deleted';
                        },
                        get children () {
                            var _el$25 = $0fa86f4b51f343a5$var$_tmpl$8();
                            _el$25.$$click = ()=>runQuizAction(quizActions.deleteQuiz(quiz.id));
                            return _el$25;
                        }
                    }), null);
                    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$18, `badge bg-${quiz.state === 'visible' ? 'success' : quiz.state === 'hidden' ? 'secondary' : quiz.state === 'archived' ? 'warning' : 'danger'}`));
                    return _el$13;
                })()
        }));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>filteredQuizzes().length === 0)() && !quizStore.loading;
            },
            get children () {
                var _el$12 = $0fa86f4b51f343a5$var$_tmpl$2();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$12, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return quizStore.quizzes.length === 0;
                    },
                    get fallback () {
                        return $0fa86f4b51f343a5$var$_tmpl$0();
                    },
                    children: "No quizzes yet. Click \"Create New Quiz\" to get started."
                }));
                return _el$12;
            }
        }), null);
        (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
            var _v$ = `btn btn-sm me-2 ${showArchived() ? 'btn-warning' : 'btn-outline-warning'}`, _v$2 = `btn btn-sm me-2 ${showDeleted() ? 'btn-danger' : 'btn-outline-danger'}`, _v$3 = quizStore.loading;
            _v$ !== _p$.e && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$5, _p$.e = _v$);
            _v$2 !== _p$.t && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$7, _p$.t = _v$2);
            _v$3 !== _p$.a && (_el$9.disabled = _p$.a = _v$3);
            return _p$;
        }, {
            e: undefined,
            t: undefined,
            a: undefined
        });
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);








/**
 * marked v17.0.6 - a markdown parser
 * Copyright (c) 2018-2026, MarkedJS. (MIT License)
 * Copyright (c) 2011-2018, Christopher Jeffrey. (MIT License)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ function $42cbc74a64ab0a8d$export$212bb2fc580a90a8() {
    return {
        async: !1,
        breaks: !1,
        extensions: null,
        gfm: !0,
        hooks: null,
        pedantic: !1,
        renderer: null,
        silent: !1,
        tokenizer: null,
        walkTokens: null
    };
}
var $42cbc74a64ab0a8d$export$ebe90cb607ad99e = $42cbc74a64ab0a8d$export$212bb2fc580a90a8();
function $42cbc74a64ab0a8d$var$G(u) {
    $42cbc74a64ab0a8d$export$ebe90cb607ad99e = u;
}
var $42cbc74a64ab0a8d$var$_ = {
    exec: ()=>null
};
function $42cbc74a64ab0a8d$var$k(u, e = "") {
    let t = typeof u == "string" ? u : u.source, n = {
        replace: (r, i)=>{
            let s = typeof i == "string" ? i : i.source;
            return s = s.replace($42cbc74a64ab0a8d$var$m.caret, "$1"), t = t.replace(r, s), n;
        },
        getRegex: ()=>new RegExp(t, e)
    };
    return n;
}
var $42cbc74a64ab0a8d$var$be = (()=>{
    try {
        return new RegExp("(?<=1)(?<!1)"), true;
    } catch  {
        return !1;
    }
})(), $42cbc74a64ab0a8d$var$m = {
    codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
    outputLinkReplace: /\\([\[\]])/g,
    indentCodeCompensation: /^(\s+)(?:```)/,
    beginningSpace: /^\s+/,
    endingHash: /#$/,
    startingSpaceChar: /^ /,
    endingSpaceChar: / $/,
    nonSpaceChar: /[^ ]/,
    newLineCharGlobal: /\n/g,
    tabCharGlobal: /\t/g,
    multipleSpaceGlobal: /\s+/g,
    blankLine: /^[ \t]*$/,
    doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
    blockquoteStart: /^ {0,3}>/,
    blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
    blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
    listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
    listIsTask: /^\[[ xX]\] +\S/,
    listReplaceTask: /^\[[ xX]\] +/,
    listTaskCheckbox: /\[[ xX]\]/,
    anyLine: /\n.*\n/,
    hrefBrackets: /^<(.*)>$/,
    tableDelimiter: /[:|]/,
    tableAlignChars: /^\||\| *$/g,
    tableRowBlankLine: /\n[ \t]*$/,
    tableAlignRight: /^ *-+: *$/,
    tableAlignCenter: /^ *:-+: *$/,
    tableAlignLeft: /^ *:-+ *$/,
    startATag: /^<a /i,
    endATag: /^<\/a>/i,
    startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
    endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
    startAngleBracket: /^</,
    endAngleBracket: />$/,
    pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
    unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
    escapeTest: /[&<>"']/,
    escapeReplace: /[&<>"']/g,
    escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
    escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
    caret: /(^|[^\[])\^/g,
    percentDecode: /%25/g,
    findPipe: /\|/g,
    splitPipe: / \|/,
    slashPipe: /\\\|/g,
    carriageReturn: /\r\n|\r/g,
    spaceLine: /^ +$/gm,
    notSpaceStart: /^\S*/,
    endingNewline: /\n$/,
    listItemRegex: (u)=>new RegExp(`^( {0,3}${u})((?:[	 ][^\\n]*)?(?:\\n|$))`),
    nextBulletRegex: (u)=>new RegExp(`^ {0,${Math.min(3, u - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
    hrRegex: (u)=>new RegExp(`^ {0,${Math.min(3, u - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
    fencesBeginRegex: (u)=>new RegExp(`^ {0,${Math.min(3, u - 1)}}(?:\`\`\`|~~~)`),
    headingBeginRegex: (u)=>new RegExp(`^ {0,${Math.min(3, u - 1)}}#`),
    htmlBeginRegex: (u)=>new RegExp(`^ {0,${Math.min(3, u - 1)}}<(?:[a-z].*>|!--)`, "i"),
    blockquoteBeginRegex: (u)=>new RegExp(`^ {0,${Math.min(3, u - 1)}}>`)
}, $42cbc74a64ab0a8d$var$Re = /^(?:[ \t]*(?:\n|$))+/, $42cbc74a64ab0a8d$var$Oe = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, $42cbc74a64ab0a8d$var$Te = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, $42cbc74a64ab0a8d$var$C = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, $42cbc74a64ab0a8d$var$we = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, $42cbc74a64ab0a8d$var$Q = / {0,3}(?:[*+-]|\d{1,9}[.)])/, $42cbc74a64ab0a8d$var$se = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, $42cbc74a64ab0a8d$var$ie = $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$se).replace(/bull/g, $42cbc74a64ab0a8d$var$Q).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), $42cbc74a64ab0a8d$var$ye = $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$se).replace(/bull/g, $42cbc74a64ab0a8d$var$Q).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), $42cbc74a64ab0a8d$var$j = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, $42cbc74a64ab0a8d$var$Pe = /^[^\n]+/, $42cbc74a64ab0a8d$var$F = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, $42cbc74a64ab0a8d$var$Se = $42cbc74a64ab0a8d$var$k(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", $42cbc74a64ab0a8d$var$F).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), $42cbc74a64ab0a8d$var$$e = $42cbc74a64ab0a8d$var$k(/^(bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, $42cbc74a64ab0a8d$var$Q).getRegex(), $42cbc74a64ab0a8d$var$v = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", $42cbc74a64ab0a8d$var$U = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, $42cbc74a64ab0a8d$var$_e = $42cbc74a64ab0a8d$var$k("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", $42cbc74a64ab0a8d$var$U).replace("tag", $42cbc74a64ab0a8d$var$v).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), $42cbc74a64ab0a8d$var$oe = $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$j).replace("hr", $42cbc74a64ab0a8d$var$C).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $42cbc74a64ab0a8d$var$v).getRegex(), $42cbc74a64ab0a8d$var$Le = $42cbc74a64ab0a8d$var$k(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", $42cbc74a64ab0a8d$var$oe).getRegex(), $42cbc74a64ab0a8d$var$K = {
    blockquote: $42cbc74a64ab0a8d$var$Le,
    code: $42cbc74a64ab0a8d$var$Oe,
    def: $42cbc74a64ab0a8d$var$Se,
    fences: $42cbc74a64ab0a8d$var$Te,
    heading: $42cbc74a64ab0a8d$var$we,
    hr: $42cbc74a64ab0a8d$var$C,
    html: $42cbc74a64ab0a8d$var$_e,
    lheading: $42cbc74a64ab0a8d$var$ie,
    list: $42cbc74a64ab0a8d$var$$e,
    newline: $42cbc74a64ab0a8d$var$Re,
    paragraph: $42cbc74a64ab0a8d$var$oe,
    table: $42cbc74a64ab0a8d$var$_,
    text: $42cbc74a64ab0a8d$var$Pe
}, $42cbc74a64ab0a8d$var$ne = $42cbc74a64ab0a8d$var$k("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", $42cbc74a64ab0a8d$var$C).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $42cbc74a64ab0a8d$var$v).getRegex(), $42cbc74a64ab0a8d$var$Me = {
    ...$42cbc74a64ab0a8d$var$K,
    lheading: $42cbc74a64ab0a8d$var$ye,
    table: $42cbc74a64ab0a8d$var$ne,
    paragraph: $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$j).replace("hr", $42cbc74a64ab0a8d$var$C).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", $42cbc74a64ab0a8d$var$ne).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $42cbc74a64ab0a8d$var$v).getRegex()
}, $42cbc74a64ab0a8d$var$ze = {
    ...$42cbc74a64ab0a8d$var$K,
    html: $42cbc74a64ab0a8d$var$k(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", $42cbc74a64ab0a8d$var$U).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: $42cbc74a64ab0a8d$var$_,
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$j).replace("hr", $42cbc74a64ab0a8d$var$C).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", $42cbc74a64ab0a8d$var$ie).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, $42cbc74a64ab0a8d$var$Ee = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, $42cbc74a64ab0a8d$var$Ie = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, $42cbc74a64ab0a8d$var$ae = /^( {2,}|\\)\n(?!\s*$)/, $42cbc74a64ab0a8d$var$Ae = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, $42cbc74a64ab0a8d$var$z = /[\p{P}\p{S}]/u, $42cbc74a64ab0a8d$var$H = /[\s\p{P}\p{S}]/u, $42cbc74a64ab0a8d$var$W = /[^\s\p{P}\p{S}]/u, $42cbc74a64ab0a8d$var$Ce = $42cbc74a64ab0a8d$var$k(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, $42cbc74a64ab0a8d$var$H).getRegex(), $42cbc74a64ab0a8d$var$le = /(?!~)[\p{P}\p{S}]/u, $42cbc74a64ab0a8d$var$Be = /(?!~)[\s\p{P}\p{S}]/u, $42cbc74a64ab0a8d$var$De = /(?:[^\s\p{P}\p{S}]|~)/u, $42cbc74a64ab0a8d$var$qe = $42cbc74a64ab0a8d$var$k(/link|precode-code|html/, "g").replace("link", /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace("precode-", $42cbc74a64ab0a8d$var$be ? "(?<!`)()" : "(^^|[^`])").replace("code", /(?<b>`+)[^`]+\k<b>(?!`)/).replace("html", /<(?! )[^<>]*?>/).getRegex(), $42cbc74a64ab0a8d$var$ue = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, $42cbc74a64ab0a8d$var$ve = $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$ue, "u").replace(/punct/g, $42cbc74a64ab0a8d$var$z).getRegex(), $42cbc74a64ab0a8d$var$He = $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$ue, "u").replace(/punct/g, $42cbc74a64ab0a8d$var$le).getRegex(), $42cbc74a64ab0a8d$var$pe = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", $42cbc74a64ab0a8d$var$Ze = $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$pe, "gu").replace(/notPunctSpace/g, $42cbc74a64ab0a8d$var$W).replace(/punctSpace/g, $42cbc74a64ab0a8d$var$H).replace(/punct/g, $42cbc74a64ab0a8d$var$z).getRegex(), $42cbc74a64ab0a8d$var$Ge = $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$pe, "gu").replace(/notPunctSpace/g, $42cbc74a64ab0a8d$var$De).replace(/punctSpace/g, $42cbc74a64ab0a8d$var$Be).replace(/punct/g, $42cbc74a64ab0a8d$var$le).getRegex(), $42cbc74a64ab0a8d$var$Ne = $42cbc74a64ab0a8d$var$k("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, $42cbc74a64ab0a8d$var$W).replace(/punctSpace/g, $42cbc74a64ab0a8d$var$H).replace(/punct/g, $42cbc74a64ab0a8d$var$z).getRegex(), $42cbc74a64ab0a8d$var$Qe = $42cbc74a64ab0a8d$var$k(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, $42cbc74a64ab0a8d$var$z).getRegex(), $42cbc74a64ab0a8d$var$je = "^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", $42cbc74a64ab0a8d$var$Fe = $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$je, "gu").replace(/notPunctSpace/g, $42cbc74a64ab0a8d$var$W).replace(/punctSpace/g, $42cbc74a64ab0a8d$var$H).replace(/punct/g, $42cbc74a64ab0a8d$var$z).getRegex(), $42cbc74a64ab0a8d$var$Ue = $42cbc74a64ab0a8d$var$k(/\\(punct)/, "gu").replace(/punct/g, $42cbc74a64ab0a8d$var$z).getRegex(), $42cbc74a64ab0a8d$var$Ke = $42cbc74a64ab0a8d$var$k(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), $42cbc74a64ab0a8d$var$We = $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$U).replace("(?:-->|$)", "-->").getRegex(), $42cbc74a64ab0a8d$var$Xe = $42cbc74a64ab0a8d$var$k("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", $42cbc74a64ab0a8d$var$We).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), $42cbc74a64ab0a8d$var$q = /(?:\[(?:\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/, $42cbc74a64ab0a8d$var$Je = $42cbc74a64ab0a8d$var$k(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?\s*\)/).replace("label", $42cbc74a64ab0a8d$var$q).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), $42cbc74a64ab0a8d$var$ce = $42cbc74a64ab0a8d$var$k(/^!?\[(label)\]\[(ref)\]/).replace("label", $42cbc74a64ab0a8d$var$q).replace("ref", $42cbc74a64ab0a8d$var$F).getRegex(), $42cbc74a64ab0a8d$var$he = $42cbc74a64ab0a8d$var$k(/^!?\[(ref)\](?:\[\])?/).replace("ref", $42cbc74a64ab0a8d$var$F).getRegex(), $42cbc74a64ab0a8d$var$Ve = $42cbc74a64ab0a8d$var$k("reflink|nolink(?!\\()", "g").replace("reflink", $42cbc74a64ab0a8d$var$ce).replace("nolink", $42cbc74a64ab0a8d$var$he).getRegex(), $42cbc74a64ab0a8d$var$re = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, $42cbc74a64ab0a8d$var$X = {
    _backpedal: $42cbc74a64ab0a8d$var$_,
    anyPunctuation: $42cbc74a64ab0a8d$var$Ue,
    autolink: $42cbc74a64ab0a8d$var$Ke,
    blockSkip: $42cbc74a64ab0a8d$var$qe,
    br: $42cbc74a64ab0a8d$var$ae,
    code: $42cbc74a64ab0a8d$var$Ie,
    del: $42cbc74a64ab0a8d$var$_,
    delLDelim: $42cbc74a64ab0a8d$var$_,
    delRDelim: $42cbc74a64ab0a8d$var$_,
    emStrongLDelim: $42cbc74a64ab0a8d$var$ve,
    emStrongRDelimAst: $42cbc74a64ab0a8d$var$Ze,
    emStrongRDelimUnd: $42cbc74a64ab0a8d$var$Ne,
    escape: $42cbc74a64ab0a8d$var$Ee,
    link: $42cbc74a64ab0a8d$var$Je,
    nolink: $42cbc74a64ab0a8d$var$he,
    punctuation: $42cbc74a64ab0a8d$var$Ce,
    reflink: $42cbc74a64ab0a8d$var$ce,
    reflinkSearch: $42cbc74a64ab0a8d$var$Ve,
    tag: $42cbc74a64ab0a8d$var$Xe,
    text: $42cbc74a64ab0a8d$var$Ae,
    url: $42cbc74a64ab0a8d$var$_
}, $42cbc74a64ab0a8d$var$Ye = {
    ...$42cbc74a64ab0a8d$var$X,
    link: $42cbc74a64ab0a8d$var$k(/^!?\[(label)\]\((.*?)\)/).replace("label", $42cbc74a64ab0a8d$var$q).getRegex(),
    reflink: $42cbc74a64ab0a8d$var$k(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", $42cbc74a64ab0a8d$var$q).getRegex()
}, $42cbc74a64ab0a8d$var$N = {
    ...$42cbc74a64ab0a8d$var$X,
    emStrongRDelimAst: $42cbc74a64ab0a8d$var$Ge,
    emStrongLDelim: $42cbc74a64ab0a8d$var$He,
    delLDelim: $42cbc74a64ab0a8d$var$Qe,
    delRDelim: $42cbc74a64ab0a8d$var$Fe,
    url: $42cbc74a64ab0a8d$var$k(/^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("protocol", $42cbc74a64ab0a8d$var$re).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
    text: $42cbc74a64ab0a8d$var$k(/^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/).replace("protocol", $42cbc74a64ab0a8d$var$re).getRegex()
}, $42cbc74a64ab0a8d$var$et = {
    ...$42cbc74a64ab0a8d$var$N,
    br: $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$ae).replace("{2,}", "*").getRegex(),
    text: $42cbc74a64ab0a8d$var$k($42cbc74a64ab0a8d$var$N.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, $42cbc74a64ab0a8d$var$B = {
    normal: $42cbc74a64ab0a8d$var$K,
    gfm: $42cbc74a64ab0a8d$var$Me,
    pedantic: $42cbc74a64ab0a8d$var$ze
}, $42cbc74a64ab0a8d$var$E = {
    normal: $42cbc74a64ab0a8d$var$X,
    gfm: $42cbc74a64ab0a8d$var$N,
    breaks: $42cbc74a64ab0a8d$var$et,
    pedantic: $42cbc74a64ab0a8d$var$Ye
};
var $42cbc74a64ab0a8d$var$tt = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
}, $42cbc74a64ab0a8d$var$ke = (u)=>$42cbc74a64ab0a8d$var$tt[u];
function $42cbc74a64ab0a8d$var$T(u, e) {
    if (e) {
        if ($42cbc74a64ab0a8d$var$m.escapeTest.test(u)) return u.replace($42cbc74a64ab0a8d$var$m.escapeReplace, $42cbc74a64ab0a8d$var$ke);
    } else if ($42cbc74a64ab0a8d$var$m.escapeTestNoEncode.test(u)) return u.replace($42cbc74a64ab0a8d$var$m.escapeReplaceNoEncode, $42cbc74a64ab0a8d$var$ke);
    return u;
}
function $42cbc74a64ab0a8d$var$J(u) {
    try {
        u = encodeURI(u).replace($42cbc74a64ab0a8d$var$m.percentDecode, "%");
    } catch  {
        return null;
    }
    return u;
}
function $42cbc74a64ab0a8d$var$V(u, e) {
    let t = u.replace($42cbc74a64ab0a8d$var$m.findPipe, (i, s, a)=>{
        let o = !1, l = s;
        for(; --l >= 0 && a[l] === "\\";)o = !o;
        return o ? "|" : " |";
    }), n = t.split($42cbc74a64ab0a8d$var$m.splitPipe), r = 0;
    if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), e) {
        if (n.length > e) n.splice(e);
        else for(; n.length < e;)n.push("");
    }
    for(; r < n.length; r++)n[r] = n[r].trim().replace($42cbc74a64ab0a8d$var$m.slashPipe, "|");
    return n;
}
function $42cbc74a64ab0a8d$var$I(u, e, t) {
    let n = u.length;
    if (n === 0) return "";
    let r = 0;
    for(; r < n;){
        let i = u.charAt(n - r - 1);
        if (i === e && !t) r++;
        else if (i !== e && t) r++;
        else break;
    }
    return u.slice(0, n - r);
}
function $42cbc74a64ab0a8d$var$de(u, e) {
    if (u.indexOf(e[1]) === -1) return -1;
    let t = 0;
    for(let n = 0; n < u.length; n++)if (u[n] === "\\") n++;
    else if (u[n] === e[0]) t++;
    else if (u[n] === e[1] && (t--, t < 0)) return n;
    return t > 0 ? -2 : -1;
}
function $42cbc74a64ab0a8d$var$ge(u, e = 0) {
    let t = e, n = "";
    for (let r of u)if (r === "	") {
        let i = 4 - t % 4;
        n += " ".repeat(i), t += i;
    } else n += r, t++;
    return n;
}
function $42cbc74a64ab0a8d$var$fe(u, e, t, n, r) {
    let i = e.href, s = e.title || null, a = u[1].replace(r.other.outputLinkReplace, "$1");
    n.state.inLink = !0;
    let o = {
        type: u[0].charAt(0) === "!" ? "image" : "link",
        raw: t,
        href: i,
        title: s,
        text: a,
        tokens: n.inlineTokens(a)
    };
    return n.state.inLink = !1, o;
}
function $42cbc74a64ab0a8d$var$nt(u, e, t) {
    let n = u.match(t.other.indentCodeCompensation);
    if (n === null) return e;
    let r = n[1];
    return e.split(`
`).map((i)=>{
        let s = i.match(t.other.beginningSpace);
        if (s === null) return i;
        let [a] = s;
        return a.length >= r.length ? i.slice(r.length) : i;
    }).join(`
`);
}
var $42cbc74a64ab0a8d$export$55e8b082af4aa63e = class {
    options;
    rules;
    lexer;
    constructor(e){
        this.options = e || $42cbc74a64ab0a8d$export$ebe90cb607ad99e;
    }
    space(e) {
        let t = this.rules.block.newline.exec(e);
        if (t && t[0].length > 0) return {
            type: "space",
            raw: t[0]
        };
    }
    code(e) {
        let t = this.rules.block.code.exec(e);
        if (t) {
            let n = t[0].replace(this.rules.other.codeRemoveIndent, "");
            return {
                type: "code",
                raw: t[0],
                codeBlockStyle: "indented",
                text: this.options.pedantic ? n : $42cbc74a64ab0a8d$var$I(n, `
`)
            };
        }
    }
    fences(e) {
        let t = this.rules.block.fences.exec(e);
        if (t) {
            let n = t[0], r = $42cbc74a64ab0a8d$var$nt(n, t[3] || "", this.rules);
            return {
                type: "code",
                raw: n,
                lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
                text: r
            };
        }
    }
    heading(e) {
        let t = this.rules.block.heading.exec(e);
        if (t) {
            let n = t[2].trim();
            if (this.rules.other.endingHash.test(n)) {
                let r = $42cbc74a64ab0a8d$var$I(n, "#");
                (this.options.pedantic || !r || this.rules.other.endingSpaceChar.test(r)) && (n = r.trim());
            }
            return {
                type: "heading",
                raw: t[0],
                depth: t[1].length,
                text: n,
                tokens: this.lexer.inline(n)
            };
        }
    }
    hr(e) {
        let t = this.rules.block.hr.exec(e);
        if (t) return {
            type: "hr",
            raw: $42cbc74a64ab0a8d$var$I(t[0], `
`)
        };
    }
    blockquote(e) {
        let t = this.rules.block.blockquote.exec(e);
        if (t) {
            let n = $42cbc74a64ab0a8d$var$I(t[0], `
`).split(`
`), r = "", i = "", s = [];
            for(; n.length > 0;){
                let a = !1, o = [], l;
                for(l = 0; l < n.length; l++)if (this.rules.other.blockquoteStart.test(n[l])) o.push(n[l]), a = !0;
                else if (!a) o.push(n[l]);
                else break;
                n = n.slice(l);
                let p = o.join(`
`), c = p.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
                r = r ? `${r}
${p}` : p, i = i ? `${i}
${c}` : c;
                let d = this.lexer.state.top;
                if (this.lexer.state.top = !0, this.lexer.blockTokens(c, s, !0), this.lexer.state.top = d, n.length === 0) break;
                let h = s.at(-1);
                if (h?.type === "code") break;
                if (h?.type === "blockquote") {
                    let R = h, f = R.raw + `
` + n.join(`
`), S = this.blockquote(f);
                    s[s.length - 1] = S, r = r.substring(0, r.length - R.raw.length) + S.raw, i = i.substring(0, i.length - R.text.length) + S.text;
                    break;
                } else if (h?.type === "list") {
                    let R = h, f = R.raw + `
` + n.join(`
`), S = this.list(f);
                    s[s.length - 1] = S, r = r.substring(0, r.length - h.raw.length) + S.raw, i = i.substring(0, i.length - R.raw.length) + S.raw, n = f.substring(s.at(-1).raw.length).split(`
`);
                    continue;
                }
            }
            return {
                type: "blockquote",
                raw: r,
                tokens: s,
                text: i
            };
        }
    }
    list(e) {
        let t = this.rules.block.list.exec(e);
        if (t) {
            let n = t[1].trim(), r = n.length > 1, i = {
                type: "list",
                raw: "",
                ordered: r,
                start: r ? +n.slice(0, -1) : "",
                loose: !1,
                items: []
            };
            n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
            let s = this.rules.other.listItemRegex(n), a = !1;
            for(; e;){
                let l = !1, p = "", c = "";
                if (!(t = s.exec(e)) || this.rules.block.hr.test(e)) break;
                p = t[0], e = e.substring(p.length);
                let d = $42cbc74a64ab0a8d$var$ge(t[2].split(`
`, 1)[0], t[1].length), h = e.split(`
`, 1)[0], R = !d.trim(), f = 0;
                if (this.options.pedantic ? (f = 2, c = d.trimStart()) : R ? f = t[1].length + 1 : (f = d.search(this.rules.other.nonSpaceChar), f = f > 4 ? 1 : f, c = d.slice(f), f += t[1].length), R && this.rules.other.blankLine.test(h) && (p += h + `
`, e = e.substring(h.length + 1), l = !0), !l) {
                    let S = this.rules.other.nextBulletRegex(f), Y = this.rules.other.hrRegex(f), ee = this.rules.other.fencesBeginRegex(f), te = this.rules.other.headingBeginRegex(f), me = this.rules.other.htmlBeginRegex(f), xe = this.rules.other.blockquoteBeginRegex(f);
                    for(; e;){
                        let Z = e.split(`
`, 1)[0], A;
                        if (h = Z, this.options.pedantic ? (h = h.replace(this.rules.other.listReplaceNesting, "  "), A = h) : A = h.replace(this.rules.other.tabCharGlobal, "    "), ee.test(h) || te.test(h) || me.test(h) || xe.test(h) || S.test(h) || Y.test(h)) break;
                        if (A.search(this.rules.other.nonSpaceChar) >= f || !h.trim()) c += `
` + A.slice(f);
                        else {
                            if (R || d.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || ee.test(d) || te.test(d) || Y.test(d)) break;
                            c += `
` + h;
                        }
                        R = !h.trim(), p += Z + `
`, e = e.substring(Z.length + 1), d = A.slice(f);
                    }
                }
                i.loose || (a ? i.loose = !0 : this.rules.other.doubleBlankLine.test(p) && (a = !0)), i.items.push({
                    type: "list_item",
                    raw: p,
                    task: !!this.options.gfm && this.rules.other.listIsTask.test(c),
                    loose: !1,
                    text: c,
                    tokens: []
                }), i.raw += p;
            }
            let o = i.items.at(-1);
            if (o) o.raw = o.raw.trimEnd(), o.text = o.text.trimEnd();
            else return;
            i.raw = i.raw.trimEnd();
            for (let l of i.items){
                if (this.lexer.state.top = !1, l.tokens = this.lexer.blockTokens(l.text, []), l.task) {
                    if (l.text = l.text.replace(this.rules.other.listReplaceTask, ""), l.tokens[0]?.type === "text" || l.tokens[0]?.type === "paragraph") {
                        l.tokens[0].raw = l.tokens[0].raw.replace(this.rules.other.listReplaceTask, ""), l.tokens[0].text = l.tokens[0].text.replace(this.rules.other.listReplaceTask, "");
                        for(let c = this.lexer.inlineQueue.length - 1; c >= 0; c--)if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[c].src)) {
                            this.lexer.inlineQueue[c].src = this.lexer.inlineQueue[c].src.replace(this.rules.other.listReplaceTask, "");
                            break;
                        }
                    }
                    let p = this.rules.other.listTaskCheckbox.exec(l.raw);
                    if (p) {
                        let c = {
                            type: "checkbox",
                            raw: p[0] + " ",
                            checked: p[0] !== "[ ]"
                        };
                        l.checked = c.checked, i.loose ? l.tokens[0] && [
                            "paragraph",
                            "text"
                        ].includes(l.tokens[0].type) && "tokens" in l.tokens[0] && l.tokens[0].tokens ? (l.tokens[0].raw = c.raw + l.tokens[0].raw, l.tokens[0].text = c.raw + l.tokens[0].text, l.tokens[0].tokens.unshift(c)) : l.tokens.unshift({
                            type: "paragraph",
                            raw: c.raw,
                            text: c.raw,
                            tokens: [
                                c
                            ]
                        }) : l.tokens.unshift(c);
                    }
                }
                if (!i.loose) {
                    let p = l.tokens.filter((d)=>d.type === "space"), c = p.length > 0 && p.some((d)=>this.rules.other.anyLine.test(d.raw));
                    i.loose = c;
                }
            }
            if (i.loose) for (let l of i.items){
                l.loose = !0;
                for (let p of l.tokens)p.type === "text" && (p.type = "paragraph");
            }
            return i;
        }
    }
    html(e) {
        let t = this.rules.block.html.exec(e);
        if (t) return {
            type: "html",
            block: !0,
            raw: t[0],
            pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
            text: t[0]
        };
    }
    def(e) {
        let t = this.rules.block.def.exec(e);
        if (t) {
            let n = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), r = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", i = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
            return {
                type: "def",
                tag: n,
                raw: t[0],
                href: r,
                title: i
            };
        }
    }
    table(e) {
        let t = this.rules.block.table.exec(e);
        if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
        let n = $42cbc74a64ab0a8d$var$V(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], s = {
            type: "table",
            raw: t[0],
            header: [],
            align: [],
            rows: []
        };
        if (n.length === r.length) {
            for (let a of r)this.rules.other.tableAlignRight.test(a) ? s.align.push("right") : this.rules.other.tableAlignCenter.test(a) ? s.align.push("center") : this.rules.other.tableAlignLeft.test(a) ? s.align.push("left") : s.align.push(null);
            for(let a = 0; a < n.length; a++)s.header.push({
                text: n[a],
                tokens: this.lexer.inline(n[a]),
                header: !0,
                align: s.align[a]
            });
            for (let a of i)s.rows.push($42cbc74a64ab0a8d$var$V(a, s.header.length).map((o, l)=>({
                    text: o,
                    tokens: this.lexer.inline(o),
                    header: !1,
                    align: s.align[l]
                })));
            return s;
        }
    }
    lheading(e) {
        let t = this.rules.block.lheading.exec(e);
        if (t) {
            let n = t[1].trim();
            return {
                type: "heading",
                raw: t[0],
                depth: t[2].charAt(0) === "=" ? 1 : 2,
                text: n,
                tokens: this.lexer.inline(n)
            };
        }
    }
    paragraph(e) {
        let t = this.rules.block.paragraph.exec(e);
        if (t) {
            let n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
            return {
                type: "paragraph",
                raw: t[0],
                text: n,
                tokens: this.lexer.inline(n)
            };
        }
    }
    text(e) {
        let t = this.rules.block.text.exec(e);
        if (t) return {
            type: "text",
            raw: t[0],
            text: t[0],
            tokens: this.lexer.inline(t[0])
        };
    }
    escape(e) {
        let t = this.rules.inline.escape.exec(e);
        if (t) return {
            type: "escape",
            raw: t[0],
            text: t[1]
        };
    }
    tag(e) {
        let t = this.rules.inline.tag.exec(e);
        if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
            type: "html",
            raw: t[0],
            inLink: this.lexer.state.inLink,
            inRawBlock: this.lexer.state.inRawBlock,
            block: !1,
            text: t[0]
        };
    }
    link(e) {
        let t = this.rules.inline.link.exec(e);
        if (t) {
            let n = t[2].trim();
            if (!this.options.pedantic && this.rules.other.startAngleBracket.test(n)) {
                if (!this.rules.other.endAngleBracket.test(n)) return;
                let s = $42cbc74a64ab0a8d$var$I(n.slice(0, -1), "\\");
                if ((n.length - s.length) % 2 === 0) return;
            } else {
                let s = $42cbc74a64ab0a8d$var$de(t[2], "()");
                if (s === -2) return;
                if (s > -1) {
                    let o = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + s;
                    t[2] = t[2].substring(0, s), t[0] = t[0].substring(0, o).trim(), t[3] = "";
                }
            }
            let r = t[2], i = "";
            if (this.options.pedantic) {
                let s = this.rules.other.pedanticHrefTitle.exec(r);
                s && (r = s[1], i = s[3]);
            } else i = t[3] ? t[3].slice(1, -1) : "";
            return r = r.trim(), this.rules.other.startAngleBracket.test(r) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(n) ? r = r.slice(1) : r = r.slice(1, -1)), $42cbc74a64ab0a8d$var$fe(t, {
                href: r && r.replace(this.rules.inline.anyPunctuation, "$1"),
                title: i && i.replace(this.rules.inline.anyPunctuation, "$1")
            }, t[0], this.lexer, this.rules);
        }
    }
    reflink(e, t) {
        let n;
        if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
            let r = (n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " "), i = t[r.toLowerCase()];
            if (!i) {
                let s = n[0].charAt(0);
                return {
                    type: "text",
                    raw: s,
                    text: s
                };
            }
            return $42cbc74a64ab0a8d$var$fe(n, i, n[0], this.lexer, this.rules);
        }
    }
    emStrong(e, t, n = "") {
        let r = this.rules.inline.emStrongLDelim.exec(e);
        if (!r || !r[1] && !r[2] && !r[3] && !r[4] || r[4] && n.match(this.rules.other.unicodeAlphaNumeric)) return;
        if (!(r[1] || r[3] || "") || !n || this.rules.inline.punctuation.exec(n)) {
            let s = [
                ...r[0]
            ].length - 1, a, o, l = s, p = 0, c = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
            for(c.lastIndex = 0, t = t.slice(-1 * e.length + s); (r = c.exec(t)) !== null;){
                if (a = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !a) continue;
                if (o = [
                    ...a
                ].length, r[3] || r[4]) {
                    l += o;
                    continue;
                } else if ((r[5] || r[6]) && s % 3 && !((s + o) % 3)) {
                    p += o;
                    continue;
                }
                if (l -= o, l > 0) continue;
                o = Math.min(o, o + l + p);
                let d = [
                    ...r[0]
                ][0].length, h = e.slice(0, s + r.index + d + o);
                if (Math.min(s, o) % 2) {
                    let f = h.slice(1, -1);
                    return {
                        type: "em",
                        raw: h,
                        text: f,
                        tokens: this.lexer.inlineTokens(f)
                    };
                }
                let R = h.slice(2, -2);
                return {
                    type: "strong",
                    raw: h,
                    text: R,
                    tokens: this.lexer.inlineTokens(R)
                };
            }
        }
    }
    codespan(e) {
        let t = this.rules.inline.code.exec(e);
        if (t) {
            let n = t[2].replace(this.rules.other.newLineCharGlobal, " "), r = this.rules.other.nonSpaceChar.test(n), i = this.rules.other.startingSpaceChar.test(n) && this.rules.other.endingSpaceChar.test(n);
            return r && i && (n = n.substring(1, n.length - 1)), {
                type: "codespan",
                raw: t[0],
                text: n
            };
        }
    }
    br(e) {
        let t = this.rules.inline.br.exec(e);
        if (t) return {
            type: "br",
            raw: t[0]
        };
    }
    del(e, t, n = "") {
        let r = this.rules.inline.delLDelim.exec(e);
        if (!r) return;
        if (!(r[1] || "") || !n || this.rules.inline.punctuation.exec(n)) {
            let s = [
                ...r[0]
            ].length - 1, a, o, l = s, p = this.rules.inline.delRDelim;
            for(p.lastIndex = 0, t = t.slice(-1 * e.length + s); (r = p.exec(t)) !== null;){
                if (a = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !a || (o = [
                    ...a
                ].length, o !== s)) continue;
                if (r[3] || r[4]) {
                    l += o;
                    continue;
                }
                if (l -= o, l > 0) continue;
                o = Math.min(o, o + l);
                let c = [
                    ...r[0]
                ][0].length, d = e.slice(0, s + r.index + c + o), h = d.slice(s, -s);
                return {
                    type: "del",
                    raw: d,
                    text: h,
                    tokens: this.lexer.inlineTokens(h)
                };
            }
        }
    }
    autolink(e) {
        let t = this.rules.inline.autolink.exec(e);
        if (t) {
            let n, r;
            return t[2] === "@" ? (n = t[1], r = "mailto:" + n) : (n = t[1], r = n), {
                type: "link",
                raw: t[0],
                text: n,
                href: r,
                tokens: [
                    {
                        type: "text",
                        raw: n,
                        text: n
                    }
                ]
            };
        }
    }
    url(e) {
        let t;
        if (t = this.rules.inline.url.exec(e)) {
            let n, r;
            if (t[2] === "@") n = t[0], r = "mailto:" + n;
            else {
                let i;
                do i = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
                while (i !== t[0]);
                n = t[0], t[1] === "www." ? r = "http://" + t[0] : r = t[0];
            }
            return {
                type: "link",
                raw: t[0],
                text: n,
                href: r,
                tokens: [
                    {
                        type: "text",
                        raw: n,
                        text: n
                    }
                ]
            };
        }
    }
    inlineText(e) {
        let t = this.rules.inline.text.exec(e);
        if (t) {
            let n = this.lexer.state.inRawBlock;
            return {
                type: "text",
                raw: t[0],
                text: t[0],
                escaped: n
            };
        }
    }
};
var $42cbc74a64ab0a8d$export$6168dc8908a6c652 = class u {
    tokens;
    options;
    state;
    inlineQueue;
    tokenizer;
    constructor(e){
        this.tokens = [], this.tokens.links = Object.create(null), this.options = e || $42cbc74a64ab0a8d$export$ebe90cb607ad99e, this.options.tokenizer = this.options.tokenizer || new $42cbc74a64ab0a8d$export$55e8b082af4aa63e, this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
            inLink: !1,
            inRawBlock: !1,
            top: !0
        };
        let t = {
            other: $42cbc74a64ab0a8d$var$m,
            block: $42cbc74a64ab0a8d$var$B.normal,
            inline: $42cbc74a64ab0a8d$var$E.normal
        };
        this.options.pedantic ? (t.block = $42cbc74a64ab0a8d$var$B.pedantic, t.inline = $42cbc74a64ab0a8d$var$E.pedantic) : this.options.gfm && (t.block = $42cbc74a64ab0a8d$var$B.gfm, this.options.breaks ? t.inline = $42cbc74a64ab0a8d$var$E.breaks : t.inline = $42cbc74a64ab0a8d$var$E.gfm), this.tokenizer.rules = t;
    }
    static get rules() {
        return {
            block: $42cbc74a64ab0a8d$var$B,
            inline: $42cbc74a64ab0a8d$var$E
        };
    }
    static lex(e, t) {
        return new u(t).lex(e);
    }
    static lexInline(e, t) {
        return new u(t).inlineTokens(e);
    }
    lex(e) {
        e = e.replace($42cbc74a64ab0a8d$var$m.carriageReturn, `
`), this.blockTokens(e, this.tokens);
        for(let t = 0; t < this.inlineQueue.length; t++){
            let n = this.inlineQueue[t];
            this.inlineTokens(n.src, n.tokens);
        }
        return this.inlineQueue = [], this.tokens;
    }
    blockTokens(e, t = [], n = !1) {
        for(this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace($42cbc74a64ab0a8d$var$m.tabCharGlobal, "    ").replace($42cbc74a64ab0a8d$var$m.spaceLine, "")); e;){
            let r;
            if (this.options.extensions?.block?.some((s)=>(r = s.call({
                    lexer: this
                }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
            if (r = this.tokenizer.space(e)) {
                e = e.substring(r.raw.length);
                let s = t.at(-1);
                r.raw.length === 1 && s !== void 0 ? s.raw += `
` : t.push(r);
                continue;
            }
            if (r = this.tokenizer.code(e)) {
                e = e.substring(r.raw.length);
                let s = t.at(-1);
                s?.type === "paragraph" || s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.at(-1).src = s.text) : t.push(r);
                continue;
            }
            if (r = this.tokenizer.fences(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.heading(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.hr(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.blockquote(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.list(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.html(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.def(e)) {
                e = e.substring(r.raw.length);
                let s = t.at(-1);
                s?.type === "paragraph" || s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.raw, this.inlineQueue.at(-1).src = s.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
                    href: r.href,
                    title: r.title
                }, t.push(r));
                continue;
            }
            if (r = this.tokenizer.table(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.lheading(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            let i = e;
            if (this.options.extensions?.startBlock) {
                let s = 1 / 0, a = e.slice(1), o;
                this.options.extensions.startBlock.forEach((l)=>{
                    o = l.call({
                        lexer: this
                    }, a), typeof o == "number" && o >= 0 && (s = Math.min(s, o));
                }), s < 1 / 0 && s >= 0 && (i = e.substring(0, s + 1));
            }
            if (this.state.top && (r = this.tokenizer.paragraph(i))) {
                let s = t.at(-1);
                n && s?.type === "paragraph" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = s.text) : t.push(r), n = i.length !== e.length, e = e.substring(r.raw.length);
                continue;
            }
            if (r = this.tokenizer.text(e)) {
                e = e.substring(r.raw.length);
                let s = t.at(-1);
                s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = s.text) : t.push(r);
                continue;
            }
            if (e) {
                let s = "Infinite loop on byte: " + e.charCodeAt(0);
                if (this.options.silent) {
                    console.error(s);
                    break;
                } else throw new Error(s);
            }
        }
        return this.state.top = !0, t;
    }
    inline(e, t = []) {
        return this.inlineQueue.push({
            src: e,
            tokens: t
        }), t;
    }
    inlineTokens(e, t = []) {
        this.tokenizer.lexer = this;
        let n = e, r = null;
        if (this.tokens.links) {
            let o = Object.keys(this.tokens.links);
            if (o.length > 0) for(; (r = this.tokenizer.rules.inline.reflinkSearch.exec(n)) !== null;)o.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) && (n = n.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
        }
        for(; (r = this.tokenizer.rules.inline.anyPunctuation.exec(n)) !== null;)n = n.slice(0, r.index) + "++" + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
        let i;
        for(; (r = this.tokenizer.rules.inline.blockSkip.exec(n)) !== null;)i = r[2] ? r[2].length : 0, n = n.slice(0, r.index + i) + "[" + "a".repeat(r[0].length - i - 2) + "]" + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        n = this.options.hooks?.emStrongMask?.call({
            lexer: this
        }, n) ?? n;
        let s = !1, a = "";
        for(; e;){
            s || (a = ""), s = !1;
            let o;
            if (this.options.extensions?.inline?.some((p)=>(o = p.call({
                    lexer: this
                }, e, t)) ? (e = e.substring(o.raw.length), t.push(o), !0) : !1)) continue;
            if (o = this.tokenizer.escape(e)) {
                e = e.substring(o.raw.length), t.push(o);
                continue;
            }
            if (o = this.tokenizer.tag(e)) {
                e = e.substring(o.raw.length), t.push(o);
                continue;
            }
            if (o = this.tokenizer.link(e)) {
                e = e.substring(o.raw.length), t.push(o);
                continue;
            }
            if (o = this.tokenizer.reflink(e, this.tokens.links)) {
                e = e.substring(o.raw.length);
                let p = t.at(-1);
                o.type === "text" && p?.type === "text" ? (p.raw += o.raw, p.text += o.text) : t.push(o);
                continue;
            }
            if (o = this.tokenizer.emStrong(e, n, a)) {
                e = e.substring(o.raw.length), t.push(o);
                continue;
            }
            if (o = this.tokenizer.codespan(e)) {
                e = e.substring(o.raw.length), t.push(o);
                continue;
            }
            if (o = this.tokenizer.br(e)) {
                e = e.substring(o.raw.length), t.push(o);
                continue;
            }
            if (o = this.tokenizer.del(e, n, a)) {
                e = e.substring(o.raw.length), t.push(o);
                continue;
            }
            if (o = this.tokenizer.autolink(e)) {
                e = e.substring(o.raw.length), t.push(o);
                continue;
            }
            if (!this.state.inLink && (o = this.tokenizer.url(e))) {
                e = e.substring(o.raw.length), t.push(o);
                continue;
            }
            let l = e;
            if (this.options.extensions?.startInline) {
                let p = 1 / 0, c = e.slice(1), d;
                this.options.extensions.startInline.forEach((h)=>{
                    d = h.call({
                        lexer: this
                    }, c), typeof d == "number" && d >= 0 && (p = Math.min(p, d));
                }), p < 1 / 0 && p >= 0 && (l = e.substring(0, p + 1));
            }
            if (o = this.tokenizer.inlineText(l)) {
                e = e.substring(o.raw.length), o.raw.slice(-1) !== "_" && (a = o.raw.slice(-1)), s = !0;
                let p = t.at(-1);
                p?.type === "text" ? (p.raw += o.raw, p.text += o.text) : t.push(o);
                continue;
            }
            if (e) {
                let p = "Infinite loop on byte: " + e.charCodeAt(0);
                if (this.options.silent) {
                    console.error(p);
                    break;
                } else throw new Error(p);
            }
        }
        return t;
    }
};
var $42cbc74a64ab0a8d$export$88530751e3977073 = class {
    options;
    parser;
    constructor(e){
        this.options = e || $42cbc74a64ab0a8d$export$ebe90cb607ad99e;
    }
    space(e) {
        return "";
    }
    code({ text: e, lang: t, escaped: n }) {
        let r = (t || "").match($42cbc74a64ab0a8d$var$m.notSpaceStart)?.[0], i = e.replace($42cbc74a64ab0a8d$var$m.endingNewline, "") + `
`;
        return r ? '<pre><code class="language-' + $42cbc74a64ab0a8d$var$T(r) + '">' + (n ? i : $42cbc74a64ab0a8d$var$T(i, !0)) + `</code></pre>
` : "<pre><code>" + (n ? i : $42cbc74a64ab0a8d$var$T(i, !0)) + `</code></pre>
`;
    }
    blockquote({ tokens: e }) {
        return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
    }
    html({ text: e }) {
        return e;
    }
    def(e) {
        return "";
    }
    heading({ tokens: e, depth: t }) {
        return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
    }
    hr(e) {
        return `<hr>
`;
    }
    list(e) {
        let t = e.ordered, n = e.start, r = "";
        for(let a = 0; a < e.items.length; a++){
            let o = e.items[a];
            r += this.listitem(o);
        }
        let i = t ? "ol" : "ul", s = t && n !== 1 ? ' start="' + n + '"' : "";
        return "<" + i + s + `>
` + r + "</" + i + `>
`;
    }
    listitem(e) {
        return `<li>${this.parser.parse(e.tokens)}</li>
`;
    }
    checkbox({ checked: e }) {
        return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"> ';
    }
    paragraph({ tokens: e }) {
        return `<p>${this.parser.parseInline(e)}</p>
`;
    }
    table(e) {
        let t = "", n = "";
        for(let i = 0; i < e.header.length; i++)n += this.tablecell(e.header[i]);
        t += this.tablerow({
            text: n
        });
        let r = "";
        for(let i = 0; i < e.rows.length; i++){
            let s = e.rows[i];
            n = "";
            for(let a = 0; a < s.length; a++)n += this.tablecell(s[a]);
            r += this.tablerow({
                text: n
            });
        }
        return r && (r = `<tbody>${r}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + r + `</table>
`;
    }
    tablerow({ text: e }) {
        return `<tr>
${e}</tr>
`;
    }
    tablecell(e) {
        let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
        return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
    }
    strong({ tokens: e }) {
        return `<strong>${this.parser.parseInline(e)}</strong>`;
    }
    em({ tokens: e }) {
        return `<em>${this.parser.parseInline(e)}</em>`;
    }
    codespan({ text: e }) {
        return `<code>${$42cbc74a64ab0a8d$var$T(e, !0)}</code>`;
    }
    br(e) {
        return "<br>";
    }
    del({ tokens: e }) {
        return `<del>${this.parser.parseInline(e)}</del>`;
    }
    link({ href: e, title: t, tokens: n }) {
        let r = this.parser.parseInline(n), i = $42cbc74a64ab0a8d$var$J(e);
        if (i === null) return r;
        e = i;
        let s = '<a href="' + e + '"';
        return t && (s += ' title="' + $42cbc74a64ab0a8d$var$T(t) + '"'), s += ">" + r + "</a>", s;
    }
    image({ href: e, title: t, text: n, tokens: r }) {
        r && (n = this.parser.parseInline(r, this.parser.textRenderer));
        let i = $42cbc74a64ab0a8d$var$J(e);
        if (i === null) return $42cbc74a64ab0a8d$var$T(n);
        e = i;
        let s = `<img src="${e}" alt="${$42cbc74a64ab0a8d$var$T(n)}"`;
        return t && (s += ` title="${$42cbc74a64ab0a8d$var$T(t)}"`), s += ">", s;
    }
    text(e) {
        return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : $42cbc74a64ab0a8d$var$T(e.text);
    }
};
var $42cbc74a64ab0a8d$export$75ebcd2c8ed5b901 = class {
    strong({ text: e }) {
        return e;
    }
    em({ text: e }) {
        return e;
    }
    codespan({ text: e }) {
        return e;
    }
    del({ text: e }) {
        return e;
    }
    html({ text: e }) {
        return e;
    }
    text({ text: e }) {
        return e;
    }
    link({ text: e }) {
        return "" + e;
    }
    image({ text: e }) {
        return "" + e;
    }
    br() {
        return "";
    }
    checkbox({ raw: e }) {
        return e;
    }
};
var $42cbc74a64ab0a8d$export$7acfa6ed01010e37 = class u {
    options;
    renderer;
    textRenderer;
    constructor(e){
        this.options = e || $42cbc74a64ab0a8d$export$ebe90cb607ad99e, this.options.renderer = this.options.renderer || new $42cbc74a64ab0a8d$export$88530751e3977073, this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new $42cbc74a64ab0a8d$export$75ebcd2c8ed5b901;
    }
    static parse(e, t) {
        return new u(t).parse(e);
    }
    static parseInline(e, t) {
        return new u(t).parseInline(e);
    }
    parse(e) {
        this.renderer.parser = this;
        let t = "";
        for(let n = 0; n < e.length; n++){
            let r = e[n];
            if (this.options.extensions?.renderers?.[r.type]) {
                let s = r, a = this.options.extensions.renderers[s.type].call({
                    parser: this
                }, s);
                if (a !== !1 || ![
                    "space",
                    "hr",
                    "heading",
                    "code",
                    "table",
                    "blockquote",
                    "list",
                    "html",
                    "def",
                    "paragraph",
                    "text"
                ].includes(s.type)) {
                    t += a || "";
                    continue;
                }
            }
            let i = r;
            switch(i.type){
                case "space":
                    t += this.renderer.space(i);
                    break;
                case "hr":
                    t += this.renderer.hr(i);
                    break;
                case "heading":
                    t += this.renderer.heading(i);
                    break;
                case "code":
                    t += this.renderer.code(i);
                    break;
                case "table":
                    t += this.renderer.table(i);
                    break;
                case "blockquote":
                    t += this.renderer.blockquote(i);
                    break;
                case "list":
                    t += this.renderer.list(i);
                    break;
                case "checkbox":
                    t += this.renderer.checkbox(i);
                    break;
                case "html":
                    t += this.renderer.html(i);
                    break;
                case "def":
                    t += this.renderer.def(i);
                    break;
                case "paragraph":
                    t += this.renderer.paragraph(i);
                    break;
                case "text":
                    t += this.renderer.text(i);
                    break;
                default:
                    {
                        let s = 'Token with "' + i.type + '" type was not found.';
                        if (this.options.silent) return console.error(s), "";
                        throw new Error(s);
                    }
            }
        }
        return t;
    }
    parseInline(e, t = this.renderer) {
        this.renderer.parser = this;
        let n = "";
        for(let r = 0; r < e.length; r++){
            let i = e[r];
            if (this.options.extensions?.renderers?.[i.type]) {
                let a = this.options.extensions.renderers[i.type].call({
                    parser: this
                }, i);
                if (a !== !1 || ![
                    "escape",
                    "html",
                    "link",
                    "image",
                    "strong",
                    "em",
                    "codespan",
                    "br",
                    "del",
                    "text"
                ].includes(i.type)) {
                    n += a || "";
                    continue;
                }
            }
            let s = i;
            switch(s.type){
                case "escape":
                    n += t.text(s);
                    break;
                case "html":
                    n += t.html(s);
                    break;
                case "link":
                    n += t.link(s);
                    break;
                case "image":
                    n += t.image(s);
                    break;
                case "checkbox":
                    n += t.checkbox(s);
                    break;
                case "strong":
                    n += t.strong(s);
                    break;
                case "em":
                    n += t.em(s);
                    break;
                case "codespan":
                    n += t.codespan(s);
                    break;
                case "br":
                    n += t.br(s);
                    break;
                case "del":
                    n += t.del(s);
                    break;
                case "text":
                    n += t.text(s);
                    break;
                default:
                    {
                        let a = 'Token with "' + s.type + '" type was not found.';
                        if (this.options.silent) return console.error(a), "";
                        throw new Error(a);
                    }
            }
        }
        return n;
    }
};
var $42cbc74a64ab0a8d$export$5fbefe39e79899a6 = class {
    options;
    block;
    constructor(e){
        this.options = e || $42cbc74a64ab0a8d$export$ebe90cb607ad99e;
    }
    static passThroughHooks = new Set([
        "preprocess",
        "postprocess",
        "processAllTokens",
        "emStrongMask"
    ]);
    static passThroughHooksRespectAsync = new Set([
        "preprocess",
        "postprocess",
        "processAllTokens"
    ]);
    preprocess(e) {
        return e;
    }
    postprocess(e) {
        return e;
    }
    processAllTokens(e) {
        return e;
    }
    emStrongMask(e) {
        return e;
    }
    provideLexer(e = this.block) {
        return e ? $42cbc74a64ab0a8d$export$6168dc8908a6c652.lex : $42cbc74a64ab0a8d$export$6168dc8908a6c652.lexInline;
    }
    provideParser(e = this.block) {
        return e ? $42cbc74a64ab0a8d$export$7acfa6ed01010e37.parse : $42cbc74a64ab0a8d$export$7acfa6ed01010e37.parseInline;
    }
};
var $42cbc74a64ab0a8d$export$164128c95a350e30 = class {
    defaults = $42cbc74a64ab0a8d$export$212bb2fc580a90a8();
    options = this.setOptions;
    parse = this.parseMarkdown(!0);
    parseInline = this.parseMarkdown(!1);
    Parser = $42cbc74a64ab0a8d$export$7acfa6ed01010e37;
    Renderer = $42cbc74a64ab0a8d$export$88530751e3977073;
    TextRenderer = $42cbc74a64ab0a8d$export$75ebcd2c8ed5b901;
    Lexer = $42cbc74a64ab0a8d$export$6168dc8908a6c652;
    Tokenizer = $42cbc74a64ab0a8d$export$55e8b082af4aa63e;
    Hooks = $42cbc74a64ab0a8d$export$5fbefe39e79899a6;
    constructor(...e){
        this.use(...e);
    }
    walkTokens(e, t) {
        let n = [];
        for (let r of e)switch(n = n.concat(t.call(this, r)), r.type){
            case "table":
                {
                    let i = r;
                    for (let s of i.header)n = n.concat(this.walkTokens(s.tokens, t));
                    for (let s of i.rows)for (let a of s)n = n.concat(this.walkTokens(a.tokens, t));
                    break;
                }
            case "list":
                {
                    let i = r;
                    n = n.concat(this.walkTokens(i.items, t));
                    break;
                }
            default:
                {
                    let i = r;
                    this.defaults.extensions?.childTokens?.[i.type] ? this.defaults.extensions.childTokens[i.type].forEach((s)=>{
                        let a = i[s].flat(1 / 0);
                        n = n.concat(this.walkTokens(a, t));
                    }) : i.tokens && (n = n.concat(this.walkTokens(i.tokens, t)));
                }
        }
        return n;
    }
    use(...e) {
        let t = this.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        return e.forEach((n)=>{
            let r = {
                ...n
            };
            if (r.async = this.defaults.async || r.async || !1, n.extensions && (n.extensions.forEach((i)=>{
                if (!i.name) throw new Error("extension name required");
                if ("renderer" in i) {
                    let s = t.renderers[i.name];
                    s ? t.renderers[i.name] = function(...a) {
                        let o = i.renderer.apply(this, a);
                        return o === !1 && (o = s.apply(this, a)), o;
                    } : t.renderers[i.name] = i.renderer;
                }
                if ("tokenizer" in i) {
                    if (!i.level || i.level !== "block" && i.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                    let s = t[i.level];
                    s ? s.unshift(i.tokenizer) : t[i.level] = [
                        i.tokenizer
                    ], i.start && (i.level === "block" ? t.startBlock ? t.startBlock.push(i.start) : t.startBlock = [
                        i.start
                    ] : i.level === "inline" && (t.startInline ? t.startInline.push(i.start) : t.startInline = [
                        i.start
                    ]));
                }
                "childTokens" in i && i.childTokens && (t.childTokens[i.name] = i.childTokens);
            }), r.extensions = t), n.renderer) {
                let i = this.defaults.renderer || new $42cbc74a64ab0a8d$export$88530751e3977073(this.defaults);
                for(let s in n.renderer){
                    if (!(s in i)) throw new Error(`renderer '${s}' does not exist`);
                    if ([
                        "options",
                        "parser"
                    ].includes(s)) continue;
                    let a = s, o = n.renderer[a], l = i[a];
                    i[a] = (...p)=>{
                        let c = o.apply(i, p);
                        return c === !1 && (c = l.apply(i, p)), c || "";
                    };
                }
                r.renderer = i;
            }
            if (n.tokenizer) {
                let i = this.defaults.tokenizer || new $42cbc74a64ab0a8d$export$55e8b082af4aa63e(this.defaults);
                for(let s in n.tokenizer){
                    if (!(s in i)) throw new Error(`tokenizer '${s}' does not exist`);
                    if ([
                        "options",
                        "rules",
                        "lexer"
                    ].includes(s)) continue;
                    let a = s, o = n.tokenizer[a], l = i[a];
                    i[a] = (...p)=>{
                        let c = o.apply(i, p);
                        return c === !1 && (c = l.apply(i, p)), c;
                    };
                }
                r.tokenizer = i;
            }
            if (n.hooks) {
                let i = this.defaults.hooks || new $42cbc74a64ab0a8d$export$5fbefe39e79899a6;
                for(let s in n.hooks){
                    if (!(s in i)) throw new Error(`hook '${s}' does not exist`);
                    if ([
                        "options",
                        "block"
                    ].includes(s)) continue;
                    let a = s, o = n.hooks[a], l = i[a];
                    $42cbc74a64ab0a8d$export$5fbefe39e79899a6.passThroughHooks.has(s) ? i[a] = (p)=>{
                        if (this.defaults.async && $42cbc74a64ab0a8d$export$5fbefe39e79899a6.passThroughHooksRespectAsync.has(s)) return (async ()=>{
                            let d = await o.call(i, p);
                            return l.call(i, d);
                        })();
                        let c = o.call(i, p);
                        return l.call(i, c);
                    } : i[a] = (...p)=>{
                        if (this.defaults.async) return (async ()=>{
                            let d = await o.apply(i, p);
                            return d === !1 && (d = await l.apply(i, p)), d;
                        })();
                        let c = o.apply(i, p);
                        return c === !1 && (c = l.apply(i, p)), c;
                    };
                }
                r.hooks = i;
            }
            if (n.walkTokens) {
                let i = this.defaults.walkTokens, s = n.walkTokens;
                r.walkTokens = function(a) {
                    let o = [];
                    return o.push(s.call(this, a)), i && (o = o.concat(i.call(this, a))), o;
                };
            }
            this.defaults = {
                ...this.defaults,
                ...r
            };
        }), this;
    }
    setOptions(e) {
        return this.defaults = {
            ...this.defaults,
            ...e
        }, this;
    }
    lexer(e, t) {
        return $42cbc74a64ab0a8d$export$6168dc8908a6c652.lex(e, t ?? this.defaults);
    }
    parser(e, t) {
        return $42cbc74a64ab0a8d$export$7acfa6ed01010e37.parse(e, t ?? this.defaults);
    }
    parseMarkdown(e) {
        return (n, r)=>{
            let i = {
                ...r
            }, s = {
                ...this.defaults,
                ...i
            }, a = this.onError(!!s.silent, !!s.async);
            if (this.defaults.async === !0 && i.async === !1) return a(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
            if (typeof n > "u" || n === null) return a(new Error("marked(): input parameter is undefined or null"));
            if (typeof n != "string") return a(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
            if (s.hooks && (s.hooks.options = s, s.hooks.block = e), s.async) return (async ()=>{
                let o = s.hooks ? await s.hooks.preprocess(n) : n, p = await (s.hooks ? await s.hooks.provideLexer(e) : e ? $42cbc74a64ab0a8d$export$6168dc8908a6c652.lex : $42cbc74a64ab0a8d$export$6168dc8908a6c652.lexInline)(o, s), c = s.hooks ? await s.hooks.processAllTokens(p) : p;
                s.walkTokens && await Promise.all(this.walkTokens(c, s.walkTokens));
                let h = await (s.hooks ? await s.hooks.provideParser(e) : e ? $42cbc74a64ab0a8d$export$7acfa6ed01010e37.parse : $42cbc74a64ab0a8d$export$7acfa6ed01010e37.parseInline)(c, s);
                return s.hooks ? await s.hooks.postprocess(h) : h;
            })().catch(a);
            try {
                s.hooks && (n = s.hooks.preprocess(n));
                let l = (s.hooks ? s.hooks.provideLexer(e) : e ? $42cbc74a64ab0a8d$export$6168dc8908a6c652.lex : $42cbc74a64ab0a8d$export$6168dc8908a6c652.lexInline)(n, s);
                s.hooks && (l = s.hooks.processAllTokens(l)), s.walkTokens && this.walkTokens(l, s.walkTokens);
                let c = (s.hooks ? s.hooks.provideParser(e) : e ? $42cbc74a64ab0a8d$export$7acfa6ed01010e37.parse : $42cbc74a64ab0a8d$export$7acfa6ed01010e37.parseInline)(l, s);
                return s.hooks && (c = s.hooks.postprocess(c)), c;
            } catch (o) {
                return a(o);
            }
        };
    }
    onError(e, t) {
        return (n)=>{
            if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
                let r = "<p>An error occurred:</p><pre>" + $42cbc74a64ab0a8d$var$T(n.message + "", !0) + "</pre>";
                return t ? Promise.resolve(r) : r;
            }
            if (t) return Promise.reject(n);
            throw n;
        };
    }
};
var $42cbc74a64ab0a8d$var$L = new $42cbc74a64ab0a8d$export$164128c95a350e30;
function $42cbc74a64ab0a8d$export$db8f131360c543a5(u, e) {
    return $42cbc74a64ab0a8d$var$L.parse(u, e);
}
$42cbc74a64ab0a8d$export$db8f131360c543a5.options = $42cbc74a64ab0a8d$export$db8f131360c543a5.setOptions = function(u) {
    return $42cbc74a64ab0a8d$var$L.setOptions(u), $42cbc74a64ab0a8d$export$db8f131360c543a5.defaults = $42cbc74a64ab0a8d$var$L.defaults, $42cbc74a64ab0a8d$var$G($42cbc74a64ab0a8d$export$db8f131360c543a5.defaults), $42cbc74a64ab0a8d$export$db8f131360c543a5;
};
$42cbc74a64ab0a8d$export$db8f131360c543a5.getDefaults = $42cbc74a64ab0a8d$export$212bb2fc580a90a8;
$42cbc74a64ab0a8d$export$db8f131360c543a5.defaults = $42cbc74a64ab0a8d$export$ebe90cb607ad99e;
$42cbc74a64ab0a8d$export$db8f131360c543a5.use = function(...u) {
    return $42cbc74a64ab0a8d$var$L.use(...u), $42cbc74a64ab0a8d$export$db8f131360c543a5.defaults = $42cbc74a64ab0a8d$var$L.defaults, $42cbc74a64ab0a8d$var$G($42cbc74a64ab0a8d$export$db8f131360c543a5.defaults), $42cbc74a64ab0a8d$export$db8f131360c543a5;
};
$42cbc74a64ab0a8d$export$db8f131360c543a5.walkTokens = function(u, e) {
    return $42cbc74a64ab0a8d$var$L.walkTokens(u, e);
};
$42cbc74a64ab0a8d$export$db8f131360c543a5.parseInline = $42cbc74a64ab0a8d$var$L.parseInline;
$42cbc74a64ab0a8d$export$db8f131360c543a5.Parser = $42cbc74a64ab0a8d$export$7acfa6ed01010e37;
$42cbc74a64ab0a8d$export$db8f131360c543a5.parser = $42cbc74a64ab0a8d$export$7acfa6ed01010e37.parse;
$42cbc74a64ab0a8d$export$db8f131360c543a5.Renderer = $42cbc74a64ab0a8d$export$88530751e3977073;
$42cbc74a64ab0a8d$export$db8f131360c543a5.TextRenderer = $42cbc74a64ab0a8d$export$75ebcd2c8ed5b901;
$42cbc74a64ab0a8d$export$db8f131360c543a5.Lexer = $42cbc74a64ab0a8d$export$6168dc8908a6c652;
$42cbc74a64ab0a8d$export$db8f131360c543a5.lexer = $42cbc74a64ab0a8d$export$6168dc8908a6c652.lex;
$42cbc74a64ab0a8d$export$db8f131360c543a5.Tokenizer = $42cbc74a64ab0a8d$export$55e8b082af4aa63e;
$42cbc74a64ab0a8d$export$db8f131360c543a5.Hooks = $42cbc74a64ab0a8d$export$5fbefe39e79899a6;
$42cbc74a64ab0a8d$export$db8f131360c543a5.parse = $42cbc74a64ab0a8d$export$db8f131360c543a5;
var $42cbc74a64ab0a8d$export$41c562ebe57d11e2 = $42cbc74a64ab0a8d$export$db8f131360c543a5.options, $42cbc74a64ab0a8d$export$add91eafeaeab287 = $42cbc74a64ab0a8d$export$db8f131360c543a5.setOptions, $42cbc74a64ab0a8d$export$1f96ae73734a86cc = $42cbc74a64ab0a8d$export$db8f131360c543a5.use, $42cbc74a64ab0a8d$export$3eedd5437d43cb76 = $42cbc74a64ab0a8d$export$db8f131360c543a5.walkTokens, $42cbc74a64ab0a8d$export$c7679c2b5e355e6f = $42cbc74a64ab0a8d$export$db8f131360c543a5.parseInline, $42cbc74a64ab0a8d$export$98e6a39c04603d36 = $42cbc74a64ab0a8d$export$db8f131360c543a5, $42cbc74a64ab0a8d$export$8f49e4af10703ce3 = $42cbc74a64ab0a8d$export$7acfa6ed01010e37.parse, $42cbc74a64ab0a8d$export$43feed32102720d2 = $42cbc74a64ab0a8d$export$6168dc8908a6c652.lex;


function $36d15394720e552f$export$546acb8157a2ef40(options) {
    if (typeof options === 'function') options = {
        highlight: options
    };
    if (!options || typeof options.highlight !== 'function') throw new Error('Must provide highlight function');
    if (typeof options.langPrefix !== 'string') options.langPrefix = 'language-';
    if (typeof options.emptyLangClass !== 'string') options.emptyLangClass = '';
    return {
        async: !!options.async,
        walkTokens (token) {
            if (token.type !== 'code') return;
            const lang = $36d15394720e552f$var$getLang(token.lang);
            if (options.async) return Promise.resolve(options.highlight(token.text, lang, token.lang || '')).then($36d15394720e552f$var$updateToken(token));
            const code = options.highlight(token.text, lang, token.lang || '');
            if (code instanceof Promise) throw new Error('markedHighlight is not set to async but the highlight function is async. Set the async option to true on markedHighlight to await the async highlight function.');
            $36d15394720e552f$var$updateToken(token)(code);
        },
        useNewRenderer: true,
        renderer: {
            code (code, infoString, escaped) {
                // istanbul ignore next
                if (typeof code === 'object') {
                    escaped = code.escaped;
                    infoString = code.lang;
                    code = code.text;
                }
                const lang = $36d15394720e552f$var$getLang(infoString);
                const classValue = lang ? options.langPrefix + $36d15394720e552f$var$escape(lang) : options.emptyLangClass;
                const classAttr = classValue ? ` class="${classValue}"` : '';
                code = code.replace(/\n$/, '');
                return `<pre><code${classAttr}>${escaped ? code : $36d15394720e552f$var$escape(code, true)}\n</code></pre>`;
            }
        }
    };
}
function $36d15394720e552f$var$getLang(lang) {
    return (lang || '').match(/\S*/)[0];
}
function $36d15394720e552f$var$updateToken(token) {
    return (code)=>{
        if (typeof code === 'string' && code !== token.text) {
            token.escaped = true;
            token.text = code;
        }
    };
}
// copied from marked helpers
const $36d15394720e552f$var$escapeTest = /[&<>"']/;
const $36d15394720e552f$var$escapeReplace = new RegExp($36d15394720e552f$var$escapeTest.source, 'g');
const $36d15394720e552f$var$escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
const $36d15394720e552f$var$escapeReplaceNoEncode = new RegExp($36d15394720e552f$var$escapeTestNoEncode.source, 'g');
const $36d15394720e552f$var$escapeReplacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
const $36d15394720e552f$var$getEscapeReplacement = (ch)=>$36d15394720e552f$var$escapeReplacements[ch];
function $36d15394720e552f$var$escape(html, encode) {
    if (encode) {
        if ($36d15394720e552f$var$escapeTest.test(html)) return html.replace($36d15394720e552f$var$escapeReplace, $36d15394720e552f$var$getEscapeReplacement);
    } else {
        if ($36d15394720e552f$var$escapeTestNoEncode.test(html)) return html.replace($36d15394720e552f$var$escapeReplaceNoEncode, $36d15394720e552f$var$getEscapeReplacement);
    }
    return html;
}


// https://nodejs.org/api/packages.html#packages_writing_dual_packages_while_avoiding_or_minimizing_hazards
var $f4840ac5e98a0872$exports = {};
/* eslint-disable no-multi-assign */ function $f4840ac5e98a0872$var$deepFreeze(obj) {
    if (obj instanceof Map) obj.clear = obj.delete = obj.set = function() {
        throw new Error('map is read-only');
    };
    else if (obj instanceof Set) obj.add = obj.clear = obj.delete = function() {
        throw new Error('set is read-only');
    };
    // Freeze self
    Object.freeze(obj);
    Object.getOwnPropertyNames(obj).forEach((name)=>{
        const prop = obj[name];
        const type = typeof prop;
        // Freeze prop if it is an object or function and also not already frozen
        if ((type === 'object' || type === 'function') && !Object.isFrozen(prop)) $f4840ac5e98a0872$var$deepFreeze(prop);
    });
    return obj;
}
/** @typedef {import('highlight.js').CallbackResponse} CallbackResponse */ /** @typedef {import('highlight.js').CompiledMode} CompiledMode */ /** @implements CallbackResponse */ class $f4840ac5e98a0872$var$Response {
    /**
   * @param {CompiledMode} mode
   */ constructor(mode){
        // eslint-disable-next-line no-undefined
        if (mode.data === undefined) mode.data = {};
        this.data = mode.data;
        this.isMatchIgnored = false;
    }
    ignoreMatch() {
        this.isMatchIgnored = true;
    }
}
/**
 * @param {string} value
 * @returns {string}
 */ function $f4840ac5e98a0872$var$escapeHTML(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
}
/**
 * performs a shallow merge of multiple objects into one
 *
 * @template T
 * @param {T} original
 * @param {Record<string,any>[]} objects
 * @returns {T} a single new object
 */ function $f4840ac5e98a0872$var$inherit$1(original, ...objects) {
    /** @type Record<string,any> */ const result = Object.create(null);
    for(const key in original)result[key] = original[key];
    objects.forEach(function(obj) {
        for(const key in obj)result[key] = obj[key];
    });
    return /** @type {T} */ result;
}
/**
 * @typedef {object} Renderer
 * @property {(text: string) => void} addText
 * @property {(node: Node) => void} openNode
 * @property {(node: Node) => void} closeNode
 * @property {() => string} value
 */ /** @typedef {{scope?: string, language?: string, sublanguage?: boolean}} Node */ /** @typedef {{walk: (r: Renderer) => void}} Tree */ /** */ const $f4840ac5e98a0872$var$SPAN_CLOSE = '</span>';
/**
 * Determines if a node needs to be wrapped in <span>
 *
 * @param {Node} node */ const $f4840ac5e98a0872$var$emitsWrappingTags = (node)=>{
    // rarely we can have a sublanguage where language is undefined
    // TODO: track down why
    return !!node.scope;
};
/**
 *
 * @param {string} name
 * @param {{prefix:string}} options
 */ const $f4840ac5e98a0872$var$scopeToCSSClass = (name, { prefix: prefix })=>{
    // sub-language
    if (name.startsWith("language:")) return name.replace("language:", "language-");
    // tiered scope: comment.line
    if (name.includes(".")) {
        const pieces = name.split(".");
        return [
            `${prefix}${pieces.shift()}`,
            ...pieces.map((x, i)=>`${x}${"_".repeat(i + 1)}`)
        ].join(" ");
    }
    // simple scope
    return `${prefix}${name}`;
};
/** @type {Renderer} */ class $f4840ac5e98a0872$var$HTMLRenderer {
    /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */ constructor(parseTree, options){
        this.buffer = "";
        this.classPrefix = options.classPrefix;
        parseTree.walk(this);
    }
    /**
   * Adds texts to the output stream
   *
   * @param {string} text */ addText(text) {
        this.buffer += $f4840ac5e98a0872$var$escapeHTML(text);
    }
    /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */ openNode(node) {
        if (!$f4840ac5e98a0872$var$emitsWrappingTags(node)) return;
        const className = $f4840ac5e98a0872$var$scopeToCSSClass(node.scope, {
            prefix: this.classPrefix
        });
        this.span(className);
    }
    /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */ closeNode(node) {
        if (!$f4840ac5e98a0872$var$emitsWrappingTags(node)) return;
        this.buffer += $f4840ac5e98a0872$var$SPAN_CLOSE;
    }
    /**
   * returns the accumulated buffer
  */ value() {
        return this.buffer;
    }
    // helpers
    /**
   * Builds a span element
   *
   * @param {string} className */ span(className) {
        this.buffer += `<span class="${className}">`;
    }
}
/** @typedef {{scope?: string, language?: string, children: Node[]} | string} Node */ /** @typedef {{scope?: string, language?: string, children: Node[]} } DataNode */ /** @typedef {import('highlight.js').Emitter} Emitter */ /**  */ /** @returns {DataNode} */ const $f4840ac5e98a0872$var$newNode = (opts = {})=>{
    /** @type DataNode */ const result = {
        children: []
    };
    Object.assign(result, opts);
    return result;
};
class $f4840ac5e98a0872$var$TokenTree {
    constructor(){
        /** @type DataNode */ this.rootNode = $f4840ac5e98a0872$var$newNode();
        this.stack = [
            this.rootNode
        ];
    }
    get top() {
        return this.stack[this.stack.length - 1];
    }
    get root() {
        return this.rootNode;
    }
    /** @param {Node} node */ add(node) {
        this.top.children.push(node);
    }
    /** @param {string} scope */ openNode(scope) {
        /** @type Node */ const node = $f4840ac5e98a0872$var$newNode({
            scope: scope
        });
        this.add(node);
        this.stack.push(node);
    }
    closeNode() {
        if (this.stack.length > 1) return this.stack.pop();
        // eslint-disable-next-line no-undefined
        return undefined;
    }
    closeAllNodes() {
        while(this.closeNode());
    }
    toJSON() {
        return JSON.stringify(this.rootNode, null, 4);
    }
    /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */ walk(builder) {
        // this does not
        return this.constructor._walk(builder, this.rootNode);
    // this works
    // return TokenTree._walk(builder, this.rootNode);
    }
    /**
   * @param {Renderer} builder
   * @param {Node} node
   */ static _walk(builder, node) {
        if (typeof node === "string") builder.addText(node);
        else if (node.children) {
            builder.openNode(node);
            node.children.forEach((child)=>this._walk(builder, child));
            builder.closeNode(node);
        }
        return builder;
    }
    /**
   * @param {Node} node
   */ static _collapse(node) {
        if (typeof node === "string") return;
        if (!node.children) return;
        if (node.children.every((el)=>typeof el === "string")) // node.text = node.children.join("");
        // delete node.children;
        node.children = [
            node.children.join("")
        ];
        else node.children.forEach((child)=>{
            $f4840ac5e98a0872$var$TokenTree._collapse(child);
        });
    }
}
/**
  Currently this is all private API, but this is the minimal API necessary
  that an Emitter must implement to fully support the parser.

  Minimal interface:

  - addText(text)
  - __addSublanguage(emitter, subLanguageName)
  - startScope(scope)
  - endScope()
  - finalize()
  - toHTML()

*/ /**
 * @implements {Emitter}
 */ class $f4840ac5e98a0872$var$TokenTreeEmitter extends $f4840ac5e98a0872$var$TokenTree {
    /**
   * @param {*} options
   */ constructor(options){
        super();
        this.options = options;
    }
    /**
   * @param {string} text
   */ addText(text) {
        if (text === "") return;
        this.add(text);
    }
    /** @param {string} scope */ startScope(scope) {
        this.openNode(scope);
    }
    endScope() {
        this.closeNode();
    }
    /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */ __addSublanguage(emitter, name) {
        /** @type DataNode */ const node = emitter.root;
        if (name) node.scope = `language:${name}`;
        this.add(node);
    }
    toHTML() {
        const renderer = new $f4840ac5e98a0872$var$HTMLRenderer(this, this.options);
        return renderer.value();
    }
    finalize() {
        this.closeAllNodes();
        return true;
    }
}
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $f4840ac5e98a0872$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $f4840ac5e98a0872$var$lookahead(re) {
    return $f4840ac5e98a0872$var$concat('(?=', re, ')');
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $f4840ac5e98a0872$var$anyNumberOfTimes(re) {
    return $f4840ac5e98a0872$var$concat('(?:', re, ')*');
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $f4840ac5e98a0872$var$optional(re) {
    return $f4840ac5e98a0872$var$concat('(?:', re, ')?');
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $f4840ac5e98a0872$var$concat(...args) {
    const joined = args.map((x)=>$f4840ac5e98a0872$var$source(x)).join("");
    return joined;
}
/**
 * @param { Array<string | RegExp | Object> } args
 * @returns {object}
 */ function $f4840ac5e98a0872$var$stripOptionsFromArgs(args) {
    const opts = args[args.length - 1];
    if (typeof opts === 'object' && opts.constructor === Object) {
        args.splice(args.length - 1, 1);
        return opts;
    } else return {};
}
/** @typedef { {capture?: boolean} } RegexEitherOptions */ /**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] | [...(RegExp | string)[], RegexEitherOptions]} args
 * @returns {string}
 */ function $f4840ac5e98a0872$var$either(...args) {
    /** @type { object & {capture?: boolean} }  */ const opts = $f4840ac5e98a0872$var$stripOptionsFromArgs(args);
    const joined = '(' + (opts.capture ? "" : "?:") + args.map((x)=>$f4840ac5e98a0872$var$source(x)).join("|") + ")";
    return joined;
}
/**
 * @param {RegExp | string} re
 * @returns {number}
 */ function $f4840ac5e98a0872$var$countMatchGroups(re) {
    return new RegExp(re.toString() + '|').exec('').length - 1;
}
/**
 * Does lexeme start with a regular expression match at the beginning
 * @param {RegExp} re
 * @param {string} lexeme
 */ function $f4840ac5e98a0872$var$startsWith(re, lexeme) {
    const match = re && re.exec(lexeme);
    return match && match.index === 0;
}
// BACKREF_RE matches an open parenthesis or backreference. To avoid an
// incorrect parse, it also matches the constructs where the meaning of
// parentheses, escapes, or capture counting changes.
const $f4840ac5e98a0872$var$BACKREF_RE = new RegExp($f4840ac5e98a0872$var$either(/\[(?:[^\\\]]|\\.)*\]/, /\(\?<(?![=!])[^>]+>/, /\(\?'[^']+'/, /\(\??/, /\\([1-9][0-9]*)/, /\\./ // any other escape sequence
));
// **INTERNAL** Not intended for outside usage
// join logically computes regexps.join(separator), but fixes the
// backreferences so they continue to match.
// it also places each individual regular expression into it's own
// match group, keeping track of the sequencing of those match groups
// is currently an exercise for the caller. :-)
/**
 * @param {(string | RegExp)[]} regexps
 * @param {{joinWith: string}} opts
 * @returns {string}
 */ function $f4840ac5e98a0872$var$_rewriteBackreferences(regexps, { joinWith: joinWith }) {
    let numCaptures = 0;
    return regexps.map((regex)=>{
        numCaptures += 1;
        const offset = numCaptures;
        let re = $f4840ac5e98a0872$var$source(regex);
        let out = '';
        while(re.length > 0){
            const match = $f4840ac5e98a0872$var$BACKREF_RE.exec(re);
            if (!match) {
                out += re;
                break;
            }
            out += re.substring(0, match.index);
            re = re.substring(match.index + match[0].length);
            if (match[0][0] === '\\' && match[1]) // Adjust the backreference.
            out += '\\' + String(Number(match[1]) + offset);
            else {
                out += match[0];
                if (match[0] === '(' || /^\(\?[<']/.test(match[0])) numCaptures++;
            }
        }
        return out;
    }).map((re)=>`(${re})`).join(joinWith);
}
/** @typedef {import('highlight.js').Mode} Mode */ /** @typedef {import('highlight.js').ModeCallback} ModeCallback */ // Common regexps
const $f4840ac5e98a0872$var$MATCH_NOTHING_RE = /\b\B/;
const $f4840ac5e98a0872$var$IDENT_RE = '[a-zA-Z]\\w*';
const $f4840ac5e98a0872$var$UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
const $f4840ac5e98a0872$var$NUMBER_RE = '\\b\\d+(\\.\\d+)?';
const $f4840ac5e98a0872$var$C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
const $f4840ac5e98a0872$var$BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
const $f4840ac5e98a0872$var$RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';
/**
* @param { Partial<Mode> & {binary?: string | RegExp} } opts
*/ const $f4840ac5e98a0872$var$SHEBANG = (opts = {})=>{
    const beginShebang = /^#![ ]*\//;
    if (opts.binary) opts.begin = $f4840ac5e98a0872$var$concat(beginShebang, /.*\b/, opts.binary, /\b.*/);
    return $f4840ac5e98a0872$var$inherit$1({
        scope: 'meta',
        begin: beginShebang,
        end: /$/,
        relevance: 0,
        /** @type {ModeCallback} */ "on:begin": (m, resp)=>{
            if (m.index !== 0) resp.ignoreMatch();
        }
    }, opts);
};
// Common modes
const $f4840ac5e98a0872$var$BACKSLASH_ESCAPE = {
    begin: '\\\\[\\s\\S]',
    relevance: 0
};
const $f4840ac5e98a0872$var$APOS_STRING_MODE = {
    scope: 'string',
    begin: '\'',
    end: '\'',
    illegal: '\\n',
    contains: [
        $f4840ac5e98a0872$var$BACKSLASH_ESCAPE
    ]
};
const $f4840ac5e98a0872$var$QUOTE_STRING_MODE = {
    scope: 'string',
    begin: '"',
    end: '"',
    illegal: '\\n',
    contains: [
        $f4840ac5e98a0872$var$BACKSLASH_ESCAPE
    ]
};
const $f4840ac5e98a0872$var$PHRASAL_WORDS_MODE = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
};
/**
 * Creates a comment mode
 *
 * @param {string | RegExp} begin
 * @param {string | RegExp} end
 * @param {Mode | {}} [modeOptions]
 * @returns {Partial<Mode>}
 */ const $f4840ac5e98a0872$var$COMMENT = function(begin, end, modeOptions = {}) {
    const mode = $f4840ac5e98a0872$var$inherit$1({
        scope: 'comment',
        begin: begin,
        end: end,
        contains: []
    }, modeOptions);
    mode.contains.push({
        scope: 'doctag',
        // hack to avoid the space from being included. the space is necessary to
        // match here to prevent the plain text rule below from gobbling up doctags
        begin: '[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)',
        end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
        excludeBegin: true,
        relevance: 0
    });
    const ENGLISH_WORD = $f4840ac5e98a0872$var$either(// list of common 1 and 2 letter words in English
    "I", "a", "is", "so", "us", "to", "at", "if", "in", "it", "on", // note: this is not an exhaustive list of contractions, just popular ones
    /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, /[A-Za-z]+[-][a-z]+/, /[A-Za-z][a-z]{2,}/ // allow capitalized words at beginning of sentences
    );
    // looking like plain text, more likely to be a comment
    mode.contains.push({
        // TODO: how to include ", (, ) without breaking grammars that use these for
        // comment delimiters?
        // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
        // ---
        // this tries to find sequences of 3 english words in a row (without any
        // "programming" type syntax) this gives us a strong signal that we've
        // TRULY found a comment - vs perhaps scanning with the wrong language.
        // It's possible to find something that LOOKS like the start of the
        // comment - but then if there is no readable text - good chance it is a
        // false match and not a comment.
        //
        // for a visual example please see:
        // https://github.com/highlightjs/highlight.js/issues/2827
        begin: $f4840ac5e98a0872$var$concat(/[ ]+/, '(', ENGLISH_WORD, /[.]?[:]?([.][ ]|[ ])/, '){3}') // look for 3 words in a row
    });
    return mode;
};
const $f4840ac5e98a0872$var$C_LINE_COMMENT_MODE = $f4840ac5e98a0872$var$COMMENT('//', '$');
const $f4840ac5e98a0872$var$C_BLOCK_COMMENT_MODE = $f4840ac5e98a0872$var$COMMENT('/\\*', '\\*/');
const $f4840ac5e98a0872$var$HASH_COMMENT_MODE = $f4840ac5e98a0872$var$COMMENT('#', '$');
const $f4840ac5e98a0872$var$NUMBER_MODE = {
    scope: 'number',
    begin: $f4840ac5e98a0872$var$NUMBER_RE,
    relevance: 0
};
const $f4840ac5e98a0872$var$C_NUMBER_MODE = {
    scope: 'number',
    begin: $f4840ac5e98a0872$var$C_NUMBER_RE,
    relevance: 0
};
const $f4840ac5e98a0872$var$BINARY_NUMBER_MODE = {
    scope: 'number',
    begin: $f4840ac5e98a0872$var$BINARY_NUMBER_RE,
    relevance: 0
};
const $f4840ac5e98a0872$var$REGEXP_MODE = {
    scope: "regexp",
    begin: /\/(?=[^/\n]*\/)/,
    end: /\/[gimuy]*/,
    contains: [
        $f4840ac5e98a0872$var$BACKSLASH_ESCAPE,
        {
            begin: /\[/,
            end: /\]/,
            relevance: 0,
            contains: [
                $f4840ac5e98a0872$var$BACKSLASH_ESCAPE
            ]
        }
    ]
};
const $f4840ac5e98a0872$var$TITLE_MODE = {
    scope: 'title',
    begin: $f4840ac5e98a0872$var$IDENT_RE,
    relevance: 0
};
const $f4840ac5e98a0872$var$UNDERSCORE_TITLE_MODE = {
    scope: 'title',
    begin: $f4840ac5e98a0872$var$UNDERSCORE_IDENT_RE,
    relevance: 0
};
const $f4840ac5e98a0872$var$METHOD_GUARD = {
    // excludes method names from keyword processing
    begin: '\\.\\s*' + $f4840ac5e98a0872$var$UNDERSCORE_IDENT_RE,
    relevance: 0
};
/**
 * Adds end same as begin mechanics to a mode
 *
 * Your mode must include at least a single () match group as that first match
 * group is what is used for comparison
 * @param {Partial<Mode>} mode
 */ const $f4840ac5e98a0872$var$END_SAME_AS_BEGIN = function(mode) {
    return Object.assign(mode, {
        /** @type {ModeCallback} */ 'on:begin': (m, resp)=>{
            resp.data._beginMatch = m[1];
        },
        /** @type {ModeCallback} */ 'on:end': (m, resp)=>{
            if (resp.data._beginMatch !== m[1]) resp.ignoreMatch();
        }
    });
};
var $f4840ac5e98a0872$var$MODES = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    APOS_STRING_MODE: $f4840ac5e98a0872$var$APOS_STRING_MODE,
    BACKSLASH_ESCAPE: $f4840ac5e98a0872$var$BACKSLASH_ESCAPE,
    BINARY_NUMBER_MODE: $f4840ac5e98a0872$var$BINARY_NUMBER_MODE,
    BINARY_NUMBER_RE: $f4840ac5e98a0872$var$BINARY_NUMBER_RE,
    COMMENT: $f4840ac5e98a0872$var$COMMENT,
    C_BLOCK_COMMENT_MODE: $f4840ac5e98a0872$var$C_BLOCK_COMMENT_MODE,
    C_LINE_COMMENT_MODE: $f4840ac5e98a0872$var$C_LINE_COMMENT_MODE,
    C_NUMBER_MODE: $f4840ac5e98a0872$var$C_NUMBER_MODE,
    C_NUMBER_RE: $f4840ac5e98a0872$var$C_NUMBER_RE,
    END_SAME_AS_BEGIN: $f4840ac5e98a0872$var$END_SAME_AS_BEGIN,
    HASH_COMMENT_MODE: $f4840ac5e98a0872$var$HASH_COMMENT_MODE,
    IDENT_RE: $f4840ac5e98a0872$var$IDENT_RE,
    MATCH_NOTHING_RE: $f4840ac5e98a0872$var$MATCH_NOTHING_RE,
    METHOD_GUARD: $f4840ac5e98a0872$var$METHOD_GUARD,
    NUMBER_MODE: $f4840ac5e98a0872$var$NUMBER_MODE,
    NUMBER_RE: $f4840ac5e98a0872$var$NUMBER_RE,
    PHRASAL_WORDS_MODE: $f4840ac5e98a0872$var$PHRASAL_WORDS_MODE,
    QUOTE_STRING_MODE: $f4840ac5e98a0872$var$QUOTE_STRING_MODE,
    REGEXP_MODE: $f4840ac5e98a0872$var$REGEXP_MODE,
    RE_STARTERS_RE: $f4840ac5e98a0872$var$RE_STARTERS_RE,
    SHEBANG: $f4840ac5e98a0872$var$SHEBANG,
    TITLE_MODE: $f4840ac5e98a0872$var$TITLE_MODE,
    UNDERSCORE_IDENT_RE: $f4840ac5e98a0872$var$UNDERSCORE_IDENT_RE,
    UNDERSCORE_TITLE_MODE: $f4840ac5e98a0872$var$UNDERSCORE_TITLE_MODE
});
/**
@typedef {import('highlight.js').CallbackResponse} CallbackResponse
@typedef {import('highlight.js').CompilerExt} CompilerExt
*/ // Grammar extensions / plugins
// See: https://github.com/highlightjs/highlight.js/issues/2833
// Grammar extensions allow "syntactic sugar" to be added to the grammar modes
// without requiring any underlying changes to the compiler internals.
// `compileMatch` being the perfect small example of now allowing a grammar
// author to write `match` when they desire to match a single expression rather
// than being forced to use `begin`.  The extension then just moves `match` into
// `begin` when it runs.  Ie, no features have been added, but we've just made
// the experience of writing (and reading grammars) a little bit nicer.
// ------
// TODO: We need negative look-behind support to do this properly
/**
 * Skip a match if it has a preceding dot
 *
 * This is used for `beginKeywords` to prevent matching expressions such as
 * `bob.keyword.do()`. The mode compiler automatically wires this up as a
 * special _internal_ 'on:begin' callback for modes with `beginKeywords`
 * @param {RegExpMatchArray} match
 * @param {CallbackResponse} response
 */ function $f4840ac5e98a0872$var$skipIfHasPrecedingDot(match, response) {
    const before = match.input[match.index - 1];
    if (before === ".") response.ignoreMatch();
}
/**
 *
 * @type {CompilerExt}
 */ function $f4840ac5e98a0872$var$scopeClassName(mode, _parent) {
    // eslint-disable-next-line no-undefined
    if (mode.className !== undefined) {
        mode.scope = mode.className;
        delete mode.className;
    }
}
/**
 * `beginKeywords` syntactic sugar
 * @type {CompilerExt}
 */ function $f4840ac5e98a0872$var$beginKeywords(mode, parent) {
    if (!parent) return;
    if (!mode.beginKeywords) return;
    // for languages with keywords that include non-word characters checking for
    // a word boundary is not sufficient, so instead we check for a word boundary
    // or whitespace - this does no harm in any case since our keyword engine
    // doesn't allow spaces in keywords anyways and we still check for the boundary
    // first
    mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')(?!\\.)(?=\\b|\\s)';
    mode.__beforeBegin = $f4840ac5e98a0872$var$skipIfHasPrecedingDot;
    mode.keywords = mode.keywords || mode.beginKeywords;
    delete mode.beginKeywords;
    // prevents double relevance, the keywords themselves provide
    // relevance, the mode doesn't need to double it
    // eslint-disable-next-line no-undefined
    if (mode.relevance === undefined) mode.relevance = 0;
}
/**
 * Allow `illegal` to contain an array of illegal values
 * @type {CompilerExt}
 */ function $f4840ac5e98a0872$var$compileIllegal(mode, _parent) {
    if (!Array.isArray(mode.illegal)) return;
    mode.illegal = $f4840ac5e98a0872$var$either(...mode.illegal);
}
/**
 * `match` to match a single expression for readability
 * @type {CompilerExt}
 */ function $f4840ac5e98a0872$var$compileMatch(mode, _parent) {
    if (!mode.match) return;
    if (mode.begin || mode.end) throw new Error("begin & end are not supported with match");
    mode.begin = mode.match;
    delete mode.match;
}
/**
 * provides the default 1 relevance to all modes
 * @type {CompilerExt}
 */ function $f4840ac5e98a0872$var$compileRelevance(mode, _parent) {
    // eslint-disable-next-line no-undefined
    if (mode.relevance === undefined) mode.relevance = 1;
}
// allow beforeMatch to act as a "qualifier" for the match
// the full match begin must be [beforeMatch][begin]
const $f4840ac5e98a0872$var$beforeMatchExt = (mode, parent)=>{
    if (!mode.beforeMatch) return;
    // starts conflicts with endsParent which we need to make sure the child
    // rule is not matched multiple times
    if (mode.starts) throw new Error("beforeMatch cannot be used with starts");
    const originalMode = Object.assign({}, mode);
    Object.keys(mode).forEach((key)=>{
        delete mode[key];
    });
    mode.keywords = originalMode.keywords;
    mode.begin = $f4840ac5e98a0872$var$concat(originalMode.beforeMatch, $f4840ac5e98a0872$var$lookahead(originalMode.begin));
    mode.starts = {
        relevance: 0,
        contains: [
            Object.assign(originalMode, {
                endsParent: true
            })
        ]
    };
    mode.relevance = 0;
    delete originalMode.beforeMatch;
};
// keywords that should have no default relevance value
const $f4840ac5e98a0872$var$COMMON_KEYWORDS = [
    'of',
    'and',
    'for',
    'in',
    'not',
    'or',
    'if',
    'then',
    'parent',
    'list',
    'value' // common variable name
];
const $f4840ac5e98a0872$var$DEFAULT_KEYWORD_SCOPE = "keyword";
/**
 * Given raw keywords from a language definition, compile them.
 *
 * @param {string | Record<string,string|string[]> | Array<string>} rawKeywords
 * @param {boolean} caseInsensitive
 */ function $f4840ac5e98a0872$var$compileKeywords(rawKeywords, caseInsensitive, scopeName = $f4840ac5e98a0872$var$DEFAULT_KEYWORD_SCOPE) {
    /** @type {import("highlight.js/private").KeywordDict} */ const compiledKeywords = Object.create(null);
    // input can be a string of keywords, an array of keywords, or a object with
    // named keys representing scopeName (which can then point to a string or array)
    if (typeof rawKeywords === 'string') compileList(scopeName, rawKeywords.split(" "));
    else if (Array.isArray(rawKeywords)) compileList(scopeName, rawKeywords);
    else Object.keys(rawKeywords).forEach(function(scopeName) {
        // collapse all our objects back into the parent object
        Object.assign(compiledKeywords, $f4840ac5e98a0872$var$compileKeywords(rawKeywords[scopeName], caseInsensitive, scopeName));
    });
    return compiledKeywords;
    // ---
    /**
   * Compiles an individual list of keywords
   *
   * Ex: "for if when while|5"
   *
   * @param {string} scopeName
   * @param {Array<string>} keywordList
   */ function compileList(scopeName, keywordList) {
        if (caseInsensitive) keywordList = keywordList.map((x)=>x.toLowerCase());
        keywordList.forEach(function(keyword) {
            const pair = keyword.split('|');
            compiledKeywords[pair[0]] = [
                scopeName,
                $f4840ac5e98a0872$var$scoreForKeyword(pair[0], pair[1])
            ];
        });
    }
}
/**
 * Returns the proper score for a given keyword
 *
 * Also takes into account comment keywords, which will be scored 0 UNLESS
 * another score has been manually assigned.
 * @param {string} keyword
 * @param {string} [providedScore]
 */ function $f4840ac5e98a0872$var$scoreForKeyword(keyword, providedScore) {
    // manual scores always win over common keywords
    // so you can force a score of 1 if you really insist
    if (providedScore) return Number(providedScore);
    return $f4840ac5e98a0872$var$commonKeyword(keyword) ? 0 : 1;
}
/**
 * Determines if a given keyword is common or not
 *
 * @param {string} keyword */ function $f4840ac5e98a0872$var$commonKeyword(keyword) {
    return $f4840ac5e98a0872$var$COMMON_KEYWORDS.includes(keyword.toLowerCase());
}
/*

For the reasoning behind this please see:
https://github.com/highlightjs/highlight.js/issues/2880#issuecomment-747275419

*/ /**
 * @type {Record<string, boolean>}
 */ const $f4840ac5e98a0872$var$seenDeprecations = {};
/**
 * @param {string} message
 */ const $f4840ac5e98a0872$var$error = (message)=>{
    console.error(message);
};
/**
 * @param {string} message
 * @param {any} args
 */ const $f4840ac5e98a0872$var$warn = (message, ...args)=>{
    console.log(`WARN: ${message}`, ...args);
};
/**
 * @param {string} version
 * @param {string} message
 */ const $f4840ac5e98a0872$var$deprecated = (version, message)=>{
    if ($f4840ac5e98a0872$var$seenDeprecations[`${version}/${message}`]) return;
    console.log(`Deprecated as of ${version}. ${message}`);
    $f4840ac5e98a0872$var$seenDeprecations[`${version}/${message}`] = true;
};
/* eslint-disable no-throw-literal */ /**
@typedef {import('highlight.js').CompiledMode} CompiledMode
*/ const $f4840ac5e98a0872$var$MultiClassError = new Error();
/**
 * Renumbers labeled scope names to account for additional inner match
 * groups that otherwise would break everything.
 *
 * Lets say we 3 match scopes:
 *
 *   { 1 => ..., 2 => ..., 3 => ... }
 *
 * So what we need is a clean match like this:
 *
 *   (a)(b)(c) => [ "a", "b", "c" ]
 *
 * But this falls apart with inner match groups:
 *
 * (a)(((b)))(c) => ["a", "b", "b", "b", "c" ]
 *
 * Our scopes are now "out of alignment" and we're repeating `b` 3 times.
 * What needs to happen is the numbers are remapped:
 *
 *   { 1 => ..., 2 => ..., 5 => ... }
 *
 * We also need to know that the ONLY groups that should be output
 * are 1, 2, and 5.  This function handles this behavior.
 *
 * @param {CompiledMode} mode
 * @param {Array<RegExp | string>} regexes
 * @param {{key: "beginScope"|"endScope"}} opts
 */ function $f4840ac5e98a0872$var$remapScopeNames(mode, regexes, { key: key }) {
    let offset = 0;
    const scopeNames = mode[key];
    /** @type Record<number,boolean> */ const emit = {};
    /** @type Record<number,string> */ const positions = {};
    for(let i = 1; i <= regexes.length; i++){
        positions[i + offset] = scopeNames[i];
        emit[i + offset] = true;
        offset += $f4840ac5e98a0872$var$countMatchGroups(regexes[i - 1]);
    }
    // we use _emit to keep track of which match groups are "top-level" to avoid double
    // output from inside match groups
    mode[key] = positions;
    mode[key]._emit = emit;
    mode[key]._multi = true;
}
/**
 * @param {CompiledMode} mode
 */ function $f4840ac5e98a0872$var$beginMultiClass(mode) {
    if (!Array.isArray(mode.begin)) return;
    if (mode.skip || mode.excludeBegin || mode.returnBegin) {
        $f4840ac5e98a0872$var$error("skip, excludeBegin, returnBegin not compatible with beginScope: {}");
        throw $f4840ac5e98a0872$var$MultiClassError;
    }
    if (typeof mode.beginScope !== "object" || mode.beginScope === null) {
        $f4840ac5e98a0872$var$error("beginScope must be object");
        throw $f4840ac5e98a0872$var$MultiClassError;
    }
    $f4840ac5e98a0872$var$remapScopeNames(mode, mode.begin, {
        key: "beginScope"
    });
    mode.begin = $f4840ac5e98a0872$var$_rewriteBackreferences(mode.begin, {
        joinWith: ""
    });
}
/**
 * @param {CompiledMode} mode
 */ function $f4840ac5e98a0872$var$endMultiClass(mode) {
    if (!Array.isArray(mode.end)) return;
    if (mode.skip || mode.excludeEnd || mode.returnEnd) {
        $f4840ac5e98a0872$var$error("skip, excludeEnd, returnEnd not compatible with endScope: {}");
        throw $f4840ac5e98a0872$var$MultiClassError;
    }
    if (typeof mode.endScope !== "object" || mode.endScope === null) {
        $f4840ac5e98a0872$var$error("endScope must be object");
        throw $f4840ac5e98a0872$var$MultiClassError;
    }
    $f4840ac5e98a0872$var$remapScopeNames(mode, mode.end, {
        key: "endScope"
    });
    mode.end = $f4840ac5e98a0872$var$_rewriteBackreferences(mode.end, {
        joinWith: ""
    });
}
/**
 * this exists only to allow `scope: {}` to be used beside `match:`
 * Otherwise `beginScope` would necessary and that would look weird

  {
    match: [ /def/, /\w+/ ]
    scope: { 1: "keyword" , 2: "title" }
  }

 * @param {CompiledMode} mode
 */ function $f4840ac5e98a0872$var$scopeSugar(mode) {
    if (mode.scope && typeof mode.scope === "object" && mode.scope !== null) {
        mode.beginScope = mode.scope;
        delete mode.scope;
    }
}
/**
 * @param {CompiledMode} mode
 */ function $f4840ac5e98a0872$var$MultiClass(mode) {
    $f4840ac5e98a0872$var$scopeSugar(mode);
    if (typeof mode.beginScope === "string") mode.beginScope = {
        _wrap: mode.beginScope
    };
    if (typeof mode.endScope === "string") mode.endScope = {
        _wrap: mode.endScope
    };
    $f4840ac5e98a0872$var$beginMultiClass(mode);
    $f4840ac5e98a0872$var$endMultiClass(mode);
}
/**
@typedef {import('highlight.js').Mode} Mode
@typedef {import('highlight.js').CompiledMode} CompiledMode
@typedef {import('highlight.js').Language} Language
@typedef {import('highlight.js').HLJSPlugin} HLJSPlugin
@typedef {import('highlight.js').CompiledLanguage} CompiledLanguage
*/ // compilation
/**
 * Compiles a language definition result
 *
 * Given the raw result of a language definition (Language), compiles this so
 * that it is ready for highlighting code.
 * @param {Language} language
 * @returns {CompiledLanguage}
 */ function $f4840ac5e98a0872$var$compileLanguage(language) {
    /**
   * Builds a regex with the case sensitivity of the current language
   *
   * @param {RegExp | string} value
   * @param {boolean} [global]
   */ function langRe(value, global) {
        return new RegExp($f4840ac5e98a0872$var$source(value), 'm' + (language.case_insensitive ? 'i' : '') + (language.unicodeRegex ? 'u' : '') + (global ? 'g' : ''));
    }
    /**
    Stores multiple regular expressions and allows you to quickly search for
    them all in a string simultaneously - returning the first match.  It does
    this by creating a huge (a|b|c) regex - each individual item wrapped with ()
    and joined by `|` - using match groups to track position.  When a match is
    found checking which position in the array has content allows us to figure
    out which of the original regexes / match groups triggered the match.

    The match object itself (the result of `Regex.exec`) is returned but also
    enhanced by merging in any meta-data that was registered with the regex.
    This is how we keep track of which mode matched, and what type of rule
    (`illegal`, `begin`, end, etc).
  */ class MultiRegex {
        constructor(){
            this.matchIndexes = {};
            // @ts-ignore
            this.regexes = [];
            this.matchAt = 1;
            this.position = 0;
        }
        // @ts-ignore
        addRule(re, opts) {
            opts.position = this.position++;
            // @ts-ignore
            this.matchIndexes[this.matchAt] = opts;
            this.regexes.push([
                opts,
                re
            ]);
            this.matchAt += $f4840ac5e98a0872$var$countMatchGroups(re) + 1;
        }
        compile() {
            if (this.regexes.length === 0) // avoids the need to check length every time exec is called
            // @ts-ignore
            this.exec = ()=>null;
            const terminators = this.regexes.map((el)=>el[1]);
            this.matcherRe = langRe($f4840ac5e98a0872$var$_rewriteBackreferences(terminators, {
                joinWith: '|'
            }), true);
            this.lastIndex = 0;
        }
        /** @param {string} s */ exec(s) {
            this.matcherRe.lastIndex = this.lastIndex;
            const match = this.matcherRe.exec(s);
            if (!match) return null;
            // eslint-disable-next-line no-undefined
            const i = match.findIndex((el, i)=>i > 0 && el !== undefined);
            // @ts-ignore
            const matchData = this.matchIndexes[i];
            // trim off any earlier non-relevant match groups (ie, the other regex
            // match groups that make up the multi-matcher)
            match.splice(0, i);
            return Object.assign(match, matchData);
        }
    }
    /*
    Created to solve the key deficiently with MultiRegex - there is no way to
    test for multiple matches at a single location.  Why would we need to do
    that?  In the future a more dynamic engine will allow certain matches to be
    ignored.  An example: if we matched say the 3rd regex in a large group but
    decided to ignore it - we'd need to started testing again at the 4th
    regex... but MultiRegex itself gives us no real way to do that.

    So what this class creates MultiRegexs on the fly for whatever search
    position they are needed.

    NOTE: These additional MultiRegex objects are created dynamically.  For most
    grammars most of the time we will never actually need anything more than the
    first MultiRegex - so this shouldn't have too much overhead.

    Say this is our search group, and we match regex3, but wish to ignore it.

      regex1 | regex2 | regex3 | regex4 | regex5    ' ie, startAt = 0

    What we need is a new MultiRegex that only includes the remaining
    possibilities:

      regex4 | regex5                               ' ie, startAt = 3

    This class wraps all that complexity up in a simple API... `startAt` decides
    where in the array of expressions to start doing the matching. It
    auto-increments, so if a match is found at position 2, then startAt will be
    set to 3.  If the end is reached startAt will return to 0.

    MOST of the time the parser will be setting startAt manually to 0.
  */ class ResumableMultiRegex {
        constructor(){
            // @ts-ignore
            this.rules = [];
            // @ts-ignore
            this.multiRegexes = [];
            this.count = 0;
            this.lastIndex = 0;
            this.regexIndex = 0;
        }
        // @ts-ignore
        getMatcher(index) {
            if (this.multiRegexes[index]) return this.multiRegexes[index];
            const matcher = new MultiRegex();
            this.rules.slice(index).forEach(([re, opts])=>matcher.addRule(re, opts));
            matcher.compile();
            this.multiRegexes[index] = matcher;
            return matcher;
        }
        resumingScanAtSamePosition() {
            return this.regexIndex !== 0;
        }
        considerAll() {
            this.regexIndex = 0;
        }
        // @ts-ignore
        addRule(re, opts) {
            this.rules.push([
                re,
                opts
            ]);
            if (opts.type === "begin") this.count++;
        }
        /** @param {string} s */ exec(s) {
            const m = this.getMatcher(this.regexIndex);
            m.lastIndex = this.lastIndex;
            let result = m.exec(s);
            // The following is because we have no easy way to say "resume scanning at the
            // existing position but also skip the current rule ONLY". What happens is
            // all prior rules are also skipped which can result in matching the wrong
            // thing. Example of matching "booger":
            // our matcher is [string, "booger", number]
            //
            // ....booger....
            // if "booger" is ignored then we'd really need a regex to scan from the
            // SAME position for only: [string, number] but ignoring "booger" (if it
            // was the first match), a simple resume would scan ahead who knows how
            // far looking only for "number", ignoring potential string matches (or
            // future "booger" matches that might be valid.)
            // So what we do: We execute two matchers, one resuming at the same
            // position, but the second full matcher starting at the position after:
            //     /--- resume first regex match here (for [number])
            //     |/---- full match here for [string, "booger", number]
            //     vv
            // ....booger....
            // Which ever results in a match first is then used. So this 3-4 step
            // process essentially allows us to say "match at this position, excluding
            // a prior rule that was ignored".
            //
            // 1. Match "booger" first, ignore. Also proves that [string] does non match.
            // 2. Resume matching for [number]
            // 3. Match at index + 1 for [string, "booger", number]
            // 4. If #2 and #3 result in matches, which came first?
            if (this.resumingScanAtSamePosition()) {
                if (result && result.index === this.lastIndex) ;
                else {
                    const m2 = this.getMatcher(0);
                    m2.lastIndex = this.lastIndex + 1;
                    result = m2.exec(s);
                }
            }
            if (result) {
                this.regexIndex += result.position + 1;
                if (this.regexIndex === this.count) // wrap-around to considering all matches again
                this.considerAll();
            }
            return result;
        }
    }
    /**
   * Given a mode, builds a huge ResumableMultiRegex that can be used to walk
   * the content and find matches.
   *
   * @param {CompiledMode} mode
   * @returns {ResumableMultiRegex}
   */ function buildModeRegex(mode) {
        const mm = new ResumableMultiRegex();
        mode.contains.forEach((term)=>mm.addRule(term.begin, {
                rule: term,
                type: "begin"
            }));
        if (mode.terminatorEnd) mm.addRule(mode.terminatorEnd, {
            type: "end"
        });
        if (mode.illegal) mm.addRule(mode.illegal, {
            type: "illegal"
        });
        return mm;
    }
    /** skip vs abort vs ignore
   *
   * @skip   - The mode is still entered and exited normally (and contains rules apply),
   *           but all content is held and added to the parent buffer rather than being
   *           output when the mode ends.  Mostly used with `sublanguage` to build up
   *           a single large buffer than can be parsed by sublanguage.
   *
   *             - The mode begin ands ends normally.
   *             - Content matched is added to the parent mode buffer.
   *             - The parser cursor is moved forward normally.
   *
   * @abort  - A hack placeholder until we have ignore.  Aborts the mode (as if it
   *           never matched) but DOES NOT continue to match subsequent `contains`
   *           modes.  Abort is bad/suboptimal because it can result in modes
   *           farther down not getting applied because an earlier rule eats the
   *           content but then aborts.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is added to the mode buffer.
   *             - The parser cursor is moved forward accordingly.
   *
   * @ignore - Ignores the mode (as if it never matched) and continues to match any
   *           subsequent `contains` modes.  Ignore isn't technically possible with
   *           the current parser implementation.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is ignored.
   *             - The parser cursor is not moved forward.
   */ /**
   * Compiles an individual mode
   *
   * This can raise an error if the mode contains certain detectable known logic
   * issues.
   * @param {Mode} mode
   * @param {CompiledMode | null} [parent]
   * @returns {CompiledMode | never}
   */ function compileMode(mode, parent) {
        const cmode = /** @type CompiledMode */ mode;
        if (mode.isCompiled) return cmode;
        [
            $f4840ac5e98a0872$var$scopeClassName,
            // do this early so compiler extensions generally don't have to worry about
            // the distinction between match/begin
            $f4840ac5e98a0872$var$compileMatch,
            $f4840ac5e98a0872$var$MultiClass,
            $f4840ac5e98a0872$var$beforeMatchExt
        ].forEach((ext)=>ext(mode, parent));
        language.compilerExtensions.forEach((ext)=>ext(mode, parent));
        // __beforeBegin is considered private API, internal use only
        mode.__beforeBegin = null;
        [
            $f4840ac5e98a0872$var$beginKeywords,
            // do this later so compiler extensions that come earlier have access to the
            // raw array if they wanted to perhaps manipulate it, etc.
            $f4840ac5e98a0872$var$compileIllegal,
            // default to 1 relevance if not specified
            $f4840ac5e98a0872$var$compileRelevance
        ].forEach((ext)=>ext(mode, parent));
        mode.isCompiled = true;
        let keywordPattern = null;
        if (typeof mode.keywords === "object" && mode.keywords.$pattern) {
            // we need a copy because keywords might be compiled multiple times
            // so we can't go deleting $pattern from the original on the first
            // pass
            mode.keywords = Object.assign({}, mode.keywords);
            keywordPattern = mode.keywords.$pattern;
            delete mode.keywords.$pattern;
        }
        keywordPattern = keywordPattern || /\w+/;
        if (mode.keywords) mode.keywords = $f4840ac5e98a0872$var$compileKeywords(mode.keywords, language.case_insensitive);
        cmode.keywordPatternRe = langRe(keywordPattern, true);
        if (parent) {
            if (!mode.begin) mode.begin = /\B|\b/;
            cmode.beginRe = langRe(cmode.begin);
            if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
            if (mode.end) cmode.endRe = langRe(cmode.end);
            cmode.terminatorEnd = $f4840ac5e98a0872$var$source(cmode.end) || '';
            if (mode.endsWithParent && parent.terminatorEnd) cmode.terminatorEnd += (mode.end ? '|' : '') + parent.terminatorEnd;
        }
        if (mode.illegal) cmode.illegalRe = langRe(/** @type {RegExp | string} */ mode.illegal);
        if (!mode.contains) mode.contains = [];
        mode.contains = [].concat(...mode.contains.map(function(c) {
            return $f4840ac5e98a0872$var$expandOrCloneMode(c === 'self' ? mode : c);
        }));
        mode.contains.forEach(function(c) {
            compileMode(/** @type Mode */ c, cmode);
        });
        if (mode.starts) compileMode(mode.starts, parent);
        cmode.matcher = buildModeRegex(cmode);
        return cmode;
    }
    if (!language.compilerExtensions) language.compilerExtensions = [];
    // self is not valid at the top-level
    if (language.contains && language.contains.includes('self')) throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
    // we need a null object, which inherit will guarantee
    language.classNameAliases = $f4840ac5e98a0872$var$inherit$1(language.classNameAliases || {});
    return compileMode(/** @type Mode */ language);
}
/**
 * Determines if a mode has a dependency on it's parent or not
 *
 * If a mode does have a parent dependency then often we need to clone it if
 * it's used in multiple places so that each copy points to the correct parent,
 * where-as modes without a parent can often safely be re-used at the bottom of
 * a mode chain.
 *
 * @param {Mode | null} mode
 * @returns {boolean} - is there a dependency on the parent?
 * */ function $f4840ac5e98a0872$var$dependencyOnParent(mode) {
    if (!mode) return false;
    return mode.endsWithParent || $f4840ac5e98a0872$var$dependencyOnParent(mode.starts);
}
/**
 * Expands a mode or clones it if necessary
 *
 * This is necessary for modes with parental dependenceis (see notes on
 * `dependencyOnParent`) and for nodes that have `variants` - which must then be
 * exploded into their own individual modes at compile time.
 *
 * @param {Mode} mode
 * @returns {Mode | Mode[]}
 * */ function $f4840ac5e98a0872$var$expandOrCloneMode(mode) {
    if (mode.variants && !mode.cachedVariants) mode.cachedVariants = mode.variants.map(function(variant) {
        return $f4840ac5e98a0872$var$inherit$1(mode, {
            variants: null
        }, variant);
    });
    // EXPAND
    // if we have variants then essentially "replace" the mode with the variants
    // this happens in compileMode, where this function is called from
    if (mode.cachedVariants) return mode.cachedVariants;
    // CLONE
    // if we have dependencies on parents then we need a unique
    // instance of ourselves, so we can be reused with many
    // different parents without issue
    if ($f4840ac5e98a0872$var$dependencyOnParent(mode)) return $f4840ac5e98a0872$var$inherit$1(mode, {
        starts: mode.starts ? $f4840ac5e98a0872$var$inherit$1(mode.starts) : null
    });
    if (Object.isFrozen(mode)) return $f4840ac5e98a0872$var$inherit$1(mode);
    // no special dependency issues, just return ourselves
    return mode;
}
var $f4840ac5e98a0872$var$version = "11.12.0";
class $f4840ac5e98a0872$var$HTMLInjectionError extends Error {
    constructor(reason, html){
        super(reason);
        this.name = "HTMLInjectionError";
        this.html = html;
    }
}
/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/ /**
@typedef {import('highlight.js').Mode} Mode
@typedef {import('highlight.js').CompiledMode} CompiledMode
@typedef {import('highlight.js').CompiledScope} CompiledScope
@typedef {import('highlight.js').Language} Language
@typedef {import('highlight.js').HLJSApi} HLJSApi
@typedef {import('highlight.js').HLJSPlugin} HLJSPlugin
@typedef {import('highlight.js').PluginEvent} PluginEvent
@typedef {import('highlight.js').HLJSOptions} HLJSOptions
@typedef {import('highlight.js').LanguageFn} LanguageFn
@typedef {import('highlight.js').HighlightedHTMLElement} HighlightedHTMLElement
@typedef {import('highlight.js').BeforeHighlightContext} BeforeHighlightContext
@typedef {import('highlight.js/private').MatchType} MatchType
@typedef {import('highlight.js/private').KeywordData} KeywordData
@typedef {import('highlight.js/private').EnhancedMatch} EnhancedMatch
@typedef {import('highlight.js/private').AnnotatedError} AnnotatedError
@typedef {import('highlight.js').AutoHighlightResult} AutoHighlightResult
@typedef {import('highlight.js').HighlightOptions} HighlightOptions
@typedef {import('highlight.js').HighlightResult} HighlightResult
*/ const $f4840ac5e98a0872$var$escape = $f4840ac5e98a0872$var$escapeHTML;
const $f4840ac5e98a0872$var$inherit = $f4840ac5e98a0872$var$inherit$1;
const $f4840ac5e98a0872$var$NO_MATCH = Symbol("nomatch");
const $f4840ac5e98a0872$var$MAX_KEYWORD_HITS = 7;
/**
 * @param {any} hljs - object that is extended (legacy)
 * @returns {HLJSApi}
 */ const $f4840ac5e98a0872$var$HLJS = function(hljs) {
    // Global internal variables used within the highlight.js library.
    /** @type {Record<string, Language>} */ const languages = Object.create(null);
    /** @type {Record<string, string>} */ const aliases = Object.create(null);
    /** @type {HLJSPlugin[]} */ const plugins = [];
    // safe/production mode - swallows more errors, tries to keep running
    // even if a single syntax or parse hits a fatal error
    let SAFE_MODE = true;
    const LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
    /** @type {Language} */ const PLAINTEXT_LANGUAGE = {
        disableAutodetect: true,
        name: 'Plain text',
        contains: []
    };
    // Global options used when within external APIs. This is modified when
    // calling the `hljs.configure` function.
    /** @type HLJSOptions */ let options = {
        ignoreUnescapedHTML: false,
        throwUnescapedHTML: false,
        noHighlightRe: /^(no-?highlight)$/i,
        languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
        classPrefix: 'hljs-',
        cssSelector: 'pre code',
        languages: null,
        // beta configuration options, subject to change, welcome to discuss
        // https://github.com/highlightjs/highlight.js/issues/1086
        __emitter: $f4840ac5e98a0872$var$TokenTreeEmitter
    };
    /* Utility functions */ /**
   * Tests a language name to see if highlighting should be skipped
   * @param {string} languageName
   */ function shouldNotHighlight(languageName) {
        return options.noHighlightRe.test(languageName);
    }
    /**
   * @param {HighlightedHTMLElement} block - the HTML element to determine language for
   */ function blockLanguage(block) {
        let classes = block.className + ' ';
        classes += block.parentNode ? block.parentNode.className : '';
        // language-* takes precedence over non-prefixed class names.
        const match = options.languageDetectRe.exec(classes);
        if (match) {
            const language = getLanguage(match[1]);
            if (!language) {
                $f4840ac5e98a0872$var$warn(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
                $f4840ac5e98a0872$var$warn("Falling back to no-highlight mode for this block.", block);
            }
            return language ? match[1] : 'no-highlight';
        }
        return classes.split(/\s+/).find((_class)=>shouldNotHighlight(_class) || getLanguage(_class));
    }
    /**
   * Core highlighting function.
   *
   * OLD API
   * highlight(lang, code, ignoreIllegals, continuation)
   *
   * NEW API
   * highlight(code, {lang, ignoreIllegals})
   *
   * @param {string} codeOrLanguageName - the language to use for highlighting
   * @param {string | HighlightOptions} optionsOrCode - the code to highlight
   * @param {boolean} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   *
   * @returns {HighlightResult} Result - an object that represents the result
   * @property {string} language - the language name
   * @property {number} relevance - the relevance score
   * @property {string} value - the highlighted HTML code
   * @property {string} code - the original raw code
   * @property {CompiledMode} top - top of the current mode stack
   * @property {boolean} illegal - indicates whether any illegal matches were found
  */ function highlight(codeOrLanguageName, optionsOrCode, ignoreIllegals) {
        let code = "";
        let languageName = "";
        if (typeof optionsOrCode === "object") {
            code = codeOrLanguageName;
            ignoreIllegals = optionsOrCode.ignoreIllegals;
            languageName = optionsOrCode.language;
        } else {
            // old API
            $f4840ac5e98a0872$var$deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated.");
            $f4840ac5e98a0872$var$deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277");
            languageName = codeOrLanguageName;
            code = optionsOrCode;
        }
        // https://github.com/highlightjs/highlight.js/issues/3149
        // eslint-disable-next-line no-undefined
        if (ignoreIllegals === undefined) ignoreIllegals = true;
        /** @type {BeforeHighlightContext} */ const context = {
            code: code,
            language: languageName
        };
        // the plugin can change the desired language or the code to be highlighted
        // just be changing the object it was passed
        fire("before:highlight", context);
        // a before plugin can usurp the result completely by providing it's own
        // in which case we don't even need to call highlight
        const result = context.result ? context.result : _highlight(context.language, context.code, ignoreIllegals);
        result.code = context.code;
        // the plugin can change anything in result to suite it
        fire("after:highlight", result);
        return result;
    }
    /**
   * private highlight that's used internally and does not fire callbacks
   *
   * @param {string} languageName - the language to use for highlighting
   * @param {string} codeToHighlight - the code to highlight
   * @param {boolean?} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode?} [continuation] - current continuation mode, if any
   * @returns {HighlightResult} - result of the highlight operation
  */ function _highlight(languageName, codeToHighlight, ignoreIllegals, continuation) {
        const keywordHits = Object.create(null);
        /**
     * Return keyword data if a match is a keyword
     * @param {CompiledMode} mode - current mode
     * @param {string} matchText - the textual match
     * @returns {KeywordData | false}
     */ function keywordData(mode, matchText) {
            return mode.keywords[matchText];
        }
        function processKeywords() {
            if (!top.keywords) {
                emitter.addText(modeBuffer);
                return;
            }
            let lastIndex = 0;
            top.keywordPatternRe.lastIndex = 0;
            let match = top.keywordPatternRe.exec(modeBuffer);
            let buf = "";
            while(match){
                buf += modeBuffer.substring(lastIndex, match.index);
                const word = language.case_insensitive ? match[0].toLowerCase() : match[0];
                const data = keywordData(top, word);
                if (data) {
                    const [kind, keywordRelevance] = data;
                    emitter.addText(buf);
                    buf = "";
                    keywordHits[word] = (keywordHits[word] || 0) + 1;
                    if (keywordHits[word] <= $f4840ac5e98a0872$var$MAX_KEYWORD_HITS) relevance += keywordRelevance;
                    if (kind.startsWith("_")) // _ implied for relevance only, do not highlight
                    // by applying a class name
                    buf += match[0];
                    else {
                        const cssClass = language.classNameAliases[kind] || kind;
                        emitKeyword(match[0], cssClass);
                    }
                } else buf += match[0];
                lastIndex = top.keywordPatternRe.lastIndex;
                match = top.keywordPatternRe.exec(modeBuffer);
            }
            buf += modeBuffer.substring(lastIndex);
            emitter.addText(buf);
        }
        function processSubLanguage() {
            if (modeBuffer === "") return;
            /** @type HighlightResult */ let result = null;
            if (typeof top.subLanguage === 'string') {
                if (!languages[top.subLanguage]) {
                    emitter.addText(modeBuffer);
                    return;
                }
                result = _highlight(top.subLanguage, modeBuffer, true, continuations[top.subLanguage]);
                continuations[top.subLanguage] = /** @type {CompiledMode} */ result._top;
            } else result = highlightAuto(modeBuffer, top.subLanguage.length ? top.subLanguage : null);
            // Counting embedded language score towards the host language may be disabled
            // with zeroing the containing mode relevance. Use case in point is Markdown that
            // allows XML everywhere and makes every XML snippet to have a much larger Markdown
            // score.
            if (top.relevance > 0) relevance += result.relevance;
            emitter.__addSublanguage(result._emitter, result.language);
        }
        function processBuffer() {
            if (top.subLanguage != null) processSubLanguage();
            else processKeywords();
            modeBuffer = '';
        }
        /**
     * @param {string} text
     * @param {string} scope
     */ function emitKeyword(keyword, scope) {
            if (keyword === "") return;
            emitter.startScope(scope);
            emitter.addText(keyword);
            emitter.endScope();
        }
        /**
     * @param {CompiledScope} scope
     * @param {RegExpMatchArray} match
     */ function emitMultiClass(scope, match) {
            let i = 1;
            const max = match.length - 1;
            while(i <= max){
                if (!scope._emit[i]) {
                    i++;
                    continue;
                }
                const klass = language.classNameAliases[scope[i]] || scope[i];
                const text = match[i];
                if (klass) emitKeyword(text, klass);
                else {
                    modeBuffer = text;
                    processKeywords();
                    modeBuffer = "";
                }
                i++;
            }
        }
        /**
     * @param {CompiledMode} mode - new mode to start
     * @param {RegExpMatchArray} match
     */ function startNewMode(mode, match) {
            if (mode.scope && typeof mode.scope === "string") emitter.openNode(language.classNameAliases[mode.scope] || mode.scope);
            if (mode.beginScope) {
                // beginScope just wraps the begin match itself in a scope
                if (mode.beginScope._wrap) {
                    emitKeyword(modeBuffer, language.classNameAliases[mode.beginScope._wrap] || mode.beginScope._wrap);
                    modeBuffer = "";
                } else if (mode.beginScope._multi) {
                    // at this point modeBuffer should just be the match
                    emitMultiClass(mode.beginScope, match);
                    modeBuffer = "";
                }
            }
            top = Object.create(mode, {
                parent: {
                    value: top
                }
            });
            return top;
        }
        /**
     * @param {CompiledMode } mode - the mode to potentially end
     * @param {RegExpMatchArray} match - the latest match
     * @param {string} matchPlusRemainder - match plus remainder of content
     * @returns {CompiledMode | void} - the next mode, or if void continue on in current mode
     */ function endOfMode(mode, match, matchPlusRemainder) {
            let matched = $f4840ac5e98a0872$var$startsWith(mode.endRe, matchPlusRemainder);
            if (matched) {
                if (mode["on:end"]) {
                    const resp = new $f4840ac5e98a0872$var$Response(mode);
                    mode["on:end"](match, resp);
                    if (resp.isMatchIgnored) matched = false;
                }
                if (matched) {
                    while(mode.endsParent && mode.parent)mode = mode.parent;
                    return mode;
                }
            }
            // even if on:end fires an `ignore` it's still possible
            // that we might trigger the end node because of a parent mode
            if (mode.endsWithParent) return endOfMode(mode.parent, match, matchPlusRemainder);
        }
        /**
     * Handle matching but then ignoring a sequence of text
     *
     * @param {string} lexeme - string containing full match text
     */ function doIgnore(lexeme) {
            if (top.matcher.regexIndex === 0) {
                // no more regexes to potentially match here, so we move the cursor forward one
                // space
                modeBuffer += lexeme[0];
                return 1;
            } else {
                // no need to move the cursor, we still have additional regexes to try and
                // match at this very spot
                resumeScanAtSamePosition = true;
                return 0;
            }
        }
        /**
     * Handle the start of a new potential mode match
     *
     * @param {EnhancedMatch} match - the current match
     * @returns {number} how far to advance the parse cursor
     */ function doBeginMatch(match) {
            const lexeme = match[0];
            const newMode = match.rule;
            const resp = new $f4840ac5e98a0872$var$Response(newMode);
            // first internal before callbacks, then the public ones
            const beforeCallbacks = [
                newMode.__beforeBegin,
                newMode["on:begin"]
            ];
            for (const cb of beforeCallbacks){
                if (!cb) continue;
                cb(match, resp);
                if (resp.isMatchIgnored) return doIgnore(lexeme);
            }
            if (newMode.skip) modeBuffer += lexeme;
            else {
                if (newMode.excludeBegin) modeBuffer += lexeme;
                processBuffer();
                if (!newMode.returnBegin && !newMode.excludeBegin) modeBuffer = lexeme;
            }
            startNewMode(newMode, match);
            return newMode.returnBegin ? 0 : lexeme.length;
        }
        /**
     * Handle the potential end of mode
     *
     * @param {RegExpMatchArray} match - the current match
     */ function doEndMatch(match) {
            const lexeme = match[0];
            const matchPlusRemainder = codeToHighlight.substring(match.index);
            const endMode = endOfMode(top, match, matchPlusRemainder);
            if (!endMode) return $f4840ac5e98a0872$var$NO_MATCH;
            const origin = top;
            if (top.endScope && top.endScope._wrap) {
                processBuffer();
                emitKeyword(lexeme, top.endScope._wrap);
            } else if (top.endScope && top.endScope._multi) {
                processBuffer();
                emitMultiClass(top.endScope, match);
            } else if (origin.skip) modeBuffer += lexeme;
            else {
                if (!(origin.returnEnd || origin.excludeEnd)) modeBuffer += lexeme;
                processBuffer();
                if (origin.excludeEnd) modeBuffer = lexeme;
            }
            do {
                if (top.scope) emitter.closeNode();
                if (!top.skip && !top.subLanguage) relevance += top.relevance;
                top = top.parent;
            }while (top !== endMode.parent);
            if (endMode.starts) startNewMode(endMode.starts, match);
            return origin.returnEnd ? 0 : lexeme.length;
        }
        function processContinuations() {
            const list = [];
            for(let current = top; current !== language; current = current.parent)if (current.scope) list.unshift(current.scope);
            list.forEach((item)=>emitter.openNode(item));
        }
        /** @type {{type?: MatchType, index?: number, rule?: Mode}}} */ let lastMatch = {};
        /**
     *  Process an individual match
     *
     * @param {string} textBeforeMatch - text preceding the match (since the last match)
     * @param {EnhancedMatch} [match] - the match itself
     */ function processLexeme(textBeforeMatch, match) {
            const lexeme = match && match[0];
            // add non-matched text to the current mode buffer
            modeBuffer += textBeforeMatch;
            if (lexeme == null) {
                processBuffer();
                return 0;
            }
            // we've found a 0 width match and we're stuck, so we need to advance
            // this happens when we have badly behaved rules that have optional matchers to the degree that
            // sometimes they can end up matching nothing at all
            // Ref: https://github.com/highlightjs/highlight.js/issues/2140
            if (lastMatch.type === "begin" && match.type === "end" && lastMatch.index === match.index && lexeme === "") {
                // spit the "skipped" character that our regex choked on back into the output sequence
                modeBuffer += codeToHighlight.slice(match.index, match.index + 1);
                if (!SAFE_MODE) {
                    /** @type {AnnotatedError} */ const err = new Error(`0 width match regex (${languageName})`);
                    err.languageName = languageName;
                    err.badRule = lastMatch.rule;
                    throw err;
                }
                return 1;
            }
            lastMatch = match;
            if (match.type === "begin") return doBeginMatch(match);
            else if (match.type === "illegal" && !ignoreIllegals) {
                // illegal match, we do not continue processing
                /** @type {AnnotatedError} */ const err = new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.scope || '<unnamed>') + '"');
                err.mode = top;
                throw err;
            } else if (match.type === "end") {
                const processed = doEndMatch(match);
                if (processed !== $f4840ac5e98a0872$var$NO_MATCH) return processed;
            }
            // edge case for when illegal matches $ (end of line/text) which is technically
            // a 0 width match but not a begin/end match so it's not caught by the
            // first handler (when `ignoreIllegals` is true)
            if (match.type === "illegal" && lexeme === "") {
                if (match.index === codeToHighlight.length) ;
                else // matched literal `\n` (with `$`) so we must manually add the newline
                // itself to the modeBuffer so it is not lost when we advance the cursor
                modeBuffer += "\n";
                return 1;
            }
            // infinite loops are BAD, this is a last ditch catch all. if we have a
            // decent number of iterations yet our index (cursor position in our
            // parsing) still 3x behind our index then something is very wrong
            // so we bail
            if (iterations > 100000 && iterations > match.index * 3) {
                const err = new Error('potential infinite loop, way more iterations than matches');
                throw err;
            }
            /*
      Why might be find ourselves here?  An potential end match that was
      triggered but could not be completed.  IE, `doEndMatch` returned NO_MATCH.
      (this could be because a callback requests the match be ignored, etc)

      This causes no real harm other than stopping a few times too many.
      */ modeBuffer += lexeme;
            return lexeme.length;
        }
        const language = getLanguage(languageName);
        if (!language) {
            $f4840ac5e98a0872$var$error(LANGUAGE_NOT_FOUND.replace("{}", languageName));
            throw new Error('Unknown language: "' + languageName + '"');
        }
        const md = $f4840ac5e98a0872$var$compileLanguage(language);
        let result = '';
        /** @type {CompiledMode} */ let top = continuation || md;
        /** @type Record<string,CompiledMode> */ const continuations = {}; // keep continuations for sub-languages
        const emitter = new options.__emitter(options);
        processContinuations();
        let modeBuffer = '';
        let relevance = 0;
        let index = 0;
        let iterations = 0;
        let resumeScanAtSamePosition = false;
        try {
            if (!language.__emitTokens) {
                top.matcher.considerAll();
                for(;;){
                    iterations++;
                    if (resumeScanAtSamePosition) // only regexes not matched previously will now be
                    // considered for a potential match
                    resumeScanAtSamePosition = false;
                    else top.matcher.considerAll();
                    top.matcher.lastIndex = index;
                    const match = top.matcher.exec(codeToHighlight);
                    // console.log("match", match[0], match.rule && match.rule.begin)
                    if (!match) break;
                    const beforeMatch = codeToHighlight.substring(index, match.index);
                    const processedCount = processLexeme(beforeMatch, match);
                    index = match.index + processedCount;
                }
                processLexeme(codeToHighlight.substring(index));
            } else language.__emitTokens(codeToHighlight, emitter);
            emitter.finalize();
            result = emitter.toHTML();
            return {
                language: languageName,
                value: result,
                relevance: relevance,
                illegal: false,
                _emitter: emitter,
                _top: top
            };
        } catch (err) {
            if (err.message && err.message.includes('Illegal')) return {
                language: languageName,
                value: $f4840ac5e98a0872$var$escape(codeToHighlight),
                illegal: true,
                relevance: 0,
                _illegalBy: {
                    message: err.message,
                    index: index,
                    context: codeToHighlight.slice(index - 100, index + 100),
                    mode: err.mode,
                    resultSoFar: result
                },
                _emitter: emitter
            };
            else if (SAFE_MODE) return {
                language: languageName,
                value: $f4840ac5e98a0872$var$escape(codeToHighlight),
                illegal: false,
                relevance: 0,
                errorRaised: err,
                _emitter: emitter,
                _top: top
            };
            else throw err;
        }
    }
    /**
   * returns a valid highlight result, without actually doing any actual work,
   * auto highlight starts with this and it's possible for small snippets that
   * auto-detection may not find a better match
   * @param {string} code
   * @returns {HighlightResult}
   */ function justTextHighlightResult(code) {
        const result = {
            value: $f4840ac5e98a0872$var$escape(code),
            illegal: false,
            relevance: 0,
            _top: PLAINTEXT_LANGUAGE,
            _emitter: new options.__emitter(options)
        };
        result._emitter.addText(code);
        return result;
    }
    /**
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - secondBest (object with the same structure for second-best heuristically
    detected language, may be absent)

    @param {string} code
    @param {Array<string>} [languageSubset]
    @returns {AutoHighlightResult}
  */ function highlightAuto(code, languageSubset) {
        languageSubset = languageSubset || options.languages || Object.keys(languages);
        const plaintext = justTextHighlightResult(code);
        const results = languageSubset.filter(getLanguage).filter(autoDetection).map((name)=>_highlight(name, code, false));
        results.unshift(plaintext); // plaintext is always an option
        const sorted = results.sort((a, b)=>{
            // sort base on relevance
            if (a.relevance !== b.relevance) return b.relevance - a.relevance;
            // always award the tie to the base language
            // ie if C++ and Arduino are tied, it's more likely to be C++
            if (a.language && b.language) {
                if (getLanguage(a.language).supersetOf === b.language) return 1;
                else if (getLanguage(b.language).supersetOf === a.language) return -1;
            }
            // otherwise say they are equal, which has the effect of sorting on
            // relevance while preserving the original ordering - which is how ties
            // have historically been settled, ie the language that comes first always
            // wins in the case of a tie
            return 0;
        });
        const [best, secondBest] = sorted;
        /** @type {AutoHighlightResult} */ const result = best;
        result.secondBest = secondBest;
        return result;
    }
    /**
   * Builds new class name for block given the language name
   *
   * @param {HTMLElement} element
   * @param {string} [currentLang]
   * @param {string} [resultLang]
   */ function updateClassName(element, currentLang, resultLang) {
        const language = currentLang && aliases[currentLang] || resultLang;
        element.classList.add("hljs");
        element.classList.add(`language-${language}`);
    }
    /**
   * Applies highlighting to a DOM node containing code.
   *
   * @param {HighlightedHTMLElement} element - the HTML element to highlight
  */ function highlightElement(element) {
        /** @type HTMLElement */ let node = null;
        const language = blockLanguage(element);
        if (shouldNotHighlight(language)) return;
        fire("before:highlightElement", {
            el: element,
            language: language
        });
        if (element.dataset.highlighted) {
            console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", element);
            return;
        }
        // we should be all text, no child nodes (unescaped HTML) - this is possibly
        // an HTML injection attack - it's likely too late if this is already in
        // production (the code has likely already done its damage by the time
        // we're seeing it)... but we yell loudly about this so that hopefully it's
        // more likely to be caught in development before making it to production
        if (element.children.length > 0) {
            if (!options.ignoreUnescapedHTML) {
                console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk.");
                console.warn("https://github.com/highlightjs/highlight.js/wiki/security");
                console.warn("The element with unescaped HTML:");
                console.warn(element);
            }
            if (options.throwUnescapedHTML) {
                const err = new $f4840ac5e98a0872$var$HTMLInjectionError("One of your code blocks includes unescaped HTML.", element.innerHTML);
                throw err;
            }
        }
        node = element;
        const text = node.textContent;
        const result = language ? highlight(text, {
            language: language,
            ignoreIllegals: true
        }) : highlightAuto(text);
        element.innerHTML = result.value;
        element.dataset.highlighted = "yes";
        updateClassName(element, language, result.language);
        element.result = {
            language: result.language,
            // TODO: remove with version 11.0
            re: result.relevance,
            relevance: result.relevance
        };
        if (result.secondBest) element.secondBest = {
            language: result.secondBest.language,
            relevance: result.secondBest.relevance
        };
        fire("after:highlightElement", {
            el: element,
            result: result,
            text: text
        });
    }
    /**
   * Updates highlight.js global options with the passed options
   *
   * @param {Partial<HLJSOptions>} userOptions
   */ function configure(userOptions) {
        options = $f4840ac5e98a0872$var$inherit(options, userOptions);
    }
    // TODO: remove v12, deprecated
    const initHighlighting = ()=>{
        highlightAll();
        $f4840ac5e98a0872$var$deprecated("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
    };
    // TODO: remove v12, deprecated
    function initHighlightingOnLoad() {
        highlightAll();
        $f4840ac5e98a0872$var$deprecated("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
    }
    let wantsHighlight = false;
    /**
   * auto-highlights all pre>code elements on the page
   */ function highlightAll() {
        function boot() {
            // if a highlight was requested before DOM was loaded, do now
            highlightAll();
        }
        // if we are called too early in the loading process
        if (document.readyState === "loading") {
            // make sure the event listener is only added once
            if (!wantsHighlight) window.addEventListener('DOMContentLoaded', boot, false);
            wantsHighlight = true;
            return;
        }
        const blocks = document.querySelectorAll(options.cssSelector);
        blocks.forEach(highlightElement);
    }
    /**
   * Register a language grammar module
   *
   * @param {string} languageName
   * @param {LanguageFn} languageDefinition
   */ function registerLanguage(languageName, languageDefinition) {
        let lang = null;
        try {
            lang = languageDefinition(hljs);
        } catch (error$1) {
            $f4840ac5e98a0872$var$error("Language definition for '{}' could not be registered.".replace("{}", languageName));
            // hard or soft error
            if (!SAFE_MODE) throw error$1;
            else $f4840ac5e98a0872$var$error(error$1);
            // languages that have serious errors are replaced with essentially a
            // "plaintext" stand-in so that the code blocks will still get normal
            // css classes applied to them - and one bad language won't break the
            // entire highlighter
            lang = PLAINTEXT_LANGUAGE;
        }
        // give it a temporary name if it doesn't have one in the meta-data
        if (!lang.name) lang.name = languageName;
        languages[languageName] = lang;
        lang.rawDefinition = languageDefinition.bind(null, hljs);
        if (lang.aliases) registerAliases(lang.aliases, {
            languageName: languageName
        });
    }
    /**
   * Remove a language grammar module
   *
   * @param {string} languageName
   */ function unregisterLanguage(languageName) {
        delete languages[languageName];
        for (const alias of Object.keys(aliases))if (aliases[alias] === languageName) delete aliases[alias];
    }
    /**
   * @returns {string[]} List of language internal names
   */ function listLanguages() {
        return Object.keys(languages);
    }
    /**
   * @param {string} name - name of the language to retrieve
   * @returns {Language | undefined}
   */ function getLanguage(name) {
        name = (name || '').toLowerCase();
        return languages[name] || languages[aliases[name]];
    }
    /**
   *
   * @param {string|string[]} aliasList - single alias or list of aliases
   * @param {{languageName: string}} opts
   */ function registerAliases(aliasList, { languageName: languageName }) {
        if (typeof aliasList === 'string') aliasList = [
            aliasList
        ];
        aliasList.forEach((alias)=>{
            aliases[alias.toLowerCase()] = languageName;
        });
    }
    /**
   * Determines if a given language has auto-detection enabled
   * @param {string} name - name of the language
   */ function autoDetection(name) {
        const lang = getLanguage(name);
        return lang && !lang.disableAutodetect;
    }
    /**
   * Upgrades the old highlightBlock plugins to the new
   * highlightElement API
   * @param {HLJSPlugin} plugin
   */ function upgradePluginAPI(plugin) {
        // TODO: remove with v12
        if (plugin["before:highlightBlock"] && !plugin["before:highlightElement"]) plugin["before:highlightElement"] = (data)=>{
            plugin["before:highlightBlock"](Object.assign({
                block: data.el
            }, data));
        };
        if (plugin["after:highlightBlock"] && !plugin["after:highlightElement"]) plugin["after:highlightElement"] = (data)=>{
            plugin["after:highlightBlock"](Object.assign({
                block: data.el
            }, data));
        };
    }
    /**
   * @param {HLJSPlugin} plugin
   */ function addPlugin(plugin) {
        upgradePluginAPI(plugin);
        plugins.push(plugin);
    }
    /**
   * @param {HLJSPlugin} plugin
   */ function removePlugin(plugin) {
        const index = plugins.indexOf(plugin);
        if (index !== -1) plugins.splice(index, 1);
    }
    /**
   *
   * @param {PluginEvent} event
   * @param {any} args
   */ function fire(event, args) {
        const cb = event;
        plugins.forEach(function(plugin) {
            if (plugin[cb]) plugin[cb](args);
        });
    }
    /**
   * DEPRECATED
   * @param {HighlightedHTMLElement} el
   */ function deprecateHighlightBlock(el) {
        $f4840ac5e98a0872$var$deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0");
        $f4840ac5e98a0872$var$deprecated("10.7.0", "Please use highlightElement now.");
        return highlightElement(el);
    }
    /* Interface definition */ Object.assign(hljs, {
        highlight: highlight,
        highlightAuto: highlightAuto,
        highlightAll: highlightAll,
        highlightElement: highlightElement,
        // TODO: Remove with v12 API
        highlightBlock: deprecateHighlightBlock,
        configure: configure,
        initHighlighting: initHighlighting,
        initHighlightingOnLoad: initHighlightingOnLoad,
        registerLanguage: registerLanguage,
        unregisterLanguage: unregisterLanguage,
        listLanguages: listLanguages,
        getLanguage: getLanguage,
        registerAliases: registerAliases,
        autoDetection: autoDetection,
        inherit: $f4840ac5e98a0872$var$inherit,
        addPlugin: addPlugin,
        removePlugin: removePlugin
    });
    hljs.debugMode = function() {
        SAFE_MODE = false;
    };
    hljs.safeMode = function() {
        SAFE_MODE = true;
    };
    hljs.versionString = $f4840ac5e98a0872$var$version;
    hljs.regex = {
        concat: $f4840ac5e98a0872$var$concat,
        lookahead: $f4840ac5e98a0872$var$lookahead,
        either: $f4840ac5e98a0872$var$either,
        optional: $f4840ac5e98a0872$var$optional,
        anyNumberOfTimes: $f4840ac5e98a0872$var$anyNumberOfTimes
    };
    for(const key in $f4840ac5e98a0872$var$MODES)// @ts-ignore
    if (typeof $f4840ac5e98a0872$var$MODES[key] === "object") // @ts-ignore
    $f4840ac5e98a0872$var$deepFreeze($f4840ac5e98a0872$var$MODES[key]);
    // merge all the modes/regexes into our main object
    Object.assign(hljs, $f4840ac5e98a0872$var$MODES);
    return hljs;
};
// Other names for the variable may break build script
const $f4840ac5e98a0872$var$highlight = $f4840ac5e98a0872$var$HLJS({});
// returns a new instance of the highlighter to be used for extensions
// check https://github.com/wooorm/lowlight/issues/47
$f4840ac5e98a0872$var$highlight.newInstance = ()=>$f4840ac5e98a0872$var$HLJS({});
$f4840ac5e98a0872$exports = $f4840ac5e98a0872$var$highlight;
$f4840ac5e98a0872$var$highlight.HighlightJS = $f4840ac5e98a0872$var$highlight;
$f4840ac5e98a0872$var$highlight.default = $f4840ac5e98a0872$var$highlight;


var $48b9e1a9b2627eb4$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($f4840ac5e98a0872$exports)));


const $676f4a3d145a5354$var$IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
const $676f4a3d145a5354$var$KEYWORDS = [
    "as",
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends",
    // It's reached stage 3, which is "recommended for implementation":
    "using"
];
const $676f4a3d145a5354$var$LITERALS = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
];
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
const $676f4a3d145a5354$var$TYPES = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
];
const $676f4a3d145a5354$var$ERROR_TYPES = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
const $676f4a3d145a5354$var$BUILT_IN_GLOBALS = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
];
const $676f4a3d145a5354$var$BUILT_IN_VARIABLES = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "self",
    "global" // Node.js
];
const $676f4a3d145a5354$var$BUILT_INS = [].concat($676f4a3d145a5354$var$BUILT_IN_GLOBALS, $676f4a3d145a5354$var$TYPES, $676f4a3d145a5354$var$ERROR_TYPES);
/*
Language: JavaScript
Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
Category: common, scripting, web
Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
*/ /** @type LanguageFn */ function $676f4a3d145a5354$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    /**
   * Takes a string like "<Booger" and checks to see
   * if we can find a matching "</Booger" later in the
   * content.
   * @param {RegExpMatchArray} match
   * @param {{after:number}} param1
   */ const hasClosingTag = (match, { after: after })=>{
        const tag = "</" + match[0].slice(1);
        const pos = match.input.indexOf(tag, after);
        return pos !== -1;
    };
    const IDENT_RE$1 = $676f4a3d145a5354$var$IDENT_RE;
    const FRAGMENT = {
        begin: '<>',
        end: '</>'
    };
    // to avoid some special cases inside isTrulyOpeningTag
    const XML_SELF_CLOSING = /<[A-Za-z0-9\\._:-]+\s*\/>/;
    const XML_TAG = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: (match, response)=>{
            const afterMatchIndex = match[0].length + match.index;
            const nextChar = match.input[afterMatchIndex];
            if (// HTML should not include another raw `<` inside a tag
            // nested type?
            // `<Array<Array<number>>`, etc.
            nextChar === "<" || // the , gives away that this is not HTML
            // `<T, A extends keyof T, V>`
            nextChar === ",") {
                response.ignoreMatch();
                return;
            }
            // `<something>`
            // Quite possibly a tag, lets look for a matching closing tag...
            if (nextChar === ">") // if we cannot find a matching closing tag, then we
            // will ignore it
            {
                if (!hasClosingTag(match, {
                    after: afterMatchIndex
                })) response.ignoreMatch();
            }
            // `<blah />` (self-closing)
            // handled by simpleSelfClosing rule
            let m;
            const afterMatch = match.input.substring(afterMatchIndex);
            // some more template typing stuff
            //  <T = any>(key?: string) => Modify<
            if (m = afterMatch.match(/^\s*=/)) {
                response.ignoreMatch();
                return;
            }
            // `<From extends string>`
            // technically this could be HTML, but it smells like a type
            // NOTE: This is ugh, but added specifically for https://github.com/highlightjs/highlight.js/issues/3276
            if (m = afterMatch.match(/^\s+extends\s+/)) {
                if (m.index === 0) {
                    response.ignoreMatch();
                    // eslint-disable-next-line no-useless-return
                    return;
                }
            }
        }
    };
    const KEYWORDS$1 = {
        $pattern: $676f4a3d145a5354$var$IDENT_RE,
        keyword: $676f4a3d145a5354$var$KEYWORDS,
        literal: $676f4a3d145a5354$var$LITERALS,
        built_in: $676f4a3d145a5354$var$BUILT_INS,
        "variable.language": $676f4a3d145a5354$var$BUILT_IN_VARIABLES
    };
    // https://tc39.es/ecma262/#sec-literals-numeric-literals
    const decimalDigits = '[0-9](_?[0-9])*';
    const frac = `\\.(${decimalDigits})`;
    // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
    // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
    const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
    const NUMBER = {
        className: 'number',
        variants: [
            // DecimalLiteral
            {
                begin: `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))` + `[eE][+-]?(${decimalDigits})\\b`
            },
            {
                begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b`
            },
            // DecimalBigIntegerLiteral
            {
                begin: `\\b(0|[1-9](_?[0-9])*)n\\b`
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    };
    const SUBST = {
        className: 'subst',
        begin: '\\$\\{',
        end: '\\}',
        keywords: KEYWORDS$1,
        contains: [] // defined later
    };
    const HTML_TEMPLATE = {
        begin: '\.?html`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'xml'
        }
    };
    const CSS_TEMPLATE = {
        begin: '\.?css`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'css'
        }
    };
    const GRAPHQL_TEMPLATE = {
        begin: '\.?gql`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'graphql'
        }
    };
    const TEMPLATE_STRING = {
        className: 'string',
        begin: '`',
        end: '`',
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    const JSDOC_COMMENT = hljs.COMMENT(/\/\*\*(?!\/)/, '\\*/', {
        relevance: 0,
        contains: [
            {
                begin: '(?=@[A-Za-z]+)',
                relevance: 0,
                contains: [
                    {
                        className: 'doctag',
                        begin: '@[A-Za-z]+'
                    },
                    {
                        className: 'type',
                        begin: '\\{',
                        end: '\\}',
                        excludeEnd: true,
                        excludeBegin: true,
                        relevance: 0
                    },
                    {
                        className: 'variable',
                        begin: IDENT_RE$1 + '(?=\\s*(-)|$)',
                        endsParent: true,
                        relevance: 0
                    },
                    // eat spaces (not newlines) so we can find
                    // types or variables
                    {
                        begin: /(?=[^\n])\s/,
                        relevance: 0
                    }
                ]
            }
        ]
    });
    const COMMENT = {
        className: "comment",
        variants: [
            JSDOC_COMMENT,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_LINE_COMMENT_MODE
        ]
    };
    const SUBST_INTERNALS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        HTML_TEMPLATE,
        CSS_TEMPLATE,
        GRAPHQL_TEMPLATE,
        TEMPLATE_STRING,
        // Skip numbers when they are part of a variable name
        {
            match: /\$\d+/
        },
        NUMBER
    ];
    SUBST.contains = SUBST_INTERNALS.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS$1,
        contains: [
            "self"
        ].concat(SUBST_INTERNALS)
    });
    const SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
    const PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
        // eat recursive parens in sub expressions
        {
            begin: /(\s*)\(/,
            end: /\)/,
            keywords: KEYWORDS$1,
            contains: [
                "self"
            ].concat(SUBST_AND_COMMENTS)
        }
    ]);
    const PARAMS = {
        className: 'params',
        // convert this to negative lookbehind in v12
        begin: /(\s*)\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS$1,
        contains: PARAMS_CONTAINS
    };
    // ES6 classes
    const CLASS_OR_EXTENDS = {
        variants: [
            // class Car extends vehicle
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1,
                    /\s+/,
                    /extends/,
                    /\s+/,
                    regex.concat(IDENT_RE$1, "(", regex.concat(/\./, IDENT_RE$1), ")*")
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    5: "keyword",
                    7: "title.class.inherited"
                }
            },
            // class Car
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1
                ],
                scope: {
                    1: "keyword",
                    3: "title.class"
                }
            }
        ]
    };
    const CLASS_REFERENCE = {
        relevance: 0,
        match: regex.either(// Hard coded exceptions
        /\bJSON/, // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
        className: "title.class",
        keywords: {
            _: [
                // se we still get relevance credit for JS library classes
                ...$676f4a3d145a5354$var$TYPES,
                ...$676f4a3d145a5354$var$ERROR_TYPES
            ]
        }
    };
    const USE_STRICT = {
        label: "use_strict",
        className: 'meta',
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
    };
    const FUNCTION_DEFINITION = {
        variants: [
            {
                match: [
                    /function/,
                    /\s+/,
                    IDENT_RE$1,
                    /(?=\s*\()/
                ]
            },
            // anonymous function
            {
                match: [
                    /function/,
                    /\s*(?=\()/
                ]
            }
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        label: "func.def",
        contains: [
            PARAMS
        ],
        illegal: /%/
    };
    const UPPER_CASE_CONSTANT = {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
    };
    function noneOf(list) {
        return regex.concat("(?!", list.join("|"), ")");
    }
    const FUNCTION_CALL = {
        match: regex.concat(/\b/, noneOf([
            ...$676f4a3d145a5354$var$BUILT_IN_GLOBALS,
            "super",
            "import",
            "await"
        ].map((x)=>`${x}\\s*\\(`)), IDENT_RE$1, regex.lookahead(/\s*\(/)),
        className: "title.function",
        relevance: 0
    };
    const PROPERTY_ACCESS = {
        begin: regex.concat(/\./, regex.lookahead(regex.concat(IDENT_RE$1, /(?![0-9A-Za-z$_(])/))),
        end: IDENT_RE$1,
        excludeBegin: true,
        keywords: "prototype",
        className: "property",
        relevance: 0
    };
    const GETTER_OR_SETTER = {
        match: [
            /get|set/,
            /\s+/,
            IDENT_RE$1,
            /(?=\()/
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            {
                begin: /\(\)/
            },
            PARAMS
        ]
    };
    const FUNC_LEAD_IN_RE = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + hljs.UNDERSCORE_IDENT_RE + ')\\s*=>';
    const FUNCTION_VARIABLE = {
        match: [
            /const|var|let/,
            /\s+/,
            IDENT_RE$1,
            /\s*/,
            /=\s*/,
            /(async\s*)?/,
            regex.lookahead(FUNC_LEAD_IN_RE)
        ],
        keywords: "async",
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            PARAMS
        ]
    };
    return {
        name: 'JavaScript',
        aliases: [
            'js',
            'jsx',
            'mjs',
            'cjs'
        ],
        keywords: KEYWORDS$1,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: PARAMS_CONTAINS,
            CLASS_REFERENCE: CLASS_REFERENCE
        },
        illegal: /#(?![$_A-Za-z])/,
        contains: [
            hljs.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            USE_STRICT,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            HTML_TEMPLATE,
            CSS_TEMPLATE,
            GRAPHQL_TEMPLATE,
            TEMPLATE_STRING,
            COMMENT,
            // Skip numbers when they are part of a variable name
            {
                match: /\$\d+/
            },
            NUMBER,
            CLASS_REFERENCE,
            {
                scope: 'attr',
                match: IDENT_RE$1 + regex.lookahead(':'),
                relevance: 0
            },
            FUNCTION_VARIABLE,
            {
                begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
                keywords: 'return throw case',
                relevance: 0,
                contains: [
                    COMMENT,
                    hljs.REGEXP_MODE,
                    {
                        className: 'function',
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: FUNC_LEAD_IN_RE,
                        returnBegin: true,
                        end: '\\s*=>',
                        contains: [
                            {
                                className: 'params',
                                variants: [
                                    {
                                        begin: hljs.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: true
                                    },
                                    {
                                        begin: /(\s*)\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS$1,
                                        contains: PARAMS_CONTAINS
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        match: /\s+/,
                        relevance: 0
                    },
                    {
                        variants: [
                            {
                                begin: FRAGMENT.begin,
                                end: FRAGMENT.end
                            },
                            {
                                match: XML_SELF_CLOSING
                            },
                            {
                                begin: XML_TAG.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                'on:begin': XML_TAG.isTrulyOpeningTag,
                                end: XML_TAG.end
                            }
                        ],
                        subLanguage: 'xml',
                        contains: [
                            {
                                begin: XML_TAG.begin,
                                end: XML_TAG.end,
                                skip: true,
                                contains: [
                                    'self'
                                ]
                            }
                        ]
                    }
                ]
            },
            FUNCTION_DEFINITION,
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: '\\b(?!function)' + hljs.UNDERSCORE_IDENT_RE + '\\(' + // first parens
                '[^()]*(\\(' + '[^()]*(\\(' + '[^()]*' + '\\)[^()]*)*' + '\\)[^()]*)*' + '\\)\\s*\\{',
                returnBegin: true,
                label: "func.def",
                contains: [
                    PARAMS,
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1,
                        className: "title.function"
                    })
                ]
            },
            // catch ... so it won't trigger the property rule below
            {
                match: /\.\.\./,
                relevance: 0
            },
            PROPERTY_ACCESS,
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                match: '\\$' + IDENT_RE$1,
                relevance: 0
            },
            {
                match: [
                    /\bconstructor(?=\s*\()/
                ],
                className: {
                    1: "title.function"
                },
                contains: [
                    PARAMS
                ]
            },
            FUNCTION_CALL,
            UPPER_CASE_CONSTANT,
            CLASS_OR_EXTENDS,
            GETTER_OR_SETTER,
            {
                match: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
            }
        ]
    };
}


/*
Language: Python
Description: Python is an interpreted, object-oriented, high-level programming language with dynamic semantics.
Website: https://www.python.org
Category: common
*/ function $75477c3004b71dea$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    const IDENT_RE = /[\p{XID_Start}_]\p{XID_Continue}*/u;
    const RESERVED_WORDS = [
        'and',
        'as',
        'assert',
        'async',
        'await',
        'break',
        'case',
        'class',
        'continue',
        'def',
        'del',
        'elif',
        'else',
        'except',
        'finally',
        'for',
        'from',
        'global',
        'if',
        'import',
        'in',
        'is',
        'lambda',
        'lazy',
        'match',
        'nonlocal|10',
        'not',
        'or',
        'pass',
        'raise',
        'return',
        'try',
        'while',
        'with',
        'yield'
    ];
    const BUILT_INS = [
        '__import__',
        'abs',
        'aiter',
        'all',
        'anext',
        'any',
        'ascii',
        'bin',
        'bool',
        'breakpoint',
        'bytearray',
        'bytes',
        'callable',
        'chr',
        'classmethod',
        'compile',
        'complex',
        'delattr',
        'dict',
        'dir',
        'divmod',
        'enumerate',
        'eval',
        'exec',
        'filter',
        'float',
        'format',
        'frozendict',
        'frozenset',
        'getattr',
        'globals',
        'hasattr',
        'hash',
        'help',
        'hex',
        'id',
        'input',
        'int',
        'isinstance',
        'issubclass',
        'iter',
        'len',
        'list',
        'locals',
        'map',
        'max',
        'memoryview',
        'min',
        'next',
        'object',
        'oct',
        'open',
        'ord',
        'pow',
        'print',
        'property',
        'range',
        'repr',
        'reversed',
        'round',
        'sentinel',
        'set',
        'setattr',
        'slice',
        'sorted',
        'staticmethod',
        'str',
        'sum',
        'super',
        'tuple',
        'type',
        'vars',
        'zip'
    ];
    const LITERALS = [
        '__debug__',
        'Ellipsis',
        'False',
        'None',
        'NotImplemented',
        'True'
    ];
    // https://docs.python.org/3/library/typing.html
    // TODO: Could these be supplemented by a CamelCase matcher in certain
    // contexts, leaving these remaining only for relevance hinting?
    const TYPES = [
        "Any",
        "Callable",
        "Coroutine",
        "Dict",
        "List",
        "Literal",
        "Generic",
        "Optional",
        "Sequence",
        "Set",
        "Tuple",
        "Type",
        "Union"
    ];
    const KEYWORDS = {
        $pattern: /[A-Za-z]\w+|__\w+__/,
        keyword: RESERVED_WORDS,
        built_in: BUILT_INS,
        literal: LITERALS,
        type: TYPES
    };
    const PROMPT = {
        className: 'meta',
        begin: /^(>>>|\.\.\.) /
    };
    const SUBST = {
        className: 'subst',
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS,
        illegal: /#/
    };
    const LITERAL_BRACKET = {
        begin: /\{\{/,
        relevance: 0
    };
    const STRING = {
        className: 'string',
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
                end: /'''/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT
                ],
                relevance: 10
            },
            {
                begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
                end: /"""/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT
                ],
                relevance: 10
            },
            {
                begin: /([fFtT][rR]|[rR][fFtT]|[fFtT])'''/,
                end: /'''/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /([fFtT][rR]|[rR][fFtT]|[fFtT])"""/,
                end: /"""/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /([uU]|[rR])'/,
                end: /'/,
                relevance: 10
            },
            {
                begin: /([uU]|[rR])"/,
                end: /"/,
                relevance: 10
            },
            {
                begin: /([bB]|[bB][rR]|[rR][bB])'/,
                end: /'/
            },
            {
                begin: /([bB]|[bB][rR]|[rR][bB])"/,
                end: /"/
            },
            {
                begin: /([fFtT][rR]|[rR][fFtT]|[fFtT])'/,
                end: /'/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /([fFtT][rR]|[rR][fFtT]|[fFtT])"/,
                end: /"/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
    // https://docs.python.org/3.9/reference/lexical_analysis.html#numeric-literals
    const digitpart = '[0-9](_?[0-9])*';
    const pointfloat = `(\\b(${digitpart}))?\\.(${digitpart})|\\b(${digitpart})\\.`;
    // Whitespace after a number (or any lexical token) is needed only if its absence
    // would change the tokenization
    // https://docs.python.org/3.9/reference/lexical_analysis.html#whitespace-between-tokens
    // We deviate slightly, requiring a word boundary or a keyword
    // to avoid accidentally recognizing *prefixes* (e.g., `0` in `0x41` or `08` or `0__1`)
    const lookahead = `\\b|${RESERVED_WORDS.join('|')}`;
    const NUMBER = {
        className: 'number',
        relevance: 0,
        variants: [
            // exponentfloat, pointfloat
            // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
            // optionally imaginary
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            // Note: no leading \b because floats can start with a decimal point
            // and we don't want to mishandle e.g. `fn(.5)`,
            // no trailing \b for pointfloat because it can end with a decimal point
            // and we don't want to mishandle e.g. `0..hex()`; this should be safe
            // because both MUST contain a decimal point and so cannot be confused with
            // the interior part of an identifier
            {
                begin: `(\\b(${digitpart})|(${pointfloat}))[eE][+-]?(${digitpart})[jJ]?(?=${lookahead})`
            },
            {
                begin: `(${pointfloat})[jJ]?`
            },
            // decinteger, bininteger, octinteger, hexinteger
            // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
            // optionally "long" in Python 2
            // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
            // decinteger is optionally imaginary
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            {
                begin: `\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=${lookahead})`
            },
            {
                begin: `\\b0[bB](_?[01])+[lL]?(?=${lookahead})`
            },
            {
                begin: `\\b0[oO](_?[0-7])+[lL]?(?=${lookahead})`
            },
            {
                begin: `\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=${lookahead})`
            },
            // imagnumber (digitpart-based)
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            {
                begin: `\\b(${digitpart})[jJ](?=${lookahead})`
            }
        ]
    };
    const COMMENT_TYPE = {
        className: "comment",
        begin: regex.lookahead(/# type:/),
        end: /$/,
        keywords: KEYWORDS,
        contains: [
            {
                begin: /# type:/
            },
            // comment within a datatype comment includes no keywords
            {
                begin: /#/,
                end: /\b\B/,
                endsWithParent: true
            }
        ]
    };
    const PARAMS = {
        className: 'params',
        variants: [
            // Exclude params in functions without params
            {
                className: "",
                begin: /\(\s*\)/,
                skip: true
            },
            {
                begin: /\(/,
                end: /\)/,
                excludeBegin: true,
                excludeEnd: true,
                keywords: KEYWORDS,
                contains: [
                    'self',
                    PROMPT,
                    NUMBER,
                    STRING,
                    hljs.HASH_COMMENT_MODE
                ]
            }
        ]
    };
    SUBST.contains = [
        STRING,
        NUMBER,
        PROMPT
    ];
    return {
        name: 'Python',
        aliases: [
            'py',
            'gyp',
            'ipython'
        ],
        unicodeRegex: true,
        keywords: KEYWORDS,
        illegal: /(<\/|\?)|=>/,
        contains: [
            PROMPT,
            NUMBER,
            {
                // very common convention
                scope: 'variable.language',
                match: /\bself\b/
            },
            {
                // eat "if" prior to string so that it won't accidentally be
                // labeled as an f-string
                beginKeywords: "if",
                relevance: 0
            },
            {
                match: /\bor\b/,
                scope: "keyword"
            },
            STRING,
            COMMENT_TYPE,
            hljs.HASH_COMMENT_MODE,
            {
                match: [
                    /\bdef/,
                    /\s+/,
                    IDENT_RE
                ],
                scope: {
                    1: "keyword",
                    3: "title.function"
                },
                contains: [
                    PARAMS
                ]
            },
            {
                variants: [
                    {
                        match: [
                            /\bclass/,
                            /\s+/,
                            IDENT_RE,
                            /\s*/,
                            /\(\s*/,
                            IDENT_RE,
                            /\s*\)/
                        ]
                    },
                    {
                        match: [
                            /\bclass/,
                            /\s+/,
                            IDENT_RE
                        ]
                    }
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    6: "title.class.inherited"
                }
            },
            {
                className: 'meta',
                begin: /^[\t ]*@/,
                end: /(?=#)|$/,
                contains: [
                    NUMBER,
                    PARAMS,
                    STRING
                ]
            }
        ]
    };
}


/*
Language: C
Category: common, system
Website: https://en.wikipedia.org/wiki/C_(programming_language)
*/ /** @type LanguageFn */ function $104ad11152cd56ac$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    // added for historic reasons because `hljs.C_LINE_COMMENT_MODE` does
    // not include such support nor can we be sure all the grammars depending
    // on it would desire this behavior
    const C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$', {
        contains: [
            {
                begin: /\\\n/
            }
        ]
    });
    const DECLTYPE_AUTO_RE = 'decltype\\(auto\\)';
    const NAMESPACE_RE = '[a-zA-Z_]\\w*::';
    const TEMPLATE_ARGUMENT_RE = '<[^<>]+>';
    const FUNCTION_TYPE_RE = '(' + DECLTYPE_AUTO_RE + '|' + regex.optional(NAMESPACE_RE) + '[a-zA-Z_]\\w*' + regex.optional(TEMPLATE_ARGUMENT_RE) + ')';
    // C11 <stdatomic.h> atomic type names. This is an explicit whitelist so that
    // C11 atomic *functions* (atomic_init, atomic_store, atomic_load,
    // atomic_fetch_add, ...) are not mistakenly highlighted as types. See #3837.
    const ATOMIC_TYPES = regex.concat(/\batomic_/, regex.either('bool', 'char', 'schar', 'uchar', 'short', 'ushort', 'int', 'uint', 'long', 'ulong', 'llong', 'ullong', 'char16_t', 'char32_t', 'wchar_t', 'int_least8_t', 'uint_least8_t', 'int_least16_t', 'uint_least16_t', 'int_least32_t', 'uint_least32_t', 'int_least64_t', 'uint_least64_t', 'int_fast8_t', 'uint_fast8_t', 'int_fast16_t', 'uint_fast16_t', 'int_fast32_t', 'uint_fast32_t', 'int_fast64_t', 'uint_fast64_t', 'intptr_t', 'uintptr_t', 'size_t', 'ptrdiff_t', 'intmax_t', 'uintmax_t'), /\b/);
    const TYPES = {
        className: 'type',
        variants: [
            {
                begin: '\\b[a-z\\d_]*_t\\b'
            },
            {
                match: ATOMIC_TYPES
            }
        ]
    };
    // https://en.cppreference.com/w/cpp/language/escape
    // \\ \x \xFF \u2837 \u00323747 \374
    const CHARACTER_ESCAPES = '\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)';
    const STRINGS = {
        className: 'string',
        variants: [
            {
                begin: '(u8?|U|L)?"',
                end: '"',
                illegal: '\\n',
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: '(u8?|U|L)?\'(' + CHARACTER_ESCAPES + "|.)",
                end: '\'',
                illegal: '.'
            },
            // https://en.cppreference.com/w/cpp/language/string_literal
            // a d-char-sequence never contains parentheses, backslashes or whitespace;
            // quotes are excluded as well so the closing delimiter cannot swallow the
            // quote that actually terminates the literal
            hljs.END_SAME_AS_BEGIN({
                begin: /(?:u8?|U|L)?R"([^()\\\s"]{0,16})\(/,
                end: /\)([^()\\\s"]{0,16})"/
            })
        ]
    };
    const NUMBERS = {
        className: 'number',
        variants: [
            {
                match: /\b(0b[01']+)/
            },
            {
                match: /(-?)\b([\d']+(\.[\d']*)?|\.[\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)/
            },
            {
                match: /(-?)\b(0[xX][a-fA-F0-9]+(?:'[a-fA-F0-9]+)*(?:\.[a-fA-F0-9]*(?:'[a-fA-F0-9]*)*)?(?:[pP][-+]?[0-9]+)?(l|L)?(u|U)?)/
            },
            {
                match: /(-?)\b\d+(?:'\d+)*(?:\.\d*(?:'\d*)*)?(?:[eE][-+]?\d+)?/
            }
        ],
        relevance: 0
    };
    // `#include` is the only preprocessor directive that takes an angle-bracket
    // quoted header (`#include <header>`). Scoping that rule to `#include` keeps
    // the greedy `<...>` match from eating a `>` that belongs to the body of
    // another directive (e.g. `#define what do { cout << ">"; } while (0)`),
    // which would otherwise leave an unbalanced `"` and break highlighting for
    // the rest of the file. See issue #3505.
    const PREPROCESSOR_INCLUDE = {
        scope: 'meta',
        begin: /#\s*include\b/,
        end: /$/,
        keywords: {
            keyword: 'include'
        },
        contains: [
            {
                // the `\` at the end of a line signaling continuation
                begin: /\\\n/
            },
            STRINGS,
            {
                scope: 'string',
                begin: /<.*?>/
            },
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    const PREPROCESSOR = {
        className: 'meta',
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: {
            keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef elifdef elifndef include"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            hljs.inherit(STRINGS, {
                className: 'string'
            }),
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    const PREPROCESSORS = [
        PREPROCESSOR_INCLUDE,
        PREPROCESSOR
    ];
    const TITLE_MODE = {
        className: 'title',
        begin: regex.optional(NAMESPACE_RE) + hljs.IDENT_RE,
        relevance: 0
    };
    const FUNCTION_TITLE = regex.optional(NAMESPACE_RE) + hljs.IDENT_RE + '\\s*\\(';
    // Bounded on purpose: an unbounded quantifier here consumes an arbitrarily
    // long run of words, and when no function title follows it the engine retries
    // the title at every token boundary of that run - quadratic in the size of
    // the document.  See #4362.
    const MAX_FUNCTION_TYPE_TOKENS = 12;
    const C_KEYWORDS = [
        "asm",
        "auto",
        "break",
        "case",
        "continue",
        "default",
        "do",
        "else",
        "enum",
        "extern",
        "for",
        "fortran",
        "goto",
        "if",
        "inline",
        "register",
        "restrict",
        "return",
        "sizeof",
        "typeof",
        "typeof_unqual",
        "struct",
        "switch",
        "typedef",
        "union",
        "volatile",
        "while",
        "_Alignas",
        "_Alignof",
        "_Atomic",
        "_Generic",
        "_Noreturn",
        "_Static_assert",
        "_Thread_local",
        // aliases
        "alignas",
        "alignof",
        "noreturn",
        "static_assert",
        "thread_local",
        // not a C keyword but is, for all intents and purposes, treated exactly like one.
        "_Pragma"
    ];
    const C_TYPES = [
        "float",
        "double",
        "signed",
        "unsigned",
        "int",
        "short",
        "long",
        "char",
        "void",
        "_Bool",
        "_BitInt",
        "_Complex",
        "_Imaginary",
        "_Decimal32",
        "_Decimal64",
        "_Decimal96",
        "_Decimal128",
        "_Decimal64x",
        "_Decimal128x",
        "_Float16",
        "_Float32",
        "_Float64",
        "_Float128",
        "_Float32x",
        "_Float64x",
        "_Float128x",
        // modifiers
        "const",
        "static",
        "constexpr",
        // aliases
        "complex",
        "bool",
        "imaginary"
    ];
    const KEYWORDS = {
        keyword: C_KEYWORDS,
        type: C_TYPES,
        literal: 'true false NULL',
        // TODO: apply hinting work similar to what was done in cpp.js
        built_in: "std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set pair bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap priority_queue make_pair array shared_ptr abort terminate abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr"
    };
    const EXPRESSION_CONTAINS = [
        ...PREPROCESSORS,
        TYPES,
        C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        NUMBERS,
        STRINGS
    ];
    const EXPRESSION_CONTEXT = {
        // This mode covers expression context where we can't expect a function
        // definition and shouldn't highlight anything that looks like one:
        // `return some()`, `else if()`, `(x*sum(1, 2))`
        variants: [
            {
                begin: /=/,
                end: /;/
            },
            {
                begin: /\(/,
                end: /\)/
            },
            {
                beginKeywords: 'new throw return else',
                end: /;/
            }
        ],
        keywords: KEYWORDS,
        contains: EXPRESSION_CONTAINS.concat([
            {
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS,
                contains: EXPRESSION_CONTAINS.concat([
                    'self'
                ]),
                relevance: 0
            }
        ]),
        relevance: 0
    };
    const FUNCTION_DECLARATION = {
        begin: '(' + FUNCTION_TYPE_RE + '[\\*&\\s]+){1,' + MAX_FUNCTION_TYPE_TOKENS + '}' + FUNCTION_TITLE,
        returnBegin: true,
        end: /[{;=]/,
        excludeEnd: true,
        keywords: KEYWORDS,
        illegal: /[^\w\s\*&:<>.]/,
        contains: [
            {
                begin: DECLTYPE_AUTO_RE,
                keywords: KEYWORDS,
                relevance: 0
            },
            {
                begin: FUNCTION_TITLE,
                returnBegin: true,
                contains: [
                    hljs.inherit(TITLE_MODE, {
                        className: "title.function"
                    })
                ],
                relevance: 0
            },
            // allow for multiple declarations, e.g.:
            // extern void f(int), g(char);
            {
                relevance: 0,
                match: /,/
            },
            {
                className: 'params',
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS,
                relevance: 0,
                contains: [
                    C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    STRINGS,
                    NUMBERS,
                    TYPES,
                    // Count matching parentheses.
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            'self',
                            C_LINE_COMMENT_MODE,
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRINGS,
                            NUMBERS,
                            TYPES
                        ]
                    }
                ]
            },
            TYPES,
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            ...PREPROCESSORS
        ]
    };
    return {
        name: "C",
        aliases: [
            'h'
        ],
        keywords: KEYWORDS,
        // Until differentiations are added between `c` and `cpp`, `c` will
        // not be auto-detected to avoid auto-detect conflicts between C and C++
        disableAutodetect: true,
        illegal: '</',
        contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, EXPRESSION_CONTAINS, [
            ...PREPROCESSORS,
            {
                begin: hljs.IDENT_RE + '::',
                keywords: KEYWORDS
            },
            {
                className: 'class',
                beginKeywords: 'enum class struct union',
                end: /[{;:<>=]/,
                contains: [
                    {
                        beginKeywords: "final class struct"
                    },
                    hljs.TITLE_MODE
                ]
            }
        ]),
        exports: {
            preprocessor: PREPROCESSOR,
            strings: STRINGS,
            keywords: KEYWORDS
        }
    };
}


/*
Language: C++
Category: common, system
Website: https://isocpp.org
*/ /** @type LanguageFn */ function $c63eafa0a78a3ade$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    // added for historic reasons because `hljs.C_LINE_COMMENT_MODE` does
    // not include such support nor can we be sure all the grammars depending
    // on it would desire this behavior
    const C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$', {
        contains: [
            {
                begin: /\\\n/
            }
        ]
    });
    const DECLTYPE_AUTO_RE = 'decltype\\(auto\\)';
    const NAMESPACE_RE = '[a-zA-Z_]\\w*::';
    const TEMPLATE_ARGUMENT_RE = '<[^<>]+>';
    const FUNCTION_TYPE_RE = '(?!struct)(' + DECLTYPE_AUTO_RE + '|' + regex.optional(NAMESPACE_RE) + '[a-zA-Z_]\\w*' + regex.optional(TEMPLATE_ARGUMENT_RE) + ')';
    const CPP_PRIMITIVE_TYPES = {
        className: 'type',
        begin: '\\b[a-z\\d_]*_t\\b'
    };
    // https://en.cppreference.com/w/cpp/language/escape
    // \\ \x \xFF \u2837 \u00323747 \374
    const CHARACTER_ESCAPES = '\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)';
    const STRINGS = {
        className: 'string',
        variants: [
            {
                begin: '(u8?|U|L)?"',
                end: '"',
                illegal: '\\n',
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: '(u8?|U|L)?\'(' + CHARACTER_ESCAPES + '|.)',
                end: '\'',
                illegal: '.'
            },
            // https://en.cppreference.com/w/cpp/language/string_literal
            // a d-char-sequence never contains parentheses, backslashes or whitespace;
            // quotes are excluded as well so the closing delimiter cannot swallow the
            // quote that actually terminates the literal
            hljs.END_SAME_AS_BEGIN({
                begin: /(?:u8?|U|L)?R"([^()\\\s"]{0,16})\(/,
                end: /\)([^()\\\s"]{0,16})"/
            })
        ]
    };
    const NUMBERS = {
        className: 'number',
        variants: [
            // Floating-point literal.
            {
                begin: "[+-]?(?:(?:\\b[0-9](?:'?[0-9])*\\.(?:[0-9](?:'?[0-9])*)?|\\.[0-9](?:'?[0-9])*)(?:[Ee][+-]?[0-9](?:'?[0-9])*)?|\\b[0-9](?:'?[0-9])*[Ee][+-]?[0-9](?:'?[0-9])*|\\b0[Xx](?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*(?:\\.(?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)?)?|\\.[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)[Pp][+-]?[0-9](?:'?[0-9])*)(?:[Ff](?:16|32|64|128)?|(BF|bf)16|[Ll]|)"
            },
            // Integer literal.
            {
                begin: "[+-]?\\b(?:0[Bb][01](?:'?[01])*|0[Xx][0-9A-Fa-f](?:'?[0-9A-Fa-f])*|0(?:'?[0-7])*|[1-9](?:'?[0-9])*)(?:[Uu](?:LL?|ll?)|[Uu][Zz]?|(?:LL?|ll?)[Uu]?|[Zz][Uu]|)"
            }
        ],
        relevance: 0
    };
    // `#include` is the only preprocessor directive that takes an angle-bracket
    // quoted header (`#include <header>`). Scoping that rule to `#include` keeps
    // the greedy `<...>` match from eating a `>` that belongs to the body of
    // another directive (e.g. `#define what do { cout << ">"; } while (0)`),
    // which would otherwise leave an unbalanced `"` and break highlighting for
    // the rest of the file. See issue #3505.
    const PREPROCESSOR_INCLUDE = {
        scope: 'meta',
        begin: /#\s*include\b/,
        end: /$/,
        keywords: {
            keyword: 'include'
        },
        contains: [
            {
                // the `\` at the end of a line signaling continuation
                begin: /\\\n/
            },
            STRINGS,
            {
                scope: 'string',
                begin: /<.*?>/
            },
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    const PREPROCESSOR = {
        className: 'meta',
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: {
            keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            hljs.inherit(STRINGS, {
                className: 'string'
            }),
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    const PREPROCESSORS = [
        PREPROCESSOR_INCLUDE,
        PREPROCESSOR
    ];
    const TITLE_MODE = {
        className: 'title',
        begin: regex.optional(NAMESPACE_RE) + hljs.IDENT_RE,
        relevance: 0
    };
    const FUNCTION_TITLE = regex.optional(NAMESPACE_RE) + hljs.IDENT_RE + '\\s*\\(';
    // Bounded on purpose: an unbounded quantifier here consumes an arbitrarily
    // long run of words, and when no function title follows it the engine retries
    // the title at every token boundary of that run - quadratic in the size of
    // the document.  See #4362.
    const MAX_FUNCTION_TYPE_TOKENS = 12;
    // https://en.cppreference.com/w/cpp/keyword
    const RESERVED_KEYWORDS = [
        'alignas',
        'alignof',
        'and',
        'and_eq',
        'asm',
        'atomic_cancel',
        'atomic_commit',
        'atomic_noexcept',
        'auto',
        'bitand',
        'bitor',
        'break',
        'case',
        'catch',
        'class',
        'co_await',
        'co_return',
        'co_yield',
        'compl',
        'concept',
        'const_cast|10',
        'consteval',
        'constexpr',
        'constinit',
        'continue',
        'decltype',
        'default',
        'delete',
        'do',
        'dynamic_cast|10',
        'else',
        'enum',
        'explicit',
        'export',
        'extern',
        'false',
        'final',
        'for',
        'friend',
        'goto',
        'if',
        'import',
        'inline',
        'module',
        'mutable',
        'namespace',
        'new',
        'noexcept',
        'not',
        'not_eq',
        'nullptr',
        'operator',
        'or',
        'or_eq',
        'override',
        'private',
        'protected',
        'public',
        'reflexpr',
        'register',
        'reinterpret_cast|10',
        'requires',
        'return',
        'sizeof',
        'static_assert',
        'static_cast|10',
        'struct',
        'switch',
        'synchronized',
        'template',
        'this',
        'thread_local',
        'throw',
        'transaction_safe',
        'transaction_safe_dynamic',
        'true',
        'try',
        'typedef',
        'typeid',
        'typename',
        'union',
        'using',
        'virtual',
        'volatile',
        'while',
        'xor',
        'xor_eq'
    ];
    // https://en.cppreference.com/w/cpp/keyword
    const RESERVED_TYPES = [
        'bool',
        'char',
        'char16_t',
        'char32_t',
        'char8_t',
        'double',
        'float',
        'int',
        'long',
        'short',
        'void',
        'wchar_t',
        'unsigned',
        'signed',
        'const',
        'static'
    ];
    const TYPE_HINTS = [
        'any',
        'auto_ptr',
        'barrier',
        'binary_semaphore',
        'bitset',
        'complex',
        'condition_variable',
        'condition_variable_any',
        'counting_semaphore',
        'deque',
        'false_type',
        'flat_map',
        'flat_set',
        'future',
        'imaginary',
        'initializer_list',
        'istringstream',
        'jthread',
        'latch',
        'lock_guard',
        'multimap',
        'multiset',
        'mutex',
        'optional',
        'ostringstream',
        'packaged_task',
        'pair',
        'promise',
        'priority_queue',
        'queue',
        'recursive_mutex',
        'recursive_timed_mutex',
        'scoped_lock',
        'set',
        'shared_future',
        'shared_lock',
        'shared_mutex',
        'shared_timed_mutex',
        'shared_ptr',
        'stack',
        'string_view',
        'stringstream',
        'timed_mutex',
        'thread',
        'true_type',
        'tuple',
        'unique_lock',
        'unique_ptr',
        'unordered_map',
        'unordered_multimap',
        'unordered_multiset',
        'unordered_set',
        'variant',
        'vector',
        'weak_ptr',
        'wstring',
        'wstring_view'
    ];
    const FUNCTION_HINTS = [
        'abort',
        'abs',
        'acos',
        'apply',
        'as_const',
        'asin',
        'atan',
        'atan2',
        'calloc',
        'ceil',
        'cerr',
        'cin',
        'clog',
        'cos',
        'cosh',
        'cout',
        'declval',
        'endl',
        'exchange',
        'exit',
        'exp',
        'fabs',
        'floor',
        'fmod',
        'forward',
        'fprintf',
        'fputs',
        'free',
        'frexp',
        'fscanf',
        'future',
        'invoke',
        'isalnum',
        'isalpha',
        'iscntrl',
        'isdigit',
        'isgraph',
        'islower',
        'isprint',
        'ispunct',
        'isspace',
        'isupper',
        'isxdigit',
        'labs',
        'launder',
        'ldexp',
        'log',
        'log10',
        'make_pair',
        'make_shared',
        'make_shared_for_overwrite',
        'make_tuple',
        'make_unique',
        'malloc',
        'memchr',
        'memcmp',
        'memcpy',
        'memset',
        'modf',
        'move',
        'pow',
        'printf',
        'putchar',
        'puts',
        'realloc',
        'scanf',
        'sin',
        'sinh',
        'snprintf',
        'sprintf',
        'sqrt',
        'sscanf',
        'std',
        'stderr',
        'stdin',
        'stdout',
        'strcat',
        'strchr',
        'strcmp',
        'strcpy',
        'strcspn',
        'strlen',
        'strncat',
        'strncmp',
        'strncpy',
        'strpbrk',
        'strrchr',
        'strspn',
        'strstr',
        'swap',
        'tan',
        'tanh',
        'terminate',
        'to_underlying',
        'tolower',
        'toupper',
        'vfprintf',
        'visit',
        'vprintf',
        'vsprintf'
    ];
    const LITERALS = [
        'NULL',
        'false',
        'nullopt',
        'nullptr',
        'true'
    ];
    // https://en.cppreference.com/w/cpp/keyword
    const BUILT_IN = [
        '_Pragma'
    ];
    const CPP_KEYWORDS = {
        type: RESERVED_TYPES,
        keyword: RESERVED_KEYWORDS,
        literal: LITERALS,
        built_in: BUILT_IN,
        _type_hints: TYPE_HINTS
    };
    const FUNCTION_DISPATCH = {
        className: 'function.dispatch',
        relevance: 0,
        keywords: {
            // Only for relevance, not highlighting.
            _hint: FUNCTION_HINTS
        },
        begin: regex.concat(/\b/, `(?!${RESERVED_KEYWORDS.join('|')})`, hljs.IDENT_RE, regex.lookahead(/(<[^<>]+>|)\s*\(/))
    };
    const EXPRESSION_CONTAINS = [
        FUNCTION_DISPATCH,
        ...PREPROCESSORS,
        CPP_PRIMITIVE_TYPES,
        C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        NUMBERS,
        STRINGS
    ];
    const EXPRESSION_CONTEXT = {
        // This mode covers expression context where we can't expect a function
        // definition and shouldn't highlight anything that looks like one:
        // `return some()`, `else if()`, `(x*sum(1, 2))`
        variants: [
            {
                begin: /=/,
                end: /;/
            },
            {
                begin: /\(/,
                end: /\)/
            },
            {
                beginKeywords: 'new throw return else',
                end: /;/
            }
        ],
        keywords: CPP_KEYWORDS,
        contains: EXPRESSION_CONTAINS.concat([
            {
                begin: /\(/,
                end: /\)/,
                keywords: CPP_KEYWORDS,
                contains: EXPRESSION_CONTAINS.concat([
                    'self'
                ]),
                relevance: 0
            }
        ]),
        relevance: 0
    };
    const FUNCTION_DECLARATION = {
        className: 'function',
        begin: '(' + FUNCTION_TYPE_RE + '[\\*&\\s]+){1,' + MAX_FUNCTION_TYPE_TOKENS + '}' + FUNCTION_TITLE,
        returnBegin: true,
        end: /[{;=]/,
        excludeEnd: true,
        keywords: CPP_KEYWORDS,
        illegal: /[^\w\s\*&:<>.]/,
        contains: [
            {
                begin: DECLTYPE_AUTO_RE,
                keywords: CPP_KEYWORDS,
                relevance: 0
            },
            {
                begin: FUNCTION_TITLE,
                returnBegin: true,
                contains: [
                    TITLE_MODE
                ],
                relevance: 0
            },
            // needed because we do not have look-behind on the below rule
            // to prevent it from grabbing the final : in a :: pair
            {
                begin: /::/,
                relevance: 0
            },
            // initializers
            {
                begin: /:/,
                endsWithParent: true,
                contains: [
                    STRINGS,
                    NUMBERS
                ]
            },
            // allow for multiple declarations, e.g.:
            // extern void f(int), g(char);
            {
                relevance: 0,
                match: /,/
            },
            {
                className: 'params',
                begin: /\(/,
                end: /\)/,
                keywords: CPP_KEYWORDS,
                relevance: 0,
                contains: [
                    C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    STRINGS,
                    NUMBERS,
                    CPP_PRIMITIVE_TYPES,
                    // Count matching parentheses.
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: CPP_KEYWORDS,
                        relevance: 0,
                        contains: [
                            'self',
                            C_LINE_COMMENT_MODE,
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRINGS,
                            NUMBERS,
                            CPP_PRIMITIVE_TYPES
                        ]
                    }
                ]
            },
            CPP_PRIMITIVE_TYPES,
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            ...PREPROCESSORS
        ]
    };
    return {
        name: 'C++',
        aliases: [
            'cc',
            'c++',
            'h++',
            'hpp',
            'hh',
            'hxx',
            'cxx'
        ],
        keywords: CPP_KEYWORDS,
        illegal: '</',
        classNameAliases: {
            'function.dispatch': 'built_in'
        },
        contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, FUNCTION_DISPATCH, EXPRESSION_CONTAINS, [
            ...PREPROCESSORS,
            {
                begin: '\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function|flat_map|flat_set)\\s*<(?!<)',
                end: '>',
                keywords: CPP_KEYWORDS,
                contains: [
                    'self',
                    CPP_PRIMITIVE_TYPES
                ]
            },
            {
                begin: hljs.IDENT_RE + '::',
                keywords: CPP_KEYWORDS
            },
            {
                match: [
                    // extra complexity to deal with `enum class` and `enum struct`
                    /\b(?:enum(?:\s+(?:class|struct))?|class|struct|union)/,
                    /\s+/,
                    /\w+/
                ],
                className: {
                    1: 'keyword',
                    3: 'title.class'
                }
            }
        ])
    };
}


// https://docs.oracle.com/javase/specs/jls/se15/html/jls-3.html#jls-3.10
var $c7926bfa1a55c2ec$var$decimalDigits = '[0-9](_*[0-9])*';
var $c7926bfa1a55c2ec$var$frac = `\\.(${$c7926bfa1a55c2ec$var$decimalDigits})`;
var $c7926bfa1a55c2ec$var$hexDigits = '[0-9a-fA-F](_*[0-9a-fA-F])*';
var $c7926bfa1a55c2ec$var$NUMERIC = {
    className: 'number',
    variants: [
        // DecimalFloatingPointLiteral
        // including ExponentPart
        {
            begin: `(\\b(${$c7926bfa1a55c2ec$var$decimalDigits})((${$c7926bfa1a55c2ec$var$frac})|\\.)?|(${$c7926bfa1a55c2ec$var$frac}))` + `[eE][+-]?(${$c7926bfa1a55c2ec$var$decimalDigits})[fFdD]?\\b`
        },
        // excluding ExponentPart
        {
            begin: `\\b(${$c7926bfa1a55c2ec$var$decimalDigits})((${$c7926bfa1a55c2ec$var$frac})[fFdD]?\\b|\\.([fFdD]\\b)?)`
        },
        {
            begin: `(${$c7926bfa1a55c2ec$var$frac})[fFdD]?\\b`
        },
        {
            begin: `\\b(${$c7926bfa1a55c2ec$var$decimalDigits})[fFdD]\\b`
        },
        // HexadecimalFloatingPointLiteral
        {
            begin: `\\b0[xX]((${$c7926bfa1a55c2ec$var$hexDigits})\\.?|(${$c7926bfa1a55c2ec$var$hexDigits})?\\.(${$c7926bfa1a55c2ec$var$hexDigits}))` + `[pP][+-]?(${$c7926bfa1a55c2ec$var$decimalDigits})[fFdD]?\\b`
        },
        // DecimalIntegerLiteral
        {
            begin: '\\b(0|[1-9](_*[0-9])*)[lL]?\\b'
        },
        // HexIntegerLiteral
        {
            begin: `\\b0[xX](${$c7926bfa1a55c2ec$var$hexDigits})[lL]?\\b`
        },
        // OctalIntegerLiteral
        {
            begin: '\\b0(_*[0-7])*[lL]?\\b'
        },
        // BinaryIntegerLiteral
        {
            begin: '\\b0[bB][01](_*[01])*[lL]?\\b'
        }
    ],
    relevance: 0
};
/*
Language: Java
Author: Vsevolod Solovyov <vsevolod.solovyov@gmail.com>
Category: common, enterprise
Website: https://www.java.com/
*/ /**
 * Allows recursive regex expressions to a given depth
 *
 * ie: recurRegex("(abc~~~)", /~~~/g, 2) becomes:
 * (abc(abc(abc)))
 *
 * @param {string} re
 * @param {RegExp} substitution (should be a g mode regex)
 * @param {number} depth
 * @returns {string}``
 */ function $c7926bfa1a55c2ec$var$recurRegex(re, substitution, depth) {
    if (depth === -1) return "";
    return re.replace(substitution, (_)=>{
        return $c7926bfa1a55c2ec$var$recurRegex(re, substitution, depth - 1);
    });
}
/** @type LanguageFn */ function $c7926bfa1a55c2ec$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    // A Java identifier consisting of letters, digits, underscore or dollar sign, not beginning with a digit
    const JAVA_IDENT_RE = '[\u00C0-\u02B8a-zA-Z_$][\u00C0-\u02B8a-zA-Z_$0-9]*';
    // Optional 1..n pairs of square brackets identifying an array type
    const ARRAY_BRACKETS_OPTIONAL_RE = '(?:(?:\\s*\\[\\s*])+)?';
    // A simple Java type: a type name, optionally followed by type arguments and/or array brackets
    // '<@@@>' is replaced with the pattern for optional type arguments by recurRegex below.
    const SIMPLE_TYPE_RE = JAVA_IDENT_RE + '<@@@>' + ARRAY_BRACKETS_OPTIONAL_RE;
    // A bounded (? extends Number) or unbounded (?) wildcard type
    const WILDCARD_TYPE_RE = '\\?(?:\\s+(?:extends|super)\\s+' + SIMPLE_TYPE_RE + ')?';
    // A Java type argument, consisting of a wildcard or simple type
    const TYPE_ARG_RE = '(?:' + WILDCARD_TYPE_RE + '|' + SIMPLE_TYPE_RE + ')';
    // Pattern for optional generic type arguments in angle brackets with up to 2 levels of nested type arguments
    const TYPE_ARGS_OPTIONAL_RE = $c7926bfa1a55c2ec$var$recurRegex('(?:\\s*<\\s*' + TYPE_ARG_RE + '(?:\\s*,\\s*' + TYPE_ARG_RE + ')*\\s*>)?', /<@@@>/g, 2);
    const MAIN_KEYWORDS = [
        'synchronized',
        'abstract',
        'private',
        'var',
        'static',
        'if',
        'const ',
        'for',
        'while',
        'strictfp',
        'finally',
        'protected',
        'import',
        'native',
        'final',
        'void',
        'enum',
        'else',
        'break',
        'transient',
        'catch',
        'instanceof',
        'volatile',
        'case',
        'assert',
        'package',
        'default',
        'public',
        'try',
        'switch',
        'continue',
        'throws',
        'protected',
        'public',
        'private',
        'module',
        'requires',
        'exports',
        'do',
        'sealed',
        'yield',
        'permits',
        'goto',
        'when'
    ];
    const BUILT_INS = [
        'super',
        'this'
    ];
    const LITERALS = [
        'false',
        'true',
        'null'
    ];
    const TYPES = [
        'char',
        'boolean',
        'long',
        'float',
        'int',
        'byte',
        'short',
        'double'
    ];
    const KEYWORDS = {
        keyword: MAIN_KEYWORDS,
        literal: LITERALS,
        type: TYPES,
        built_in: BUILT_INS
    };
    const ANNOTATION = {
        className: 'meta',
        begin: '@' + JAVA_IDENT_RE,
        contains: [
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    "self"
                ] // allow nested () inside our annotation
            }
        ]
    };
    const PARAMS = {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        keywords: KEYWORDS,
        relevance: 0,
        contains: [
            hljs.C_BLOCK_COMMENT_MODE
        ],
        endsParent: true
    };
    return {
        name: 'Java',
        aliases: [
            'jsp'
        ],
        keywords: KEYWORDS,
        illegal: /<\/|#/,
        contains: [
            hljs.COMMENT('/\\*\\*', '\\*/', {
                relevance: 0,
                contains: [
                    {
                        // eat up @'s in emails to prevent them to be recognized as doctags
                        begin: /\w+@/,
                        relevance: 0
                    },
                    {
                        className: 'doctag',
                        begin: '@[A-Za-z]+'
                    }
                ]
            }),
            // relevance boost
            {
                begin: /import java\.[a-z]+\./,
                keywords: "import",
                relevance: 2
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                begin: /"""/,
                end: /"""/,
                className: "string",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                match: [
                    /\b(?:class|interface|enum|extends|implements|new)/,
                    /\s+/,
                    JAVA_IDENT_RE
                ],
                className: {
                    1: "keyword",
                    3: "title.class"
                }
            },
            {
                // Exceptions for hyphenated keywords
                match: /non-sealed/,
                scope: "keyword"
            },
            {
                // Expression keywords prevent keyword-led expressions from being
                // recognized as variable or method declarations.
                beginKeywords: 'new throw return else yield assert',
                relevance: 0
            },
            {
                begin: [
                    JAVA_IDENT_RE,
                    regex.concat(TYPE_ARGS_OPTIONAL_RE, ARRAY_BRACKETS_OPTIONAL_RE, /\s+/),
                    JAVA_IDENT_RE,
                    ARRAY_BRACKETS_OPTIONAL_RE,
                    /\s*/,
                    /=(?!=)/
                ],
                className: {
                    1: "type",
                    3: "variable",
                    6: "operator"
                }
            },
            {
                begin: [
                    /record/,
                    /\s+/,
                    JAVA_IDENT_RE
                ],
                className: {
                    1: "keyword",
                    3: "title.class"
                },
                contains: [
                    PARAMS,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                begin: [
                    JAVA_IDENT_RE,
                    regex.concat(TYPE_ARGS_OPTIONAL_RE, ARRAY_BRACKETS_OPTIONAL_RE, /\s+/),
                    JAVA_IDENT_RE,
                    /\s*(?=\()/
                ],
                className: {
                    1: "type",
                    3: "title.function"
                },
                keywords: KEYWORDS,
                contains: [
                    {
                        className: 'params',
                        begin: /\(/,
                        end: /\)/,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            ANNOTATION,
                            hljs.APOS_STRING_MODE,
                            hljs.QUOTE_STRING_MODE,
                            $c7926bfa1a55c2ec$var$NUMERIC,
                            hljs.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            $c7926bfa1a55c2ec$var$NUMERIC,
            ANNOTATION
        ]
    };
}


/*
 Language: SQL
 Website: https://en.wikipedia.org/wiki/SQL
 Category: common, database
 */ /*

Goals:

SQL is intended to highlight basic/common SQL keywords and expressions

- If pretty much every single SQL server includes supports, then it's a canidate.
- It is NOT intended to include tons of vendor specific keywords (Oracle, MySQL,
  PostgreSQL) although the list of data types is purposely a bit more expansive.
- For more specific SQL grammars please see:
  - PostgreSQL and PL/pgSQL - core
  - T-SQL - https://github.com/highlightjs/highlightjs-tsql
  - sql_more (core)

 */ function $1b0c8cb9d63197fa$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    const COMMENT_MODE = hljs.COMMENT('--', '$');
    const STRING = {
        scope: 'string',
        variants: [
            {
                begin: /'/,
                end: /'/,
                contains: [
                    {
                        match: /''/
                    }
                ]
            }
        ]
    };
    const QUOTED_IDENTIFIER = {
        begin: /"/,
        end: /"/,
        contains: [
            {
                match: /""/
            }
        ]
    };
    const LITERALS = [
        "true",
        "false",
        // Not sure it's correct to call NULL literal, and clauses like IS [NOT] NULL look strange that way.
        // "null",
        "unknown"
    ];
    const MULTI_WORD_TYPES = [
        "double precision",
        "large object",
        "with timezone",
        "without timezone"
    ];
    const TYPES = [
        'bigint',
        'binary',
        'blob',
        'boolean',
        'char',
        'character',
        'clob',
        'date',
        'dec',
        'decfloat',
        'decimal',
        'float',
        'int',
        'integer',
        'interval',
        'nchar',
        'nclob',
        'national',
        'numeric',
        'real',
        'row',
        'smallint',
        'time',
        'timestamp',
        'varchar',
        'varying',
        'varbinary'
    ];
    const NON_RESERVED_WORDS = [
        "add",
        "asc",
        "collation",
        "desc",
        "final",
        "first",
        "last",
        "view"
    ];
    // https://jakewheat.github.io/sql-overview/sql-2016-foundation-grammar.html#reserved-word
    const RESERVED_WORDS = [
        "abs",
        "acos",
        "all",
        "allocate",
        "alter",
        "and",
        "any",
        "are",
        "array",
        "array_agg",
        "array_max_cardinality",
        "as",
        "asensitive",
        "asin",
        "asymmetric",
        "at",
        "atan",
        "atomic",
        "authorization",
        "avg",
        "begin",
        "begin_frame",
        "begin_partition",
        "between",
        "bigint",
        "binary",
        "blob",
        "boolean",
        "both",
        "by",
        "call",
        "called",
        "cardinality",
        "cascaded",
        "case",
        "cast",
        "ceil",
        "ceiling",
        "char",
        "char_length",
        "character",
        "character_length",
        "check",
        "classifier",
        "clob",
        "close",
        "coalesce",
        "collate",
        "collect",
        "column",
        "commit",
        "condition",
        "connect",
        "constraint",
        "contains",
        "convert",
        "copy",
        "corr",
        "corresponding",
        "cos",
        "cosh",
        "count",
        "covar_pop",
        "covar_samp",
        "create",
        "cross",
        "cube",
        "cume_dist",
        "current",
        "current_catalog",
        "current_date",
        "current_default_transform_group",
        "current_path",
        "current_role",
        "current_row",
        "current_schema",
        "current_time",
        "current_timestamp",
        "current_path",
        "current_role",
        "current_transform_group_for_type",
        "current_user",
        "cursor",
        "cycle",
        "date",
        "day",
        "deallocate",
        "dec",
        "decimal",
        "decfloat",
        "declare",
        "default",
        "define",
        "delete",
        "dense_rank",
        "deref",
        "describe",
        "deterministic",
        "disconnect",
        "distinct",
        "double",
        "drop",
        "dynamic",
        "each",
        "element",
        "else",
        "empty",
        "end",
        "end_frame",
        "end_partition",
        "end-exec",
        "equals",
        "escape",
        "every",
        "except",
        "exec",
        "execute",
        "exists",
        "exp",
        "external",
        "extract",
        "false",
        "fetch",
        "filter",
        "first_value",
        "float",
        "floor",
        "for",
        "foreign",
        "frame_row",
        "free",
        "from",
        "full",
        "function",
        "fusion",
        "get",
        "global",
        "grant",
        "group",
        "grouping",
        "groups",
        "having",
        "hold",
        "hour",
        "identity",
        "in",
        "indicator",
        "initial",
        "inner",
        "inout",
        "insensitive",
        "insert",
        "int",
        "integer",
        "intersect",
        "intersection",
        "interval",
        "into",
        "is",
        "join",
        "json_array",
        "json_arrayagg",
        "json_exists",
        "json_object",
        "json_objectagg",
        "json_query",
        "json_table",
        "json_table_primitive",
        "json_value",
        "lag",
        "language",
        "large",
        "last_value",
        "lateral",
        "lead",
        "leading",
        "left",
        "like",
        "like_regex",
        "listagg",
        "ln",
        "local",
        "localtime",
        "localtimestamp",
        "log",
        "log10",
        "lower",
        "match",
        "match_number",
        "match_recognize",
        "matches",
        "max",
        "member",
        "merge",
        "method",
        "min",
        "minute",
        "mod",
        "modifies",
        "module",
        "month",
        "multiset",
        "national",
        "natural",
        "nchar",
        "nclob",
        "new",
        "no",
        "none",
        "normalize",
        "not",
        "nth_value",
        "ntile",
        "null",
        "nullif",
        "numeric",
        "octet_length",
        "occurrences_regex",
        "of",
        "offset",
        "old",
        "omit",
        "on",
        "one",
        "only",
        "open",
        "or",
        "order",
        "out",
        "outer",
        "over",
        "overlaps",
        "overlay",
        "parameter",
        "partition",
        "pattern",
        "per",
        "percent",
        "percent_rank",
        "percentile_cont",
        "percentile_disc",
        "period",
        "portion",
        "position",
        "position_regex",
        "power",
        "precedes",
        "precision",
        "prepare",
        "primary",
        "procedure",
        "ptf",
        "range",
        "rank",
        "reads",
        "real",
        "recursive",
        "ref",
        "references",
        "referencing",
        "regr_avgx",
        "regr_avgy",
        "regr_count",
        "regr_intercept",
        "regr_r2",
        "regr_slope",
        "regr_sxx",
        "regr_sxy",
        "regr_syy",
        "release",
        "result",
        "return",
        "returns",
        "revoke",
        "right",
        "rollback",
        "rollup",
        "row",
        "row_number",
        "rows",
        "running",
        "savepoint",
        "scope",
        "scroll",
        "search",
        "second",
        "seek",
        "select",
        "sensitive",
        "session_user",
        "set",
        "show",
        "similar",
        "sin",
        "sinh",
        "skip",
        "smallint",
        "some",
        "specific",
        "specifictype",
        "sql",
        "sqlexception",
        "sqlstate",
        "sqlwarning",
        "sqrt",
        "start",
        "static",
        "stddev_pop",
        "stddev_samp",
        "submultiset",
        "subset",
        "substring",
        "substring_regex",
        "succeeds",
        "sum",
        "symmetric",
        "system",
        "system_time",
        "system_user",
        "table",
        "tablesample",
        "tan",
        "tanh",
        "then",
        "time",
        "timestamp",
        "timezone_hour",
        "timezone_minute",
        "to",
        "trailing",
        "translate",
        "translate_regex",
        "translation",
        "treat",
        "trigger",
        "trim",
        "trim_array",
        "true",
        "truncate",
        "uescape",
        "union",
        "unique",
        "unknown",
        "unnest",
        "update",
        "upper",
        "user",
        "using",
        "value",
        "values",
        "value_of",
        "var_pop",
        "var_samp",
        "varbinary",
        "varchar",
        "varying",
        "versioning",
        "when",
        "whenever",
        "where",
        "width_bucket",
        "window",
        "with",
        "within",
        "without",
        "year"
    ];
    // these are reserved words we have identified to be functions
    // and should only be highlighted in a dispatch-like context
    // ie, array_agg(...), etc.
    const RESERVED_FUNCTIONS = [
        "abs",
        "acos",
        "array_agg",
        "asin",
        "atan",
        "avg",
        "cast",
        "ceil",
        "ceiling",
        "coalesce",
        "corr",
        "cos",
        "cosh",
        "count",
        "covar_pop",
        "covar_samp",
        "cume_dist",
        "dense_rank",
        "deref",
        "element",
        "exp",
        "extract",
        "first_value",
        "floor",
        "json_array",
        "json_arrayagg",
        "json_exists",
        "json_object",
        "json_objectagg",
        "json_query",
        "json_table",
        "json_table_primitive",
        "json_value",
        "lag",
        "last_value",
        "lead",
        "listagg",
        "ln",
        "log",
        "log10",
        "lower",
        "max",
        "min",
        "mod",
        "nth_value",
        "ntile",
        "nullif",
        "percent_rank",
        "percentile_cont",
        "percentile_disc",
        "position",
        "position_regex",
        "power",
        "rank",
        "regr_avgx",
        "regr_avgy",
        "regr_count",
        "regr_intercept",
        "regr_r2",
        "regr_slope",
        "regr_sxx",
        "regr_sxy",
        "regr_syy",
        "row_number",
        "sin",
        "sinh",
        "sqrt",
        "stddev_pop",
        "stddev_samp",
        "substring",
        "substring_regex",
        "sum",
        "tan",
        "tanh",
        "translate",
        "translate_regex",
        "treat",
        "trim",
        "trim_array",
        "unnest",
        "upper",
        "value_of",
        "var_pop",
        "var_samp",
        "width_bucket"
    ];
    // these functions can
    const POSSIBLE_WITHOUT_PARENS = [
        "current_catalog",
        "current_date",
        "current_default_transform_group",
        "current_path",
        "current_role",
        "current_schema",
        "current_transform_group_for_type",
        "current_user",
        "session_user",
        "system_time",
        "system_user",
        "current_time",
        "localtime",
        "current_timestamp",
        "localtimestamp"
    ];
    // those exist to boost relevance making these very
    // "SQL like" keyword combos worth +1 extra relevance
    const COMBOS = [
        "create table",
        "insert into",
        "primary key",
        "foreign key",
        "not null",
        "alter table",
        "add constraint",
        "grouping sets",
        "on overflow",
        "character set",
        "respect nulls",
        "ignore nulls",
        "nulls first",
        "nulls last",
        "depth first",
        "breadth first"
    ];
    const FUNCTIONS = RESERVED_FUNCTIONS;
    const KEYWORDS = [
        ...RESERVED_WORDS,
        ...NON_RESERVED_WORDS
    ].filter((keyword)=>{
        return !RESERVED_FUNCTIONS.includes(keyword);
    });
    const VARIABLE = {
        scope: "variable",
        match: /@[a-z0-9][a-z0-9_]*/
    };
    const OPERATOR = {
        scope: "operator",
        match: /[-+*/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,
        relevance: 0
    };
    const FUNCTION_CALL = {
        match: regex.concat(/\b/, regex.either(...FUNCTIONS), /\s*\(/),
        relevance: 0,
        keywords: {
            built_in: FUNCTIONS
        }
    };
    // turns a multi-word keyword combo into a regex that doesn't
    // care about extra whitespace etc.
    // input: "START QUERY"
    // output: /\bSTART\s+QUERY\b/
    function kws_to_regex(list) {
        return regex.concat(/\b/, regex.either(...list.map((kw)=>{
            return kw.replace(/\s+/, "\\s+");
        })), /\b/);
    }
    const MULTI_WORD_KEYWORDS = {
        scope: "keyword",
        match: kws_to_regex(COMBOS),
        relevance: 0
    };
    // keywords with less than 3 letters are reduced in relevancy
    function reduceRelevancy(list, { exceptions: exceptions, when: when } = {}) {
        const qualifyFn = when;
        exceptions = exceptions || [];
        return list.map((item)=>{
            if (item.match(/\|\d+$/) || exceptions.includes(item)) return item;
            else if (qualifyFn(item)) return `${item}|0`;
            else return item;
        });
    }
    return {
        name: 'SQL',
        case_insensitive: true,
        // does not include {} or HTML tags `</`
        illegal: /[{}]|<\//,
        keywords: {
            $pattern: /\b[\w\.]+/,
            keyword: reduceRelevancy(KEYWORDS, {
                when: (x)=>x.length < 3
            }),
            literal: LITERALS,
            type: TYPES,
            built_in: POSSIBLE_WITHOUT_PARENS
        },
        contains: [
            {
                scope: "type",
                match: kws_to_regex(MULTI_WORD_TYPES)
            },
            MULTI_WORD_KEYWORDS,
            FUNCTION_CALL,
            VARIABLE,
            STRING,
            QUOTED_IDENTIFIER,
            hljs.C_NUMBER_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            COMMENT_MODE,
            OPERATOR
        ]
    };
}


/*
Language: Bash
Author: vah <vahtenberg@gmail.com>
Contributrors: Benjamin Pannell <contact@sierrasoftworks.com>
Website: https://www.gnu.org/software/bash/
Category: common, scripting
*/ /** @type LanguageFn */ function $3fae064f625e78b6$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    const VAR = {};
    const BRACED_VAR = {
        begin: /\$\{/,
        end: /\}/,
        contains: [
            "self",
            {
                begin: /:-/,
                contains: [
                    VAR
                ]
            } // default values
        ]
    };
    Object.assign(VAR, {
        className: 'variable',
        variants: [
            {
                begin: regex.concat(/\$[\w\d#@][\w\d_]*/, // negative look-ahead tries to avoid matching patterns that are not
                // Perl at all like $ident$, @ident@, etc.
                `(?![\\w\\d])(?![$])`)
            },
            BRACED_VAR
        ]
    });
    const SUBST = {
        className: 'subst',
        begin: /\$\(/,
        end: /\)/,
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    const COMMENT = hljs.inherit(hljs.COMMENT(), {
        match: [
            /(^|\s)/,
            /#.*$/
        ],
        scope: {
            2: 'comment'
        }
    });
    const HERE_DOC = {
        begin: /<<-?\s*(?=\w+)/,
        starts: {
            contains: [
                hljs.END_SAME_AS_BEGIN({
                    begin: /(\w+)/,
                    end: /(\w+)/,
                    className: 'string'
                })
            ]
        }
    };
    const QUOTE_STRING = {
        className: 'string',
        begin: /"/,
        end: /"/,
        contains: [
            hljs.BACKSLASH_ESCAPE,
            VAR,
            SUBST
        ]
    };
    SUBST.contains.push(QUOTE_STRING);
    const ESCAPED_QUOTE = {
        match: /\\"/
    };
    const APOS_STRING = {
        className: 'string',
        begin: /'/,
        end: /'/
    };
    const ESCAPED_APOS = {
        match: /\\'/
    };
    const ARITHMETIC = {
        begin: /\$?\(\(/,
        end: /\)\)/,
        contains: [
            {
                begin: /\d+#[0-9a-f]+/,
                className: "number"
            },
            hljs.NUMBER_MODE,
            VAR
        ]
    };
    const SH_LIKE_SHELLS = [
        "fish",
        "bash",
        "zsh",
        "sh",
        "csh",
        "ksh",
        "tcsh",
        "dash",
        "scsh"
    ];
    const KNOWN_SHEBANG = hljs.SHEBANG({
        binary: `(${SH_LIKE_SHELLS.join("|")})`,
        relevance: 10
    });
    const FUNCTION = {
        className: 'function',
        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
        returnBegin: true,
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                begin: /\w[\w\d_]*/
            })
        ],
        relevance: 0
    };
    const KEYWORDS = [
        "if",
        "then",
        "else",
        "elif",
        "fi",
        "time",
        "for",
        "while",
        "until",
        "in",
        "do",
        "done",
        "case",
        "esac",
        "coproc",
        "function",
        "select"
    ];
    const LITERALS = [
        "true",
        "false"
    ];
    // to consume paths to prevent keyword matches inside them
    const PATH_MODE = {
        match: /(\/[a-z._-]+)+/
    };
    // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
    const SHELL_BUILT_INS = [
        "break",
        "cd",
        "continue",
        "eval",
        "exec",
        "exit",
        "export",
        "getopts",
        "hash",
        "pwd",
        "readonly",
        "return",
        "shift",
        "test",
        "times",
        "trap",
        "umask",
        "unset"
    ];
    const BASH_BUILT_INS = [
        "alias",
        "bind",
        "builtin",
        "caller",
        "command",
        "declare",
        "echo",
        "enable",
        "help",
        "let",
        "local",
        "logout",
        "mapfile",
        "printf",
        "read",
        "readarray",
        "source",
        "sudo",
        "type",
        "typeset",
        "ulimit",
        "unalias"
    ];
    const ZSH_BUILT_INS = [
        "autoload",
        "bg",
        "bindkey",
        "bye",
        "cap",
        "chdir",
        "clone",
        "comparguments",
        "compcall",
        "compctl",
        "compdescribe",
        "compfiles",
        "compgroups",
        "compquote",
        "comptags",
        "comptry",
        "compvalues",
        "dirs",
        "disable",
        "disown",
        "echotc",
        "echoti",
        "emulate",
        "fc",
        "fg",
        "float",
        "functions",
        "getcap",
        "getln",
        "history",
        "integer",
        "jobs",
        "kill",
        "limit",
        "log",
        "noglob",
        "popd",
        "print",
        "pushd",
        "pushln",
        "rehash",
        "sched",
        "setcap",
        "setopt",
        "stat",
        "suspend",
        "ttyctl",
        "unfunction",
        "unhash",
        "unlimit",
        "unsetopt",
        "vared",
        "wait",
        "whence",
        "where",
        "which",
        "zcompile",
        "zformat",
        "zftp",
        "zle",
        "zmodload",
        "zparseopts",
        "zprof",
        "zpty",
        "zregexparse",
        "zsocket",
        "zstyle",
        "ztcp"
    ];
    const GNU_CORE_UTILS = [
        "chcon",
        "chgrp",
        "chown",
        "chmod",
        "cp",
        "dd",
        "df",
        "dir",
        "dircolors",
        "ln",
        "ls",
        "mkdir",
        "mkfifo",
        "mknod",
        "mktemp",
        "mv",
        "realpath",
        "rm",
        "rmdir",
        "shred",
        "sync",
        "touch",
        "truncate",
        "vdir",
        "b2sum",
        "base32",
        "base64",
        "cat",
        "cksum",
        "comm",
        "csplit",
        "cut",
        "expand",
        "fmt",
        "fold",
        "head",
        "join",
        "md5sum",
        "nl",
        "numfmt",
        "od",
        "paste",
        "ptx",
        "pr",
        "sha1sum",
        "sha224sum",
        "sha256sum",
        "sha384sum",
        "sha512sum",
        "shuf",
        "sort",
        "split",
        "sum",
        "tac",
        "tail",
        "tr",
        "tsort",
        "unexpand",
        "uniq",
        "wc",
        "arch",
        "basename",
        "chroot",
        "date",
        "dirname",
        "du",
        "echo",
        "env",
        "expr",
        "factor",
        // "false", // keyword literal already
        "groups",
        "hostid",
        "id",
        "link",
        "logname",
        "nice",
        "nohup",
        "nproc",
        "pathchk",
        "pinky",
        "printenv",
        "printf",
        "pwd",
        "readlink",
        "runcon",
        "seq",
        "sleep",
        "stat",
        "stdbuf",
        "stty",
        "tee",
        "test",
        "timeout",
        // "true", // keyword literal already
        "tty",
        "uname",
        "unlink",
        "uptime",
        "users",
        "who",
        "whoami",
        "yes"
    ];
    return {
        name: 'Bash',
        aliases: [
            'sh',
            'zsh'
        ],
        keywords: {
            $pattern: /\b[a-z][a-z0-9._-]+\b/,
            keyword: KEYWORDS,
            literal: LITERALS,
            built_in: [
                ...SHELL_BUILT_INS,
                ...BASH_BUILT_INS,
                // Shell modifiers
                "set",
                "shopt",
                ...ZSH_BUILT_INS,
                ...GNU_CORE_UTILS
            ]
        },
        contains: [
            KNOWN_SHEBANG,
            hljs.SHEBANG(),
            FUNCTION,
            ARITHMETIC,
            COMMENT,
            HERE_DOC,
            PATH_MODE,
            QUOTE_STRING,
            ESCAPED_QUOTE,
            APOS_STRING,
            ESCAPED_APOS,
            VAR
        ]
    };
}


const $34512cd73918b228$var$EXTENDED_NUMBER_RE = '([-+]?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)|NaN|[-+]?Infinity'; // 0x..., 0..., decimal, float
const $34512cd73918b228$var$EXTENDED_NUMBER_MODE = {
    scope: 'number',
    match: $34512cd73918b228$var$EXTENDED_NUMBER_RE,
    relevance: 0
};
/*
Language: JSON
Description: JSON (JavaScript Object Notation) is a lightweight data-interchange format.
Websites: http://www.json.org, https://www.json5.org
Category: common, protocols, web
*/ function $34512cd73918b228$export$2e2bcd8739ae039(hljs) {
    const ATTRIBUTE = {
        className: 'attr',
        begin: /(("(\\.|[^\\"\r\n])*")|('(\\.|[^\\'\r\n])*'))(?=\s*:)/,
        relevance: 1.01
    };
    const PUNCTUATION = {
        match: /[{}[\],:]/,
        className: "punctuation",
        relevance: 0
    };
    const LITERALS = [
        "true",
        "false",
        "null"
    ];
    // NOTE: normally we would rely on `keywords` for this but using a mode here allows us
    // - to use the very tight `illegal: \S` rule later to flag any other character
    // - as illegal indicating that despite looking like JSON we do not truly have
    // - JSON and thus improve false-positively greatly since JSON will try and claim
    // - all sorts of JSON looking stuff
    const LITERALS_MODE = {
        scope: "literal",
        beginKeywords: LITERALS.join(" ")
    };
    return {
        name: 'JSON',
        aliases: [
            'jsonc',
            'json5'
        ],
        keywords: {
            literal: LITERALS
        },
        contains: [
            ATTRIBUTE,
            PUNCTUATION,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            LITERALS_MODE,
            $34512cd73918b228$var$EXTENDED_NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ],
        illegal: '\\S'
    };
}


/*
Language: HTML, XML
Website: https://www.w3.org/XML/
Category: common, web
Audit: 2020
*/ /** @type LanguageFn */ function $f619f7324f198cc1$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    // XML names can have the following additional letters: https://www.w3.org/TR/xml/#NT-NameChar
    // OTHER_NAME_CHARS = /[:\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]/;
    // Element names start with NAME_START_CHAR followed by optional other Unicode letters, ASCII digits, hyphens, underscores, and periods
    // const TAG_NAME_RE = regex.concat(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, regex.optional(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*:/), /[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*/);;
    // const XML_IDENT_RE = /[A-Z_a-z:\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]+/;
    // const TAG_NAME_RE = regex.concat(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, regex.optional(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*:/), /[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*/);
    // however, to cater for performance and more Unicode support rely simply on the Unicode letter class
    const TAG_NAME_RE = regex.concat(/[\p{L}_]/u, regex.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u);
    const XML_IDENT_RE = /[\p{L}0-9._:-]+/u;
    const XML_ENTITIES = {
        className: 'symbol',
        begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
    };
    const XML_META_KEYWORDS = {
        begin: /\s/,
        contains: [
            {
                className: 'keyword',
                begin: /#?[a-z_][a-z1-9_-]+/,
                illegal: /\n/
            }
        ]
    };
    const XML_META_PAR_KEYWORDS = hljs.inherit(XML_META_KEYWORDS, {
        begin: /\(/,
        end: /\)/
    });
    const APOS_META_STRING_MODE = hljs.inherit(hljs.APOS_STRING_MODE, {
        className: 'string'
    });
    const QUOTE_META_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        className: 'string'
    });
    const TAG_INTERNALS = {
        endsWithParent: true,
        illegal: /</,
        relevance: 0,
        contains: [
            {
                className: 'attr',
                begin: XML_IDENT_RE,
                relevance: 0
            },
            {
                begin: /=\s*/,
                relevance: 0,
                contains: [
                    {
                        className: 'string',
                        endsParent: true,
                        variants: [
                            {
                                begin: /"/,
                                end: /"/,
                                contains: [
                                    XML_ENTITIES
                                ]
                            },
                            {
                                begin: /'/,
                                end: /'/,
                                contains: [
                                    XML_ENTITIES
                                ]
                            },
                            {
                                begin: /[^\s"'=<>`]+/
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        name: 'HTML, XML',
        aliases: [
            'html',
            'xhtml',
            'rss',
            'atom',
            'xjb',
            'xsd',
            'xsl',
            'plist',
            'wsf',
            'svg'
        ],
        case_insensitive: true,
        unicodeRegex: true,
        contains: [
            {
                className: 'meta',
                begin: /<![a-z]/,
                end: />/,
                relevance: 10,
                contains: [
                    XML_META_KEYWORDS,
                    QUOTE_META_STRING_MODE,
                    APOS_META_STRING_MODE,
                    XML_META_PAR_KEYWORDS,
                    {
                        begin: /\[/,
                        end: /\]/,
                        contains: [
                            {
                                className: 'meta',
                                begin: /<![a-z]/,
                                end: />/,
                                contains: [
                                    XML_META_KEYWORDS,
                                    XML_META_PAR_KEYWORDS,
                                    QUOTE_META_STRING_MODE,
                                    APOS_META_STRING_MODE
                                ]
                            }
                        ]
                    }
                ]
            },
            hljs.COMMENT(/<!--/, /-->/, {
                relevance: 10
            }),
            {
                begin: /<!\[CDATA\[/,
                end: /\]\]>/,
                relevance: 10
            },
            XML_ENTITIES,
            // xml processing instructions
            {
                className: 'meta',
                end: /\?>/,
                variants: [
                    {
                        begin: /<\?xml/,
                        relevance: 10,
                        contains: [
                            QUOTE_META_STRING_MODE
                        ]
                    },
                    {
                        begin: /<\?[a-z][a-z0-9]+/
                    }
                ]
            },
            {
                className: 'tag',
                /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending bracket.
        */ begin: /<style(?=\s|>)/,
                end: />/,
                keywords: {
                    name: 'style'
                },
                contains: [
                    TAG_INTERNALS
                ],
                starts: {
                    end: /<\/style>/,
                    returnEnd: true,
                    subLanguage: 'css'
                }
            },
            {
                className: 'tag',
                // See the comment in the <style tag about the lookahead pattern
                begin: /<script(?=\s|>)/,
                end: />/,
                keywords: {
                    name: 'script'
                },
                contains: [
                    TAG_INTERNALS
                ],
                starts: {
                    end: /<\/script>/,
                    returnEnd: true,
                    subLanguage: 'javascript'
                }
            },
            // we need this for now for jSX
            {
                className: 'tag',
                begin: /<>|<\/>/
            },
            // open tag
            {
                className: 'tag',
                begin: regex.concat(/</, regex.lookahead(regex.concat(TAG_NAME_RE, // <tag/>
                // <tag>
                // <tag ...
                regex.either(/\/>/, />/, /\s/)))),
                end: /\/?>/,
                contains: [
                    {
                        className: 'name',
                        begin: TAG_NAME_RE,
                        relevance: 0,
                        starts: TAG_INTERNALS
                    }
                ]
            },
            // close tag
            {
                className: 'tag',
                begin: regex.concat(/<\//, regex.lookahead(regex.concat(TAG_NAME_RE, />/))),
                contains: [
                    {
                        className: 'name',
                        begin: TAG_NAME_RE,
                        relevance: 0
                    },
                    {
                        begin: />/,
                        relevance: 0,
                        endsParent: true
                    }
                ]
            }
        ]
    };
}


/**
 * This is the ParseError class, which is the main error thrown by KaTeX
 * functions when something has gone wrong. This is used to distinguish internal
 * errors from errors in the expression that the user provided.
 *
 * If possible, a caller should provide a Token or ParseNode with information
 * about where in the source string the problem occurred.
 */ class $ef0731f441f79e9a$export$f9c837a54db411d extends Error {
    // The underlying error message without any context added.
    constructor(message, // The error message
    token){
        var error = "KaTeX parse error: " + message;
        var start;
        var end;
        var loc = token && token.loc;
        if (loc && loc.start <= loc.end) {
            // If we have the input and a position, make the error a bit fancier
            // Get the input
            var input = loc.lexer.input;
            // Prepend some information
            start = loc.start;
            end = loc.end;
            if (start === input.length) error += " at end of input: ";
            else error += " at position " + (start + 1) + ": ";
            // Underline token in question using combining underscores
            var underlined = input.slice(start, end).replace(/[^]/g, "$&\u0332");
            // Extract some context from the input and add it to the error
            var left;
            if (start > 15) left = "\u2026" + input.slice(start - 15, start);
            else left = input.slice(0, start);
            var right;
            if (end + 15 < input.length) right = input.slice(end, end + 15) + "\u2026";
            else right = input.slice(end);
            error += left + underlined + right;
        }
        super(error);
        this.name = "ParseError";
        this.position = void 0;
        // Error start position based on passed-in Token or ParseNode.
        this.length = void 0;
        // Length of affected text based on passed-in Token or ParseNode.
        this.rawMessage = void 0;
        Object.setPrototypeOf(this, $ef0731f441f79e9a$export$f9c837a54db411d.prototype);
        this.position = start;
        if (start != null && end != null) this.length = end - start;
        this.rawMessage = message;
    }
}
/**
 * This file contains a list of utility functions which are useful in other
 * files.
 */ // hyphenate and escape adapted from Facebook's React under Apache 2 license
var $ef0731f441f79e9a$var$uppercase = /([A-Z])/g;
var $ef0731f441f79e9a$var$hyphenate = (str)=>str.replace($ef0731f441f79e9a$var$uppercase, "-$1").toLowerCase();
var $ef0731f441f79e9a$var$ESCAPE_LOOKUP = {
    "&": "&amp;",
    ">": "&gt;",
    "<": "&lt;",
    "\"": "&quot;",
    "'": "&#x27;"
};
var $ef0731f441f79e9a$var$ESCAPE_REGEX = /[&><"']/g;
/**
 * Escapes text to prevent scripting attacks.
 */ var $ef0731f441f79e9a$var$escape = (text)=>String(text).replace($ef0731f441f79e9a$var$ESCAPE_REGEX, (match)=>$ef0731f441f79e9a$var$ESCAPE_LOOKUP[match]);
/**
 * Sometimes we want to pull out the innermost element of a group. In most
 * cases, this will just be the group itself, but when ordgroups and colors have
 * a single element, we want to pull that out.
 */ var $ef0731f441f79e9a$var$getBaseElem = (group)=>{
    if (group.type === "ordgroup") {
        if (group.body.length === 1) return $ef0731f441f79e9a$var$getBaseElem(group.body[0]);
        else return group;
    } else if (group.type === "color") {
        if (group.body.length === 1) return $ef0731f441f79e9a$var$getBaseElem(group.body[0]);
        else return group;
    } else if (group.type === "font") return $ef0731f441f79e9a$var$getBaseElem(group.body);
    else return group;
};
var $ef0731f441f79e9a$var$characterNodesTypes = new Set([
    "mathord",
    "textord",
    "atom"
]);
/**
 * TeXbook algorithms often reference "character boxes", which are simply groups
 * with a single character in them. To decide if something is a character box,
 * we find its innermost group, and see if it is a single character.
 */ var $ef0731f441f79e9a$var$isCharacterBox = (group)=>$ef0731f441f79e9a$var$characterNodesTypes.has($ef0731f441f79e9a$var$getBaseElem(group).type);
/**
 * Return the protocol of a URL, or "_relative" if the URL does not specify a
 * protocol (and thus is relative), or `null` if URL has invalid protocol
 * (so should be outright rejected).
 */ var $ef0731f441f79e9a$var$protocolFromUrl = (url)=>{
    // Check for possible leading protocol.
    // https://url.spec.whatwg.org/#url-parsing strips leading whitespace
    // (U+20) or C0 control (U+00-U+1F) characters.
    var protocol = /^[\x00-\x20]*([^\\/#?]*?)(:|&#0*58|&#x0*3a|&colon)/i.exec(url);
    if (!protocol) return "_relative";
    // Reject weird colons
    if (protocol[2] !== ":") return null;
    // Reject invalid characters in scheme according to
    // https://datatracker.ietf.org/doc/html/rfc3986#section-3.1
    if (!/^[a-zA-Z][a-zA-Z0-9+\-.]*$/.test(protocol[1])) return null;
    // Lowercase the protocol
    return protocol[1].toLowerCase();
};
/* eslint no-console:0 */ // TODO: automatically generate documentation
// TODO: check all properties on Settings exist
// TODO: check the type of a property on Settings matches
var $ef0731f441f79e9a$export$52389b8e2e8ab6f0 = {
    displayMode: {
        type: "boolean",
        description: "Render math in display mode, which puts the math in display style (so \\int and \\sum are large, for example), and centers the math on the page on its own line.",
        cli: "-d, --display-mode"
    },
    output: {
        type: {
            enum: [
                "htmlAndMathml",
                "html",
                "mathml"
            ]
        },
        description: "Determines the markup language of the output.",
        cli: "-F, --format <type>"
    },
    leqno: {
        type: "boolean",
        description: "Render display math in leqno style (left-justified tags)."
    },
    fleqn: {
        type: "boolean",
        description: "Render display math flush left."
    },
    throwOnError: {
        type: "boolean",
        default: true,
        cli: "-t, --no-throw-on-error",
        cliDescription: "Render errors (in the color given by --error-color) instead of throwing a ParseError exception when encountering an error."
    },
    errorColor: {
        type: "string",
        default: "#cc0000",
        cli: "-c, --error-color <color>",
        cliDescription: "A color string given in the format 'rgb' or 'rrggbb' (no #). This option determines the color of errors rendered by the -t option.",
        cliProcessor: (color)=>"#" + color
    },
    macros: {
        type: "object",
        cli: "-m, --macro <def>",
        cliDescription: "Define custom macro of the form '\\foo:expansion' (use multiple -m arguments for multiple macros).",
        cliDefault: [],
        cliProcessor: (def, defs)=>{
            defs.push(def);
            return defs;
        }
    },
    minRuleThickness: {
        type: "number",
        description: "Specifies a minimum thickness, in ems, for fraction lines, `\\sqrt` top lines, `{array}` vertical lines, `\\hline`, `\\hdashline`, `\\underline`, `\\overline`, and the borders of `\\fbox`, `\\boxed`, and `\\fcolorbox`.",
        processor: (t)=>Math.max(0, t),
        cli: "--min-rule-thickness <size>",
        cliProcessor: parseFloat
    },
    colorIsTextColor: {
        type: "boolean",
        description: "Makes \\color behave like LaTeX's 2-argument \\textcolor, instead of LaTeX's one-argument \\color mode change.",
        cli: "-b, --color-is-text-color"
    },
    strict: {
        type: [
            {
                enum: [
                    "warn",
                    "ignore",
                    "error"
                ]
            },
            "boolean",
            "function"
        ],
        description: "Turn on strict / LaTeX faithfulness mode, which throws an error if the input uses features that are not supported by LaTeX.",
        cli: "-S, --strict",
        cliDefault: false
    },
    trust: {
        type: [
            "boolean",
            "function"
        ],
        description: "Trust the input, enabling all HTML features such as \\url.",
        cli: "-T, --trust"
    },
    maxSize: {
        type: "number",
        default: Infinity,
        description: "If non-zero, all user-specified sizes, e.g. in \\rule{500em}{500em}, will be capped to maxSize ems. Otherwise, elements and spaces can be arbitrarily large",
        processor: (s)=>Math.max(0, s),
        cli: "-s, --max-size <n>",
        cliProcessor: parseInt
    },
    maxExpand: {
        type: "number",
        default: 1000,
        description: "Limit the number of macro expansions to the specified number, to prevent e.g. infinite macro loops. If set to Infinity, the macro expander will try to fully expand as in LaTeX.",
        processor: (n)=>Math.max(0, n),
        cli: "-e, --max-expand <n>",
        cliProcessor: (n)=>n === "Infinity" ? Infinity : parseInt(n)
    },
    globalGroup: {
        type: "boolean",
        cli: false
    }
};
function $ef0731f441f79e9a$var$getImplicitDefault(type) {
    if (typeof type !== 'string') return type.enum[0];
    switch(type){
        case 'boolean':
            return false;
        case 'string':
            return '';
        case 'number':
            return 0;
        case 'object':
            return {};
        default:
            throw new Error("Unexpected schema type; settings must declare an explicit default.");
    }
}
function $ef0731f441f79e9a$var$getDefaultValue(schema) {
    if (schema.default !== undefined) return schema.default;
    var type = Array.isArray(schema.type) ? schema.type[0] : schema.type;
    return $ef0731f441f79e9a$var$getImplicitDefault(type);
}
function $ef0731f441f79e9a$var$applySetting(target, prop, options, schema) {
    var optionValue = options[prop];
    target[prop] = optionValue !== undefined ? schema.processor ? schema.processor(optionValue) : optionValue : $ef0731f441f79e9a$var$getDefaultValue(schema);
}
/**
 * The main Settings object
 *
 * The current options stored are:
 *  - displayMode: Whether the expression should be typeset as inline math
 *                 (false, the default), meaning that the math starts in
 *                 \textstyle and is placed in an inline-block); or as display
 *                 math (true), meaning that the math starts in \displaystyle
 *                 and is placed in a block with vertical margin.
 */ class $ef0731f441f79e9a$var$Settings {
    constructor(options){
        if (options === void 0) options = {};
        this.displayMode = void 0;
        this.output = void 0;
        this.leqno = void 0;
        this.fleqn = void 0;
        this.throwOnError = void 0;
        this.errorColor = void 0;
        this.macros = void 0;
        this.minRuleThickness = void 0;
        this.colorIsTextColor = void 0;
        this.strict = void 0;
        this.trust = void 0;
        this.maxSize = void 0;
        this.maxExpand = void 0;
        this.globalGroup = void 0;
        // allow null options
        options = options || {};
        for (var prop of Object.keys($ef0731f441f79e9a$export$52389b8e2e8ab6f0)){
            var schema = $ef0731f441f79e9a$export$52389b8e2e8ab6f0[prop];
            if (schema) // TODO: validate options
            $ef0731f441f79e9a$var$applySetting(this, prop, options, schema);
        }
    }
    /**
   * Report nonstrict (non-LaTeX-compatible) input.
   * Can safely not be called if `this.strict` is false in JavaScript.
   */ reportNonstrict(errorCode, errorMsg, token) {
        var strict = this.strict;
        if (typeof strict === "function") // Allow return value of strict function to be boolean or string
        // (or null/undefined, meaning no further processing).
        strict = strict(errorCode, errorMsg, token);
        if (!strict || strict === "ignore") return;
        else if (strict === true || strict === "error") throw new $ef0731f441f79e9a$export$f9c837a54db411d("LaTeX-incompatible input and strict mode is set to 'error': " + (errorMsg + " [" + errorCode + "]"), token);
        else if (strict === "warn") typeof console !== "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (errorMsg + " [" + errorCode + "]"));
        else // won't happen in type-safe code
        typeof console !== "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + strict + "': " + errorMsg + " [" + errorCode + "]"));
    }
    /**
   * Check whether to apply strict (LaTeX-adhering) behavior for unusual
   * input (like `\\`).  Unlike `nonstrict`, will not throw an error;
   * instead, "error" translates to a return value of `true`, while "ignore"
   * translates to a return value of `false`.  May still print a warning:
   * "warn" prints a warning and returns `false`.
   * This is for the second category of `errorCode`s listed in the README.
   */ useStrictBehavior(errorCode, errorMsg, token) {
        var strict = this.strict;
        if (typeof strict === "function") // Allow return value of strict function to be boolean or string
        // (or null/undefined, meaning no further processing).
        // But catch any exceptions thrown by function, treating them
        // like "error".
        try {
            strict = strict(errorCode, errorMsg, token);
        } catch (error) {
            strict = "error";
        }
        if (!strict || strict === "ignore") return false;
        else if (strict === true || strict === "error") return true;
        else if (strict === "warn") {
            typeof console !== "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (errorMsg + " [" + errorCode + "]"));
            return false;
        } else {
            // won't happen in type-safe code
            typeof console !== "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + strict + "': " + errorMsg + " [" + errorCode + "]"));
            return false;
        }
    }
    /**
   * Check whether to test potentially dangerous input, and return
   * `true` (trusted) or `false` (untrusted).  The sole argument `context`
   * should be an object with `command` field specifying the relevant LaTeX
   * command (as a string starting with `\`), and any other arguments, etc.
   * If `context` has a `url` field, a `protocol` field will automatically
   * get added by this function (changing the specified object).
   */ isTrusted(context) {
        if ("url" in context && context.url && !context.protocol) {
            var protocol = $ef0731f441f79e9a$var$protocolFromUrl(context.url);
            if (protocol == null) return false;
            context.protocol = protocol;
        }
        var trust = typeof this.trust === "function" ? this.trust(context) : this.trust;
        return Boolean(trust);
    }
}
/**
 * This file contains information and classes for the various kinds of styles
 * used in TeX. It provides a generic `Style` class, which holds information
 * about a specific style. It then provides instances of all the different kinds
 * of styles possible, and provides functions to move between them and get
 * information about them.
 */ /**
 * The main style class. Contains a unique id for the style, a size (which is
 * the same for cramped and uncramped version of a style), and a cramped flag.
 */ class $ef0731f441f79e9a$var$Style {
    constructor(id, size, cramped){
        this.id = void 0;
        this.size = void 0;
        this.cramped = void 0;
        this.id = id;
        this.size = size;
        this.cramped = cramped;
    }
    /**
   * Get the style of a superscript given a base in the current style.
   */ sup() {
        return $ef0731f441f79e9a$var$styles[$ef0731f441f79e9a$var$sup[this.id]];
    }
    /**
   * Get the style of a subscript given a base in the current style.
   */ sub() {
        return $ef0731f441f79e9a$var$styles[$ef0731f441f79e9a$var$sub[this.id]];
    }
    /**
   * Get the style of a fraction numerator given the fraction in the current
   * style.
   */ fracNum() {
        return $ef0731f441f79e9a$var$styles[$ef0731f441f79e9a$var$fracNum[this.id]];
    }
    /**
   * Get the style of a fraction denominator given the fraction in the current
   * style.
   */ fracDen() {
        return $ef0731f441f79e9a$var$styles[$ef0731f441f79e9a$var$fracDen[this.id]];
    }
    /**
   * Get the cramped version of a style (in particular, cramping a cramped style
   * doesn't change the style).
   */ cramp() {
        return $ef0731f441f79e9a$var$styles[$ef0731f441f79e9a$var$cramp[this.id]];
    }
    /**
   * Get a text or display version of this style.
   */ text() {
        return $ef0731f441f79e9a$var$styles[$ef0731f441f79e9a$var$text$1[this.id]];
    }
    /**
   * Return true if this style is tightly spaced (scriptstyle/scriptscriptstyle)
   */ isTight() {
        return this.size >= 2;
    }
}
// IDs of the different styles
var $ef0731f441f79e9a$var$D = 0;
var $ef0731f441f79e9a$var$Dc = 1;
var $ef0731f441f79e9a$var$T = 2;
var $ef0731f441f79e9a$var$Tc = 3;
var $ef0731f441f79e9a$var$S = 4;
var $ef0731f441f79e9a$var$Sc = 5;
var $ef0731f441f79e9a$var$SS = 6;
var $ef0731f441f79e9a$var$SSc = 7;
// Instances of the different styles
var $ef0731f441f79e9a$var$styles = [
    new $ef0731f441f79e9a$var$Style($ef0731f441f79e9a$var$D, 0, false),
    new $ef0731f441f79e9a$var$Style($ef0731f441f79e9a$var$Dc, 0, true),
    new $ef0731f441f79e9a$var$Style($ef0731f441f79e9a$var$T, 1, false),
    new $ef0731f441f79e9a$var$Style($ef0731f441f79e9a$var$Tc, 1, true),
    new $ef0731f441f79e9a$var$Style($ef0731f441f79e9a$var$S, 2, false),
    new $ef0731f441f79e9a$var$Style($ef0731f441f79e9a$var$Sc, 2, true),
    new $ef0731f441f79e9a$var$Style($ef0731f441f79e9a$var$SS, 3, false),
    new $ef0731f441f79e9a$var$Style($ef0731f441f79e9a$var$SSc, 3, true)
];
// Lookup tables for switching from one style to another
var $ef0731f441f79e9a$var$sup = [
    $ef0731f441f79e9a$var$S,
    $ef0731f441f79e9a$var$Sc,
    $ef0731f441f79e9a$var$S,
    $ef0731f441f79e9a$var$Sc,
    $ef0731f441f79e9a$var$SS,
    $ef0731f441f79e9a$var$SSc,
    $ef0731f441f79e9a$var$SS,
    $ef0731f441f79e9a$var$SSc
];
var $ef0731f441f79e9a$var$sub = [
    $ef0731f441f79e9a$var$Sc,
    $ef0731f441f79e9a$var$Sc,
    $ef0731f441f79e9a$var$Sc,
    $ef0731f441f79e9a$var$Sc,
    $ef0731f441f79e9a$var$SSc,
    $ef0731f441f79e9a$var$SSc,
    $ef0731f441f79e9a$var$SSc,
    $ef0731f441f79e9a$var$SSc
];
var $ef0731f441f79e9a$var$fracNum = [
    $ef0731f441f79e9a$var$T,
    $ef0731f441f79e9a$var$Tc,
    $ef0731f441f79e9a$var$S,
    $ef0731f441f79e9a$var$Sc,
    $ef0731f441f79e9a$var$SS,
    $ef0731f441f79e9a$var$SSc,
    $ef0731f441f79e9a$var$SS,
    $ef0731f441f79e9a$var$SSc
];
var $ef0731f441f79e9a$var$fracDen = [
    $ef0731f441f79e9a$var$Tc,
    $ef0731f441f79e9a$var$Tc,
    $ef0731f441f79e9a$var$Sc,
    $ef0731f441f79e9a$var$Sc,
    $ef0731f441f79e9a$var$SSc,
    $ef0731f441f79e9a$var$SSc,
    $ef0731f441f79e9a$var$SSc,
    $ef0731f441f79e9a$var$SSc
];
var $ef0731f441f79e9a$var$cramp = [
    $ef0731f441f79e9a$var$Dc,
    $ef0731f441f79e9a$var$Dc,
    $ef0731f441f79e9a$var$Tc,
    $ef0731f441f79e9a$var$Tc,
    $ef0731f441f79e9a$var$Sc,
    $ef0731f441f79e9a$var$Sc,
    $ef0731f441f79e9a$var$SSc,
    $ef0731f441f79e9a$var$SSc
];
var $ef0731f441f79e9a$var$text$1 = [
    $ef0731f441f79e9a$var$D,
    $ef0731f441f79e9a$var$Dc,
    $ef0731f441f79e9a$var$T,
    $ef0731f441f79e9a$var$Tc,
    $ef0731f441f79e9a$var$T,
    $ef0731f441f79e9a$var$Tc,
    $ef0731f441f79e9a$var$T,
    $ef0731f441f79e9a$var$Tc
];
// We only export some of the styles.
var $ef0731f441f79e9a$var$Style$1 = {
    DISPLAY: $ef0731f441f79e9a$var$styles[$ef0731f441f79e9a$var$D],
    TEXT: $ef0731f441f79e9a$var$styles[$ef0731f441f79e9a$var$T],
    SCRIPT: $ef0731f441f79e9a$var$styles[$ef0731f441f79e9a$var$S],
    SCRIPTSCRIPT: $ef0731f441f79e9a$var$styles[$ef0731f441f79e9a$var$SS]
};
/*
 * This file defines the Unicode scripts and script families that we
 * support. To add new scripts or families, just add a new entry to the
 * scriptData array below. Adding scripts to the scriptData array allows
 * characters from that script to appear in \text{} environments.
 */ /**
 * Unicode block data for the families of scripts we support in \text{}.
 * Scripts only need to appear here if they do not have font metrics.
 */ var $ef0731f441f79e9a$var$scriptData = [
    {
        // Latin characters beyond the Latin-1 characters we have metrics for.
        // Needed for Czech, Hungarian and Turkish text, for example.
        name: 'latin',
        blocks: [
            [
                0x0100,
                0x024f
            ],
            // Latin Extended-A and Latin Extended-B
            [
                0x0300,
                0x036f
            ] // Combining Diacritical marks
        ]
    },
    {
        // The Cyrillic script used by Russian and related languages.
        // A Cyrillic subset used to be supported as explicitly defined
        // symbols in symbols.js
        name: 'cyrillic',
        blocks: [
            [
                0x0400,
                0x04ff
            ]
        ]
    },
    {
        // Armenian
        name: 'armenian',
        blocks: [
            [
                0x0530,
                0x058F
            ]
        ]
    },
    {
        // The Brahmic scripts of South and Southeast Asia
        // Devanagari (0900–097F)
        // Bengali (0980–09FF)
        // Gurmukhi (0A00–0A7F)
        // Gujarati (0A80–0AFF)
        // Oriya (0B00–0B7F)
        // Tamil (0B80–0BFF)
        // Telugu (0C00–0C7F)
        // Kannada (0C80–0CFF)
        // Malayalam (0D00–0D7F)
        // Sinhala (0D80–0DFF)
        // Thai (0E00–0E7F)
        // Lao (0E80–0EFF)
        // Tibetan (0F00–0FFF)
        // Myanmar (1000–109F)
        name: 'brahmic',
        blocks: [
            [
                0x0900,
                0x109F
            ]
        ]
    },
    {
        name: 'georgian',
        blocks: [
            [
                0x10A0,
                0x10ff
            ]
        ]
    },
    {
        // Chinese and Japanese.
        // The "k" in cjk is for Korean, but we've separated Korean out
        name: "cjk",
        blocks: [
            [
                0x3000,
                0x30FF
            ],
            // CJK symbols and punctuation, Hiragana, Katakana
            [
                0x4E00,
                0x9FAF
            ],
            // CJK ideograms
            [
                0xFF00,
                0xFF60
            ] // Fullwidth punctuation
        ]
    },
    {
        // Korean
        name: 'hangul',
        blocks: [
            [
                0xAC00,
                0xD7AF
            ]
        ]
    }
];
/**
 * Given a codepoint, return the name of the script or script family
 * it is from, or null if it is not part of a known block
 */ function $ef0731f441f79e9a$var$scriptFromCodepoint(codepoint) {
    for(var i = 0; i < $ef0731f441f79e9a$var$scriptData.length; i++){
        var script = $ef0731f441f79e9a$var$scriptData[i];
        for(var _i = 0; _i < script.blocks.length; _i++){
            var block = script.blocks[_i];
            if (codepoint >= block[0] && codepoint <= block[1]) return script.name;
        }
    }
    return null;
}
/**
 * A flattened version of all the supported blocks in a single array.
 * This is an optimization to make supportedCodepoint() fast.
 */ var $ef0731f441f79e9a$var$allBlocks = [];
$ef0731f441f79e9a$var$scriptData.forEach((s)=>s.blocks.forEach((b)=>$ef0731f441f79e9a$var$allBlocks.push(...b)));
/**
 * Given a codepoint, return true if it falls within one of the
 * scripts or script families defined above and false otherwise.
 *
 * Micro benchmarks shows that this is faster than
 * /[\u3000-\u30FF\u4E00-\u9FAF\uFF00-\uFF60\uAC00-\uD7AF\u0900-\u109F]/.test()
 * in Firefox, Chrome and Node.
 */ function $ef0731f441f79e9a$var$supportedCodepoint(codepoint) {
    for(var i = 0; i < $ef0731f441f79e9a$var$allBlocks.length; i += 2){
        if (codepoint >= $ef0731f441f79e9a$var$allBlocks[i] && codepoint <= $ef0731f441f79e9a$var$allBlocks[i + 1]) return true;
    }
    return false;
}
/**
 * This file provides support to domTree.js and delimiter.js.
 * It's a storehouse of path geometry for SVG images.
 */ // In all paths below, the viewBox-to-em scale is 1000:1.
// Second Brush Stroke
//    Low resolution monitors struggle to display images in fine detail.
//    So browsers apply anti-aliasing. A long straight arrow shaft therefore
//    will sometimes appear as if it has a blurred edge.
//    To mitigate this, these SVG files contain a second "brush-stroke" on the
//    arrow shafts. That is, a second long thin rectangular SVG path has been
//    written directly on top of each arrow shaft. This reinforcement causes
//    some of the screen pixels to display as black instead of the anti-aliased
//    gray pixel that a  single path would generate. So we get arrow shafts
//    whose edges appear to be sharper.
var $ef0731f441f79e9a$var$doubleBrushStroke = (svgPath)=>svgPath + " " + svgPath;
var $ef0731f441f79e9a$var$hLinePad = 80; // padding above a sqrt vinculum. Prevents image cropping.
// The vinculum of a \sqrt can be made thicker by a KaTeX rendering option.
// Think of variable extraVinculum as two detours in the SVG path.
// The detour begins at the lower left of the area labeled extraVinculum below.
// The detour proceeds one extraVinculum distance up and slightly to the right,
// displacing the radiused corner between surd and vinculum. The radius is
// traversed as usual, then the detour resumes. It goes right, to the end of
// the very long vinculum, then down one extraVinculum distance,
// after which it resumes regular path geometry for the radical.
/*                                                  vinculum
                                                   /
         /▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒←extraVinculum
        / █████████████████████←0.04em (40 unit) std vinculum thickness
       / /
      / /
     / /\
    / / surd
*/ var $ef0731f441f79e9a$var$sqrtMain = function sqrtMain(extraVinculum, hLinePad) {
    // sqrtMain path geometry is from glyph U221A in the font KaTeX Main
    return "M95," + (622 + extraVinculum + hLinePad) + "\nc-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14\nc0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54\nc44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10\ns173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429\nc69,-144,104.5,-217.7,106.5,-221\nl" + extraVinculum / 2.075 + " -" + extraVinculum + "\nc5.3,-9.3,12,-14,20,-14\nH400000v" + (40 + extraVinculum) + "H845.2724\ns-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7\nc-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47z\nM" + (834 + extraVinculum) + " " + hLinePad + "h400000v" + (40 + extraVinculum) + "h-400000z";
};
var $ef0731f441f79e9a$var$sqrtSize1 = function sqrtSize1(extraVinculum, hLinePad) {
    // size1 is from glyph U221A in the font KaTeX_Size1-Regular
    return "M263," + (601 + extraVinculum + hLinePad) + "c0.7,0,18,39.7,52,119\nc34,79.3,68.167,158.7,102.5,238c34.3,79.3,51.8,119.3,52.5,120\nc340,-704.7,510.7,-1060.3,512,-1067\nl" + extraVinculum / 2.084 + " -" + extraVinculum + "\nc4.7,-7.3,11,-11,19,-11\nH40000v" + (40 + extraVinculum) + "H1012.3\ns-271.3,567,-271.3,567c-38.7,80.7,-84,175,-136,283c-52,108,-89.167,185.3,-111.5,232\nc-22.3,46.7,-33.8,70.3,-34.5,71c-4.7,4.7,-12.3,7,-23,7s-12,-1,-12,-1\ns-109,-253,-109,-253c-72.7,-168,-109.3,-252,-110,-252c-10.7,8,-22,16.7,-34,26\nc-22,17.3,-33.3,26,-34,26s-26,-26,-26,-26s76,-59,76,-59s76,-60,76,-60z\nM" + (1001 + extraVinculum) + " " + hLinePad + "h400000v" + (40 + extraVinculum) + "h-400000z";
};
var $ef0731f441f79e9a$var$sqrtSize2 = function sqrtSize2(extraVinculum, hLinePad) {
    // size2 is from glyph U221A in the font KaTeX_Size2-Regular
    return "M983 " + (10 + extraVinculum + hLinePad) + "\nl" + extraVinculum / 3.13 + " -" + extraVinculum + "\nc4,-6.7,10,-10,18,-10 H400000v" + (40 + extraVinculum) + "\nH1013.1s-83.4,268,-264.1,840c-180.7,572,-277,876.3,-289,913c-4.7,4.7,-12.7,7,-24,7\ns-12,0,-12,0c-1.3,-3.3,-3.7,-11.7,-7,-25c-35.3,-125.3,-106.7,-373.3,-214,-744\nc-10,12,-21,25,-33,39s-32,39,-32,39c-6,-5.3,-15,-14,-27,-26s25,-30,25,-30\nc26.7,-32.7,52,-63,76,-91s52,-60,52,-60s208,722,208,722\nc56,-175.3,126.3,-397.3,211,-666c84.7,-268.7,153.8,-488.2,207.5,-658.5\nc53.7,-170.3,84.5,-266.8,92.5,-289.5z\nM" + (1001 + extraVinculum) + " " + hLinePad + "h400000v" + (40 + extraVinculum) + "h-400000z";
};
var $ef0731f441f79e9a$var$sqrtSize3 = function sqrtSize3(extraVinculum, hLinePad) {
    // size3 is from glyph U221A in the font KaTeX_Size3-Regular
    return "M424," + (2398 + extraVinculum + hLinePad) + "\nc-1.3,-0.7,-38.5,-172,-111.5,-514c-73,-342,-109.8,-513.3,-110.5,-514\nc0,-2,-10.7,14.3,-32,49c-4.7,7.3,-9.8,15.7,-15.5,25c-5.7,9.3,-9.8,16,-12.5,20\ns-5,7,-5,7c-4,-3.3,-8.3,-7.7,-13,-13s-13,-13,-13,-13s76,-122,76,-122s77,-121,77,-121\ns209,968,209,968c0,-2,84.7,-361.7,254,-1079c169.3,-717.3,254.7,-1077.7,256,-1081\nl" + extraVinculum / 4.223 + " -" + extraVinculum + "c4,-6.7,10,-10,18,-10 H400000\nv" + (40 + extraVinculum) + "H1014.6\ns-87.3,378.7,-272.6,1166c-185.3,787.3,-279.3,1182.3,-282,1185\nc-2,6,-10,9,-24,9\nc-8,0,-12,-0.7,-12,-2z M" + (1001 + extraVinculum) + " " + hLinePad + "\nh400000v" + (40 + extraVinculum) + "h-400000z";
};
var $ef0731f441f79e9a$var$sqrtSize4 = function sqrtSize4(extraVinculum, hLinePad) {
    // size4 is from glyph U221A in the font KaTeX_Size4-Regular
    return "M473," + (2713 + extraVinculum + hLinePad) + "\nc339.3,-1799.3,509.3,-2700,510,-2702 l" + extraVinculum / 5.298 + " -" + extraVinculum + "\nc3.3,-7.3,9.3,-11,18,-11 H400000v" + (40 + extraVinculum) + "H1017.7\ns-90.5,478,-276.2,1466c-185.7,988,-279.5,1483,-281.5,1485c-2,6,-10,9,-24,9\nc-8,0,-12,-0.7,-12,-2c0,-1.3,-5.3,-32,-16,-92c-50.7,-293.3,-119.7,-693.3,-207,-1200\nc0,-1.3,-5.3,8.7,-16,30c-10.7,21.3,-21.3,42.7,-32,64s-16,33,-16,33s-26,-26,-26,-26\ns76,-153,76,-153s77,-151,77,-151c0.7,0.7,35.7,202,105,604c67.3,400.7,102,602.7,104,\n606zM" + (1001 + extraVinculum) + " " + hLinePad + "h400000v" + (40 + extraVinculum) + "H1017.7z";
};
var $ef0731f441f79e9a$var$phasePath = function phasePath(y) {
    var x = y / 2; // x coordinate at top of angle
    return "M400000 " + y + " H0 L" + x + " 0 l65 45 L145 " + (y - 80) + " H400000z";
};
var $ef0731f441f79e9a$var$sqrtTall = function sqrtTall(extraVinculum, hLinePad, viewBoxHeight) {
    // sqrtTall is from glyph U23B7 in the font KaTeX_Size4-Regular
    // One path edge has a variable length. It runs vertically from the vinculum
    // to a point near (14 units) the bottom of the surd. The vinculum
    // is normally 40 units thick. So the length of the line in question is:
    var vertSegment = viewBoxHeight - 54 - hLinePad - extraVinculum;
    return "M702 " + (extraVinculum + hLinePad) + "H400000" + (40 + extraVinculum) + "\nH742v" + vertSegment + "l-4 4-4 4c-.667.7 -2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1\nh-12l-28-84c-16.667-52-96.667 -294.333-240-727l-212 -643 -85 170\nc-4-3.333-8.333-7.667-13 -13l-13-13l77-155 77-156c66 199.333 139 419.667\n219 661 l218 661zM702 " + hLinePad + "H400000v" + (40 + extraVinculum) + "H742z";
};
var $ef0731f441f79e9a$var$sqrtPath = function sqrtPath(size, extraVinculum, viewBoxHeight) {
    extraVinculum = 1000 * extraVinculum; // Convert from document ems to viewBox.
    var path = "";
    switch(size){
        case "sqrtMain":
            path = $ef0731f441f79e9a$var$sqrtMain(extraVinculum, $ef0731f441f79e9a$var$hLinePad);
            break;
        case "sqrtSize1":
            path = $ef0731f441f79e9a$var$sqrtSize1(extraVinculum, $ef0731f441f79e9a$var$hLinePad);
            break;
        case "sqrtSize2":
            path = $ef0731f441f79e9a$var$sqrtSize2(extraVinculum, $ef0731f441f79e9a$var$hLinePad);
            break;
        case "sqrtSize3":
            path = $ef0731f441f79e9a$var$sqrtSize3(extraVinculum, $ef0731f441f79e9a$var$hLinePad);
            break;
        case "sqrtSize4":
            path = $ef0731f441f79e9a$var$sqrtSize4(extraVinculum, $ef0731f441f79e9a$var$hLinePad);
            break;
        case "sqrtTall":
            path = $ef0731f441f79e9a$var$sqrtTall(extraVinculum, $ef0731f441f79e9a$var$hLinePad, viewBoxHeight);
    }
    return path;
};
var $ef0731f441f79e9a$var$innerPath = function innerPath(name, height) {
    // The inner part of stretchy tall delimiters
    switch(name){
        case "\u239c":
            return $ef0731f441f79e9a$var$doubleBrushStroke("M291 0 H417 V" + height + " H291z");
        case "\u2223":
            return $ef0731f441f79e9a$var$doubleBrushStroke("M145 0 H188 V" + height + " H145z");
        case "\u2225":
            return $ef0731f441f79e9a$var$doubleBrushStroke("M145 0 H188 V" + height + " H145z") + $ef0731f441f79e9a$var$doubleBrushStroke("M367 0 H410 V" + height + " H367z");
        case "\u239f":
            return $ef0731f441f79e9a$var$doubleBrushStroke("M457 0 H583 V" + height + " H457z");
        case "\u23a2":
            return $ef0731f441f79e9a$var$doubleBrushStroke("M319 0 H403 V" + height + " H319z");
        case "\u23a5":
            return $ef0731f441f79e9a$var$doubleBrushStroke("M263 0 H347 V" + height + " H263z");
        case "\u23aa":
            return $ef0731f441f79e9a$var$doubleBrushStroke("M384 0 H504 V" + height + " H384z");
        case "\u23d0":
            return $ef0731f441f79e9a$var$doubleBrushStroke("M312 0 H355 V" + height + " H312z");
        case "\u2016":
            return $ef0731f441f79e9a$var$doubleBrushStroke("M257 0 H300 V" + height + " H257z") + $ef0731f441f79e9a$var$doubleBrushStroke("M478 0 H521 V" + height + " H478z");
        default:
            return "";
    }
};
var $ef0731f441f79e9a$var$path = {
    // The doubleleftarrow geometry is from glyph U+21D0 in the font KaTeX Main
    doubleleftarrow: "M262 157\nl10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3\n 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28\n 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5\nc2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5\n 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87\n-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7\n-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z\nm8 0v40h399730v-40zm0 194v40h399730v-40z",
    // doublerightarrow is from glyph U+21D2 in font KaTeX Main
    doublerightarrow: "M399738 392l\n-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5\n 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88\n-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68\n-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18\n-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782\nc-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3\n-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z",
    // leftarrow is from glyph U+2190 in font KaTeX Main
    leftarrow: "M400000 241H110l3-3c68.7-52.7 113.7-120\n 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8\n-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247\nc-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208\n 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3\n 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202\n l-3-3h399890zM100 241v40h399900v-40z",
    // overbrace is from glyphs U+23A9/23A8/23A7 in font KaTeX_Size4-Regular
    leftbrace: "M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117\n-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7\n 5-6 9-10 13-.7 1-7.3 1-20 1H6z",
    leftbraceunder: "M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13\n 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688\n 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7\n-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z",
    // overgroup is from the MnSymbol package (public domain)
    leftgroup: "M400000 80\nH435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0\n 435 0h399565z",
    leftgroupunder: "M400000 262\nH435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219\n 435 219h399565z",
    // Harpoons are from glyph U+21BD in font KaTeX Main
    leftharpoon: "M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3\n-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5\n-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7\n-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z",
    leftharpoonplus: "M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5\n 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3\n-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7\n-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z\nm0 0v40h400000v-40z",
    leftharpoondown: "M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333\n 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5\n 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667\n-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z",
    leftharpoondownplus: "M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12\n 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7\n-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0\nv40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z",
    // hook is from glyph U+21A9 in font KaTeX Main
    lefthook: "M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5\n-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3\n-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21\n 71.5 23h399859zM103 281v-40h399897v40z",
    leftlinesegment: $ef0731f441f79e9a$var$doubleBrushStroke("M40 281 V428 H0 V94 H40 V241 H400000 v40z"),
    leftbracketunder: $ef0731f441f79e9a$var$doubleBrushStroke("M0 0 h120 V290 H399995 v120 H0z"),
    leftbracketover: $ef0731f441f79e9a$var$doubleBrushStroke("M0 440 h120 V150 H399995 v-120 H0z"),
    leftmapsto: $ef0731f441f79e9a$var$doubleBrushStroke("M40 281 V448H0V74H40V241H400000v40z"),
    // tofrom is from glyph U+21C4 in font KaTeX AMS Regular
    leftToFrom: "M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23\n-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8\nc28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3\n 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z",
    longequal: $ef0731f441f79e9a$var$doubleBrushStroke("M0 50 h400000 v40H0z m0 194h40000v40H0z"),
    midbrace: "M200428 334\nc-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14\n-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7\n 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11\n 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z",
    midbraceunder: "M199572 214\nc100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14\n 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3\n 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0\n-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z",
    oiintSize1: "M512.6 71.6c272.6 0 320.3 106.8 320.3 178.2 0 70.8-47.7 177.6\n-320.3 177.6S193.1 320.6 193.1 249.8c0-71.4 46.9-178.2 319.5-178.2z\nm368.1 178.2c0-86.4-60.9-215.4-368.1-215.4-306.4 0-367.3 129-367.3 215.4 0 85.8\n60.9 214.8 367.3 214.8 307.2 0 368.1-129 368.1-214.8z",
    oiintSize2: "M757.8 100.1c384.7 0 451.1 137.6 451.1 230 0 91.3-66.4 228.8\n-451.1 228.8-386.3 0-452.7-137.5-452.7-228.8 0-92.4 66.4-230 452.7-230z\nm502.4 230c0-111.2-82.4-277.2-502.4-277.2s-504 166-504 277.2\nc0 110 84 276 504 276s502.4-166 502.4-276z",
    oiiintSize1: "M681.4 71.6c408.9 0 480.5 106.8 480.5 178.2 0 70.8-71.6 177.6\n-480.5 177.6S202.1 320.6 202.1 249.8c0-71.4 70.5-178.2 479.3-178.2z\nm525.8 178.2c0-86.4-86.8-215.4-525.7-215.4-437.9 0-524.7 129-524.7 215.4 0\n85.8 86.8 214.8 524.7 214.8 438.9 0 525.7-129 525.7-214.8z",
    oiiintSize2: "M1021.2 53c603.6 0 707.8 165.8 707.8 277.2 0 110-104.2 275.8\n-707.8 275.8-606 0-710.2-165.8-710.2-275.8C311 218.8 415.2 53 1021.2 53z\nm770.4 277.1c0-131.2-126.4-327.6-770.5-327.6S248.4 198.9 248.4 330.1\nc0 130 128.8 326.4 772.7 326.4s770.5-196.4 770.5-326.4z",
    rightarrow: "M0 241v40h399891c-47.3 35.3-84 78-110 128\n-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20\n 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7\n 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85\n-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5\n-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67\n 151.7 139 205zm0 0v40h399900v-40z",
    rightbrace: "M400000 542l\n-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5\ns-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1\nc124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z",
    rightbraceunder: "M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3\n 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237\n-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z",
    rightgroup: "M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0\n 3-1 3-3v-38c-76-158-257-219-435-219H0z",
    rightgroupunder: "M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18\n 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z",
    rightharpoon: "M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3\n-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2\n-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58\n 69.2 92 94.5zm0 0v40h399900v-40z",
    rightharpoonplus: "M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11\n-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7\n 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z\nm0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z",
    rightharpoondown: "M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8\n 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5\n-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95\n-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z",
    rightharpoondownplus: "M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8\n 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3\n 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3\n-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z\nm0-194v40h400000v-40zm0 0v40h400000v-40z",
    righthook: "M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3\n 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0\n-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21\n 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z",
    rightlinesegment: $ef0731f441f79e9a$var$doubleBrushStroke("M399960 241 V94 h40 V428 h-40 V281 H0 v-40z"),
    rightbracketunder: $ef0731f441f79e9a$var$doubleBrushStroke("M399995 0 h-120 V290 H0 v120 H400000z"),
    rightbracketover: $ef0731f441f79e9a$var$doubleBrushStroke("M399995 440 h-120 V150 H0 v-120 H399995z"),
    rightToFrom: "M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23\n 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32\n-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142\n-167z M100 147v40h399900v-40zM0 341v40h399900v-40z",
    // twoheadleftarrow is from glyph U+219E in font KaTeX AMS Regular
    twoheadleftarrow: "M0 167c68 40\n 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69\n-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3\n-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19\n-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101\n 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z",
    twoheadrightarrow: "M400000 167\nc-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3\n 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42\n 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333\n-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70\n 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z",
    // tilde1 is a modified version of a glyph from the MnSymbol package
    tilde1: "M200 55.538c-77 0-168 73.953-177 73.953-3 0-7\n-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0\n 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0\n 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128\n-68.267.847-113-73.952-191-73.952z",
    // ditto tilde2, tilde3, & tilde4
    tilde2: "M344 55.266c-142 0-300.638 81.316-311.5 86.418\n-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9\n 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114\nc1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751\n 181.476 676 181.476c-149 0-189-126.21-332-126.21z",
    tilde3: "M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457\n-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0\n 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697\n 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696\n -338 0-409-156.573-744-156.573z",
    tilde4: "M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345\n-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409\n 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9\n 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409\n -175.236-744-175.236z",
    // vec is from glyph U+20D7 in font KaTeX Main
    vec: "M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5\n3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11\n10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63\n-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1\n-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59\nH213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359\nc-16-25.333-24-45-24-59z",
    // widehat1 is a modified version of a glyph from the MnSymbol package
    widehat1: "M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22\nc-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z",
    // ditto widehat2, widehat3, & widehat4
    widehat2: "M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",
    widehat3: "M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",
    widehat4: "M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",
    // widecheck paths are all inverted versions of widehat
    widecheck1: "M529,159h5l519,-115c5,-1,9,-5,9,-10c0,-1,-1,-2,-1,-3l-4,-22c-1,\n-5,-5,-9,-11,-9h-2l-512,92l-513,-92h-2c-5,0,-9,4,-11,9l-5,22c-1,6,2,12,8,13z",
    widecheck2: "M1181,220h2l1171,-176c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,\n-11,-10h-1l-1168,153l-1167,-153h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z",
    widecheck3: "M1181,280h2l1171,-236c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,\n-11,-10h-1l-1168,213l-1167,-213h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z",
    widecheck4: "M1181,340h2l1171,-296c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,\n-11,-10h-1l-1168,273l-1167,-273h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z",
    // The next ten paths support reaction arrows from the mhchem package.
    // Arrows for \ce{<-->} are offset from xAxis by 0.22ex, per mhchem in LaTeX
    // baraboveleftarrow is mostly from glyph U+2190 in font KaTeX Main
    baraboveleftarrow: "M400000 620h-399890l3 -3c68.7 -52.7 113.7 -120 135 -202\nc4 -14.7 6 -23 6 -25c0 -7.3 -7 -11 -21 -11c-8 0 -13.2 0.8 -15.5 2.5\nc-2.3 1.7 -4.2 5.8 -5.5 12.5c-1.3 4.7 -2.7 10.3 -4 17c-12 48.7 -34.8 92 -68.5 130\ns-74.2 66.3 -121.5 85c-10 4 -16 7.7 -18 11c0 8.7 6 14.3 18 17c47.3 18.7 87.8 47\n121.5 85s56.5 81.3 68.5 130c0.7 2 1.3 5 2 9s1.2 6.7 1.5 8c0.3 1.3 1 3.3 2 6\ns2.2 4.5 3.5 5.5c1.3 1 3.3 1.8 6 2.5s6 1 10 1c14 0 21 -3.7 21 -11\nc0 -2 -2 -10.3 -6 -25c-20 -79.3 -65 -146.7 -135 -202l-3 -3h399890z\nM100 620v40h399900v-40z M0 241v40h399900v-40zM0 241v40h399900v-40z",
    // rightarrowabovebar is mostly from glyph U+2192, KaTeX Main
    rightarrowabovebar: "M0 241v40h399891c-47.3 35.3-84 78-110 128-16.7 32\n-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20 11 8 0\n13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7 39\n-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85-40.5\n-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5\n-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67\n151.7 139 205zm96 379h399894v40H0zm0 0h399904v40H0z",
    // The short left harpoon has 0.5em (i.e. 500 units) kern on the left end.
    // Ref from mhchem.sty: \rlap{\raisebox{-.22ex}{$\kern0.5em
    baraboveshortleftharpoon: "M507,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11\nc1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17\nc2,0.7,5,1,9,1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21\nc-32,-87.3,-82.7,-157.7,-152,-211c0,0,-3,-3,-3,-3l399351,0l0,-40\nc-398570,0,-399437,0,-399437,0z M593 435 v40 H399500 v-40z\nM0 281 v-40 H399908 v40z M0 281 v-40 H399908 v40z",
    rightharpoonaboveshortbar: "M0,241 l0,40c399126,0,399993,0,399993,0\nc4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,\n-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6\nc-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z\nM0 241 v40 H399908 v-40z M0 475 v-40 H399500 v40z M0 475 v-40 H399500 v40z",
    shortbaraboveleftharpoon: "M7,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11\nc1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17c2,0.7,5,1,9,\n1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21c-32,-87.3,-82.7,-157.7,\n-152,-211c0,0,-3,-3,-3,-3l399907,0l0,-40c-399126,0,-399993,0,-399993,0z\nM93 435 v40 H400000 v-40z M500 241 v40 H400000 v-40z M500 241 v40 H400000 v-40z",
    shortrightharpoonabovebar: "M53,241l0,40c398570,0,399437,0,399437,0\nc4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,\n-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6\nc-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z\nM500 241 v40 H399408 v-40z M500 435 v40 H400000 v-40z"
};
var $ef0731f441f79e9a$var$tallDelim = function tallDelim(label, midHeight) {
    switch(label){
        case "lbrack":
            return "M403 1759 V84 H666 V0 H319 V1759 v" + midHeight + " v1759 v84 h347 v-84\nH403z M403 1759 V0 H319 V1759 v" + midHeight + " v1759 v84 h84z";
        case "rbrack":
            return "M347 1759 V0 H0 V84 H263 V1759 v" + midHeight + " v1759 H0 v84 H347z\nM347 1759 V0 H263 V1759 v" + midHeight + " v1759 h84z";
        case "vert":
            return "M145 15 v585 v" + midHeight + " v585 c2.667,10,9.667,15,21,15\nc10,0,16.667,-5,20,-15 v-585 v" + -midHeight + " v-585 c-2.667,-10,-9.667,-15,-21,-15\nc-10,0,-16.667,5,-20,15z M188 15 H145 v585 v" + midHeight + " v585 h43z";
        case "doublevert":
            return "M145 15 v585 v" + midHeight + " v585 c2.667,10,9.667,15,21,15\nc10,0,16.667,-5,20,-15 v-585 v" + -midHeight + " v-585 c-2.667,-10,-9.667,-15,-21,-15\nc-10,0,-16.667,5,-20,15z M188 15 H145 v585 v" + midHeight + " v585 h43z\nM367 15 v585 v" + midHeight + " v585 c2.667,10,9.667,15,21,15\nc10,0,16.667,-5,20,-15 v-585 v" + -midHeight + " v-585 c-2.667,-10,-9.667,-15,-21,-15\nc-10,0,-16.667,5,-20,15z M410 15 H367 v585 v" + midHeight + " v585 h43z";
        case "lfloor":
            return "M319 602 V0 H403 V602 v" + midHeight + " v1715 h263 v84 H319z\nMM319 602 V0 H403 V602 v" + midHeight + " v1715 H319z";
        case "rfloor":
            return "M319 602 V0 H403 V602 v" + midHeight + " v1799 H0 v-84 H319z\nMM319 602 V0 H403 V602 v" + midHeight + " v1715 H319z";
        case "lceil":
            return "M403 1759 V84 H666 V0 H319 V1759 v" + midHeight + " v602 h84z\nM403 1759 V0 H319 V1759 v" + midHeight + " v602 h84z";
        case "rceil":
            return "M347 1759 V0 H0 V84 H263 V1759 v" + midHeight + " v602 h84z\nM347 1759 V0 h-84 V1759 v" + midHeight + " v602 h84z";
        case "lparen":
            return "M863,9c0,-2,-2,-5,-6,-9c0,0,-17,0,-17,0c-12.7,0,-19.3,0.3,-20,1\nc-5.3,5.3,-10.3,11,-15,17c-242.7,294.7,-395.3,682,-458,1162c-21.3,163.3,-33.3,349,\n-36,557 l0," + (midHeight + 84) + "c0.2,6,0,26,0,60c2,159.3,10,310.7,24,454c53.3,528,210,\n949.7,470,1265c4.7,6,9.7,11.7,15,17c0.7,0.7,7,1,19,1c0,0,18,0,18,0c4,-4,6,-7,6,-9\nc0,-2.7,-3.3,-8.7,-10,-18c-135.3,-192.7,-235.5,-414.3,-300.5,-665c-65,-250.7,-102.5,\n-544.7,-112.5,-882c-2,-104,-3,-167,-3,-189\nl0,-" + (midHeight + 92) + "c0,-162.7,5.7,-314,17,-454c20.7,-272,63.7,-513,129,-723c65.3,\n-210,155.3,-396.3,270,-559c6.7,-9.3,10,-15.3,10,-18z";
        case "rparen":
            return "M76,0c-16.7,0,-25,3,-25,9c0,2,2,6.3,6,13c21.3,28.7,42.3,60.3,\n63,95c96.7,156.7,172.8,332.5,228.5,527.5c55.7,195,92.8,416.5,111.5,664.5\nc11.3,139.3,17,290.7,17,454c0,28,1.7,43,3.3,45l0," + (midHeight + 9) + "\nc-3,4,-3.3,16.7,-3.3,38c0,162,-5.7,313.7,-17,455c-18.7,248,-55.8,469.3,-111.5,664\nc-55.7,194.7,-131.8,370.3,-228.5,527c-20.7,34.7,-41.7,66.3,-63,95c-2,3.3,-4,7,-6,11\nc0,7.3,5.7,11,17,11c0,0,11,0,11,0c9.3,0,14.3,-0.3,15,-1c5.3,-5.3,10.3,-11,15,-17\nc242.7,-294.7,395.3,-681.7,458,-1161c21.3,-164.7,33.3,-350.7,36,-558\nl0,-" + (midHeight + 144) + "c-2,-159.3,-10,-310.7,-24,-454c-53.3,-528,-210,-949.7,\n-470,-1265c-4.7,-6,-9.7,-11.7,-15,-17c-0.7,-0.7,-6.7,-1,-18,-1z";
        default:
            // We should not ever get here.
            throw new Error("Unknown stretchy delimiter.");
    }
};
function $ef0731f441f79e9a$var$isMathDomNode(node) {
    return 'toText' in node;
}
/**
 * This node represents a document fragment, which contains elements, but when
 * placed into the DOM doesn't have any representation itself. It only contains
 * children and doesn't have any DOM node properties.
 */ class $ef0731f441f79e9a$var$DocumentFragment {
    // Never used; needed for satisfying interface.
    constructor(children){
        this.children = void 0;
        this.classes = void 0;
        this.height = void 0;
        this.depth = void 0;
        this.maxFontSize = void 0;
        this.style = void 0;
        this.children = children;
        this.classes = [];
        this.height = 0;
        this.depth = 0;
        this.maxFontSize = 0;
        this.style = {};
    }
    hasClass(className) {
        return this.classes.includes(className);
    }
    /** Convert the fragment into a node. */ toNode() {
        var frag = document.createDocumentFragment();
        for(var i = 0; i < this.children.length; i++)frag.appendChild(this.children[i].toNode());
        return frag;
    }
    /** Convert the fragment into HTML markup. */ toMarkup() {
        var markup = "";
        // Simply concatenate the markup for the children together.
        for(var i = 0; i < this.children.length; i++)markup += this.children[i].toMarkup();
        return markup;
    }
    /**
   * Converts the math node into a string, similar to innerText. Applies to
   * MathDomNode's only.
   */ toText() {
        return this.children.map((child)=>{
            if ($ef0731f441f79e9a$var$isMathDomNode(child)) return child.toText();
            throw new Error("Expected MathDomNode with toText, got " + child.constructor.name);
        }).join("");
    }
}
/**
 * This file does conversion between units.  In particular, it provides
 * calculateSize to convert other units into ems.
 */ // This table gives the number of TeX pts in one of each *absolute* TeX unit.
// Thus, multiplying a length by this number converts the length from units
// into pts.  Dividing the result by ptPerEm gives the number of ems
// *assuming* a font size of ptPerEm (normal size, normal style).
var $ef0731f441f79e9a$var$ptPerUnit = {
    // https://en.wikibooks.org/wiki/LaTeX/Lengths and
    // https://tex.stackexchange.com/a/8263
    "pt": 1,
    // TeX point
    "mm": 7227 / 2540,
    // millimeter
    "cm": 7227 / 254,
    // centimeter
    "in": 72.27,
    // inch
    "bp": 1.00375,
    // big (PostScript) points
    "pc": 12,
    // pica
    "dd": 1238 / 1157,
    // didot
    "cc": 14856 / 1157,
    // cicero (12 didot)
    "nd": 685 / 642,
    // new didot
    "nc": 1370 / 107,
    // new cicero (12 new didot)
    "sp": 1 / 65536,
    // scaled point (TeX's internal smallest unit)
    // https://tex.stackexchange.com/a/41371
    "px": 1.00375 // \pdfpxdimen defaults to 1 bp in pdfTeX and LuaTeX
};
// Dictionary of relative units, for fast validity testing.
var $ef0731f441f79e9a$var$relativeUnit = {
    "ex": true,
    "em": true,
    "mu": true
};
/**
 * Determine whether the specified unit (either a string defining the unit
 * or a "size" parse node containing a unit field) is valid.
 */ var $ef0731f441f79e9a$var$validUnit = function validUnit(unit) {
    if (typeof unit !== "string") unit = unit.unit;
    return unit in $ef0731f441f79e9a$var$ptPerUnit || unit in $ef0731f441f79e9a$var$relativeUnit || unit === "ex";
};
/*
 * Convert a "size" parse node (with numeric "number" and string "unit" fields,
 * as parsed by functions.js argType "size") into a CSS em value for the
 * current style/scale.  `options` gives the current options.
 */ var $ef0731f441f79e9a$var$calculateSize = function calculateSize(sizeValue, options) {
    var scale;
    if (sizeValue.unit in $ef0731f441f79e9a$var$ptPerUnit) // Absolute units
    scale = $ef0731f441f79e9a$var$ptPerUnit[sizeValue.unit] // Convert unit to pt
     / options.fontMetrics().ptPerEm // Convert pt to CSS em
     / options.sizeMultiplier; // Unscale to make absolute units
    else if (sizeValue.unit === "mu") // `mu` units scale with scriptstyle/scriptscriptstyle.
    scale = options.fontMetrics().cssEmPerMu;
    else {
        // Other relative units always refer to the *textstyle* font
        // in the current size.
        var unitOptions;
        if (options.style.isTight()) // isTight() means current style is script/scriptscript.
        unitOptions = options.havingStyle(options.style.text());
        else unitOptions = options;
        // TODO: In TeX these units are relative to the quad of the current
        // *text* font, e.g. cmr10. KaTeX instead uses values from the
        // comparably-sized *Computer Modern symbol* font. At 10pt, these
        // match. At 7pt and 5pt, they differ: cmr7=1.138894, cmsy7=1.170641;
        // cmr5=1.361133, cmsy5=1.472241. Consider $\scriptsize a\kern1emb$.
        // TeX \showlists shows a kern of 1.13889 * fontsize;
        // KaTeX shows a kern of 1.171 * fontsize.
        if (sizeValue.unit === "ex") scale = unitOptions.fontMetrics().xHeight;
        else if (sizeValue.unit === "em") scale = unitOptions.fontMetrics().quad;
        else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid unit: '" + sizeValue.unit + "'");
        if (unitOptions !== options) scale *= unitOptions.sizeMultiplier / options.sizeMultiplier;
    }
    return Math.min(sizeValue.number * scale, options.maxSize);
};
/**
 * Round `n` to 4 decimal places, or to the nearest 1/10,000th em. See
 * https://github.com/KaTeX/KaTeX/pull/2460.
 */ var $ef0731f441f79e9a$var$makeEm = function makeEm(n) {
    return +n.toFixed(4) + "em";
};
/**
 * These objects store the data about the DOM nodes we create, as well as some
 * extra data. They can then be transformed into real DOM nodes with the
 * `toNode` function or HTML markup using `toMarkup`. They are useful for both
 * storing extra properties on the nodes, as well as providing a way to easily
 * work with the DOM.
 *
 * Similar functions for working with MathML nodes exist in mathMLTree.js.
 *
 * TODO: refactor `span` and `anchor` into common superclass when
 * target environments support class inheritance
 */ /**
 * Create an HTML className based on a list of classes. In addition to joining
 * with spaces, we also remove empty classes.
 */ var $ef0731f441f79e9a$var$createClass = function createClass(classes) {
    return classes.filter((cls)=>cls).join(" ");
};
/**
 * Serialize a CssStyle object into a semicolon-delimited inline-style string
 * (hyphenating camelCase property names). Returns "" when no property is set.
 */ var $ef0731f441f79e9a$var$cssStyleToString = function cssStyleToString(style) {
    var styles = "";
    for (var key of Object.keys(style)){
        var value = style[key];
        if (value !== undefined) styles += $ef0731f441f79e9a$var$hyphenate(key) + ":" + value + ";";
    }
    return styles;
};
var $ef0731f441f79e9a$var$initNode = function initNode(classes, options, style) {
    this.classes = classes || [];
    this.attributes = {};
    this.height = 0;
    this.depth = 0;
    this.maxFontSize = 0;
    this.style = style || {};
    if (options) {
        if (options.style.isTight()) this.classes.push("mtight");
        var color = options.getColor();
        if (color) this.style.color = color;
    }
};
/**
 * Convert into an HTML node
 */ var $ef0731f441f79e9a$var$toNode = function toNode(tagName) {
    var node = document.createElement(tagName);
    // Apply the class
    node.className = $ef0731f441f79e9a$var$createClass(this.classes);
    // Apply inline styles
    Object.assign(node.style, this.style);
    // Apply attributes
    for (var attr of Object.keys(this.attributes))node.setAttribute(attr, this.attributes[attr]);
    // Append the children, also as HTML nodes
    for(var i = 0; i < this.children.length; i++)node.appendChild(this.children[i].toNode());
    return node;
};
/**
 * https://w3c.github.io/html-reference/syntax.html#syntax-attributes
 *
 * > Attribute Names must consist of one or more characters
 * other than the space characters, U+0000 NULL,
 * '"', "'", ">", "/", "=", the control characters,
 * and any characters that are not defined by Unicode.
 */ var $ef0731f441f79e9a$var$invalidAttributeNameRegex = /[\s"'>/=\x00-\x1f]/;
/**
 * Convert into an HTML markup string
 */ var $ef0731f441f79e9a$var$toMarkup = function toMarkup(tagName) {
    var markup = "<" + tagName;
    // Add the class
    if (this.classes.length) markup += " class=\"" + $ef0731f441f79e9a$var$escape($ef0731f441f79e9a$var$createClass(this.classes)) + "\"";
    var styles = $ef0731f441f79e9a$var$cssStyleToString(this.style);
    if (styles) markup += " style=\"" + $ef0731f441f79e9a$var$escape(styles) + "\"";
    // Add the attributes
    for (var attr of Object.keys(this.attributes)){
        if ($ef0731f441f79e9a$var$invalidAttributeNameRegex.test(attr)) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid attribute name '" + attr + "'");
        markup += " " + attr + "=\"" + $ef0731f441f79e9a$var$escape(this.attributes[attr]) + "\"";
    }
    markup += ">";
    // Add the markup of the children, also as markup
    for(var i = 0; i < this.children.length; i++)markup += this.children[i].toMarkup();
    markup += "</" + tagName + ">";
    return markup;
};
/**
 * This node represents a span node, with a className, a list of children, and
 * an inline style. It also contains information about its height, depth, and
 * maxFontSize.
 *
 * Represents two types with different uses: SvgSpan to wrap an SVG and DomSpan
 * otherwise. This typesafety is important when HTML builders access a span's
 * children.
 */ class $ef0731f441f79e9a$var$Span {
    constructor(classes, children, options, style){
        this.children = void 0;
        this.attributes = void 0;
        this.classes = void 0;
        this.height = void 0;
        this.depth = void 0;
        this.width = void 0;
        this.maxFontSize = void 0;
        this.style = void 0;
        /**
     * Italic correction carried over from a SymbolNode when the symbol is
     * wrapped in a vlist (e.g. \oiint / \oiiint).  Read by supsub to adjust
     * subscript positioning.  Only set when nonzero; use `?? 0` at read sites.
     */ this.italic = void 0;
        $ef0731f441f79e9a$var$initNode.call(this, classes, options, style);
        this.children = children || [];
    }
    /**
   * Sets an arbitrary attribute on the span. Warning: use this wisely. Not
   * all browsers support attributes the same, and having too many custom
   * attributes is probably bad.
   */ setAttribute(attribute, value) {
        this.attributes[attribute] = value;
    }
    hasClass(className) {
        return this.classes.includes(className);
    }
    toNode() {
        return $ef0731f441f79e9a$var$toNode.call(this, "span");
    }
    toMarkup() {
        return $ef0731f441f79e9a$var$toMarkup.call(this, "span");
    }
}
/**
 * This node represents an anchor (<a>) element with a hyperlink.  See `span`
 * for further details.
 */ class $ef0731f441f79e9a$var$Anchor {
    constructor(href, classes, children, options){
        this.children = void 0;
        this.attributes = void 0;
        this.classes = void 0;
        this.height = void 0;
        this.depth = void 0;
        this.maxFontSize = void 0;
        this.style = void 0;
        $ef0731f441f79e9a$var$initNode.call(this, classes, options);
        this.children = children || [];
        this.setAttribute('href', href);
    }
    setAttribute(attribute, value) {
        this.attributes[attribute] = value;
    }
    hasClass(className) {
        return this.classes.includes(className);
    }
    toNode() {
        return $ef0731f441f79e9a$var$toNode.call(this, "a");
    }
    toMarkup() {
        return $ef0731f441f79e9a$var$toMarkup.call(this, "a");
    }
}
/**
 * This node represents an image embed (<img>) element.
 */ class $ef0731f441f79e9a$var$Img {
    constructor(src, alt, style){
        this.src = void 0;
        this.alt = void 0;
        this.classes = void 0;
        this.height = void 0;
        this.depth = void 0;
        this.maxFontSize = void 0;
        this.style = void 0;
        this.alt = alt;
        this.src = src;
        this.classes = [
            "mord"
        ];
        this.height = 0;
        this.depth = 0;
        this.maxFontSize = 0;
        this.style = style;
    }
    hasClass(className) {
        return this.classes.includes(className);
    }
    toNode() {
        var node = document.createElement("img");
        node.src = this.src;
        node.alt = this.alt;
        node.className = "mord";
        // Apply inline styles
        Object.assign(node.style, this.style);
        return node;
    }
    toMarkup() {
        var markup = "<img src=\"" + $ef0731f441f79e9a$var$escape(this.src) + "\"" + (" alt=\"" + $ef0731f441f79e9a$var$escape(this.alt) + "\"");
        var styles = $ef0731f441f79e9a$var$cssStyleToString(this.style);
        if (styles) markup += " style=\"" + $ef0731f441f79e9a$var$escape(styles) + "\"";
        markup += "'/>";
        return markup;
    }
}
var $ef0731f441f79e9a$var$iCombinations = {
    "\xee": '\u0131\u0302',
    "\xef": '\u0131\u0308',
    "\xed": '\u0131\u0301',
    // 'ī': '\u0131\u0304', // enable when we add Extended Latin
    "\xec": '\u0131\u0300'
};
/**
 * A symbol node contains information about a single symbol. It either renders
 * to a single text node, or a span with a single text node in it, depending on
 * whether it has CSS classes, styles, or needs italic correction.
 */ class $ef0731f441f79e9a$var$SymbolNode {
    constructor(text, height, depth, italic, skew, width, classes, style){
        this.text = void 0;
        this.height = void 0;
        this.depth = void 0;
        this.italic = void 0;
        this.skew = void 0;
        this.width = void 0;
        this.maxFontSize = void 0;
        this.classes = void 0;
        this.style = void 0;
        this.text = text;
        this.height = height || 0;
        this.depth = depth || 0;
        this.italic = italic || 0;
        this.skew = skew || 0;
        this.width = width || 0;
        this.classes = classes || [];
        this.style = style || {};
        this.maxFontSize = 0;
        // Mark text from non-Latin scripts with specific classes so that we
        // can specify which fonts to use.  This allows us to render these
        // characters with a serif font in situations where the browser would
        // either default to a sans serif or render a placeholder character.
        // We use CSS class names like cjk_fallback, hangul_fallback and
        // brahmic_fallback. See ./unicodeScripts.js for the set of possible
        // script names
        var script = $ef0731f441f79e9a$var$scriptFromCodepoint(this.text.charCodeAt(0));
        if (script) this.classes.push(script + "_fallback");
        if (/[îïíì]/.test(this.text)) // add ī when we add Extended Latin
        this.text = $ef0731f441f79e9a$var$iCombinations[this.text];
    }
    hasClass(className) {
        return this.classes.includes(className);
    }
    /**
   * Creates a text node or span from a symbol node. Note that a span is only
   * created if it is needed.
   */ toNode() {
        var node = document.createTextNode(this.text);
        var span = null;
        if (this.italic > 0) {
            span = document.createElement("span");
            span.style.marginRight = $ef0731f441f79e9a$var$makeEm(this.italic);
        }
        if (this.classes.length > 0) {
            span = span || document.createElement("span");
            span.className = $ef0731f441f79e9a$var$createClass(this.classes);
        }
        if (Object.keys(this.style).length > 0) {
            span = span || document.createElement("span");
            Object.assign(span.style, this.style);
        }
        if (span) {
            span.appendChild(node);
            return span;
        } else return node;
    }
    /**
   * Creates markup for a symbol node.
   */ toMarkup() {
        // TODO(alpert): More duplication than I'd like from
        // span.prototype.toMarkup and symbolNode.prototype.toNode...
        var needsSpan = false;
        var markup = "<span";
        if (this.classes.length) {
            needsSpan = true;
            markup += " class=\"";
            markup += $ef0731f441f79e9a$var$escape($ef0731f441f79e9a$var$createClass(this.classes));
            markup += "\"";
        }
        var styles = "";
        if (this.italic > 0) styles += "margin-right:" + $ef0731f441f79e9a$var$makeEm(this.italic) + ";";
        styles += $ef0731f441f79e9a$var$cssStyleToString(this.style);
        if (styles) {
            needsSpan = true;
            markup += " style=\"" + $ef0731f441f79e9a$var$escape(styles) + "\"";
        }
        var escaped = $ef0731f441f79e9a$var$escape(this.text);
        if (needsSpan) {
            markup += ">";
            markup += escaped;
            markup += "</span>";
            return markup;
        } else return escaped;
    }
}
/**
 * SVG nodes are used to render stretchy wide elements.
 */ class $ef0731f441f79e9a$var$SvgNode {
    constructor(children, attributes){
        this.children = void 0;
        this.attributes = void 0;
        this.children = children || [];
        this.attributes = attributes || {};
    }
    toNode() {
        var svgNS = "http://www.w3.org/2000/svg";
        var node = document.createElementNS(svgNS, "svg");
        // Apply attributes
        for (var attr of Object.keys(this.attributes))node.setAttribute(attr, this.attributes[attr]);
        for(var i = 0; i < this.children.length; i++)node.appendChild(this.children[i].toNode());
        return node;
    }
    toMarkup() {
        var markup = "<svg xmlns=\"http://www.w3.org/2000/svg\"";
        // Apply attributes
        for (var attr of Object.keys(this.attributes))markup += " " + attr + "=\"" + $ef0731f441f79e9a$var$escape(this.attributes[attr]) + "\"";
        markup += ">";
        for(var i = 0; i < this.children.length; i++)markup += this.children[i].toMarkup();
        markup += "</svg>";
        return markup;
    }
}
class $ef0731f441f79e9a$var$PathNode {
    constructor(pathName, alternate){
        this.pathName = void 0;
        this.alternate = void 0;
        this.pathName = pathName;
        this.alternate = alternate; // Used only for \sqrt, \phase, & tall delims
    }
    toNode() {
        var svgNS = "http://www.w3.org/2000/svg";
        var node = document.createElementNS(svgNS, "path");
        if (this.alternate) node.setAttribute("d", this.alternate);
        else node.setAttribute("d", $ef0731f441f79e9a$var$path[this.pathName]);
        return node;
    }
    toMarkup() {
        if (this.alternate) return "<path d=\"" + $ef0731f441f79e9a$var$escape(this.alternate) + "\"/>";
        else return "<path d=\"" + $ef0731f441f79e9a$var$escape($ef0731f441f79e9a$var$path[this.pathName]) + "\"/>";
    }
}
class $ef0731f441f79e9a$var$LineNode {
    constructor(attributes){
        this.attributes = void 0;
        this.attributes = attributes || {};
    }
    toNode() {
        var svgNS = "http://www.w3.org/2000/svg";
        var node = document.createElementNS(svgNS, "line");
        // Apply attributes
        for (var attr of Object.keys(this.attributes))node.setAttribute(attr, this.attributes[attr]);
        return node;
    }
    toMarkup() {
        var markup = "<line";
        for (var attr of Object.keys(this.attributes))markup += " " + attr + "=\"" + $ef0731f441f79e9a$var$escape(this.attributes[attr]) + "\"";
        markup += "/>";
        return markup;
    }
}
function $ef0731f441f79e9a$var$assertSymbolDomNode(group) {
    if (group instanceof $ef0731f441f79e9a$var$SymbolNode) return group;
    else throw new Error("Expected symbolNode but got " + String(group) + ".");
}
function $ef0731f441f79e9a$var$assertSpan(group) {
    if (group instanceof $ef0731f441f79e9a$var$Span) return group;
    else throw new Error("Expected span<HtmlDomNode> but got " + String(group) + ".");
}
/**
 * Whether an HtmlDomNode has HtmlDomNode children.
 * HtmlDomNode is a base type representing a union of
 * SymbolNode, SvgSpan, DomSpan, Anchor, and documentFragment.
 * In the last three cases, the children are HtmlDomNode[].
 */ var $ef0731f441f79e9a$var$hasHtmlDomChildren = (node)=>node instanceof $ef0731f441f79e9a$var$Span || node instanceof $ef0731f441f79e9a$var$Anchor || node instanceof $ef0731f441f79e9a$var$DocumentFragment;
// This file is GENERATED by buildMetrics.sh. DO NOT MODIFY.
var $ef0731f441f79e9a$var$fontMetricsData = {
    "AMS-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "65": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "66": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "67": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "68": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "69": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "70": [
            0,
            0.68889,
            0,
            0,
            0.61111
        ],
        "71": [
            0,
            0.68889,
            0,
            0,
            0.77778
        ],
        "72": [
            0,
            0.68889,
            0,
            0,
            0.77778
        ],
        "73": [
            0,
            0.68889,
            0,
            0,
            0.38889
        ],
        "74": [
            0.16667,
            0.68889,
            0,
            0,
            0.5
        ],
        "75": [
            0,
            0.68889,
            0,
            0,
            0.77778
        ],
        "76": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "77": [
            0,
            0.68889,
            0,
            0,
            0.94445
        ],
        "78": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "79": [
            0.16667,
            0.68889,
            0,
            0,
            0.77778
        ],
        "80": [
            0,
            0.68889,
            0,
            0,
            0.61111
        ],
        "81": [
            0.16667,
            0.68889,
            0,
            0,
            0.77778
        ],
        "82": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "83": [
            0,
            0.68889,
            0,
            0,
            0.55556
        ],
        "84": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "85": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "86": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "87": [
            0,
            0.68889,
            0,
            0,
            1.0
        ],
        "88": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "89": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "90": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "107": [
            0,
            0.68889,
            0,
            0,
            0.55556
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "165": [
            0,
            0.675,
            0.025,
            0,
            0.75
        ],
        "174": [
            0.15559,
            0.69224,
            0,
            0,
            0.94666
        ],
        "240": [
            0,
            0.68889,
            0,
            0,
            0.55556
        ],
        "295": [
            0,
            0.68889,
            0,
            0,
            0.54028
        ],
        "710": [
            0,
            0.825,
            0,
            0,
            2.33334
        ],
        "732": [
            0,
            0.9,
            0,
            0,
            2.33334
        ],
        "770": [
            0,
            0.825,
            0,
            0,
            2.33334
        ],
        "771": [
            0,
            0.9,
            0,
            0,
            2.33334
        ],
        "989": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "1008": [
            0,
            0.43056,
            0.04028,
            0,
            0.66667
        ],
        "8245": [
            0,
            0.54986,
            0,
            0,
            0.275
        ],
        "8463": [
            0,
            0.68889,
            0,
            0,
            0.54028
        ],
        "8487": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "8498": [
            0,
            0.68889,
            0,
            0,
            0.55556
        ],
        "8502": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "8503": [
            0,
            0.68889,
            0,
            0,
            0.44445
        ],
        "8504": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "8513": [
            0,
            0.68889,
            0,
            0,
            0.63889
        ],
        "8592": [
            -0.03598,
            0.46402,
            0,
            0,
            0.5
        ],
        "8594": [
            -0.03598,
            0.46402,
            0,
            0,
            0.5
        ],
        "8602": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8603": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8606": [
            0.01354,
            0.52239,
            0,
            0,
            1.0
        ],
        "8608": [
            0.01354,
            0.52239,
            0,
            0,
            1.0
        ],
        "8610": [
            0.01354,
            0.52239,
            0,
            0,
            1.11111
        ],
        "8611": [
            0.01354,
            0.52239,
            0,
            0,
            1.11111
        ],
        "8619": [
            0,
            0.54986,
            0,
            0,
            1.0
        ],
        "8620": [
            0,
            0.54986,
            0,
            0,
            1.0
        ],
        "8621": [
            -0.13313,
            0.37788,
            0,
            0,
            1.38889
        ],
        "8622": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8624": [
            0,
            0.69224,
            0,
            0,
            0.5
        ],
        "8625": [
            0,
            0.69224,
            0,
            0,
            0.5
        ],
        "8630": [
            0,
            0.43056,
            0,
            0,
            1.0
        ],
        "8631": [
            0,
            0.43056,
            0,
            0,
            1.0
        ],
        "8634": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8635": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8638": [
            0.19444,
            0.69224,
            0,
            0,
            0.41667
        ],
        "8639": [
            0.19444,
            0.69224,
            0,
            0,
            0.41667
        ],
        "8642": [
            0.19444,
            0.69224,
            0,
            0,
            0.41667
        ],
        "8643": [
            0.19444,
            0.69224,
            0,
            0,
            0.41667
        ],
        "8644": [
            0.1808,
            0.675,
            0,
            0,
            1.0
        ],
        "8646": [
            0.1808,
            0.675,
            0,
            0,
            1.0
        ],
        "8647": [
            0.1808,
            0.675,
            0,
            0,
            1.0
        ],
        "8648": [
            0.19444,
            0.69224,
            0,
            0,
            0.83334
        ],
        "8649": [
            0.1808,
            0.675,
            0,
            0,
            1.0
        ],
        "8650": [
            0.19444,
            0.69224,
            0,
            0,
            0.83334
        ],
        "8651": [
            0.01354,
            0.52239,
            0,
            0,
            1.0
        ],
        "8652": [
            0.01354,
            0.52239,
            0,
            0,
            1.0
        ],
        "8653": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8654": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8655": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8666": [
            0.13667,
            0.63667,
            0,
            0,
            1.0
        ],
        "8667": [
            0.13667,
            0.63667,
            0,
            0,
            1.0
        ],
        "8669": [
            -0.13313,
            0.37788,
            0,
            0,
            1.0
        ],
        "8672": [
            -0.064,
            0.437,
            0,
            0,
            1.334
        ],
        "8674": [
            -0.064,
            0.437,
            0,
            0,
            1.334
        ],
        "8705": [
            0,
            0.825,
            0,
            0,
            0.5
        ],
        "8708": [
            0,
            0.68889,
            0,
            0,
            0.55556
        ],
        "8709": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "8717": [
            0,
            0.43056,
            0,
            0,
            0.42917
        ],
        "8722": [
            -0.03598,
            0.46402,
            0,
            0,
            0.5
        ],
        "8724": [
            0.08198,
            0.69224,
            0,
            0,
            0.77778
        ],
        "8726": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "8733": [
            0,
            0.69224,
            0,
            0,
            0.77778
        ],
        "8736": [
            0,
            0.69224,
            0,
            0,
            0.72222
        ],
        "8737": [
            0,
            0.69224,
            0,
            0,
            0.72222
        ],
        "8738": [
            0.03517,
            0.52239,
            0,
            0,
            0.72222
        ],
        "8739": [
            0.08167,
            0.58167,
            0,
            0,
            0.22222
        ],
        "8740": [
            0.25142,
            0.74111,
            0,
            0,
            0.27778
        ],
        "8741": [
            0.08167,
            0.58167,
            0,
            0,
            0.38889
        ],
        "8742": [
            0.25142,
            0.74111,
            0,
            0,
            0.5
        ],
        "8756": [
            0,
            0.69224,
            0,
            0,
            0.66667
        ],
        "8757": [
            0,
            0.69224,
            0,
            0,
            0.66667
        ],
        "8764": [
            -0.13313,
            0.36687,
            0,
            0,
            0.77778
        ],
        "8765": [
            -0.13313,
            0.37788,
            0,
            0,
            0.77778
        ],
        "8769": [
            -0.13313,
            0.36687,
            0,
            0,
            0.77778
        ],
        "8770": [
            -0.03625,
            0.46375,
            0,
            0,
            0.77778
        ],
        "8774": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8776": [
            -0.01688,
            0.48312,
            0,
            0,
            0.77778
        ],
        "8778": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "8782": [
            0.06062,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8783": [
            0.06062,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8785": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8786": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8787": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8790": [
            0,
            0.69224,
            0,
            0,
            0.77778
        ],
        "8791": [
            0.22958,
            0.72958,
            0,
            0,
            0.77778
        ],
        "8796": [
            0.08198,
            0.91667,
            0,
            0,
            0.77778
        ],
        "8806": [
            0.25583,
            0.75583,
            0,
            0,
            0.77778
        ],
        "8807": [
            0.25583,
            0.75583,
            0,
            0,
            0.77778
        ],
        "8808": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "8809": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "8812": [
            0.25583,
            0.75583,
            0,
            0,
            0.5
        ],
        "8814": [
            0.20576,
            0.70576,
            0,
            0,
            0.77778
        ],
        "8815": [
            0.20576,
            0.70576,
            0,
            0,
            0.77778
        ],
        "8816": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8817": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8818": [
            0.22958,
            0.72958,
            0,
            0,
            0.77778
        ],
        "8819": [
            0.22958,
            0.72958,
            0,
            0,
            0.77778
        ],
        "8822": [
            0.1808,
            0.675,
            0,
            0,
            0.77778
        ],
        "8823": [
            0.1808,
            0.675,
            0,
            0,
            0.77778
        ],
        "8828": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "8829": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "8830": [
            0.22958,
            0.72958,
            0,
            0,
            0.77778
        ],
        "8831": [
            0.22958,
            0.72958,
            0,
            0,
            0.77778
        ],
        "8832": [
            0.20576,
            0.70576,
            0,
            0,
            0.77778
        ],
        "8833": [
            0.20576,
            0.70576,
            0,
            0,
            0.77778
        ],
        "8840": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8841": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8842": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8843": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8847": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8848": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8858": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8859": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8861": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8862": [
            0,
            0.675,
            0,
            0,
            0.77778
        ],
        "8863": [
            0,
            0.675,
            0,
            0,
            0.77778
        ],
        "8864": [
            0,
            0.675,
            0,
            0,
            0.77778
        ],
        "8865": [
            0,
            0.675,
            0,
            0,
            0.77778
        ],
        "8872": [
            0,
            0.69224,
            0,
            0,
            0.61111
        ],
        "8873": [
            0,
            0.69224,
            0,
            0,
            0.72222
        ],
        "8874": [
            0,
            0.69224,
            0,
            0,
            0.88889
        ],
        "8876": [
            0,
            0.68889,
            0,
            0,
            0.61111
        ],
        "8877": [
            0,
            0.68889,
            0,
            0,
            0.61111
        ],
        "8878": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "8879": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "8882": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8883": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8884": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "8885": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "8888": [
            0,
            0.54986,
            0,
            0,
            1.11111
        ],
        "8890": [
            0.19444,
            0.43056,
            0,
            0,
            0.55556
        ],
        "8891": [
            0.19444,
            0.69224,
            0,
            0,
            0.61111
        ],
        "8892": [
            0.19444,
            0.69224,
            0,
            0,
            0.61111
        ],
        "8901": [
            0,
            0.54986,
            0,
            0,
            0.27778
        ],
        "8903": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "8905": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "8906": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "8907": [
            0,
            0.69224,
            0,
            0,
            0.77778
        ],
        "8908": [
            0,
            0.69224,
            0,
            0,
            0.77778
        ],
        "8909": [
            -0.03598,
            0.46402,
            0,
            0,
            0.77778
        ],
        "8910": [
            0,
            0.54986,
            0,
            0,
            0.76042
        ],
        "8911": [
            0,
            0.54986,
            0,
            0,
            0.76042
        ],
        "8912": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8913": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8914": [
            0,
            0.54986,
            0,
            0,
            0.66667
        ],
        "8915": [
            0,
            0.54986,
            0,
            0,
            0.66667
        ],
        "8916": [
            0,
            0.69224,
            0,
            0,
            0.66667
        ],
        "8918": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "8919": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "8920": [
            0.03517,
            0.54986,
            0,
            0,
            1.33334
        ],
        "8921": [
            0.03517,
            0.54986,
            0,
            0,
            1.33334
        ],
        "8922": [
            0.38569,
            0.88569,
            0,
            0,
            0.77778
        ],
        "8923": [
            0.38569,
            0.88569,
            0,
            0,
            0.77778
        ],
        "8926": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "8927": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "8928": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8929": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8934": [
            0.23222,
            0.74111,
            0,
            0,
            0.77778
        ],
        "8935": [
            0.23222,
            0.74111,
            0,
            0,
            0.77778
        ],
        "8936": [
            0.23222,
            0.74111,
            0,
            0,
            0.77778
        ],
        "8937": [
            0.23222,
            0.74111,
            0,
            0,
            0.77778
        ],
        "8938": [
            0.20576,
            0.70576,
            0,
            0,
            0.77778
        ],
        "8939": [
            0.20576,
            0.70576,
            0,
            0,
            0.77778
        ],
        "8940": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8941": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8994": [
            0.19444,
            0.69224,
            0,
            0,
            0.77778
        ],
        "8995": [
            0.19444,
            0.69224,
            0,
            0,
            0.77778
        ],
        "9416": [
            0.15559,
            0.69224,
            0,
            0,
            0.90222
        ],
        "9484": [
            0,
            0.69224,
            0,
            0,
            0.5
        ],
        "9488": [
            0,
            0.69224,
            0,
            0,
            0.5
        ],
        "9492": [
            0,
            0.37788,
            0,
            0,
            0.5
        ],
        "9496": [
            0,
            0.37788,
            0,
            0,
            0.5
        ],
        "9585": [
            0.19444,
            0.68889,
            0,
            0,
            0.88889
        ],
        "9586": [
            0.19444,
            0.74111,
            0,
            0,
            0.88889
        ],
        "9632": [
            0,
            0.675,
            0,
            0,
            0.77778
        ],
        "9633": [
            0,
            0.675,
            0,
            0,
            0.77778
        ],
        "9650": [
            0,
            0.54986,
            0,
            0,
            0.72222
        ],
        "9651": [
            0,
            0.54986,
            0,
            0,
            0.72222
        ],
        "9654": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "9660": [
            0,
            0.54986,
            0,
            0,
            0.72222
        ],
        "9661": [
            0,
            0.54986,
            0,
            0,
            0.72222
        ],
        "9664": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "9674": [
            0.11111,
            0.69224,
            0,
            0,
            0.66667
        ],
        "9733": [
            0.19444,
            0.69224,
            0,
            0,
            0.94445
        ],
        "10003": [
            0,
            0.69224,
            0,
            0,
            0.83334
        ],
        "10016": [
            0,
            0.69224,
            0,
            0,
            0.83334
        ],
        "10731": [
            0.11111,
            0.69224,
            0,
            0,
            0.66667
        ],
        "10846": [
            0.19444,
            0.75583,
            0,
            0,
            0.61111
        ],
        "10877": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "10878": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "10885": [
            0.25583,
            0.75583,
            0,
            0,
            0.77778
        ],
        "10886": [
            0.25583,
            0.75583,
            0,
            0,
            0.77778
        ],
        "10887": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "10888": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "10889": [
            0.26167,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10890": [
            0.26167,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10891": [
            0.48256,
            0.98256,
            0,
            0,
            0.77778
        ],
        "10892": [
            0.48256,
            0.98256,
            0,
            0,
            0.77778
        ],
        "10901": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "10902": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "10933": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10934": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10935": [
            0.26167,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10936": [
            0.26167,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10937": [
            0.26167,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10938": [
            0.26167,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10949": [
            0.25583,
            0.75583,
            0,
            0,
            0.77778
        ],
        "10950": [
            0.25583,
            0.75583,
            0,
            0,
            0.77778
        ],
        "10955": [
            0.28481,
            0.79383,
            0,
            0,
            0.77778
        ],
        "10956": [
            0.28481,
            0.79383,
            0,
            0,
            0.77778
        ],
        "57350": [
            0.08167,
            0.58167,
            0,
            0,
            0.22222
        ],
        "57351": [
            0.08167,
            0.58167,
            0,
            0,
            0.38889
        ],
        "57352": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "57353": [
            0,
            0.43056,
            0.04028,
            0,
            0.66667
        ],
        "57356": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "57357": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "57358": [
            0.41951,
            0.91951,
            0,
            0,
            0.77778
        ],
        "57359": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "57360": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "57361": [
            0.41951,
            0.91951,
            0,
            0,
            0.77778
        ],
        "57366": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "57367": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "57368": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "57369": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "57370": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "57371": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ]
    },
    "Caligraphic-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "65": [
            0,
            0.68333,
            0,
            0.19445,
            0.79847
        ],
        "66": [
            0,
            0.68333,
            0.03041,
            0.13889,
            0.65681
        ],
        "67": [
            0,
            0.68333,
            0.05834,
            0.13889,
            0.52653
        ],
        "68": [
            0,
            0.68333,
            0.02778,
            0.08334,
            0.77139
        ],
        "69": [
            0,
            0.68333,
            0.08944,
            0.11111,
            0.52778
        ],
        "70": [
            0,
            0.68333,
            0.09931,
            0.11111,
            0.71875
        ],
        "71": [
            0.09722,
            0.68333,
            0.0593,
            0.11111,
            0.59487
        ],
        "72": [
            0,
            0.68333,
            0.00965,
            0.11111,
            0.84452
        ],
        "73": [
            0,
            0.68333,
            0.07382,
            0,
            0.54452
        ],
        "74": [
            0.09722,
            0.68333,
            0.18472,
            0.16667,
            0.67778
        ],
        "75": [
            0,
            0.68333,
            0.01445,
            0.05556,
            0.76195
        ],
        "76": [
            0,
            0.68333,
            0,
            0.13889,
            0.68972
        ],
        "77": [
            0,
            0.68333,
            0,
            0.13889,
            1.2009
        ],
        "78": [
            0,
            0.68333,
            0.14736,
            0.08334,
            0.82049
        ],
        "79": [
            0,
            0.68333,
            0.02778,
            0.11111,
            0.79611
        ],
        "80": [
            0,
            0.68333,
            0.08222,
            0.08334,
            0.69556
        ],
        "81": [
            0.09722,
            0.68333,
            0,
            0.11111,
            0.81667
        ],
        "82": [
            0,
            0.68333,
            0,
            0.08334,
            0.8475
        ],
        "83": [
            0,
            0.68333,
            0.075,
            0.13889,
            0.60556
        ],
        "84": [
            0,
            0.68333,
            0.25417,
            0,
            0.54464
        ],
        "85": [
            0,
            0.68333,
            0.09931,
            0.08334,
            0.62583
        ],
        "86": [
            0,
            0.68333,
            0.08222,
            0,
            0.61278
        ],
        "87": [
            0,
            0.68333,
            0.08222,
            0.08334,
            0.98778
        ],
        "88": [
            0,
            0.68333,
            0.14643,
            0.13889,
            0.7133
        ],
        "89": [
            0.09722,
            0.68333,
            0.08222,
            0.08334,
            0.66834
        ],
        "90": [
            0,
            0.68333,
            0.07944,
            0.13889,
            0.72473
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ]
    },
    "Fraktur-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69141,
            0,
            0,
            0.29574
        ],
        "34": [
            0,
            0.69141,
            0,
            0,
            0.21471
        ],
        "38": [
            0,
            0.69141,
            0,
            0,
            0.73786
        ],
        "39": [
            0,
            0.69141,
            0,
            0,
            0.21201
        ],
        "40": [
            0.24982,
            0.74947,
            0,
            0,
            0.38865
        ],
        "41": [
            0.24982,
            0.74947,
            0,
            0,
            0.38865
        ],
        "42": [
            0,
            0.62119,
            0,
            0,
            0.27764
        ],
        "43": [
            0.08319,
            0.58283,
            0,
            0,
            0.75623
        ],
        "44": [
            0,
            0.10803,
            0,
            0,
            0.27764
        ],
        "45": [
            0.08319,
            0.58283,
            0,
            0,
            0.75623
        ],
        "46": [
            0,
            0.10803,
            0,
            0,
            0.27764
        ],
        "47": [
            0.24982,
            0.74947,
            0,
            0,
            0.50181
        ],
        "48": [
            0,
            0.47534,
            0,
            0,
            0.50181
        ],
        "49": [
            0,
            0.47534,
            0,
            0,
            0.50181
        ],
        "50": [
            0,
            0.47534,
            0,
            0,
            0.50181
        ],
        "51": [
            0.18906,
            0.47534,
            0,
            0,
            0.50181
        ],
        "52": [
            0.18906,
            0.47534,
            0,
            0,
            0.50181
        ],
        "53": [
            0.18906,
            0.47534,
            0,
            0,
            0.50181
        ],
        "54": [
            0,
            0.69141,
            0,
            0,
            0.50181
        ],
        "55": [
            0.18906,
            0.47534,
            0,
            0,
            0.50181
        ],
        "56": [
            0,
            0.69141,
            0,
            0,
            0.50181
        ],
        "57": [
            0.18906,
            0.47534,
            0,
            0,
            0.50181
        ],
        "58": [
            0,
            0.47534,
            0,
            0,
            0.21606
        ],
        "59": [
            0.12604,
            0.47534,
            0,
            0,
            0.21606
        ],
        "61": [
            -0.13099,
            0.36866,
            0,
            0,
            0.75623
        ],
        "63": [
            0,
            0.69141,
            0,
            0,
            0.36245
        ],
        "65": [
            0,
            0.69141,
            0,
            0,
            0.7176
        ],
        "66": [
            0,
            0.69141,
            0,
            0,
            0.88397
        ],
        "67": [
            0,
            0.69141,
            0,
            0,
            0.61254
        ],
        "68": [
            0,
            0.69141,
            0,
            0,
            0.83158
        ],
        "69": [
            0,
            0.69141,
            0,
            0,
            0.66278
        ],
        "70": [
            0.12604,
            0.69141,
            0,
            0,
            0.61119
        ],
        "71": [
            0,
            0.69141,
            0,
            0,
            0.78539
        ],
        "72": [
            0.06302,
            0.69141,
            0,
            0,
            0.7203
        ],
        "73": [
            0,
            0.69141,
            0,
            0,
            0.55448
        ],
        "74": [
            0.12604,
            0.69141,
            0,
            0,
            0.55231
        ],
        "75": [
            0,
            0.69141,
            0,
            0,
            0.66845
        ],
        "76": [
            0,
            0.69141,
            0,
            0,
            0.66602
        ],
        "77": [
            0,
            0.69141,
            0,
            0,
            1.04953
        ],
        "78": [
            0,
            0.69141,
            0,
            0,
            0.83212
        ],
        "79": [
            0,
            0.69141,
            0,
            0,
            0.82699
        ],
        "80": [
            0.18906,
            0.69141,
            0,
            0,
            0.82753
        ],
        "81": [
            0.03781,
            0.69141,
            0,
            0,
            0.82699
        ],
        "82": [
            0,
            0.69141,
            0,
            0,
            0.82807
        ],
        "83": [
            0,
            0.69141,
            0,
            0,
            0.82861
        ],
        "84": [
            0,
            0.69141,
            0,
            0,
            0.66899
        ],
        "85": [
            0,
            0.69141,
            0,
            0,
            0.64576
        ],
        "86": [
            0,
            0.69141,
            0,
            0,
            0.83131
        ],
        "87": [
            0,
            0.69141,
            0,
            0,
            1.04602
        ],
        "88": [
            0,
            0.69141,
            0,
            0,
            0.71922
        ],
        "89": [
            0.18906,
            0.69141,
            0,
            0,
            0.83293
        ],
        "90": [
            0.12604,
            0.69141,
            0,
            0,
            0.60201
        ],
        "91": [
            0.24982,
            0.74947,
            0,
            0,
            0.27764
        ],
        "93": [
            0.24982,
            0.74947,
            0,
            0,
            0.27764
        ],
        "94": [
            0,
            0.69141,
            0,
            0,
            0.49965
        ],
        "97": [
            0,
            0.47534,
            0,
            0,
            0.50046
        ],
        "98": [
            0,
            0.69141,
            0,
            0,
            0.51315
        ],
        "99": [
            0,
            0.47534,
            0,
            0,
            0.38946
        ],
        "100": [
            0,
            0.62119,
            0,
            0,
            0.49857
        ],
        "101": [
            0,
            0.47534,
            0,
            0,
            0.40053
        ],
        "102": [
            0.18906,
            0.69141,
            0,
            0,
            0.32626
        ],
        "103": [
            0.18906,
            0.47534,
            0,
            0,
            0.5037
        ],
        "104": [
            0.18906,
            0.69141,
            0,
            0,
            0.52126
        ],
        "105": [
            0,
            0.69141,
            0,
            0,
            0.27899
        ],
        "106": [
            0,
            0.69141,
            0,
            0,
            0.28088
        ],
        "107": [
            0,
            0.69141,
            0,
            0,
            0.38946
        ],
        "108": [
            0,
            0.69141,
            0,
            0,
            0.27953
        ],
        "109": [
            0,
            0.47534,
            0,
            0,
            0.76676
        ],
        "110": [
            0,
            0.47534,
            0,
            0,
            0.52666
        ],
        "111": [
            0,
            0.47534,
            0,
            0,
            0.48885
        ],
        "112": [
            0.18906,
            0.52396,
            0,
            0,
            0.50046
        ],
        "113": [
            0.18906,
            0.47534,
            0,
            0,
            0.48912
        ],
        "114": [
            0,
            0.47534,
            0,
            0,
            0.38919
        ],
        "115": [
            0,
            0.47534,
            0,
            0,
            0.44266
        ],
        "116": [
            0,
            0.62119,
            0,
            0,
            0.33301
        ],
        "117": [
            0,
            0.47534,
            0,
            0,
            0.5172
        ],
        "118": [
            0,
            0.52396,
            0,
            0,
            0.5118
        ],
        "119": [
            0,
            0.52396,
            0,
            0,
            0.77351
        ],
        "120": [
            0.18906,
            0.47534,
            0,
            0,
            0.38865
        ],
        "121": [
            0.18906,
            0.47534,
            0,
            0,
            0.49884
        ],
        "122": [
            0.18906,
            0.47534,
            0,
            0,
            0.39054
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "8216": [
            0,
            0.69141,
            0,
            0,
            0.21471
        ],
        "8217": [
            0,
            0.69141,
            0,
            0,
            0.21471
        ],
        "58112": [
            0,
            0.62119,
            0,
            0,
            0.49749
        ],
        "58113": [
            0,
            0.62119,
            0,
            0,
            0.4983
        ],
        "58114": [
            0.18906,
            0.69141,
            0,
            0,
            0.33328
        ],
        "58115": [
            0.18906,
            0.69141,
            0,
            0,
            0.32923
        ],
        "58116": [
            0.18906,
            0.47534,
            0,
            0,
            0.50343
        ],
        "58117": [
            0,
            0.69141,
            0,
            0,
            0.33301
        ],
        "58118": [
            0,
            0.62119,
            0,
            0,
            0.33409
        ],
        "58119": [
            0,
            0.47534,
            0,
            0,
            0.50073
        ]
    },
    "Main-Bold": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0,
            0,
            0.35
        ],
        "34": [
            0,
            0.69444,
            0,
            0,
            0.60278
        ],
        "35": [
            0.19444,
            0.69444,
            0,
            0,
            0.95833
        ],
        "36": [
            0.05556,
            0.75,
            0,
            0,
            0.575
        ],
        "37": [
            0.05556,
            0.75,
            0,
            0,
            0.95833
        ],
        "38": [
            0,
            0.69444,
            0,
            0,
            0.89444
        ],
        "39": [
            0,
            0.69444,
            0,
            0,
            0.31944
        ],
        "40": [
            0.25,
            0.75,
            0,
            0,
            0.44722
        ],
        "41": [
            0.25,
            0.75,
            0,
            0,
            0.44722
        ],
        "42": [
            0,
            0.75,
            0,
            0,
            0.575
        ],
        "43": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "44": [
            0.19444,
            0.15556,
            0,
            0,
            0.31944
        ],
        "45": [
            0,
            0.44444,
            0,
            0,
            0.38333
        ],
        "46": [
            0,
            0.15556,
            0,
            0,
            0.31944
        ],
        "47": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "48": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "49": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "50": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "51": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "52": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "53": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "54": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "55": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "56": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "57": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "58": [
            0,
            0.44444,
            0,
            0,
            0.31944
        ],
        "59": [
            0.19444,
            0.44444,
            0,
            0,
            0.31944
        ],
        "60": [
            0.08556,
            0.58556,
            0,
            0,
            0.89444
        ],
        "61": [
            -0.10889,
            0.39111,
            0,
            0,
            0.89444
        ],
        "62": [
            0.08556,
            0.58556,
            0,
            0,
            0.89444
        ],
        "63": [
            0,
            0.69444,
            0,
            0,
            0.54305
        ],
        "64": [
            0,
            0.69444,
            0,
            0,
            0.89444
        ],
        "65": [
            0,
            0.68611,
            0,
            0,
            0.86944
        ],
        "66": [
            0,
            0.68611,
            0,
            0,
            0.81805
        ],
        "67": [
            0,
            0.68611,
            0,
            0,
            0.83055
        ],
        "68": [
            0,
            0.68611,
            0,
            0,
            0.88194
        ],
        "69": [
            0,
            0.68611,
            0,
            0,
            0.75555
        ],
        "70": [
            0,
            0.68611,
            0,
            0,
            0.72361
        ],
        "71": [
            0,
            0.68611,
            0,
            0,
            0.90416
        ],
        "72": [
            0,
            0.68611,
            0,
            0,
            0.9
        ],
        "73": [
            0,
            0.68611,
            0,
            0,
            0.43611
        ],
        "74": [
            0,
            0.68611,
            0,
            0,
            0.59444
        ],
        "75": [
            0,
            0.68611,
            0,
            0,
            0.90138
        ],
        "76": [
            0,
            0.68611,
            0,
            0,
            0.69166
        ],
        "77": [
            0,
            0.68611,
            0,
            0,
            1.09166
        ],
        "78": [
            0,
            0.68611,
            0,
            0,
            0.9
        ],
        "79": [
            0,
            0.68611,
            0,
            0,
            0.86388
        ],
        "80": [
            0,
            0.68611,
            0,
            0,
            0.78611
        ],
        "81": [
            0.19444,
            0.68611,
            0,
            0,
            0.86388
        ],
        "82": [
            0,
            0.68611,
            0,
            0,
            0.8625
        ],
        "83": [
            0,
            0.68611,
            0,
            0,
            0.63889
        ],
        "84": [
            0,
            0.68611,
            0,
            0,
            0.8
        ],
        "85": [
            0,
            0.68611,
            0,
            0,
            0.88472
        ],
        "86": [
            0,
            0.68611,
            0.01597,
            0,
            0.86944
        ],
        "87": [
            0,
            0.68611,
            0.01597,
            0,
            1.18888
        ],
        "88": [
            0,
            0.68611,
            0,
            0,
            0.86944
        ],
        "89": [
            0,
            0.68611,
            0.02875,
            0,
            0.86944
        ],
        "90": [
            0,
            0.68611,
            0,
            0,
            0.70277
        ],
        "91": [
            0.25,
            0.75,
            0,
            0,
            0.31944
        ],
        "92": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "93": [
            0.25,
            0.75,
            0,
            0,
            0.31944
        ],
        "94": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "95": [
            0.31,
            0.13444,
            0.03194,
            0,
            0.575
        ],
        "97": [
            0,
            0.44444,
            0,
            0,
            0.55902
        ],
        "98": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "99": [
            0,
            0.44444,
            0,
            0,
            0.51111
        ],
        "100": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "101": [
            0,
            0.44444,
            0,
            0,
            0.52708
        ],
        "102": [
            0,
            0.69444,
            0.10903,
            0,
            0.35139
        ],
        "103": [
            0.19444,
            0.44444,
            0.01597,
            0,
            0.575
        ],
        "104": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "105": [
            0,
            0.69444,
            0,
            0,
            0.31944
        ],
        "106": [
            0.19444,
            0.69444,
            0,
            0,
            0.35139
        ],
        "107": [
            0,
            0.69444,
            0,
            0,
            0.60694
        ],
        "108": [
            0,
            0.69444,
            0,
            0,
            0.31944
        ],
        "109": [
            0,
            0.44444,
            0,
            0,
            0.95833
        ],
        "110": [
            0,
            0.44444,
            0,
            0,
            0.63889
        ],
        "111": [
            0,
            0.44444,
            0,
            0,
            0.575
        ],
        "112": [
            0.19444,
            0.44444,
            0,
            0,
            0.63889
        ],
        "113": [
            0.19444,
            0.44444,
            0,
            0,
            0.60694
        ],
        "114": [
            0,
            0.44444,
            0,
            0,
            0.47361
        ],
        "115": [
            0,
            0.44444,
            0,
            0,
            0.45361
        ],
        "116": [
            0,
            0.63492,
            0,
            0,
            0.44722
        ],
        "117": [
            0,
            0.44444,
            0,
            0,
            0.63889
        ],
        "118": [
            0,
            0.44444,
            0.01597,
            0,
            0.60694
        ],
        "119": [
            0,
            0.44444,
            0.01597,
            0,
            0.83055
        ],
        "120": [
            0,
            0.44444,
            0,
            0,
            0.60694
        ],
        "121": [
            0.19444,
            0.44444,
            0.01597,
            0,
            0.60694
        ],
        "122": [
            0,
            0.44444,
            0,
            0,
            0.51111
        ],
        "123": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "124": [
            0.25,
            0.75,
            0,
            0,
            0.31944
        ],
        "125": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "126": [
            0.35,
            0.34444,
            0,
            0,
            0.575
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "163": [
            0,
            0.69444,
            0,
            0,
            0.86853
        ],
        "168": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "172": [
            0,
            0.44444,
            0,
            0,
            0.76666
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.86944
        ],
        "177": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.51111
        ],
        "198": [
            0,
            0.68611,
            0,
            0,
            1.04166
        ],
        "215": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "216": [
            0.04861,
            0.73472,
            0,
            0,
            0.89444
        ],
        "223": [
            0,
            0.69444,
            0,
            0,
            0.59722
        ],
        "230": [
            0,
            0.44444,
            0,
            0,
            0.83055
        ],
        "247": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "248": [
            0.09722,
            0.54167,
            0,
            0,
            0.575
        ],
        "305": [
            0,
            0.44444,
            0,
            0,
            0.31944
        ],
        "338": [
            0,
            0.68611,
            0,
            0,
            1.16944
        ],
        "339": [
            0,
            0.44444,
            0,
            0,
            0.89444
        ],
        "567": [
            0.19444,
            0.44444,
            0,
            0,
            0.35139
        ],
        "710": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "711": [
            0,
            0.63194,
            0,
            0,
            0.575
        ],
        "713": [
            0,
            0.59611,
            0,
            0,
            0.575
        ],
        "714": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "715": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "728": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "729": [
            0,
            0.69444,
            0,
            0,
            0.31944
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.86944
        ],
        "732": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "733": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "915": [
            0,
            0.68611,
            0,
            0,
            0.69166
        ],
        "916": [
            0,
            0.68611,
            0,
            0,
            0.95833
        ],
        "920": [
            0,
            0.68611,
            0,
            0,
            0.89444
        ],
        "923": [
            0,
            0.68611,
            0,
            0,
            0.80555
        ],
        "926": [
            0,
            0.68611,
            0,
            0,
            0.76666
        ],
        "928": [
            0,
            0.68611,
            0,
            0,
            0.9
        ],
        "931": [
            0,
            0.68611,
            0,
            0,
            0.83055
        ],
        "933": [
            0,
            0.68611,
            0,
            0,
            0.89444
        ],
        "934": [
            0,
            0.68611,
            0,
            0,
            0.83055
        ],
        "936": [
            0,
            0.68611,
            0,
            0,
            0.89444
        ],
        "937": [
            0,
            0.68611,
            0,
            0,
            0.83055
        ],
        "8211": [
            0,
            0.44444,
            0.03194,
            0,
            0.575
        ],
        "8212": [
            0,
            0.44444,
            0.03194,
            0,
            1.14999
        ],
        "8216": [
            0,
            0.69444,
            0,
            0,
            0.31944
        ],
        "8217": [
            0,
            0.69444,
            0,
            0,
            0.31944
        ],
        "8220": [
            0,
            0.69444,
            0,
            0,
            0.60278
        ],
        "8221": [
            0,
            0.69444,
            0,
            0,
            0.60278
        ],
        "8224": [
            0.19444,
            0.69444,
            0,
            0,
            0.51111
        ],
        "8225": [
            0.19444,
            0.69444,
            0,
            0,
            0.51111
        ],
        "8242": [
            0,
            0.55556,
            0,
            0,
            0.34444
        ],
        "8407": [
            0,
            0.72444,
            0.15486,
            0,
            0.575
        ],
        "8463": [
            0,
            0.69444,
            0,
            0,
            0.66759
        ],
        "8465": [
            0,
            0.69444,
            0,
            0,
            0.83055
        ],
        "8467": [
            0,
            0.69444,
            0,
            0,
            0.47361
        ],
        "8472": [
            0.19444,
            0.44444,
            0,
            0,
            0.74027
        ],
        "8476": [
            0,
            0.69444,
            0,
            0,
            0.83055
        ],
        "8501": [
            0,
            0.69444,
            0,
            0,
            0.70277
        ],
        "8592": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8593": [
            0.19444,
            0.69444,
            0,
            0,
            0.575
        ],
        "8594": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8595": [
            0.19444,
            0.69444,
            0,
            0,
            0.575
        ],
        "8596": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8597": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "8598": [
            0.19444,
            0.69444,
            0,
            0,
            1.14999
        ],
        "8599": [
            0.19444,
            0.69444,
            0,
            0,
            1.14999
        ],
        "8600": [
            0.19444,
            0.69444,
            0,
            0,
            1.14999
        ],
        "8601": [
            0.19444,
            0.69444,
            0,
            0,
            1.14999
        ],
        "8636": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8637": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8640": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8641": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8656": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8657": [
            0.19444,
            0.69444,
            0,
            0,
            0.70277
        ],
        "8658": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8659": [
            0.19444,
            0.69444,
            0,
            0,
            0.70277
        ],
        "8660": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8661": [
            0.25,
            0.75,
            0,
            0,
            0.70277
        ],
        "8704": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "8706": [
            0,
            0.69444,
            0.06389,
            0,
            0.62847
        ],
        "8707": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "8709": [
            0.05556,
            0.75,
            0,
            0,
            0.575
        ],
        "8711": [
            0,
            0.68611,
            0,
            0,
            0.95833
        ],
        "8712": [
            0.08556,
            0.58556,
            0,
            0,
            0.76666
        ],
        "8715": [
            0.08556,
            0.58556,
            0,
            0,
            0.76666
        ],
        "8722": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8723": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8725": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "8726": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "8727": [
            -0.02778,
            0.47222,
            0,
            0,
            0.575
        ],
        "8728": [
            -0.02639,
            0.47361,
            0,
            0,
            0.575
        ],
        "8729": [
            -0.02639,
            0.47361,
            0,
            0,
            0.575
        ],
        "8730": [
            0.18,
            0.82,
            0,
            0,
            0.95833
        ],
        "8733": [
            0,
            0.44444,
            0,
            0,
            0.89444
        ],
        "8734": [
            0,
            0.44444,
            0,
            0,
            1.14999
        ],
        "8736": [
            0,
            0.69224,
            0,
            0,
            0.72222
        ],
        "8739": [
            0.25,
            0.75,
            0,
            0,
            0.31944
        ],
        "8741": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "8743": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8744": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8745": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8746": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8747": [
            0.19444,
            0.69444,
            0.12778,
            0,
            0.56875
        ],
        "8764": [
            -0.10889,
            0.39111,
            0,
            0,
            0.89444
        ],
        "8768": [
            0.19444,
            0.69444,
            0,
            0,
            0.31944
        ],
        "8771": [
            0.00222,
            0.50222,
            0,
            0,
            0.89444
        ],
        "8773": [
            0.027,
            0.638,
            0,
            0,
            0.894
        ],
        "8776": [
            0.02444,
            0.52444,
            0,
            0,
            0.89444
        ],
        "8781": [
            0.00222,
            0.50222,
            0,
            0,
            0.89444
        ],
        "8801": [
            0.00222,
            0.50222,
            0,
            0,
            0.89444
        ],
        "8804": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "8805": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "8810": [
            0.08556,
            0.58556,
            0,
            0,
            1.14999
        ],
        "8811": [
            0.08556,
            0.58556,
            0,
            0,
            1.14999
        ],
        "8826": [
            0.08556,
            0.58556,
            0,
            0,
            0.89444
        ],
        "8827": [
            0.08556,
            0.58556,
            0,
            0,
            0.89444
        ],
        "8834": [
            0.08556,
            0.58556,
            0,
            0,
            0.89444
        ],
        "8835": [
            0.08556,
            0.58556,
            0,
            0,
            0.89444
        ],
        "8838": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "8839": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "8846": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8849": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "8850": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "8851": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8852": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8853": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8854": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8855": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8856": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8857": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8866": [
            0,
            0.69444,
            0,
            0,
            0.70277
        ],
        "8867": [
            0,
            0.69444,
            0,
            0,
            0.70277
        ],
        "8868": [
            0,
            0.69444,
            0,
            0,
            0.89444
        ],
        "8869": [
            0,
            0.69444,
            0,
            0,
            0.89444
        ],
        "8900": [
            -0.02639,
            0.47361,
            0,
            0,
            0.575
        ],
        "8901": [
            -0.02639,
            0.47361,
            0,
            0,
            0.31944
        ],
        "8902": [
            -0.02778,
            0.47222,
            0,
            0,
            0.575
        ],
        "8968": [
            0.25,
            0.75,
            0,
            0,
            0.51111
        ],
        "8969": [
            0.25,
            0.75,
            0,
            0,
            0.51111
        ],
        "8970": [
            0.25,
            0.75,
            0,
            0,
            0.51111
        ],
        "8971": [
            0.25,
            0.75,
            0,
            0,
            0.51111
        ],
        "8994": [
            -0.13889,
            0.36111,
            0,
            0,
            1.14999
        ],
        "8995": [
            -0.13889,
            0.36111,
            0,
            0,
            1.14999
        ],
        "9651": [
            0.19444,
            0.69444,
            0,
            0,
            1.02222
        ],
        "9657": [
            -0.02778,
            0.47222,
            0,
            0,
            0.575
        ],
        "9661": [
            0.19444,
            0.69444,
            0,
            0,
            1.02222
        ],
        "9667": [
            -0.02778,
            0.47222,
            0,
            0,
            0.575
        ],
        "9711": [
            0.19444,
            0.69444,
            0,
            0,
            1.14999
        ],
        "9824": [
            0.12963,
            0.69444,
            0,
            0,
            0.89444
        ],
        "9825": [
            0.12963,
            0.69444,
            0,
            0,
            0.89444
        ],
        "9826": [
            0.12963,
            0.69444,
            0,
            0,
            0.89444
        ],
        "9827": [
            0.12963,
            0.69444,
            0,
            0,
            0.89444
        ],
        "9837": [
            0,
            0.75,
            0,
            0,
            0.44722
        ],
        "9838": [
            0.19444,
            0.69444,
            0,
            0,
            0.44722
        ],
        "9839": [
            0.19444,
            0.69444,
            0,
            0,
            0.44722
        ],
        "10216": [
            0.25,
            0.75,
            0,
            0,
            0.44722
        ],
        "10217": [
            0.25,
            0.75,
            0,
            0,
            0.44722
        ],
        "10815": [
            0,
            0.68611,
            0,
            0,
            0.9
        ],
        "10927": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "10928": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "57376": [
            0.19444,
            0.69444,
            0,
            0,
            0
        ]
    },
    "Main-BoldItalic": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0.11417,
            0,
            0.38611
        ],
        "34": [
            0,
            0.69444,
            0.07939,
            0,
            0.62055
        ],
        "35": [
            0.19444,
            0.69444,
            0.06833,
            0,
            0.94444
        ],
        "37": [
            0.05556,
            0.75,
            0.12861,
            0,
            0.94444
        ],
        "38": [
            0,
            0.69444,
            0.08528,
            0,
            0.88555
        ],
        "39": [
            0,
            0.69444,
            0.12945,
            0,
            0.35555
        ],
        "40": [
            0.25,
            0.75,
            0.15806,
            0,
            0.47333
        ],
        "41": [
            0.25,
            0.75,
            0.03306,
            0,
            0.47333
        ],
        "42": [
            0,
            0.75,
            0.14333,
            0,
            0.59111
        ],
        "43": [
            0.10333,
            0.60333,
            0.03306,
            0,
            0.88555
        ],
        "44": [
            0.19444,
            0.14722,
            0,
            0,
            0.35555
        ],
        "45": [
            0,
            0.44444,
            0.02611,
            0,
            0.41444
        ],
        "46": [
            0,
            0.14722,
            0,
            0,
            0.35555
        ],
        "47": [
            0.25,
            0.75,
            0.15806,
            0,
            0.59111
        ],
        "48": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "49": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "50": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "51": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "52": [
            0.19444,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "53": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "54": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "55": [
            0.19444,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "56": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "57": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "58": [
            0,
            0.44444,
            0.06695,
            0,
            0.35555
        ],
        "59": [
            0.19444,
            0.44444,
            0.06695,
            0,
            0.35555
        ],
        "61": [
            -0.10889,
            0.39111,
            0.06833,
            0,
            0.88555
        ],
        "63": [
            0,
            0.69444,
            0.11472,
            0,
            0.59111
        ],
        "64": [
            0,
            0.69444,
            0.09208,
            0,
            0.88555
        ],
        "65": [
            0,
            0.68611,
            0,
            0,
            0.86555
        ],
        "66": [
            0,
            0.68611,
            0.0992,
            0,
            0.81666
        ],
        "67": [
            0,
            0.68611,
            0.14208,
            0,
            0.82666
        ],
        "68": [
            0,
            0.68611,
            0.09062,
            0,
            0.87555
        ],
        "69": [
            0,
            0.68611,
            0.11431,
            0,
            0.75666
        ],
        "70": [
            0,
            0.68611,
            0.12903,
            0,
            0.72722
        ],
        "71": [
            0,
            0.68611,
            0.07347,
            0,
            0.89527
        ],
        "72": [
            0,
            0.68611,
            0.17208,
            0,
            0.8961
        ],
        "73": [
            0,
            0.68611,
            0.15681,
            0,
            0.47166
        ],
        "74": [
            0,
            0.68611,
            0.145,
            0,
            0.61055
        ],
        "75": [
            0,
            0.68611,
            0.14208,
            0,
            0.89499
        ],
        "76": [
            0,
            0.68611,
            0,
            0,
            0.69777
        ],
        "77": [
            0,
            0.68611,
            0.17208,
            0,
            1.07277
        ],
        "78": [
            0,
            0.68611,
            0.17208,
            0,
            0.8961
        ],
        "79": [
            0,
            0.68611,
            0.09062,
            0,
            0.85499
        ],
        "80": [
            0,
            0.68611,
            0.0992,
            0,
            0.78721
        ],
        "81": [
            0.19444,
            0.68611,
            0.09062,
            0,
            0.85499
        ],
        "82": [
            0,
            0.68611,
            0.02559,
            0,
            0.85944
        ],
        "83": [
            0,
            0.68611,
            0.11264,
            0,
            0.64999
        ],
        "84": [
            0,
            0.68611,
            0.12903,
            0,
            0.7961
        ],
        "85": [
            0,
            0.68611,
            0.17208,
            0,
            0.88083
        ],
        "86": [
            0,
            0.68611,
            0.18625,
            0,
            0.86555
        ],
        "87": [
            0,
            0.68611,
            0.18625,
            0,
            1.15999
        ],
        "88": [
            0,
            0.68611,
            0.15681,
            0,
            0.86555
        ],
        "89": [
            0,
            0.68611,
            0.19803,
            0,
            0.86555
        ],
        "90": [
            0,
            0.68611,
            0.14208,
            0,
            0.70888
        ],
        "91": [
            0.25,
            0.75,
            0.1875,
            0,
            0.35611
        ],
        "93": [
            0.25,
            0.75,
            0.09972,
            0,
            0.35611
        ],
        "94": [
            0,
            0.69444,
            0.06709,
            0,
            0.59111
        ],
        "95": [
            0.31,
            0.13444,
            0.09811,
            0,
            0.59111
        ],
        "97": [
            0,
            0.44444,
            0.09426,
            0,
            0.59111
        ],
        "98": [
            0,
            0.69444,
            0.07861,
            0,
            0.53222
        ],
        "99": [
            0,
            0.44444,
            0.05222,
            0,
            0.53222
        ],
        "100": [
            0,
            0.69444,
            0.10861,
            0,
            0.59111
        ],
        "101": [
            0,
            0.44444,
            0.085,
            0,
            0.53222
        ],
        "102": [
            0.19444,
            0.69444,
            0.21778,
            0,
            0.4
        ],
        "103": [
            0.19444,
            0.44444,
            0.105,
            0,
            0.53222
        ],
        "104": [
            0,
            0.69444,
            0.09426,
            0,
            0.59111
        ],
        "105": [
            0,
            0.69326,
            0.11387,
            0,
            0.35555
        ],
        "106": [
            0.19444,
            0.69326,
            0.1672,
            0,
            0.35555
        ],
        "107": [
            0,
            0.69444,
            0.11111,
            0,
            0.53222
        ],
        "108": [
            0,
            0.69444,
            0.10861,
            0,
            0.29666
        ],
        "109": [
            0,
            0.44444,
            0.09426,
            0,
            0.94444
        ],
        "110": [
            0,
            0.44444,
            0.09426,
            0,
            0.64999
        ],
        "111": [
            0,
            0.44444,
            0.07861,
            0,
            0.59111
        ],
        "112": [
            0.19444,
            0.44444,
            0.07861,
            0,
            0.59111
        ],
        "113": [
            0.19444,
            0.44444,
            0.105,
            0,
            0.53222
        ],
        "114": [
            0,
            0.44444,
            0.11111,
            0,
            0.50167
        ],
        "115": [
            0,
            0.44444,
            0.08167,
            0,
            0.48694
        ],
        "116": [
            0,
            0.63492,
            0.09639,
            0,
            0.385
        ],
        "117": [
            0,
            0.44444,
            0.09426,
            0,
            0.62055
        ],
        "118": [
            0,
            0.44444,
            0.11111,
            0,
            0.53222
        ],
        "119": [
            0,
            0.44444,
            0.11111,
            0,
            0.76777
        ],
        "120": [
            0,
            0.44444,
            0.12583,
            0,
            0.56055
        ],
        "121": [
            0.19444,
            0.44444,
            0.105,
            0,
            0.56166
        ],
        "122": [
            0,
            0.44444,
            0.13889,
            0,
            0.49055
        ],
        "126": [
            0.35,
            0.34444,
            0.11472,
            0,
            0.59111
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "168": [
            0,
            0.69444,
            0.11473,
            0,
            0.59111
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.94888
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.53222
        ],
        "198": [
            0,
            0.68611,
            0.11431,
            0,
            1.02277
        ],
        "216": [
            0.04861,
            0.73472,
            0.09062,
            0,
            0.88555
        ],
        "223": [
            0.19444,
            0.69444,
            0.09736,
            0,
            0.665
        ],
        "230": [
            0,
            0.44444,
            0.085,
            0,
            0.82666
        ],
        "248": [
            0.09722,
            0.54167,
            0.09458,
            0,
            0.59111
        ],
        "305": [
            0,
            0.44444,
            0.09426,
            0,
            0.35555
        ],
        "338": [
            0,
            0.68611,
            0.11431,
            0,
            1.14054
        ],
        "339": [
            0,
            0.44444,
            0.085,
            0,
            0.82666
        ],
        "567": [
            0.19444,
            0.44444,
            0.04611,
            0,
            0.385
        ],
        "710": [
            0,
            0.69444,
            0.06709,
            0,
            0.59111
        ],
        "711": [
            0,
            0.63194,
            0.08271,
            0,
            0.59111
        ],
        "713": [
            0,
            0.59444,
            0.10444,
            0,
            0.59111
        ],
        "714": [
            0,
            0.69444,
            0.08528,
            0,
            0.59111
        ],
        "715": [
            0,
            0.69444,
            0,
            0,
            0.59111
        ],
        "728": [
            0,
            0.69444,
            0.10333,
            0,
            0.59111
        ],
        "729": [
            0,
            0.69444,
            0.12945,
            0,
            0.35555
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.94888
        ],
        "732": [
            0,
            0.69444,
            0.11472,
            0,
            0.59111
        ],
        "733": [
            0,
            0.69444,
            0.11472,
            0,
            0.59111
        ],
        "915": [
            0,
            0.68611,
            0.12903,
            0,
            0.69777
        ],
        "916": [
            0,
            0.68611,
            0,
            0,
            0.94444
        ],
        "920": [
            0,
            0.68611,
            0.09062,
            0,
            0.88555
        ],
        "923": [
            0,
            0.68611,
            0,
            0,
            0.80666
        ],
        "926": [
            0,
            0.68611,
            0.15092,
            0,
            0.76777
        ],
        "928": [
            0,
            0.68611,
            0.17208,
            0,
            0.8961
        ],
        "931": [
            0,
            0.68611,
            0.11431,
            0,
            0.82666
        ],
        "933": [
            0,
            0.68611,
            0.10778,
            0,
            0.88555
        ],
        "934": [
            0,
            0.68611,
            0.05632,
            0,
            0.82666
        ],
        "936": [
            0,
            0.68611,
            0.10778,
            0,
            0.88555
        ],
        "937": [
            0,
            0.68611,
            0.0992,
            0,
            0.82666
        ],
        "8211": [
            0,
            0.44444,
            0.09811,
            0,
            0.59111
        ],
        "8212": [
            0,
            0.44444,
            0.09811,
            0,
            1.18221
        ],
        "8216": [
            0,
            0.69444,
            0.12945,
            0,
            0.35555
        ],
        "8217": [
            0,
            0.69444,
            0.12945,
            0,
            0.35555
        ],
        "8220": [
            0,
            0.69444,
            0.16772,
            0,
            0.62055
        ],
        "8221": [
            0,
            0.69444,
            0.07939,
            0,
            0.62055
        ]
    },
    "Main-Italic": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0.12417,
            0,
            0.30667
        ],
        "34": [
            0,
            0.69444,
            0.06961,
            0,
            0.51444
        ],
        "35": [
            0.19444,
            0.69444,
            0.06616,
            0,
            0.81777
        ],
        "37": [
            0.05556,
            0.75,
            0.13639,
            0,
            0.81777
        ],
        "38": [
            0,
            0.69444,
            0.09694,
            0,
            0.76666
        ],
        "39": [
            0,
            0.69444,
            0.12417,
            0,
            0.30667
        ],
        "40": [
            0.25,
            0.75,
            0.16194,
            0,
            0.40889
        ],
        "41": [
            0.25,
            0.75,
            0.03694,
            0,
            0.40889
        ],
        "42": [
            0,
            0.75,
            0.14917,
            0,
            0.51111
        ],
        "43": [
            0.05667,
            0.56167,
            0.03694,
            0,
            0.76666
        ],
        "44": [
            0.19444,
            0.10556,
            0,
            0,
            0.30667
        ],
        "45": [
            0,
            0.43056,
            0.02826,
            0,
            0.35778
        ],
        "46": [
            0,
            0.10556,
            0,
            0,
            0.30667
        ],
        "47": [
            0.25,
            0.75,
            0.16194,
            0,
            0.51111
        ],
        "48": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "49": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "50": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "51": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "52": [
            0.19444,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "53": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "54": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "55": [
            0.19444,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "56": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "57": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "58": [
            0,
            0.43056,
            0.0582,
            0,
            0.30667
        ],
        "59": [
            0.19444,
            0.43056,
            0.0582,
            0,
            0.30667
        ],
        "61": [
            -0.13313,
            0.36687,
            0.06616,
            0,
            0.76666
        ],
        "63": [
            0,
            0.69444,
            0.1225,
            0,
            0.51111
        ],
        "64": [
            0,
            0.69444,
            0.09597,
            0,
            0.76666
        ],
        "65": [
            0,
            0.68333,
            0,
            0,
            0.74333
        ],
        "66": [
            0,
            0.68333,
            0.10257,
            0,
            0.70389
        ],
        "67": [
            0,
            0.68333,
            0.14528,
            0,
            0.71555
        ],
        "68": [
            0,
            0.68333,
            0.09403,
            0,
            0.755
        ],
        "69": [
            0,
            0.68333,
            0.12028,
            0,
            0.67833
        ],
        "70": [
            0,
            0.68333,
            0.13305,
            0,
            0.65277
        ],
        "71": [
            0,
            0.68333,
            0.08722,
            0,
            0.77361
        ],
        "72": [
            0,
            0.68333,
            0.16389,
            0,
            0.74333
        ],
        "73": [
            0,
            0.68333,
            0.15806,
            0,
            0.38555
        ],
        "74": [
            0,
            0.68333,
            0.14028,
            0,
            0.525
        ],
        "75": [
            0,
            0.68333,
            0.14528,
            0,
            0.76888
        ],
        "76": [
            0,
            0.68333,
            0,
            0,
            0.62722
        ],
        "77": [
            0,
            0.68333,
            0.16389,
            0,
            0.89666
        ],
        "78": [
            0,
            0.68333,
            0.16389,
            0,
            0.74333
        ],
        "79": [
            0,
            0.68333,
            0.09403,
            0,
            0.76666
        ],
        "80": [
            0,
            0.68333,
            0.10257,
            0,
            0.67833
        ],
        "81": [
            0.19444,
            0.68333,
            0.09403,
            0,
            0.76666
        ],
        "82": [
            0,
            0.68333,
            0.03868,
            0,
            0.72944
        ],
        "83": [
            0,
            0.68333,
            0.11972,
            0,
            0.56222
        ],
        "84": [
            0,
            0.68333,
            0.13305,
            0,
            0.71555
        ],
        "85": [
            0,
            0.68333,
            0.16389,
            0,
            0.74333
        ],
        "86": [
            0,
            0.68333,
            0.18361,
            0,
            0.74333
        ],
        "87": [
            0,
            0.68333,
            0.18361,
            0,
            0.99888
        ],
        "88": [
            0,
            0.68333,
            0.15806,
            0,
            0.74333
        ],
        "89": [
            0,
            0.68333,
            0.19383,
            0,
            0.74333
        ],
        "90": [
            0,
            0.68333,
            0.14528,
            0,
            0.61333
        ],
        "91": [
            0.25,
            0.75,
            0.1875,
            0,
            0.30667
        ],
        "93": [
            0.25,
            0.75,
            0.10528,
            0,
            0.30667
        ],
        "94": [
            0,
            0.69444,
            0.06646,
            0,
            0.51111
        ],
        "95": [
            0.31,
            0.12056,
            0.09208,
            0,
            0.51111
        ],
        "97": [
            0,
            0.43056,
            0.07671,
            0,
            0.51111
        ],
        "98": [
            0,
            0.69444,
            0.06312,
            0,
            0.46
        ],
        "99": [
            0,
            0.43056,
            0.05653,
            0,
            0.46
        ],
        "100": [
            0,
            0.69444,
            0.10333,
            0,
            0.51111
        ],
        "101": [
            0,
            0.43056,
            0.07514,
            0,
            0.46
        ],
        "102": [
            0.19444,
            0.69444,
            0.21194,
            0,
            0.30667
        ],
        "103": [
            0.19444,
            0.43056,
            0.08847,
            0,
            0.46
        ],
        "104": [
            0,
            0.69444,
            0.07671,
            0,
            0.51111
        ],
        "105": [
            0,
            0.65536,
            0.1019,
            0,
            0.30667
        ],
        "106": [
            0.19444,
            0.65536,
            0.14467,
            0,
            0.30667
        ],
        "107": [
            0,
            0.69444,
            0.10764,
            0,
            0.46
        ],
        "108": [
            0,
            0.69444,
            0.10333,
            0,
            0.25555
        ],
        "109": [
            0,
            0.43056,
            0.07671,
            0,
            0.81777
        ],
        "110": [
            0,
            0.43056,
            0.07671,
            0,
            0.56222
        ],
        "111": [
            0,
            0.43056,
            0.06312,
            0,
            0.51111
        ],
        "112": [
            0.19444,
            0.43056,
            0.06312,
            0,
            0.51111
        ],
        "113": [
            0.19444,
            0.43056,
            0.08847,
            0,
            0.46
        ],
        "114": [
            0,
            0.43056,
            0.10764,
            0,
            0.42166
        ],
        "115": [
            0,
            0.43056,
            0.08208,
            0,
            0.40889
        ],
        "116": [
            0,
            0.61508,
            0.09486,
            0,
            0.33222
        ],
        "117": [
            0,
            0.43056,
            0.07671,
            0,
            0.53666
        ],
        "118": [
            0,
            0.43056,
            0.10764,
            0,
            0.46
        ],
        "119": [
            0,
            0.43056,
            0.10764,
            0,
            0.66444
        ],
        "120": [
            0,
            0.43056,
            0.12042,
            0,
            0.46389
        ],
        "121": [
            0.19444,
            0.43056,
            0.08847,
            0,
            0.48555
        ],
        "122": [
            0,
            0.43056,
            0.12292,
            0,
            0.40889
        ],
        "126": [
            0.35,
            0.31786,
            0.11585,
            0,
            0.51111
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "168": [
            0,
            0.66786,
            0.10474,
            0,
            0.51111
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.83129
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.46
        ],
        "198": [
            0,
            0.68333,
            0.12028,
            0,
            0.88277
        ],
        "216": [
            0.04861,
            0.73194,
            0.09403,
            0,
            0.76666
        ],
        "223": [
            0.19444,
            0.69444,
            0.10514,
            0,
            0.53666
        ],
        "230": [
            0,
            0.43056,
            0.07514,
            0,
            0.71555
        ],
        "248": [
            0.09722,
            0.52778,
            0.09194,
            0,
            0.51111
        ],
        "338": [
            0,
            0.68333,
            0.12028,
            0,
            0.98499
        ],
        "339": [
            0,
            0.43056,
            0.07514,
            0,
            0.71555
        ],
        "710": [
            0,
            0.69444,
            0.06646,
            0,
            0.51111
        ],
        "711": [
            0,
            0.62847,
            0.08295,
            0,
            0.51111
        ],
        "713": [
            0,
            0.56167,
            0.10333,
            0,
            0.51111
        ],
        "714": [
            0,
            0.69444,
            0.09694,
            0,
            0.51111
        ],
        "715": [
            0,
            0.69444,
            0,
            0,
            0.51111
        ],
        "728": [
            0,
            0.69444,
            0.10806,
            0,
            0.51111
        ],
        "729": [
            0,
            0.66786,
            0.11752,
            0,
            0.30667
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.83129
        ],
        "732": [
            0,
            0.66786,
            0.11585,
            0,
            0.51111
        ],
        "733": [
            0,
            0.69444,
            0.1225,
            0,
            0.51111
        ],
        "915": [
            0,
            0.68333,
            0.13305,
            0,
            0.62722
        ],
        "916": [
            0,
            0.68333,
            0,
            0,
            0.81777
        ],
        "920": [
            0,
            0.68333,
            0.09403,
            0,
            0.76666
        ],
        "923": [
            0,
            0.68333,
            0,
            0,
            0.69222
        ],
        "926": [
            0,
            0.68333,
            0.15294,
            0,
            0.66444
        ],
        "928": [
            0,
            0.68333,
            0.16389,
            0,
            0.74333
        ],
        "931": [
            0,
            0.68333,
            0.12028,
            0,
            0.71555
        ],
        "933": [
            0,
            0.68333,
            0.11111,
            0,
            0.76666
        ],
        "934": [
            0,
            0.68333,
            0.05986,
            0,
            0.71555
        ],
        "936": [
            0,
            0.68333,
            0.11111,
            0,
            0.76666
        ],
        "937": [
            0,
            0.68333,
            0.10257,
            0,
            0.71555
        ],
        "8211": [
            0,
            0.43056,
            0.09208,
            0,
            0.51111
        ],
        "8212": [
            0,
            0.43056,
            0.09208,
            0,
            1.02222
        ],
        "8216": [
            0,
            0.69444,
            0.12417,
            0,
            0.30667
        ],
        "8217": [
            0,
            0.69444,
            0.12417,
            0,
            0.30667
        ],
        "8220": [
            0,
            0.69444,
            0.1685,
            0,
            0.51444
        ],
        "8221": [
            0,
            0.69444,
            0.06961,
            0,
            0.51444
        ],
        "8463": [
            0,
            0.68889,
            0,
            0,
            0.54028
        ]
    },
    "Main-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "34": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "35": [
            0.19444,
            0.69444,
            0,
            0,
            0.83334
        ],
        "36": [
            0.05556,
            0.75,
            0,
            0,
            0.5
        ],
        "37": [
            0.05556,
            0.75,
            0,
            0,
            0.83334
        ],
        "38": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "39": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "40": [
            0.25,
            0.75,
            0,
            0,
            0.38889
        ],
        "41": [
            0.25,
            0.75,
            0,
            0,
            0.38889
        ],
        "42": [
            0,
            0.75,
            0,
            0,
            0.5
        ],
        "43": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "44": [
            0.19444,
            0.10556,
            0,
            0,
            0.27778
        ],
        "45": [
            0,
            0.43056,
            0,
            0,
            0.33333
        ],
        "46": [
            0,
            0.10556,
            0,
            0,
            0.27778
        ],
        "47": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "48": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "49": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "50": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "51": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "52": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "53": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "54": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "55": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "56": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "57": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "58": [
            0,
            0.43056,
            0,
            0,
            0.27778
        ],
        "59": [
            0.19444,
            0.43056,
            0,
            0,
            0.27778
        ],
        "60": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "61": [
            -0.13313,
            0.36687,
            0,
            0,
            0.77778
        ],
        "62": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "63": [
            0,
            0.69444,
            0,
            0,
            0.47222
        ],
        "64": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "65": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "66": [
            0,
            0.68333,
            0,
            0,
            0.70834
        ],
        "67": [
            0,
            0.68333,
            0,
            0,
            0.72222
        ],
        "68": [
            0,
            0.68333,
            0,
            0,
            0.76389
        ],
        "69": [
            0,
            0.68333,
            0,
            0,
            0.68056
        ],
        "70": [
            0,
            0.68333,
            0,
            0,
            0.65278
        ],
        "71": [
            0,
            0.68333,
            0,
            0,
            0.78472
        ],
        "72": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "73": [
            0,
            0.68333,
            0,
            0,
            0.36111
        ],
        "74": [
            0,
            0.68333,
            0,
            0,
            0.51389
        ],
        "75": [
            0,
            0.68333,
            0,
            0,
            0.77778
        ],
        "76": [
            0,
            0.68333,
            0,
            0,
            0.625
        ],
        "77": [
            0,
            0.68333,
            0,
            0,
            0.91667
        ],
        "78": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "79": [
            0,
            0.68333,
            0,
            0,
            0.77778
        ],
        "80": [
            0,
            0.68333,
            0,
            0,
            0.68056
        ],
        "81": [
            0.19444,
            0.68333,
            0,
            0,
            0.77778
        ],
        "82": [
            0,
            0.68333,
            0,
            0,
            0.73611
        ],
        "83": [
            0,
            0.68333,
            0,
            0,
            0.55556
        ],
        "84": [
            0,
            0.68333,
            0,
            0,
            0.72222
        ],
        "85": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "86": [
            0,
            0.68333,
            0.01389,
            0,
            0.75
        ],
        "87": [
            0,
            0.68333,
            0.01389,
            0,
            1.02778
        ],
        "88": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "89": [
            0,
            0.68333,
            0.025,
            0,
            0.75
        ],
        "90": [
            0,
            0.68333,
            0,
            0,
            0.61111
        ],
        "91": [
            0.25,
            0.75,
            0,
            0,
            0.27778
        ],
        "92": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "93": [
            0.25,
            0.75,
            0,
            0,
            0.27778
        ],
        "94": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "95": [
            0.31,
            0.12056,
            0.02778,
            0,
            0.5
        ],
        "97": [
            0,
            0.43056,
            0,
            0,
            0.5
        ],
        "98": [
            0,
            0.69444,
            0,
            0,
            0.55556
        ],
        "99": [
            0,
            0.43056,
            0,
            0,
            0.44445
        ],
        "100": [
            0,
            0.69444,
            0,
            0,
            0.55556
        ],
        "101": [
            0,
            0.43056,
            0,
            0,
            0.44445
        ],
        "102": [
            0,
            0.69444,
            0.07778,
            0,
            0.30556
        ],
        "103": [
            0.19444,
            0.43056,
            0.01389,
            0,
            0.5
        ],
        "104": [
            0,
            0.69444,
            0,
            0,
            0.55556
        ],
        "105": [
            0,
            0.66786,
            0,
            0,
            0.27778
        ],
        "106": [
            0.19444,
            0.66786,
            0,
            0,
            0.30556
        ],
        "107": [
            0,
            0.69444,
            0,
            0,
            0.52778
        ],
        "108": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "109": [
            0,
            0.43056,
            0,
            0,
            0.83334
        ],
        "110": [
            0,
            0.43056,
            0,
            0,
            0.55556
        ],
        "111": [
            0,
            0.43056,
            0,
            0,
            0.5
        ],
        "112": [
            0.19444,
            0.43056,
            0,
            0,
            0.55556
        ],
        "113": [
            0.19444,
            0.43056,
            0,
            0,
            0.52778
        ],
        "114": [
            0,
            0.43056,
            0,
            0,
            0.39167
        ],
        "115": [
            0,
            0.43056,
            0,
            0,
            0.39445
        ],
        "116": [
            0,
            0.61508,
            0,
            0,
            0.38889
        ],
        "117": [
            0,
            0.43056,
            0,
            0,
            0.55556
        ],
        "118": [
            0,
            0.43056,
            0.01389,
            0,
            0.52778
        ],
        "119": [
            0,
            0.43056,
            0.01389,
            0,
            0.72222
        ],
        "120": [
            0,
            0.43056,
            0,
            0,
            0.52778
        ],
        "121": [
            0.19444,
            0.43056,
            0.01389,
            0,
            0.52778
        ],
        "122": [
            0,
            0.43056,
            0,
            0,
            0.44445
        ],
        "123": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "124": [
            0.25,
            0.75,
            0,
            0,
            0.27778
        ],
        "125": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "126": [
            0.35,
            0.31786,
            0,
            0,
            0.5
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "163": [
            0,
            0.69444,
            0,
            0,
            0.76909
        ],
        "167": [
            0.19444,
            0.69444,
            0,
            0,
            0.44445
        ],
        "168": [
            0,
            0.66786,
            0,
            0,
            0.5
        ],
        "172": [
            0,
            0.43056,
            0,
            0,
            0.66667
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.75
        ],
        "177": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "182": [
            0.19444,
            0.69444,
            0,
            0,
            0.61111
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.44445
        ],
        "198": [
            0,
            0.68333,
            0,
            0,
            0.90278
        ],
        "215": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "216": [
            0.04861,
            0.73194,
            0,
            0,
            0.77778
        ],
        "223": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "230": [
            0,
            0.43056,
            0,
            0,
            0.72222
        ],
        "247": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "248": [
            0.09722,
            0.52778,
            0,
            0,
            0.5
        ],
        "305": [
            0,
            0.43056,
            0,
            0,
            0.27778
        ],
        "338": [
            0,
            0.68333,
            0,
            0,
            1.01389
        ],
        "339": [
            0,
            0.43056,
            0,
            0,
            0.77778
        ],
        "567": [
            0.19444,
            0.43056,
            0,
            0,
            0.30556
        ],
        "710": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "711": [
            0,
            0.62847,
            0,
            0,
            0.5
        ],
        "713": [
            0,
            0.56778,
            0,
            0,
            0.5
        ],
        "714": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "715": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "728": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "729": [
            0,
            0.66786,
            0,
            0,
            0.27778
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.75
        ],
        "732": [
            0,
            0.66786,
            0,
            0,
            0.5
        ],
        "733": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "915": [
            0,
            0.68333,
            0,
            0,
            0.625
        ],
        "916": [
            0,
            0.68333,
            0,
            0,
            0.83334
        ],
        "920": [
            0,
            0.68333,
            0,
            0,
            0.77778
        ],
        "923": [
            0,
            0.68333,
            0,
            0,
            0.69445
        ],
        "926": [
            0,
            0.68333,
            0,
            0,
            0.66667
        ],
        "928": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "931": [
            0,
            0.68333,
            0,
            0,
            0.72222
        ],
        "933": [
            0,
            0.68333,
            0,
            0,
            0.77778
        ],
        "934": [
            0,
            0.68333,
            0,
            0,
            0.72222
        ],
        "936": [
            0,
            0.68333,
            0,
            0,
            0.77778
        ],
        "937": [
            0,
            0.68333,
            0,
            0,
            0.72222
        ],
        "8211": [
            0,
            0.43056,
            0.02778,
            0,
            0.5
        ],
        "8212": [
            0,
            0.43056,
            0.02778,
            0,
            1.0
        ],
        "8216": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "8217": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "8220": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "8221": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "8224": [
            0.19444,
            0.69444,
            0,
            0,
            0.44445
        ],
        "8225": [
            0.19444,
            0.69444,
            0,
            0,
            0.44445
        ],
        "8230": [
            0,
            0.123,
            0,
            0,
            1.172
        ],
        "8242": [
            0,
            0.55556,
            0,
            0,
            0.275
        ],
        "8407": [
            0,
            0.71444,
            0.15382,
            0,
            0.5
        ],
        "8463": [
            0,
            0.68889,
            0,
            0,
            0.54028
        ],
        "8465": [
            0,
            0.69444,
            0,
            0,
            0.72222
        ],
        "8467": [
            0,
            0.69444,
            0,
            0.11111,
            0.41667
        ],
        "8472": [
            0.19444,
            0.43056,
            0,
            0.11111,
            0.63646
        ],
        "8476": [
            0,
            0.69444,
            0,
            0,
            0.72222
        ],
        "8501": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "8592": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8593": [
            0.19444,
            0.69444,
            0,
            0,
            0.5
        ],
        "8594": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8595": [
            0.19444,
            0.69444,
            0,
            0,
            0.5
        ],
        "8596": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8597": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "8598": [
            0.19444,
            0.69444,
            0,
            0,
            1.0
        ],
        "8599": [
            0.19444,
            0.69444,
            0,
            0,
            1.0
        ],
        "8600": [
            0.19444,
            0.69444,
            0,
            0,
            1.0
        ],
        "8601": [
            0.19444,
            0.69444,
            0,
            0,
            1.0
        ],
        "8614": [
            0.011,
            0.511,
            0,
            0,
            1.0
        ],
        "8617": [
            0.011,
            0.511,
            0,
            0,
            1.126
        ],
        "8618": [
            0.011,
            0.511,
            0,
            0,
            1.126
        ],
        "8636": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8637": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8640": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8641": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8652": [
            0.011,
            0.671,
            0,
            0,
            1.0
        ],
        "8656": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8657": [
            0.19444,
            0.69444,
            0,
            0,
            0.61111
        ],
        "8658": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8659": [
            0.19444,
            0.69444,
            0,
            0,
            0.61111
        ],
        "8660": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8661": [
            0.25,
            0.75,
            0,
            0,
            0.61111
        ],
        "8704": [
            0,
            0.69444,
            0,
            0,
            0.55556
        ],
        "8706": [
            0,
            0.69444,
            0.05556,
            0.08334,
            0.5309
        ],
        "8707": [
            0,
            0.69444,
            0,
            0,
            0.55556
        ],
        "8709": [
            0.05556,
            0.75,
            0,
            0,
            0.5
        ],
        "8711": [
            0,
            0.68333,
            0,
            0,
            0.83334
        ],
        "8712": [
            0.0391,
            0.5391,
            0,
            0,
            0.66667
        ],
        "8715": [
            0.0391,
            0.5391,
            0,
            0,
            0.66667
        ],
        "8722": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8723": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8725": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "8726": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "8727": [
            -0.03472,
            0.46528,
            0,
            0,
            0.5
        ],
        "8728": [
            -0.05555,
            0.44445,
            0,
            0,
            0.5
        ],
        "8729": [
            -0.05555,
            0.44445,
            0,
            0,
            0.5
        ],
        "8730": [
            0.2,
            0.8,
            0,
            0,
            0.83334
        ],
        "8733": [
            0,
            0.43056,
            0,
            0,
            0.77778
        ],
        "8734": [
            0,
            0.43056,
            0,
            0,
            1.0
        ],
        "8736": [
            0,
            0.69224,
            0,
            0,
            0.72222
        ],
        "8739": [
            0.25,
            0.75,
            0,
            0,
            0.27778
        ],
        "8741": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "8743": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8744": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8745": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8746": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8747": [
            0.19444,
            0.69444,
            0.11111,
            0,
            0.41667
        ],
        "8764": [
            -0.13313,
            0.36687,
            0,
            0,
            0.77778
        ],
        "8768": [
            0.19444,
            0.69444,
            0,
            0,
            0.27778
        ],
        "8771": [
            -0.03625,
            0.46375,
            0,
            0,
            0.77778
        ],
        "8773": [
            -0.022,
            0.589,
            0,
            0,
            0.778
        ],
        "8776": [
            -0.01688,
            0.48312,
            0,
            0,
            0.77778
        ],
        "8781": [
            -0.03625,
            0.46375,
            0,
            0,
            0.77778
        ],
        "8784": [
            -0.133,
            0.673,
            0,
            0,
            0.778
        ],
        "8801": [
            -0.03625,
            0.46375,
            0,
            0,
            0.77778
        ],
        "8804": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8805": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8810": [
            0.0391,
            0.5391,
            0,
            0,
            1.0
        ],
        "8811": [
            0.0391,
            0.5391,
            0,
            0,
            1.0
        ],
        "8826": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "8827": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "8834": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "8835": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "8838": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8839": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8846": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8849": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8850": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8851": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8852": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8853": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8854": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8855": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8856": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8857": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8866": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "8867": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "8868": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "8869": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "8872": [
            0.249,
            0.75,
            0,
            0,
            0.867
        ],
        "8900": [
            -0.05555,
            0.44445,
            0,
            0,
            0.5
        ],
        "8901": [
            -0.05555,
            0.44445,
            0,
            0,
            0.27778
        ],
        "8902": [
            -0.03472,
            0.46528,
            0,
            0,
            0.5
        ],
        "8904": [
            0.005,
            0.505,
            0,
            0,
            0.9
        ],
        "8942": [
            0.03,
            0.903,
            0,
            0,
            0.278
        ],
        "8943": [
            -0.19,
            0.313,
            0,
            0,
            1.172
        ],
        "8945": [
            -0.1,
            0.823,
            0,
            0,
            1.282
        ],
        "8968": [
            0.25,
            0.75,
            0,
            0,
            0.44445
        ],
        "8969": [
            0.25,
            0.75,
            0,
            0,
            0.44445
        ],
        "8970": [
            0.25,
            0.75,
            0,
            0,
            0.44445
        ],
        "8971": [
            0.25,
            0.75,
            0,
            0,
            0.44445
        ],
        "8994": [
            -0.14236,
            0.35764,
            0,
            0,
            1.0
        ],
        "8995": [
            -0.14236,
            0.35764,
            0,
            0,
            1.0
        ],
        "9136": [
            0.244,
            0.744,
            0,
            0,
            0.412
        ],
        "9137": [
            0.244,
            0.745,
            0,
            0,
            0.412
        ],
        "9651": [
            0.19444,
            0.69444,
            0,
            0,
            0.88889
        ],
        "9657": [
            -0.03472,
            0.46528,
            0,
            0,
            0.5
        ],
        "9661": [
            0.19444,
            0.69444,
            0,
            0,
            0.88889
        ],
        "9667": [
            -0.03472,
            0.46528,
            0,
            0,
            0.5
        ],
        "9711": [
            0.19444,
            0.69444,
            0,
            0,
            1.0
        ],
        "9824": [
            0.12963,
            0.69444,
            0,
            0,
            0.77778
        ],
        "9825": [
            0.12963,
            0.69444,
            0,
            0,
            0.77778
        ],
        "9826": [
            0.12963,
            0.69444,
            0,
            0,
            0.77778
        ],
        "9827": [
            0.12963,
            0.69444,
            0,
            0,
            0.77778
        ],
        "9837": [
            0,
            0.75,
            0,
            0,
            0.38889
        ],
        "9838": [
            0.19444,
            0.69444,
            0,
            0,
            0.38889
        ],
        "9839": [
            0.19444,
            0.69444,
            0,
            0,
            0.38889
        ],
        "10216": [
            0.25,
            0.75,
            0,
            0,
            0.38889
        ],
        "10217": [
            0.25,
            0.75,
            0,
            0,
            0.38889
        ],
        "10222": [
            0.244,
            0.744,
            0,
            0,
            0.412
        ],
        "10223": [
            0.244,
            0.745,
            0,
            0,
            0.412
        ],
        "10229": [
            0.011,
            0.511,
            0,
            0,
            1.609
        ],
        "10230": [
            0.011,
            0.511,
            0,
            0,
            1.638
        ],
        "10231": [
            0.011,
            0.511,
            0,
            0,
            1.859
        ],
        "10232": [
            0.024,
            0.525,
            0,
            0,
            1.609
        ],
        "10233": [
            0.024,
            0.525,
            0,
            0,
            1.638
        ],
        "10234": [
            0.024,
            0.525,
            0,
            0,
            1.858
        ],
        "10236": [
            0.011,
            0.511,
            0,
            0,
            1.638
        ],
        "10815": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "10927": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "10928": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "57376": [
            0.19444,
            0.69444,
            0,
            0,
            0
        ]
    },
    "Math-BoldItalic": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "48": [
            0,
            0.44444,
            0,
            0,
            0.575
        ],
        "49": [
            0,
            0.44444,
            0,
            0,
            0.575
        ],
        "50": [
            0,
            0.44444,
            0,
            0,
            0.575
        ],
        "51": [
            0.19444,
            0.44444,
            0,
            0,
            0.575
        ],
        "52": [
            0.19444,
            0.44444,
            0,
            0,
            0.575
        ],
        "53": [
            0.19444,
            0.44444,
            0,
            0,
            0.575
        ],
        "54": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "55": [
            0.19444,
            0.44444,
            0,
            0,
            0.575
        ],
        "56": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "57": [
            0.19444,
            0.44444,
            0,
            0,
            0.575
        ],
        "65": [
            0,
            0.68611,
            0,
            0,
            0.86944
        ],
        "66": [
            0,
            0.68611,
            0.04835,
            0,
            0.8664
        ],
        "67": [
            0,
            0.68611,
            0.06979,
            0,
            0.81694
        ],
        "68": [
            0,
            0.68611,
            0.03194,
            0,
            0.93812
        ],
        "69": [
            0,
            0.68611,
            0.05451,
            0,
            0.81007
        ],
        "70": [
            0,
            0.68611,
            0.15972,
            0,
            0.68889
        ],
        "71": [
            0,
            0.68611,
            0,
            0,
            0.88673
        ],
        "72": [
            0,
            0.68611,
            0.08229,
            0,
            0.98229
        ],
        "73": [
            0,
            0.68611,
            0.07778,
            0,
            0.51111
        ],
        "74": [
            0,
            0.68611,
            0.10069,
            0,
            0.63125
        ],
        "75": [
            0,
            0.68611,
            0.06979,
            0,
            0.97118
        ],
        "76": [
            0,
            0.68611,
            0,
            0,
            0.75555
        ],
        "77": [
            0,
            0.68611,
            0.11424,
            0,
            1.14201
        ],
        "78": [
            0,
            0.68611,
            0.11424,
            0,
            0.95034
        ],
        "79": [
            0,
            0.68611,
            0.03194,
            0,
            0.83666
        ],
        "80": [
            0,
            0.68611,
            0.15972,
            0,
            0.72309
        ],
        "81": [
            0.19444,
            0.68611,
            0,
            0,
            0.86861
        ],
        "82": [
            0,
            0.68611,
            0.00421,
            0,
            0.87235
        ],
        "83": [
            0,
            0.68611,
            0.05382,
            0,
            0.69271
        ],
        "84": [
            0,
            0.68611,
            0.15972,
            0,
            0.63663
        ],
        "85": [
            0,
            0.68611,
            0.11424,
            0,
            0.80027
        ],
        "86": [
            0,
            0.68611,
            0.25555,
            0,
            0.67778
        ],
        "87": [
            0,
            0.68611,
            0.15972,
            0,
            1.09305
        ],
        "88": [
            0,
            0.68611,
            0.07778,
            0,
            0.94722
        ],
        "89": [
            0,
            0.68611,
            0.25555,
            0,
            0.67458
        ],
        "90": [
            0,
            0.68611,
            0.06979,
            0,
            0.77257
        ],
        "97": [
            0,
            0.44444,
            0,
            0,
            0.63287
        ],
        "98": [
            0,
            0.69444,
            0,
            0,
            0.52083
        ],
        "99": [
            0,
            0.44444,
            0,
            0,
            0.51342
        ],
        "100": [
            0,
            0.69444,
            0,
            0,
            0.60972
        ],
        "101": [
            0,
            0.44444,
            0,
            0,
            0.55361
        ],
        "102": [
            0.19444,
            0.69444,
            0.11042,
            0,
            0.56806
        ],
        "103": [
            0.19444,
            0.44444,
            0.03704,
            0,
            0.5449
        ],
        "104": [
            0,
            0.69444,
            0,
            0,
            0.66759
        ],
        "105": [
            0,
            0.69326,
            0,
            0,
            0.4048
        ],
        "106": [
            0.19444,
            0.69326,
            0.0622,
            0,
            0.47083
        ],
        "107": [
            0,
            0.69444,
            0.01852,
            0,
            0.6037
        ],
        "108": [
            0,
            0.69444,
            0.0088,
            0,
            0.34815
        ],
        "109": [
            0,
            0.44444,
            0,
            0,
            1.0324
        ],
        "110": [
            0,
            0.44444,
            0,
            0,
            0.71296
        ],
        "111": [
            0,
            0.44444,
            0,
            0,
            0.58472
        ],
        "112": [
            0.19444,
            0.44444,
            0,
            0,
            0.60092
        ],
        "113": [
            0.19444,
            0.44444,
            0.03704,
            0,
            0.54213
        ],
        "114": [
            0,
            0.44444,
            0.03194,
            0,
            0.5287
        ],
        "115": [
            0,
            0.44444,
            0,
            0,
            0.53125
        ],
        "116": [
            0,
            0.63492,
            0,
            0,
            0.41528
        ],
        "117": [
            0,
            0.44444,
            0,
            0,
            0.68102
        ],
        "118": [
            0,
            0.44444,
            0.03704,
            0,
            0.56666
        ],
        "119": [
            0,
            0.44444,
            0.02778,
            0,
            0.83148
        ],
        "120": [
            0,
            0.44444,
            0,
            0,
            0.65903
        ],
        "121": [
            0.19444,
            0.44444,
            0.03704,
            0,
            0.59028
        ],
        "122": [
            0,
            0.44444,
            0.04213,
            0,
            0.55509
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "915": [
            0,
            0.68611,
            0.15972,
            0,
            0.65694
        ],
        "916": [
            0,
            0.68611,
            0,
            0,
            0.95833
        ],
        "920": [
            0,
            0.68611,
            0.03194,
            0,
            0.86722
        ],
        "923": [
            0,
            0.68611,
            0,
            0,
            0.80555
        ],
        "926": [
            0,
            0.68611,
            0.07458,
            0,
            0.84125
        ],
        "928": [
            0,
            0.68611,
            0.08229,
            0,
            0.98229
        ],
        "931": [
            0,
            0.68611,
            0.05451,
            0,
            0.88507
        ],
        "933": [
            0,
            0.68611,
            0.15972,
            0,
            0.67083
        ],
        "934": [
            0,
            0.68611,
            0,
            0,
            0.76666
        ],
        "936": [
            0,
            0.68611,
            0.11653,
            0,
            0.71402
        ],
        "937": [
            0,
            0.68611,
            0.04835,
            0,
            0.8789
        ],
        "945": [
            0,
            0.44444,
            0,
            0,
            0.76064
        ],
        "946": [
            0.19444,
            0.69444,
            0.03403,
            0,
            0.65972
        ],
        "947": [
            0.19444,
            0.44444,
            0.06389,
            0,
            0.59003
        ],
        "948": [
            0,
            0.69444,
            0.03819,
            0,
            0.52222
        ],
        "949": [
            0,
            0.44444,
            0,
            0,
            0.52882
        ],
        "950": [
            0.19444,
            0.69444,
            0.06215,
            0,
            0.50833
        ],
        "951": [
            0.19444,
            0.44444,
            0.03704,
            0,
            0.6
        ],
        "952": [
            0,
            0.69444,
            0.03194,
            0,
            0.5618
        ],
        "953": [
            0,
            0.44444,
            0,
            0,
            0.41204
        ],
        "954": [
            0,
            0.44444,
            0,
            0,
            0.66759
        ],
        "955": [
            0,
            0.69444,
            0,
            0,
            0.67083
        ],
        "956": [
            0.19444,
            0.44444,
            0,
            0,
            0.70787
        ],
        "957": [
            0,
            0.44444,
            0.06898,
            0,
            0.57685
        ],
        "958": [
            0.19444,
            0.69444,
            0.03021,
            0,
            0.50833
        ],
        "959": [
            0,
            0.44444,
            0,
            0,
            0.58472
        ],
        "960": [
            0,
            0.44444,
            0.03704,
            0,
            0.68241
        ],
        "961": [
            0.19444,
            0.44444,
            0,
            0,
            0.6118
        ],
        "962": [
            0.09722,
            0.44444,
            0.07917,
            0,
            0.42361
        ],
        "963": [
            0,
            0.44444,
            0.03704,
            0,
            0.68588
        ],
        "964": [
            0,
            0.44444,
            0.13472,
            0,
            0.52083
        ],
        "965": [
            0,
            0.44444,
            0.03704,
            0,
            0.63055
        ],
        "966": [
            0.19444,
            0.44444,
            0,
            0,
            0.74722
        ],
        "967": [
            0.19444,
            0.44444,
            0,
            0,
            0.71805
        ],
        "968": [
            0.19444,
            0.69444,
            0.03704,
            0,
            0.75833
        ],
        "969": [
            0,
            0.44444,
            0.03704,
            0,
            0.71782
        ],
        "977": [
            0,
            0.69444,
            0,
            0,
            0.69155
        ],
        "981": [
            0.19444,
            0.69444,
            0,
            0,
            0.7125
        ],
        "982": [
            0,
            0.44444,
            0.03194,
            0,
            0.975
        ],
        "1009": [
            0.19444,
            0.44444,
            0,
            0,
            0.6118
        ],
        "1013": [
            0,
            0.44444,
            0,
            0,
            0.48333
        ],
        "57649": [
            0,
            0.44444,
            0,
            0,
            0.39352
        ],
        "57911": [
            0.19444,
            0.44444,
            0,
            0,
            0.43889
        ]
    },
    "Math-Italic": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "48": [
            0,
            0.43056,
            0,
            0,
            0.5
        ],
        "49": [
            0,
            0.43056,
            0,
            0,
            0.5
        ],
        "50": [
            0,
            0.43056,
            0,
            0,
            0.5
        ],
        "51": [
            0.19444,
            0.43056,
            0,
            0,
            0.5
        ],
        "52": [
            0.19444,
            0.43056,
            0,
            0,
            0.5
        ],
        "53": [
            0.19444,
            0.43056,
            0,
            0,
            0.5
        ],
        "54": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "55": [
            0.19444,
            0.43056,
            0,
            0,
            0.5
        ],
        "56": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "57": [
            0.19444,
            0.43056,
            0,
            0,
            0.5
        ],
        "65": [
            0,
            0.68333,
            0,
            0.13889,
            0.75
        ],
        "66": [
            0,
            0.68333,
            0.05017,
            0.08334,
            0.75851
        ],
        "67": [
            0,
            0.68333,
            0.07153,
            0.08334,
            0.71472
        ],
        "68": [
            0,
            0.68333,
            0.02778,
            0.05556,
            0.82792
        ],
        "69": [
            0,
            0.68333,
            0.05764,
            0.08334,
            0.7382
        ],
        "70": [
            0,
            0.68333,
            0.13889,
            0.08334,
            0.64306
        ],
        "71": [
            0,
            0.68333,
            0,
            0.08334,
            0.78625
        ],
        "72": [
            0,
            0.68333,
            0.08125,
            0.05556,
            0.83125
        ],
        "73": [
            0,
            0.68333,
            0.07847,
            0.11111,
            0.43958
        ],
        "74": [
            0,
            0.68333,
            0.09618,
            0.16667,
            0.55451
        ],
        "75": [
            0,
            0.68333,
            0.07153,
            0.05556,
            0.84931
        ],
        "76": [
            0,
            0.68333,
            0,
            0.02778,
            0.68056
        ],
        "77": [
            0,
            0.68333,
            0.10903,
            0.08334,
            0.97014
        ],
        "78": [
            0,
            0.68333,
            0.10903,
            0.08334,
            0.80347
        ],
        "79": [
            0,
            0.68333,
            0.02778,
            0.08334,
            0.76278
        ],
        "80": [
            0,
            0.68333,
            0.13889,
            0.08334,
            0.64201
        ],
        "81": [
            0.19444,
            0.68333,
            0,
            0.08334,
            0.79056
        ],
        "82": [
            0,
            0.68333,
            0.00773,
            0.08334,
            0.75929
        ],
        "83": [
            0,
            0.68333,
            0.05764,
            0.08334,
            0.6132
        ],
        "84": [
            0,
            0.68333,
            0.13889,
            0.08334,
            0.58438
        ],
        "85": [
            0,
            0.68333,
            0.10903,
            0.02778,
            0.68278
        ],
        "86": [
            0,
            0.68333,
            0.22222,
            0,
            0.58333
        ],
        "87": [
            0,
            0.68333,
            0.13889,
            0,
            0.94445
        ],
        "88": [
            0,
            0.68333,
            0.07847,
            0.08334,
            0.82847
        ],
        "89": [
            0,
            0.68333,
            0.22222,
            0,
            0.58056
        ],
        "90": [
            0,
            0.68333,
            0.07153,
            0.08334,
            0.68264
        ],
        "97": [
            0,
            0.43056,
            0,
            0,
            0.52859
        ],
        "98": [
            0,
            0.69444,
            0,
            0,
            0.42917
        ],
        "99": [
            0,
            0.43056,
            0,
            0.05556,
            0.43276
        ],
        "100": [
            0,
            0.69444,
            0,
            0.16667,
            0.52049
        ],
        "101": [
            0,
            0.43056,
            0,
            0.05556,
            0.46563
        ],
        "102": [
            0.19444,
            0.69444,
            0.10764,
            0.16667,
            0.48959
        ],
        "103": [
            0.19444,
            0.43056,
            0.03588,
            0.02778,
            0.47697
        ],
        "104": [
            0,
            0.69444,
            0,
            0,
            0.57616
        ],
        "105": [
            0,
            0.65952,
            0,
            0,
            0.34451
        ],
        "106": [
            0.19444,
            0.65952,
            0.05724,
            0,
            0.41181
        ],
        "107": [
            0,
            0.69444,
            0.03148,
            0,
            0.5206
        ],
        "108": [
            0,
            0.69444,
            0.01968,
            0.08334,
            0.29838
        ],
        "109": [
            0,
            0.43056,
            0,
            0,
            0.87801
        ],
        "110": [
            0,
            0.43056,
            0,
            0,
            0.60023
        ],
        "111": [
            0,
            0.43056,
            0,
            0.05556,
            0.48472
        ],
        "112": [
            0.19444,
            0.43056,
            0,
            0.08334,
            0.50313
        ],
        "113": [
            0.19444,
            0.43056,
            0.03588,
            0.08334,
            0.44641
        ],
        "114": [
            0,
            0.43056,
            0.02778,
            0.05556,
            0.45116
        ],
        "115": [
            0,
            0.43056,
            0,
            0.05556,
            0.46875
        ],
        "116": [
            0,
            0.61508,
            0,
            0.08334,
            0.36111
        ],
        "117": [
            0,
            0.43056,
            0,
            0.02778,
            0.57246
        ],
        "118": [
            0,
            0.43056,
            0.03588,
            0.02778,
            0.48472
        ],
        "119": [
            0,
            0.43056,
            0.02691,
            0.08334,
            0.71592
        ],
        "120": [
            0,
            0.43056,
            0,
            0.02778,
            0.57153
        ],
        "121": [
            0.19444,
            0.43056,
            0.03588,
            0.05556,
            0.49028
        ],
        "122": [
            0,
            0.43056,
            0.04398,
            0.05556,
            0.46505
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "915": [
            0,
            0.68333,
            0.13889,
            0.08334,
            0.61528
        ],
        "916": [
            0,
            0.68333,
            0,
            0.16667,
            0.83334
        ],
        "920": [
            0,
            0.68333,
            0.02778,
            0.08334,
            0.76278
        ],
        "923": [
            0,
            0.68333,
            0,
            0.16667,
            0.69445
        ],
        "926": [
            0,
            0.68333,
            0.07569,
            0.08334,
            0.74236
        ],
        "928": [
            0,
            0.68333,
            0.08125,
            0.05556,
            0.83125
        ],
        "931": [
            0,
            0.68333,
            0.05764,
            0.08334,
            0.77986
        ],
        "933": [
            0,
            0.68333,
            0.13889,
            0.05556,
            0.58333
        ],
        "934": [
            0,
            0.68333,
            0,
            0.08334,
            0.66667
        ],
        "936": [
            0,
            0.68333,
            0.11,
            0.05556,
            0.61222
        ],
        "937": [
            0,
            0.68333,
            0.05017,
            0.08334,
            0.7724
        ],
        "945": [
            0,
            0.43056,
            0.0037,
            0.02778,
            0.6397
        ],
        "946": [
            0.19444,
            0.69444,
            0.05278,
            0.08334,
            0.56563
        ],
        "947": [
            0.19444,
            0.43056,
            0.05556,
            0,
            0.51773
        ],
        "948": [
            0,
            0.69444,
            0.03785,
            0.05556,
            0.44444
        ],
        "949": [
            0,
            0.43056,
            0,
            0.08334,
            0.46632
        ],
        "950": [
            0.19444,
            0.69444,
            0.07378,
            0.08334,
            0.4375
        ],
        "951": [
            0.19444,
            0.43056,
            0.03588,
            0.05556,
            0.49653
        ],
        "952": [
            0,
            0.69444,
            0.02778,
            0.08334,
            0.46944
        ],
        "953": [
            0,
            0.43056,
            0,
            0.05556,
            0.35394
        ],
        "954": [
            0,
            0.43056,
            0,
            0,
            0.57616
        ],
        "955": [
            0,
            0.69444,
            0,
            0,
            0.58334
        ],
        "956": [
            0.19444,
            0.43056,
            0,
            0.02778,
            0.60255
        ],
        "957": [
            0,
            0.43056,
            0.06366,
            0.02778,
            0.49398
        ],
        "958": [
            0.19444,
            0.69444,
            0.04601,
            0.11111,
            0.4375
        ],
        "959": [
            0,
            0.43056,
            0,
            0.05556,
            0.48472
        ],
        "960": [
            0,
            0.43056,
            0.03588,
            0,
            0.57003
        ],
        "961": [
            0.19444,
            0.43056,
            0,
            0.08334,
            0.51702
        ],
        "962": [
            0.09722,
            0.43056,
            0.07986,
            0.08334,
            0.36285
        ],
        "963": [
            0,
            0.43056,
            0.03588,
            0,
            0.57141
        ],
        "964": [
            0,
            0.43056,
            0.1132,
            0.02778,
            0.43715
        ],
        "965": [
            0,
            0.43056,
            0.03588,
            0.02778,
            0.54028
        ],
        "966": [
            0.19444,
            0.43056,
            0,
            0.08334,
            0.65417
        ],
        "967": [
            0.19444,
            0.43056,
            0,
            0.05556,
            0.62569
        ],
        "968": [
            0.19444,
            0.69444,
            0.03588,
            0.11111,
            0.65139
        ],
        "969": [
            0,
            0.43056,
            0.03588,
            0,
            0.62245
        ],
        "977": [
            0,
            0.69444,
            0,
            0.08334,
            0.59144
        ],
        "981": [
            0.19444,
            0.69444,
            0,
            0.08334,
            0.59583
        ],
        "982": [
            0,
            0.43056,
            0.02778,
            0,
            0.82813
        ],
        "1009": [
            0.19444,
            0.43056,
            0,
            0.08334,
            0.51702
        ],
        "1013": [
            0,
            0.43056,
            0,
            0.05556,
            0.4059
        ],
        "57649": [
            0,
            0.43056,
            0,
            0.02778,
            0.32246
        ],
        "57911": [
            0.19444,
            0.43056,
            0,
            0.08334,
            0.38403
        ]
    },
    "SansSerif-Bold": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0,
            0,
            0.36667
        ],
        "34": [
            0,
            0.69444,
            0,
            0,
            0.55834
        ],
        "35": [
            0.19444,
            0.69444,
            0,
            0,
            0.91667
        ],
        "36": [
            0.05556,
            0.75,
            0,
            0,
            0.55
        ],
        "37": [
            0.05556,
            0.75,
            0,
            0,
            1.02912
        ],
        "38": [
            0,
            0.69444,
            0,
            0,
            0.83056
        ],
        "39": [
            0,
            0.69444,
            0,
            0,
            0.30556
        ],
        "40": [
            0.25,
            0.75,
            0,
            0,
            0.42778
        ],
        "41": [
            0.25,
            0.75,
            0,
            0,
            0.42778
        ],
        "42": [
            0,
            0.75,
            0,
            0,
            0.55
        ],
        "43": [
            0.11667,
            0.61667,
            0,
            0,
            0.85556
        ],
        "44": [
            0.10556,
            0.13056,
            0,
            0,
            0.30556
        ],
        "45": [
            0,
            0.45833,
            0,
            0,
            0.36667
        ],
        "46": [
            0,
            0.13056,
            0,
            0,
            0.30556
        ],
        "47": [
            0.25,
            0.75,
            0,
            0,
            0.55
        ],
        "48": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "49": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "50": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "51": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "52": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "53": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "54": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "55": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "56": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "57": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "58": [
            0,
            0.45833,
            0,
            0,
            0.30556
        ],
        "59": [
            0.10556,
            0.45833,
            0,
            0,
            0.30556
        ],
        "61": [
            -0.09375,
            0.40625,
            0,
            0,
            0.85556
        ],
        "63": [
            0,
            0.69444,
            0,
            0,
            0.51945
        ],
        "64": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "65": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "66": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "67": [
            0,
            0.69444,
            0,
            0,
            0.70278
        ],
        "68": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "69": [
            0,
            0.69444,
            0,
            0,
            0.64167
        ],
        "70": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "71": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "72": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "73": [
            0,
            0.69444,
            0,
            0,
            0.33056
        ],
        "74": [
            0,
            0.69444,
            0,
            0,
            0.51945
        ],
        "75": [
            0,
            0.69444,
            0,
            0,
            0.76389
        ],
        "76": [
            0,
            0.69444,
            0,
            0,
            0.58056
        ],
        "77": [
            0,
            0.69444,
            0,
            0,
            0.97778
        ],
        "78": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "79": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "80": [
            0,
            0.69444,
            0,
            0,
            0.70278
        ],
        "81": [
            0.10556,
            0.69444,
            0,
            0,
            0.79445
        ],
        "82": [
            0,
            0.69444,
            0,
            0,
            0.70278
        ],
        "83": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "84": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "85": [
            0,
            0.69444,
            0,
            0,
            0.76389
        ],
        "86": [
            0,
            0.69444,
            0.01528,
            0,
            0.73334
        ],
        "87": [
            0,
            0.69444,
            0.01528,
            0,
            1.03889
        ],
        "88": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "89": [
            0,
            0.69444,
            0.0275,
            0,
            0.73334
        ],
        "90": [
            0,
            0.69444,
            0,
            0,
            0.67223
        ],
        "91": [
            0.25,
            0.75,
            0,
            0,
            0.34306
        ],
        "93": [
            0.25,
            0.75,
            0,
            0,
            0.34306
        ],
        "94": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "95": [
            0.35,
            0.10833,
            0.03056,
            0,
            0.55
        ],
        "97": [
            0,
            0.45833,
            0,
            0,
            0.525
        ],
        "98": [
            0,
            0.69444,
            0,
            0,
            0.56111
        ],
        "99": [
            0,
            0.45833,
            0,
            0,
            0.48889
        ],
        "100": [
            0,
            0.69444,
            0,
            0,
            0.56111
        ],
        "101": [
            0,
            0.45833,
            0,
            0,
            0.51111
        ],
        "102": [
            0,
            0.69444,
            0.07639,
            0,
            0.33611
        ],
        "103": [
            0.19444,
            0.45833,
            0.01528,
            0,
            0.55
        ],
        "104": [
            0,
            0.69444,
            0,
            0,
            0.56111
        ],
        "105": [
            0,
            0.69444,
            0,
            0,
            0.25556
        ],
        "106": [
            0.19444,
            0.69444,
            0,
            0,
            0.28611
        ],
        "107": [
            0,
            0.69444,
            0,
            0,
            0.53056
        ],
        "108": [
            0,
            0.69444,
            0,
            0,
            0.25556
        ],
        "109": [
            0,
            0.45833,
            0,
            0,
            0.86667
        ],
        "110": [
            0,
            0.45833,
            0,
            0,
            0.56111
        ],
        "111": [
            0,
            0.45833,
            0,
            0,
            0.55
        ],
        "112": [
            0.19444,
            0.45833,
            0,
            0,
            0.56111
        ],
        "113": [
            0.19444,
            0.45833,
            0,
            0,
            0.56111
        ],
        "114": [
            0,
            0.45833,
            0.01528,
            0,
            0.37222
        ],
        "115": [
            0,
            0.45833,
            0,
            0,
            0.42167
        ],
        "116": [
            0,
            0.58929,
            0,
            0,
            0.40417
        ],
        "117": [
            0,
            0.45833,
            0,
            0,
            0.56111
        ],
        "118": [
            0,
            0.45833,
            0.01528,
            0,
            0.5
        ],
        "119": [
            0,
            0.45833,
            0.01528,
            0,
            0.74445
        ],
        "120": [
            0,
            0.45833,
            0,
            0,
            0.5
        ],
        "121": [
            0.19444,
            0.45833,
            0.01528,
            0,
            0.5
        ],
        "122": [
            0,
            0.45833,
            0,
            0,
            0.47639
        ],
        "126": [
            0.35,
            0.34444,
            0,
            0,
            0.55
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "168": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "180": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.48889
        ],
        "305": [
            0,
            0.45833,
            0,
            0,
            0.25556
        ],
        "567": [
            0.19444,
            0.45833,
            0,
            0,
            0.28611
        ],
        "710": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "711": [
            0,
            0.63542,
            0,
            0,
            0.55
        ],
        "713": [
            0,
            0.63778,
            0,
            0,
            0.55
        ],
        "728": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "729": [
            0,
            0.69444,
            0,
            0,
            0.30556
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "732": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "733": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "915": [
            0,
            0.69444,
            0,
            0,
            0.58056
        ],
        "916": [
            0,
            0.69444,
            0,
            0,
            0.91667
        ],
        "920": [
            0,
            0.69444,
            0,
            0,
            0.85556
        ],
        "923": [
            0,
            0.69444,
            0,
            0,
            0.67223
        ],
        "926": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "928": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "931": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "933": [
            0,
            0.69444,
            0,
            0,
            0.85556
        ],
        "934": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "936": [
            0,
            0.69444,
            0,
            0,
            0.85556
        ],
        "937": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "8211": [
            0,
            0.45833,
            0.03056,
            0,
            0.55
        ],
        "8212": [
            0,
            0.45833,
            0.03056,
            0,
            1.10001
        ],
        "8216": [
            0,
            0.69444,
            0,
            0,
            0.30556
        ],
        "8217": [
            0,
            0.69444,
            0,
            0,
            0.30556
        ],
        "8220": [
            0,
            0.69444,
            0,
            0,
            0.55834
        ],
        "8221": [
            0,
            0.69444,
            0,
            0,
            0.55834
        ]
    },
    "SansSerif-Italic": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0.05733,
            0,
            0.31945
        ],
        "34": [
            0,
            0.69444,
            0.00316,
            0,
            0.5
        ],
        "35": [
            0.19444,
            0.69444,
            0.05087,
            0,
            0.83334
        ],
        "36": [
            0.05556,
            0.75,
            0.11156,
            0,
            0.5
        ],
        "37": [
            0.05556,
            0.75,
            0.03126,
            0,
            0.83334
        ],
        "38": [
            0,
            0.69444,
            0.03058,
            0,
            0.75834
        ],
        "39": [
            0,
            0.69444,
            0.07816,
            0,
            0.27778
        ],
        "40": [
            0.25,
            0.75,
            0.13164,
            0,
            0.38889
        ],
        "41": [
            0.25,
            0.75,
            0.02536,
            0,
            0.38889
        ],
        "42": [
            0,
            0.75,
            0.11775,
            0,
            0.5
        ],
        "43": [
            0.08333,
            0.58333,
            0.02536,
            0,
            0.77778
        ],
        "44": [
            0.125,
            0.08333,
            0,
            0,
            0.27778
        ],
        "45": [
            0,
            0.44444,
            0.01946,
            0,
            0.33333
        ],
        "46": [
            0,
            0.08333,
            0,
            0,
            0.27778
        ],
        "47": [
            0.25,
            0.75,
            0.13164,
            0,
            0.5
        ],
        "48": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "49": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "50": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "51": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "52": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "53": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "54": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "55": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "56": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "57": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "58": [
            0,
            0.44444,
            0.02502,
            0,
            0.27778
        ],
        "59": [
            0.125,
            0.44444,
            0.02502,
            0,
            0.27778
        ],
        "61": [
            -0.13,
            0.37,
            0.05087,
            0,
            0.77778
        ],
        "63": [
            0,
            0.69444,
            0.11809,
            0,
            0.47222
        ],
        "64": [
            0,
            0.69444,
            0.07555,
            0,
            0.66667
        ],
        "65": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "66": [
            0,
            0.69444,
            0.08293,
            0,
            0.66667
        ],
        "67": [
            0,
            0.69444,
            0.11983,
            0,
            0.63889
        ],
        "68": [
            0,
            0.69444,
            0.07555,
            0,
            0.72223
        ],
        "69": [
            0,
            0.69444,
            0.11983,
            0,
            0.59722
        ],
        "70": [
            0,
            0.69444,
            0.13372,
            0,
            0.56945
        ],
        "71": [
            0,
            0.69444,
            0.11983,
            0,
            0.66667
        ],
        "72": [
            0,
            0.69444,
            0.08094,
            0,
            0.70834
        ],
        "73": [
            0,
            0.69444,
            0.13372,
            0,
            0.27778
        ],
        "74": [
            0,
            0.69444,
            0.08094,
            0,
            0.47222
        ],
        "75": [
            0,
            0.69444,
            0.11983,
            0,
            0.69445
        ],
        "76": [
            0,
            0.69444,
            0,
            0,
            0.54167
        ],
        "77": [
            0,
            0.69444,
            0.08094,
            0,
            0.875
        ],
        "78": [
            0,
            0.69444,
            0.08094,
            0,
            0.70834
        ],
        "79": [
            0,
            0.69444,
            0.07555,
            0,
            0.73611
        ],
        "80": [
            0,
            0.69444,
            0.08293,
            0,
            0.63889
        ],
        "81": [
            0.125,
            0.69444,
            0.07555,
            0,
            0.73611
        ],
        "82": [
            0,
            0.69444,
            0.08293,
            0,
            0.64584
        ],
        "83": [
            0,
            0.69444,
            0.09205,
            0,
            0.55556
        ],
        "84": [
            0,
            0.69444,
            0.13372,
            0,
            0.68056
        ],
        "85": [
            0,
            0.69444,
            0.08094,
            0,
            0.6875
        ],
        "86": [
            0,
            0.69444,
            0.1615,
            0,
            0.66667
        ],
        "87": [
            0,
            0.69444,
            0.1615,
            0,
            0.94445
        ],
        "88": [
            0,
            0.69444,
            0.13372,
            0,
            0.66667
        ],
        "89": [
            0,
            0.69444,
            0.17261,
            0,
            0.66667
        ],
        "90": [
            0,
            0.69444,
            0.11983,
            0,
            0.61111
        ],
        "91": [
            0.25,
            0.75,
            0.15942,
            0,
            0.28889
        ],
        "93": [
            0.25,
            0.75,
            0.08719,
            0,
            0.28889
        ],
        "94": [
            0,
            0.69444,
            0.0799,
            0,
            0.5
        ],
        "95": [
            0.35,
            0.09444,
            0.08616,
            0,
            0.5
        ],
        "97": [
            0,
            0.44444,
            0.00981,
            0,
            0.48056
        ],
        "98": [
            0,
            0.69444,
            0.03057,
            0,
            0.51667
        ],
        "99": [
            0,
            0.44444,
            0.08336,
            0,
            0.44445
        ],
        "100": [
            0,
            0.69444,
            0.09483,
            0,
            0.51667
        ],
        "101": [
            0,
            0.44444,
            0.06778,
            0,
            0.44445
        ],
        "102": [
            0,
            0.69444,
            0.21705,
            0,
            0.30556
        ],
        "103": [
            0.19444,
            0.44444,
            0.10836,
            0,
            0.5
        ],
        "104": [
            0,
            0.69444,
            0.01778,
            0,
            0.51667
        ],
        "105": [
            0,
            0.67937,
            0.09718,
            0,
            0.23889
        ],
        "106": [
            0.19444,
            0.67937,
            0.09162,
            0,
            0.26667
        ],
        "107": [
            0,
            0.69444,
            0.08336,
            0,
            0.48889
        ],
        "108": [
            0,
            0.69444,
            0.09483,
            0,
            0.23889
        ],
        "109": [
            0,
            0.44444,
            0.01778,
            0,
            0.79445
        ],
        "110": [
            0,
            0.44444,
            0.01778,
            0,
            0.51667
        ],
        "111": [
            0,
            0.44444,
            0.06613,
            0,
            0.5
        ],
        "112": [
            0.19444,
            0.44444,
            0.0389,
            0,
            0.51667
        ],
        "113": [
            0.19444,
            0.44444,
            0.04169,
            0,
            0.51667
        ],
        "114": [
            0,
            0.44444,
            0.10836,
            0,
            0.34167
        ],
        "115": [
            0,
            0.44444,
            0.0778,
            0,
            0.38333
        ],
        "116": [
            0,
            0.57143,
            0.07225,
            0,
            0.36111
        ],
        "117": [
            0,
            0.44444,
            0.04169,
            0,
            0.51667
        ],
        "118": [
            0,
            0.44444,
            0.10836,
            0,
            0.46111
        ],
        "119": [
            0,
            0.44444,
            0.10836,
            0,
            0.68334
        ],
        "120": [
            0,
            0.44444,
            0.09169,
            0,
            0.46111
        ],
        "121": [
            0.19444,
            0.44444,
            0.10836,
            0,
            0.46111
        ],
        "122": [
            0,
            0.44444,
            0.08752,
            0,
            0.43472
        ],
        "126": [
            0.35,
            0.32659,
            0.08826,
            0,
            0.5
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "168": [
            0,
            0.67937,
            0.06385,
            0,
            0.5
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.73752
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.44445
        ],
        "305": [
            0,
            0.44444,
            0.04169,
            0,
            0.23889
        ],
        "567": [
            0.19444,
            0.44444,
            0.04169,
            0,
            0.26667
        ],
        "710": [
            0,
            0.69444,
            0.0799,
            0,
            0.5
        ],
        "711": [
            0,
            0.63194,
            0.08432,
            0,
            0.5
        ],
        "713": [
            0,
            0.60889,
            0.08776,
            0,
            0.5
        ],
        "714": [
            0,
            0.69444,
            0.09205,
            0,
            0.5
        ],
        "715": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "728": [
            0,
            0.69444,
            0.09483,
            0,
            0.5
        ],
        "729": [
            0,
            0.67937,
            0.07774,
            0,
            0.27778
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.73752
        ],
        "732": [
            0,
            0.67659,
            0.08826,
            0,
            0.5
        ],
        "733": [
            0,
            0.69444,
            0.09205,
            0,
            0.5
        ],
        "915": [
            0,
            0.69444,
            0.13372,
            0,
            0.54167
        ],
        "916": [
            0,
            0.69444,
            0,
            0,
            0.83334
        ],
        "920": [
            0,
            0.69444,
            0.07555,
            0,
            0.77778
        ],
        "923": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "926": [
            0,
            0.69444,
            0.12816,
            0,
            0.66667
        ],
        "928": [
            0,
            0.69444,
            0.08094,
            0,
            0.70834
        ],
        "931": [
            0,
            0.69444,
            0.11983,
            0,
            0.72222
        ],
        "933": [
            0,
            0.69444,
            0.09031,
            0,
            0.77778
        ],
        "934": [
            0,
            0.69444,
            0.04603,
            0,
            0.72222
        ],
        "936": [
            0,
            0.69444,
            0.09031,
            0,
            0.77778
        ],
        "937": [
            0,
            0.69444,
            0.08293,
            0,
            0.72222
        ],
        "8211": [
            0,
            0.44444,
            0.08616,
            0,
            0.5
        ],
        "8212": [
            0,
            0.44444,
            0.08616,
            0,
            1.0
        ],
        "8216": [
            0,
            0.69444,
            0.07816,
            0,
            0.27778
        ],
        "8217": [
            0,
            0.69444,
            0.07816,
            0,
            0.27778
        ],
        "8220": [
            0,
            0.69444,
            0.14205,
            0,
            0.5
        ],
        "8221": [
            0,
            0.69444,
            0.00316,
            0,
            0.5
        ]
    },
    "SansSerif-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0,
            0,
            0.31945
        ],
        "34": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "35": [
            0.19444,
            0.69444,
            0,
            0,
            0.83334
        ],
        "36": [
            0.05556,
            0.75,
            0,
            0,
            0.5
        ],
        "37": [
            0.05556,
            0.75,
            0,
            0,
            0.83334
        ],
        "38": [
            0,
            0.69444,
            0,
            0,
            0.75834
        ],
        "39": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "40": [
            0.25,
            0.75,
            0,
            0,
            0.38889
        ],
        "41": [
            0.25,
            0.75,
            0,
            0,
            0.38889
        ],
        "42": [
            0,
            0.75,
            0,
            0,
            0.5
        ],
        "43": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "44": [
            0.125,
            0.08333,
            0,
            0,
            0.27778
        ],
        "45": [
            0,
            0.44444,
            0,
            0,
            0.33333
        ],
        "46": [
            0,
            0.08333,
            0,
            0,
            0.27778
        ],
        "47": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "48": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "49": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "50": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "51": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "52": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "53": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "54": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "55": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "56": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "57": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "58": [
            0,
            0.44444,
            0,
            0,
            0.27778
        ],
        "59": [
            0.125,
            0.44444,
            0,
            0,
            0.27778
        ],
        "61": [
            -0.13,
            0.37,
            0,
            0,
            0.77778
        ],
        "63": [
            0,
            0.69444,
            0,
            0,
            0.47222
        ],
        "64": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "65": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "66": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "67": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "68": [
            0,
            0.69444,
            0,
            0,
            0.72223
        ],
        "69": [
            0,
            0.69444,
            0,
            0,
            0.59722
        ],
        "70": [
            0,
            0.69444,
            0,
            0,
            0.56945
        ],
        "71": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "72": [
            0,
            0.69444,
            0,
            0,
            0.70834
        ],
        "73": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "74": [
            0,
            0.69444,
            0,
            0,
            0.47222
        ],
        "75": [
            0,
            0.69444,
            0,
            0,
            0.69445
        ],
        "76": [
            0,
            0.69444,
            0,
            0,
            0.54167
        ],
        "77": [
            0,
            0.69444,
            0,
            0,
            0.875
        ],
        "78": [
            0,
            0.69444,
            0,
            0,
            0.70834
        ],
        "79": [
            0,
            0.69444,
            0,
            0,
            0.73611
        ],
        "80": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "81": [
            0.125,
            0.69444,
            0,
            0,
            0.73611
        ],
        "82": [
            0,
            0.69444,
            0,
            0,
            0.64584
        ],
        "83": [
            0,
            0.69444,
            0,
            0,
            0.55556
        ],
        "84": [
            0,
            0.69444,
            0,
            0,
            0.68056
        ],
        "85": [
            0,
            0.69444,
            0,
            0,
            0.6875
        ],
        "86": [
            0,
            0.69444,
            0.01389,
            0,
            0.66667
        ],
        "87": [
            0,
            0.69444,
            0.01389,
            0,
            0.94445
        ],
        "88": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "89": [
            0,
            0.69444,
            0.025,
            0,
            0.66667
        ],
        "90": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "91": [
            0.25,
            0.75,
            0,
            0,
            0.28889
        ],
        "93": [
            0.25,
            0.75,
            0,
            0,
            0.28889
        ],
        "94": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "95": [
            0.35,
            0.09444,
            0.02778,
            0,
            0.5
        ],
        "97": [
            0,
            0.44444,
            0,
            0,
            0.48056
        ],
        "98": [
            0,
            0.69444,
            0,
            0,
            0.51667
        ],
        "99": [
            0,
            0.44444,
            0,
            0,
            0.44445
        ],
        "100": [
            0,
            0.69444,
            0,
            0,
            0.51667
        ],
        "101": [
            0,
            0.44444,
            0,
            0,
            0.44445
        ],
        "102": [
            0,
            0.69444,
            0.06944,
            0,
            0.30556
        ],
        "103": [
            0.19444,
            0.44444,
            0.01389,
            0,
            0.5
        ],
        "104": [
            0,
            0.69444,
            0,
            0,
            0.51667
        ],
        "105": [
            0,
            0.67937,
            0,
            0,
            0.23889
        ],
        "106": [
            0.19444,
            0.67937,
            0,
            0,
            0.26667
        ],
        "107": [
            0,
            0.69444,
            0,
            0,
            0.48889
        ],
        "108": [
            0,
            0.69444,
            0,
            0,
            0.23889
        ],
        "109": [
            0,
            0.44444,
            0,
            0,
            0.79445
        ],
        "110": [
            0,
            0.44444,
            0,
            0,
            0.51667
        ],
        "111": [
            0,
            0.44444,
            0,
            0,
            0.5
        ],
        "112": [
            0.19444,
            0.44444,
            0,
            0,
            0.51667
        ],
        "113": [
            0.19444,
            0.44444,
            0,
            0,
            0.51667
        ],
        "114": [
            0,
            0.44444,
            0.01389,
            0,
            0.34167
        ],
        "115": [
            0,
            0.44444,
            0,
            0,
            0.38333
        ],
        "116": [
            0,
            0.57143,
            0,
            0,
            0.36111
        ],
        "117": [
            0,
            0.44444,
            0,
            0,
            0.51667
        ],
        "118": [
            0,
            0.44444,
            0.01389,
            0,
            0.46111
        ],
        "119": [
            0,
            0.44444,
            0.01389,
            0,
            0.68334
        ],
        "120": [
            0,
            0.44444,
            0,
            0,
            0.46111
        ],
        "121": [
            0.19444,
            0.44444,
            0.01389,
            0,
            0.46111
        ],
        "122": [
            0,
            0.44444,
            0,
            0,
            0.43472
        ],
        "126": [
            0.35,
            0.32659,
            0,
            0,
            0.5
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "168": [
            0,
            0.67937,
            0,
            0,
            0.5
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.44445
        ],
        "305": [
            0,
            0.44444,
            0,
            0,
            0.23889
        ],
        "567": [
            0.19444,
            0.44444,
            0,
            0,
            0.26667
        ],
        "710": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "711": [
            0,
            0.63194,
            0,
            0,
            0.5
        ],
        "713": [
            0,
            0.60889,
            0,
            0,
            0.5
        ],
        "714": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "715": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "728": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "729": [
            0,
            0.67937,
            0,
            0,
            0.27778
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "732": [
            0,
            0.67659,
            0,
            0,
            0.5
        ],
        "733": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "915": [
            0,
            0.69444,
            0,
            0,
            0.54167
        ],
        "916": [
            0,
            0.69444,
            0,
            0,
            0.83334
        ],
        "920": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "923": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "926": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "928": [
            0,
            0.69444,
            0,
            0,
            0.70834
        ],
        "931": [
            0,
            0.69444,
            0,
            0,
            0.72222
        ],
        "933": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "934": [
            0,
            0.69444,
            0,
            0,
            0.72222
        ],
        "936": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "937": [
            0,
            0.69444,
            0,
            0,
            0.72222
        ],
        "8211": [
            0,
            0.44444,
            0.02778,
            0,
            0.5
        ],
        "8212": [
            0,
            0.44444,
            0.02778,
            0,
            1.0
        ],
        "8216": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "8217": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "8220": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "8221": [
            0,
            0.69444,
            0,
            0,
            0.5
        ]
    },
    "Script-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "65": [
            0,
            0.7,
            0.22925,
            0,
            0.80253
        ],
        "66": [
            0,
            0.7,
            0.04087,
            0,
            0.90757
        ],
        "67": [
            0,
            0.7,
            0.1689,
            0,
            0.66619
        ],
        "68": [
            0,
            0.7,
            0.09371,
            0,
            0.77443
        ],
        "69": [
            0,
            0.7,
            0.18583,
            0,
            0.56162
        ],
        "70": [
            0,
            0.7,
            0.13634,
            0,
            0.89544
        ],
        "71": [
            0,
            0.7,
            0.17322,
            0,
            0.60961
        ],
        "72": [
            0,
            0.7,
            0.29694,
            0,
            0.96919
        ],
        "73": [
            0,
            0.7,
            0.19189,
            0,
            0.80907
        ],
        "74": [
            0.27778,
            0.7,
            0.19189,
            0,
            1.05159
        ],
        "75": [
            0,
            0.7,
            0.31259,
            0,
            0.91364
        ],
        "76": [
            0,
            0.7,
            0.19189,
            0,
            0.87373
        ],
        "77": [
            0,
            0.7,
            0.15981,
            0,
            1.08031
        ],
        "78": [
            0,
            0.7,
            0.3525,
            0,
            0.9015
        ],
        "79": [
            0,
            0.7,
            0.08078,
            0,
            0.73787
        ],
        "80": [
            0,
            0.7,
            0.08078,
            0,
            1.01262
        ],
        "81": [
            0,
            0.7,
            0.03305,
            0,
            0.88282
        ],
        "82": [
            0,
            0.7,
            0.06259,
            0,
            0.85
        ],
        "83": [
            0,
            0.7,
            0.19189,
            0,
            0.86767
        ],
        "84": [
            0,
            0.7,
            0.29087,
            0,
            0.74697
        ],
        "85": [
            0,
            0.7,
            0.25815,
            0,
            0.79996
        ],
        "86": [
            0,
            0.7,
            0.27523,
            0,
            0.62204
        ],
        "87": [
            0,
            0.7,
            0.27523,
            0,
            0.80532
        ],
        "88": [
            0,
            0.7,
            0.26006,
            0,
            0.94445
        ],
        "89": [
            0,
            0.7,
            0.2939,
            0,
            0.70961
        ],
        "90": [
            0,
            0.7,
            0.24037,
            0,
            0.8212
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ]
    },
    "Size1-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "40": [
            0.35001,
            0.85,
            0,
            0,
            0.45834
        ],
        "41": [
            0.35001,
            0.85,
            0,
            0,
            0.45834
        ],
        "47": [
            0.35001,
            0.85,
            0,
            0,
            0.57778
        ],
        "91": [
            0.35001,
            0.85,
            0,
            0,
            0.41667
        ],
        "92": [
            0.35001,
            0.85,
            0,
            0,
            0.57778
        ],
        "93": [
            0.35001,
            0.85,
            0,
            0,
            0.41667
        ],
        "123": [
            0.35001,
            0.85,
            0,
            0,
            0.58334
        ],
        "125": [
            0.35001,
            0.85,
            0,
            0,
            0.58334
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "710": [
            0,
            0.72222,
            0,
            0,
            0.55556
        ],
        "732": [
            0,
            0.72222,
            0,
            0,
            0.55556
        ],
        "770": [
            0,
            0.72222,
            0,
            0,
            0.55556
        ],
        "771": [
            0,
            0.72222,
            0,
            0,
            0.55556
        ],
        "8214": [
            -0.00099,
            0.601,
            0,
            0,
            0.77778
        ],
        "8593": [
            1e-05,
            0.6,
            0,
            0,
            0.66667
        ],
        "8595": [
            1e-05,
            0.6,
            0,
            0,
            0.66667
        ],
        "8657": [
            1e-05,
            0.6,
            0,
            0,
            0.77778
        ],
        "8659": [
            1e-05,
            0.6,
            0,
            0,
            0.77778
        ],
        "8719": [
            0.25001,
            0.75,
            0,
            0,
            0.94445
        ],
        "8720": [
            0.25001,
            0.75,
            0,
            0,
            0.94445
        ],
        "8721": [
            0.25001,
            0.75,
            0,
            0,
            1.05556
        ],
        "8730": [
            0.35001,
            0.85,
            0,
            0,
            1.0
        ],
        "8739": [
            -0.00599,
            0.606,
            0,
            0,
            0.33333
        ],
        "8741": [
            -0.00599,
            0.606,
            0,
            0,
            0.55556
        ],
        "8747": [
            0.30612,
            0.805,
            0.19445,
            0,
            0.47222
        ],
        "8748": [
            0.306,
            0.805,
            0.19445,
            0,
            0.47222
        ],
        "8749": [
            0.306,
            0.805,
            0.19445,
            0,
            0.47222
        ],
        "8750": [
            0.30612,
            0.805,
            0.19445,
            0,
            0.47222
        ],
        "8896": [
            0.25001,
            0.75,
            0,
            0,
            0.83334
        ],
        "8897": [
            0.25001,
            0.75,
            0,
            0,
            0.83334
        ],
        "8898": [
            0.25001,
            0.75,
            0,
            0,
            0.83334
        ],
        "8899": [
            0.25001,
            0.75,
            0,
            0,
            0.83334
        ],
        "8968": [
            0.35001,
            0.85,
            0,
            0,
            0.47222
        ],
        "8969": [
            0.35001,
            0.85,
            0,
            0,
            0.47222
        ],
        "8970": [
            0.35001,
            0.85,
            0,
            0,
            0.47222
        ],
        "8971": [
            0.35001,
            0.85,
            0,
            0,
            0.47222
        ],
        "9168": [
            -0.00099,
            0.601,
            0,
            0,
            0.66667
        ],
        "10216": [
            0.35001,
            0.85,
            0,
            0,
            0.47222
        ],
        "10217": [
            0.35001,
            0.85,
            0,
            0,
            0.47222
        ],
        "10752": [
            0.25001,
            0.75,
            0,
            0,
            1.11111
        ],
        "10753": [
            0.25001,
            0.75,
            0,
            0,
            1.11111
        ],
        "10754": [
            0.25001,
            0.75,
            0,
            0,
            1.11111
        ],
        "10756": [
            0.25001,
            0.75,
            0,
            0,
            0.83334
        ],
        "10758": [
            0.25001,
            0.75,
            0,
            0,
            0.83334
        ]
    },
    "Size2-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "40": [
            0.65002,
            1.15,
            0,
            0,
            0.59722
        ],
        "41": [
            0.65002,
            1.15,
            0,
            0,
            0.59722
        ],
        "47": [
            0.65002,
            1.15,
            0,
            0,
            0.81111
        ],
        "91": [
            0.65002,
            1.15,
            0,
            0,
            0.47222
        ],
        "92": [
            0.65002,
            1.15,
            0,
            0,
            0.81111
        ],
        "93": [
            0.65002,
            1.15,
            0,
            0,
            0.47222
        ],
        "123": [
            0.65002,
            1.15,
            0,
            0,
            0.66667
        ],
        "125": [
            0.65002,
            1.15,
            0,
            0,
            0.66667
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "710": [
            0,
            0.75,
            0,
            0,
            1.0
        ],
        "732": [
            0,
            0.75,
            0,
            0,
            1.0
        ],
        "770": [
            0,
            0.75,
            0,
            0,
            1.0
        ],
        "771": [
            0,
            0.75,
            0,
            0,
            1.0
        ],
        "8719": [
            0.55001,
            1.05,
            0,
            0,
            1.27778
        ],
        "8720": [
            0.55001,
            1.05,
            0,
            0,
            1.27778
        ],
        "8721": [
            0.55001,
            1.05,
            0,
            0,
            1.44445
        ],
        "8730": [
            0.65002,
            1.15,
            0,
            0,
            1.0
        ],
        "8747": [
            0.86225,
            1.36,
            0.44445,
            0,
            0.55556
        ],
        "8748": [
            0.862,
            1.36,
            0.44445,
            0,
            0.55556
        ],
        "8749": [
            0.862,
            1.36,
            0.44445,
            0,
            0.55556
        ],
        "8750": [
            0.86225,
            1.36,
            0.44445,
            0,
            0.55556
        ],
        "8896": [
            0.55001,
            1.05,
            0,
            0,
            1.11111
        ],
        "8897": [
            0.55001,
            1.05,
            0,
            0,
            1.11111
        ],
        "8898": [
            0.55001,
            1.05,
            0,
            0,
            1.11111
        ],
        "8899": [
            0.55001,
            1.05,
            0,
            0,
            1.11111
        ],
        "8968": [
            0.65002,
            1.15,
            0,
            0,
            0.52778
        ],
        "8969": [
            0.65002,
            1.15,
            0,
            0,
            0.52778
        ],
        "8970": [
            0.65002,
            1.15,
            0,
            0,
            0.52778
        ],
        "8971": [
            0.65002,
            1.15,
            0,
            0,
            0.52778
        ],
        "10216": [
            0.65002,
            1.15,
            0,
            0,
            0.61111
        ],
        "10217": [
            0.65002,
            1.15,
            0,
            0,
            0.61111
        ],
        "10752": [
            0.55001,
            1.05,
            0,
            0,
            1.51112
        ],
        "10753": [
            0.55001,
            1.05,
            0,
            0,
            1.51112
        ],
        "10754": [
            0.55001,
            1.05,
            0,
            0,
            1.51112
        ],
        "10756": [
            0.55001,
            1.05,
            0,
            0,
            1.11111
        ],
        "10758": [
            0.55001,
            1.05,
            0,
            0,
            1.11111
        ]
    },
    "Size3-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "40": [
            0.95003,
            1.45,
            0,
            0,
            0.73611
        ],
        "41": [
            0.95003,
            1.45,
            0,
            0,
            0.73611
        ],
        "47": [
            0.95003,
            1.45,
            0,
            0,
            1.04445
        ],
        "91": [
            0.95003,
            1.45,
            0,
            0,
            0.52778
        ],
        "92": [
            0.95003,
            1.45,
            0,
            0,
            1.04445
        ],
        "93": [
            0.95003,
            1.45,
            0,
            0,
            0.52778
        ],
        "123": [
            0.95003,
            1.45,
            0,
            0,
            0.75
        ],
        "125": [
            0.95003,
            1.45,
            0,
            0,
            0.75
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "710": [
            0,
            0.75,
            0,
            0,
            1.44445
        ],
        "732": [
            0,
            0.75,
            0,
            0,
            1.44445
        ],
        "770": [
            0,
            0.75,
            0,
            0,
            1.44445
        ],
        "771": [
            0,
            0.75,
            0,
            0,
            1.44445
        ],
        "8730": [
            0.95003,
            1.45,
            0,
            0,
            1.0
        ],
        "8968": [
            0.95003,
            1.45,
            0,
            0,
            0.58334
        ],
        "8969": [
            0.95003,
            1.45,
            0,
            0,
            0.58334
        ],
        "8970": [
            0.95003,
            1.45,
            0,
            0,
            0.58334
        ],
        "8971": [
            0.95003,
            1.45,
            0,
            0,
            0.58334
        ],
        "10216": [
            0.95003,
            1.45,
            0,
            0,
            0.75
        ],
        "10217": [
            0.95003,
            1.45,
            0,
            0,
            0.75
        ]
    },
    "Size4-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "40": [
            1.25003,
            1.75,
            0,
            0,
            0.79167
        ],
        "41": [
            1.25003,
            1.75,
            0,
            0,
            0.79167
        ],
        "47": [
            1.25003,
            1.75,
            0,
            0,
            1.27778
        ],
        "91": [
            1.25003,
            1.75,
            0,
            0,
            0.58334
        ],
        "92": [
            1.25003,
            1.75,
            0,
            0,
            1.27778
        ],
        "93": [
            1.25003,
            1.75,
            0,
            0,
            0.58334
        ],
        "123": [
            1.25003,
            1.75,
            0,
            0,
            0.80556
        ],
        "125": [
            1.25003,
            1.75,
            0,
            0,
            0.80556
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "710": [
            0,
            0.825,
            0,
            0,
            1.8889
        ],
        "732": [
            0,
            0.825,
            0,
            0,
            1.8889
        ],
        "770": [
            0,
            0.825,
            0,
            0,
            1.8889
        ],
        "771": [
            0,
            0.825,
            0,
            0,
            1.8889
        ],
        "8730": [
            1.25003,
            1.75,
            0,
            0,
            1.0
        ],
        "8968": [
            1.25003,
            1.75,
            0,
            0,
            0.63889
        ],
        "8969": [
            1.25003,
            1.75,
            0,
            0,
            0.63889
        ],
        "8970": [
            1.25003,
            1.75,
            0,
            0,
            0.63889
        ],
        "8971": [
            1.25003,
            1.75,
            0,
            0,
            0.63889
        ],
        "9115": [
            0.64502,
            1.155,
            0,
            0,
            0.875
        ],
        "9116": [
            1e-05,
            0.6,
            0,
            0,
            0.875
        ],
        "9117": [
            0.64502,
            1.155,
            0,
            0,
            0.875
        ],
        "9118": [
            0.64502,
            1.155,
            0,
            0,
            0.875
        ],
        "9119": [
            1e-05,
            0.6,
            0,
            0,
            0.875
        ],
        "9120": [
            0.64502,
            1.155,
            0,
            0,
            0.875
        ],
        "9121": [
            0.64502,
            1.155,
            0,
            0,
            0.66667
        ],
        "9122": [
            -0.00099,
            0.601,
            0,
            0,
            0.66667
        ],
        "9123": [
            0.64502,
            1.155,
            0,
            0,
            0.66667
        ],
        "9124": [
            0.64502,
            1.155,
            0,
            0,
            0.66667
        ],
        "9125": [
            -0.00099,
            0.601,
            0,
            0,
            0.66667
        ],
        "9126": [
            0.64502,
            1.155,
            0,
            0,
            0.66667
        ],
        "9127": [
            1e-05,
            0.9,
            0,
            0,
            0.88889
        ],
        "9128": [
            0.65002,
            1.15,
            0,
            0,
            0.88889
        ],
        "9129": [
            0.90001,
            0,
            0,
            0,
            0.88889
        ],
        "9130": [
            0,
            0.3,
            0,
            0,
            0.88889
        ],
        "9131": [
            1e-05,
            0.9,
            0,
            0,
            0.88889
        ],
        "9132": [
            0.65002,
            1.15,
            0,
            0,
            0.88889
        ],
        "9133": [
            0.90001,
            0,
            0,
            0,
            0.88889
        ],
        "9143": [
            0.88502,
            0.915,
            0,
            0,
            1.05556
        ],
        "10216": [
            1.25003,
            1.75,
            0,
            0,
            0.80556
        ],
        "10217": [
            1.25003,
            1.75,
            0,
            0,
            0.80556
        ],
        "57344": [
            -0.00499,
            0.605,
            0,
            0,
            1.05556
        ],
        "57345": [
            -0.00499,
            0.605,
            0,
            0,
            1.05556
        ],
        "57680": [
            0,
            0.12,
            0,
            0,
            0.45
        ],
        "57681": [
            0,
            0.12,
            0,
            0,
            0.45
        ],
        "57682": [
            0,
            0.12,
            0,
            0,
            0.45
        ],
        "57683": [
            0,
            0.12,
            0,
            0,
            0.45
        ]
    },
    "Typewriter-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.525
        ],
        "33": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "34": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "35": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "36": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "37": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "38": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "39": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "40": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "41": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "42": [
            0,
            0.52083,
            0,
            0,
            0.525
        ],
        "43": [
            -0.08056,
            0.53055,
            0,
            0,
            0.525
        ],
        "44": [
            0.13889,
            0.125,
            0,
            0,
            0.525
        ],
        "45": [
            -0.08056,
            0.53055,
            0,
            0,
            0.525
        ],
        "46": [
            0,
            0.125,
            0,
            0,
            0.525
        ],
        "47": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "48": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "49": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "50": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "51": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "52": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "53": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "54": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "55": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "56": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "57": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "58": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "59": [
            0.13889,
            0.43056,
            0,
            0,
            0.525
        ],
        "60": [
            -0.05556,
            0.55556,
            0,
            0,
            0.525
        ],
        "61": [
            -0.19549,
            0.41562,
            0,
            0,
            0.525
        ],
        "62": [
            -0.05556,
            0.55556,
            0,
            0,
            0.525
        ],
        "63": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "64": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "65": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "66": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "67": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "68": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "69": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "70": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "71": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "72": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "73": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "74": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "75": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "76": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "77": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "78": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "79": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "80": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "81": [
            0.13889,
            0.61111,
            0,
            0,
            0.525
        ],
        "82": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "83": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "84": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "85": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "86": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "87": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "88": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "89": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "90": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "91": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "92": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "93": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "94": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "95": [
            0.09514,
            0,
            0,
            0,
            0.525
        ],
        "96": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "97": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "98": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "99": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "100": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "101": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "102": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "103": [
            0.22222,
            0.43056,
            0,
            0,
            0.525
        ],
        "104": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "105": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "106": [
            0.22222,
            0.61111,
            0,
            0,
            0.525
        ],
        "107": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "108": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "109": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "110": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "111": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "112": [
            0.22222,
            0.43056,
            0,
            0,
            0.525
        ],
        "113": [
            0.22222,
            0.43056,
            0,
            0,
            0.525
        ],
        "114": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "115": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "116": [
            0,
            0.55358,
            0,
            0,
            0.525
        ],
        "117": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "118": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "119": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "120": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "121": [
            0.22222,
            0.43056,
            0,
            0,
            0.525
        ],
        "122": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "123": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "124": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "125": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "126": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "127": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.525
        ],
        "176": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "184": [
            0.19445,
            0,
            0,
            0,
            0.525
        ],
        "305": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "567": [
            0.22222,
            0.43056,
            0,
            0,
            0.525
        ],
        "711": [
            0,
            0.56597,
            0,
            0,
            0.525
        ],
        "713": [
            0,
            0.56555,
            0,
            0,
            0.525
        ],
        "714": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "715": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "728": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "730": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "770": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "771": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "776": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "915": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "916": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "920": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "923": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "926": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "928": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "931": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "933": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "934": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "936": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "937": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "8216": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "8217": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "8242": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "9251": [
            0.11111,
            0.21944,
            0,
            0,
            0.525
        ]
    }
};
/**
 * This file contains metrics regarding fonts and individual symbols. The sigma
 * and xi variables, as well as the metricMap map contain data extracted from
 * TeX, TeX font metrics, and the TTF files. These data are then exposed via the
 * `metrics` variable and the getCharacterMetrics function.
 */ // In TeX, there are actually three sets of dimensions, one for each of
// textstyle (size index 5 and higher: >=9pt), scriptstyle (size index 3 and 4:
// 7-8pt), and scriptscriptstyle (size index 1 and 2: 5-6pt).  These are
// provided in the arrays below, in that order.
//
// The font metrics are stored in fonts cmsy10, cmsy7, and cmsy5 respectively.
// This was determined by running the following script:
//
//     latex -interaction=nonstopmode \
//     '\documentclass{article}\usepackage{amsmath}\begin{document}' \
//     '$a$ \expandafter\show\the\textfont2' \
//     '\expandafter\show\the\scriptfont2' \
//     '\expandafter\show\the\scriptscriptfont2' \
//     '\stop'
//
// The metrics themselves were retrieved using the following commands:
//
//     tftopl cmsy10
//     tftopl cmsy7
//     tftopl cmsy5
//
// The output of each of these commands is quite lengthy.  The only part we
// care about is the FONTDIMEN section. Each value is measured in EMs.
var $ef0731f441f79e9a$var$sigmasAndXis = {
    slant: [
        0.250,
        0.250,
        0.250
    ],
    // sigma1
    space: [
        0.000,
        0.000,
        0.000
    ],
    // sigma2
    stretch: [
        0.000,
        0.000,
        0.000
    ],
    // sigma3
    shrink: [
        0.000,
        0.000,
        0.000
    ],
    // sigma4
    xHeight: [
        0.431,
        0.431,
        0.431
    ],
    // sigma5
    quad: [
        1.000,
        1.171,
        1.472
    ],
    // sigma6
    extraSpace: [
        0.000,
        0.000,
        0.000
    ],
    // sigma7
    num1: [
        0.677,
        0.732,
        0.925
    ],
    // sigma8
    num2: [
        0.394,
        0.384,
        0.387
    ],
    // sigma9
    num3: [
        0.444,
        0.471,
        0.504
    ],
    // sigma10
    denom1: [
        0.686,
        0.752,
        1.025
    ],
    // sigma11
    denom2: [
        0.345,
        0.344,
        0.532
    ],
    // sigma12
    sup1: [
        0.413,
        0.503,
        0.504
    ],
    // sigma13
    sup2: [
        0.363,
        0.431,
        0.404
    ],
    // sigma14
    sup3: [
        0.289,
        0.286,
        0.294
    ],
    // sigma15
    sub1: [
        0.150,
        0.143,
        0.200
    ],
    // sigma16
    sub2: [
        0.247,
        0.286,
        0.400
    ],
    // sigma17
    supDrop: [
        0.386,
        0.353,
        0.494
    ],
    // sigma18
    subDrop: [
        0.050,
        0.071,
        0.100
    ],
    // sigma19
    delim1: [
        2.390,
        1.700,
        1.980
    ],
    // sigma20
    delim2: [
        1.010,
        1.157,
        1.420
    ],
    // sigma21
    axisHeight: [
        0.250,
        0.250,
        0.250
    ],
    // sigma22
    // These font metrics are extracted from TeX by using tftopl on cmex10.tfm;
    // they correspond to the font parameters of the extension fonts (family 3).
    // See the TeXbook, page 441. In AMSTeX, the extension fonts scale; to
    // match cmex7, we'd use cmex7.tfm values for script and scriptscript
    // values.
    defaultRuleThickness: [
        0.04,
        0.049,
        0.049
    ],
    // xi8; cmex7: 0.049
    bigOpSpacing1: [
        0.111,
        0.111,
        0.111
    ],
    // xi9
    bigOpSpacing2: [
        0.166,
        0.166,
        0.166
    ],
    // xi10
    bigOpSpacing3: [
        0.2,
        0.2,
        0.2
    ],
    // xi11
    bigOpSpacing4: [
        0.6,
        0.611,
        0.611
    ],
    // xi12; cmex7: 0.611
    bigOpSpacing5: [
        0.1,
        0.143,
        0.143
    ],
    // xi13; cmex7: 0.143
    // The \sqrt rule width is taken from the height of the surd character.
    // Since we use the same font at all sizes, this thickness doesn't scale.
    sqrtRuleThickness: [
        0.04,
        0.04,
        0.04
    ],
    // This value determines how large a pt is, for metrics which are defined
    // in terms of pts.
    // This value is also used in katex.scss; if you change it make sure the
    // values match.
    ptPerEm: [
        10.0,
        10.0,
        10.0
    ],
    // The space between adjacent `|` columns in an array definition. From
    // `\showthe\doublerulesep` in LaTeX. Equals 2.0 / ptPerEm.
    doubleRuleSep: [
        0.2,
        0.2,
        0.2
    ],
    // The width of separator lines in {array} environments. From
    // `\showthe\arrayrulewidth` in LaTeX. Equals 0.4 / ptPerEm.
    arrayRuleWidth: [
        0.04,
        0.04,
        0.04
    ],
    // Two values from LaTeX source2e:
    fboxsep: [
        0.3,
        0.3,
        0.3
    ],
    //        3 pt / ptPerEm
    fboxrule: [
        0.04,
        0.04,
        0.04
    ] // 0.4 pt / ptPerEm
};
// These are very rough approximations.  We default to Times New Roman which
// should have Latin-1 and Cyrillic characters, but may not depending on the
// operating system.  The metrics do not account for extra height from the
// accents.  In the case of Cyrillic characters which have both ascenders and
// descenders we prefer approximations with ascenders, primarily to prevent
// the fraction bar or root line from intersecting the glyph.
// TODO(kevinb) allow union of multiple glyph metrics for better accuracy.
var $ef0731f441f79e9a$var$extraCharacterMap = {
    // Latin-1
    "\xc5": 'A',
    "\xd0": 'D',
    "\xde": 'o',
    "\xe5": 'a',
    "\xf0": 'd',
    "\xfe": 'o',
    // Cyrillic
    "\u0410": 'A',
    "\u0411": 'B',
    "\u0412": 'B',
    "\u0413": 'F',
    "\u0414": 'A',
    "\u0415": 'E',
    "\u0416": 'K',
    "\u0417": '3',
    "\u0418": 'N',
    "\u0419": 'N',
    "\u041A": 'K',
    "\u041B": 'N',
    "\u041C": 'M',
    "\u041D": 'H',
    "\u041E": 'O',
    "\u041F": 'N',
    "\u0420": 'P',
    "\u0421": 'C',
    "\u0422": 'T',
    "\u0423": 'y',
    "\u0424": 'O',
    "\u0425": 'X',
    "\u0426": 'U',
    "\u0427": 'h',
    "\u0428": 'W',
    "\u0429": 'W',
    "\u042A": 'B',
    "\u042B": 'X',
    "\u042C": 'B',
    "\u042D": '3',
    "\u042E": 'X',
    "\u042F": 'R',
    "\u0430": 'a',
    "\u0431": 'b',
    "\u0432": 'a',
    "\u0433": 'r',
    "\u0434": 'y',
    "\u0435": 'e',
    "\u0436": 'm',
    "\u0437": 'e',
    "\u0438": 'n',
    "\u0439": 'n',
    "\u043A": 'n',
    "\u043B": 'n',
    "\u043C": 'm',
    "\u043D": 'n',
    "\u043E": 'o',
    "\u043F": 'n',
    "\u0440": 'p',
    "\u0441": 'c',
    "\u0442": 'o',
    "\u0443": 'y',
    "\u0444": 'b',
    "\u0445": 'x',
    "\u0446": 'n',
    "\u0447": 'n',
    "\u0448": 'w',
    "\u0449": 'w',
    "\u044A": 'a',
    "\u044B": 'm',
    "\u044C": 'a',
    "\u044D": 'e',
    "\u044E": 'm',
    "\u044F": 'r'
};
/**
 * This function adds new font metrics to default metricMap
 * It can also override existing metrics
 */ function $ef0731f441f79e9a$export$48cd0bdd7709b195(fontName, metrics) {
    $ef0731f441f79e9a$var$fontMetricsData[fontName] = metrics;
}
/**
 * This function is a convenience function for looking up information in the
 * metricMap table. It takes a character as a string, and a font.
 *
 * Note: the `width` property may be undefined if fontMetricsData.js wasn't
 * built using `Make extended_metrics`.
 */ function $ef0731f441f79e9a$var$getCharacterMetrics(character, font, mode) {
    if (!$ef0731f441f79e9a$var$fontMetricsData[font]) throw new Error("Font metrics not found for font: " + font + ".");
    var ch = character.charCodeAt(0);
    var metrics = $ef0731f441f79e9a$var$fontMetricsData[font][ch];
    if (!metrics && character[0] in $ef0731f441f79e9a$var$extraCharacterMap) {
        ch = $ef0731f441f79e9a$var$extraCharacterMap[character[0]].charCodeAt(0);
        metrics = $ef0731f441f79e9a$var$fontMetricsData[font][ch];
    }
    if (!metrics && mode === 'text') // We don't typically have font metrics for Asian scripts.
    // But since we support them in text mode, we need to return
    // some sort of metrics.
    // So if the character is in a script we support but we
    // don't have metrics for it, just use the metrics for
    // the Latin capital letter M. This is close enough because
    // we (currently) only care about the height of the glyph
    // not its width.
    {
        if ($ef0731f441f79e9a$var$supportedCodepoint(ch)) metrics = $ef0731f441f79e9a$var$fontMetricsData[font][77]; // 77 is the charcode for 'M'
    }
    if (metrics) return {
        depth: metrics[0],
        height: metrics[1],
        italic: metrics[2],
        skew: metrics[3],
        width: metrics[4]
    };
}
var $ef0731f441f79e9a$var$fontMetricsBySizeIndex = {};
/**
 * Get the font metrics for a given size.
 */ function $ef0731f441f79e9a$var$getGlobalMetrics(size) {
    var sizeIndex;
    if (size >= 5) sizeIndex = 0;
    else if (size >= 3) sizeIndex = 1;
    else sizeIndex = 2;
    if (!$ef0731f441f79e9a$var$fontMetricsBySizeIndex[sizeIndex]) {
        var metrics = $ef0731f441f79e9a$var$fontMetricsBySizeIndex[sizeIndex] = {
            cssEmPerMu: $ef0731f441f79e9a$var$sigmasAndXis.quad[sizeIndex] / 18
        };
        for(var key in $ef0731f441f79e9a$var$sigmasAndXis)if ($ef0731f441f79e9a$var$sigmasAndXis.hasOwnProperty(key)) metrics[key] = $ef0731f441f79e9a$var$sigmasAndXis[key][sizeIndex];
    }
    return $ef0731f441f79e9a$var$fontMetricsBySizeIndex[sizeIndex];
}
/**
 * This file holds a list of all no-argument functions and single-character
 * symbols (like 'a' or ';').
 *
 * For each of the symbols, there are three properties they can have:
 * - font (required): the font to be used for this symbol. Either "main" (the
     normal font), or "ams" (the ams fonts).
 * - group (required): the ParseNode group type the symbol should have (i.e.
     "textord", "mathord", etc).
     See https://github.com/KaTeX/KaTeX/wiki/Examining-TeX#group-types
 * - replace: the character that this symbol or function should be
 *   replaced with (i.e. "\phi" has a replace value of "\u03d5", the phi
 *   character in the main font).
 *
 * The outermost map in the table indicates what mode the symbols should be
 * accepted in (e.g. "math" or "text").
 */ var $ef0731f441f79e9a$var$symbols = {
    "math": {},
    "text": {}
};
/** `acceptUnicodeChar = true` is only applicable if `replace` is set. */ function $ef0731f441f79e9a$export$4de7425e0ddfa6f7(mode, font, group, replace, name, acceptUnicodeChar) {
    $ef0731f441f79e9a$var$symbols[mode][name] = {
        font: font,
        group: group,
        replace: replace
    };
    if (acceptUnicodeChar && replace) $ef0731f441f79e9a$var$symbols[mode][replace] = $ef0731f441f79e9a$var$symbols[mode][name];
}
// Some abbreviations for commonly used strings.
// This helps minify the code, and also spotting typos using jshint.
// modes:
var $ef0731f441f79e9a$var$math = "math";
var $ef0731f441f79e9a$var$text = "text";
// fonts:
var $ef0731f441f79e9a$var$main = "main";
var $ef0731f441f79e9a$var$ams = "ams";
// groups:
var $ef0731f441f79e9a$var$accent = "accent-token";
var $ef0731f441f79e9a$var$bin = "bin";
var $ef0731f441f79e9a$var$close = "close";
var $ef0731f441f79e9a$var$inner = "inner";
var $ef0731f441f79e9a$var$mathord = "mathord";
var $ef0731f441f79e9a$var$op = "op-token";
var $ef0731f441f79e9a$var$open = "open";
var $ef0731f441f79e9a$var$punct = "punct";
var $ef0731f441f79e9a$var$rel = "rel";
var $ef0731f441f79e9a$var$spacing = "spacing";
var $ef0731f441f79e9a$var$textord = "textord";
// Now comes the symbol table
// Relation Symbols
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2261", "\\equiv", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u227a", "\\prec", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u227b", "\\succ", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u223c", "\\sim", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u22a5", "\\perp");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2aaf", "\\preceq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2ab0", "\\succeq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2243", "\\simeq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2223", "\\mid", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u226a", "\\ll", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u226b", "\\gg", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u224d", "\\asymp", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2225", "\\parallel");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u22c8", "\\bowtie", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2323", "\\smile", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2291", "\\sqsubseteq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2292", "\\sqsupseteq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2250", "\\doteq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2322", "\\frown", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u220b", "\\ni", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u221d", "\\propto", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u22a2", "\\vdash", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u22a3", "\\dashv", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u220b", "\\owns");
// Punctuation
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$punct, "\u002e", "\\ldotp");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$punct, "\u22c5", "\\cdotp");
// The KaTeX fonts do not contain U+00B7. Use the centered dot glyph at U+22C5
// in both modes, but keep math-mode punctuation spacing only in math mode.
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$punct, "\u22c5", "\u00b7");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u22c5", "\u00b7");
// Misc Symbols
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0023", "\\#");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0023", "\\#");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0026", "\\&");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0026", "\\&");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2135", "\\aleph", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2200", "\\forall", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u210f", "\\hbar", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2203", "\\exists", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2207", "\\nabla", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u266d", "\\flat", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2113", "\\ell", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u266e", "\\natural", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2663", "\\clubsuit", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2118", "\\wp", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u266f", "\\sharp", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2662", "\\diamondsuit", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u211c", "\\Re", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2661", "\\heartsuit", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2111", "\\Im", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2660", "\\spadesuit", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00a7", "\\S", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00a7", "\\S");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00b6", "\\P", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00b6", "\\P");
// Math and Text
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2020", "\\dag");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2020", "\\dag");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2020", "\\textdagger");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2021", "\\ddag");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2021", "\\ddag");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2021", "\\textdaggerdbl");
// Large Delimiters
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, "\u23b1", "\\rmoustache", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$open, "\u23b0", "\\lmoustache", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, "\u27ef", "\\rgroup", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$open, "\u27ee", "\\lgroup", true);
// Binary Operators
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2213", "\\mp", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2296", "\\ominus", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u228e", "\\uplus", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2293", "\\sqcap", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2217", "\\ast");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2294", "\\sqcup", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u25ef", "\\bigcirc", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2219", "\\bullet", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2021", "\\ddagger");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2240", "\\wr", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2a3f", "\\amalg");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u0026", "\\And"); // from amsmath
// Arrow Symbols
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u27f5", "\\longleftarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21d0", "\\Leftarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u27f8", "\\Longleftarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u27f6", "\\longrightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21d2", "\\Rightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u27f9", "\\Longrightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2194", "\\leftrightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u27f7", "\\longleftrightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21d4", "\\Leftrightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u27fa", "\\Longleftrightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21a6", "\\mapsto", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u27fc", "\\longmapsto", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2197", "\\nearrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21a9", "\\hookleftarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21aa", "\\hookrightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2198", "\\searrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21bc", "\\leftharpoonup", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21c0", "\\rightharpoonup", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2199", "\\swarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21bd", "\\leftharpoondown", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21c1", "\\rightharpoondown", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2196", "\\nwarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21cc", "\\rightleftharpoons", true);
// AMS Negated Binary Relations
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u226e", "\\nless", true);
// Symbol names preceded by "@" each have a corresponding macro.
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue010", "\\@nleqslant");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue011", "\\@nleqq");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2a87", "\\lneq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2268", "\\lneqq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue00c", "\\@lvertneqq");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22e6", "\\lnsim", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2a89", "\\lnapprox", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2280", "\\nprec", true);
// unicode-math maps \u22e0 to \npreccurlyeq. We'll use the AMS synonym.
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22e0", "\\npreceq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22e8", "\\precnsim", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2ab9", "\\precnapprox", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2241", "\\nsim", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue006", "\\@nshortmid");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2224", "\\nmid", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22ac", "\\nvdash", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22ad", "\\nvDash", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22ea", "\\ntriangleleft");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22ec", "\\ntrianglelefteq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u228a", "\\subsetneq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue01a", "\\@varsubsetneq");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2acb", "\\subsetneqq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue017", "\\@varsubsetneqq");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u226f", "\\ngtr", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue00f", "\\@ngeqslant");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue00e", "\\@ngeqq");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2a88", "\\gneq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2269", "\\gneqq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue00d", "\\@gvertneqq");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22e7", "\\gnsim", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2a8a", "\\gnapprox", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2281", "\\nsucc", true);
// unicode-math maps \u22e1 to \nsucccurlyeq. We'll use the AMS synonym.
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22e1", "\\nsucceq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22e9", "\\succnsim", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2aba", "\\succnapprox", true);
// unicode-math maps \u2246 to \simneqq. We'll use the AMS synonym.
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2246", "\\ncong", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue007", "\\@nshortparallel");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2226", "\\nparallel", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22af", "\\nVDash", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22eb", "\\ntriangleright");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22ed", "\\ntrianglerighteq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue018", "\\@nsupseteqq");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u228b", "\\supsetneq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue01b", "\\@varsupsetneq");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2acc", "\\supsetneqq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue019", "\\@varsupsetneqq");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22ae", "\\nVdash", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2ab5", "\\precneqq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2ab6", "\\succneqq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\ue016", "\\@nsubseteqq");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22b4", "\\unlhd");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22b5", "\\unrhd");
// AMS Negated Arrows
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u219a", "\\nleftarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u219b", "\\nrightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21cd", "\\nLeftarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21cf", "\\nRightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21ae", "\\nleftrightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21ce", "\\nLeftrightarrow", true);
// AMS Misc
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u25b3", "\\vartriangle");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u210f", "\\hslash");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u25bd", "\\triangledown");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u25ca", "\\lozenge");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u24c8", "\\circledS");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u00ae", "\\circledR");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u00ae", "\\circledR");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2221", "\\measuredangle", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2204", "\\nexists");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2127", "\\mho");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2132", "\\Finv", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2141", "\\Game", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2035", "\\backprime");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u25b2", "\\blacktriangle");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u25bc", "\\blacktriangledown");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u25a0", "\\blacksquare");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u29eb", "\\blacklozenge");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2605", "\\bigstar");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2222", "\\sphericalangle", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2201", "\\complement", true);
// unicode-math maps U+F0 to \matheth. We map to AMS function \eth
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u00f0", "\\eth", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00f0", "\u00f0");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2571", "\\diagup");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2572", "\\diagdown");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u25a1", "\\square");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u25a1", "\\Box");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u25ca", "\\Diamond");
// unicode-math maps U+A5 to \mathyen. We map to AMS function \yen
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u00a5", "\\yen", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u00a5", "\\yen", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2713", "\\checkmark", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2713", "\\checkmark");
// AMS Hebrew
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2136", "\\beth", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2138", "\\daleth", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2137", "\\gimel", true);
// AMS Greek
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u03dd", "\\digamma", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u03f0", "\\varkappa");
// AMS Delimiters
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$open, "\u250c", "\\@ulcorner", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$close, "\u2510", "\\@urcorner", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$open, "\u2514", "\\@llcorner", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$close, "\u2518", "\\@lrcorner", true);
// AMS Binary Relations
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2266", "\\leqq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2a7d", "\\leqslant", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2a95", "\\eqslantless", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2272", "\\lesssim", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2a85", "\\lessapprox", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u224a", "\\approxeq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22d6", "\\lessdot");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22d8", "\\lll", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2276", "\\lessgtr", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22da", "\\lesseqgtr", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2a8b", "\\lesseqqgtr", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2251", "\\doteqdot");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2253", "\\risingdotseq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2252", "\\fallingdotseq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u223d", "\\backsim", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22cd", "\\backsimeq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2ac5", "\\subseteqq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22d0", "\\Subset", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u228f", "\\sqsubset", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u227c", "\\preccurlyeq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22de", "\\curlyeqprec", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u227e", "\\precsim", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2ab7", "\\precapprox", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22b2", "\\vartriangleleft");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22b4", "\\trianglelefteq");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22a8", "\\vDash", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22aa", "\\Vvdash", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2323", "\\smallsmile");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2322", "\\smallfrown");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u224f", "\\bumpeq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u224e", "\\Bumpeq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2267", "\\geqq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2a7e", "\\geqslant", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2a96", "\\eqslantgtr", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2273", "\\gtrsim", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2a86", "\\gtrapprox", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22d7", "\\gtrdot");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22d9", "\\ggg", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2277", "\\gtrless", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22db", "\\gtreqless", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2a8c", "\\gtreqqless", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2256", "\\eqcirc", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2257", "\\circeq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u225c", "\\triangleq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u223c", "\\thicksim");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2248", "\\thickapprox");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2ac6", "\\supseteqq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22d1", "\\Supset", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2290", "\\sqsupset", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u227d", "\\succcurlyeq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22df", "\\curlyeqsucc", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u227f", "\\succsim", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2ab8", "\\succapprox", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22b3", "\\vartriangleright");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22b5", "\\trianglerighteq");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22a9", "\\Vdash", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2223", "\\shortmid");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2225", "\\shortparallel");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u226c", "\\between", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22d4", "\\pitchfork", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u221d", "\\varpropto");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u25c0", "\\blacktriangleleft");
// unicode-math says that \therefore is a mathord atom.
// We kept the amssymb atom type, which is rel.
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2234", "\\therefore", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u220d", "\\backepsilon");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u25b6", "\\blacktriangleright");
// unicode-math says that \because is a mathord atom.
// We kept the amssymb atom type, which is rel.
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2235", "\\because", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22d8", "\\llless");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22d9", "\\gggtr");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22b2", "\\lhd");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22b3", "\\rhd");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2242", "\\eqsim", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u22c8", "\\Join");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2251", "\\Doteq", true);
// AMS Binary Operators
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u2214", "\\dotplus", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u2216", "\\smallsetminus");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22d2", "\\Cap", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22d3", "\\Cup", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u2a5e", "\\doublebarwedge", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u229f", "\\boxminus", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u229e", "\\boxplus", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22c7", "\\divideontimes", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22c9", "\\ltimes", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22ca", "\\rtimes", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22cb", "\\leftthreetimes", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22cc", "\\rightthreetimes", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22cf", "\\curlywedge", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22ce", "\\curlyvee", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u229d", "\\circleddash", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u229b", "\\circledast", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22c5", "\\centerdot");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22ba", "\\intercal", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22d2", "\\doublecap");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22d3", "\\doublecup");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22a0", "\\boxtimes", true);
// AMS Arrows
// Note: unicode-math maps \u21e2 to their own function \rightdasharrow.
// We'll map it to AMS function \dashrightarrow. It produces the same atom.
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21e2", "\\dashrightarrow", true);
// unicode-math maps \u21e0 to \leftdasharrow. We'll use the AMS synonym.
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21e0", "\\dashleftarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21c7", "\\leftleftarrows", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21c6", "\\leftrightarrows", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21da", "\\Lleftarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u219e", "\\twoheadleftarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21a2", "\\leftarrowtail", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21ab", "\\looparrowleft", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21cb", "\\leftrightharpoons", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21b6", "\\curvearrowleft", true);
// unicode-math maps \u21ba to \acwopencirclearrow. We'll use the AMS synonym.
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21ba", "\\circlearrowleft", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21b0", "\\Lsh", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21c8", "\\upuparrows", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21bf", "\\upharpoonleft", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21c3", "\\downharpoonleft", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u22b6", "\\origof", true); // not in font
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u22b7", "\\imageof", true); // not in font
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u22b8", "\\multimap", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21ad", "\\leftrightsquigarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21c9", "\\rightrightarrows", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21c4", "\\rightleftarrows", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21a0", "\\twoheadrightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21a3", "\\rightarrowtail", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21ac", "\\looparrowright", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21b7", "\\curvearrowright", true);
// unicode-math maps \u21bb to \cwopencirclearrow. We'll use the AMS synonym.
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21bb", "\\circlearrowright", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21b1", "\\Rsh", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21ca", "\\downdownarrows", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21be", "\\upharpoonright", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21c2", "\\downharpoonright", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21dd", "\\rightsquigarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21dd", "\\leadsto");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21db", "\\Rrightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u21be", "\\restriction");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2018", "`");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "$", "\\$");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "$", "\\$");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "$", "\\textdollar");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "%", "\\%");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "%", "\\%");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "_", "\\_");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "_", "\\_");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "_", "\\textunderscore");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2220", "\\angle", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u221e", "\\infty", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2032", "\\prime");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u25b3", "\\triangle");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0393", "\\Gamma", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0394", "\\Delta", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0398", "\\Theta", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u039b", "\\Lambda", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u039e", "\\Xi", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u03a0", "\\Pi", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u03a3", "\\Sigma", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u03a5", "\\Upsilon", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u03a6", "\\Phi", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u03a8", "\\Psi", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u03a9", "\\Omega", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "A", "\u0391");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "B", "\u0392");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "E", "\u0395");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "Z", "\u0396");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "H", "\u0397");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "I", "\u0399");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "K", "\u039A");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "M", "\u039C");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "N", "\u039D");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "O", "\u039F");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "P", "\u03A1");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "T", "\u03A4");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "X", "\u03A7");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00ac", "\\neg", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00ac", "\\lnot");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u22a4", "\\top");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u22a5", "\\bot");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2205", "\\emptyset");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2205", "\\varnothing");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03b1", "\\alpha", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03b2", "\\beta", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03b3", "\\gamma", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03b4", "\\delta", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03f5", "\\epsilon", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03b6", "\\zeta", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03b7", "\\eta", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03b8", "\\theta", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03b9", "\\iota", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03ba", "\\kappa", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03bb", "\\lambda", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03bc", "\\mu", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03bd", "\\nu", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03be", "\\xi", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03bf", "\\omicron", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03c0", "\\pi", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03c1", "\\rho", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03c3", "\\sigma", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03c4", "\\tau", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03c5", "\\upsilon", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03d5", "\\phi", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03c7", "\\chi", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03c8", "\\psi", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03c9", "\\omega", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03b5", "\\varepsilon", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03d1", "\\vartheta", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03d6", "\\varpi", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03f1", "\\varrho", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03c2", "\\varsigma", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\u03c6", "\\varphi", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2217", "*", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "+", "+");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2212", "-", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u22c5", "\\cdot", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2218", "\\circ", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u00f7", "\\div", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u00b1", "\\pm", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u00d7", "\\times", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2229", "\\cap", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u222a", "\\cup", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2216", "\\setminus", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2227", "\\land");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2228", "\\lor");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2227", "\\wedge", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2228", "\\vee", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u221a", "\\surd");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$open, "\u27e8", "\\langle", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$open, "\u2223", "\\lvert");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$open, "\u2225", "\\lVert");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, "?", "?");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, "!", "!");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, "\u27e9", "\\rangle", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, "\u2223", "\\rvert");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, "\u2225", "\\rVert");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "=", "=");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, ":", ":");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2248", "\\approx", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2245", "\\cong", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2265", "\\ge");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2265", "\\geq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2190", "\\gets");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, ">", "\\gt", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2208", "\\in", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\ue020", "\\@not");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2282", "\\subset", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2283", "\\supset", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2286", "\\subseteq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2287", "\\supseteq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2288", "\\nsubseteq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2289", "\\nsupseteq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u22a8", "\\models");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2190", "\\leftarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2264", "\\le");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2264", "\\leq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "<", "\\lt", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2192", "\\rightarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2192", "\\to");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2271", "\\ngeq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$rel, "\u2270", "\\nleq", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$spacing, "\u00a0", "\\ ");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$spacing, "\u00a0", "\\space");
// Ref: LaTeX Source 2e: \DeclareRobustCommand{\nobreakspace}{%
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$spacing, "\u00a0", "\\nobreakspace");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$spacing, "\u00a0", "\\ ");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$spacing, "\u00a0", " ");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$spacing, "\u00a0", "\\space");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$spacing, "\u00a0", "\\nobreakspace");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$spacing, "", "\\nobreak");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$spacing, "", "\\allowbreak");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$punct, ",", ",");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$punct, ";", ";");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22bc", "\\barwedge", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22bb", "\\veebar", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2299", "\\odot", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2295", "\\oplus", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2297", "\\otimes", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2202", "\\partial", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2298", "\\oslash", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u229a", "\\circledcirc", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$bin, "\u22a1", "\\boxdot", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u25b3", "\\bigtriangleup");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u25bd", "\\bigtriangledown");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u2020", "\\dagger");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u22c4", "\\diamond");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u22c6", "\\star");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u25c3", "\\triangleleft");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$bin, "\u25b9", "\\triangleright");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$open, "{", "\\{");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "{", "\\{");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "{", "\\textbraceleft");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, "}", "\\}");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "}", "\\}");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "}", "\\textbraceright");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$open, "{", "\\lbrace");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, "}", "\\rbrace");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$open, "[", "\\lbrack", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "[", "\\lbrack", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, "]", "\\rbrack", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "]", "\\rbrack", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$open, "(", "\\lparen", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, ")", "\\rparen", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "<", "\\textless", true); // in T1 fontenc
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, ">", "\\textgreater", true); // in T1 fontenc
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$open, "\u230a", "\\lfloor", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, "\u230b", "\\rfloor", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$open, "\u2308", "\\lceil", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$close, "\u2309", "\\rceil", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\\", "\\backslash");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2223", "|");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2223", "\\vert");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "|", "\\textbar", true); // in T1 fontenc
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2225", "\\|");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2225", "\\Vert");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2225", "\\textbardbl");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "~", "\\textasciitilde");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\\", "\\textbackslash");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "^", "\\textasciicircum");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2191", "\\uparrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21d1", "\\Uparrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2193", "\\downarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21d3", "\\Downarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u2195", "\\updownarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$rel, "\u21d5", "\\Updownarrow", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u2210", "\\coprod");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u22c1", "\\bigvee");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u22c0", "\\bigwedge");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u2a04", "\\biguplus");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u22c2", "\\bigcap");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u22c3", "\\bigcup");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u222b", "\\int");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u222b", "\\intop");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u222c", "\\iint");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u222d", "\\iiint");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u220f", "\\prod");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u2211", "\\sum");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u2a02", "\\bigotimes");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u2a01", "\\bigoplus");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u2a00", "\\bigodot");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u222e", "\\oint");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u222f", "\\oiint");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u2230", "\\oiiint");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u2a06", "\\bigsqcup");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$op, "\u222b", "\\smallint");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$inner, "\u2026", "\\textellipsis");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$inner, "\u2026", "\\mathellipsis");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$inner, "\u2026", "\\ldots", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$inner, "\u2026", "\\ldots", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$inner, "\u22ef", "\\@cdots", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$inner, "\u22f1", "\\ddots", true);
// \vdots is a macro that uses one of these two symbols (with made-up names):
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u22ee", "\\varvdots");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u22ee", "\\varvdots");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02ca", "\\acute");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02cb", "\\grave");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u00a8", "\\ddot");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u007e", "\\tilde");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02c9", "\\bar");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02d8", "\\breve");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02c7", "\\check");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u005e", "\\hat");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u20d7", "\\vec");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02d9", "\\dot");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02da", "\\mathring");
// \imath and \jmath should be invariant to \mathrm, \mathbf, etc., so use PUA
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\ue131", "\\@imath");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "\ue237", "\\@jmath");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0131", "\u0131");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0237", "\u0237");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0131", "\\i", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0237", "\\j", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00df", "\\ss", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00e6", "\\ae", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0153", "\\oe", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00f8", "\\o", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00c6", "\\AE", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u0152", "\\OE", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00d8", "\\O", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02ca", "\\'"); // acute
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02cb", "\\`"); // grave
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02c6", "\\^"); // circumflex
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02dc", "\\~"); // tilde
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02c9", "\\="); // macron
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02d8", "\\u"); // breve
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02d9", "\\."); // dot above
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u00b8", "\\c"); // cedilla
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02da", "\\r"); // ring above
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02c7", "\\v"); // caron
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u00a8", '\\"'); // diaeresis
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u02dd", "\\H"); // double acute
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$accent, "\u25ef", "\\textcircled"); // \bigcirc glyph
// These ligatures are detected and created in Parser.js's `formLigatures`.
var $ef0731f441f79e9a$var$ligatures = {
    "--": true,
    "---": true,
    "``": true,
    "''": true
};
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2013", "--", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2013", "\\textendash");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2014", "---", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2014", "\\textemdash");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2018", "`", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2018", "\\textquoteleft");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2019", "'", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u2019", "\\textquoteright");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u201c", "``", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u201c", "\\textquotedblleft");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u201d", "''", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u201d", "\\textquotedblright");
//  \degree from gensymb package
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00b0", "\\degree", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00b0", "\\degree");
// \textdegree from inputenc package
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00b0", "\\textdegree", true);
// TODO: In LaTeX, \pounds can generate a different character in text and math
// mode, but among our fonts, only Main-Regular defines this character "163".
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00a3", "\\pounds");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00a3", "\\mathsterling", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00a3", "\\pounds");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "\u00a3", "\\textsterling", true);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2720", "\\maltese");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "\u2720", "\\maltese");
// There are lots of symbols which are the same, so we add them in afterwards.
// All of these are textords in math mode
var $ef0731f441f79e9a$var$mathTextSymbols = "0123456789/@.\"";
for(var $ef0731f441f79e9a$var$i = 0; $ef0731f441f79e9a$var$i < $ef0731f441f79e9a$var$mathTextSymbols.length; $ef0731f441f79e9a$var$i++){
    var $ef0731f441f79e9a$var$ch = $ef0731f441f79e9a$var$mathTextSymbols.charAt($ef0731f441f79e9a$var$i);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$ch, $ef0731f441f79e9a$var$ch);
}
// All of these are textords in text mode
var $ef0731f441f79e9a$var$textSymbols = "0123456789!@*()-=+\";:?/.,";
for(var $ef0731f441f79e9a$var$_i = 0; $ef0731f441f79e9a$var$_i < $ef0731f441f79e9a$var$textSymbols.length; $ef0731f441f79e9a$var$_i++){
    var $ef0731f441f79e9a$var$_ch = $ef0731f441f79e9a$var$textSymbols.charAt($ef0731f441f79e9a$var$_i);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch, $ef0731f441f79e9a$var$_ch);
}
// All of these are textords in text mode, and mathords in math mode
var $ef0731f441f79e9a$var$letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
for(var $ef0731f441f79e9a$var$_i2 = 0; $ef0731f441f79e9a$var$_i2 < $ef0731f441f79e9a$var$letters.length; $ef0731f441f79e9a$var$_i2++){
    var $ef0731f441f79e9a$var$_ch2 = $ef0731f441f79e9a$var$letters.charAt($ef0731f441f79e9a$var$_i2);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch2, $ef0731f441f79e9a$var$_ch2);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch2, $ef0731f441f79e9a$var$_ch2);
}
// Blackboard bold and script letters in Unicode range
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "C", "\u2102"); // blackboard bold
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "C", "\u2102");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "H", "\u210D");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "H", "\u210D");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "N", "\u2115");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "N", "\u2115");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "P", "\u2119");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "P", "\u2119");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "Q", "\u211A");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "Q", "\u211A");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "R", "\u211D");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "R", "\u211D");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "Z", "\u2124");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$ams, $ef0731f441f79e9a$var$textord, "Z", "\u2124");
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "h", "\u210E"); // italic h, Planck constant
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "h", "\u210E");
// The next loop loads wide (surrogate pair) characters.
// We support some letters in the Unicode range U+1D400 to U+1D7FF,
// Mathematical Alphanumeric Symbols.
// Some editors do not deal well with wide characters. So don't write the
// string into this file. Instead, create the string from the surrogate pair.
var $ef0731f441f79e9a$var$wideChar;
for(var $ef0731f441f79e9a$var$_i3 = 0; $ef0731f441f79e9a$var$_i3 < $ef0731f441f79e9a$var$letters.length; $ef0731f441f79e9a$var$_i3++){
    var $ef0731f441f79e9a$var$_ch3 = $ef0731f441f79e9a$var$letters.charAt($ef0731f441f79e9a$var$_i3);
    // The hex numbers in the next line are a surrogate pair.
    // 0xD835 is the high surrogate for all letters in the range we support.
    // 0xDC00 is the low surrogate for bold A.
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDC00 + $ef0731f441f79e9a$var$_i3); // A-Z a-z bold
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDC34 + $ef0731f441f79e9a$var$_i3); // A-Z a-z italic
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDC68 + $ef0731f441f79e9a$var$_i3); // A-Z a-z bold italic
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDD04 + $ef0731f441f79e9a$var$_i3); // A-Z a-z Fraktur
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDD6C + $ef0731f441f79e9a$var$_i3); // A-Z a-z bold Fraktur
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDDA0 + $ef0731f441f79e9a$var$_i3); // A-Z a-z sans-serif
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDDD4 + $ef0731f441f79e9a$var$_i3); // A-Z a-z sans bold
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDE08 + $ef0731f441f79e9a$var$_i3); // A-Z a-z sans italic
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDE70 + $ef0731f441f79e9a$var$_i3); // A-Z a-z monospace
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    if ($ef0731f441f79e9a$var$_i3 < 26) {
        // KaTeX fonts have only capital letters for blackboard bold and script.
        // See exception for k below.
        $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDD38 + $ef0731f441f79e9a$var$_i3); // A-Z double struck
        $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
        $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
        $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDC9C + $ef0731f441f79e9a$var$_i3); // A-Z script
        $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
        $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch3, $ef0731f441f79e9a$var$wideChar);
    }
// TODO: Add bold script when it is supported by a KaTeX font.
}
// "k" is the only double struck lower case letter in the KaTeX fonts.
$ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDD5C); // k double struck
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, "k", $ef0731f441f79e9a$var$wideChar);
$ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, "k", $ef0731f441f79e9a$var$wideChar);
// Next, some wide character numerals
for(var $ef0731f441f79e9a$var$_i4 = 0; $ef0731f441f79e9a$var$_i4 < 10; $ef0731f441f79e9a$var$_i4++){
    var $ef0731f441f79e9a$var$_ch4 = $ef0731f441f79e9a$var$_i4.toString();
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDFCE + $ef0731f441f79e9a$var$_i4); // 0-9 bold
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch4, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch4, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDFE2 + $ef0731f441f79e9a$var$_i4); // 0-9 sans serif
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch4, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch4, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDFEC + $ef0731f441f79e9a$var$_i4); // 0-9 bold sans
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch4, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch4, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$var$wideChar = String.fromCharCode(0xD835, 0xDFF6 + $ef0731f441f79e9a$var$_i4); // 0-9 monospace
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch4, $ef0731f441f79e9a$var$wideChar);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch4, $ef0731f441f79e9a$var$wideChar);
}
// We add these Latin-1 letters as symbols for backwards-compatibility,
// but they are not actually in the font, nor are they supported by the
// Unicode accent mechanism, so they fall back to Times font and look ugly.
// TODO(edemaine): Fix this.
var $ef0731f441f79e9a$var$extraLatin = "\u00d0\u00de\u00fe";
for(var $ef0731f441f79e9a$var$_i5 = 0; $ef0731f441f79e9a$var$_i5 < $ef0731f441f79e9a$var$extraLatin.length; $ef0731f441f79e9a$var$_i5++){
    var $ef0731f441f79e9a$var$_ch5 = $ef0731f441f79e9a$var$extraLatin.charAt($ef0731f441f79e9a$var$_i5);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$math, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$mathord, $ef0731f441f79e9a$var$_ch5, $ef0731f441f79e9a$var$_ch5);
    $ef0731f441f79e9a$export$4de7425e0ddfa6f7($ef0731f441f79e9a$var$text, $ef0731f441f79e9a$var$main, $ef0731f441f79e9a$var$textord, $ef0731f441f79e9a$var$_ch5, $ef0731f441f79e9a$var$_ch5);
}
/**
 * This file provides support for Unicode range U+1D400 to U+1D7FF,
 * Mathematical Alphanumeric Symbols.
 *
 * Function wideCharacterFont takes a wide character as input and returns
 * the font information necessary to render it properly.
 */ var $ef0731f441f79e9a$var$boldUpright = {
    mathClass: "mathbf",
    textClass: "textbf",
    font: "Main-Bold"
};
var $ef0731f441f79e9a$var$italic = {
    mathClass: "mathnormal",
    textClass: "textit",
    font: "Math-Italic"
};
var $ef0731f441f79e9a$var$boldItalic = {
    mathClass: "boldsymbol",
    textClass: "boldsymbol",
    font: "Main-BoldItalic"
};
var $ef0731f441f79e9a$var$script = {
    mathClass: "mathscr",
    textClass: "textscr",
    font: "Script-Regular"
};
var $ef0731f441f79e9a$var$noFont = {
    mathClass: "",
    textClass: "",
    font: ""
};
var $ef0731f441f79e9a$var$fraktur = {
    mathClass: "mathfrak",
    textClass: "textfrak",
    font: "Fraktur-Regular"
};
var $ef0731f441f79e9a$var$doubleStruck = {
    mathClass: "mathbb",
    textClass: "textbb",
    font: "AMS-Regular"
};
var $ef0731f441f79e9a$var$boldFraktur = {
    mathClass: "mathboldfrak",
    textClass: "textboldfrak",
    font: "Fraktur-Regular"
};
var $ef0731f441f79e9a$var$sansSerif = {
    mathClass: "mathsf",
    textClass: "textsf",
    font: "SansSerif-Regular"
};
var $ef0731f441f79e9a$var$boldSansSerif = {
    mathClass: "mathboldsf",
    textClass: "textboldsf",
    font: "SansSerif-Bold"
};
var $ef0731f441f79e9a$var$italicSansSerif = {
    mathClass: "mathitsf",
    textClass: "textitsf",
    font: "SansSerif-Italic"
};
var $ef0731f441f79e9a$var$monospace = {
    mathClass: "mathtt",
    textClass: "texttt",
    font: "Typewriter-Regular"
};
/**
 * Data below is from https://www.unicode.org/charts/PDF/U1D400.pdf
 * That document sorts characters into groups by font type, say bold or italic.
 *
 * In the arrays below, each object consists of three properties:
 *      * The CSS class of that group when in math mode.
 *      * The CSS class of that group when in text mode.
 *      * The font name, so that KaTeX can get font metrics.
 */ var $ef0731f441f79e9a$var$wideLatinLetterData = [
    $ef0731f441f79e9a$var$boldUpright,
    $ef0731f441f79e9a$var$boldUpright,
    // A-Z, a-z
    $ef0731f441f79e9a$var$italic,
    $ef0731f441f79e9a$var$italic,
    // A-Z, a-z
    $ef0731f441f79e9a$var$boldItalic,
    $ef0731f441f79e9a$var$boldItalic,
    // A-Z, a-z
    // Map fancy A-Z letters to script, not calligraphic.
    // This aligns with unicode-math and math fonts (except Cambria Math).
    $ef0731f441f79e9a$var$script,
    $ef0731f441f79e9a$var$noFont,
    // A-Z script, a-z — no font
    $ef0731f441f79e9a$var$noFont,
    $ef0731f441f79e9a$var$noFont,
    // A-Z bold script, a-z bold script — no font
    $ef0731f441f79e9a$var$fraktur,
    $ef0731f441f79e9a$var$fraktur,
    // A-Z, a-z
    $ef0731f441f79e9a$var$doubleStruck,
    $ef0731f441f79e9a$var$doubleStruck,
    // A-Z double-struck, k double-struck
    // Note that we are using a bold font, but font metrics for regular Fraktur.
    $ef0731f441f79e9a$var$boldFraktur,
    $ef0731f441f79e9a$var$boldFraktur,
    // A-Z, a-z
    $ef0731f441f79e9a$var$sansSerif,
    $ef0731f441f79e9a$var$sansSerif,
    // A-Z, a-z
    $ef0731f441f79e9a$var$boldSansSerif,
    $ef0731f441f79e9a$var$boldSansSerif,
    // A-Z, a-z
    $ef0731f441f79e9a$var$italicSansSerif,
    $ef0731f441f79e9a$var$italicSansSerif,
    // A-Z, a-z
    $ef0731f441f79e9a$var$noFont,
    $ef0731f441f79e9a$var$noFont,
    // A-Z bold italic sans, a-z bold italic sans - no font
    $ef0731f441f79e9a$var$monospace,
    $ef0731f441f79e9a$var$monospace // A-Z, a-z
];
var $ef0731f441f79e9a$var$wideNumeralData = [
    $ef0731f441f79e9a$var$boldUpright,
    // 0-9
    $ef0731f441f79e9a$var$noFont,
    // 0-9 double-struck. No KaTeX font.
    $ef0731f441f79e9a$var$sansSerif,
    // 0-9
    $ef0731f441f79e9a$var$boldSansSerif,
    // 0-9
    $ef0731f441f79e9a$var$monospace // 0-9
];
var $ef0731f441f79e9a$var$wideCharacterFont = (wideChar)=>{
    // IE doesn't support codePointAt(). So work with the surrogate pair.
    var H = wideChar.charCodeAt(0); // high surrogate
    var L = wideChar.charCodeAt(1); // low surrogate
    var codePoint = (H - 0xD800) * 0x400 + (L - 0xDC00) + 0x10000;
    if (0x1D400 <= codePoint && codePoint < 0x1D6A4) {
        // wideLatinLetterData contains exactly 26 chars on each row.
        // So we can calculate the relevant row. No traverse necessary.
        var i = Math.floor((codePoint - 0x1D400) / 26);
        return $ef0731f441f79e9a$var$wideLatinLetterData[i];
    } else if (0x1D7CE <= codePoint && codePoint <= 0x1D7FF) {
        // Numerals, ten per row.
        var _i = Math.floor((codePoint - 0x1D7CE) / 10);
        return $ef0731f441f79e9a$var$wideNumeralData[_i];
    } else if (codePoint === 0x1D6A5 || codePoint === 0x1D6A6) // dotless i or j
    return $ef0731f441f79e9a$var$wideLatinLetterData[0];
    else if (0x1D6A6 < codePoint && codePoint < 0x1D7CE) // Greek letters. Not supported, yet.
    return $ef0731f441f79e9a$var$noFont;
    else // We don't support any wide characters outside 1D400–1D7FF.
    throw new $ef0731f441f79e9a$export$f9c837a54db411d("Unsupported character: " + wideChar);
};
/* eslint no-console:0 */ /**
 * Looks up the given symbol in fontMetrics, after applying any symbol
 * replacements defined in symbol.js
 */ var $ef0731f441f79e9a$var$lookupSymbol = function lookupSymbol(value, fontName, mode) {
    // Replace the value with its replaced value from symbol.js
    if ($ef0731f441f79e9a$var$symbols[mode][value]) {
        var replacement = $ef0731f441f79e9a$var$symbols[mode][value].replace;
        if (replacement) value = replacement;
    }
    return {
        value: value,
        metrics: $ef0731f441f79e9a$var$getCharacterMetrics(value, fontName, mode)
    };
};
/**
 * Makes a symbolNode after translation via the list of symbols in symbols.js.
 * Correctly pulls out metrics for the character, and optionally takes a list of
 * classes to be attached to the node.
 *
 * TODO: make argument order closer to makeSpan
 * TODO: add a separate argument for math class (e.g. `mop`, `mbin`), which
 * should if present come first in `classes`.
 * TODO(#953): Make `options` mandatory and always pass it in.
 */ var $ef0731f441f79e9a$var$makeSymbol = function makeSymbol(value, fontName, mode, options, classes) {
    var lookup = $ef0731f441f79e9a$var$lookupSymbol(value, fontName, mode);
    var metrics = lookup.metrics;
    value = lookup.value;
    var symbolNode;
    if (metrics) {
        var italic = metrics.italic;
        if (mode === "text" || options && options.font === "mathit") italic = 0;
        symbolNode = new $ef0731f441f79e9a$var$SymbolNode(value, metrics.height, metrics.depth, italic, metrics.skew, metrics.width, classes);
    } else {
        // TODO(emily): Figure out a good way to only print this in development
        typeof console !== "undefined" && console.warn("No character metrics " + ("for '" + value + "' in style '" + fontName + "' and mode '" + mode + "'"));
        symbolNode = new $ef0731f441f79e9a$var$SymbolNode(value, 0, 0, 0, 0, 0, classes);
    }
    if (options) {
        symbolNode.maxFontSize = options.sizeMultiplier;
        if (options.style.isTight()) symbolNode.classes.push("mtight");
        var color = options.getColor();
        if (color) symbolNode.style.color = color;
    }
    return symbolNode;
};
/**
 * Makes a symbol in Main-Regular or AMS-Regular.
 * Used for rel, bin, open, close, inner, and punct.
 */ var $ef0731f441f79e9a$var$mathsym = function mathsym(value, mode, options, classes) {
    if (classes === void 0) classes = [];
    // Decide what font to render the symbol in by its entry in the symbols
    // table.
    // Have a special case for when the value = \ because the \ is used as a
    // textord in unsupported command errors but cannot be parsed as a regular
    // text ordinal and is therefore not present as a symbol in the symbols
    // table for text, as well as a special case for boldsymbol because it
    // can be used for bold + and -
    if (options.font === "boldsymbol" && $ef0731f441f79e9a$var$lookupSymbol(value, "Main-Bold", mode).metrics) return $ef0731f441f79e9a$var$makeSymbol(value, "Main-Bold", mode, options, classes.concat([
        "mathbf"
    ]));
    else if (value === "\\" || $ef0731f441f79e9a$var$symbols[mode][value].font === "main") return $ef0731f441f79e9a$var$makeSymbol(value, "Main-Regular", mode, options, classes);
    else return $ef0731f441f79e9a$var$makeSymbol(value, "AMS-Regular", mode, options, classes.concat([
        "amsrm"
    ]));
};
/**
 * Determines which of the two font names (Main-Bold and Math-BoldItalic) and
 * corresponding style tags (mathbf or boldsymbol) to use for font "boldsymbol",
 * depending on the symbol.  Use this function instead of fontMap for font
 * "boldsymbol".
 */ var $ef0731f441f79e9a$var$boldSymbol = function boldSymbol(value, mode, type) {
    if (type !== "textord" && $ef0731f441f79e9a$var$lookupSymbol(value, "Math-BoldItalic", mode).metrics) return {
        fontName: "Math-BoldItalic",
        fontClass: "boldsymbol"
    };
    else // Some glyphs do not exist in Math-BoldItalic so we need to use
    // Main-Bold instead.
    return {
        fontName: "Main-Bold",
        fontClass: "mathbf"
    };
};
/**
 * Makes either a mathord or textord in the correct font and color.
 */ var $ef0731f441f79e9a$var$makeOrd = function makeOrd(group, options, type) {
    var mode = group.mode;
    var text = group.text;
    var classes = [
        "mord"
    ];
    var { font: font, fontFamily: fontFamily, fontWeight: fontWeight, fontShape: fontShape } = options;
    // Math mode or Old font (i.e. \rm)
    var useFont = mode === "math" || mode === "text" && !!font;
    var fontOrFamily = useFont ? font : fontFamily;
    var wideFontName = "";
    var wideFontClass = "";
    if (text.charCodeAt(0) === 0xD835) {
        var wideCharData = $ef0731f441f79e9a$var$wideCharacterFont(text);
        wideFontName = wideCharData.font;
        wideFontClass = wideCharData[mode + "Class"];
    }
    if (wideFontName) // surrogate pairs get special treatment
    return $ef0731f441f79e9a$var$makeSymbol(text, wideFontName, mode, options, classes.concat(wideFontClass));
    else if (fontOrFamily) {
        var fontName;
        var fontClasses;
        if (fontOrFamily === "boldsymbol") {
            var fontData = $ef0731f441f79e9a$var$boldSymbol(text, mode, type);
            fontName = fontData.fontName;
            fontClasses = [
                fontData.fontClass
            ];
        } else if (useFont) {
            fontName = $ef0731f441f79e9a$var$fontMap[font].fontName;
            fontClasses = [
                font
            ];
        } else {
            fontName = $ef0731f441f79e9a$var$retrieveTextFontName(fontFamily, fontWeight, fontShape);
            fontClasses = [
                fontFamily,
                fontWeight,
                fontShape
            ];
        }
        if ($ef0731f441f79e9a$var$lookupSymbol(text, fontName, mode).metrics) return $ef0731f441f79e9a$var$makeSymbol(text, fontName, mode, options, classes.concat(fontClasses));
        else if ($ef0731f441f79e9a$var$ligatures.hasOwnProperty(text) && fontName.slice(0, 10) === "Typewriter") {
            // Deconstruct ligatures in monospace fonts (\texttt, \tt).
            var parts = [];
            for(var i = 0; i < text.length; i++)parts.push($ef0731f441f79e9a$var$makeSymbol(text[i], fontName, mode, options, classes.concat(fontClasses)));
            return $ef0731f441f79e9a$var$makeFragment(parts);
        }
    }
    // Makes a symbol in the default font for mathords and textords.
    if (type === "mathord") return $ef0731f441f79e9a$var$makeSymbol(text, "Math-Italic", mode, options, classes.concat([
        "mathnormal"
    ]));
    else if (type === "textord") {
        var _font = $ef0731f441f79e9a$var$symbols[mode][text] && $ef0731f441f79e9a$var$symbols[mode][text].font;
        if (_font === "ams") {
            var _fontName = $ef0731f441f79e9a$var$retrieveTextFontName("amsrm", fontWeight, fontShape);
            return $ef0731f441f79e9a$var$makeSymbol(text, _fontName, mode, options, classes.concat("amsrm", fontWeight, fontShape));
        } else if (_font === "main" || !_font) {
            var _fontName2 = $ef0731f441f79e9a$var$retrieveTextFontName("textrm", fontWeight, fontShape);
            return $ef0731f441f79e9a$var$makeSymbol(text, _fontName2, mode, options, classes.concat(fontWeight, fontShape));
        } else {
            // fonts added by plugins
            var _fontName3 = $ef0731f441f79e9a$var$retrieveTextFontName(_font, fontWeight, fontShape);
            // We add font name as a css class
            return $ef0731f441f79e9a$var$makeSymbol(text, _fontName3, mode, options, classes.concat(_fontName3, fontWeight, fontShape));
        }
    } else throw new Error("unexpected type: " + type + " in makeOrd");
};
/**
 * Returns true if subsequent symbolNodes have the same classes, skew, maxFont,
 * and styles. For mathnormal text, the left node must also have zero italic
 * correction so we don't lose spacing between combined glyphs.
 */ var $ef0731f441f79e9a$var$canCombine = (prev, next)=>{
    if ($ef0731f441f79e9a$var$createClass(prev.classes) !== $ef0731f441f79e9a$var$createClass(next.classes) || prev.skew !== next.skew || prev.maxFontSize !== next.maxFontSize || prev.italic !== 0 && prev.hasClass("mathnormal")) return false;
    // If prev and next both are just "mbin"s or "mord"s we don't combine them
    // so that the proper spacing can be preserved.
    if (prev.classes.length === 1) {
        var cls = prev.classes[0];
        if (cls === "mbin" || cls === "mord") return false;
    }
    for (var key of Object.keys(prev.style)){
        if (prev.style[key] !== next.style[key]) return false;
    }
    for (var _key of Object.keys(next.style)){
        if (prev.style[_key] !== next.style[_key]) return false;
    }
    return true;
};
/**
 * Combine consecutive domTree.symbolNodes into a single symbolNode.
 * Note: this function mutates the argument.
 */ var $ef0731f441f79e9a$var$tryCombineChars = (chars)=>{
    for(var i = 0; i < chars.length - 1; i++){
        var prev = chars[i];
        var next = chars[i + 1];
        if (prev instanceof $ef0731f441f79e9a$var$SymbolNode && next instanceof $ef0731f441f79e9a$var$SymbolNode && $ef0731f441f79e9a$var$canCombine(prev, next)) {
            prev.text += next.text;
            prev.height = Math.max(prev.height, next.height);
            prev.depth = Math.max(prev.depth, next.depth);
            // Use the last character's italic correction since we use
            // it to add padding to the right of the span created from
            // the combined characters.
            prev.italic = next.italic;
            chars.splice(i + 1, 1);
            i--;
        }
    }
    return chars;
};
/**
 * Calculate the height, depth, and maxFontSize of an element based on its
 * children.
 */ var $ef0731f441f79e9a$var$sizeElementFromChildren = function sizeElementFromChildren(elem) {
    var height = 0;
    var depth = 0;
    var maxFontSize = 0;
    for(var i = 0; i < elem.children.length; i++){
        var child = elem.children[i];
        if (child.height > height) height = child.height;
        if (child.depth > depth) depth = child.depth;
        if (child.maxFontSize > maxFontSize) maxFontSize = child.maxFontSize;
    }
    elem.height = height;
    elem.depth = depth;
    elem.maxFontSize = maxFontSize;
};
/**
 * Makes a span with the given list of classes, list of children, and options.
 *
 * TODO(#953): Ensure that `options` is always provided (currently some call
 * sites don't pass it) and make the type below mandatory.
 * TODO: add a separate argument for math class (e.g. `mop`, `mbin`), which
 * should if present come first in `classes`.
 */ var $ef0731f441f79e9a$var$makeSpan = function makeSpan(classes, children, options, style) {
    var span = new $ef0731f441f79e9a$var$Span(classes, children, options, style);
    $ef0731f441f79e9a$var$sizeElementFromChildren(span);
    return span;
};
// SVG one is simpler -- doesn't require height, depth, max-font setting.
// This is also a separate method for typesafety.
var $ef0731f441f79e9a$var$makeSvgSpan = (classes, children, options, style)=>new $ef0731f441f79e9a$var$Span(classes, children, options, style);
var $ef0731f441f79e9a$var$makeLineSpan = function makeLineSpan(className, options, thickness) {
    var line = $ef0731f441f79e9a$var$makeSpan([
        className
    ], [], options);
    line.height = Math.max(thickness || options.fontMetrics().defaultRuleThickness, options.minRuleThickness);
    line.style.borderBottomWidth = $ef0731f441f79e9a$var$makeEm(line.height);
    line.maxFontSize = 1.0;
    return line;
};
/**
 * Makes an anchor with the given href, list of classes, list of children,
 * and options.
 */ var $ef0731f441f79e9a$var$makeAnchor = function makeAnchor(href, classes, children, options) {
    var anchor = new $ef0731f441f79e9a$var$Anchor(href, classes, children, options);
    $ef0731f441f79e9a$var$sizeElementFromChildren(anchor);
    return anchor;
};
/**
 * Makes a document fragment with the given list of children.
 */ var $ef0731f441f79e9a$var$makeFragment = function makeFragment(children) {
    var fragment = new $ef0731f441f79e9a$var$DocumentFragment(children);
    $ef0731f441f79e9a$var$sizeElementFromChildren(fragment);
    return fragment;
};
/**
 * Wraps group in a span if it's a document fragment, allowing to apply classes
 * and styles
 */ var $ef0731f441f79e9a$var$wrapFragment = function wrapFragment(group, options) {
    if (group instanceof $ef0731f441f79e9a$var$DocumentFragment) return $ef0731f441f79e9a$var$makeSpan([], [
        group
    ], options);
    return group;
};
// Computes the updated `children` list and the overall depth.
//
// This helper function for makeVList makes it easier to enforce type safety by
// allowing early exits (returns) in the logic.
var $ef0731f441f79e9a$var$getVListChildrenAndDepth = function getVListChildrenAndDepth(params) {
    if (params.positionType === "individualShift") {
        var oldChildren = params.children;
        var children = [
            oldChildren[0]
        ];
        // Add in kerns to the list of params.children to get each element to be
        // shifted to the correct specified shift
        var _depth = -oldChildren[0].shift - oldChildren[0].elem.depth;
        var currPos = _depth;
        for(var i = 1; i < oldChildren.length; i++){
            var diff = -oldChildren[i].shift - currPos - oldChildren[i].elem.depth;
            var size = diff - (oldChildren[i - 1].elem.height + oldChildren[i - 1].elem.depth);
            currPos = currPos + diff;
            children.push({
                type: "kern",
                size: size
            });
            children.push(oldChildren[i]);
        }
        return {
            children: children,
            depth: _depth
        };
    }
    var depth;
    if (params.positionType === "top") {
        // We always start at the bottom, so calculate the bottom by adding up
        // all the sizes
        var bottom = params.positionData;
        for(var _i = 0; _i < params.children.length; _i++){
            var child = params.children[_i];
            bottom -= child.type === "kern" ? child.size : child.elem.height + child.elem.depth;
        }
        depth = bottom;
    } else if (params.positionType === "bottom") depth = -params.positionData;
    else {
        var firstChild = params.children[0];
        if (firstChild.type !== "elem") throw new Error('First child must have type "elem".');
        if (params.positionType === "shift") depth = -firstChild.elem.depth - params.positionData;
        else if (params.positionType === "firstBaseline") depth = -firstChild.elem.depth;
        else throw new Error("Invalid positionType " + params.positionType + ".");
    }
    return {
        children: params.children,
        depth: depth
    };
};
/**
 * Makes a vertical list by stacking elements and kerns on top of each other.
 * Allows for many different ways of specifying the positioning method.
 *
 * See VListParam documentation above.
 */ var $ef0731f441f79e9a$var$makeVList = function makeVList(params, options) {
    var { children: children, depth: depth } = $ef0731f441f79e9a$var$getVListChildrenAndDepth(params);
    // Create a strut that is taller than any list item. The strut is added to
    // each item, where it will determine the item's baseline. Since it has
    // `overflow:hidden`, the strut's top edge will sit on the item's line box's
    // top edge and the strut's bottom edge will sit on the item's baseline,
    // with no additional line-height spacing. This allows the item baseline to
    // be positioned precisely without worrying about font ascent and
    // line-height.
    var pstrutSize = 0;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        if (child.type === "elem") {
            var elem = child.elem;
            pstrutSize = Math.max(pstrutSize, elem.maxFontSize, elem.height);
        }
    }
    pstrutSize += 2;
    var pstrut = $ef0731f441f79e9a$var$makeSpan([
        "pstrut"
    ], []);
    pstrut.style.height = $ef0731f441f79e9a$var$makeEm(pstrutSize);
    // Create a new list of actual children at the correct offsets
    var realChildren = [];
    var minPos = depth;
    var maxPos = depth;
    var currPos = depth;
    for(var _i2 = 0; _i2 < children.length; _i2++){
        var _child = children[_i2];
        if (_child.type === "kern") currPos += _child.size;
        else {
            var _elem = _child.elem;
            var classes = _child.wrapperClasses || [];
            var style = _child.wrapperStyle || {};
            var childWrap = $ef0731f441f79e9a$var$makeSpan(classes, [
                pstrut,
                _elem
            ], undefined, style);
            childWrap.style.top = $ef0731f441f79e9a$var$makeEm(-pstrutSize - currPos - _elem.depth);
            if (_child.marginLeft) childWrap.style.marginLeft = _child.marginLeft;
            if (_child.marginRight) childWrap.style.marginRight = _child.marginRight;
            realChildren.push(childWrap);
            currPos += _elem.height + _elem.depth;
        }
        minPos = Math.min(minPos, currPos);
        maxPos = Math.max(maxPos, currPos);
    }
    // The vlist contents go in a table-cell with `vertical-align:bottom`.
    // This cell's bottom edge will determine the containing table's baseline
    // without overly expanding the containing line-box.
    var vlist = $ef0731f441f79e9a$var$makeSpan([
        "vlist"
    ], realChildren);
    vlist.style.height = $ef0731f441f79e9a$var$makeEm(maxPos);
    // A second row is used if necessary to represent the vlist's depth.
    var rows;
    if (minPos < 0) {
        // We will define depth in an empty span with display: table-cell.
        // It should render with the height that we define. But Chrome, in
        // contenteditable mode only, treats that span as if it contains some
        // text content. And that min-height over-rides our desired height.
        // So we put another empty span inside the depth strut span.
        var emptySpan = $ef0731f441f79e9a$var$makeSpan([], []);
        var depthStrut = $ef0731f441f79e9a$var$makeSpan([
            "vlist"
        ], [
            emptySpan
        ]);
        depthStrut.style.height = $ef0731f441f79e9a$var$makeEm(-minPos);
        // Safari wants the first row to have inline content; otherwise it
        // puts the bottom of the *second* row on the baseline.
        var topStrut = $ef0731f441f79e9a$var$makeSpan([
            "vlist-s"
        ], [
            new $ef0731f441f79e9a$var$SymbolNode("\u200b")
        ]);
        rows = [
            $ef0731f441f79e9a$var$makeSpan([
                "vlist-r"
            ], [
                vlist,
                topStrut
            ]),
            $ef0731f441f79e9a$var$makeSpan([
                "vlist-r"
            ], [
                depthStrut
            ])
        ];
    } else rows = [
        $ef0731f441f79e9a$var$makeSpan([
            "vlist-r"
        ], [
            vlist
        ])
    ];
    var vtable = $ef0731f441f79e9a$var$makeSpan([
        "vlist-t"
    ], rows);
    if (rows.length === 2) vtable.classes.push("vlist-t2");
    vtable.height = maxPos;
    vtable.depth = -minPos;
    return vtable;
};
// Glue is a concept from TeX which is a flexible space between elements in
// either a vertical or horizontal list. In KaTeX, at least for now, it's
// static space between elements in a horizontal layout.
var $ef0731f441f79e9a$var$makeGlue = (measurement, options)=>{
    // Make an empty span for the space
    var rule = $ef0731f441f79e9a$var$makeSpan([
        "mspace"
    ], [], options);
    var size = $ef0731f441f79e9a$var$calculateSize(measurement, options);
    rule.style.marginRight = $ef0731f441f79e9a$var$makeEm(size);
    return rule;
};
// Takes font options, and returns the appropriate fontLookup name
var $ef0731f441f79e9a$var$retrieveTextFontName = (fontFamily, fontWeight, fontShape)=>{
    var baseFontName;
    var fontStylesName;
    switch(fontFamily){
        case "amsrm":
            baseFontName = "AMS";
            break;
        case "textrm":
            baseFontName = "Main";
            break;
        case "textsf":
            baseFontName = "SansSerif";
            break;
        case "texttt":
            baseFontName = "Typewriter";
            break;
        default:
            baseFontName = fontFamily;
    }
    if (fontWeight === "textbf" && fontShape === "textit") fontStylesName = "BoldItalic";
    else if (fontWeight === "textbf") fontStylesName = "Bold";
    else if (fontShape === "textit") fontStylesName = "Italic";
    else fontStylesName = "Regular";
    return baseFontName + "-" + fontStylesName;
};
/**
 * Maps TeX font commands to objects containing:
 * - variant: string used for "mathvariant" attribute in buildMathML.js
 * - fontName: the "style" parameter to fontMetrics.getCharacterMetrics
 */ // A map between tex font commands an MathML mathvariant attribute values
var $ef0731f441f79e9a$var$fontMap = {
    // styles
    "mathbf": {
        variant: "bold",
        fontName: "Main-Bold"
    },
    "mathrm": {
        variant: "normal",
        fontName: "Main-Regular"
    },
    "textit": {
        variant: "italic",
        fontName: "Main-Italic"
    },
    "mathit": {
        variant: "italic",
        fontName: "Main-Italic"
    },
    "mathnormal": {
        variant: "italic",
        fontName: "Math-Italic"
    },
    "mathsfit": {
        variant: "sans-serif-italic",
        fontName: "SansSerif-Italic"
    },
    // "boldsymbol" is missing because they require the use of multiple fonts:
    // Math-BoldItalic and Main-Bold.  This is handled by a special case in
    // makeOrd which ends up calling boldsymbol.
    // families
    "mathbb": {
        variant: "double-struck",
        fontName: "AMS-Regular"
    },
    "mathcal": {
        variant: "script",
        fontName: "Caligraphic-Regular"
    },
    "mathfrak": {
        variant: "fraktur",
        fontName: "Fraktur-Regular"
    },
    "mathscr": {
        variant: "script",
        fontName: "Script-Regular"
    },
    "mathsf": {
        variant: "sans-serif",
        fontName: "SansSerif-Regular"
    },
    "mathtt": {
        variant: "monospace",
        fontName: "Typewriter-Regular"
    }
};
var $ef0731f441f79e9a$var$svgData = {
    //   path, width, height
    vec: [
        "vec",
        0.471,
        0.714
    ],
    // values from the font glyph
    oiintSize1: [
        "oiintSize1",
        0.957,
        0.499
    ],
    // oval to overlay the integrand
    oiintSize2: [
        "oiintSize2",
        1.472,
        0.659
    ],
    oiiintSize1: [
        "oiiintSize1",
        1.304,
        0.499
    ],
    oiiintSize2: [
        "oiiintSize2",
        1.98,
        0.659
    ]
};
var $ef0731f441f79e9a$var$staticSvg = function staticSvg(value, options) {
    // Create a span with inline SVG for the element.
    var [pathName, width, height] = $ef0731f441f79e9a$var$svgData[value];
    var path = new $ef0731f441f79e9a$var$PathNode(pathName);
    var svgNode = new $ef0731f441f79e9a$var$SvgNode([
        path
    ], {
        "width": $ef0731f441f79e9a$var$makeEm(width),
        "height": $ef0731f441f79e9a$var$makeEm(height),
        // Override CSS rule `.katex svg { width: 100% }`
        "style": "width:" + $ef0731f441f79e9a$var$makeEm(width),
        "viewBox": "0 0 " + 1000 * width + " " + 1000 * height,
        "preserveAspectRatio": "xMinYMin"
    });
    var span = $ef0731f441f79e9a$var$makeSvgSpan([
        "overlay"
    ], [
        svgNode
    ], options);
    span.height = height;
    span.style.height = $ef0731f441f79e9a$var$makeEm(height);
    span.style.width = $ef0731f441f79e9a$var$makeEm(width);
    return span;
};
var $ef0731f441f79e9a$var$thinspace = {
    number: 3,
    unit: "mu"
};
var $ef0731f441f79e9a$var$mediumspace = {
    number: 4,
    unit: "mu"
};
var $ef0731f441f79e9a$var$thickspace = {
    number: 5,
    unit: "mu"
};
// Spacing relationships for display and text styles
var $ef0731f441f79e9a$var$spacings = {
    mord: {
        mop: $ef0731f441f79e9a$var$thinspace,
        mbin: $ef0731f441f79e9a$var$mediumspace,
        mrel: $ef0731f441f79e9a$var$thickspace,
        minner: $ef0731f441f79e9a$var$thinspace
    },
    mop: {
        mord: $ef0731f441f79e9a$var$thinspace,
        mop: $ef0731f441f79e9a$var$thinspace,
        mrel: $ef0731f441f79e9a$var$thickspace,
        minner: $ef0731f441f79e9a$var$thinspace
    },
    mbin: {
        mord: $ef0731f441f79e9a$var$mediumspace,
        mop: $ef0731f441f79e9a$var$mediumspace,
        mopen: $ef0731f441f79e9a$var$mediumspace,
        minner: $ef0731f441f79e9a$var$mediumspace
    },
    mrel: {
        mord: $ef0731f441f79e9a$var$thickspace,
        mop: $ef0731f441f79e9a$var$thickspace,
        mopen: $ef0731f441f79e9a$var$thickspace,
        minner: $ef0731f441f79e9a$var$thickspace
    },
    mopen: {},
    mclose: {
        mop: $ef0731f441f79e9a$var$thinspace,
        mbin: $ef0731f441f79e9a$var$mediumspace,
        mrel: $ef0731f441f79e9a$var$thickspace,
        minner: $ef0731f441f79e9a$var$thinspace
    },
    mpunct: {
        mord: $ef0731f441f79e9a$var$thinspace,
        mop: $ef0731f441f79e9a$var$thinspace,
        mrel: $ef0731f441f79e9a$var$thickspace,
        mopen: $ef0731f441f79e9a$var$thinspace,
        mclose: $ef0731f441f79e9a$var$thinspace,
        mpunct: $ef0731f441f79e9a$var$thinspace,
        minner: $ef0731f441f79e9a$var$thinspace
    },
    minner: {
        mord: $ef0731f441f79e9a$var$thinspace,
        mop: $ef0731f441f79e9a$var$thinspace,
        mbin: $ef0731f441f79e9a$var$mediumspace,
        mrel: $ef0731f441f79e9a$var$thickspace,
        mopen: $ef0731f441f79e9a$var$thinspace,
        mpunct: $ef0731f441f79e9a$var$thinspace,
        minner: $ef0731f441f79e9a$var$thinspace
    }
};
// Spacing relationships for script and scriptscript styles
var $ef0731f441f79e9a$var$tightSpacings = {
    mord: {
        mop: $ef0731f441f79e9a$var$thinspace
    },
    mop: {
        mord: $ef0731f441f79e9a$var$thinspace,
        mop: $ef0731f441f79e9a$var$thinspace
    },
    mbin: {},
    mrel: {},
    mopen: {},
    mclose: {
        mop: $ef0731f441f79e9a$var$thinspace
    },
    mpunct: {},
    minner: {
        mop: $ef0731f441f79e9a$var$thinspace
    }
};
/**
 * All registered functions.
 * `functions.js` just exports this same dictionary again and makes it public.
 * `Parser.js` requires this dictionary.
 */ var $ef0731f441f79e9a$var$_functions = {};
/**
 * All HTML builders. Should be only used in the `define*` and the `build*ML`
 * functions.
 *
 * Builders for different node types are stored side by side, but
 * `HtmlBuilder<T>` is contravariant in `T`, so there is no single type
 * argument that makes storing/retrieving them typecheck.  `any` is used
 * as an existential-quantifier escape hatch.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $ef0731f441f79e9a$var$_htmlGroupBuilders = {};
/**
 * All MathML builders. Should be only used in the `define*` and the `build*ML`
 * functions.  See `_htmlGroupBuilders` above for the rationale behind `any`.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $ef0731f441f79e9a$var$_mathmlGroupBuilders = {};
function $ef0731f441f79e9a$export$6eeef399b524690e(_ref) {
    var { type: type, names: names, props: props, handler: handler, htmlBuilder: htmlBuilder, mathmlBuilder: mathmlBuilder } = _ref;
    // Set default values of functions
    var data = {
        type: type,
        numArgs: props.numArgs,
        argTypes: props.argTypes,
        allowedInArgument: !!props.allowedInArgument,
        allowedInText: !!props.allowedInText,
        allowedInMath: props.allowedInMath === undefined ? true : props.allowedInMath,
        numOptionalArgs: props.numOptionalArgs || 0,
        infix: !!props.infix,
        primitive: !!props.primitive,
        handler: handler
    };
    for(var i = 0; i < names.length; ++i)$ef0731f441f79e9a$var$_functions[names[i]] = data;
    if (type) {
        if (htmlBuilder) $ef0731f441f79e9a$var$_htmlGroupBuilders[type] = htmlBuilder;
        if (mathmlBuilder) $ef0731f441f79e9a$var$_mathmlGroupBuilders[type] = mathmlBuilder;
    }
}
/**
 * Use this to register only the HTML and MathML builders for a function (e.g.
 * if the function's ParseNode is generated in Parser.js rather than via a
 * stand-alone handler provided to `defineFunction`).
 */ function $ef0731f441f79e9a$var$defineFunctionBuilders(_ref2) {
    var { type: type, htmlBuilder: htmlBuilder, mathmlBuilder: mathmlBuilder } = _ref2;
    $ef0731f441f79e9a$export$6eeef399b524690e({
        type: type,
        names: [],
        props: {
            numArgs: 0
        },
        handler () {
            throw new Error('Should never be called.');
        },
        htmlBuilder: htmlBuilder,
        mathmlBuilder: mathmlBuilder
    });
}
var $ef0731f441f79e9a$var$normalizeArgument = function normalizeArgument(arg) {
    return arg.type === "ordgroup" && arg.body.length === 1 ? arg.body[0] : arg;
};
// Since the corresponding buildHTML/buildMathML function expects a
// list of elements, we normalize for different kinds of arguments
var $ef0731f441f79e9a$var$ordargument = function ordargument(arg) {
    return arg.type === "ordgroup" ? arg.body : [
        arg
    ];
};
/**
 * This file does the main work of building a domTree structure from a parse
 * tree. The entry point is the `buildHTML` function, which takes a parse tree.
 * Then, the buildExpression, buildGroup, and various groupBuilders functions
 * are called, to produce a final HTML tree.
 */ // Binary atoms (first class `mbin`) change into ordinary atoms (`mord`)
// depending on their surroundings. See TeXbook pg. 442-446, Rules 5 and 6,
// and the text before Rule 19.
var $ef0731f441f79e9a$var$binLeftCanceller = new Set([
    "leftmost",
    "mbin",
    "mopen",
    "mrel",
    "mop",
    "mpunct"
]);
var $ef0731f441f79e9a$var$binRightCanceller = new Set([
    "rightmost",
    "mrel",
    "mclose",
    "mpunct"
]);
var $ef0731f441f79e9a$var$styleMap$1 = {
    "display": $ef0731f441f79e9a$var$Style$1.DISPLAY,
    "text": $ef0731f441f79e9a$var$Style$1.TEXT,
    "script": $ef0731f441f79e9a$var$Style$1.SCRIPT,
    "scriptscript": $ef0731f441f79e9a$var$Style$1.SCRIPTSCRIPT
};
var $ef0731f441f79e9a$var$DomEnum = {
    mord: "mord",
    mop: "mop",
    mbin: "mbin",
    mrel: "mrel",
    mopen: "mopen",
    mclose: "mclose",
    mpunct: "mpunct",
    minner: "minner"
};
/**
 * Take a list of nodes, build them in order, and return a list of the built
 * nodes. documentFragments are flattened into their contents, so the
 * returned list contains no fragments. `isRealGroup` is true if `expression`
 * is a real group (no atoms will be added on either side), as opposed to
 * a partial group (e.g. one created by \color). `surrounding` is an array
 * consisting type of nodes that will be added to the left and right.
 */ var $ef0731f441f79e9a$var$buildExpression$1 = function buildExpression(expression, options, isRealGroup, surrounding) {
    if (surrounding === void 0) surrounding = [
        null,
        null
    ];
    // Parse expressions into `groups`.
    var groups = [];
    for(var i = 0; i < expression.length; i++){
        var output = $ef0731f441f79e9a$var$buildGroup$1(expression[i], options);
        if (output instanceof $ef0731f441f79e9a$var$DocumentFragment) {
            var children = output.children;
            groups.push(...children);
        } else groups.push(output);
    }
    // Combine consecutive domTree.symbolNodes into a single symbolNode.
    $ef0731f441f79e9a$var$tryCombineChars(groups);
    // If `expression` is a partial group, let the parent handle spacings
    // to avoid processing groups multiple times.
    if (!isRealGroup) return groups;
    var glueOptions = options;
    if (expression.length === 1) {
        var node = expression[0];
        if (node.type === "sizing") glueOptions = options.havingSize(node.size);
        else if (node.type === "styling") glueOptions = options.havingStyle($ef0731f441f79e9a$var$styleMap$1[node.style]);
    }
    // Dummy spans for determining spacings between surrounding atoms.
    // If `expression` has no atoms on the left or right, class "leftmost"
    // or "rightmost", respectively, is used to indicate it.
    var dummyPrev = $ef0731f441f79e9a$var$makeSpan([
        surrounding[0] || "leftmost"
    ], [], options);
    var dummyNext = $ef0731f441f79e9a$var$makeSpan([
        surrounding[1] || "rightmost"
    ], [], options);
    // TODO: These code assumes that a node's math class is the first element
    // of its `classes` array. A later cleanup should ensure this, for
    // instance by changing the signature of `makeSpan`.
    // Before determining what spaces to insert, perform bin cancellation.
    // Binary operators change to ordinary symbols in some contexts.
    var isRoot = isRealGroup === "root";
    $ef0731f441f79e9a$var$_traverseNonSpaceNodes(groups, (node, prev)=>{
        var prevType = prev.classes[0];
        var type = node.classes[0];
        if (prevType === "mbin" && $ef0731f441f79e9a$var$binRightCanceller.has(type)) prev.classes[0] = "mord";
        else if (type === "mbin" && $ef0731f441f79e9a$var$binLeftCanceller.has(prevType)) node.classes[0] = "mord";
    }, {
        node: dummyPrev
    }, dummyNext, isRoot);
    $ef0731f441f79e9a$var$_traverseNonSpaceNodes(groups, (node, prev)=>{
        var _tightSpacings$prevTy, _spacings$prevType;
        var prevType = $ef0731f441f79e9a$var$getTypeOfDomTree(prev);
        var type = $ef0731f441f79e9a$var$getTypeOfDomTree(node);
        // 'mtight' indicates that the node is script or scriptscript style.
        var space = prevType && type ? node.hasClass("mtight") ? (_tightSpacings$prevTy = $ef0731f441f79e9a$var$tightSpacings[prevType]) == null ? void 0 : _tightSpacings$prevTy[type] : (_spacings$prevType = $ef0731f441f79e9a$var$spacings[prevType]) == null ? void 0 : _spacings$prevType[type] : null;
        if (space) // Insert glue (spacing) after the `prev`.
        return $ef0731f441f79e9a$var$makeGlue(space, glueOptions);
    }, {
        node: dummyPrev
    }, dummyNext, isRoot);
    return groups;
};
// Depth-first traverse non-space `nodes`, calling `callback` with the current and
// previous node as arguments, optionally returning a node to insert after the
// previous node. `prev` is an object with the previous node and `insertAfter`
// function to insert after it. `next` is a node that will be added to the right.
// Used for bin cancellation and inserting spacings.
var $ef0731f441f79e9a$var$_traverseNonSpaceNodes = function traverseNonSpaceNodes(nodes, callback, prev, next, isRoot) {
    if (next) // temporarily append the right node, if exists
    nodes.push(next);
    var i = 0;
    for(; i < nodes.length; i++){
        var node = nodes[i];
        var partialGroup = $ef0731f441f79e9a$var$checkPartialGroup(node);
        if (partialGroup) {
            // Recursive DFS
            // TODO(ts): partialGroup.children is ReadonlyArray but this
            // function mutates the array (insertAfter splices into it).
            $ef0731f441f79e9a$var$_traverseNonSpaceNodes(partialGroup.children, callback, prev, null, isRoot);
            continue;
        }
        // Ignore explicit spaces (e.g., \;, \,) when determining what implicit
        // spacing should go between atoms of different classes
        var nonspace = !node.hasClass("mspace");
        if (nonspace) {
            var result = callback(node, prev.node);
            if (result) {
                if (prev.insertAfter) prev.insertAfter(result);
                else {
                    // insert at front
                    nodes.unshift(result);
                    i++;
                }
            }
        }
        if (nonspace) prev.node = node;
        else if (isRoot && node.hasClass("newline")) prev.node = $ef0731f441f79e9a$var$makeSpan([
            "leftmost"
        ]); // treat like beginning of line
        prev.insertAfter = ((index)=>(n)=>{
                nodes.splice(index + 1, 0, n);
                i++;
            })(i);
    }
    if (next) nodes.pop();
};
// Check if given node is a partial group, i.e., does not affect spacing around.
var $ef0731f441f79e9a$var$checkPartialGroup = function checkPartialGroup(node) {
    if (node instanceof $ef0731f441f79e9a$var$DocumentFragment || node instanceof $ef0731f441f79e9a$var$Anchor || node instanceof $ef0731f441f79e9a$var$Span && node.hasClass("enclosing")) return node;
    return null;
};
// Return the outermost node of a domTree.
var $ef0731f441f79e9a$var$_getOutermostNode = function getOutermostNode(node, side) {
    var partialGroup = $ef0731f441f79e9a$var$checkPartialGroup(node);
    if (partialGroup) {
        var children = partialGroup.children;
        if (children.length) {
            if (side === "right") return $ef0731f441f79e9a$var$_getOutermostNode(children[children.length - 1], "right");
            else if (side === "left") return $ef0731f441f79e9a$var$_getOutermostNode(children[0], "left");
        }
    }
    return node;
};
// Return math atom class (mclass) of a domTree.
// If `side` is given, it will get the type of the outermost node at given side.
var $ef0731f441f79e9a$var$getTypeOfDomTree = function getTypeOfDomTree(node, side) {
    if (!node) return null;
    if (side) node = $ef0731f441f79e9a$var$_getOutermostNode(node, side);
    // This makes a lot of assumptions as to where the type of atom
    // appears.  We should do a better job of enforcing this.
    var className = node.classes[0];
    return $ef0731f441f79e9a$var$DomEnum[className] || null;
};
var $ef0731f441f79e9a$var$makeNullDelimiter = function makeNullDelimiter(options, classes) {
    var moreClasses = [
        "nulldelimiter"
    ].concat(options.baseSizingClasses());
    return $ef0731f441f79e9a$var$makeSpan(classes.concat(moreClasses));
};
/**
 * buildGroup is the function that takes a group and calls the correct groupType
 * function for it. It also handles the interaction of size and style changes
 * between parents and children.
 */ var $ef0731f441f79e9a$var$buildGroup$1 = function buildGroup(group, options, baseOptions) {
    if (!group) return $ef0731f441f79e9a$var$makeSpan();
    if ($ef0731f441f79e9a$var$_htmlGroupBuilders[group.type]) {
        // TODO(ts): groupBuilders is Record<string, HtmlBuilder<any>>;
        // a type-safe registry would need a mapped type keyed by NodeType.
        var groupNode = $ef0731f441f79e9a$var$_htmlGroupBuilders[group.type](group, options);
        // If the size changed between the parent and the current group, account
        // for that size difference.
        if (baseOptions && options.size !== baseOptions.size) {
            groupNode = $ef0731f441f79e9a$var$makeSpan(options.sizingClasses(baseOptions), [
                groupNode
            ], options);
            var multiplier = options.sizeMultiplier / baseOptions.sizeMultiplier;
            groupNode.height *= multiplier;
            groupNode.depth *= multiplier;
        }
        return groupNode;
    } else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Got group of unknown type: '" + group.type + "'");
};
/**
 * Combine an array of HTML DOM nodes (e.g., the output of `buildExpression`)
 * into an unbreakable HTML node of class .base, with proper struts to
 * guarantee correct vertical extent.  `buildHTML` calls this repeatedly to
 * make up the entire expression as a sequence of unbreakable units.
 */ function $ef0731f441f79e9a$var$buildHTMLUnbreakable(children, options) {
    // Compute height and depth of this chunk.
    var body = $ef0731f441f79e9a$var$makeSpan([
        "base"
    ], children, options);
    // Add strut, which ensures that the top of the HTML element falls at
    // the height of the expression, and the bottom of the HTML element
    // falls at the depth of the expression.
    var strut = $ef0731f441f79e9a$var$makeSpan([
        "strut"
    ]);
    strut.style.height = $ef0731f441f79e9a$var$makeEm(body.height + body.depth);
    if (body.depth) strut.style.verticalAlign = $ef0731f441f79e9a$var$makeEm(-body.depth);
    body.children.unshift(strut);
    return body;
}
/**
 * Take an entire parse tree, and build it into an appropriate set of HTML
 * nodes.
 */ function $ef0731f441f79e9a$var$buildHTML(tree, options) {
    // Strip off outer tag wrapper for processing below.
    var tag = null;
    if (tree.length === 1 && tree[0].type === "tag") {
        tag = tree[0].tag;
        tree = tree[0].body;
    }
    // Build the expression contained in the tree
    var expression = $ef0731f441f79e9a$var$buildExpression$1(tree, options, "root");
    var eqnNum;
    if (expression.length === 2 && expression[1].hasClass("tag")) // An environment with automatic equation numbers, e.g. {gather}.
    eqnNum = expression.pop();
    var children = [];
    // Create one base node for each chunk between potential line breaks.
    // The TeXBook [p.173] says "A formula will be broken only after a
    // relation symbol like $=$ or $<$ or $\rightarrow$, or after a binary
    // operation symbol like $+$ or $-$ or $\times$, where the relation or
    // binary operation is on the ``outer level'' of the formula (i.e., not
    // enclosed in {...} and not part of an \over construction)."
    var parts = [];
    for(var i = 0; i < expression.length; i++){
        parts.push(expression[i]);
        if (expression[i].hasClass("mbin") || expression[i].hasClass("mrel") || expression[i].hasClass("allowbreak")) {
            // Put any post-operator glue on same line as operator.
            // Watch for \nobreak along the way, and stop at \newline.
            var nobreak = false;
            while(i < expression.length - 1 && expression[i + 1].hasClass("mspace") && !expression[i + 1].hasClass("newline")){
                i++;
                parts.push(expression[i]);
                if (expression[i].hasClass("nobreak")) nobreak = true;
            }
            // Don't allow break if \nobreak among the post-operator glue.
            if (!nobreak) {
                children.push($ef0731f441f79e9a$var$buildHTMLUnbreakable(parts, options));
                parts = [];
            }
        } else if (expression[i].hasClass("newline")) {
            // Write the line except the newline
            parts.pop();
            if (parts.length > 0) {
                children.push($ef0731f441f79e9a$var$buildHTMLUnbreakable(parts, options));
                parts = [];
            }
            // Put the newline at the top level
            children.push(expression[i]);
        }
    }
    if (parts.length > 0) children.push($ef0731f441f79e9a$var$buildHTMLUnbreakable(parts, options));
    // Now, if there was a tag, build it too and append it as a final child.
    var tagChild;
    if (tag) {
        tagChild = $ef0731f441f79e9a$var$buildHTMLUnbreakable($ef0731f441f79e9a$var$buildExpression$1(tag, options, true), options);
        tagChild.classes = [
            "tag"
        ];
        children.push(tagChild);
    } else if (eqnNum) children.push(eqnNum);
    var htmlNode = $ef0731f441f79e9a$var$makeSpan([
        "katex-html"
    ], children);
    htmlNode.setAttribute("aria-hidden", "true");
    // Adjust the strut of the tag to be the maximum height of all children
    // (the height of the enclosing htmlNode) for proper vertical alignment.
    if (tagChild) {
        var strut = tagChild.children[0];
        strut.style.height = $ef0731f441f79e9a$var$makeEm(htmlNode.height + htmlNode.depth);
        if (htmlNode.depth) strut.style.verticalAlign = $ef0731f441f79e9a$var$makeEm(-htmlNode.depth);
    }
    return htmlNode;
}
/**
 * These objects store data about MathML nodes. This is the MathML equivalent
 * of the types in domTree.js. Since MathML handles its own rendering, and
 * since we're mainly using MathML to improve accessibility, we don't manage
 * any of the styling state that the plain DOM nodes do.
 *
 * The `toNode` and `toMarkup` functions work similarly to how they do in
 * domTree.js, creating namespaced DOM nodes and HTML text markup respectively.
 */ function $ef0731f441f79e9a$var$newDocumentFragment(children) {
    return new $ef0731f441f79e9a$var$DocumentFragment(children);
}
/**
 * This node represents a general purpose MathML node of any type. The
 * constructor requires the type of node to create (for example, `"mo"` or
 * `"mspace"`, corresponding to `<mo>` and `<mspace>` tags).
 */ class $ef0731f441f79e9a$var$MathNode {
    constructor(type, children, classes){
        this.type = void 0;
        this.attributes = void 0;
        this.children = void 0;
        this.classes = void 0;
        this.type = type;
        this.attributes = {};
        this.children = children || [];
        this.classes = classes || [];
    }
    /**
   * Sets an attribute on a MathML node. MathML depends on attributes to convey a
   * semantic content, so this is used heavily.
   */ setAttribute(name, value) {
        this.attributes[name] = value;
    }
    /**
   * Gets an attribute on a MathML node.
   */ getAttribute(name) {
        return this.attributes[name];
    }
    /**
   * Converts the math node into a MathML-namespaced DOM element.
   */ toNode() {
        var node = document.createElementNS("http://www.w3.org/1998/Math/MathML", this.type);
        for(var attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) node.setAttribute(attr, this.attributes[attr]);
        if (this.classes.length > 0) node.className = $ef0731f441f79e9a$var$createClass(this.classes);
        for(var i = 0; i < this.children.length; i++)// Combine multiple TextNodes into one TextNode, to prevent
        // screen readers from reading each as a separate word [#3995]
        if (this.children[i] instanceof $ef0731f441f79e9a$var$TextNode && this.children[i + 1] instanceof $ef0731f441f79e9a$var$TextNode) {
            var text = this.children[i].toText() + this.children[++i].toText();
            while(this.children[i + 1] instanceof $ef0731f441f79e9a$var$TextNode)text += this.children[++i].toText();
            node.appendChild(new $ef0731f441f79e9a$var$TextNode(text).toNode());
        } else node.appendChild(this.children[i].toNode());
        return node;
    }
    /**
   * Converts the math node into an HTML markup string.
   */ toMarkup() {
        var markup = "<" + this.type;
        // Add the attributes
        for(var attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) {
            markup += " " + attr + "=\"";
            markup += $ef0731f441f79e9a$var$escape(this.attributes[attr]);
            markup += "\"";
        }
        if (this.classes.length > 0) markup += " class =\"" + $ef0731f441f79e9a$var$escape($ef0731f441f79e9a$var$createClass(this.classes)) + "\"";
        markup += ">";
        for(var i = 0; i < this.children.length; i++)markup += this.children[i].toMarkup();
        markup += "</" + this.type + ">";
        return markup;
    }
    /**
   * Converts the math node into a string, similar to innerText, but escaped.
   */ toText() {
        return this.children.map((child)=>child.toText()).join("");
    }
}
/**
 * This node represents a piece of text.
 */ class $ef0731f441f79e9a$var$TextNode {
    constructor(text){
        this.text = void 0;
        this.text = text;
    }
    /**
   * Converts the text node into a DOM text node.
   */ toNode() {
        return document.createTextNode(this.text);
    }
    /**
   * Converts the text node into escaped HTML markup
   * (representing the text itself).
   */ toMarkup() {
        return $ef0731f441f79e9a$var$escape(this.toText());
    }
    /**
   * Converts the text node into a string
   * (representing the text itself).
   */ toText() {
        return this.text;
    }
}
/**
 * This node represents a space, but may render as <mspace.../> or as text,
 * depending on the width.
 */ class $ef0731f441f79e9a$var$SpaceNode {
    /**
   * Create a Space node with width given in CSS ems.
   */ constructor(width){
        this.width = void 0;
        this.character = void 0;
        this.width = width;
        // See https://www.w3.org/TR/2000/WD-MathML2-20000328/chapter6.html
        // for a table of space-like characters.  We use Unicode
        // representations instead of &LongNames; as it's not clear how to
        // make the latter via document.createTextNode.
        if (width >= 0.05555 && width <= 0.05556) this.character = "\u200a"; // &VeryThinSpace;
        else if (width >= 0.1666 && width <= 0.1667) this.character = "\u2009"; // &ThinSpace;
        else if (width >= 0.2222 && width <= 0.2223) this.character = "\u2005"; // &MediumSpace;
        else if (width >= 0.2777 && width <= 0.2778) this.character = "\u2005\u200a"; // &ThickSpace;
        else if (width >= -0.05556 && width <= -0.05555) this.character = "\u200a\u2063"; // &NegativeVeryThinSpace;
        else if (width >= -0.1667 && width <= -0.1666) this.character = "\u2009\u2063"; // &NegativeThinSpace;
        else if (width >= -0.2223 && width <= -0.2222) this.character = "\u205f\u2063"; // &NegativeMediumSpace;
        else if (width >= -0.2778 && width <= -0.2777) this.character = "\u2005\u2063"; // &NegativeThickSpace;
        else this.character = null;
    }
    /**
   * Converts the math node into a MathML-namespaced DOM element.
   */ toNode() {
        if (this.character) return document.createTextNode(this.character);
        else {
            var node = document.createElementNS("http://www.w3.org/1998/Math/MathML", "mspace");
            node.setAttribute("width", $ef0731f441f79e9a$var$makeEm(this.width));
            return node;
        }
    }
    /**
   * Converts the math node into an HTML markup string.
   */ toMarkup() {
        if (this.character) return "<mtext>" + this.character + "</mtext>";
        else return "<mspace width=\"" + $ef0731f441f79e9a$var$makeEm(this.width) + "\"/>";
    }
    /**
   * Converts the math node into a string, similar to innerText.
   */ toText() {
        if (this.character) return this.character;
        else return " ";
    }
}
/**
 * This file converts a parse tree into a corresponding MathML tree. The main
 * entry point is the `buildMathML` function, which takes a parse tree from the
 * parser.
 */ var $ef0731f441f79e9a$var$noVariantSymbols = new Set([
    "\\imath",
    "\\jmath"
]);
var $ef0731f441f79e9a$var$rowLikeTypes = new Set([
    "mrow",
    "mtable"
]);
/**
 * Takes a symbol and converts it into a MathML text node after performing
 * optional replacement from symbols.js.
 */ var $ef0731f441f79e9a$var$makeText = function makeText(text, mode, options) {
    if ($ef0731f441f79e9a$var$symbols[mode][text] && $ef0731f441f79e9a$var$symbols[mode][text].replace && text.charCodeAt(0) !== 0xD835 && !($ef0731f441f79e9a$var$ligatures.hasOwnProperty(text) && options && (options.fontFamily && options.fontFamily.slice(4, 6) === "tt" || options.font && options.font.slice(4, 6) === "tt"))) text = $ef0731f441f79e9a$var$symbols[mode][text].replace;
    return new $ef0731f441f79e9a$var$TextNode(text);
};
/**
 * Wrap the given array of nodes in an <mrow> node if needed, i.e.,
 * unless the array has length 1.  Always returns a single node.
 */ var $ef0731f441f79e9a$var$makeRow = function makeRow(body) {
    if (body.length === 1) return body[0];
    else return new $ef0731f441f79e9a$var$MathNode("mrow", body);
};
var $ef0731f441f79e9a$var$mathFontVariants = {
    mathit: "italic",
    boldsymbol: (group)=>group.type === "textord" ? "bold" : "bold-italic",
    mathbf: "bold",
    mathbb: "double-struck",
    mathsfit: "sans-serif-italic",
    mathfrak: "fraktur",
    mathscr: "script",
    mathcal: "script",
    mathsf: "sans-serif",
    mathtt: "monospace"
};
/**
 * Returns the math variant as a string or null if none is required.
 */ var $ef0731f441f79e9a$var$getVariant = (group, options)=>{
    // Handle \text... font specifiers as best we can.
    // MathML has a limited list of allowable mathvariant specifiers; see
    // https://www.w3.org/TR/MathML3/chapter3.html#presm.commatt
    if (group.mode === "text") {
        if (options.fontFamily === "texttt") return "monospace";
        else if (options.fontFamily === "textsf") {
            if (options.fontShape === "textit" && options.fontWeight === "textbf") return "sans-serif-bold-italic";
            else if (options.fontShape === "textit") return "sans-serif-italic";
            else if (options.fontWeight === "textbf") return "bold-sans-serif";
            else return "sans-serif";
        } else if (options.fontShape === "textit" && options.fontWeight === "textbf") return "bold-italic";
        else if (options.fontShape === "textit") return "italic";
        else if (options.fontWeight === "textbf") return "bold";
    }
    var font = options.font;
    if (!font || font === "mathnormal") return null;
    var mode = group.mode;
    var mathVariant = $ef0731f441f79e9a$var$mathFontVariants[font];
    if (mathVariant) return typeof mathVariant === "function" ? mathVariant(group) : mathVariant;
    var text = group.text;
    if ($ef0731f441f79e9a$var$noVariantSymbols.has(text)) return null;
    if ($ef0731f441f79e9a$var$symbols[mode][text]) {
        var replacement = $ef0731f441f79e9a$var$symbols[mode][text].replace;
        if (replacement) text = replacement;
    }
    var fontName = $ef0731f441f79e9a$var$fontMap[font].fontName;
    if ($ef0731f441f79e9a$var$getCharacterMetrics(text, fontName, mode)) return $ef0731f441f79e9a$var$fontMap[font].variant;
    return null;
};
/**
 * Check for <mi>.</mi> which is how a dot renders in MathML,
 * or <mo separator="true" lspace="0em" rspace="0em">,</mo>
 * which is how a braced comma {,} renders in MathML
 */ function $ef0731f441f79e9a$var$isNumberPunctuation(group) {
    if (!group) return false;
    if (group.type === 'mi' && group.children.length === 1) {
        var child = group.children[0];
        return child instanceof $ef0731f441f79e9a$var$TextNode && child.text === '.';
    } else if (group.type === 'mo' && group.children.length === 1 && group.getAttribute('separator') === 'true' && group.getAttribute('lspace') === '0em' && group.getAttribute('rspace') === '0em') {
        var _child = group.children[0];
        return _child instanceof $ef0731f441f79e9a$var$TextNode && _child.text === ',';
    } else return false;
}
/**
 * Takes a list of nodes, builds them, and returns a list of the generated
 * MathML nodes.  Also combine consecutive <mtext> outputs into a single
 * <mtext> tag.
 */ var $ef0731f441f79e9a$var$buildExpression = function buildExpression(expression, options, isOrdgroup) {
    if (expression.length === 1) {
        var group = $ef0731f441f79e9a$var$buildGroup(expression[0], options);
        if (isOrdgroup && group instanceof $ef0731f441f79e9a$var$MathNode && group.type === "mo") {
            // When TeX writers want to suppress spacing on an operator,
            // they often put the operator by itself inside braces.
            group.setAttribute("lspace", "0em");
            group.setAttribute("rspace", "0em");
        }
        return [
            group
        ];
    }
    var groups = [];
    var lastGroup;
    for(var i = 0; i < expression.length; i++){
        var _group = $ef0731f441f79e9a$var$buildGroup(expression[i], options);
        if (_group instanceof $ef0731f441f79e9a$var$MathNode && lastGroup instanceof $ef0731f441f79e9a$var$MathNode) {
            // Concatenate adjacent <mtext>s
            if (_group.type === 'mtext' && lastGroup.type === 'mtext' && _group.getAttribute('mathvariant') === lastGroup.getAttribute('mathvariant')) {
                lastGroup.children.push(..._group.children);
                continue;
            // Concatenate adjacent <mn>s
            } else if (_group.type === 'mn' && lastGroup.type === 'mn') {
                lastGroup.children.push(..._group.children);
                continue;
            // Concatenate <mn>...</mn> followed by <mi>.</mi>
            } else if ($ef0731f441f79e9a$var$isNumberPunctuation(_group) && lastGroup.type === 'mn') {
                lastGroup.children.push(..._group.children);
                continue;
            // Concatenate <mi>.</mi> followed by <mn>...</mn>
            } else if (_group.type === 'mn' && $ef0731f441f79e9a$var$isNumberPunctuation(lastGroup)) {
                _group.children = [
                    ...lastGroup.children,
                    ..._group.children
                ];
                groups.pop();
            // Put preceding <mn>...</mn> or <mi>.</mi> inside base of
            // <msup><mn>...base...</mn>...exponent...</msup> (or <msub>)
            } else if ((_group.type === 'msup' || _group.type === 'msub') && _group.children.length >= 1 && (lastGroup.type === 'mn' || $ef0731f441f79e9a$var$isNumberPunctuation(lastGroup))) {
                var base = _group.children[0];
                if (base instanceof $ef0731f441f79e9a$var$MathNode && base.type === 'mn') {
                    base.children = [
                        ...lastGroup.children,
                        ...base.children
                    ];
                    groups.pop();
                }
            // \not
            } else if (lastGroup.type === 'mi' && lastGroup.children.length === 1) {
                var lastChild = lastGroup.children[0];
                if (lastChild instanceof $ef0731f441f79e9a$var$TextNode && lastChild.text === '\u0338' && (_group.type === 'mo' || _group.type === 'mi' || _group.type === 'mn')) {
                    var child = _group.children[0];
                    if (child instanceof $ef0731f441f79e9a$var$TextNode && child.text.length > 0) {
                        // Overlay with combining character long solidus
                        child.text = child.text.slice(0, 1) + "\u0338" + child.text.slice(1);
                        groups.pop();
                    }
                }
            }
        }
        groups.push(_group);
        lastGroup = _group;
    }
    return groups;
};
/**
 * Equivalent to buildExpression, but wraps the elements in an <mrow>
 * if there's more than one.  Returns a single node instead of an array.
 */ var $ef0731f441f79e9a$var$buildExpressionRow = function buildExpressionRow(expression, options, isOrdgroup) {
    return $ef0731f441f79e9a$var$makeRow($ef0731f441f79e9a$var$buildExpression(expression, options, isOrdgroup));
};
/**
 * Takes a group from the parser and calls the appropriate groupBuilders function
 * on it to produce a MathML node.
 */ var $ef0731f441f79e9a$var$buildGroup = function buildGroup(group, options) {
    if (!group) return new $ef0731f441f79e9a$var$MathNode("mrow");
    if ($ef0731f441f79e9a$var$_mathmlGroupBuilders[group.type]) // TODO(ts): MathMLBuilder returns MathDomNode but all concrete
    // builders return MathNode. Widening the return type here would
    // require updating all callers that assume MathNode.
    return $ef0731f441f79e9a$var$_mathmlGroupBuilders[group.type](group, options);
    else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Got group of unknown type: '" + group.type + "'");
};
/**
 * Takes a full parse tree and settings and builds a MathML representation of
 * it. In particular, we put the elements from building the parse tree into a
 * <semantics> tag so we can also include that TeX source as an annotation.
 *
 * Note that we actually return a domTree element with a `<math>` inside it so
 * we can do appropriate styling.
 */ function $ef0731f441f79e9a$var$buildMathML(tree, texExpression, options, isDisplayMode, forMathmlOnly) {
    var expression = $ef0731f441f79e9a$var$buildExpression(tree, options);
    // TODO: Make a pass thru the MathML similar to buildHTML.traverseNonSpaceNodes
    // and add spacing nodes. This is necessary only adjacent to math operators
    // like \sin or \lim or to subsup elements that contain math operators.
    // MathML takes care of the other spacing issues.
    // Wrap up the expression in an mrow so it is presented in the semantics
    // tag correctly, unless it's a single <mrow> or <mtable>.
    var wrapper;
    if (expression.length === 1 && expression[0] instanceof $ef0731f441f79e9a$var$MathNode && $ef0731f441f79e9a$var$rowLikeTypes.has(expression[0].type)) wrapper = expression[0];
    else wrapper = new $ef0731f441f79e9a$var$MathNode("mrow", expression);
    // Build a TeX annotation of the source
    var annotation = new $ef0731f441f79e9a$var$MathNode("annotation", [
        new $ef0731f441f79e9a$var$TextNode(texExpression)
    ]);
    annotation.setAttribute("encoding", "application/x-tex");
    var semantics = new $ef0731f441f79e9a$var$MathNode("semantics", [
        wrapper,
        annotation
    ]);
    var math = new $ef0731f441f79e9a$var$MathNode("math", [
        semantics
    ]);
    math.setAttribute("xmlns", "http://www.w3.org/1998/Math/MathML");
    if (isDisplayMode) math.setAttribute("display", "block");
    // You can't style <math> nodes, so we wrap the node in a span.
    // NOTE: The span class is not typed to have <math> nodes as children, and
    // we don't want to make the children type more generic since the children
    // of span are expected to have more fields in `buildHtml` contexts.
    // The MathNode implements VirtualNode (toNode/toMarkup) which is all that
    // Span needs from its children for rendering.
    // TODO(ts): Span's child type is HtmlDomNode, but MathNode only implements
    // VirtualNode. The double-cast acknowledges this architectural limitation.
    var wrapperClass = forMathmlOnly ? "katex" : "katex-mathml";
    return $ef0731f441f79e9a$var$makeSpan([
        wrapperClass
    ], [
        math
    ]);
}
/**
 * This file contains information about the options that the Parser carries
 * around with it while parsing. Data is held in an `Options` object, and when
 * recursing, a new `Options` object can be created with the `.with*` and
 * `.reset` functions.
 */ var $ef0731f441f79e9a$var$sizeStyleMap = [
    // Each element contains [textsize, scriptsize, scriptscriptsize].
    // The size mappings are taken from TeX with \normalsize=10pt.
    [
        1,
        1,
        1
    ],
    // size1: [5, 5, 5]              \tiny
    [
        2,
        1,
        1
    ],
    // size2: [6, 5, 5]
    [
        3,
        1,
        1
    ],
    // size3: [7, 5, 5]              \scriptsize
    [
        4,
        2,
        1
    ],
    // size4: [8, 6, 5]              \footnotesize
    [
        5,
        2,
        1
    ],
    // size5: [9, 6, 5]              \small
    [
        6,
        3,
        1
    ],
    // size6: [10, 7, 5]             \normalsize
    [
        7,
        4,
        2
    ],
    // size7: [12, 8, 6]             \large
    [
        8,
        6,
        3
    ],
    // size8: [14.4, 10, 7]          \Large
    [
        9,
        7,
        6
    ],
    // size9: [17.28, 12, 10]        \LARGE
    [
        10,
        8,
        7
    ],
    // size10: [20.74, 14.4, 12]     \huge
    [
        11,
        10,
        9
    ] // size11: [24.88, 20.74, 17.28] \HUGE
];
var $ef0731f441f79e9a$var$sizeMultipliers = [
    // fontMetrics.js:getGlobalMetrics also uses size indexes, so if
    // you change size indexes, change that function.
    0.5,
    0.6,
    0.7,
    0.8,
    0.9,
    1.0,
    1.2,
    1.44,
    1.728,
    2.074,
    2.488
];
var $ef0731f441f79e9a$var$sizeAtStyle = function sizeAtStyle(size, style) {
    return style.size < 2 ? size : $ef0731f441f79e9a$var$sizeStyleMap[size - 1][style.size - 1];
};
/**
 * This is the main options class. It contains the current style, size, color,
 * and font.
 *
 * Options objects should not be modified. To create a new Options with
 * different properties, call a `.having*` method.
 */ class $ef0731f441f79e9a$var$Options {
    constructor(data){
        this.style = void 0;
        this.color = void 0;
        this.size = void 0;
        this.textSize = void 0;
        this.phantom = void 0;
        // A font family applies to a group of fonts (i.e. SansSerif), while a font
        // represents a specific font (i.e. SansSerif Bold).
        // See: https://tex.stackexchange.com/questions/22350/difference-between-textrm-and-mathrm
        this.font = void 0;
        this.fontFamily = void 0;
        this.fontWeight = void 0;
        this.fontShape = void 0;
        this.sizeMultiplier = void 0;
        this.maxSize = void 0;
        this.minRuleThickness = void 0;
        this._fontMetrics = void 0;
        this.style = data.style;
        this.color = data.color;
        this.size = data.size || $ef0731f441f79e9a$var$Options.BASESIZE;
        this.textSize = data.textSize || this.size;
        this.phantom = !!data.phantom;
        this.font = data.font || "";
        this.fontFamily = data.fontFamily || "";
        this.fontWeight = data.fontWeight || "";
        this.fontShape = data.fontShape || "";
        this.sizeMultiplier = $ef0731f441f79e9a$var$sizeMultipliers[this.size - 1];
        this.maxSize = data.maxSize;
        this.minRuleThickness = data.minRuleThickness;
        this._fontMetrics = undefined;
    }
    /**
   * Returns a new options object with the same properties as "this".  Properties
   * from "extension" will be copied to the new options object.
   */ extend(extension) {
        var data = {
            style: this.style,
            size: this.size,
            textSize: this.textSize,
            color: this.color,
            phantom: this.phantom,
            font: this.font,
            fontFamily: this.fontFamily,
            fontWeight: this.fontWeight,
            fontShape: this.fontShape,
            maxSize: this.maxSize,
            minRuleThickness: this.minRuleThickness
        };
        Object.assign(data, extension);
        return new $ef0731f441f79e9a$var$Options(data);
    }
    /**
   * Return an options object with the given style. If `this.style === style`,
   * returns `this`.
   */ havingStyle(style) {
        if (this.style === style) return this;
        else return this.extend({
            style: style,
            size: $ef0731f441f79e9a$var$sizeAtStyle(this.textSize, style)
        });
    }
    /**
   * Return an options object with a cramped version of the current style. If
   * the current style is cramped, returns `this`.
   */ havingCrampedStyle() {
        return this.havingStyle(this.style.cramp());
    }
    /**
   * Return an options object with the given size and in at least `\textstyle`.
   * Returns `this` if appropriate.
   */ havingSize(size) {
        if (this.size === size && this.textSize === size) return this;
        else return this.extend({
            style: this.style.text(),
            size: size,
            textSize: size,
            sizeMultiplier: $ef0731f441f79e9a$var$sizeMultipliers[size - 1]
        });
    }
    /**
   * Like `this.havingSize(BASESIZE).havingStyle(style)`. If `style` is omitted,
   * changes to at least `\textstyle`.
   */ havingBaseStyle(style) {
        style = style || this.style.text();
        var wantSize = $ef0731f441f79e9a$var$sizeAtStyle($ef0731f441f79e9a$var$Options.BASESIZE, style);
        if (this.size === wantSize && this.textSize === $ef0731f441f79e9a$var$Options.BASESIZE && this.style === style) return this;
        else return this.extend({
            style: style,
            size: wantSize
        });
    }
    /**
   * Remove the effect of sizing changes such as \Huge.
   * Keep the effect of the current style, such as \scriptstyle.
   */ havingBaseSizing() {
        var size;
        switch(this.style.id){
            case 4:
            case 5:
                size = 3; // normalsize in scriptstyle
                break;
            case 6:
            case 7:
                size = 1; // normalsize in scriptscriptstyle
                break;
            default:
                size = 6;
        }
        return this.extend({
            style: this.style.text(),
            size: size
        });
    }
    /**
   * Create a new options object with the given color.
   */ withColor(color) {
        return this.extend({
            color: color
        });
    }
    /**
   * Create a new options object with "phantom" set to true.
   */ withPhantom() {
        return this.extend({
            phantom: true
        });
    }
    /**
   * Creates a new options object with the given math font or old text font.
   * @type {[type]}
   */ withFont(font) {
        return this.extend({
            font: font
        });
    }
    /**
   * Create a new options objects with the given fontFamily.
   */ withTextFontFamily(fontFamily) {
        return this.extend({
            fontFamily: fontFamily,
            font: ""
        });
    }
    /**
   * Creates a new options object with the given font weight
   */ withTextFontWeight(fontWeight) {
        return this.extend({
            fontWeight: fontWeight,
            font: ""
        });
    }
    /**
   * Creates a new options object with the given font weight
   */ withTextFontShape(fontShape) {
        return this.extend({
            fontShape: fontShape,
            font: ""
        });
    }
    /**
   * Return the CSS sizing classes required to switch from enclosing options
   * `oldOptions` to `this`. Returns an array of classes.
   */ sizingClasses(oldOptions) {
        if (oldOptions.size !== this.size) return [
            "sizing",
            "reset-size" + oldOptions.size,
            "size" + this.size
        ];
        else return [];
    }
    /**
   * Return the CSS sizing classes required to switch to the base size. Like
   * `this.havingSize(BASESIZE).sizingClasses(this)`.
   */ baseSizingClasses() {
        if (this.size !== $ef0731f441f79e9a$var$Options.BASESIZE) return [
            "sizing",
            "reset-size" + this.size,
            "size" + $ef0731f441f79e9a$var$Options.BASESIZE
        ];
        else return [];
    }
    /**
   * Return the font metrics for this size.
   */ fontMetrics() {
        if (!this._fontMetrics) this._fontMetrics = $ef0731f441f79e9a$var$getGlobalMetrics(this.size);
        return this._fontMetrics;
    }
    /**
   * Gets the CSS color of the current options object
   */ getColor() {
        if (this.phantom) return "transparent";
        else return this.color;
    }
}
/**
 * The base size index.
 */ $ef0731f441f79e9a$var$Options.BASESIZE = 6;
var $ef0731f441f79e9a$var$optionsFromSettings = function optionsFromSettings(settings) {
    return new $ef0731f441f79e9a$var$Options({
        style: settings.displayMode ? $ef0731f441f79e9a$var$Style$1.DISPLAY : $ef0731f441f79e9a$var$Style$1.TEXT,
        maxSize: settings.maxSize,
        minRuleThickness: settings.minRuleThickness
    });
};
var $ef0731f441f79e9a$var$displayWrap = function displayWrap(node, settings) {
    if (settings.displayMode) {
        var classes = [
            "katex-display"
        ];
        if (settings.leqno) classes.push("leqno");
        if (settings.fleqn) classes.push("fleqn");
        node = $ef0731f441f79e9a$var$makeSpan(classes, [
            node
        ]);
    }
    return node;
};
var $ef0731f441f79e9a$var$buildTree = function buildTree(tree, expression, settings) {
    var options = $ef0731f441f79e9a$var$optionsFromSettings(settings);
    var katexNode;
    if (settings.output === "mathml") return $ef0731f441f79e9a$var$buildMathML(tree, expression, options, settings.displayMode, true);
    else if (settings.output === "html") {
        var htmlNode = $ef0731f441f79e9a$var$buildHTML(tree, options);
        katexNode = $ef0731f441f79e9a$var$makeSpan([
            "katex"
        ], [
            htmlNode
        ]);
    } else {
        var mathMLNode = $ef0731f441f79e9a$var$buildMathML(tree, expression, options, settings.displayMode, false);
        var _htmlNode = $ef0731f441f79e9a$var$buildHTML(tree, options);
        katexNode = $ef0731f441f79e9a$var$makeSpan([
            "katex"
        ], [
            mathMLNode,
            _htmlNode
        ]);
    }
    return $ef0731f441f79e9a$var$displayWrap(katexNode, settings);
};
var $ef0731f441f79e9a$var$buildHTMLTree = function buildHTMLTree(tree, expression, settings) {
    var options = $ef0731f441f79e9a$var$optionsFromSettings(settings);
    var htmlNode = $ef0731f441f79e9a$var$buildHTML(tree, options);
    var katexNode = $ef0731f441f79e9a$var$makeSpan([
        "katex"
    ], [
        htmlNode
    ]);
    return $ef0731f441f79e9a$var$displayWrap(katexNode, settings);
};
/**
 * This file provides support to buildMathML.js and buildHTML.js
 * for stretchy wide elements rendered from SVG files
 * and other CSS trickery.
 */ var $ef0731f441f79e9a$var$stretchyCodePoint = {
    widehat: "^",
    widecheck: "\u02C7",
    widetilde: "~",
    utilde: "~",
    overleftarrow: "\u2190",
    underleftarrow: "\u2190",
    xleftarrow: "\u2190",
    overrightarrow: "\u2192",
    underrightarrow: "\u2192",
    xrightarrow: "\u2192",
    underbrace: "\u23df",
    overbrace: "\u23de",
    underbracket: "\u23b5",
    overbracket: "\u23b4",
    overgroup: "\u23e0",
    undergroup: "\u23e1",
    overleftrightarrow: "\u2194",
    underleftrightarrow: "\u2194",
    xleftrightarrow: "\u2194",
    Overrightarrow: "\u21d2",
    xRightarrow: "\u21d2",
    overleftharpoon: "\u21bc",
    xleftharpoonup: "\u21bc",
    overrightharpoon: "\u21c0",
    xrightharpoonup: "\u21c0",
    xLeftarrow: "\u21d0",
    xLeftrightarrow: "\u21d4",
    xhookleftarrow: "\u21a9",
    xhookrightarrow: "\u21aa",
    xmapsto: "\u21a6",
    xrightharpoondown: "\u21c1",
    xleftharpoondown: "\u21bd",
    xrightleftharpoons: "\u21cc",
    xleftrightharpoons: "\u21cb",
    xtwoheadleftarrow: "\u219e",
    xtwoheadrightarrow: "\u21a0",
    xlongequal: "=",
    xtofrom: "\u21c4",
    xrightleftarrows: "\u21c4",
    xrightequilibrium: "\u21cc",
    // Not a perfect match.
    xleftequilibrium: "\u21cb",
    // None better available.
    "\\cdrightarrow": "\u2192",
    "\\cdleftarrow": "\u2190",
    "\\cdlongequal": "="
};
var $ef0731f441f79e9a$var$stretchyMathML = function stretchyMathML(label) {
    var node = new $ef0731f441f79e9a$var$MathNode("mo", [
        new $ef0731f441f79e9a$var$TextNode($ef0731f441f79e9a$var$stretchyCodePoint[label.replace(/^\\/, '')])
    ]);
    node.setAttribute("stretchy", "true");
    return node;
};
var $ef0731f441f79e9a$var$katexImagesData = {
    //   path(s), minWidth, height, align
    overrightarrow: [
        [
            "rightarrow"
        ],
        0.888,
        522,
        "xMaxYMin"
    ],
    overleftarrow: [
        [
            "leftarrow"
        ],
        0.888,
        522,
        "xMinYMin"
    ],
    underrightarrow: [
        [
            "rightarrow"
        ],
        0.888,
        522,
        "xMaxYMin"
    ],
    underleftarrow: [
        [
            "leftarrow"
        ],
        0.888,
        522,
        "xMinYMin"
    ],
    xrightarrow: [
        [
            "rightarrow"
        ],
        1.469,
        522,
        "xMaxYMin"
    ],
    "\\cdrightarrow": [
        [
            "rightarrow"
        ],
        3.0,
        522,
        "xMaxYMin"
    ],
    // CD minwwidth2.5pc
    xleftarrow: [
        [
            "leftarrow"
        ],
        1.469,
        522,
        "xMinYMin"
    ],
    "\\cdleftarrow": [
        [
            "leftarrow"
        ],
        3.0,
        522,
        "xMinYMin"
    ],
    Overrightarrow: [
        [
            "doublerightarrow"
        ],
        0.888,
        560,
        "xMaxYMin"
    ],
    xRightarrow: [
        [
            "doublerightarrow"
        ],
        1.526,
        560,
        "xMaxYMin"
    ],
    xLeftarrow: [
        [
            "doubleleftarrow"
        ],
        1.526,
        560,
        "xMinYMin"
    ],
    overleftharpoon: [
        [
            "leftharpoon"
        ],
        0.888,
        522,
        "xMinYMin"
    ],
    xleftharpoonup: [
        [
            "leftharpoon"
        ],
        0.888,
        522,
        "xMinYMin"
    ],
    xleftharpoondown: [
        [
            "leftharpoondown"
        ],
        0.888,
        522,
        "xMinYMin"
    ],
    overrightharpoon: [
        [
            "rightharpoon"
        ],
        0.888,
        522,
        "xMaxYMin"
    ],
    xrightharpoonup: [
        [
            "rightharpoon"
        ],
        0.888,
        522,
        "xMaxYMin"
    ],
    xrightharpoondown: [
        [
            "rightharpoondown"
        ],
        0.888,
        522,
        "xMaxYMin"
    ],
    xlongequal: [
        [
            "longequal"
        ],
        0.888,
        334,
        "xMinYMin"
    ],
    "\\cdlongequal": [
        [
            "longequal"
        ],
        3.0,
        334,
        "xMinYMin"
    ],
    xtwoheadleftarrow: [
        [
            "twoheadleftarrow"
        ],
        0.888,
        334,
        "xMinYMin"
    ],
    xtwoheadrightarrow: [
        [
            "twoheadrightarrow"
        ],
        0.888,
        334,
        "xMaxYMin"
    ],
    overleftrightarrow: [
        [
            "leftarrow",
            "rightarrow"
        ],
        0.888,
        522
    ],
    overbrace: [
        [
            "leftbrace",
            "midbrace",
            "rightbrace"
        ],
        1.6,
        548
    ],
    underbrace: [
        [
            "leftbraceunder",
            "midbraceunder",
            "rightbraceunder"
        ],
        1.6,
        548
    ],
    underleftrightarrow: [
        [
            "leftarrow",
            "rightarrow"
        ],
        0.888,
        522
    ],
    xleftrightarrow: [
        [
            "leftarrow",
            "rightarrow"
        ],
        1.75,
        522
    ],
    xLeftrightarrow: [
        [
            "doubleleftarrow",
            "doublerightarrow"
        ],
        1.75,
        560
    ],
    xrightleftharpoons: [
        [
            "leftharpoondownplus",
            "rightharpoonplus"
        ],
        1.75,
        716
    ],
    xleftrightharpoons: [
        [
            "leftharpoonplus",
            "rightharpoondownplus"
        ],
        1.75,
        716
    ],
    xhookleftarrow: [
        [
            "leftarrow",
            "righthook"
        ],
        1.08,
        522
    ],
    xhookrightarrow: [
        [
            "lefthook",
            "rightarrow"
        ],
        1.08,
        522
    ],
    overlinesegment: [
        [
            "leftlinesegment",
            "rightlinesegment"
        ],
        0.888,
        522
    ],
    underlinesegment: [
        [
            "leftlinesegment",
            "rightlinesegment"
        ],
        0.888,
        522
    ],
    overbracket: [
        [
            "leftbracketover",
            "rightbracketover"
        ],
        1.6,
        440
    ],
    underbracket: [
        [
            "leftbracketunder",
            "rightbracketunder"
        ],
        1.6,
        410
    ],
    overgroup: [
        [
            "leftgroup",
            "rightgroup"
        ],
        0.888,
        342
    ],
    undergroup: [
        [
            "leftgroupunder",
            "rightgroupunder"
        ],
        0.888,
        342
    ],
    xmapsto: [
        [
            "leftmapsto",
            "rightarrow"
        ],
        1.5,
        522
    ],
    xtofrom: [
        [
            "leftToFrom",
            "rightToFrom"
        ],
        1.75,
        528
    ],
    // The next three arrows are from the mhchem package.
    // In mhchem.sty, min-length is 2.0em. But these arrows might appear in the
    // document as \xrightarrow or \xrightleftharpoons. Those have
    // min-length = 1.75em, so we set min-length on these next three to match.
    xrightleftarrows: [
        [
            "baraboveleftarrow",
            "rightarrowabovebar"
        ],
        1.75,
        901
    ],
    xrightequilibrium: [
        [
            "baraboveshortleftharpoon",
            "rightharpoonaboveshortbar"
        ],
        1.75,
        716
    ],
    xleftequilibrium: [
        [
            "shortbaraboveleftharpoon",
            "shortrightharpoonabovebar"
        ],
        1.75,
        716
    ]
};
var $ef0731f441f79e9a$var$wideAccentLabels = new Set([
    "widehat",
    "widecheck",
    "widetilde",
    "utilde"
]);
var $ef0731f441f79e9a$var$stretchySvg = function stretchySvg(group, options) {
    // Create a span with inline SVG for the element.
    function buildSvgSpan_() {
        var viewBoxWidth = 400000; // default
        var label = group.label.slice(1);
        if ($ef0731f441f79e9a$var$wideAccentLabels.has(label) && 'base' in group) {
            // There are four SVG images available for each function.
            // Choose a taller image when there are more characters.
            var numChars = group.base.type === "ordgroup" ? group.base.body.length : 1;
            var viewBoxHeight;
            var pathName;
            var _height;
            if (numChars > 5) {
                if (label === "widehat" || label === "widecheck") {
                    viewBoxHeight = 420;
                    viewBoxWidth = 2364;
                    _height = 0.42;
                    pathName = label + "4";
                } else {
                    viewBoxHeight = 312;
                    viewBoxWidth = 2340;
                    _height = 0.34;
                    pathName = "tilde4";
                }
            } else {
                var imgIndex = [
                    1,
                    1,
                    2,
                    2,
                    3,
                    3
                ][numChars];
                if (label === "widehat" || label === "widecheck") {
                    viewBoxWidth = [
                        0,
                        1062,
                        2364,
                        2364,
                        2364
                    ][imgIndex];
                    viewBoxHeight = [
                        0,
                        239,
                        300,
                        360,
                        420
                    ][imgIndex];
                    _height = [
                        0,
                        0.24,
                        0.3,
                        0.3,
                        0.36,
                        0.42
                    ][imgIndex];
                    pathName = label + imgIndex;
                } else {
                    viewBoxWidth = [
                        0,
                        600,
                        1033,
                        2339,
                        2340
                    ][imgIndex];
                    viewBoxHeight = [
                        0,
                        260,
                        286,
                        306,
                        312
                    ][imgIndex];
                    _height = [
                        0,
                        0.26,
                        0.286,
                        0.3,
                        0.306,
                        0.34
                    ][imgIndex];
                    pathName = "tilde" + imgIndex;
                }
            }
            var path = new $ef0731f441f79e9a$var$PathNode(pathName);
            var svgNode = new $ef0731f441f79e9a$var$SvgNode([
                path
            ], {
                "width": "100%",
                "height": $ef0731f441f79e9a$var$makeEm(_height),
                "viewBox": "0 0 " + viewBoxWidth + " " + viewBoxHeight,
                "preserveAspectRatio": "none"
            });
            return {
                span: $ef0731f441f79e9a$var$makeSvgSpan([], [
                    svgNode
                ], options),
                minWidth: 0,
                height: _height
            };
        } else {
            var spans = [];
            var data = $ef0731f441f79e9a$var$katexImagesData[label];
            if (!data) throw new Error("No SVG data for \"" + label + "\".");
            var [paths, _minWidth, _viewBoxHeight] = data;
            var _height2 = _viewBoxHeight / 1000;
            var numSvgChildren = paths.length;
            var widthClasses;
            var aligns;
            if (numSvgChildren === 1) {
                if (data.length !== 4) throw new Error("Expected 4-tuple for single-path SVG data \"" + label + "\".");
                widthClasses = [
                    "hide-tail"
                ];
                aligns = [
                    data[3]
                ];
            } else if (numSvgChildren === 2) {
                widthClasses = [
                    "halfarrow-left",
                    "halfarrow-right"
                ];
                aligns = [
                    "xMinYMin",
                    "xMaxYMin"
                ];
            } else if (numSvgChildren === 3) {
                widthClasses = [
                    "brace-left",
                    "brace-center",
                    "brace-right"
                ];
                aligns = [
                    "xMinYMin",
                    "xMidYMin",
                    "xMaxYMin"
                ];
            } else throw new Error("Correct katexImagesData or update code here to support\n                    " + numSvgChildren + " children.");
            for(var i = 0; i < numSvgChildren; i++){
                var _path = new $ef0731f441f79e9a$var$PathNode(paths[i]);
                var _svgNode = new $ef0731f441f79e9a$var$SvgNode([
                    _path
                ], {
                    "width": "400em",
                    "height": $ef0731f441f79e9a$var$makeEm(_height2),
                    "viewBox": "0 0 " + viewBoxWidth + " " + _viewBoxHeight,
                    "preserveAspectRatio": aligns[i] + " slice"
                });
                var _span = $ef0731f441f79e9a$var$makeSvgSpan([
                    widthClasses[i]
                ], [
                    _svgNode
                ], options);
                if (numSvgChildren === 1) return {
                    span: _span,
                    minWidth: _minWidth,
                    height: _height2
                };
                else {
                    _span.style.height = $ef0731f441f79e9a$var$makeEm(_height2);
                    spans.push(_span);
                }
            }
            return {
                span: $ef0731f441f79e9a$var$makeSpan([
                    "stretchy"
                ], spans, options),
                minWidth: _minWidth,
                height: _height2
            };
        }
    } // buildSvgSpan_()
    var { span: span, minWidth: minWidth, height: height } = buildSvgSpan_();
    // Note that we are returning span.depth = 0.
    // Any adjustments relative to the baseline must be done in buildHTML.
    span.height = height;
    span.style.height = $ef0731f441f79e9a$var$makeEm(height);
    if (minWidth > 0) span.style.minWidth = $ef0731f441f79e9a$var$makeEm(minWidth);
    return span;
};
var $ef0731f441f79e9a$var$stretchyEnclose = function stretchyEnclose(inner, label, topPad, bottomPad, options) {
    // Return an image span for \cancel, \bcancel, \xcancel, \fbox, or \angl
    var img;
    var totalHeight = inner.height + inner.depth + topPad + bottomPad;
    if (/fbox|color|angl/.test(label)) {
        img = $ef0731f441f79e9a$var$makeSpan([
            "stretchy",
            label
        ], [], options);
        if (label === "fbox") {
            var color = options.color && options.getColor();
            if (color) img.style.borderColor = color;
        }
    } else {
        // \cancel, \bcancel, or \xcancel
        // Since \cancel's SVG is inline and it omits the viewBox attribute,
        // its stroke-width will not vary with span area.
        var lines = [];
        if (/^[bx]cancel$/.test(label)) lines.push(new $ef0731f441f79e9a$var$LineNode({
            "x1": "0",
            "y1": "0",
            "x2": "100%",
            "y2": "100%",
            "stroke-width": "0.046em"
        }));
        if (/^x?cancel$/.test(label)) lines.push(new $ef0731f441f79e9a$var$LineNode({
            "x1": "0",
            "y1": "100%",
            "x2": "100%",
            "y2": "0",
            "stroke-width": "0.046em"
        }));
        var svgNode = new $ef0731f441f79e9a$var$SvgNode(lines, {
            "width": "100%",
            "height": $ef0731f441f79e9a$var$makeEm(totalHeight)
        });
        img = $ef0731f441f79e9a$var$makeSvgSpan([], [
            svgNode
        ], options);
    }
    img.height = totalHeight;
    img.style.height = $ef0731f441f79e9a$var$makeEm(totalHeight);
    return img;
};
/**
 * Small module for atom-group constants and type guard.  Kept separate from
 * `symbols.ts` so that consumers (notably `contrib/render-a11y-string`) can
 * pull in `isAtom` without dragging in the ~870-line symbol tables.
 */ // Some of these have a "-token" suffix since these are also used as `ParseNode`
// types for raw text tokens, and we want to avoid conflicts with higher-level
// `ParseNode` types. These `ParseNode`s are constructed within `Parser` by
// looking up the `symbols` map.
var $ef0731f441f79e9a$var$ATOMS = {
    "bin": 1,
    "close": 1,
    "inner": 1,
    "open": 1,
    "punct": 1,
    "rel": 1
};
var $ef0731f441f79e9a$var$NON_ATOMS = {
    "accent-token": 1,
    "mathord": 1,
    "op-token": 1,
    "spacing": 1,
    "textord": 1
};
function $ef0731f441f79e9a$var$isAtom(value) {
    return value in $ef0731f441f79e9a$var$ATOMS;
}
/**
 * Asserts that the node is of the given type and returns it with stricter
 * typing. Throws if the node's type does not match.
 */ function $ef0731f441f79e9a$var$assertNodeType(node, type) {
    if (!node || node.type !== type) throw new Error("Expected node of type " + type + ", but got " + (node ? "node of type " + node.type : String(node)));
    return node;
}
/**
 * Returns the node more strictly typed iff it is of the given type. Otherwise,
 * returns null.
 */ function $ef0731f441f79e9a$var$assertSymbolNodeType(node) {
    var typedNode = $ef0731f441f79e9a$var$checkSymbolNodeType(node);
    if (!typedNode) throw new Error("Expected node of symbol group type, but got " + (node ? "node of type " + node.type : String(node)));
    return typedNode;
}
/**
 * Returns the node more strictly typed iff it is of the given type. Otherwise,
 * returns null.
 */ function $ef0731f441f79e9a$var$checkSymbolNodeType(node) {
    if (node && (node.type === "atom" || $ef0731f441f79e9a$var$NON_ATOMS.hasOwnProperty(node.type))) return node;
    return null;
}
var $ef0731f441f79e9a$var$getBaseSymbol = (group)=>{
    if (group instanceof $ef0731f441f79e9a$var$SymbolNode) return group;
    if ($ef0731f441f79e9a$var$hasHtmlDomChildren(group) && group.children.length === 1) return $ef0731f441f79e9a$var$getBaseSymbol(group.children[0]);
};
// NOTE: Unlike most `htmlBuilder`s, this one handles not only "accent", but
// also "supsub" since an accent can affect super/subscripting.
var $ef0731f441f79e9a$var$htmlBuilder$a = (grp, options)=>{
    // Accents are handled in the TeXbook pg. 443, rule 12.
    var base;
    var group;
    var supSubGroup;
    if (grp && grp.type === "supsub") {
        // If our base is a character box, and we have superscripts and
        // subscripts, the supsub will defer to us. In particular, we want
        // to attach the superscripts and subscripts to the inner body (so
        // that the position of the superscripts and subscripts won't be
        // affected by the height of the accent). We accomplish this by
        // sticking the base of the accent into the base of the supsub, and
        // rendering that, while keeping track of where the accent is.
        // The real accent group is the base of the supsub group
        group = $ef0731f441f79e9a$var$assertNodeType(grp.base, "accent");
        // The character box is the base of the accent group
        base = group.base;
        // Stick the character box into the base of the supsub group
        grp.base = base;
        // Rerender the supsub group with its new base, and store that
        // result.
        supSubGroup = $ef0731f441f79e9a$var$assertSpan($ef0731f441f79e9a$var$buildGroup$1(grp, options));
        // reset original base
        grp.base = group;
    } else {
        group = $ef0731f441f79e9a$var$assertNodeType(grp, "accent");
        base = group.base;
    }
    // Build the base group
    var body = $ef0731f441f79e9a$var$buildGroup$1(base, options.havingCrampedStyle());
    // Does the accent need to shift for the skew of a character?
    var mustShift = group.isShifty && $ef0731f441f79e9a$var$isCharacterBox(base);
    // Calculate the skew of the accent. This is based on the line "If the
    // nucleus is not a single character, let s = 0; otherwise set s to the
    // kern amount for the nucleus followed by the \skewchar of its font."
    // Note that our skew metrics are just the kern between each character
    // and the skewchar.
    var skew = 0;
    if (mustShift) {
        var _getBaseSymbol$skew, _getBaseSymbol;
        // Read the skew from the rendered base symbol.
        // This preserves font metrics from font wrappers like \mathbb.
        skew = (_getBaseSymbol$skew = (_getBaseSymbol = $ef0731f441f79e9a$var$getBaseSymbol(body)) == null ? void 0 : _getBaseSymbol.skew) != null ? _getBaseSymbol$skew : 0;
    }
    var accentBelow = group.label === "\\c";
    // calculate the amount of space between the body and the accent
    var clearance = accentBelow ? body.height + body.depth : Math.min(body.height, options.fontMetrics().xHeight);
    // Build the accent
    var accentBody;
    if (!group.isStretchy) {
        var accent;
        var width;
        if (group.label === "\\vec") {
            // Before version 0.9, \vec used the combining font glyph U+20D7.
            // But browsers, especially Safari, are not consistent in how they
            // render combining characters when not preceded by a character.
            // So now we use an SVG.
            // If Safari reforms, we should consider reverting to the glyph.
            accent = $ef0731f441f79e9a$var$staticSvg("vec", options);
            width = $ef0731f441f79e9a$var$svgData.vec[1];
        } else {
            accent = $ef0731f441f79e9a$var$makeOrd({
                type: "textord",
                mode: group.mode,
                text: group.label
            }, options, "textord");
            accent = $ef0731f441f79e9a$var$assertSymbolDomNode(accent);
            // Remove the italic correction of the accent, because it only serves to
            // shift the accent over to a place we don't want.
            accent.italic = 0;
            width = accent.width;
            if (accentBelow) clearance += accent.depth;
        }
        accentBody = $ef0731f441f79e9a$var$makeSpan([
            "accent-body"
        ], [
            accent
        ]);
        // "Full" accents expand the width of the resulting symbol to be
        // at least the width of the accent, and overlap directly onto the
        // character without any vertical offset.
        var accentFull = group.label === "\\textcircled";
        if (accentFull) {
            accentBody.classes.push('accent-full');
            clearance = body.height;
        }
        // Shift the accent over by the skew.
        var left = skew;
        // CSS defines `.katex .accent .accent-body:not(.accent-full) { width: 0 }`
        // so that the accent doesn't contribute to the bounding box.
        // We need to shift the character by its width (effectively half
        // its width) to compensate.
        if (!accentFull) left -= width / 2;
        accentBody.style.left = $ef0731f441f79e9a$var$makeEm(left);
        // \textcircled uses the \bigcirc glyph, so it needs some
        // vertical adjustment to match LaTeX.
        if (group.label === "\\textcircled") accentBody.style.top = ".2em";
        accentBody = $ef0731f441f79e9a$var$makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: body
                },
                {
                    type: "kern",
                    size: -clearance
                },
                {
                    type: "elem",
                    elem: accentBody
                }
            ]
        });
    } else {
        accentBody = $ef0731f441f79e9a$var$stretchySvg(group, options);
        accentBody = $ef0731f441f79e9a$var$makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: body
                },
                {
                    type: "elem",
                    elem: accentBody,
                    wrapperClasses: [
                        "svg-align"
                    ],
                    wrapperStyle: skew > 0 ? {
                        width: "calc(100% - " + $ef0731f441f79e9a$var$makeEm(2 * skew) + ")",
                        marginLeft: $ef0731f441f79e9a$var$makeEm(2 * skew)
                    } : undefined
                }
            ]
        });
    }
    var accentWrap = $ef0731f441f79e9a$var$makeSpan([
        "mord",
        "accent"
    ], [
        accentBody
    ], options);
    if (supSubGroup) {
        // Here, we replace the "base" child of the supsub with our newly
        // generated accent.
        supSubGroup.children[0] = accentWrap;
        // Since we don't rerun the height calculation after replacing the
        // accent, we manually recalculate height.
        supSubGroup.height = Math.max(accentWrap.height, supSubGroup.height);
        // Accents should always be ords, even when their innards are not.
        supSubGroup.classes[0] = "mord";
        return supSubGroup;
    } else return accentWrap;
};
var $ef0731f441f79e9a$var$mathmlBuilder$9 = (group, options)=>{
    var accentNode = group.isStretchy ? $ef0731f441f79e9a$var$stretchyMathML(group.label) : new $ef0731f441f79e9a$var$MathNode("mo", [
        $ef0731f441f79e9a$var$makeText(group.label, group.mode)
    ]);
    var node = new $ef0731f441f79e9a$var$MathNode("mover", [
        $ef0731f441f79e9a$var$buildGroup(group.base, options),
        accentNode
    ]);
    node.setAttribute("accent", "true");
    return node;
};
var $ef0731f441f79e9a$var$NON_STRETCHY_ACCENT_REGEX = new RegExp([
    "\\acute",
    "\\grave",
    "\\ddot",
    "\\tilde",
    "\\bar",
    "\\breve",
    "\\check",
    "\\hat",
    "\\vec",
    "\\dot",
    "\\mathring"
].map((accent)=>"\\" + accent).join("|"));
// Accents
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "accent",
    names: [
        "\\acute",
        "\\grave",
        "\\ddot",
        "\\tilde",
        "\\bar",
        "\\breve",
        "\\check",
        "\\hat",
        "\\vec",
        "\\dot",
        "\\mathring",
        "\\widecheck",
        "\\widehat",
        "\\widetilde",
        "\\overrightarrow",
        "\\overleftarrow",
        "\\Overrightarrow",
        "\\overleftrightarrow",
        "\\overgroup",
        "\\overlinesegment",
        "\\overleftharpoon",
        "\\overrightharpoon"
    ],
    props: {
        numArgs: 1
    },
    handler: (context, args)=>{
        var base = $ef0731f441f79e9a$var$normalizeArgument(args[0]);
        var isStretchy = !$ef0731f441f79e9a$var$NON_STRETCHY_ACCENT_REGEX.test(context.funcName);
        var isShifty = !isStretchy || context.funcName === "\\widehat" || context.funcName === "\\widetilde" || context.funcName === "\\widecheck";
        return {
            type: "accent",
            mode: context.parser.mode,
            label: context.funcName,
            isStretchy: isStretchy,
            isShifty: isShifty,
            base: base
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$a,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$9
});
// Text-mode accents
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "accent",
    names: [
        "\\'",
        "\\`",
        "\\^",
        "\\~",
        "\\=",
        "\\u",
        "\\.",
        '\\"',
        "\\c",
        "\\r",
        "\\H",
        "\\v",
        "\\textcircled"
    ],
    props: {
        numArgs: 1,
        allowedInText: true,
        allowedInMath: true,
        // unless in strict mode
        argTypes: [
            "primitive"
        ]
    },
    handler: (context, args)=>{
        var base = args[0];
        var mode = context.parser.mode;
        if (mode === "math") {
            context.parser.settings.reportNonstrict("mathVsTextAccents", "LaTeX's accent " + context.funcName + " works only in text mode");
            mode = "text";
        }
        return {
            type: "accent",
            mode: mode,
            label: context.funcName,
            isStretchy: false,
            isShifty: true,
            base: base
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$a,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$9
});
// Horizontal overlap functions
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "accentUnder",
    names: [
        "\\underleftarrow",
        "\\underrightarrow",
        "\\underleftrightarrow",
        "\\undergroup",
        "\\underlinesegment",
        "\\utilde"
    ],
    props: {
        numArgs: 1
    },
    handler: (_ref, args)=>{
        var { parser: parser, funcName: funcName } = _ref;
        var base = args[0];
        return {
            type: "accentUnder",
            mode: parser.mode,
            label: funcName,
            base: base
        };
    },
    htmlBuilder: (group, options)=>{
        // Treat under accents much like underlines.
        var innerGroup = $ef0731f441f79e9a$var$buildGroup$1(group.base, options);
        var accentBody = $ef0731f441f79e9a$var$stretchySvg(group, options);
        var kern = group.label === "\\utilde" ? 0.12 : 0;
        // Generate the vlist, with the appropriate kerns
        var vlist = $ef0731f441f79e9a$var$makeVList({
            positionType: "top",
            positionData: innerGroup.height,
            children: [
                {
                    type: "elem",
                    elem: accentBody,
                    wrapperClasses: [
                        "svg-align"
                    ]
                },
                {
                    type: "kern",
                    size: kern
                },
                {
                    type: "elem",
                    elem: innerGroup
                }
            ]
        });
        return $ef0731f441f79e9a$var$makeSpan([
            "mord",
            "accentunder"
        ], [
            vlist
        ], options);
    },
    mathmlBuilder: (group, options)=>{
        var accentNode = $ef0731f441f79e9a$var$stretchyMathML(group.label);
        var node = new $ef0731f441f79e9a$var$MathNode("munder", [
            $ef0731f441f79e9a$var$buildGroup(group.base, options),
            accentNode
        ]);
        node.setAttribute("accentunder", "true");
        return node;
    }
});
// Helper function
var $ef0731f441f79e9a$var$paddedNode = (group)=>{
    var node = new $ef0731f441f79e9a$var$MathNode("mpadded", group ? [
        group
    ] : []);
    node.setAttribute("width", "+0.6em");
    node.setAttribute("lspace", "0.3em");
    return node;
};
// Stretchy arrows with an optional argument
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "xArrow",
    names: [
        "\\xleftarrow",
        "\\xrightarrow",
        "\\xLeftarrow",
        "\\xRightarrow",
        "\\xleftrightarrow",
        "\\xLeftrightarrow",
        "\\xhookleftarrow",
        "\\xhookrightarrow",
        "\\xmapsto",
        "\\xrightharpoondown",
        "\\xrightharpoonup",
        "\\xleftharpoondown",
        "\\xleftharpoonup",
        "\\xrightleftharpoons",
        "\\xleftrightharpoons",
        "\\xlongequal",
        "\\xtwoheadrightarrow",
        "\\xtwoheadleftarrow",
        "\\xtofrom",
        // The next 3 functions are here to support the mhchem extension.
        // Direct use of these functions is discouraged and may break someday.
        "\\xrightleftarrows",
        "\\xrightequilibrium",
        "\\xleftequilibrium",
        // The next 3 functions are here only to support the {CD} environment.
        "\\\\cdrightarrow",
        "\\\\cdleftarrow",
        "\\\\cdlongequal"
    ],
    props: {
        numArgs: 1,
        numOptionalArgs: 1
    },
    handler (_ref, args, optArgs) {
        var { parser: parser, funcName: funcName } = _ref;
        return {
            type: "xArrow",
            mode: parser.mode,
            label: funcName,
            body: args[0],
            below: optArgs[0]
        };
    },
    htmlBuilder (group, options) {
        var style = options.style;
        // Build the argument groups in the appropriate style.
        // Ref: amsmath.dtx:   \hbox{$\scriptstyle\mkern#3mu{#6}\mkern#4mu$}%
        // Some groups can return document fragments.  Handle those by wrapping
        // them in a span.
        var newOptions = options.havingStyle(style.sup());
        var upperGroup = $ef0731f441f79e9a$var$wrapFragment($ef0731f441f79e9a$var$buildGroup$1(group.body, newOptions, options), options);
        var arrowPrefix = group.label.slice(0, 2) === "\\x" ? "x" : "cd";
        upperGroup.classes.push(arrowPrefix + "-arrow-pad");
        var lowerGroup;
        if (group.below) {
            // Build the lower group
            newOptions = options.havingStyle(style.sub());
            lowerGroup = $ef0731f441f79e9a$var$wrapFragment($ef0731f441f79e9a$var$buildGroup$1(group.below, newOptions, options), options);
            lowerGroup.classes.push(arrowPrefix + "-arrow-pad");
        }
        var arrowBody = $ef0731f441f79e9a$var$stretchySvg(group, options);
        // Re shift: Note that stretchySvg returned arrowBody.depth = 0.
        // The point we want on the math axis is at 0.5 * arrowBody.height.
        var arrowShift = -options.fontMetrics().axisHeight + 0.5 * arrowBody.height;
        // 2 mu kern. Ref: amsmath.dtx: #7\if0#2\else\mkern#2mu\fi
        var upperShift = -options.fontMetrics().axisHeight - 0.5 * arrowBody.height - 0.111; // 0.111 em = 2 mu
        if (upperGroup.depth > 0.25 || group.label === "\\xleftequilibrium") upperShift -= upperGroup.depth; // shift up if depth encroaches
        // Generate the vlist
        var vlist;
        if (lowerGroup) {
            var lowerShift = -options.fontMetrics().axisHeight + lowerGroup.height + 0.5 * arrowBody.height + 0.111;
            vlist = $ef0731f441f79e9a$var$makeVList({
                positionType: "individualShift",
                children: [
                    {
                        type: "elem",
                        elem: upperGroup,
                        shift: upperShift
                    },
                    {
                        type: "elem",
                        elem: arrowBody,
                        shift: arrowShift,
                        wrapperClasses: [
                            "svg-align"
                        ]
                    },
                    {
                        type: "elem",
                        elem: lowerGroup,
                        shift: lowerShift
                    }
                ]
            });
        } else vlist = $ef0731f441f79e9a$var$makeVList({
            positionType: "individualShift",
            children: [
                {
                    type: "elem",
                    elem: upperGroup,
                    shift: upperShift
                },
                {
                    type: "elem",
                    elem: arrowBody,
                    shift: arrowShift,
                    wrapperClasses: [
                        "svg-align"
                    ]
                }
            ]
        });
        return $ef0731f441f79e9a$var$makeSpan([
            "mrel",
            "x-arrow"
        ], [
            vlist
        ], options);
    },
    mathmlBuilder (group, options) {
        var arrowNode = $ef0731f441f79e9a$var$stretchyMathML(group.label);
        arrowNode.setAttribute("minsize", group.label.charAt(0) === "x" ? "1.75em" : "3.0em");
        var node;
        if (group.body) {
            var upperNode = $ef0731f441f79e9a$var$paddedNode($ef0731f441f79e9a$var$buildGroup(group.body, options));
            if (group.below) {
                var lowerNode = $ef0731f441f79e9a$var$paddedNode($ef0731f441f79e9a$var$buildGroup(group.below, options));
                node = new $ef0731f441f79e9a$var$MathNode("munderover", [
                    arrowNode,
                    lowerNode,
                    upperNode
                ]);
            } else node = new $ef0731f441f79e9a$var$MathNode("mover", [
                arrowNode,
                upperNode
            ]);
        } else if (group.below) {
            var _lowerNode = $ef0731f441f79e9a$var$paddedNode($ef0731f441f79e9a$var$buildGroup(group.below, options));
            node = new $ef0731f441f79e9a$var$MathNode("munder", [
                arrowNode,
                _lowerNode
            ]);
        } else {
            // This should never happen.
            // Parser.js throws an error if there is no argument.
            node = $ef0731f441f79e9a$var$paddedNode();
            node = new $ef0731f441f79e9a$var$MathNode("mover", [
                arrowNode,
                node
            ]);
        }
        return node;
    }
});
function $ef0731f441f79e9a$var$htmlBuilder$9(group, options) {
    var elements = $ef0731f441f79e9a$var$buildExpression$1(group.body, options, true);
    return $ef0731f441f79e9a$var$makeSpan([
        group.mclass
    ], elements, options);
}
function $ef0731f441f79e9a$var$mathmlBuilder$8(group, options) {
    var node;
    var inner = $ef0731f441f79e9a$var$buildExpression(group.body, options);
    if (group.mclass === "minner") node = new $ef0731f441f79e9a$var$MathNode("mpadded", inner);
    else if (group.mclass === "mord") {
        if (group.isCharacterBox) {
            node = inner[0];
            node.type = "mi";
        } else node = new $ef0731f441f79e9a$var$MathNode("mi", inner);
    } else {
        if (group.isCharacterBox) {
            node = inner[0];
            node.type = "mo";
        } else node = new $ef0731f441f79e9a$var$MathNode("mo", inner);
        // Set spacing based on what is the most likely adjacent atom type.
        // See TeXbook p170.
        if (group.mclass === "mbin") {
            node.attributes.lspace = "0.22em"; // medium space
            node.attributes.rspace = "0.22em";
        } else if (group.mclass === "mpunct") {
            node.attributes.lspace = "0em";
            node.attributes.rspace = "0.17em"; // thinspace
        } else if (group.mclass === "mopen" || group.mclass === "mclose") {
            node.attributes.lspace = "0em";
            node.attributes.rspace = "0em";
        } else if (group.mclass === "minner") {
            node.attributes.lspace = "0.0556em"; // 1 mu is the most likely option
            node.attributes.width = "+0.1111em";
        }
    // MathML <mo> default space is 5/18 em, so <mrel> needs no action.
    // Ref: https://developer.mozilla.org/en-US/docs/Web/MathML/Element/mo
    }
    return node;
}
// Math class commands except \mathop
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "mclass",
    names: [
        "\\mathord",
        "\\mathbin",
        "\\mathrel",
        "\\mathopen",
        "\\mathclose",
        "\\mathpunct",
        "\\mathinner"
    ],
    props: {
        numArgs: 1,
        primitive: true
    },
    handler (_ref, args) {
        var { parser: parser, funcName: funcName } = _ref;
        var body = args[0];
        return {
            type: "mclass",
            mode: parser.mode,
            mclass: "m" + funcName.slice(5),
            // TODO(kevinb): don't prefix with 'm'
            body: $ef0731f441f79e9a$var$ordargument(body),
            isCharacterBox: $ef0731f441f79e9a$var$isCharacterBox(body)
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$9,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$8
});
var $ef0731f441f79e9a$var$binrelClass = (arg)=>{
    // \binrel@ spacing varies with (bin|rel|ord) of the atom in the argument.
    // (by rendering separately and with {}s before and after, and measuring
    // the change in spacing).  We'll do roughly the same by detecting the
    // atom type directly.
    var atom = arg.type === "ordgroup" && arg.body.length ? arg.body[0] : arg;
    if (atom.type === "atom" && (atom.family === "bin" || atom.family === "rel")) return "m" + atom.family;
    else return "mord";
};
// \@binrel{x}{y} renders like y but as mbin/mrel/mord if x is mbin/mrel/mord.
// This is equivalent to \binrel@{x}\binrel@@{y} in AMSTeX.
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "mclass",
    names: [
        "\\@binrel"
    ],
    props: {
        numArgs: 2
    },
    handler (_ref2, args) {
        var { parser: parser } = _ref2;
        return {
            type: "mclass",
            mode: parser.mode,
            mclass: $ef0731f441f79e9a$var$binrelClass(args[0]),
            body: $ef0731f441f79e9a$var$ordargument(args[1]),
            isCharacterBox: $ef0731f441f79e9a$var$isCharacterBox(args[1])
        };
    }
});
// Build a relation or stacked op by placing one symbol on top of another
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "mclass",
    names: [
        "\\stackrel",
        "\\overset",
        "\\underset"
    ],
    props: {
        numArgs: 2
    },
    handler (_ref3, args) {
        var { parser: parser, funcName: funcName } = _ref3;
        var baseArg = args[1];
        var shiftedArg = args[0];
        var mclass;
        if (funcName !== "\\stackrel") // LaTeX applies \binrel spacing to \overset and \underset.
        mclass = $ef0731f441f79e9a$var$binrelClass(baseArg);
        else mclass = "mrel"; // for \stackrel
        var baseOp = {
            type: "op",
            mode: baseArg.mode,
            limits: true,
            alwaysHandleSupSub: true,
            parentIsSupSub: false,
            symbol: false,
            suppressBaseShift: funcName !== "\\stackrel",
            body: $ef0731f441f79e9a$var$ordargument(baseArg)
        };
        var supsub = {
            type: "supsub",
            mode: shiftedArg.mode,
            base: baseOp,
            sup: funcName === "\\underset" ? null : shiftedArg,
            sub: funcName === "\\underset" ? shiftedArg : null
        };
        return {
            type: "mclass",
            mode: parser.mode,
            mclass: mclass,
            body: [
                supsub
            ],
            isCharacterBox: $ef0731f441f79e9a$var$isCharacterBox(supsub)
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$9,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$8
});
// \pmb is a simulation of bold font.
// The version of \pmb in ambsy.sty works by typesetting three copies
// with small offsets. We use CSS text-shadow.
// It's a hack. Not as good as a real bold font. Better than nothing.
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "pmb",
    names: [
        "\\pmb"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler (_ref, args) {
        var { parser: parser } = _ref;
        return {
            type: "pmb",
            mode: parser.mode,
            mclass: $ef0731f441f79e9a$var$binrelClass(args[0]),
            body: $ef0731f441f79e9a$var$ordargument(args[0])
        };
    },
    htmlBuilder (group, options) {
        var elements = $ef0731f441f79e9a$var$buildExpression$1(group.body, options, true);
        var node = $ef0731f441f79e9a$var$makeSpan([
            group.mclass
        ], elements, options);
        node.style.textShadow = "0.02em 0.01em 0.04px";
        return node;
    },
    mathmlBuilder (group, style) {
        var inner = $ef0731f441f79e9a$var$buildExpression(group.body, style);
        // Wrap with an <mstyle> element.
        var node = new $ef0731f441f79e9a$var$MathNode("mstyle", inner);
        node.setAttribute("style", "text-shadow: 0.02em 0.01em 0.04px");
        return node;
    }
});
var $ef0731f441f79e9a$var$cdArrowFunctionName = {
    ">": "\\\\cdrightarrow",
    "<": "\\\\cdleftarrow",
    "=": "\\\\cdlongequal",
    "A": "\\uparrow",
    "V": "\\downarrow",
    "|": "\\Vert",
    ".": "no arrow"
};
var $ef0731f441f79e9a$var$newCell = ()=>{
    // Create an empty cell, to be filled below with parse nodes.
    // The parseTree from this module must be constructed like the
    // one created by parseArray(), so an empty CD cell must
    // be a ParseNode<"styling">. And CD is always displaystyle.
    return {
        type: "styling",
        body: [],
        mode: "math",
        style: "display",
        resetFont: true
    };
};
var $ef0731f441f79e9a$var$isStartOfArrow = (node)=>{
    return node.type === "textord" && node.text === "@";
};
var $ef0731f441f79e9a$var$isLabelEnd = (node, endChar)=>{
    return (node.type === "mathord" || node.type === "atom") && node.text === endChar;
};
function $ef0731f441f79e9a$var$cdArrow(arrowChar, labels, parser) {
    // Return a parse tree of an arrow and its labels.
    // This acts in a way similar to a macro expansion.
    var funcName = $ef0731f441f79e9a$var$cdArrowFunctionName[arrowChar];
    switch(funcName){
        case "\\\\cdrightarrow":
        case "\\\\cdleftarrow":
            return parser.callFunction(funcName, [
                labels[0]
            ], [
                labels[1]
            ]);
        case "\\uparrow":
        case "\\downarrow":
            var leftLabel = parser.callFunction("\\\\cdleft", [
                labels[0]
            ], []);
            var bareArrow = {
                type: "atom",
                text: funcName,
                mode: "math",
                family: "rel"
            };
            var sizedArrow = parser.callFunction("\\Big", [
                bareArrow
            ], []);
            var rightLabel = parser.callFunction("\\\\cdright", [
                labels[1]
            ], []);
            var arrowGroup = {
                type: "ordgroup",
                mode: "math",
                body: [
                    leftLabel,
                    sizedArrow,
                    rightLabel
                ]
            };
            return parser.callFunction("\\\\cdparent", [
                arrowGroup
            ], []);
        case "\\\\cdlongequal":
            return parser.callFunction("\\\\cdlongequal", [], []);
        case "\\Vert":
            var arrow = {
                type: "textord",
                text: "\\Vert",
                mode: "math"
            };
            return parser.callFunction("\\Big", [
                arrow
            ], []);
        default:
            return {
                type: "textord",
                text: " ",
                mode: "math"
            };
    }
}
function $ef0731f441f79e9a$var$parseCD(parser) {
    // Get the array's parse nodes with \\ temporarily mapped to \cr.
    var parsedRows = [];
    parser.gullet.beginGroup();
    parser.gullet.macros.set("\\cr", "\\\\\\relax");
    parser.gullet.beginGroup();
    while(true){
        // Get the parse nodes for the next row.
        parsedRows.push(parser.parseExpression(false, "\\\\"));
        parser.gullet.endGroup();
        parser.gullet.beginGroup();
        var next = parser.fetch().text;
        if (next === "&" || next === "\\\\") parser.consume();
        else if (next === "\\end") {
            if (parsedRows[parsedRows.length - 1].length === 0) parsedRows.pop(); // final row ended in \\
            break;
        } else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Expected \\\\ or \\cr or \\end", parser.nextToken);
    }
    var row = [];
    var body = [
        row
    ];
    // Loop thru the parse nodes. Collect them into cells and arrows.
    for(var i = 0; i < parsedRows.length; i++){
        // Start a new row.
        var rowNodes = parsedRows[i];
        // Create the first cell.
        var cell = $ef0731f441f79e9a$var$newCell();
        for(var j = 0; j < rowNodes.length; j++)if (!$ef0731f441f79e9a$var$isStartOfArrow(rowNodes[j])) // If a parseNode is not an arrow, it goes into a cell.
        cell.body.push(rowNodes[j]);
        else {
            // Parse node j is an "@", the start of an arrow.
            // Before starting on the arrow, push the cell into `row`.
            row.push(cell);
            // Now collect parseNodes into an arrow.
            // The character after "@" defines the arrow type.
            j += 1;
            var arrowChar = $ef0731f441f79e9a$var$assertSymbolNodeType(rowNodes[j]).text;
            // Create two empty label nodes. We may or may not use them.
            var labels = new Array(2);
            labels[0] = {
                type: "ordgroup",
                mode: "math",
                body: []
            };
            labels[1] = {
                type: "ordgroup",
                mode: "math",
                body: []
            };
            // Process the arrow.
            if ("=|.".includes(arrowChar)) ;
            else if ("<>AV".includes(arrowChar)) // Four arrows, `@>>>`, `@<<<`, `@AAA`, and `@VVV`, each take
            // two optional labels. E.g. the right-point arrow syntax is
            // really:  @>{optional label}>{optional label}>
            // Collect parseNodes into labels.
            for(var labelNum = 0; labelNum < 2; labelNum++){
                var inLabel = true;
                for(var k = j + 1; k < rowNodes.length; k++){
                    if ($ef0731f441f79e9a$var$isLabelEnd(rowNodes[k], arrowChar)) {
                        inLabel = false;
                        j = k;
                        break;
                    }
                    if ($ef0731f441f79e9a$var$isStartOfArrow(rowNodes[k])) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Missing a " + arrowChar + " character to complete a CD arrow.", rowNodes[k]);
                    labels[labelNum].body.push(rowNodes[k]);
                }
                if (inLabel) // isLabelEnd never returned a true.
                throw new $ef0731f441f79e9a$export$f9c837a54db411d("Missing a " + arrowChar + " character to complete a CD arrow.", rowNodes[j]);
            }
            else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Expected one of \"<>AV=|.\" after @", rowNodes[j]);
            // Now join the arrow to its labels.
            var arrow = $ef0731f441f79e9a$var$cdArrow(arrowChar, labels, parser);
            // Wrap the arrow in  ParseNode<"styling">.
            // This is done to match parseArray() behavior.
            var wrappedArrow = {
                type: "styling",
                body: [
                    arrow
                ],
                mode: "math",
                style: "display",
                // CD is always displaystyle.
                resetFont: true
            };
            row.push(wrappedArrow);
            // In CD's syntax, cells are implicit. That is, everything that
            // is not an arrow gets collected into a cell. So create an empty
            // cell now. It will collect upcoming parseNodes.
            cell = $ef0731f441f79e9a$var$newCell();
        }
        if (i % 2 === 0) // Even-numbered rows consist of: cell, arrow, cell, arrow, ... cell
        // The last cell is not yet pushed into `row`, so:
        row.push(cell);
        else // Odd-numbered rows consist of: vert arrow, empty cell, ... vert arrow
        // Remove the empty cell that was placed at the beginning of `row`.
        row.shift();
        row = [];
        body.push(row);
    }
    // End row group
    parser.gullet.endGroup();
    // End array group defining \\
    parser.gullet.endGroup();
    // define column separation.
    var cols = new Array(body[0].length).fill({
        type: "align",
        align: "c",
        pregap: 0.25,
        // CD package sets \enskip between columns.
        postgap: 0.25 // So pre and post each get half an \enskip, i.e. 0.25em.
    });
    return {
        type: "array",
        mode: "math",
        body: body,
        arraystretch: 1,
        addJot: true,
        rowGaps: [
            null
        ],
        cols: cols,
        colSeparationType: "CD",
        hLinesBeforeRow: new Array(body.length + 1).fill([])
    };
}
// The functions below are not available for general use.
// They are here only for internal use by the {CD} environment in placing labels
// next to vertical arrows.
// We don't need any such functions for horizontal arrows because we can reuse
// the functionality that already exists for extensible arrows.
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "cdlabel",
    names: [
        "\\\\cdleft",
        "\\\\cdright"
    ],
    props: {
        numArgs: 1
    },
    handler (_ref, args) {
        var { parser: parser, funcName: funcName } = _ref;
        return {
            type: "cdlabel",
            mode: parser.mode,
            side: funcName.slice(4),
            label: args[0]
        };
    },
    htmlBuilder (group, options) {
        var newOptions = options.havingStyle(options.style.sup());
        var label = $ef0731f441f79e9a$var$wrapFragment($ef0731f441f79e9a$var$buildGroup$1(group.label, newOptions, options), options);
        label.classes.push("cd-label-" + group.side);
        label.style.bottom = $ef0731f441f79e9a$var$makeEm(0.8 - label.depth);
        // Zero out label height & depth, so vertical align of arrow is set
        // by the arrow height, not by the label.
        label.height = 0;
        label.depth = 0;
        return label;
    },
    mathmlBuilder (group, options) {
        var label = new $ef0731f441f79e9a$var$MathNode("mrow", [
            $ef0731f441f79e9a$var$buildGroup(group.label, options)
        ]);
        label = new $ef0731f441f79e9a$var$MathNode("mpadded", [
            label
        ]);
        label.setAttribute("width", "0");
        if (group.side === "left") label.setAttribute("lspace", "-1width");
        // We have to guess at vertical alignment. We know the arrow is 1.8em tall,
        // But we don't know the height or depth of the label.
        label.setAttribute("voffset", "0.7em");
        label = new $ef0731f441f79e9a$var$MathNode("mstyle", [
            label
        ]);
        label.setAttribute("displaystyle", "false");
        label.setAttribute("scriptlevel", "1");
        return label;
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "cdlabelparent",
    names: [
        "\\\\cdparent"
    ],
    props: {
        numArgs: 1
    },
    handler (_ref2, args) {
        var { parser: parser } = _ref2;
        return {
            type: "cdlabelparent",
            mode: parser.mode,
            fragment: args[0]
        };
    },
    htmlBuilder (group, options) {
        // Wrap the vertical arrow and its labels.
        // The parent gets position: relative. The child gets position: absolute.
        // So CSS can locate the label correctly.
        var parent = $ef0731f441f79e9a$var$wrapFragment($ef0731f441f79e9a$var$buildGroup$1(group.fragment, options), options);
        parent.classes.push("cd-vert-arrow");
        return parent;
    },
    mathmlBuilder (group, options) {
        return new $ef0731f441f79e9a$var$MathNode("mrow", [
            $ef0731f441f79e9a$var$buildGroup(group.fragment, options)
        ]);
    }
});
// \@char is an internal function that takes a grouped decimal argument like
// {123} and converts into symbol with code 123.  It is used by the *macro*
// \char defined in macros.js.
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "textord",
    names: [
        "\\@char"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler (_ref, args) {
        var { parser: parser } = _ref;
        var arg = $ef0731f441f79e9a$var$assertNodeType(args[0], "ordgroup");
        var group = arg.body;
        var number = "";
        for(var i = 0; i < group.length; i++){
            var node = $ef0731f441f79e9a$var$assertNodeType(group[i], "textord");
            number += node.text;
        }
        var code = parseInt(number);
        var text;
        if (isNaN(code)) throw new $ef0731f441f79e9a$export$f9c837a54db411d("\\@char has non-numeric argument " + number);
        else if (code < 0 || code >= 0x10ffff) throw new $ef0731f441f79e9a$export$f9c837a54db411d("\\@char with invalid code point " + number);
        else if (code <= 0xffff) text = String.fromCharCode(code);
        else {
            // Astral code point; split into surrogate halves
            code -= 0x10000;
            text = String.fromCharCode((code >> 10) + 0xd800, (code & 0x3ff) + 0xdc00);
        }
        return {
            type: "textord",
            mode: parser.mode,
            text: text
        };
    }
});
var $ef0731f441f79e9a$var$htmlBuilder$8 = (group, options)=>{
    var elements = $ef0731f441f79e9a$var$buildExpression$1(group.body, options.withColor(group.color), false);
    // \color isn't supposed to affect the type of the elements it contains.
    // To accomplish this, we wrap the results in a fragment, so the inner
    // elements will be able to directly interact with their neighbors. For
    // example, `\color{red}{2 +} 3` has the same spacing as `2 + 3`
    return $ef0731f441f79e9a$var$makeFragment(elements);
};
var $ef0731f441f79e9a$var$mathmlBuilder$7 = (group, options)=>{
    var inner = $ef0731f441f79e9a$var$buildExpression(group.body, options.withColor(group.color));
    var node = new $ef0731f441f79e9a$var$MathNode("mstyle", inner);
    node.setAttribute("mathcolor", group.color);
    return node;
};
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "color",
    names: [
        "\\textcolor"
    ],
    props: {
        numArgs: 2,
        allowedInText: true,
        argTypes: [
            "color",
            "original"
        ]
    },
    handler (_ref, args) {
        var { parser: parser } = _ref;
        var color = $ef0731f441f79e9a$var$assertNodeType(args[0], "color-token").color;
        var body = args[1];
        return {
            type: "color",
            mode: parser.mode,
            color: color,
            body: $ef0731f441f79e9a$var$ordargument(body)
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$8,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$7
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "color",
    names: [
        "\\color"
    ],
    props: {
        numArgs: 1,
        allowedInText: true,
        argTypes: [
            "color"
        ]
    },
    handler (_ref2, args) {
        var { parser: parser, breakOnTokenText: breakOnTokenText } = _ref2;
        var color = $ef0731f441f79e9a$var$assertNodeType(args[0], "color-token").color;
        // Set macro \current@color in current namespace to store the current
        // color, mimicking the behavior of color.sty.
        // This is currently used just to correctly color a \right
        // that follows a \color command.
        parser.gullet.macros.set("\\current@color", color);
        // Parse out the implicit body that should be colored.
        var body = parser.parseExpression(true, breakOnTokenText);
        return {
            type: "color",
            mode: parser.mode,
            color: color,
            body: body
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$8,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$7
});
// Row breaks within tabular environments, and line breaks at top level
// \DeclareRobustCommand\\{...\@xnewline}
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "cr",
    names: [
        "\\\\"
    ],
    props: {
        numArgs: 0,
        numOptionalArgs: 0,
        allowedInText: true
    },
    handler (_ref, args, optArgs) {
        var { parser: parser } = _ref;
        var size = parser.gullet.future().text === "[" ? parser.parseSizeGroup(true) : null;
        var newLine = !parser.settings.displayMode || !parser.settings.useStrictBehavior("newLineInDisplayMode", "In LaTeX, \\\\ or \\newline does nothing in display mode");
        return {
            type: "cr",
            mode: parser.mode,
            newLine: newLine,
            size: size && $ef0731f441f79e9a$var$assertNodeType(size, "size").value
        };
    },
    // The following builders are called only at the top level,
    // not within tabular/array environments.
    htmlBuilder (group, options) {
        var span = $ef0731f441f79e9a$var$makeSpan([
            "mspace"
        ], [], options);
        if (group.newLine) {
            span.classes.push("newline");
            if (group.size) span.style.marginTop = $ef0731f441f79e9a$var$makeEm($ef0731f441f79e9a$var$calculateSize(group.size, options));
        }
        return span;
    },
    mathmlBuilder (group, options) {
        var node = new $ef0731f441f79e9a$var$MathNode("mspace");
        if (group.newLine) {
            node.setAttribute("linebreak", "newline");
            if (group.size) node.setAttribute("height", $ef0731f441f79e9a$var$makeEm($ef0731f441f79e9a$var$calculateSize(group.size, options)));
        }
        return node;
    }
});
var $ef0731f441f79e9a$var$globalMap = {
    "\\global": "\\global",
    "\\long": "\\\\globallong",
    "\\\\globallong": "\\\\globallong",
    "\\def": "\\gdef",
    "\\gdef": "\\gdef",
    "\\edef": "\\xdef",
    "\\xdef": "\\xdef",
    "\\let": "\\\\globallet",
    "\\futurelet": "\\\\globalfuture"
};
var $ef0731f441f79e9a$var$checkControlSequence = (tok)=>{
    var name = tok.text;
    if (/^(?:[\\{}$&#^_]|EOF)$/.test(name)) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Expected a control sequence", tok);
    return name;
};
var $ef0731f441f79e9a$var$getRHS = (parser)=>{
    var tok = parser.gullet.popToken();
    if (tok.text === "=") {
        // consume optional equals
        tok = parser.gullet.popToken();
        if (tok.text === " ") // consume one optional space
        tok = parser.gullet.popToken();
    }
    return tok;
};
var $ef0731f441f79e9a$var$letCommand = (parser, name, tok, global)=>{
    var macro = parser.gullet.macros.get(tok.text);
    if (macro == null) {
        // don't expand it later even if a macro with the same name is defined
        // e.g., \let\foo=\frac \def\frac{\relax} \frac12
        tok.noexpand = true;
        macro = {
            tokens: [
                tok
            ],
            numArgs: 0,
            // reproduce the same behavior in expansion
            unexpandable: !parser.gullet.isExpandable(tok.text)
        };
    }
    parser.gullet.macros.set(name, macro, global);
};
// <assignment> -> <non-macro assignment>|<macro assignment>
// <non-macro assignment> -> <simple assignment>|\global<non-macro assignment>
// <macro assignment> -> <definition>|<prefix><macro assignment>
// <prefix> -> \global|\long|\outer
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "internal",
    names: [
        "\\global",
        "\\long",
        "\\\\globallong" // can’t be entered directly
    ],
    props: {
        numArgs: 0,
        allowedInText: true
    },
    handler (_ref) {
        var { parser: parser, funcName: funcName } = _ref;
        parser.consumeSpaces();
        var token = parser.fetch();
        if ($ef0731f441f79e9a$var$globalMap[token.text]) {
            // KaTeX doesn't have \par, so ignore \long
            if (funcName === "\\global" || funcName === "\\\\globallong") token.text = $ef0731f441f79e9a$var$globalMap[token.text];
            return $ef0731f441f79e9a$var$assertNodeType(parser.parseFunction(), "internal");
        }
        throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid token after macro prefix", token);
    }
});
// Basic support for macro definitions: \def, \gdef, \edef, \xdef
// <definition> -> <def><control sequence><definition text>
// <def> -> \def|\gdef|\edef|\xdef
// <definition text> -> <parameter text><left brace><balanced text><right brace>
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "internal",
    names: [
        "\\def",
        "\\gdef",
        "\\edef",
        "\\xdef"
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        primitive: true
    },
    handler (_ref2) {
        var { parser: parser, funcName: funcName } = _ref2;
        var tok = parser.gullet.popToken();
        var name = tok.text;
        if (/^(?:[\\{}$&#^_]|EOF)$/.test(name)) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Expected a control sequence", tok);
        var numArgs = 0;
        var insert;
        var delimiters = [
            []
        ];
        // <parameter text> contains no braces
        while(parser.gullet.future().text !== "{"){
            tok = parser.gullet.popToken();
            if (tok.text === "#") {
                // If the very last character of the <parameter text> is #, so that
                // this # is immediately followed by {, TeX will behave as if the {
                // had been inserted at the right end of both the parameter text
                // and the replacement text.
                if (parser.gullet.future().text === "{") {
                    insert = parser.gullet.future();
                    delimiters[numArgs].push("{");
                    break;
                }
                // A parameter, the first appearance of # must be followed by 1,
                // the next by 2, and so on; up to nine #’s are allowed
                tok = parser.gullet.popToken();
                if (!/^[1-9]$/.test(tok.text)) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid argument number \"" + tok.text + "\"");
                if (parseInt(tok.text) !== numArgs + 1) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Argument number \"" + tok.text + "\" out of order");
                numArgs++;
                delimiters.push([]);
            } else if (tok.text === "EOF") throw new $ef0731f441f79e9a$export$f9c837a54db411d("Expected a macro definition");
            else delimiters[numArgs].push(tok.text);
        }
        // replacement text, enclosed in '{' and '}' and properly nested
        var { tokens: tokens } = parser.gullet.consumeArg();
        if (insert) tokens.unshift(insert);
        if (funcName === "\\edef" || funcName === "\\xdef") {
            tokens = parser.gullet.expandTokens(tokens);
            tokens.reverse(); // to fit in with stack order
        }
        // Final arg is the expansion of the macro
        parser.gullet.macros.set(name, {
            tokens: tokens,
            numArgs: numArgs,
            delimiters: delimiters
        }, funcName === $ef0731f441f79e9a$var$globalMap[funcName]);
        return {
            type: "internal",
            mode: parser.mode
        };
    }
});
// <simple assignment> -> <let assignment>
// <let assignment> -> \futurelet<control sequence><token><token>
//     | \let<control sequence><equals><one optional space><token>
// <equals> -> <optional spaces>|<optional spaces>=
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "internal",
    names: [
        "\\let",
        "\\\\globallet" // can’t be entered directly
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        primitive: true
    },
    handler (_ref3) {
        var { parser: parser, funcName: funcName } = _ref3;
        var name = $ef0731f441f79e9a$var$checkControlSequence(parser.gullet.popToken());
        parser.gullet.consumeSpaces();
        var tok = $ef0731f441f79e9a$var$getRHS(parser);
        $ef0731f441f79e9a$var$letCommand(parser, name, tok, funcName === "\\\\globallet");
        return {
            type: "internal",
            mode: parser.mode
        };
    }
});
// ref: https://www.tug.org/TUGboat/tb09-3/tb22bechtolsheim.pdf
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "internal",
    names: [
        "\\futurelet",
        "\\\\globalfuture" // can’t be entered directly
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        primitive: true
    },
    handler (_ref4) {
        var { parser: parser, funcName: funcName } = _ref4;
        var name = $ef0731f441f79e9a$var$checkControlSequence(parser.gullet.popToken());
        var middle = parser.gullet.popToken();
        var tok = parser.gullet.popToken();
        $ef0731f441f79e9a$var$letCommand(parser, name, tok, funcName === "\\\\globalfuture");
        parser.gullet.pushToken(tok);
        parser.gullet.pushToken(middle);
        return {
            type: "internal",
            mode: parser.mode
        };
    }
});
/**
 * This file deals with creating delimiters of various sizes. The TeXbook
 * discusses these routines on page 441-442, in the "Another subroutine sets box
 * x to a specified variable delimiter" paragraph.
 *
 * There are three main routines here. `makeSmallDelim` makes a delimiter in the
 * normal font, but in either text, script, or scriptscript style.
 * `makeLargeDelim` makes a delimiter in textstyle, but in one of the Size1,
 * Size2, Size3, or Size4 fonts. `makeStackedDelim` makes a delimiter out of
 * smaller pieces that are stacked on top of one another.
 *
 * The functions take a parameter `center`, which determines if the delimiter
 * should be centered around the axis.
 *
 * Then, there are three exposed functions. `sizedDelim` makes a delimiter in
 * one of the given sizes. This is used for things like `\bigl`.
 * `customSizedDelim` makes a delimiter with a given total height+depth. It is
 * called in places like `\sqrt`. `leftRightDelim` makes an appropriate
 * delimiter which surrounds an expression of a given height an depth. It is
 * used in `\left` and `\right`.
 */ /**
 * Get the metrics for a given symbol and font, after transformation (i.e.
 * after following replacement from symbols.js)
 */ var $ef0731f441f79e9a$var$getMetrics = function getMetrics(symbol, font, mode) {
    var replace = $ef0731f441f79e9a$var$symbols.math[symbol] && $ef0731f441f79e9a$var$symbols.math[symbol].replace;
    var metrics = $ef0731f441f79e9a$var$getCharacterMetrics(replace || symbol, font, mode);
    if (!metrics) throw new Error("Unsupported symbol " + symbol + " and font size " + font + ".");
    return metrics;
};
/**
 * Puts a delimiter span in a given style, and adds appropriate height, depth,
 * and maxFontSizes.
 */ var $ef0731f441f79e9a$var$styleWrap = function styleWrap(delim, toStyle, options, classes) {
    var newOptions = options.havingBaseStyle(toStyle);
    var span = $ef0731f441f79e9a$var$makeSpan(classes.concat(newOptions.sizingClasses(options)), [
        delim
    ], options);
    var delimSizeMultiplier = newOptions.sizeMultiplier / options.sizeMultiplier;
    span.height *= delimSizeMultiplier;
    span.depth *= delimSizeMultiplier;
    span.maxFontSize = newOptions.sizeMultiplier;
    return span;
};
var $ef0731f441f79e9a$var$centerSpan = function centerSpan(span, options, style) {
    var newOptions = options.havingBaseStyle(style);
    var shift = (1 - options.sizeMultiplier / newOptions.sizeMultiplier) * options.fontMetrics().axisHeight;
    span.classes.push("delimcenter");
    span.style.top = $ef0731f441f79e9a$var$makeEm(shift);
    span.height -= shift;
    span.depth += shift;
};
/**
 * Makes a small delimiter. This is a delimiter that comes in the Main-Regular
 * font, but is restyled to either be in textstyle, scriptstyle, or
 * scriptscriptstyle.
 */ var $ef0731f441f79e9a$var$makeSmallDelim = function makeSmallDelim(delim, style, center, options, mode, classes) {
    var text = $ef0731f441f79e9a$var$makeSymbol(delim, "Main-Regular", mode, options);
    var span = $ef0731f441f79e9a$var$styleWrap(text, style, options, classes);
    if (center) $ef0731f441f79e9a$var$centerSpan(span, options, style);
    return span;
};
/**
 * Builds a symbol in the given font size (note size is an integer)
 */ var $ef0731f441f79e9a$var$mathrmSize = function mathrmSize(value, size, mode, options) {
    return $ef0731f441f79e9a$var$makeSymbol(value, "Size" + size + "-Regular", mode, options);
};
/**
 * Makes a large delimiter. This is a delimiter that comes in the Size1, Size2,
 * Size3, or Size4 fonts. It is always rendered in textstyle.
 */ var $ef0731f441f79e9a$var$makeLargeDelim = function makeLargeDelim(delim, size, center, options, mode, classes) {
    var inner = $ef0731f441f79e9a$var$mathrmSize(delim, size, mode, options);
    var span = $ef0731f441f79e9a$var$styleWrap($ef0731f441f79e9a$var$makeSpan([
        "delimsizing",
        "size" + size
    ], [
        inner
    ], options), $ef0731f441f79e9a$var$Style$1.TEXT, options, classes);
    if (center) $ef0731f441f79e9a$var$centerSpan(span, options, $ef0731f441f79e9a$var$Style$1.TEXT);
    return span;
};
/**
 * Make a span from a font glyph with the given offset and in the given font.
 * This is used in makeStackedDelim to make the stacking pieces for the delimiter.
 */ var $ef0731f441f79e9a$var$makeGlyphSpan = function makeGlyphSpan(symbol, font, mode) {
    var sizeClass;
    // Apply the correct CSS class to choose the right font.
    if (font === "Size1-Regular") sizeClass = "delim-size1";
    else sizeClass = "delim-size4";
    var corner = $ef0731f441f79e9a$var$makeSpan([
        "delimsizinginner",
        sizeClass
    ], [
        $ef0731f441f79e9a$var$makeSpan([], [
            $ef0731f441f79e9a$var$makeSymbol(symbol, font, mode)
        ])
    ]);
    // Since this will be passed into `makeVList` in the end, wrap the element
    // in the appropriate tag that VList uses.
    return {
        type: "elem",
        elem: corner
    };
};
var $ef0731f441f79e9a$var$makeInner = function makeInner(ch, height, options) {
    // Create a span with inline SVG for the inner part of a tall stacked delimiter.
    var width = $ef0731f441f79e9a$var$fontMetricsData['Size4-Regular'][ch.charCodeAt(0)] ? $ef0731f441f79e9a$var$fontMetricsData['Size4-Regular'][ch.charCodeAt(0)][4] : $ef0731f441f79e9a$var$fontMetricsData['Size1-Regular'][ch.charCodeAt(0)][4];
    var path = new $ef0731f441f79e9a$var$PathNode("inner", $ef0731f441f79e9a$var$innerPath(ch, Math.round(1000 * height)));
    var svgNode = new $ef0731f441f79e9a$var$SvgNode([
        path
    ], {
        "width": $ef0731f441f79e9a$var$makeEm(width),
        "height": $ef0731f441f79e9a$var$makeEm(height),
        // Override CSS rule `.katex svg { width: 100% }`
        "style": "width:" + $ef0731f441f79e9a$var$makeEm(width),
        "viewBox": "0 0 " + 1000 * width + " " + Math.round(1000 * height),
        "preserveAspectRatio": "xMinYMin"
    });
    var span = $ef0731f441f79e9a$var$makeSvgSpan([], [
        svgNode
    ], options);
    span.height = height;
    span.style.height = $ef0731f441f79e9a$var$makeEm(height);
    span.style.width = $ef0731f441f79e9a$var$makeEm(width);
    return {
        type: "elem",
        elem: span
    };
};
// Helpers for makeStackedDelim
var $ef0731f441f79e9a$var$lapInEms = 0.008;
var $ef0731f441f79e9a$var$lap = {
    type: "kern",
    size: -1 * $ef0731f441f79e9a$var$lapInEms
};
var $ef0731f441f79e9a$var$verts = new Set([
    "|",
    "\\lvert",
    "\\rvert",
    "\\vert"
]);
var $ef0731f441f79e9a$var$doubleVerts = new Set([
    "\\|",
    "\\lVert",
    "\\rVert",
    "\\Vert"
]);
/**
 * Make a stacked delimiter out of a given delimiter, with the total height at
 * least `heightTotal`. This routine is mentioned on page 442 of the TeXbook.
 */ var $ef0731f441f79e9a$var$makeStackedDelim = function makeStackedDelim(delim, heightTotal, center, options, mode, classes) {
    // There are four parts, the top, an optional middle, a repeated part, and a
    // bottom.
    var top;
    var middle;
    var repeat;
    var bottom;
    var svgLabel = "";
    var viewBoxWidth = 0;
    top = repeat = bottom = delim;
    middle = null;
    // Also keep track of what font the delimiters are in
    var font = "Size1-Regular";
    // We set the parts and font based on the symbol. Note that we use
    // '\u23d0' instead of '|' and '\u2016' instead of '\\|' for the
    // repeats of the arrows
    if (delim === "\\uparrow") repeat = bottom = "\u23d0";
    else if (delim === "\\Uparrow") repeat = bottom = "\u2016";
    else if (delim === "\\downarrow") top = repeat = "\u23d0";
    else if (delim === "\\Downarrow") top = repeat = "\u2016";
    else if (delim === "\\updownarrow") {
        top = "\\uparrow";
        repeat = "\u23d0";
        bottom = "\\downarrow";
    } else if (delim === "\\Updownarrow") {
        top = "\\Uparrow";
        repeat = "\u2016";
        bottom = "\\Downarrow";
    } else if ($ef0731f441f79e9a$var$verts.has(delim)) {
        repeat = "\u2223";
        svgLabel = "vert";
        viewBoxWidth = 333;
    } else if ($ef0731f441f79e9a$var$doubleVerts.has(delim)) {
        repeat = "\u2225";
        svgLabel = "doublevert";
        viewBoxWidth = 556;
    } else if (delim === "[" || delim === "\\lbrack") {
        top = "\u23a1";
        repeat = "\u23a2";
        bottom = "\u23a3";
        font = "Size4-Regular";
        svgLabel = "lbrack";
        viewBoxWidth = 667;
    } else if (delim === "]" || delim === "\\rbrack") {
        top = "\u23a4";
        repeat = "\u23a5";
        bottom = "\u23a6";
        font = "Size4-Regular";
        svgLabel = "rbrack";
        viewBoxWidth = 667;
    } else if (delim === "\\lfloor" || delim === "\u230a") {
        repeat = top = "\u23a2";
        bottom = "\u23a3";
        font = "Size4-Regular";
        svgLabel = "lfloor";
        viewBoxWidth = 667;
    } else if (delim === "\\lceil" || delim === "\u2308") {
        top = "\u23a1";
        repeat = bottom = "\u23a2";
        font = "Size4-Regular";
        svgLabel = "lceil";
        viewBoxWidth = 667;
    } else if (delim === "\\rfloor" || delim === "\u230b") {
        repeat = top = "\u23a5";
        bottom = "\u23a6";
        font = "Size4-Regular";
        svgLabel = "rfloor";
        viewBoxWidth = 667;
    } else if (delim === "\\rceil" || delim === "\u2309") {
        top = "\u23a4";
        repeat = bottom = "\u23a5";
        font = "Size4-Regular";
        svgLabel = "rceil";
        viewBoxWidth = 667;
    } else if (delim === "(" || delim === "\\lparen") {
        top = "\u239b";
        repeat = "\u239c";
        bottom = "\u239d";
        font = "Size4-Regular";
        svgLabel = "lparen";
        viewBoxWidth = 875;
    } else if (delim === ")" || delim === "\\rparen") {
        top = "\u239e";
        repeat = "\u239f";
        bottom = "\u23a0";
        font = "Size4-Regular";
        svgLabel = "rparen";
        viewBoxWidth = 875;
    } else if (delim === "\\{" || delim === "\\lbrace") {
        top = "\u23a7";
        middle = "\u23a8";
        bottom = "\u23a9";
        repeat = "\u23aa";
        font = "Size4-Regular";
    } else if (delim === "\\}" || delim === "\\rbrace") {
        top = "\u23ab";
        middle = "\u23ac";
        bottom = "\u23ad";
        repeat = "\u23aa";
        font = "Size4-Regular";
    } else if (delim === "\\lgroup" || delim === "\u27ee") {
        top = "\u23a7";
        bottom = "\u23a9";
        repeat = "\u23aa";
        font = "Size4-Regular";
    } else if (delim === "\\rgroup" || delim === "\u27ef") {
        top = "\u23ab";
        bottom = "\u23ad";
        repeat = "\u23aa";
        font = "Size4-Regular";
    } else if (delim === "\\lmoustache" || delim === "\u23b0") {
        top = "\u23a7";
        bottom = "\u23ad";
        repeat = "\u23aa";
        font = "Size4-Regular";
    } else if (delim === "\\rmoustache" || delim === "\u23b1") {
        top = "\u23ab";
        bottom = "\u23a9";
        repeat = "\u23aa";
        font = "Size4-Regular";
    }
    // Get the metrics of the four sections
    var topMetrics = $ef0731f441f79e9a$var$getMetrics(top, font, mode);
    var topHeightTotal = topMetrics.height + topMetrics.depth;
    var repeatMetrics = $ef0731f441f79e9a$var$getMetrics(repeat, font, mode);
    var repeatHeightTotal = repeatMetrics.height + repeatMetrics.depth;
    var bottomMetrics = $ef0731f441f79e9a$var$getMetrics(bottom, font, mode);
    var bottomHeightTotal = bottomMetrics.height + bottomMetrics.depth;
    var middleHeightTotal = 0;
    var middleFactor = 1;
    if (middle !== null) {
        var middleMetrics = $ef0731f441f79e9a$var$getMetrics(middle, font, mode);
        middleHeightTotal = middleMetrics.height + middleMetrics.depth;
        middleFactor = 2; // repeat symmetrically above and below middle
    }
    // Calculate the minimal height that the delimiter can have.
    // It is at least the size of the top, bottom, and optional middle combined.
    var minHeight = topHeightTotal + bottomHeightTotal + middleHeightTotal;
    // Compute the number of copies of the repeat symbol we will need
    var repeatCount = Math.max(0, Math.ceil((heightTotal - minHeight) / (middleFactor * repeatHeightTotal)));
    // Compute the total height of the delimiter including all the symbols
    var realHeightTotal = minHeight + repeatCount * middleFactor * repeatHeightTotal;
    // The center of the delimiter is placed at the center of the axis. Note
    // that in this context, "center" means that the delimiter should be
    // centered around the axis in the current style, while normally it is
    // centered around the axis in textstyle.
    var axisHeight = options.fontMetrics().axisHeight;
    if (center) axisHeight *= options.sizeMultiplier;
    // Calculate the depth
    var depth = realHeightTotal / 2 - axisHeight;
    // Now, we start building the pieces that will go into the vlist
    // Keep a list of the pieces of the stacked delimiter
    var stack = [];
    if (svgLabel.length > 0) {
        // Instead of stacking glyphs, create a single SVG.
        // This evades browser problems with imprecise positioning of spans.
        var midHeight = realHeightTotal - topHeightTotal - bottomHeightTotal;
        var viewBoxHeight = Math.round(realHeightTotal * 1000);
        var pathStr = $ef0731f441f79e9a$var$tallDelim(svgLabel, Math.round(midHeight * 1000));
        var path = new $ef0731f441f79e9a$var$PathNode(svgLabel, pathStr);
        var width = $ef0731f441f79e9a$var$makeEm(viewBoxWidth / 1000);
        var height = $ef0731f441f79e9a$var$makeEm(viewBoxHeight / 1000);
        var svg = new $ef0731f441f79e9a$var$SvgNode([
            path
        ], {
            "width": width,
            "height": height,
            "viewBox": "0 0 " + viewBoxWidth + " " + viewBoxHeight
        });
        var wrapper = $ef0731f441f79e9a$var$makeSvgSpan([], [
            svg
        ], options);
        wrapper.height = viewBoxHeight / 1000;
        wrapper.style.width = width;
        wrapper.style.height = height;
        stack.push({
            type: "elem",
            elem: wrapper
        });
    } else {
        // Stack glyphs
        // Start by adding the bottom symbol
        stack.push($ef0731f441f79e9a$var$makeGlyphSpan(bottom, font, mode));
        stack.push($ef0731f441f79e9a$var$lap); // overlap
        if (middle === null) {
            // The middle section will be an SVG. Make it an extra 0.016em tall.
            // We'll overlap by 0.008em at top and bottom.
            var innerHeight = realHeightTotal - topHeightTotal - bottomHeightTotal + 2 * $ef0731f441f79e9a$var$lapInEms;
            stack.push($ef0731f441f79e9a$var$makeInner(repeat, innerHeight, options));
        } else {
            // When there is a middle bit, we need the middle part and two repeated
            // sections
            var _innerHeight = (realHeightTotal - topHeightTotal - bottomHeightTotal - middleHeightTotal) / 2 + 2 * $ef0731f441f79e9a$var$lapInEms;
            stack.push($ef0731f441f79e9a$var$makeInner(repeat, _innerHeight, options));
            // Now insert the middle of the brace.
            stack.push($ef0731f441f79e9a$var$lap);
            stack.push($ef0731f441f79e9a$var$makeGlyphSpan(middle, font, mode));
            stack.push($ef0731f441f79e9a$var$lap);
            stack.push($ef0731f441f79e9a$var$makeInner(repeat, _innerHeight, options));
        }
        // Add the top symbol
        stack.push($ef0731f441f79e9a$var$lap);
        stack.push($ef0731f441f79e9a$var$makeGlyphSpan(top, font, mode));
    }
    // Finally, build the vlist
    var newOptions = options.havingBaseStyle($ef0731f441f79e9a$var$Style$1.TEXT);
    var inner = $ef0731f441f79e9a$var$makeVList({
        positionType: "bottom",
        positionData: depth,
        children: stack
    });
    return $ef0731f441f79e9a$var$styleWrap($ef0731f441f79e9a$var$makeSpan([
        "delimsizing",
        "mult"
    ], [
        inner
    ], newOptions), $ef0731f441f79e9a$var$Style$1.TEXT, options, classes);
};
// All surds have 0.08em padding above the vinculum inside the SVG.
// That keeps browser span height rounding error from pinching the line.
var $ef0731f441f79e9a$var$vbPad = 80; // padding above the surd, measured inside the viewBox.
var $ef0731f441f79e9a$var$emPad = 0.08; // padding, in ems, measured in the document.
var $ef0731f441f79e9a$var$sqrtSvg = function sqrtSvg(sqrtName, height, viewBoxHeight, extraVinculum, options) {
    var path = $ef0731f441f79e9a$var$sqrtPath(sqrtName, extraVinculum, viewBoxHeight);
    var pathNode = new $ef0731f441f79e9a$var$PathNode(sqrtName, path);
    var svg = new $ef0731f441f79e9a$var$SvgNode([
        pathNode
    ], {
        // Note: 1000:1 ratio of viewBox to document em width.
        "width": "400em",
        "height": $ef0731f441f79e9a$var$makeEm(height),
        "viewBox": "0 0 400000 " + viewBoxHeight,
        "preserveAspectRatio": "xMinYMin slice"
    });
    return $ef0731f441f79e9a$var$makeSvgSpan([
        "hide-tail"
    ], [
        svg
    ], options);
};
/**
 * Make a sqrt image of the given height,
 */ var $ef0731f441f79e9a$var$makeSqrtImage = function makeSqrtImage(height, options) {
    // Define a newOptions that removes the effect of size changes such as \Huge.
    // We don't pick different a height surd for \Huge. For it, we scale up.
    var newOptions = options.havingBaseSizing();
    // Pick the desired surd glyph from a sequence of surds.
    var delim = $ef0731f441f79e9a$var$traverseSequence("\\surd", height * newOptions.sizeMultiplier, $ef0731f441f79e9a$var$stackLargeDelimiterSequence, newOptions);
    var sizeMultiplier = newOptions.sizeMultiplier; // default
    // The standard sqrt SVGs each have a 0.04em thick vinculum.
    // If Settings.minRuleThickness is larger than that, we add extraVinculum.
    var extraVinculum = Math.max(0, options.minRuleThickness - options.fontMetrics().sqrtRuleThickness);
    // Create a span containing an SVG image of a sqrt symbol.
    var span;
    var spanHeight;
    var texHeight;
    var viewBoxHeight;
    var advanceWidth;
    // We create viewBoxes with 80 units of "padding" above each surd.
    // Then browser rounding error on the parent span height will not
    // encroach on the ink of the vinculum. But that padding is not
    // included in the TeX-like `height` used for calculation of
    // vertical alignment. So texHeight = span.height < span.style.height.
    if (delim.type === "small") {
        // Get an SVG that is derived from glyph U+221A in font KaTeX-Main.
        // 1000 unit normal glyph height.
        viewBoxHeight = 1000 + 1000 * extraVinculum + $ef0731f441f79e9a$var$vbPad;
        if (height < 1.0) sizeMultiplier = 1.0; // mimic a \textfont radical
        else if (height < 1.4) sizeMultiplier = 0.7; // mimic a \scriptfont radical
        spanHeight = (1.0 + extraVinculum + $ef0731f441f79e9a$var$emPad) / sizeMultiplier;
        texHeight = (1.00 + extraVinculum) / sizeMultiplier;
        span = $ef0731f441f79e9a$var$sqrtSvg("sqrtMain", spanHeight, viewBoxHeight, extraVinculum, options);
        span.style.minWidth = "0.853em";
        advanceWidth = 0.833 / sizeMultiplier; // from the font.
    } else if (delim.type === "large") {
        // These SVGs come from fonts: KaTeX_Size1, _Size2, etc.
        viewBoxHeight = (1000 + $ef0731f441f79e9a$var$vbPad) * $ef0731f441f79e9a$var$sizeToMaxHeight[delim.size];
        texHeight = ($ef0731f441f79e9a$var$sizeToMaxHeight[delim.size] + extraVinculum) / sizeMultiplier;
        spanHeight = ($ef0731f441f79e9a$var$sizeToMaxHeight[delim.size] + extraVinculum + $ef0731f441f79e9a$var$emPad) / sizeMultiplier;
        span = $ef0731f441f79e9a$var$sqrtSvg("sqrtSize" + delim.size, spanHeight, viewBoxHeight, extraVinculum, options);
        span.style.minWidth = "1.02em";
        advanceWidth = 1.0 / sizeMultiplier; // 1.0 from the font.
    } else {
        // Tall sqrt. In TeX, this would be stacked using multiple glyphs.
        // We'll use a single SVG to accomplish the same thing.
        spanHeight = height + extraVinculum + $ef0731f441f79e9a$var$emPad;
        texHeight = height + extraVinculum;
        viewBoxHeight = Math.floor(1000 * height + extraVinculum) + $ef0731f441f79e9a$var$vbPad;
        span = $ef0731f441f79e9a$var$sqrtSvg("sqrtTall", spanHeight, viewBoxHeight, extraVinculum, options);
        span.style.minWidth = "0.742em";
        advanceWidth = 1.056;
    }
    span.height = texHeight;
    span.style.height = $ef0731f441f79e9a$var$makeEm(spanHeight);
    return {
        span: span,
        advanceWidth: advanceWidth,
        // Calculate the actual line width.
        // This actually should depend on the chosen font -- e.g. \boldmath
        // should use the thicker surd symbols from e.g. KaTeX_Main-Bold, and
        // have thicker rules.
        ruleWidth: (options.fontMetrics().sqrtRuleThickness + extraVinculum) * sizeMultiplier
    };
};
// There are three kinds of delimiters, delimiters that stack when they become
// too large
var $ef0731f441f79e9a$var$stackLargeDelimiters = new Set([
    "(",
    "\\lparen",
    ")",
    "\\rparen",
    "[",
    "\\lbrack",
    "]",
    "\\rbrack",
    "\\{",
    "\\lbrace",
    "\\}",
    "\\rbrace",
    "\\lfloor",
    "\\rfloor",
    "\u230a",
    "\u230b",
    "\\lceil",
    "\\rceil",
    "\u2308",
    "\u2309",
    "\\surd"
]);
// delimiters that always stack
var $ef0731f441f79e9a$var$stackAlwaysDelimiters = new Set([
    "\\uparrow",
    "\\downarrow",
    "\\updownarrow",
    "\\Uparrow",
    "\\Downarrow",
    "\\Updownarrow",
    "|",
    "\\|",
    "\\vert",
    "\\Vert",
    "\\lvert",
    "\\rvert",
    "\\lVert",
    "\\rVert",
    "\\lgroup",
    "\\rgroup",
    "\u27ee",
    "\u27ef",
    "\\lmoustache",
    "\\rmoustache",
    "\u23b0",
    "\u23b1"
]);
// and delimiters that never stack
var $ef0731f441f79e9a$var$stackNeverDelimiters = new Set([
    "<",
    ">",
    "\\langle",
    "\\rangle",
    "/",
    "\\backslash",
    "\\lt",
    "\\gt"
]);
// Metrics of the different sizes. Found by looking at TeX's output of
// $\bigl| // \Bigl| \biggl| \Biggl| \showlists$
// Used to create stacked delimiters of appropriate sizes in makeSizedDelim.
var $ef0731f441f79e9a$var$sizeToMaxHeight = [
    0,
    1.2,
    1.8,
    2.4,
    3.0
];
/**
 * Used to create a delimiter of a specific size, where `size` is 1, 2, 3, or 4.
 */ var $ef0731f441f79e9a$var$makeSizedDelim = function makeSizedDelim(delim, size, options, mode, classes) {
    // < and > turn into \langle and \rangle in delimiters
    if (delim === "<" || delim === "\\lt" || delim === "\u27e8") delim = "\\langle";
    else if (delim === ">" || delim === "\\gt" || delim === "\u27e9") delim = "\\rangle";
    // Sized delimiters are never centered.
    if ($ef0731f441f79e9a$var$stackLargeDelimiters.has(delim) || $ef0731f441f79e9a$var$stackNeverDelimiters.has(delim)) return $ef0731f441f79e9a$var$makeLargeDelim(delim, size, false, options, mode, classes);
    else if ($ef0731f441f79e9a$var$stackAlwaysDelimiters.has(delim)) return $ef0731f441f79e9a$var$makeStackedDelim(delim, $ef0731f441f79e9a$var$sizeToMaxHeight[size], false, options, mode, classes);
    else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Illegal delimiter: '" + delim + "'");
};
// Delimiters that never stack try small delimiters and large delimiters only
var $ef0731f441f79e9a$var$stackNeverDelimiterSequence = [
    {
        type: "small",
        style: $ef0731f441f79e9a$var$Style$1.SCRIPTSCRIPT
    },
    {
        type: "small",
        style: $ef0731f441f79e9a$var$Style$1.SCRIPT
    },
    {
        type: "small",
        style: $ef0731f441f79e9a$var$Style$1.TEXT
    },
    {
        type: "large",
        size: 1
    },
    {
        type: "large",
        size: 2
    },
    {
        type: "large",
        size: 3
    },
    {
        type: "large",
        size: 4
    }
];
// Delimiters that always stack try the small delimiters first, then stack
var $ef0731f441f79e9a$var$stackAlwaysDelimiterSequence = [
    {
        type: "small",
        style: $ef0731f441f79e9a$var$Style$1.SCRIPTSCRIPT
    },
    {
        type: "small",
        style: $ef0731f441f79e9a$var$Style$1.SCRIPT
    },
    {
        type: "small",
        style: $ef0731f441f79e9a$var$Style$1.TEXT
    },
    {
        type: "stack"
    }
];
// Delimiters that stack when large try the small and then large delimiters, and
// stack afterwards
var $ef0731f441f79e9a$var$stackLargeDelimiterSequence = [
    {
        type: "small",
        style: $ef0731f441f79e9a$var$Style$1.SCRIPTSCRIPT
    },
    {
        type: "small",
        style: $ef0731f441f79e9a$var$Style$1.SCRIPT
    },
    {
        type: "small",
        style: $ef0731f441f79e9a$var$Style$1.TEXT
    },
    {
        type: "large",
        size: 1
    },
    {
        type: "large",
        size: 2
    },
    {
        type: "large",
        size: 3
    },
    {
        type: "large",
        size: 4
    },
    {
        type: "stack"
    }
];
/**
 * Get the font used in a delimiter based on what kind of delimiter it is.
 * TODO(#963) Use more specific font family return type once that is introduced.
 */ var $ef0731f441f79e9a$var$delimTypeToFont = function delimTypeToFont(type) {
    if (type.type === "small") return "Main-Regular";
    else if (type.type === "large") return "Size" + type.size + "-Regular";
    else if (type.type === "stack") return "Size4-Regular";
    else {
        var delimKind = type.type;
        throw new Error("Add support for delim type '" + delimKind + "' here.");
    }
};
/**
 * Traverse a sequence of types of delimiters to decide what kind of delimiter
 * should be used to create a delimiter of the given height+depth.
 */ var $ef0731f441f79e9a$var$traverseSequence = function traverseSequence(delim, height, sequence, options) {
    // Here, we choose the index we should start at in the sequences. In smaller
    // sizes (which correspond to larger numbers in style.size) we start earlier
    // in the sequence. Thus, scriptscript starts at index 3-3=0, script starts
    // at index 3-2=1, text starts at 3-1=2, and display starts at min(2,3-0)=2
    var start = Math.min(2, 3 - options.style.size);
    for(var i = start; i < sequence.length; i++){
        var delimType = sequence[i];
        if (delimType.type === "stack") break;
        var metrics = $ef0731f441f79e9a$var$getMetrics(delim, $ef0731f441f79e9a$var$delimTypeToFont(delimType), "math");
        var heightDepth = metrics.height + metrics.depth;
        // Small delimiters are scaled down versions of the same font, so we
        // account for the style change size.
        if (delimType.type === "small") {
            var newOptions = options.havingBaseStyle(delimType.style);
            heightDepth *= newOptions.sizeMultiplier;
        }
        // Check if the delimiter at this size works for the given height.
        if (heightDepth > height) return delimType;
    }
    // If we reached the end of the sequence, return the last sequence element.
    return sequence[sequence.length - 1];
};
/**
 * Make a delimiter of a given height+depth, with optional centering. Here, we
 * traverse the sequences, and create a delimiter that the sequence tells us to.
 */ var $ef0731f441f79e9a$var$makeCustomSizedDelim = function makeCustomSizedDelim(delim, height, center, options, mode, classes) {
    if (delim === "<" || delim === "\\lt" || delim === "\u27e8") delim = "\\langle";
    else if (delim === ">" || delim === "\\gt" || delim === "\u27e9") delim = "\\rangle";
    // Decide what sequence to use
    var sequence;
    if ($ef0731f441f79e9a$var$stackNeverDelimiters.has(delim)) sequence = $ef0731f441f79e9a$var$stackNeverDelimiterSequence;
    else if ($ef0731f441f79e9a$var$stackLargeDelimiters.has(delim)) sequence = $ef0731f441f79e9a$var$stackLargeDelimiterSequence;
    else sequence = $ef0731f441f79e9a$var$stackAlwaysDelimiterSequence;
    // Look through the sequence
    var delimType = $ef0731f441f79e9a$var$traverseSequence(delim, height, sequence, options);
    // Get the delimiter from font glyphs.
    // Depending on the sequence element we decided on, call the
    // appropriate function.
    if (delimType.type === "small") return $ef0731f441f79e9a$var$makeSmallDelim(delim, delimType.style, center, options, mode, classes);
    else if (delimType.type === "large") return $ef0731f441f79e9a$var$makeLargeDelim(delim, delimType.size, center, options, mode, classes);
    else return $ef0731f441f79e9a$var$makeStackedDelim(delim, height, center, options, mode, classes);
};
/**
 * Make a delimiter for use with `\left` and `\right`, given a height and depth
 * of an expression that the delimiters surround.
 */ var $ef0731f441f79e9a$var$makeLeftRightDelim = function makeLeftRightDelim(delim, height, depth, options, mode, classes) {
    // We always center \left/\right delimiters, so the axis is always shifted
    var axisHeight = options.fontMetrics().axisHeight * options.sizeMultiplier;
    // Taken from TeX source, tex.web, function make_left_right
    var delimiterFactor = 901;
    var delimiterExtend = 5.0 / options.fontMetrics().ptPerEm;
    var maxDistFromAxis = Math.max(height - axisHeight, depth + axisHeight);
    var totalHeight = Math.max(// In real TeX, calculations are done using integral values which are
    // 65536 per pt, or 655360 per em. So, the division here truncates in
    // TeX but doesn't here, producing different results. If we wanted to
    // exactly match TeX's calculation, we could do
    //   Math.floor(655360 * maxDistFromAxis / 500) *
    //    delimiterFactor / 655360
    // (To see the difference, compare
    //    x^{x^{\left(\rule{0.1em}{0.68em}\right)}}
    // in TeX and KaTeX)
    maxDistFromAxis / 500 * delimiterFactor, 2 * maxDistFromAxis - delimiterExtend);
    // Finally, we defer to `makeCustomSizedDelim` with our calculated total
    // height
    return $ef0731f441f79e9a$var$makeCustomSizedDelim(delim, totalHeight, true, options, mode, classes);
};
// Extra data needed for the delimiter handler down below
var $ef0731f441f79e9a$var$delimiterSizes = {
    "\\bigl": {
        mclass: "mopen",
        size: 1
    },
    "\\Bigl": {
        mclass: "mopen",
        size: 2
    },
    "\\biggl": {
        mclass: "mopen",
        size: 3
    },
    "\\Biggl": {
        mclass: "mopen",
        size: 4
    },
    "\\bigr": {
        mclass: "mclose",
        size: 1
    },
    "\\Bigr": {
        mclass: "mclose",
        size: 2
    },
    "\\biggr": {
        mclass: "mclose",
        size: 3
    },
    "\\Biggr": {
        mclass: "mclose",
        size: 4
    },
    "\\bigm": {
        mclass: "mrel",
        size: 1
    },
    "\\Bigm": {
        mclass: "mrel",
        size: 2
    },
    "\\biggm": {
        mclass: "mrel",
        size: 3
    },
    "\\Biggm": {
        mclass: "mrel",
        size: 4
    },
    "\\big": {
        mclass: "mord",
        size: 1
    },
    "\\Big": {
        mclass: "mord",
        size: 2
    },
    "\\bigg": {
        mclass: "mord",
        size: 3
    },
    "\\Bigg": {
        mclass: "mord",
        size: 4
    }
};
var $ef0731f441f79e9a$var$delimiters = new Set([
    "(",
    "\\lparen",
    ")",
    "\\rparen",
    "[",
    "\\lbrack",
    "]",
    "\\rbrack",
    "\\{",
    "\\lbrace",
    "\\}",
    "\\rbrace",
    "\\lfloor",
    "\\rfloor",
    "\u230a",
    "\u230b",
    "\\lceil",
    "\\rceil",
    "\u2308",
    "\u2309",
    "<",
    ">",
    "\\langle",
    "\u27e8",
    "\\rangle",
    "\u27e9",
    "\\lt",
    "\\gt",
    "\\lvert",
    "\\rvert",
    "\\lVert",
    "\\rVert",
    "\\lgroup",
    "\\rgroup",
    "\u27ee",
    "\u27ef",
    "\\lmoustache",
    "\\rmoustache",
    "\u23b0",
    "\u23b1",
    "/",
    "\\backslash",
    "|",
    "\\vert",
    "\\|",
    "\\Vert",
    "\\uparrow",
    "\\Uparrow",
    "\\downarrow",
    "\\Downarrow",
    "\\updownarrow",
    "\\Updownarrow",
    "."
]);
function $ef0731f441f79e9a$var$isMiddleDelimNode(node) {
    return 'isMiddle' in node;
}
// Delimiter functions
function $ef0731f441f79e9a$var$checkDelimiter(delim, context) {
    var symDelim = $ef0731f441f79e9a$var$checkSymbolNodeType(delim);
    if (symDelim && $ef0731f441f79e9a$var$delimiters.has(symDelim.text)) return symDelim;
    else if (symDelim) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid delimiter '" + symDelim.text + "' after '" + context.funcName + "'", delim);
    else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid delimiter type '" + delim.type + "'", delim);
}
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "delimsizing",
    names: [
        "\\bigl",
        "\\Bigl",
        "\\biggl",
        "\\Biggl",
        "\\bigr",
        "\\Bigr",
        "\\biggr",
        "\\Biggr",
        "\\bigm",
        "\\Bigm",
        "\\biggm",
        "\\Biggm",
        "\\big",
        "\\Big",
        "\\bigg",
        "\\Bigg"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "primitive"
        ]
    },
    handler: (context, args)=>{
        var delim = $ef0731f441f79e9a$var$checkDelimiter(args[0], context);
        return {
            type: "delimsizing",
            mode: context.parser.mode,
            size: $ef0731f441f79e9a$var$delimiterSizes[context.funcName].size,
            mclass: $ef0731f441f79e9a$var$delimiterSizes[context.funcName].mclass,
            delim: delim.text
        };
    },
    htmlBuilder: (group, options)=>{
        if (group.delim === ".") // Empty delimiters still count as elements, even though they don't
        // show anything.
        return $ef0731f441f79e9a$var$makeSpan([
            group.mclass
        ]);
        return $ef0731f441f79e9a$var$makeSizedDelim(group.delim, group.size, options, group.mode, [
            group.mclass
        ]);
    },
    mathmlBuilder: (group)=>{
        var children = [];
        if (group.delim !== ".") children.push($ef0731f441f79e9a$var$makeText(group.delim, group.mode));
        var node = new $ef0731f441f79e9a$var$MathNode("mo", children);
        if (group.mclass === "mopen" || group.mclass === "mclose") // Only some of the delimsizing functions act as fences, and they
        // return "mopen" or "mclose" mclass.
        node.setAttribute("fence", "true");
        else // Explicitly disable fencing if it's not a fence, to override the
        // defaults.
        node.setAttribute("fence", "false");
        node.setAttribute("stretchy", "true");
        var size = $ef0731f441f79e9a$var$makeEm($ef0731f441f79e9a$var$sizeToMaxHeight[group.size]);
        node.setAttribute("minsize", size);
        node.setAttribute("maxsize", size);
        return node;
    }
});
function $ef0731f441f79e9a$var$assertParsed(group) {
    if (!group.body) throw new Error("Bug: The leftright ParseNode wasn't fully parsed.");
}
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "leftright-right",
    names: [
        "\\right"
    ],
    props: {
        numArgs: 1,
        primitive: true
    },
    handler: (context, args)=>{
        // \left case below triggers parsing of \right in
        //   `const right = parser.parseFunction();`
        // uses this return value.
        var color = context.parser.gullet.macros.get("\\current@color");
        if (color && typeof color !== "string") throw new $ef0731f441f79e9a$export$f9c837a54db411d("\\current@color set to non-string in \\right");
        return {
            type: "leftright-right",
            mode: context.parser.mode,
            delim: $ef0731f441f79e9a$var$checkDelimiter(args[0], context).text,
            color: color // undefined if not set via \color
        };
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "leftright",
    names: [
        "\\left"
    ],
    props: {
        numArgs: 1,
        primitive: true
    },
    handler: (context, args)=>{
        var delim = $ef0731f441f79e9a$var$checkDelimiter(args[0], context);
        var parser = context.parser;
        // Parse out the implicit body
        ++parser.leftrightDepth;
        // parseExpression stops before '\\right'
        var body = parser.parseExpression(false);
        --parser.leftrightDepth;
        // Check the next token
        parser.expect("\\right", false);
        var right = $ef0731f441f79e9a$var$assertNodeType(parser.parseFunction(), "leftright-right");
        return {
            type: "leftright",
            mode: parser.mode,
            body: body,
            left: delim.text,
            right: right.delim,
            rightColor: right.color
        };
    },
    htmlBuilder: (group, options)=>{
        $ef0731f441f79e9a$var$assertParsed(group);
        // Build the inner expression
        var inner = $ef0731f441f79e9a$var$buildExpression$1(group.body, options, true, [
            "mopen",
            "mclose"
        ]);
        var innerHeight = 0;
        var innerDepth = 0;
        var hadMiddle = false;
        // Calculate its height and depth
        for(var i = 0; i < inner.length; i++){
            var node = inner[i];
            if ($ef0731f441f79e9a$var$isMiddleDelimNode(node)) hadMiddle = true;
            else {
                innerHeight = Math.max(inner[i].height, innerHeight);
                innerDepth = Math.max(inner[i].depth, innerDepth);
            }
        }
        // The size of delimiters is the same, regardless of what style we are
        // in. Thus, to correctly calculate the size of delimiter we need around
        // a group, we scale down the inner size based on the size.
        innerHeight *= options.sizeMultiplier;
        innerDepth *= options.sizeMultiplier;
        var leftDelim;
        if (group.left === ".") // Empty delimiters in \left and \right make null delimiter spaces.
        leftDelim = $ef0731f441f79e9a$var$makeNullDelimiter(options, [
            "mopen"
        ]);
        else // Otherwise, use leftRightDelim to generate the correct sized
        // delimiter.
        leftDelim = $ef0731f441f79e9a$var$makeLeftRightDelim(group.left, innerHeight, innerDepth, options, group.mode, [
            "mopen"
        ]);
        // Add it to the beginning of the expression
        inner.unshift(leftDelim);
        // Handle middle delimiters
        if (hadMiddle) for(var _i = 1; _i < inner.length; _i++){
            var middleDelim = inner[_i];
            if ($ef0731f441f79e9a$var$isMiddleDelimNode(middleDelim)) {
                var isMiddle = middleDelim.isMiddle;
                // Apply the options that were active when \middle was called
                inner[_i] = $ef0731f441f79e9a$var$makeLeftRightDelim(isMiddle.delim, innerHeight, innerDepth, isMiddle.options, group.mode, []);
            }
        }
        var rightDelim;
        // Same for the right delimiter, but using color specified by \color
        if (group.right === ".") rightDelim = $ef0731f441f79e9a$var$makeNullDelimiter(options, [
            "mclose"
        ]);
        else {
            var colorOptions = group.rightColor ? options.withColor(group.rightColor) : options;
            rightDelim = $ef0731f441f79e9a$var$makeLeftRightDelim(group.right, innerHeight, innerDepth, colorOptions, group.mode, [
                "mclose"
            ]);
        }
        // Add it to the end of the expression.
        inner.push(rightDelim);
        return $ef0731f441f79e9a$var$makeSpan([
            "minner"
        ], inner, options);
    },
    mathmlBuilder: (group, options)=>{
        $ef0731f441f79e9a$var$assertParsed(group);
        var inner = $ef0731f441f79e9a$var$buildExpression(group.body, options);
        if (group.left !== ".") {
            var leftNode = new $ef0731f441f79e9a$var$MathNode("mo", [
                $ef0731f441f79e9a$var$makeText(group.left, group.mode)
            ]);
            leftNode.setAttribute("fence", "true");
            inner.unshift(leftNode);
        }
        if (group.right !== ".") {
            var rightNode = new $ef0731f441f79e9a$var$MathNode("mo", [
                $ef0731f441f79e9a$var$makeText(group.right, group.mode)
            ]);
            rightNode.setAttribute("fence", "true");
            if (group.rightColor) rightNode.setAttribute("mathcolor", group.rightColor);
            inner.push(rightNode);
        }
        return $ef0731f441f79e9a$var$makeRow(inner);
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "middle",
    names: [
        "\\middle"
    ],
    props: {
        numArgs: 1,
        primitive: true
    },
    handler: (context, args)=>{
        var delim = $ef0731f441f79e9a$var$checkDelimiter(args[0], context);
        if (!context.parser.leftrightDepth) throw new $ef0731f441f79e9a$export$f9c837a54db411d("\\middle without preceding \\left", delim);
        return {
            type: "middle",
            mode: context.parser.mode,
            delim: delim.text
        };
    },
    htmlBuilder: (group, options)=>{
        var middleDelim;
        if (group.delim === ".") middleDelim = $ef0731f441f79e9a$var$makeNullDelimiter(options, []);
        else {
            middleDelim = $ef0731f441f79e9a$var$makeSizedDelim(group.delim, 1, options, group.mode, []);
            // Patch an ad-hoc property onto the node so the \left/\right
            // builder can reconstruct appropriately sized middle delimiters.
            // isMiddle is not part of HtmlDomNode; the read side uses
            // isMiddleDelimNode() to check before accessing.
            middleDelim.isMiddle = {
                delim: group.delim,
                options: options
            };
        }
        return middleDelim;
    },
    mathmlBuilder: (group, options)=>{
        // A Firefox \middle will stretch a character vertically only if it
        // is in the fence part of the operator dictionary at:
        // https://www.w3.org/TR/MathML3/appendixc.html.
        // So we need to avoid U+2223 and use plain "|" instead.
        var textNode = group.delim === "\\vert" || group.delim === "|" ? $ef0731f441f79e9a$var$makeText("|", "text") : $ef0731f441f79e9a$var$makeText(group.delim, group.mode);
        var middleNode = new $ef0731f441f79e9a$var$MathNode("mo", [
            textNode
        ]);
        middleNode.setAttribute("fence", "true");
        // MathML gives 5/18em spacing to each <mo> element.
        // \middle should get delimiter spacing instead.
        middleNode.setAttribute("lspace", "0.05em");
        middleNode.setAttribute("rspace", "0.05em");
        return middleNode;
    }
});
var $ef0731f441f79e9a$var$htmlBuilder$7 = (group, options)=>{
    // \cancel, \bcancel, \xcancel, \sout, \fbox, \colorbox, \fcolorbox, \phase
    // Some groups can return document fragments.  Handle those by wrapping
    // them in a span.
    var inner = $ef0731f441f79e9a$var$wrapFragment($ef0731f441f79e9a$var$buildGroup$1(group.body, options), options);
    var label = group.label.slice(1);
    var scale = options.sizeMultiplier;
    var img;
    var imgShift;
    // In the LaTeX cancel package, line geometry is slightly different
    // depending on whether the subject is wider than it is tall, or vice versa.
    // We don't know the width of a group, so as a proxy, we test if
    // the subject is a single character. This captures most of the
    // subjects that should get the "tall" treatment.
    var isSingleChar = $ef0731f441f79e9a$var$isCharacterBox(group.body);
    if (label === "sout") {
        img = $ef0731f441f79e9a$var$makeSpan([
            "stretchy",
            "sout"
        ]);
        img.height = options.fontMetrics().defaultRuleThickness / scale;
        imgShift = -0.5 * options.fontMetrics().xHeight;
    } else if (label === "phase") {
        // Set a couple of dimensions from the steinmetz package.
        var lineWeight = $ef0731f441f79e9a$var$calculateSize({
            number: 0.6,
            unit: "pt"
        }, options);
        var clearance = $ef0731f441f79e9a$var$calculateSize({
            number: 0.35,
            unit: "ex"
        }, options);
        // Prevent size changes like \Huge from affecting line thickness
        var newOptions = options.havingBaseSizing();
        scale = scale / newOptions.sizeMultiplier;
        var angleHeight = inner.height + inner.depth + lineWeight + clearance;
        // Reserve a left pad for the angle.
        inner.style.paddingLeft = $ef0731f441f79e9a$var$makeEm(angleHeight / 2 + lineWeight);
        // Create an SVG
        var viewBoxHeight = Math.floor(1000 * angleHeight * scale);
        var path = $ef0731f441f79e9a$var$phasePath(viewBoxHeight);
        var svgNode = new $ef0731f441f79e9a$var$SvgNode([
            new $ef0731f441f79e9a$var$PathNode("phase", path)
        ], {
            "width": "400em",
            "height": $ef0731f441f79e9a$var$makeEm(viewBoxHeight / 1000),
            "viewBox": "0 0 400000 " + viewBoxHeight,
            "preserveAspectRatio": "xMinYMin slice"
        });
        // Wrap it in a span with overflow: hidden.
        img = $ef0731f441f79e9a$var$makeSvgSpan([
            "hide-tail"
        ], [
            svgNode
        ], options);
        img.style.height = $ef0731f441f79e9a$var$makeEm(angleHeight);
        imgShift = inner.depth + lineWeight + clearance;
    } else {
        // Add horizontal padding
        if (/cancel/.test(label)) {
            if (!isSingleChar) inner.classes.push("cancel-pad");
        } else if (label === "angl") inner.classes.push("anglpad");
        else inner.classes.push("boxpad");
        // Add vertical padding
        var topPad;
        var bottomPad;
        var ruleThickness = 0;
        // ref: cancel package: \advance\totalheight2\p@ % "+2"
        if (/box/.test(label)) {
            ruleThickness = Math.max(options.fontMetrics().fboxrule, // default
            options.minRuleThickness);
            topPad = options.fontMetrics().fboxsep + (label === "colorbox" ? 0 : ruleThickness);
            bottomPad = topPad;
        } else if (label === "angl") {
            ruleThickness = Math.max(options.fontMetrics().defaultRuleThickness, options.minRuleThickness);
            topPad = 4 * ruleThickness; // gap = 3 × line, plus the line itself.
            bottomPad = Math.max(0, 0.25 - inner.depth);
        } else {
            topPad = isSingleChar ? 0.2 : 0;
            bottomPad = topPad;
        }
        img = $ef0731f441f79e9a$var$stretchyEnclose(inner, label, topPad, bottomPad, options);
        if (/fbox|boxed|fcolorbox/.test(label)) {
            img.style.borderStyle = "solid";
            img.style.borderWidth = $ef0731f441f79e9a$var$makeEm(ruleThickness);
        } else if (label === "angl" && ruleThickness !== 0.049) {
            img.style.borderTopWidth = $ef0731f441f79e9a$var$makeEm(ruleThickness);
            img.style.borderRightWidth = $ef0731f441f79e9a$var$makeEm(ruleThickness);
        }
        imgShift = inner.depth + bottomPad;
        if (group.backgroundColor) {
            img.style.backgroundColor = group.backgroundColor;
            if (group.borderColor) img.style.borderColor = group.borderColor;
        }
    }
    var vlist;
    if (group.backgroundColor) vlist = $ef0731f441f79e9a$var$makeVList({
        positionType: "individualShift",
        children: [
            // Put the color background behind inner;
            {
                type: "elem",
                elem: img,
                shift: imgShift
            },
            {
                type: "elem",
                elem: inner,
                shift: 0
            }
        ]
    });
    else {
        var classes = /cancel|phase/.test(label) ? [
            "svg-align"
        ] : [];
        vlist = $ef0731f441f79e9a$var$makeVList({
            positionType: "individualShift",
            children: [
                // Write the \cancel stroke on top of inner.
                {
                    type: "elem",
                    elem: inner,
                    shift: 0
                },
                {
                    type: "elem",
                    elem: img,
                    shift: imgShift,
                    wrapperClasses: classes
                }
            ]
        });
    }
    if (/cancel/.test(label)) {
        // The cancel package documentation says that cancel lines add their height
        // to the expression, but tests show that isn't how it actually works.
        vlist.height = inner.height;
        vlist.depth = inner.depth;
    }
    if (/cancel/.test(label) && !isSingleChar) // cancel does not create horiz space for its line extension.
    return $ef0731f441f79e9a$var$makeSpan([
        "mord",
        "cancel-lap"
    ], [
        vlist
    ], options);
    else return $ef0731f441f79e9a$var$makeSpan([
        "mord"
    ], [
        vlist
    ], options);
};
var $ef0731f441f79e9a$var$mathmlBuilder$6 = (group, options)=>{
    var fboxsep;
    var node = new $ef0731f441f79e9a$var$MathNode(group.label.includes("colorbox") ? "mpadded" : "menclose", [
        $ef0731f441f79e9a$var$buildGroup(group.body, options)
    ]);
    switch(group.label){
        case "\\cancel":
            node.setAttribute("notation", "updiagonalstrike");
            break;
        case "\\bcancel":
            node.setAttribute("notation", "downdiagonalstrike");
            break;
        case "\\phase":
            node.setAttribute("notation", "phasorangle");
            break;
        case "\\sout":
            node.setAttribute("notation", "horizontalstrike");
            break;
        case "\\fbox":
            node.setAttribute("notation", "box");
            break;
        case "\\angl":
            node.setAttribute("notation", "actuarial");
            break;
        case "\\fcolorbox":
        case "\\colorbox":
            // <menclose> doesn't have a good notation option. So use <mpadded>
            // instead. Set some attributes that come included with <menclose>.
            fboxsep = options.fontMetrics().fboxsep * options.fontMetrics().ptPerEm;
            node.setAttribute("width", "+" + 2 * fboxsep + "pt");
            node.setAttribute("height", "+" + 2 * fboxsep + "pt");
            node.setAttribute("lspace", fboxsep + "pt"); //
            node.setAttribute("voffset", fboxsep + "pt");
            if (group.label === "\\fcolorbox") {
                var thk = Math.max(options.fontMetrics().fboxrule, // default
                options.minRuleThickness);
                node.setAttribute("style", "border: " + $ef0731f441f79e9a$var$makeEm(thk) + " solid " + group.borderColor);
            }
            break;
        case "\\xcancel":
            node.setAttribute("notation", "updiagonalstrike downdiagonalstrike");
            break;
    }
    if (group.backgroundColor) node.setAttribute("mathbackground", group.backgroundColor);
    return node;
};
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "enclose",
    names: [
        "\\colorbox"
    ],
    props: {
        numArgs: 2,
        allowedInText: true,
        argTypes: [
            "color",
            "hbox"
        ]
    },
    handler (_ref, args, optArgs) {
        var { parser: parser, funcName: funcName } = _ref;
        var color = $ef0731f441f79e9a$var$assertNodeType(args[0], "color-token").color;
        var body = args[1];
        return {
            type: "enclose",
            mode: parser.mode,
            label: funcName,
            backgroundColor: color,
            body: body
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$7,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$6
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "enclose",
    names: [
        "\\fcolorbox"
    ],
    props: {
        numArgs: 3,
        allowedInText: true,
        argTypes: [
            "color",
            "color",
            "hbox"
        ]
    },
    handler (_ref2, args, optArgs) {
        var { parser: parser, funcName: funcName } = _ref2;
        var borderColor = $ef0731f441f79e9a$var$assertNodeType(args[0], "color-token").color;
        var backgroundColor = $ef0731f441f79e9a$var$assertNodeType(args[1], "color-token").color;
        var body = args[2];
        return {
            type: "enclose",
            mode: parser.mode,
            label: funcName,
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            body: body
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$7,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$6
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "enclose",
    names: [
        "\\fbox"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "hbox"
        ],
        allowedInText: true
    },
    handler (_ref3, args) {
        var { parser: parser } = _ref3;
        return {
            type: "enclose",
            mode: parser.mode,
            label: "\\fbox",
            body: args[0]
        };
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "enclose",
    names: [
        "\\cancel",
        "\\bcancel",
        "\\xcancel",
        "\\phase"
    ],
    props: {
        numArgs: 1
    },
    handler (_ref4, args) {
        var { parser: parser, funcName: funcName } = _ref4;
        var body = args[0];
        return {
            type: "enclose",
            mode: parser.mode,
            label: funcName,
            body: body
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$7,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$6
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "enclose",
    names: [
        "\\sout"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler (_ref5, args) {
        var { parser: parser, funcName: funcName } = _ref5;
        if (parser.mode === "math") parser.settings.reportNonstrict("mathVsSout", "LaTeX's \\sout works only in text mode");
        var body = args[0];
        return {
            type: "enclose",
            mode: parser.mode,
            label: funcName,
            body: body
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$7,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$6
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "enclose",
    names: [
        "\\angl"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "hbox"
        ],
        allowedInText: false
    },
    handler (_ref6, args) {
        var { parser: parser } = _ref6;
        return {
            type: "enclose",
            mode: parser.mode,
            label: "\\angl",
            body: args[0]
        };
    }
});
/**
 * All registered environments.
 * `environments.js` exports this same dictionary again and makes it public.
 * `Parser.js` requires this dictionary via `environments.js`.
 */ var $ef0731f441f79e9a$var$_environments = {};
function $ef0731f441f79e9a$var$defineEnvironment(_ref) {
    var { type: type, names: names, props: props, handler: handler, htmlBuilder: htmlBuilder, mathmlBuilder: mathmlBuilder } = _ref;
    // Set default values of environments.
    var data = {
        type: type,
        numArgs: props.numArgs || 0,
        allowedInText: false,
        numOptionalArgs: 0,
        handler: handler
    };
    for(var i = 0; i < names.length; ++i)// TODO: The value type of _environments should be a type union of all
    // possible `EnvSpec<>` possibilities instead of `EnvSpec<*>`, which is
    // an existential type.
    $ef0731f441f79e9a$var$_environments[names[i]] = data;
    if (htmlBuilder) $ef0731f441f79e9a$var$_htmlGroupBuilders[type] = htmlBuilder;
    if (mathmlBuilder) $ef0731f441f79e9a$var$_mathmlGroupBuilders[type] = mathmlBuilder;
}
/**
 * All registered global/built-in macros.
 * `macros.js` exports this same dictionary again and makes it public.
 * `Parser.js` requires this dictionary via `macros.js`.
 */ var $ef0731f441f79e9a$var$_macros = {};
// This function might one day accept an additional argument and do more things.
function $ef0731f441f79e9a$export$1c70906d0a09453f(name, body) {
    $ef0731f441f79e9a$var$_macros[name] = body;
}
/**
 * Lexing or parsing positional information for error reporting.
 * This object is immutable.
 */ class $ef0731f441f79e9a$var$SourceLocation {
    // End offset, zero-based exclusive.
    constructor(lexer, start, end){
        // The + prefix indicates that these fields aren't writeable
        this.lexer = void 0;
        // Lexer holding the input string.
        this.start = void 0;
        // Start offset, zero-based inclusive.
        this.end = void 0;
        this.lexer = lexer;
        this.start = start;
        this.end = end;
    }
    /**
   * Merges two `SourceLocation`s from location providers, given they are
   * provided in order of appearance.
   * - Returns the first one's location if only the first is provided.
   * - Returns a merged range of the first and the last if both are provided
   *   and their lexers match.
   * - Otherwise, returns null.
   */ static range(first, second) {
        if (!second) return first && first.loc;
        else if (!first || !first.loc || !second.loc || first.loc.lexer !== second.loc.lexer) return null;
        else return new $ef0731f441f79e9a$var$SourceLocation(first.loc.lexer, first.loc.start, second.loc.end);
    }
}
/**
 * The resulting token returned from `lex`.
 *
 * It consists of the token text plus some position information.
 * The position information is essentially a range in an input string,
 * but instead of referencing the bare input string, we refer to the lexer.
 * That way it is possible to attach extra metadata to the input string,
 * like for example a file name or similar.
 *
 * The position information is optional, so it is OK to construct synthetic
 * tokens if appropriate. Not providing available position information may
 * lead to degraded error reporting, though.
 */ class $ef0731f441f79e9a$var$Token {
    // used in \noexpand
    constructor(text, // the text of this token
    loc){
        this.text = void 0;
        this.loc = void 0;
        this.noexpand = void 0;
        // don't expand the token
        this.treatAsRelax = void 0;
        this.text = text;
        this.loc = loc;
    }
    /**
   * Given a pair of tokens (this and endToken), compute a `Token` encompassing
   * the whole input range enclosed by these two.
   */ range(endToken, // last token of the range, inclusive
    text) {
        return new $ef0731f441f79e9a$var$Token(text, $ef0731f441f79e9a$var$SourceLocation.range(this, endToken));
    }
}
// Helper functions
function $ef0731f441f79e9a$var$getHLines(parser) {
    // Return an array. The array length = number of hlines.
    // Each element in the array tells if the line is dashed.
    var hlineInfo = [];
    parser.consumeSpaces();
    var nxt = parser.fetch().text;
    if (nxt === "\\relax") {
        // \relax is an artifact of the \cr macro below
        parser.consume();
        parser.consumeSpaces();
        nxt = parser.fetch().text;
    }
    while(nxt === "\\hline" || nxt === "\\hdashline"){
        parser.consume();
        hlineInfo.push(nxt === "\\hdashline");
        parser.consumeSpaces();
        nxt = parser.fetch().text;
    }
    return hlineInfo;
}
var $ef0731f441f79e9a$var$validateAmsEnvironmentContext = (context)=>{
    var settings = context.parser.settings;
    if (!settings.displayMode) throw new $ef0731f441f79e9a$export$f9c837a54db411d("{" + context.envName + "} can be used only in" + " display mode.");
};
var $ef0731f441f79e9a$var$gatherEnvironments = new Set([
    "gather",
    "gather*"
]);
// autoTag (an argument to parseArray) can be one of three values:
// * undefined: Regular (not-top-level) array; no tags on each row
// * true: Automatic equation numbering, overridable by \tag
// * false: Tags allowed on each row, but no automatic numbering
// This function *doesn't* work with the "split" environment name.
function $ef0731f441f79e9a$var$getAutoTag(name) {
    if (!name.includes("ed")) return !name.includes("*");
// return undefined;
}
/**
 * Parse the body of the environment, with rows delimited by \\ and
 * columns delimited by &, and create a nested list in row-major order
 * with one group per cell.  If given an optional argument style
 * ("text", "display", etc.), then each cell is cast into that style.
 */ function $ef0731f441f79e9a$var$parseArray(parser, _ref, style) {
    var { hskipBeforeAndAfter: hskipBeforeAndAfter, addJot: addJot, cols: cols, arraystretch: arraystretch, colSeparationType: colSeparationType, autoTag: autoTag, singleRow: singleRow, emptySingleRow: emptySingleRow, maxNumCols: maxNumCols, leqno: leqno } = _ref;
    parser.gullet.beginGroup();
    if (!singleRow) // \cr is equivalent to \\ without the optional size argument (see below)
    // TODO: provide helpful error when \cr is used outside array environment
    parser.gullet.macros.set("\\cr", "\\\\\\relax");
    // Get current arraystretch if it's not set by the environment
    if (!arraystretch) {
        var stretch = parser.gullet.expandMacroAsText("\\arraystretch");
        if (stretch == null) // Default \arraystretch from lttab.dtx
        arraystretch = 1;
        else {
            arraystretch = parseFloat(stretch);
            if (!arraystretch || arraystretch < 0) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid \\arraystretch: " + stretch);
        }
    }
    // Start group for first cell
    parser.gullet.beginGroup();
    var row = [];
    var body = [
        row
    ];
    var rowGaps = [];
    var hLinesBeforeRow = [];
    var tags = autoTag != null ? [] : undefined;
    // amsmath uses \global\@eqnswtrue and \global\@eqnswfalse to represent
    // whether this row should have an equation number.  Simulate this with
    // a \@eqnsw macro set to 1 or 0.
    function beginRow() {
        if (autoTag) parser.gullet.macros.set("\\@eqnsw", "1", true);
    }
    function endRow() {
        if (tags) {
            if (parser.gullet.macros.get("\\df@tag")) {
                tags.push(parser.subparse([
                    new $ef0731f441f79e9a$var$Token("\\df@tag")
                ]));
                parser.gullet.macros.set("\\df@tag", undefined, true);
            } else tags.push(Boolean(autoTag) && parser.gullet.macros.get("\\@eqnsw") === "1");
        }
    }
    beginRow();
    // Test for \hline at the top of the array.
    hLinesBeforeRow.push($ef0731f441f79e9a$var$getHLines(parser));
    while(true){
        // Parse each cell in its own group (namespace)
        var cellBody = parser.parseExpression(false, singleRow ? "\\end" : "\\\\");
        parser.gullet.endGroup();
        parser.gullet.beginGroup();
        var cell = {
            type: "ordgroup",
            mode: parser.mode,
            body: cellBody
        };
        if (style) cell = {
            type: "styling",
            mode: parser.mode,
            style: style,
            resetFont: true,
            body: [
                cell
            ]
        };
        row.push(cell);
        var next = parser.fetch().text;
        if (next === "&") {
            if (maxNumCols && row.length === maxNumCols) {
                if (singleRow || colSeparationType) // {equation} or {split}
                throw new $ef0731f441f79e9a$export$f9c837a54db411d("Too many tab characters: &", parser.nextToken);
                else // {array} environment
                parser.settings.reportNonstrict("textEnv", "Too few columns specified in the {array} column argument.");
            }
            parser.consume();
        } else if (next === "\\end") {
            endRow();
            // Arrays terminate newlines with `\crcr` which consumes a `\cr` if
            // the last line is empty.  However, AMS environments keep the
            // empty row if it's the only one.
            // NOTE: Currently, `cell` is the last item added into `row`.
            if (row.length === 1 && cell.type === "styling" && cell.body.length === 1 && cell.body[0].type === "ordgroup" && cell.body[0].body.length === 0 && (body.length > 1 || !emptySingleRow)) body.pop();
            if (hLinesBeforeRow.length < body.length + 1) hLinesBeforeRow.push([]);
            break;
        } else if (next === "\\\\") {
            parser.consume();
            var size = void 0;
            // \def\Let@{\let\\\math@cr}
            // \def\math@cr{...\math@cr@}
            // \def\math@cr@{\new@ifnextchar[\math@cr@@{\math@cr@@[\z@]}}
            // \def\math@cr@@[#1]{...\math@cr@@@...}
            // \def\math@cr@@@{\cr}
            if (parser.gullet.future().text !== " ") size = parser.parseSizeGroup(true);
            rowGaps.push(size ? size.value : null);
            endRow();
            // check for \hline(s) following the row separator
            hLinesBeforeRow.push($ef0731f441f79e9a$var$getHLines(parser));
            row = [];
            body.push(row);
            beginRow();
        } else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Expected & or \\\\ or \\cr or \\end", parser.nextToken);
    }
    // End cell group
    parser.gullet.endGroup();
    // End array group defining \cr
    parser.gullet.endGroup();
    return {
        type: "array",
        mode: parser.mode,
        addJot: addJot,
        arraystretch: arraystretch,
        body: body,
        cols: cols,
        rowGaps: rowGaps,
        hskipBeforeAndAfter: hskipBeforeAndAfter,
        hLinesBeforeRow: hLinesBeforeRow,
        colSeparationType: colSeparationType,
        tags: tags,
        leqno: leqno
    };
}
// Decides on a style for cells in an array according to whether the given
// environment name starts with the letter 'd'.
function $ef0731f441f79e9a$var$dCellStyle(envName) {
    if (envName.slice(0, 1) === "d") return "display";
    else return "text";
}
var $ef0731f441f79e9a$var$htmlBuilder$6 = function htmlBuilder(group, options) {
    var r;
    var c;
    var nr = group.body.length;
    var hLinesBeforeRow = group.hLinesBeforeRow;
    var nc = 0;
    var body = new Array(nr);
    var hlines = [];
    var ruleThickness = Math.max(// From LaTeX \showthe\arrayrulewidth. Equals 0.04 em.
    options.fontMetrics().arrayRuleWidth, options.minRuleThickness);
    // Horizontal spacing
    var pt = 1 / options.fontMetrics().ptPerEm;
    var arraycolsep = 5 * pt; // default value, i.e. \arraycolsep in article.cls
    if (group.colSeparationType && group.colSeparationType === "small") {
        // We're in a {smallmatrix}. Default column space is \thickspace,
        // i.e. 5/18em = 0.2778em, per amsmath.dtx for {smallmatrix}.
        // But that needs adjustment because LaTeX applies \scriptstyle to the
        // entire array, including the colspace, but this function applies
        // \scriptstyle only inside each element.
        var localMultiplier = options.havingStyle($ef0731f441f79e9a$var$Style$1.SCRIPT).sizeMultiplier;
        arraycolsep = 0.2778 * (localMultiplier / options.sizeMultiplier);
    }
    // Vertical spacing
    var baselineskip = group.colSeparationType === "CD" ? $ef0731f441f79e9a$var$calculateSize({
        number: 3,
        unit: "ex"
    }, options) : 12 * pt; // see size10.clo
    // Default \jot from ltmath.dtx
    // TODO(edemaine): allow overriding \jot via \setlength (#687)
    var jot = 3 * pt;
    var arrayskip = group.arraystretch * baselineskip;
    var arstrutHeight = 0.7 * arrayskip; // \strutbox in ltfsstrc.dtx and
    var arstrutDepth = 0.3 * arrayskip; // \@arstrutbox in lttab.dtx
    var totalHeight = 0;
    // Set a position for \hline(s) at the top of the array, if any.
    function setHLinePos(hlinesInGap) {
        for(var i = 0; i < hlinesInGap.length; ++i){
            if (i > 0) totalHeight += 0.25;
            hlines.push({
                pos: totalHeight,
                isDashed: hlinesInGap[i]
            });
        }
    }
    setHLinePos(hLinesBeforeRow[0]);
    for(r = 0; r < group.body.length; ++r){
        var inrow = group.body[r];
        var height = arstrutHeight; // \@array adds an \@arstrut
        var depth = arstrutDepth; // to each tow (via the template)
        if (nc < inrow.length) nc = inrow.length;
        var outrow = {
            cells: new Array(inrow.length),
            height: 0,
            depth: 0,
            pos: 0
        };
        for(c = 0; c < inrow.length; ++c){
            var elt = $ef0731f441f79e9a$var$buildGroup$1(inrow[c], options);
            if (depth < elt.depth) depth = elt.depth;
            if (height < elt.height) height = elt.height;
            outrow.cells[c] = elt;
        }
        var rowGap = group.rowGaps[r];
        var gap = 0;
        if (rowGap) {
            gap = $ef0731f441f79e9a$var$calculateSize(rowGap, options);
            if (gap > 0) {
                // \@argarraycr
                gap += arstrutDepth;
                if (depth < gap) depth = gap; // \@xargarraycr
                gap = 0;
            }
        }
        // In AMS multiline environments such as aligned and gathered, rows
        // correspond to lines that have additional \jot added between lines
        // via \openup.
        // We simulate this by adding \jot depth to each row except the last.
        if (group.addJot && r < group.body.length - 1) depth += jot;
        outrow.height = height;
        outrow.depth = depth;
        totalHeight += height;
        outrow.pos = totalHeight;
        totalHeight += depth + gap; // \@yargarraycr
        body[r] = outrow;
        // Set a position for \hline(s), if any.
        setHLinePos(hLinesBeforeRow[r + 1]);
    }
    var offset = totalHeight / 2 + options.fontMetrics().axisHeight;
    var colDescriptions = group.cols || [];
    var cols = [];
    var colSep;
    var colDescrNum;
    var tagSpans = [];
    if (group.tags && group.tags.some((tag)=>tag)) // An environment with manual tags and/or automatic equation numbers.
    // Create node(s), the latter of which trigger CSS counter increment.
    for(r = 0; r < nr; ++r){
        var rw = body[r];
        var shift = rw.pos - offset;
        var tag = group.tags[r];
        var tagSpan = void 0;
        if (tag === true) // automatic numbering
        tagSpan = $ef0731f441f79e9a$var$makeSpan([
            "eqn-num"
        ], [], options);
        else if (tag === false) // \nonumber/\notag or starred environment
        tagSpan = $ef0731f441f79e9a$var$makeSpan([], [], options);
        else // manual \tag
        tagSpan = $ef0731f441f79e9a$var$makeSpan([], $ef0731f441f79e9a$var$buildExpression$1(tag, options, true), options);
        tagSpan.depth = rw.depth;
        tagSpan.height = rw.height;
        tagSpans.push({
            type: "elem",
            elem: tagSpan,
            shift: shift
        });
    }
    for(c = 0, colDescrNum = 0; // Continue while either there are more columns or more column
    // descriptions, so trailing separators don't get lost.
    c < nc || colDescrNum < colDescriptions.length; ++c, ++colDescrNum){
        var _colDescr3;
        var colDescr = colDescriptions[colDescrNum];
        var firstSeparator = true;
        while(((_colDescr = colDescr) == null ? void 0 : _colDescr.type) === "separator"){
            var _colDescr;
            // If there is more than one separator in a row, add a space
            // between them.
            if (!firstSeparator) {
                colSep = $ef0731f441f79e9a$var$makeSpan([
                    "arraycolsep"
                ], []);
                colSep.style.width = $ef0731f441f79e9a$var$makeEm(options.fontMetrics().doubleRuleSep);
                cols.push(colSep);
            }
            if (colDescr.separator === "|" || colDescr.separator === ":") {
                var lineType = colDescr.separator === "|" ? "solid" : "dashed";
                var separator = $ef0731f441f79e9a$var$makeSpan([
                    "vertical-separator"
                ], [], options);
                separator.style.height = $ef0731f441f79e9a$var$makeEm(totalHeight);
                separator.style.borderRightWidth = $ef0731f441f79e9a$var$makeEm(ruleThickness);
                separator.style.borderRightStyle = lineType;
                separator.style.margin = "0 " + $ef0731f441f79e9a$var$makeEm(-ruleThickness / 2);
                var _shift = totalHeight - offset;
                if (_shift) separator.style.verticalAlign = $ef0731f441f79e9a$var$makeEm(-_shift);
                cols.push(separator);
            } else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid separator type: " + colDescr.separator);
            colDescrNum++;
            colDescr = colDescriptions[colDescrNum];
            firstSeparator = false;
        }
        if (c >= nc) continue;
        var sepwidth = void 0;
        if (c > 0 || group.hskipBeforeAndAfter) {
            var _colDescr$pregap, _colDescr2;
            sepwidth = (_colDescr$pregap = (_colDescr2 = colDescr) == null ? void 0 : _colDescr2.pregap) != null ? _colDescr$pregap : arraycolsep;
            if (sepwidth !== 0) {
                colSep = $ef0731f441f79e9a$var$makeSpan([
                    "arraycolsep"
                ], []);
                colSep.style.width = $ef0731f441f79e9a$var$makeEm(sepwidth);
                cols.push(colSep);
            }
        }
        var colElems = [];
        for(r = 0; r < nr; ++r){
            var row = body[r];
            var elem = row.cells[c];
            if (!elem) continue;
            var _shift2 = row.pos - offset;
            elem.depth = row.depth;
            elem.height = row.height;
            colElems.push({
                type: "elem",
                elem: elem,
                shift: _shift2
            });
        }
        var colVList = $ef0731f441f79e9a$var$makeVList({
            positionType: "individualShift",
            children: colElems
        });
        var colSpan = $ef0731f441f79e9a$var$makeSpan([
            "col-align-" + (((_colDescr3 = colDescr) == null ? void 0 : _colDescr3.align) || "c")
        ], [
            colVList
        ]);
        cols.push(colSpan);
        if (c < nc - 1 || group.hskipBeforeAndAfter) {
            var _colDescr$postgap, _colDescr4;
            sepwidth = (_colDescr$postgap = (_colDescr4 = colDescr) == null ? void 0 : _colDescr4.postgap) != null ? _colDescr$postgap : arraycolsep;
            if (sepwidth !== 0) {
                colSep = $ef0731f441f79e9a$var$makeSpan([
                    "arraycolsep"
                ], []);
                colSep.style.width = $ef0731f441f79e9a$var$makeEm(sepwidth);
                cols.push(colSep);
            }
        }
    }
    var tableBody = $ef0731f441f79e9a$var$makeSpan([
        "mtable"
    ], cols);
    // Add \hline(s), if any.
    if (hlines.length > 0) {
        var line = $ef0731f441f79e9a$var$makeLineSpan("hline", options, ruleThickness);
        var dashes = $ef0731f441f79e9a$var$makeLineSpan("hdashline", options, ruleThickness);
        var vListElems = [
            {
                type: "elem",
                elem: tableBody,
                shift: 0
            }
        ];
        while(hlines.length > 0){
            var hline = hlines.pop();
            var lineShift = hline.pos - offset;
            if (hline.isDashed) vListElems.push({
                type: "elem",
                elem: dashes,
                shift: lineShift
            });
            else vListElems.push({
                type: "elem",
                elem: line,
                shift: lineShift
            });
        }
        tableBody = $ef0731f441f79e9a$var$makeVList({
            positionType: "individualShift",
            children: vListElems
        });
    }
    if (tagSpans.length === 0) return $ef0731f441f79e9a$var$makeSpan([
        "mord"
    ], [
        tableBody
    ], options);
    else {
        var eqnNumCol = $ef0731f441f79e9a$var$makeVList({
            positionType: "individualShift",
            children: tagSpans
        });
        var tagCol = $ef0731f441f79e9a$var$makeSpan([
            "tag"
        ], [
            eqnNumCol
        ], options);
        return $ef0731f441f79e9a$var$makeFragment([
            tableBody,
            tagCol
        ]);
    }
};
var $ef0731f441f79e9a$var$alignMap = {
    c: "center ",
    l: "left ",
    r: "right "
};
var $ef0731f441f79e9a$var$mathmlBuilder$5 = function mathmlBuilder(group, options) {
    var tbl = [];
    var glue = new $ef0731f441f79e9a$var$MathNode("mtd", [], [
        "mtr-glue"
    ]);
    var tag = new $ef0731f441f79e9a$var$MathNode("mtd", [], [
        "mml-eqn-num"
    ]);
    for(var i = 0; i < group.body.length; i++){
        var rw = group.body[i];
        var row = [];
        for(var j = 0; j < rw.length; j++)row.push(new $ef0731f441f79e9a$var$MathNode("mtd", [
            $ef0731f441f79e9a$var$buildGroup(rw[j], options)
        ]));
        if (group.tags && group.tags[i]) {
            row.unshift(glue);
            row.push(glue);
            if (group.leqno) row.unshift(tag);
            else row.push(tag);
        }
        tbl.push(new $ef0731f441f79e9a$var$MathNode("mtr", row));
    }
    var table = new $ef0731f441f79e9a$var$MathNode("mtable", tbl);
    // Set column alignment, row spacing, column spacing, and
    // array lines by setting attributes on the table element.
    // Set the row spacing. In MathML, we specify a gap distance.
    // We do not use rowGap[] because MathML automatically increases
    // cell height with the height/depth of the element content.
    // LaTeX \arraystretch multiplies the row baseline-to-baseline distance.
    // We simulate this by adding (arraystretch - 1)em to the gap. This
    // does a reasonable job of adjusting arrays containing 1 em tall content.
    // The 0.16 and 0.09 values are found empirically. They produce an array
    // similar to LaTeX and in which content does not interfere with \hlines.
    var gap = group.arraystretch === 0.5 ? 0.1 // {smallmatrix}, {subarray}
     : 0.16 + group.arraystretch - 1 + (group.addJot ? 0.09 : 0);
    table.setAttribute("rowspacing", $ef0731f441f79e9a$var$makeEm(gap));
    // MathML table lines go only between cells.
    // To place a line on an edge we'll use <menclose>, if necessary.
    var menclose = "";
    var align = "";
    if (group.cols && group.cols.length > 0) {
        // Find column alignment, column spacing, and  vertical lines.
        var cols = group.cols;
        var columnLines = "";
        var prevTypeWasAlign = false;
        var iStart = 0;
        var iEnd = cols.length;
        if (cols[0].type === "separator") {
            menclose += "top ";
            iStart = 1;
        }
        if (cols[cols.length - 1].type === "separator") {
            menclose += "bottom ";
            iEnd -= 1;
        }
        for(var _i = iStart; _i < iEnd; _i++){
            var col = cols[_i];
            if (col.type === "align") {
                align += $ef0731f441f79e9a$var$alignMap[col.align];
                if (prevTypeWasAlign) columnLines += "none ";
                prevTypeWasAlign = true;
            } else if (col.type === "separator") // MathML accepts only single lines between cells.
            // So we read only the first of consecutive separators.
            {
                if (prevTypeWasAlign) {
                    columnLines += col.separator === "|" ? "solid " : "dashed ";
                    prevTypeWasAlign = false;
                }
            }
        }
        table.setAttribute("columnalign", align.trim());
        if (/[sd]/.test(columnLines)) table.setAttribute("columnlines", columnLines.trim());
    }
    // Set column spacing.
    if (group.colSeparationType === "align") {
        var _cols = group.cols || [];
        var spacing = "";
        for(var _i2 = 1; _i2 < _cols.length; _i2++)spacing += _i2 % 2 ? "0em " : "1em ";
        table.setAttribute("columnspacing", spacing.trim());
    } else if (group.colSeparationType === "alignat" || group.colSeparationType === "gather") table.setAttribute("columnspacing", "0em");
    else if (group.colSeparationType === "small") table.setAttribute("columnspacing", "0.2778em");
    else if (group.colSeparationType === "CD") table.setAttribute("columnspacing", "0.5em");
    else table.setAttribute("columnspacing", "1em");
    // Address \hline and \hdashline
    var rowLines = "";
    var hlines = group.hLinesBeforeRow;
    menclose += hlines[0].length > 0 ? "left " : "";
    menclose += hlines[hlines.length - 1].length > 0 ? "right " : "";
    for(var _i3 = 1; _i3 < hlines.length - 1; _i3++)rowLines += hlines[_i3].length === 0 ? "none " : hlines[_i3][0] ? "dashed " : "solid ";
    if (/[sd]/.test(rowLines)) table.setAttribute("rowlines", rowLines.trim());
    if (menclose !== "") {
        table = new $ef0731f441f79e9a$var$MathNode("menclose", [
            table
        ]);
        table.setAttribute("notation", menclose.trim());
    }
    if (group.arraystretch && group.arraystretch < 1) {
        // A small array. Wrap in scriptstyle so row gap is not too large.
        table = new $ef0731f441f79e9a$var$MathNode("mstyle", [
            table
        ]);
        table.setAttribute("scriptlevel", "1");
    }
    return table;
};
// Convenience function for align, align*, aligned, alignat, alignat*, alignedat.
var $ef0731f441f79e9a$var$alignedHandler = function alignedHandler(context, args) {
    if (!context.envName.includes("ed")) $ef0731f441f79e9a$var$validateAmsEnvironmentContext(context);
    var cols = [];
    var separationType = context.envName.includes("at") ? "alignat" : "align";
    var isSplit = context.envName === "split";
    var res = $ef0731f441f79e9a$var$parseArray(context.parser, {
        cols: cols,
        addJot: true,
        autoTag: isSplit ? undefined : $ef0731f441f79e9a$var$getAutoTag(context.envName),
        emptySingleRow: true,
        colSeparationType: separationType,
        maxNumCols: isSplit ? 2 : undefined,
        leqno: context.parser.settings.leqno
    }, "display");
    // Determining number of columns.
    // 1. If the first argument is given, we use it as a number of columns,
    //    and makes sure that each row doesn't exceed that number.
    // 2. Otherwise, just count number of columns = maximum number
    //    of cells in each row ("aligned" mode -- isAligned will be true).
    //
    // At the same time, prepend empty group {} at beginning of every second
    // cell in each row (starting with second cell) so that operators become
    // binary.  This behavior is implemented in amsmath's \start@aligned.
    var numMaths = 0;
    var numCols = 0;
    var emptyGroup = {
        type: "ordgroup",
        mode: context.mode,
        body: []
    };
    if (args[0] && args[0].type === "ordgroup") {
        var arg0 = "";
        for(var i = 0; i < args[0].body.length; i++){
            var textord = $ef0731f441f79e9a$var$assertNodeType(args[0].body[i], "textord");
            arg0 += textord.text;
        }
        numMaths = Number(arg0);
        numCols = numMaths * 2;
    }
    var isAligned = !numCols;
    res.body.forEach(function(row) {
        for(var _i4 = 1; _i4 < row.length; _i4 += 2){
            // Modify ordgroup node within styling node
            var styling = $ef0731f441f79e9a$var$assertNodeType(row[_i4], "styling");
            var ordgroup = $ef0731f441f79e9a$var$assertNodeType(styling.body[0], "ordgroup");
            ordgroup.body.unshift(emptyGroup);
        }
        if (!isAligned) {
            // Case 1
            var curMaths = row.length / 2;
            if (numMaths < curMaths) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Too many math in a row: " + ("expected " + numMaths + ", but got " + curMaths), row[0]);
        } else if (numCols < row.length) // Case 2
        numCols = row.length;
    });
    // Adjusting alignment.
    // In aligned mode, we add one \qquad between columns;
    // otherwise we add nothing.
    for(var _i5 = 0; _i5 < numCols; ++_i5){
        var align = "r";
        var pregap = 0;
        if (_i5 % 2 === 1) align = "l";
        else if (_i5 > 0 && isAligned) // "aligned" mode.
        pregap = 1; // add one \quad
        cols[_i5] = {
            type: "align",
            align: align,
            pregap: pregap,
            postgap: 0
        };
    }
    res.colSeparationType = isAligned ? "align" : "alignat";
    return res;
};
// Arrays are part of LaTeX, defined in lttab.dtx so its documentation
// is part of the source2e.pdf file of LaTeX2e source documentation.
// {darray} is an {array} environment where cells are set in \displaystyle,
// as defined in nccmath.sty.
$ef0731f441f79e9a$var$defineEnvironment({
    type: "array",
    names: [
        "array",
        "darray"
    ],
    props: {
        numArgs: 1
    },
    handler (context, args) {
        // Since no types are specified above, the two possibilities are
        // - The argument is wrapped in {} or [], in which case Parser's
        //   parseGroup() returns an "ordgroup" wrapping some symbol node.
        // - The argument is a bare symbol node.
        var symNode = $ef0731f441f79e9a$var$checkSymbolNodeType(args[0]);
        var colalign = symNode ? [
            args[0]
        ] : $ef0731f441f79e9a$var$assertNodeType(args[0], "ordgroup").body;
        var cols = colalign.map(function(nde) {
            var node = $ef0731f441f79e9a$var$assertSymbolNodeType(nde);
            var ca = node.text;
            if ("lcr".includes(ca)) return {
                type: "align",
                align: ca
            };
            else if (ca === "|") return {
                type: "separator",
                separator: "|"
            };
            else if (ca === ":") return {
                type: "separator",
                separator: ":"
            };
            throw new $ef0731f441f79e9a$export$f9c837a54db411d("Unknown column alignment: " + ca, nde);
        });
        var res = {
            cols: cols,
            hskipBeforeAndAfter: true,
            // \@preamble in lttab.dtx
            maxNumCols: cols.length
        };
        return $ef0731f441f79e9a$var$parseArray(context.parser, res, $ef0731f441f79e9a$var$dCellStyle(context.envName));
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$6,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$5
});
// The matrix environments of amsmath builds on the array environment
// of LaTeX, which is discussed above.
// The mathtools package adds starred versions of the same environments.
// These have an optional argument to choose left|center|right justification.
$ef0731f441f79e9a$var$defineEnvironment({
    type: "array",
    names: [
        "matrix",
        "pmatrix",
        "bmatrix",
        "Bmatrix",
        "vmatrix",
        "Vmatrix",
        "matrix*",
        "pmatrix*",
        "bmatrix*",
        "Bmatrix*",
        "vmatrix*",
        "Vmatrix*"
    ],
    props: {
        numArgs: 0
    },
    handler (context) {
        var delimiters = {
            "matrix": null,
            "pmatrix": [
                "(",
                ")"
            ],
            "bmatrix": [
                "[",
                "]"
            ],
            "Bmatrix": [
                "\\{",
                "\\}"
            ],
            "vmatrix": [
                "|",
                "|"
            ],
            "Vmatrix": [
                "\\Vert",
                "\\Vert"
            ]
        }[context.envName.replace("*", "")];
        // \hskip -\arraycolsep in amsmath
        var colAlign = "c";
        var payload = {
            hskipBeforeAndAfter: false,
            cols: [
                {
                    type: "align",
                    align: colAlign
                }
            ]
        };
        if (context.envName.charAt(context.envName.length - 1) === "*") {
            // It's one of the mathtools starred functions.
            // Parse the optional alignment argument.
            var parser = context.parser;
            parser.consumeSpaces();
            if (parser.fetch().text === "[") {
                parser.consume();
                parser.consumeSpaces();
                colAlign = parser.fetch().text;
                if (!"lcr".includes(colAlign)) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Expected l or c or r", parser.nextToken);
                parser.consume();
                parser.consumeSpaces();
                parser.expect("]");
                parser.consume();
                payload.cols = [
                    {
                        type: "align",
                        align: colAlign
                    }
                ];
            }
        }
        var res = $ef0731f441f79e9a$var$parseArray(context.parser, payload, $ef0731f441f79e9a$var$dCellStyle(context.envName));
        // Populate cols with the correct number of column alignment specs.
        var numCols = Math.max(0, ...res.body.map((row)=>row.length));
        res.cols = new Array(numCols).fill({
            type: "align",
            align: colAlign
        });
        return delimiters ? {
            type: "leftright",
            mode: context.mode,
            body: [
                res
            ],
            left: delimiters[0],
            right: delimiters[1],
            rightColor: undefined // \right uninfluenced by \color in array
        } : res;
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$6,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$5
});
$ef0731f441f79e9a$var$defineEnvironment({
    type: "array",
    names: [
        "smallmatrix"
    ],
    props: {
        numArgs: 0
    },
    handler (context) {
        var payload = {
            arraystretch: 0.5
        };
        var res = $ef0731f441f79e9a$var$parseArray(context.parser, payload, "script");
        res.colSeparationType = "small";
        return res;
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$6,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$5
});
$ef0731f441f79e9a$var$defineEnvironment({
    type: "array",
    names: [
        "subarray"
    ],
    props: {
        numArgs: 1
    },
    handler (context, args) {
        // Parsing of {subarray} is similar to {array}
        var symNode = $ef0731f441f79e9a$var$checkSymbolNodeType(args[0]);
        var colalign = symNode ? [
            args[0]
        ] : $ef0731f441f79e9a$var$assertNodeType(args[0], "ordgroup").body;
        var cols = colalign.map(function(nde) {
            var node = $ef0731f441f79e9a$var$assertSymbolNodeType(nde);
            var ca = node.text;
            // {subarray} only recognizes "l" & "c"
            if ("lc".includes(ca)) return {
                type: "align",
                align: ca
            };
            throw new $ef0731f441f79e9a$export$f9c837a54db411d("Unknown column alignment: " + ca, nde);
        });
        if (cols.length > 1) throw new $ef0731f441f79e9a$export$f9c837a54db411d("{subarray} can contain only one column");
        var payload = {
            cols: cols,
            hskipBeforeAndAfter: false,
            arraystretch: 0.5
        };
        var res = $ef0731f441f79e9a$var$parseArray(context.parser, payload, "script");
        if (res.body.length > 0 && res.body[0].length > 1) throw new $ef0731f441f79e9a$export$f9c837a54db411d("{subarray} can contain only one column");
        return res;
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$6,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$5
});
// A cases environment (in amsmath.sty) is almost equivalent to
// \def\arraystretch{1.2}%
// \left\{\begin{array}{@{}l@{\quad}l@{}} … \end{array}\right.
// {dcases} is a {cases} environment where cells are set in \displaystyle,
// as defined in mathtools.sty.
// {rcases} is another mathtools environment. It's brace is on the right side.
$ef0731f441f79e9a$var$defineEnvironment({
    type: "array",
    names: [
        "cases",
        "dcases",
        "rcases",
        "drcases"
    ],
    props: {
        numArgs: 0
    },
    handler (context) {
        var payload = {
            arraystretch: 1.2,
            cols: [
                {
                    type: "align",
                    align: "l",
                    pregap: 0,
                    // TODO(kevinb) get the current style.
                    // For now we use the metrics for TEXT style which is what we were
                    // doing before.  Before attempting to get the current style we
                    // should look at TeX's behavior especially for \over and matrices.
                    postgap: 1.0 /* 1em quad */ 
                },
                {
                    type: "align",
                    align: "l",
                    pregap: 0,
                    postgap: 0
                }
            ]
        };
        var res = $ef0731f441f79e9a$var$parseArray(context.parser, payload, $ef0731f441f79e9a$var$dCellStyle(context.envName));
        return {
            type: "leftright",
            mode: context.mode,
            body: [
                res
            ],
            left: context.envName.includes("r") ? "." : "\\{",
            right: context.envName.includes("r") ? "\\}" : ".",
            rightColor: undefined
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$6,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$5
});
// In the align environment, one uses ampersands, &, to specify number of
// columns in each row, and to locate spacing between each column.
// align gets automatic numbering. align* and aligned do not.
// The alignedat environment can be used in math mode.
// Note that we assume \nomallineskiplimit to be zero,
// so that \strut@ is the same as \strut.
$ef0731f441f79e9a$var$defineEnvironment({
    type: "array",
    names: [
        "align",
        "align*",
        "aligned",
        "split"
    ],
    props: {
        numArgs: 0
    },
    handler: $ef0731f441f79e9a$var$alignedHandler,
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$6,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$5
});
// A gathered environment is like an array environment with one centered
// column, but where rows are considered lines so get \jot line spacing
// and contents are set in \displaystyle.
$ef0731f441f79e9a$var$defineEnvironment({
    type: "array",
    names: [
        "gathered",
        "gather",
        "gather*"
    ],
    props: {
        numArgs: 0
    },
    handler (context) {
        if ($ef0731f441f79e9a$var$gatherEnvironments.has(context.envName)) $ef0731f441f79e9a$var$validateAmsEnvironmentContext(context);
        var res = {
            cols: [
                {
                    type: "align",
                    align: "c"
                }
            ],
            addJot: true,
            colSeparationType: "gather",
            autoTag: $ef0731f441f79e9a$var$getAutoTag(context.envName),
            emptySingleRow: true,
            leqno: context.parser.settings.leqno
        };
        return $ef0731f441f79e9a$var$parseArray(context.parser, res, "display");
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$6,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$5
});
// alignat environment is like an align environment, but one must explicitly
// specify maximum number of columns in each row, and can adjust spacing between
// each columns.
$ef0731f441f79e9a$var$defineEnvironment({
    type: "array",
    names: [
        "alignat",
        "alignat*",
        "alignedat"
    ],
    props: {
        numArgs: 1
    },
    handler: $ef0731f441f79e9a$var$alignedHandler,
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$6,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$5
});
$ef0731f441f79e9a$var$defineEnvironment({
    type: "array",
    names: [
        "equation",
        "equation*"
    ],
    props: {
        numArgs: 0
    },
    handler (context) {
        $ef0731f441f79e9a$var$validateAmsEnvironmentContext(context);
        var res = {
            autoTag: $ef0731f441f79e9a$var$getAutoTag(context.envName),
            emptySingleRow: true,
            singleRow: true,
            maxNumCols: 1,
            leqno: context.parser.settings.leqno
        };
        return $ef0731f441f79e9a$var$parseArray(context.parser, res, "display");
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$6,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$5
});
$ef0731f441f79e9a$var$defineEnvironment({
    type: "array",
    names: [
        "CD"
    ],
    props: {
        numArgs: 0
    },
    handler (context) {
        $ef0731f441f79e9a$var$validateAmsEnvironmentContext(context);
        return $ef0731f441f79e9a$var$parseCD(context.parser);
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$6,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$5
});
$ef0731f441f79e9a$export$1c70906d0a09453f("\\nonumber", "\\gdef\\@eqnsw{0}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\notag", "\\nonumber");
// Catch \hline outside array environment
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "text",
    // Doesn't matter what this is.
    names: [
        "\\hline",
        "\\hdashline"
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        allowedInMath: true
    },
    handler (context, args) {
        throw new $ef0731f441f79e9a$export$f9c837a54db411d(context.funcName + " valid only within array environment");
    }
});
var $ef0731f441f79e9a$var$environments = $ef0731f441f79e9a$var$_environments;
// Environment delimiters. HTML/MathML rendering is defined in the corresponding
// defineEnvironment definitions.
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "environment",
    names: [
        "\\begin",
        "\\end"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "text"
        ]
    },
    handler (_ref, args) {
        var { parser: parser, funcName: funcName } = _ref;
        var nameGroup = args[0];
        if (nameGroup.type !== "ordgroup") throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid environment name", nameGroup);
        var envName = "";
        for(var i = 0; i < nameGroup.body.length; ++i)envName += $ef0731f441f79e9a$var$assertNodeType(nameGroup.body[i], "textord").text;
        if (funcName === "\\begin") {
            // begin...end is similar to left...right
            if (!$ef0731f441f79e9a$var$environments.hasOwnProperty(envName)) throw new $ef0731f441f79e9a$export$f9c837a54db411d("No such environment: " + envName, nameGroup);
            // Build the environment object. Arguments and other information will
            // be made available to the begin and end methods using properties.
            var env = $ef0731f441f79e9a$var$environments[envName];
            var { args: _args, optArgs: optArgs } = parser.parseArguments("\\begin{" + envName + "}", env);
            var context = {
                mode: parser.mode,
                envName: envName,
                parser: parser
            };
            var result = env.handler(context, _args, optArgs);
            parser.expect("\\end", false);
            var endNameToken = parser.nextToken;
            var end = $ef0731f441f79e9a$var$assertNodeType(parser.parseFunction(), "environment");
            if (end.name !== envName) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Mismatch: \\begin{" + envName + "} matched by \\end{" + end.name + "}", endNameToken);
            // env.handler returns the specific node type (e.g. "array"),
            // not "environment". This cast is unavoidable: defineFunction
            // requires the handler to return ParseNode<"environment"> but
            // \begin delegates to environment handlers with different types.
            return result;
        }
        return {
            type: "environment",
            mode: parser.mode,
            name: envName,
            nameGroup: nameGroup
        };
    }
});
// TODO(kevinb): implement \\sl and \\sc
var $ef0731f441f79e9a$var$htmlBuilder$5 = (group, options)=>{
    var font = group.font;
    var newOptions = options.withFont(font);
    return $ef0731f441f79e9a$var$buildGroup$1(group.body, newOptions);
};
var $ef0731f441f79e9a$var$mathmlBuilder$4 = (group, options)=>{
    var font = group.font;
    var newOptions = options.withFont(font);
    return $ef0731f441f79e9a$var$buildGroup(group.body, newOptions);
};
var $ef0731f441f79e9a$var$fontAliases = {
    "\\Bbb": "\\mathbb",
    "\\bold": "\\mathbf",
    "\\frak": "\\mathfrak"
};
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "font",
    names: [
        // styles, except \boldsymbol defined below
        "\\mathrm",
        "\\mathit",
        "\\mathbf",
        "\\mathnormal",
        "\\mathsfit",
        // families
        "\\mathbb",
        "\\mathcal",
        "\\mathfrak",
        "\\mathscr",
        "\\mathsf",
        "\\mathtt",
        // aliases, except \bm defined below
        "\\Bbb",
        "\\bold",
        "\\frak"
    ],
    props: {
        numArgs: 1,
        allowedInArgument: true
    },
    handler: (_ref, args)=>{
        var { parser: parser, funcName: funcName } = _ref;
        var body = $ef0731f441f79e9a$var$normalizeArgument(args[0]);
        var func = funcName;
        if (func in $ef0731f441f79e9a$var$fontAliases) func = $ef0731f441f79e9a$var$fontAliases[func];
        return {
            type: "font",
            mode: parser.mode,
            font: func.slice(1),
            body: body
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$5,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$4
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "mclass",
    names: [
        "\\boldsymbol",
        "\\bm"
    ],
    props: {
        numArgs: 1
    },
    handler: (_ref2, args)=>{
        var { parser: parser } = _ref2;
        var body = args[0];
        // amsbsy.sty's \boldsymbol uses \binrel spacing to inherit the
        // argument's bin|rel|ord status
        return {
            type: "mclass",
            mode: parser.mode,
            mclass: $ef0731f441f79e9a$var$binrelClass(body),
            body: [
                {
                    type: "font",
                    mode: parser.mode,
                    font: "boldsymbol",
                    body: body
                }
            ],
            isCharacterBox: $ef0731f441f79e9a$var$isCharacterBox(body)
        };
    }
});
// Old font changing functions
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "font",
    names: [
        "\\rm",
        "\\sf",
        "\\tt",
        "\\bf",
        "\\it",
        "\\cal"
    ],
    props: {
        numArgs: 0,
        allowedInText: true
    },
    handler: (_ref3, args)=>{
        var { parser: parser, funcName: funcName, breakOnTokenText: breakOnTokenText } = _ref3;
        var { mode: mode } = parser;
        var body = parser.parseExpression(true, breakOnTokenText);
        return {
            type: "font",
            mode: mode,
            font: "math" + funcName.slice(1),
            body: {
                type: "ordgroup",
                mode: parser.mode,
                body: body
            }
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$5,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$4
});
var $ef0731f441f79e9a$var$htmlBuilder$4 = (group, options)=>{
    // Fractions are handled in the TeXbook on pages 444-445, rules 15(a-e).
    var style = options.style;
    var nstyle = style.fracNum();
    var dstyle = style.fracDen();
    var newOptions;
    newOptions = options.havingStyle(nstyle);
    var numerm = $ef0731f441f79e9a$var$buildGroup$1(group.numer, newOptions, options);
    if (group.continued) {
        // \cfrac inserts a \strut into the numerator.
        // Get \strut dimensions from TeXbook page 353.
        var hStrut = 8.5 / options.fontMetrics().ptPerEm;
        var dStrut = 3.5 / options.fontMetrics().ptPerEm;
        numerm.height = numerm.height < hStrut ? hStrut : numerm.height;
        numerm.depth = numerm.depth < dStrut ? dStrut : numerm.depth;
    }
    newOptions = options.havingStyle(dstyle);
    var denomm = $ef0731f441f79e9a$var$buildGroup$1(group.denom, newOptions, options);
    var rule;
    var ruleWidth;
    var ruleSpacing;
    if (group.hasBarLine) {
        if (group.barSize) {
            ruleWidth = $ef0731f441f79e9a$var$calculateSize(group.barSize, options);
            rule = $ef0731f441f79e9a$var$makeLineSpan("frac-line", options, ruleWidth);
        } else rule = $ef0731f441f79e9a$var$makeLineSpan("frac-line", options);
        ruleWidth = rule.height;
        ruleSpacing = rule.height;
    } else {
        rule = null;
        ruleWidth = 0;
        ruleSpacing = options.fontMetrics().defaultRuleThickness;
    }
    // Rule 15b
    var numShift;
    var clearance;
    var denomShift;
    if (style.size === $ef0731f441f79e9a$var$Style$1.DISPLAY.size) {
        numShift = options.fontMetrics().num1;
        if (ruleWidth > 0) clearance = 3 * ruleSpacing;
        else clearance = 7 * ruleSpacing;
        denomShift = options.fontMetrics().denom1;
    } else {
        if (ruleWidth > 0) {
            numShift = options.fontMetrics().num2;
            clearance = ruleSpacing;
        } else {
            numShift = options.fontMetrics().num3;
            clearance = 3 * ruleSpacing;
        }
        denomShift = options.fontMetrics().denom2;
    }
    var frac;
    if (!rule) {
        // Rule 15c
        var candidateClearance = numShift - numerm.depth - (denomm.height - denomShift);
        if (candidateClearance < clearance) {
            numShift += 0.5 * (clearance - candidateClearance);
            denomShift += 0.5 * (clearance - candidateClearance);
        }
        frac = $ef0731f441f79e9a$var$makeVList({
            positionType: "individualShift",
            children: [
                {
                    type: "elem",
                    elem: denomm,
                    shift: denomShift
                },
                {
                    type: "elem",
                    elem: numerm,
                    shift: -numShift
                }
            ]
        });
    } else {
        // Rule 15d
        var axisHeight = options.fontMetrics().axisHeight;
        if (numShift - numerm.depth - (axisHeight + 0.5 * ruleWidth) < clearance) numShift += clearance - (numShift - numerm.depth - (axisHeight + 0.5 * ruleWidth));
        if (axisHeight - 0.5 * ruleWidth - (denomm.height - denomShift) < clearance) denomShift += clearance - (axisHeight - 0.5 * ruleWidth - (denomm.height - denomShift));
        var midShift = -(axisHeight - 0.5 * ruleWidth);
        frac = $ef0731f441f79e9a$var$makeVList({
            positionType: "individualShift",
            children: [
                {
                    type: "elem",
                    elem: denomm,
                    shift: denomShift
                },
                {
                    type: "elem",
                    elem: rule,
                    shift: midShift
                },
                {
                    type: "elem",
                    elem: numerm,
                    shift: -numShift
                }
            ]
        });
    }
    // Since we manually change the style sometimes (with \dfrac or \tfrac),
    // account for the possible size change here.
    newOptions = options.havingStyle(style);
    frac.height *= newOptions.sizeMultiplier / options.sizeMultiplier;
    frac.depth *= newOptions.sizeMultiplier / options.sizeMultiplier;
    // Rule 15e
    var delimSize;
    if (style.size === $ef0731f441f79e9a$var$Style$1.DISPLAY.size) delimSize = options.fontMetrics().delim1;
    else if (style.size === $ef0731f441f79e9a$var$Style$1.SCRIPTSCRIPT.size) delimSize = options.havingStyle($ef0731f441f79e9a$var$Style$1.SCRIPT).fontMetrics().delim2;
    else delimSize = options.fontMetrics().delim2;
    var leftDelim;
    var rightDelim;
    if (group.leftDelim == null) leftDelim = $ef0731f441f79e9a$var$makeNullDelimiter(options, [
        "mopen"
    ]);
    else leftDelim = $ef0731f441f79e9a$var$makeCustomSizedDelim(group.leftDelim, delimSize, true, options.havingStyle(style), group.mode, [
        "mopen"
    ]);
    if (group.continued) rightDelim = $ef0731f441f79e9a$var$makeSpan([]); // zero width for \cfrac
    else if (group.rightDelim == null) rightDelim = $ef0731f441f79e9a$var$makeNullDelimiter(options, [
        "mclose"
    ]);
    else rightDelim = $ef0731f441f79e9a$var$makeCustomSizedDelim(group.rightDelim, delimSize, true, options.havingStyle(style), group.mode, [
        "mclose"
    ]);
    return $ef0731f441f79e9a$var$makeSpan([
        "mord"
    ].concat(newOptions.sizingClasses(options)), [
        leftDelim,
        $ef0731f441f79e9a$var$makeSpan([
            "mfrac"
        ], [
            frac
        ]),
        rightDelim
    ], options);
};
var $ef0731f441f79e9a$var$mathmlBuilder$3 = (group, options)=>{
    var node = new $ef0731f441f79e9a$var$MathNode("mfrac", [
        $ef0731f441f79e9a$var$buildGroup(group.numer, options),
        $ef0731f441f79e9a$var$buildGroup(group.denom, options)
    ]);
    if (!group.hasBarLine) node.setAttribute("linethickness", "0px");
    else if (group.barSize) {
        var ruleWidth = $ef0731f441f79e9a$var$calculateSize(group.barSize, options);
        node.setAttribute("linethickness", $ef0731f441f79e9a$var$makeEm(ruleWidth));
    }
    if (group.leftDelim != null || group.rightDelim != null) {
        var withDelims = [];
        if (group.leftDelim != null) {
            var leftOp = new $ef0731f441f79e9a$var$MathNode("mo", [
                new $ef0731f441f79e9a$var$TextNode(group.leftDelim.replace("\\", ""))
            ]);
            leftOp.setAttribute("fence", "true");
            withDelims.push(leftOp);
        }
        withDelims.push(node);
        if (group.rightDelim != null) {
            var rightOp = new $ef0731f441f79e9a$var$MathNode("mo", [
                new $ef0731f441f79e9a$var$TextNode(group.rightDelim.replace("\\", ""))
            ]);
            rightOp.setAttribute("fence", "true");
            withDelims.push(rightOp);
        }
        return $ef0731f441f79e9a$var$makeRow(withDelims);
    }
    return node;
};
var $ef0731f441f79e9a$var$wrapWithStyle = (frac, style)=>{
    if (!style) return frac;
    var wrapper = {
        type: "styling",
        mode: frac.mode,
        style: style,
        body: [
            frac
        ]
    };
    // @ts-ignore defineFunction handler needs to return ParseNode<"genfrac">
    return wrapper;
};
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "genfrac",
    names: [
        "\\cfrac",
        "\\dfrac",
        "\\frac",
        "\\tfrac",
        "\\dbinom",
        "\\binom",
        "\\tbinom",
        "\\\\atopfrac",
        // can’t be entered directly
        "\\\\bracefrac",
        "\\\\brackfrac" // ditto
    ],
    props: {
        numArgs: 2,
        allowedInArgument: true
    },
    handler: (_ref, args)=>{
        var { parser: parser, funcName: funcName } = _ref;
        var numer = args[0];
        var denom = args[1];
        var hasBarLine;
        var leftDelim = null;
        var rightDelim = null;
        switch(funcName){
            case "\\cfrac":
            case "\\dfrac":
            case "\\frac":
            case "\\tfrac":
                hasBarLine = true;
                break;
            case "\\\\atopfrac":
                hasBarLine = false;
                break;
            case "\\dbinom":
            case "\\binom":
            case "\\tbinom":
                hasBarLine = false;
                leftDelim = "(";
                rightDelim = ")";
                break;
            case "\\\\bracefrac":
                hasBarLine = false;
                leftDelim = "\\{";
                rightDelim = "\\}";
                break;
            case "\\\\brackfrac":
                hasBarLine = false;
                leftDelim = "[";
                rightDelim = "]";
                break;
            default:
                throw new Error("Unrecognized genfrac command");
        }
        var continued = funcName === "\\cfrac";
        var style = null;
        if (continued || funcName.startsWith("\\d")) style = "display";
        else if (funcName.startsWith("\\t")) style = "text";
        return $ef0731f441f79e9a$var$wrapWithStyle({
            type: "genfrac",
            mode: parser.mode,
            numer: numer,
            denom: denom,
            continued: continued,
            hasBarLine: hasBarLine,
            leftDelim: leftDelim,
            rightDelim: rightDelim,
            barSize: null
        }, style);
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$4,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$3
});
// Infix generalized fractions -- these are not rendered directly, but replaced
// immediately by one of the variants above.
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "infix",
    names: [
        "\\over",
        "\\choose",
        "\\atop",
        "\\brace",
        "\\brack"
    ],
    props: {
        numArgs: 0,
        infix: true
    },
    handler (_ref2) {
        var { parser: parser, funcName: funcName, token: token } = _ref2;
        var replaceWith;
        switch(funcName){
            case "\\over":
                replaceWith = "\\frac";
                break;
            case "\\choose":
                replaceWith = "\\binom";
                break;
            case "\\atop":
                replaceWith = "\\\\atopfrac";
                break;
            case "\\brace":
                replaceWith = "\\\\bracefrac";
                break;
            case "\\brack":
                replaceWith = "\\\\brackfrac";
                break;
            default:
                throw new Error("Unrecognized infix genfrac command");
        }
        return {
            type: "infix",
            mode: parser.mode,
            replaceWith: replaceWith,
            token: token
        };
    }
});
var $ef0731f441f79e9a$var$stylArray = [
    "display",
    "text",
    "script",
    "scriptscript"
];
var $ef0731f441f79e9a$var$delimFromValue = function delimFromValue(delimString) {
    var delim = null;
    if (delimString.length > 0) {
        delim = delimString;
        delim = delim === "." ? null : delim;
    }
    return delim;
};
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "genfrac",
    names: [
        "\\genfrac"
    ],
    props: {
        numArgs: 6,
        allowedInArgument: true,
        argTypes: [
            "math",
            "math",
            "size",
            "text",
            "math",
            "math"
        ]
    },
    handler (_ref3, args) {
        var { parser: parser } = _ref3;
        var numer = args[4];
        var denom = args[5];
        // Look into the parse nodes to get the desired delimiters.
        var leftNode = $ef0731f441f79e9a$var$normalizeArgument(args[0]);
        var leftDelim = leftNode.type === "atom" && leftNode.family === "open" ? $ef0731f441f79e9a$var$delimFromValue(leftNode.text) : null;
        var rightNode = $ef0731f441f79e9a$var$normalizeArgument(args[1]);
        var rightDelim = rightNode.type === "atom" && rightNode.family === "close" ? $ef0731f441f79e9a$var$delimFromValue(rightNode.text) : null;
        var barNode = $ef0731f441f79e9a$var$assertNodeType(args[2], "size");
        var hasBarLine;
        var barSize = null;
        if (barNode.isBlank) // \genfrac acts differently than \above.
        // \genfrac treats an empty size group as a signal to use a
        // standard bar size. \above would see size = 0 and omit the bar.
        hasBarLine = true;
        else {
            barSize = barNode.value;
            hasBarLine = barSize.number > 0;
        }
        // Find out if we want displaystyle, textstyle, etc.
        var size = null;
        var styl = args[3];
        if (styl.type === "ordgroup") {
            if (styl.body.length > 0) {
                var textOrd = $ef0731f441f79e9a$var$assertNodeType(styl.body[0], "textord");
                size = $ef0731f441f79e9a$var$stylArray[Number(textOrd.text)];
            }
        } else {
            styl = $ef0731f441f79e9a$var$assertNodeType(styl, "textord");
            size = $ef0731f441f79e9a$var$stylArray[Number(styl.text)];
        }
        return $ef0731f441f79e9a$var$wrapWithStyle({
            type: "genfrac",
            mode: parser.mode,
            numer: numer,
            denom: denom,
            continued: false,
            hasBarLine: hasBarLine,
            barSize: barSize,
            leftDelim: leftDelim,
            rightDelim: rightDelim
        }, size);
    }
});
// \above is an infix fraction that also defines a fraction bar size.
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "infix",
    names: [
        "\\above"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "size"
        ],
        infix: true
    },
    handler (_ref4, args) {
        var { parser: parser, funcName: funcName, token: token } = _ref4;
        return {
            type: "infix",
            mode: parser.mode,
            replaceWith: "\\\\abovefrac",
            size: $ef0731f441f79e9a$var$assertNodeType(args[0], "size").value,
            token: token
        };
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "genfrac",
    names: [
        "\\\\abovefrac"
    ],
    props: {
        numArgs: 3,
        argTypes: [
            "math",
            "size",
            "math"
        ]
    },
    handler: (_ref5, args)=>{
        var { parser: parser, funcName: funcName } = _ref5;
        var numer = args[0];
        var barSize = $ef0731f441f79e9a$var$assertNodeType(args[1], "infix").size;
        if (!barSize) throw new Error("\\\\abovefrac expected size, but got " + String(barSize));
        var denom = args[2];
        var hasBarLine = barSize.number > 0;
        return {
            type: "genfrac",
            mode: parser.mode,
            numer: numer,
            denom: denom,
            continued: false,
            hasBarLine: hasBarLine,
            barSize: barSize,
            leftDelim: null,
            rightDelim: null
        };
    }
});
// NOTE: Unlike most `htmlBuilder`s, this one handles not only "horizBrace", but
// also "supsub" since an over/underbrace can affect super/subscripting.
var $ef0731f441f79e9a$var$htmlBuilder$3 = (grp, options)=>{
    var style = options.style;
    // Pull out the `ParseNode<"horizBrace">` if `grp` is a "supsub" node.
    var supSubGroup;
    var group;
    if (grp.type === "supsub") {
        // Ref: LaTeX source2e: }}}}\limits}
        // i.e. LaTeX treats the brace similar to an op and passes it
        // with \limits, so we need to assign supsub style.
        supSubGroup = grp.sup ? $ef0731f441f79e9a$var$buildGroup$1(grp.sup, options.havingStyle(style.sup()), options) : $ef0731f441f79e9a$var$buildGroup$1(grp.sub, options.havingStyle(style.sub()), options);
        group = $ef0731f441f79e9a$var$assertNodeType(grp.base, "horizBrace");
    } else group = $ef0731f441f79e9a$var$assertNodeType(grp, "horizBrace");
    // Build the base group
    var body = $ef0731f441f79e9a$var$buildGroup$1(group.base, options.havingBaseStyle($ef0731f441f79e9a$var$Style$1.DISPLAY));
    // Create the stretchy element
    var braceBody = $ef0731f441f79e9a$var$stretchySvg(group, options);
    // Generate the vlist, with the appropriate kerns        ┏━━━━━━━━┓
    // This first vlist contains the content and the brace:   equation
    var vlist;
    if (group.isOver) vlist = $ef0731f441f79e9a$var$makeVList({
        positionType: "firstBaseline",
        children: [
            {
                type: "elem",
                elem: body
            },
            {
                type: "kern",
                size: 0.1
            },
            {
                type: "elem",
                elem: braceBody,
                wrapperClasses: [
                    "svg-align"
                ]
            }
        ]
    });
    else vlist = $ef0731f441f79e9a$var$makeVList({
        positionType: "bottom",
        positionData: body.depth + 0.1 + braceBody.height,
        children: [
            {
                type: "elem",
                elem: braceBody,
                wrapperClasses: [
                    "svg-align"
                ]
            },
            {
                type: "kern",
                size: 0.1
            },
            {
                type: "elem",
                elem: body
            }
        ]
    });
    if (supSubGroup) {
        // To write the supsub, wrap the first vlist in another vlist:
        // They can't all go in the same vlist, because the note might be
        // wider than the equation. We want the equation to control the
        // brace width.
        //      note          long note           long note
        //   ┏━━━━━━━━┓   or    ┏━━━┓     not    ┏━━━━━━━━━┓
        //    equation           eqn                 eqn
        var vSpan = $ef0731f441f79e9a$var$makeSpan([
            "minner",
            group.isOver ? "mover" : "munder"
        ], [
            vlist
        ], options);
        if (group.isOver) vlist = $ef0731f441f79e9a$var$makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: vSpan
                },
                {
                    type: "kern",
                    size: 0.2
                },
                {
                    type: "elem",
                    elem: supSubGroup
                }
            ]
        });
        else vlist = $ef0731f441f79e9a$var$makeVList({
            positionType: "bottom",
            positionData: vSpan.depth + 0.2 + supSubGroup.height + supSubGroup.depth,
            children: [
                {
                    type: "elem",
                    elem: supSubGroup
                },
                {
                    type: "kern",
                    size: 0.2
                },
                {
                    type: "elem",
                    elem: vSpan
                }
            ]
        });
    }
    return $ef0731f441f79e9a$var$makeSpan([
        "minner",
        group.isOver ? "mover" : "munder"
    ], [
        vlist
    ], options);
};
var $ef0731f441f79e9a$var$mathmlBuilder$2 = (group, options)=>{
    var accentNode = $ef0731f441f79e9a$var$stretchyMathML(group.label);
    return new $ef0731f441f79e9a$var$MathNode(group.isOver ? "mover" : "munder", [
        $ef0731f441f79e9a$var$buildGroup(group.base, options),
        accentNode
    ]);
};
// Horizontal stretchy braces
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "horizBrace",
    names: [
        "\\overbrace",
        "\\underbrace",
        "\\overbracket",
        "\\underbracket"
    ],
    props: {
        numArgs: 1
    },
    handler (_ref, args) {
        var { parser: parser, funcName: funcName } = _ref;
        return {
            type: "horizBrace",
            mode: parser.mode,
            label: funcName,
            isOver: funcName.includes("\\over"),
            base: args[0]
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$3,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$2
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "href",
    names: [
        "\\href"
    ],
    props: {
        numArgs: 2,
        argTypes: [
            "url",
            "original"
        ],
        allowedInText: true
    },
    handler: (_ref, args)=>{
        var { parser: parser } = _ref;
        var body = args[1];
        var href = $ef0731f441f79e9a$var$assertNodeType(args[0], "url").url;
        if (!parser.settings.isTrusted({
            command: "\\href",
            url: href
        })) return parser.formatUnsupportedCmd("\\href");
        return {
            type: "href",
            mode: parser.mode,
            href: href,
            body: $ef0731f441f79e9a$var$ordargument(body)
        };
    },
    htmlBuilder: (group, options)=>{
        var elements = $ef0731f441f79e9a$var$buildExpression$1(group.body, options, false);
        return $ef0731f441f79e9a$var$makeAnchor(group.href, [], elements, options);
    },
    mathmlBuilder: (group, options)=>{
        var math = $ef0731f441f79e9a$var$buildExpressionRow(group.body, options);
        if (!(math instanceof $ef0731f441f79e9a$var$MathNode)) math = new $ef0731f441f79e9a$var$MathNode("mrow", [
            math
        ]);
        math.setAttribute("href", group.href);
        return math;
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "href",
    names: [
        "\\url"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "url"
        ],
        allowedInText: true
    },
    handler: (_ref2, args)=>{
        var { parser: parser } = _ref2;
        var href = $ef0731f441f79e9a$var$assertNodeType(args[0], "url").url;
        if (!parser.settings.isTrusted({
            command: "\\url",
            url: href
        })) return parser.formatUnsupportedCmd("\\url");
        var chars = [];
        for(var i = 0; i < href.length; i++){
            var c = href[i];
            if (c === "~") c = "\\textasciitilde";
            chars.push({
                type: "textord",
                mode: "text",
                text: c
            });
        }
        var body = {
            type: "text",
            mode: parser.mode,
            font: "\\texttt",
            body: chars
        };
        return {
            type: "href",
            mode: parser.mode,
            href: href,
            body: $ef0731f441f79e9a$var$ordargument(body)
        };
    }
});
// \hbox is provided for compatibility with LaTeX \vcenter.
// In LaTeX, \vcenter can act only on a box, as in
// \vcenter{\hbox{$\frac{a+b}{\dfrac{c}{d}}$}}
// This function by itself doesn't do anything but prevent a soft line break.
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "hbox",
    names: [
        "\\hbox"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "text"
        ],
        allowedInText: true,
        primitive: true
    },
    handler (_ref, args) {
        var { parser: parser } = _ref;
        return {
            type: "hbox",
            mode: parser.mode,
            body: $ef0731f441f79e9a$var$ordargument(args[0])
        };
    },
    htmlBuilder (group, options) {
        var elements = $ef0731f441f79e9a$var$buildExpression$1(group.body, options.withFont(''), false);
        return $ef0731f441f79e9a$var$makeFragment(elements);
    },
    mathmlBuilder (group, options) {
        return new $ef0731f441f79e9a$var$MathNode("mrow", $ef0731f441f79e9a$var$buildExpression(group.body, options.withFont('')));
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "html",
    names: [
        "\\htmlClass",
        "\\htmlId",
        "\\htmlStyle",
        "\\htmlData"
    ],
    props: {
        numArgs: 2,
        argTypes: [
            "raw",
            "original"
        ],
        allowedInText: true
    },
    handler: (_ref, args)=>{
        var { parser: parser, funcName: funcName, token: token } = _ref;
        var value = $ef0731f441f79e9a$var$assertNodeType(args[0], "raw").string;
        var body = args[1];
        if (parser.settings.strict) parser.settings.reportNonstrict("htmlExtension", "HTML extension is disabled on strict mode");
        var trustContext;
        var attributes = {};
        switch(funcName){
            case "\\htmlClass":
                attributes.class = value;
                trustContext = {
                    command: "\\htmlClass",
                    class: value
                };
                break;
            case "\\htmlId":
                attributes.id = value;
                trustContext = {
                    command: "\\htmlId",
                    id: value
                };
                break;
            case "\\htmlStyle":
                attributes.style = value;
                trustContext = {
                    command: "\\htmlStyle",
                    style: value
                };
                break;
            case "\\htmlData":
                var data = value.split(",");
                for(var i = 0; i < data.length; i++){
                    var item = data[i];
                    var firstEquals = item.indexOf("=");
                    if (firstEquals < 0) throw new $ef0731f441f79e9a$export$f9c837a54db411d("\\htmlData key/value '" + item + "'" + " missing equals sign");
                    var key = item.slice(0, firstEquals);
                    var _value = item.slice(firstEquals + 1);
                    attributes["data-" + key.trim()] = _value;
                }
                trustContext = {
                    command: "\\htmlData",
                    attributes: attributes
                };
                break;
            default:
                throw new Error("Unrecognized html command");
        }
        if (!parser.settings.isTrusted(trustContext)) return parser.formatUnsupportedCmd(funcName);
        return {
            type: "html",
            mode: parser.mode,
            attributes: attributes,
            body: $ef0731f441f79e9a$var$ordargument(body)
        };
    },
    htmlBuilder: (group, options)=>{
        var elements = $ef0731f441f79e9a$var$buildExpression$1(group.body, options, false);
        var classes = [
            "enclosing"
        ];
        if (group.attributes.class) classes.push(...group.attributes.class.trim().split(/\s+/));
        var span = $ef0731f441f79e9a$var$makeSpan(classes, elements, options);
        for(var attr in group.attributes)if (attr !== "class" && group.attributes.hasOwnProperty(attr)) span.setAttribute(attr, group.attributes[attr]);
        return span;
    },
    mathmlBuilder: (group, options)=>{
        return $ef0731f441f79e9a$var$buildExpressionRow(group.body, options);
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "htmlmathml",
    names: [
        "\\html@mathml"
    ],
    props: {
        numArgs: 2,
        allowedInArgument: true,
        allowedInText: true
    },
    handler: (_ref, args)=>{
        var { parser: parser } = _ref;
        return {
            type: "htmlmathml",
            mode: parser.mode,
            html: $ef0731f441f79e9a$var$ordargument(args[0]),
            mathml: $ef0731f441f79e9a$var$ordargument(args[1])
        };
    },
    htmlBuilder: (group, options)=>{
        var elements = $ef0731f441f79e9a$var$buildExpression$1(group.html, options, false);
        return $ef0731f441f79e9a$var$makeFragment(elements);
    },
    mathmlBuilder: (group, options)=>{
        return $ef0731f441f79e9a$var$buildExpressionRow(group.mathml, options);
    }
});
var $ef0731f441f79e9a$var$sizeData = function sizeData(str) {
    if (/^[-+]? *(\d+(\.\d*)?|\.\d+)$/.test(str)) // str is a number with no unit specified.
    // default unit is bp, per graphix package.
    return {
        number: +str,
        unit: "bp"
    };
    else {
        var match = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(str);
        if (!match) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid size: '" + str + "' in \\includegraphics");
        var data = {
            number: +(match[1] + match[2]),
            // sign + magnitude, cast to number
            unit: match[3]
        };
        if (!$ef0731f441f79e9a$var$validUnit(data)) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid unit: '" + data.unit + "' in \\includegraphics.");
        return data;
    }
};
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "includegraphics",
    names: [
        "\\includegraphics"
    ],
    props: {
        numArgs: 1,
        numOptionalArgs: 1,
        argTypes: [
            "raw",
            "url"
        ],
        allowedInText: false
    },
    handler: (_ref, args, optArgs)=>{
        var { parser: parser } = _ref;
        var width = {
            number: 0,
            unit: "em"
        };
        var height = {
            number: 0.9,
            unit: "em"
        }; // sorta character sized.
        var totalheight = {
            number: 0,
            unit: "em"
        };
        var alt = "";
        if (optArgs[0]) {
            var attributeStr = $ef0731f441f79e9a$var$assertNodeType(optArgs[0], "raw").string;
            // Parser.js does not parse key/value pairs. We get a string.
            var attributes = attributeStr.split(",");
            for(var i = 0; i < attributes.length; i++){
                var keyVal = attributes[i].split("=");
                if (keyVal.length === 2) {
                    var str = keyVal[1].trim();
                    switch(keyVal[0].trim()){
                        case "alt":
                            alt = str;
                            break;
                        case "width":
                            width = $ef0731f441f79e9a$var$sizeData(str);
                            break;
                        case "height":
                            height = $ef0731f441f79e9a$var$sizeData(str);
                            break;
                        case "totalheight":
                            totalheight = $ef0731f441f79e9a$var$sizeData(str);
                            break;
                        default:
                            throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid key: '" + keyVal[0] + "' in \\includegraphics.");
                    }
                }
            }
        }
        var src = $ef0731f441f79e9a$var$assertNodeType(args[0], "url").url;
        if (alt === "") {
            // No alt given. Use the file name. Strip away the path.
            alt = src;
            alt = alt.replace(/^.*[\\/]/, '');
            alt = alt.substring(0, alt.lastIndexOf('.'));
        }
        if (!parser.settings.isTrusted({
            command: "\\includegraphics",
            url: src
        })) return parser.formatUnsupportedCmd("\\includegraphics");
        return {
            type: "includegraphics",
            mode: parser.mode,
            alt: alt,
            width: width,
            height: height,
            totalheight: totalheight,
            src: src
        };
    },
    htmlBuilder: (group, options)=>{
        var height = $ef0731f441f79e9a$var$calculateSize(group.height, options);
        var depth = 0;
        if (group.totalheight.number > 0) depth = $ef0731f441f79e9a$var$calculateSize(group.totalheight, options) - height;
        var width = 0;
        if (group.width.number > 0) width = $ef0731f441f79e9a$var$calculateSize(group.width, options);
        var style = {
            height: $ef0731f441f79e9a$var$makeEm(height + depth)
        };
        if (width > 0) style.width = $ef0731f441f79e9a$var$makeEm(width);
        if (depth > 0) style.verticalAlign = $ef0731f441f79e9a$var$makeEm(-depth);
        var node = new $ef0731f441f79e9a$var$Img(group.src, group.alt, style);
        node.height = height;
        node.depth = depth;
        return node;
    },
    mathmlBuilder: (group, options)=>{
        var node = new $ef0731f441f79e9a$var$MathNode("mglyph", []);
        node.setAttribute("alt", group.alt);
        var height = $ef0731f441f79e9a$var$calculateSize(group.height, options);
        var depth = 0;
        if (group.totalheight.number > 0) {
            depth = $ef0731f441f79e9a$var$calculateSize(group.totalheight, options) - height;
            node.setAttribute("valign", $ef0731f441f79e9a$var$makeEm(-depth));
        }
        node.setAttribute("height", $ef0731f441f79e9a$var$makeEm(height + depth));
        if (group.width.number > 0) {
            var width = $ef0731f441f79e9a$var$calculateSize(group.width, options);
            node.setAttribute("width", $ef0731f441f79e9a$var$makeEm(width));
        }
        node.setAttribute("src", group.src);
        return node;
    }
});
// Horizontal spacing commands
// TODO: \hskip and \mskip should support plus and minus in lengths
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "kern",
    names: [
        "\\kern",
        "\\mkern",
        "\\hskip",
        "\\mskip"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "size"
        ],
        primitive: true,
        allowedInText: true
    },
    handler (_ref, args) {
        var { parser: parser, funcName: funcName } = _ref;
        var size = $ef0731f441f79e9a$var$assertNodeType(args[0], "size");
        if (parser.settings.strict) {
            var mathFunction = funcName[1] === 'm'; // \mkern, \mskip
            var muUnit = size.value.unit === 'mu';
            if (mathFunction) {
                if (!muUnit) parser.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + funcName + " supports only mu units, " + ("not " + size.value.unit + " units"));
                if (parser.mode !== "math") parser.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + funcName + " works only in math mode");
            } else // !mathFunction
            if (muUnit) parser.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + funcName + " doesn't support mu units");
        }
        return {
            type: "kern",
            mode: parser.mode,
            dimension: size.value
        };
    },
    htmlBuilder (group, options) {
        return $ef0731f441f79e9a$var$makeGlue(group.dimension, options);
    },
    mathmlBuilder (group, options) {
        var dimension = $ef0731f441f79e9a$var$calculateSize(group.dimension, options);
        return new $ef0731f441f79e9a$var$SpaceNode(dimension);
    }
});
// Horizontal overlap functions
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "lap",
    names: [
        "\\mathllap",
        "\\mathrlap",
        "\\mathclap"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler: (_ref, args)=>{
        var { parser: parser, funcName: funcName } = _ref;
        var body = args[0];
        return {
            type: "lap",
            mode: parser.mode,
            alignment: funcName.slice(5),
            body: body
        };
    },
    htmlBuilder: (group, options)=>{
        // mathllap, mathrlap, mathclap
        var inner;
        if (group.alignment === "clap") {
            // ref: https://www.math.lsu.edu/~aperlis/publications/mathclap/
            inner = $ef0731f441f79e9a$var$makeSpan([], [
                $ef0731f441f79e9a$var$buildGroup$1(group.body, options)
            ]);
            // wrap, since CSS will center a .clap > .inner > span
            inner = $ef0731f441f79e9a$var$makeSpan([
                "inner"
            ], [
                inner
            ], options);
        } else inner = $ef0731f441f79e9a$var$makeSpan([
            "inner"
        ], [
            $ef0731f441f79e9a$var$buildGroup$1(group.body, options)
        ]);
        var fix = $ef0731f441f79e9a$var$makeSpan([
            "fix"
        ], []);
        var node = $ef0731f441f79e9a$var$makeSpan([
            group.alignment
        ], [
            inner,
            fix
        ], options);
        // At this point, we have correctly set horizontal alignment of the
        // two items involved in the lap.
        // Next, use a strut to set the height of the HTML bounding box.
        // Otherwise, a tall argument may be misplaced.
        // This code resolved issue #1153
        var strut = $ef0731f441f79e9a$var$makeSpan([
            "strut"
        ]);
        strut.style.height = $ef0731f441f79e9a$var$makeEm(node.height + node.depth);
        if (node.depth) strut.style.verticalAlign = $ef0731f441f79e9a$var$makeEm(-node.depth);
        node.children.unshift(strut);
        // Next, prevent vertical misplacement when next to something tall.
        // This code resolves issue #1234
        node = $ef0731f441f79e9a$var$makeSpan([
            "thinbox"
        ], [
            node
        ], options);
        return $ef0731f441f79e9a$var$makeSpan([
            "mord",
            "vbox"
        ], [
            node
        ], options);
    },
    mathmlBuilder: (group, options)=>{
        // mathllap, mathrlap, mathclap
        var node = new $ef0731f441f79e9a$var$MathNode("mpadded", [
            $ef0731f441f79e9a$var$buildGroup(group.body, options)
        ]);
        if (group.alignment !== "rlap") {
            var offset = group.alignment === "llap" ? "-1" : "-0.5";
            node.setAttribute("lspace", offset + "width");
        }
        node.setAttribute("width", "0px");
        return node;
    }
});
// Switching from text mode back to math mode
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "styling",
    names: [
        "\\(",
        "$"
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        allowedInMath: false
    },
    handler (_ref, args) {
        var { funcName: funcName, parser: parser } = _ref;
        var outerMode = parser.mode;
        parser.switchMode("math");
        var close = funcName === "\\(" ? "\\)" : "$";
        var body = parser.parseExpression(false, close);
        parser.expect(close);
        parser.switchMode(outerMode);
        return {
            type: "styling",
            mode: parser.mode,
            style: "text",
            resetFont: true,
            body: body
        };
    }
});
// Check for extra closing math delimiters
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "text",
    // Doesn't matter what this is.
    names: [
        "\\)",
        "\\]"
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        allowedInMath: false
    },
    handler (context, args) {
        throw new $ef0731f441f79e9a$export$f9c837a54db411d("Mismatched " + context.funcName);
    }
});
var $ef0731f441f79e9a$var$chooseMathStyle = (group, options)=>{
    switch(options.style.size){
        case $ef0731f441f79e9a$var$Style$1.DISPLAY.size:
            return group.display;
        case $ef0731f441f79e9a$var$Style$1.TEXT.size:
            return group.text;
        case $ef0731f441f79e9a$var$Style$1.SCRIPT.size:
            return group.script;
        case $ef0731f441f79e9a$var$Style$1.SCRIPTSCRIPT.size:
            return group.scriptscript;
        default:
            return group.text;
    }
};
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "mathchoice",
    names: [
        "\\mathchoice"
    ],
    props: {
        numArgs: 4,
        primitive: true
    },
    handler: (_ref, args)=>{
        var { parser: parser } = _ref;
        return {
            type: "mathchoice",
            mode: parser.mode,
            display: $ef0731f441f79e9a$var$ordargument(args[0]),
            text: $ef0731f441f79e9a$var$ordargument(args[1]),
            script: $ef0731f441f79e9a$var$ordargument(args[2]),
            scriptscript: $ef0731f441f79e9a$var$ordargument(args[3])
        };
    },
    htmlBuilder: (group, options)=>{
        var body = $ef0731f441f79e9a$var$chooseMathStyle(group, options);
        var elements = $ef0731f441f79e9a$var$buildExpression$1(body, options, false);
        return $ef0731f441f79e9a$var$makeFragment(elements);
    },
    mathmlBuilder: (group, options)=>{
        var body = $ef0731f441f79e9a$var$chooseMathStyle(group, options);
        return $ef0731f441f79e9a$var$buildExpressionRow(body, options);
    }
});
// For an operator with limits, assemble the base, sup, and sub into a span.
var $ef0731f441f79e9a$var$assembleSupSub = (base, supGroup, subGroup, options, style, slant, baseShift)=>{
    base = $ef0731f441f79e9a$var$makeSpan([], [
        base
    ]);
    var subIsSingleCharacter = subGroup && $ef0731f441f79e9a$var$isCharacterBox(subGroup);
    var sub;
    var sup;
    // We manually have to handle the superscripts and subscripts. This,
    // aside from the kern calculations, is copied from supsub.
    if (supGroup) {
        var elem = $ef0731f441f79e9a$var$buildGroup$1(supGroup, options.havingStyle(style.sup()), options);
        sup = {
            elem: elem,
            kern: Math.max(options.fontMetrics().bigOpSpacing1, options.fontMetrics().bigOpSpacing3 - elem.depth)
        };
    }
    if (subGroup) {
        var _elem = $ef0731f441f79e9a$var$buildGroup$1(subGroup, options.havingStyle(style.sub()), options);
        sub = {
            elem: _elem,
            kern: Math.max(options.fontMetrics().bigOpSpacing2, options.fontMetrics().bigOpSpacing4 - _elem.height)
        };
    }
    // Build the final group as a vlist of the possible subscript, base,
    // and possible superscript.
    var finalGroup;
    if (sup && sub) {
        var bottom = options.fontMetrics().bigOpSpacing5 + sub.elem.height + sub.elem.depth + sub.kern + base.depth + baseShift;
        finalGroup = $ef0731f441f79e9a$var$makeVList({
            positionType: "bottom",
            positionData: bottom,
            children: [
                {
                    type: "kern",
                    size: options.fontMetrics().bigOpSpacing5
                },
                {
                    type: "elem",
                    elem: sub.elem,
                    marginLeft: $ef0731f441f79e9a$var$makeEm(-slant)
                },
                {
                    type: "kern",
                    size: sub.kern
                },
                {
                    type: "elem",
                    elem: base
                },
                {
                    type: "kern",
                    size: sup.kern
                },
                {
                    type: "elem",
                    elem: sup.elem,
                    marginLeft: $ef0731f441f79e9a$var$makeEm(slant)
                },
                {
                    type: "kern",
                    size: options.fontMetrics().bigOpSpacing5
                }
            ]
        });
    } else if (sub) {
        var top = base.height - baseShift;
        // Shift the limits by the slant of the symbol. Note
        // that we are supposed to shift the limits by 1/2 of the slant,
        // but since we are centering the limits adding a full slant of
        // margin will shift by 1/2 that.
        finalGroup = $ef0731f441f79e9a$var$makeVList({
            positionType: "top",
            positionData: top,
            children: [
                {
                    type: "kern",
                    size: options.fontMetrics().bigOpSpacing5
                },
                {
                    type: "elem",
                    elem: sub.elem,
                    marginLeft: $ef0731f441f79e9a$var$makeEm(-slant)
                },
                {
                    type: "kern",
                    size: sub.kern
                },
                {
                    type: "elem",
                    elem: base
                }
            ]
        });
    } else if (sup) {
        var _bottom = base.depth + baseShift;
        finalGroup = $ef0731f441f79e9a$var$makeVList({
            positionType: "bottom",
            positionData: _bottom,
            children: [
                {
                    type: "elem",
                    elem: base
                },
                {
                    type: "kern",
                    size: sup.kern
                },
                {
                    type: "elem",
                    elem: sup.elem,
                    marginLeft: $ef0731f441f79e9a$var$makeEm(slant)
                },
                {
                    type: "kern",
                    size: options.fontMetrics().bigOpSpacing5
                }
            ]
        });
    } else // This case probably shouldn't occur (this would mean the
    // supsub was sending us a group with no superscript or
    // subscript) but be safe.
    return base;
    var parts = [
        finalGroup
    ];
    if (sub && slant !== 0 && !subIsSingleCharacter) {
        // A negative margin-left was applied to the lower limit.
        // Avoid an overlap by placing a spacer on the left on the group.
        var spacer = $ef0731f441f79e9a$var$makeSpan([
            "mspace"
        ], [], options);
        spacer.style.marginRight = $ef0731f441f79e9a$var$makeEm(slant);
        parts.unshift(spacer);
    }
    return $ef0731f441f79e9a$var$makeSpan([
        "mop",
        "op-limits"
    ], parts, options);
};
// Limits, symbols
// Most operators have a large successor symbol, but these don't.
var $ef0731f441f79e9a$var$noSuccessor = new Set([
    "\\smallint"
]);
// NOTE: Unlike most `htmlBuilder`s, this one handles not only "op", but also
// "supsub" since some of them (like \int) can affect super/subscripting.
var $ef0731f441f79e9a$var$htmlBuilder$2 = (grp, options)=>{
    // Operators are handled in the TeXbook pg. 443-444, rule 13(a).
    var supGroup;
    var subGroup;
    var hasLimits = false;
    var group;
    if (grp.type === "supsub") {
        // If we have limits, supsub will pass us its group to handle. Pull
        // out the superscript and subscript and set the group to the op in
        // its base.
        supGroup = grp.sup;
        subGroup = grp.sub;
        group = $ef0731f441f79e9a$var$assertNodeType(grp.base, "op");
        hasLimits = true;
    } else group = $ef0731f441f79e9a$var$assertNodeType(grp, "op");
    var style = options.style;
    var large = false;
    if (style.size === $ef0731f441f79e9a$var$Style$1.DISPLAY.size && group.symbol && !$ef0731f441f79e9a$var$noSuccessor.has(group.name)) // Most symbol operators get larger in displaystyle (rule 13)
    large = true;
    var base;
    // Italic correction from the symbol glyph, captured before the symbol
    // may be wrapped in a vlist (for \oiint/\oiiint).  Stays 0 for non-symbol ops.
    var symbolItalic;
    if (group.symbol) {
        // If this is a symbol, create the symbol.
        var fontName = large ? "Size2-Regular" : "Size1-Regular";
        var stash = "";
        if (group.name === "\\oiint" || group.name === "\\oiiint") {
            // No font glyphs yet, so use a glyph w/o the oval.
            // TODO: When font glyphs are available, delete this code.
            stash = group.name.slice(1);
            group.name = stash === "oiint" ? "\\iint" : "\\iiint";
        }
        base = $ef0731f441f79e9a$var$makeSymbol(group.name, fontName, "math", options, [
            "mop",
            "op-symbol",
            large ? "large-op" : "small-op"
        ]);
        symbolItalic = base.italic;
        if (stash.length > 0) {
            // We're in \oiint or \oiiint. Overlay the oval.
            // TODO: When font glyphs are available, delete this code.
            var oval = $ef0731f441f79e9a$var$staticSvg(stash + "Size" + (large ? "2" : "1"), options);
            base = $ef0731f441f79e9a$var$makeVList({
                positionType: "individualShift",
                children: [
                    {
                        type: "elem",
                        elem: base,
                        shift: 0
                    },
                    {
                        type: "elem",
                        elem: oval,
                        shift: large ? 0.08 : 0
                    }
                ]
            });
            group.name = "\\" + stash;
            base.classes.unshift("mop");
            // Carry the italic correction from the original symbol to the
            // vlist wrapper so supsub can use it for subscript positioning.
            base.italic = symbolItalic;
        }
    } else if (group.body) {
        // If this is a list, compose that list.
        var inner = $ef0731f441f79e9a$var$buildExpression$1(group.body, options, true);
        if (inner.length === 1 && inner[0] instanceof $ef0731f441f79e9a$var$SymbolNode) {
            base = inner[0];
            base.classes[0] = "mop"; // replace old mclass
        } else base = $ef0731f441f79e9a$var$makeSpan([
            "mop"
        ], inner, options);
    } else {
        // Otherwise, this is a text operator. Build the text from the
        // operator's name.
        var output = [];
        for(var i = 1; i < group.name.length; i++)output.push($ef0731f441f79e9a$var$mathsym(group.name[i], group.mode, options));
        base = $ef0731f441f79e9a$var$makeSpan([
            "mop"
        ], output, options);
    }
    // If content of op is a single symbol, shift it vertically.
    var baseShift = 0;
    var slant = 0;
    if ((base instanceof $ef0731f441f79e9a$var$SymbolNode || group.name === "\\oiint" || group.name === "\\oiiint") && !group.suppressBaseShift) {
        var _base$italic;
        // We suppress the shift of the base of \overset and \underset. Otherwise,
        // shift the symbol so its center lies on the axis (rule 13). It
        // appears that our fonts have the centers of the symbols already
        // almost on the axis, so these numbers are very small. Note we
        // don't actually apply this here, but instead it is used either in
        // the vlist creation or separately when there are no limits.
        baseShift = (base.height - base.depth) / 2 - options.fontMetrics().axisHeight;
        // The slant of the symbol is just its italic correction.
        // SymbolNode carries .italic natively; Span (for \oiint/\oiiint)
        // only has it set when nonzero, so default to 0.
        slant = (_base$italic = base.italic) != null ? _base$italic : 0;
    }
    if (hasLimits) return $ef0731f441f79e9a$var$assembleSupSub(base, supGroup, subGroup, options, style, slant, baseShift);
    else {
        if (baseShift) {
            base.style.position = "relative";
            base.style.top = $ef0731f441f79e9a$var$makeEm(baseShift);
        }
        return base;
    }
};
var $ef0731f441f79e9a$var$mathmlBuilder$1 = (group, options)=>{
    var node;
    if (group.symbol) {
        // This is a symbol. Just add the symbol.
        node = new $ef0731f441f79e9a$var$MathNode("mo", [
            $ef0731f441f79e9a$var$makeText(group.name, group.mode)
        ]);
        if ($ef0731f441f79e9a$var$noSuccessor.has(group.name)) node.setAttribute("largeop", "false");
    } else if (group.body) // This is an operator with children. Add them.
    node = new $ef0731f441f79e9a$var$MathNode("mo", $ef0731f441f79e9a$var$buildExpression(group.body, options));
    else {
        // This is a text operator. Add all the characters from the
        // operator's name.
        node = new $ef0731f441f79e9a$var$MathNode("mi", [
            new $ef0731f441f79e9a$var$TextNode(group.name.slice(1))
        ]);
        // Append an <mo>&ApplyFunction;</mo>.
        // ref: https://www.w3.org/TR/REC-MathML/chap3_2.html#sec3.2.4
        var operator = new $ef0731f441f79e9a$var$MathNode("mo", [
            $ef0731f441f79e9a$var$makeText("\u2061", "text")
        ]);
        if (group.parentIsSupSub) node = new $ef0731f441f79e9a$var$MathNode("mrow", [
            node,
            operator
        ]);
        else node = $ef0731f441f79e9a$var$newDocumentFragment([
            node,
            operator
        ]);
    }
    return node;
};
var $ef0731f441f79e9a$var$singleCharBigOps = {
    "\u220F": "\\prod",
    "\u2210": "\\coprod",
    "\u2211": "\\sum",
    "\u22c0": "\\bigwedge",
    "\u22c1": "\\bigvee",
    "\u22c2": "\\bigcap",
    "\u22c3": "\\bigcup",
    "\u2a00": "\\bigodot",
    "\u2a01": "\\bigoplus",
    "\u2a02": "\\bigotimes",
    "\u2a04": "\\biguplus",
    "\u2a06": "\\bigsqcup"
};
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "op",
    names: [
        "\\coprod",
        "\\bigvee",
        "\\bigwedge",
        "\\biguplus",
        "\\bigcap",
        "\\bigcup",
        "\\intop",
        "\\prod",
        "\\sum",
        "\\bigotimes",
        "\\bigoplus",
        "\\bigodot",
        "\\bigsqcup",
        "\\smallint",
        "\u220F",
        "\u2210",
        "\u2211",
        "\u22c0",
        "\u22c1",
        "\u22c2",
        "\u22c3",
        "\u2a00",
        "\u2a01",
        "\u2a02",
        "\u2a04",
        "\u2a06"
    ],
    props: {
        numArgs: 0
    },
    handler: (_ref, args)=>{
        var { parser: parser, funcName: funcName } = _ref;
        var fName = funcName;
        if (fName.length === 1) fName = $ef0731f441f79e9a$var$singleCharBigOps[fName];
        return {
            type: "op",
            mode: parser.mode,
            limits: true,
            parentIsSupSub: false,
            symbol: true,
            name: fName
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$2,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$1
});
// Note: calling defineFunction with a type that's already been defined only
// works because the same htmlBuilder and mathmlBuilder are being used.
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "op",
    names: [
        "\\mathop"
    ],
    props: {
        numArgs: 1,
        primitive: true
    },
    handler: (_ref2, args)=>{
        var { parser: parser } = _ref2;
        var body = args[0];
        return {
            type: "op",
            mode: parser.mode,
            limits: false,
            parentIsSupSub: false,
            symbol: false,
            body: $ef0731f441f79e9a$var$ordargument(body)
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$2,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$1
});
// There are 2 flags for operators; whether they produce limits in
// displaystyle, and whether they are symbols and should grow in
// displaystyle. These four groups cover the four possible choices.
var $ef0731f441f79e9a$var$singleCharIntegrals = {
    "\u222b": "\\int",
    "\u222c": "\\iint",
    "\u222d": "\\iiint",
    "\u222e": "\\oint",
    "\u222f": "\\oiint",
    "\u2230": "\\oiiint"
};
// No limits, not symbols
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "op",
    names: [
        "\\arcsin",
        "\\arccos",
        "\\arctan",
        "\\arctg",
        "\\arcctg",
        "\\arg",
        "\\ch",
        "\\cos",
        "\\cosec",
        "\\cosh",
        "\\cot",
        "\\cotg",
        "\\coth",
        "\\csc",
        "\\ctg",
        "\\cth",
        "\\deg",
        "\\dim",
        "\\exp",
        "\\hom",
        "\\ker",
        "\\lg",
        "\\ln",
        "\\log",
        "\\sec",
        "\\sin",
        "\\sinh",
        "\\sh",
        "\\tan",
        "\\tanh",
        "\\tg",
        "\\th"
    ],
    props: {
        numArgs: 0
    },
    handler (_ref3) {
        var { parser: parser, funcName: funcName } = _ref3;
        return {
            type: "op",
            mode: parser.mode,
            limits: false,
            parentIsSupSub: false,
            symbol: false,
            name: funcName
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$2,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$1
});
// Limits, not symbols
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "op",
    names: [
        "\\det",
        "\\gcd",
        "\\inf",
        "\\lim",
        "\\max",
        "\\min",
        "\\Pr",
        "\\sup"
    ],
    props: {
        numArgs: 0
    },
    handler (_ref4) {
        var { parser: parser, funcName: funcName } = _ref4;
        return {
            type: "op",
            mode: parser.mode,
            limits: true,
            parentIsSupSub: false,
            symbol: false,
            name: funcName
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$2,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$1
});
// No limits, symbols
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "op",
    names: [
        "\\int",
        "\\iint",
        "\\iiint",
        "\\oint",
        "\\oiint",
        "\\oiiint",
        "\u222b",
        "\u222c",
        "\u222d",
        "\u222e",
        "\u222f",
        "\u2230"
    ],
    props: {
        numArgs: 0,
        allowedInArgument: true
    },
    handler (_ref5) {
        var { parser: parser, funcName: funcName } = _ref5;
        var fName = funcName;
        if (fName.length === 1) fName = $ef0731f441f79e9a$var$singleCharIntegrals[fName];
        return {
            type: "op",
            mode: parser.mode,
            limits: false,
            parentIsSupSub: false,
            symbol: true,
            name: fName
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$2,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder$1
});
// NOTE: Unlike most `htmlBuilder`s, this one handles not only
// "operatorname", but also  "supsub" since \operatorname* can
// affect super/subscripting.
var $ef0731f441f79e9a$var$htmlBuilder$1 = (grp, options)=>{
    // Operators are handled in the TeXbook pg. 443-444, rule 13(a).
    var supGroup;
    var subGroup;
    var hasLimits = false;
    var group;
    if (grp.type === "supsub") {
        // If we have limits, supsub will pass us its group to handle. Pull
        // out the superscript and subscript and set the group to the op in
        // its base.
        supGroup = grp.sup;
        subGroup = grp.sub;
        group = $ef0731f441f79e9a$var$assertNodeType(grp.base, "operatorname");
        hasLimits = true;
    } else group = $ef0731f441f79e9a$var$assertNodeType(grp, "operatorname");
    var base;
    if (group.body.length > 0) {
        var body = group.body.map((child)=>{
            var childText = "text" in child ? child.text : undefined;
            if (typeof childText === "string") return {
                type: "textord",
                mode: child.mode,
                text: childText
            };
            else return child;
        });
        // Consolidate function names into symbol characters.
        var expression = $ef0731f441f79e9a$var$buildExpression$1(body, options.withFont("mathrm"), true);
        for(var i = 0; i < expression.length; i++){
            var child = expression[i];
            if (child instanceof $ef0731f441f79e9a$var$SymbolNode) // Per amsopn package,
            // change minus to hyphen and \ast to asterisk
            child.text = child.text.replace(/\u2212/, "-").replace(/\u2217/, "*");
        }
        base = $ef0731f441f79e9a$var$makeSpan([
            "mop"
        ], expression, options);
    } else base = $ef0731f441f79e9a$var$makeSpan([
        "mop"
    ], [], options);
    if (hasLimits) return $ef0731f441f79e9a$var$assembleSupSub(base, supGroup, subGroup, options, options.style, 0, 0);
    else return base;
};
var $ef0731f441f79e9a$var$mathmlBuilder = (group, options)=>{
    // The steps taken here are similar to the html version.
    var expression = $ef0731f441f79e9a$var$buildExpression(group.body, options.withFont("mathrm"));
    // Is expression a string or has it something like a fraction?
    var isAllString = true; // default
    for(var i = 0; i < expression.length; i++){
        var node = expression[i];
        if (node instanceof $ef0731f441f79e9a$var$SpaceNode) ;
        else if (node instanceof $ef0731f441f79e9a$var$MathNode) switch(node.type){
            case "mi":
            case "mn":
            case "mspace":
            case "mtext":
                break;
            // Do nothing yet.
            case "mo":
                var child = node.children[0];
                if (node.children.length === 1 && child instanceof $ef0731f441f79e9a$var$TextNode) child.text = child.text.replace(/\u2212/, "-").replace(/\u2217/, "*");
                else isAllString = false;
                break;
            default:
                isAllString = false;
        }
        else isAllString = false;
    }
    if (isAllString) {
        // Write a single TextNode instead of multiple nested tags.
        var word = expression.map((node)=>node.toText()).join("");
        expression = [
            new $ef0731f441f79e9a$var$TextNode(word)
        ];
    }
    var identifier = new $ef0731f441f79e9a$var$MathNode("mi", expression);
    identifier.setAttribute("mathvariant", "normal");
    // \u2061 is the same as &ApplyFunction;
    // ref: https://www.w3schools.com/charsets/ref_html_entities_a.asp
    var operator = new $ef0731f441f79e9a$var$MathNode("mo", [
        $ef0731f441f79e9a$var$makeText("\u2061", "text")
    ]);
    if (group.parentIsSupSub) return new $ef0731f441f79e9a$var$MathNode("mrow", [
        identifier,
        operator
    ]);
    else return $ef0731f441f79e9a$var$newDocumentFragment([
        identifier,
        operator
    ]);
};
// \operatorname
// amsopn.dtx: \mathop{#1\kern\z@\operator@font#3}\newmcodes@
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "operatorname",
    names: [
        "\\operatorname@",
        "\\operatornamewithlimits"
    ],
    props: {
        numArgs: 1
    },
    handler: (_ref, args)=>{
        var { parser: parser, funcName: funcName } = _ref;
        var body = args[0];
        return {
            type: "operatorname",
            mode: parser.mode,
            body: $ef0731f441f79e9a$var$ordargument(body),
            alwaysHandleSupSub: funcName === "\\operatornamewithlimits",
            limits: false,
            parentIsSupSub: false
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder$1,
    mathmlBuilder: $ef0731f441f79e9a$var$mathmlBuilder
});
$ef0731f441f79e9a$export$1c70906d0a09453f("\\operatorname", "\\@ifstar\\operatornamewithlimits\\operatorname@");
$ef0731f441f79e9a$var$defineFunctionBuilders({
    type: "ordgroup",
    htmlBuilder (group, options) {
        if (group.semisimple) return $ef0731f441f79e9a$var$makeFragment($ef0731f441f79e9a$var$buildExpression$1(group.body, options, false));
        return $ef0731f441f79e9a$var$makeSpan([
            "mord"
        ], $ef0731f441f79e9a$var$buildExpression$1(group.body, options, true), options);
    },
    mathmlBuilder (group, options) {
        return $ef0731f441f79e9a$var$buildExpressionRow(group.body, options, true);
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "overline",
    names: [
        "\\overline"
    ],
    props: {
        numArgs: 1
    },
    handler (_ref, args) {
        var { parser: parser } = _ref;
        var body = args[0];
        return {
            type: "overline",
            mode: parser.mode,
            body: body
        };
    },
    htmlBuilder (group, options) {
        // Overlines are handled in the TeXbook pg 443, Rule 9.
        // Build the inner group in the cramped style.
        var innerGroup = $ef0731f441f79e9a$var$buildGroup$1(group.body, options.havingCrampedStyle());
        // Create the line above the body
        var line = $ef0731f441f79e9a$var$makeLineSpan("overline-line", options);
        // Generate the vlist, with the appropriate kerns
        var defaultRuleThickness = options.fontMetrics().defaultRuleThickness;
        var vlist = $ef0731f441f79e9a$var$makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: innerGroup
                },
                {
                    type: "kern",
                    size: 3 * defaultRuleThickness
                },
                {
                    type: "elem",
                    elem: line
                },
                {
                    type: "kern",
                    size: defaultRuleThickness
                }
            ]
        });
        return $ef0731f441f79e9a$var$makeSpan([
            "mord",
            "overline"
        ], [
            vlist
        ], options);
    },
    mathmlBuilder (group, options) {
        var operator = new $ef0731f441f79e9a$var$MathNode("mo", [
            new $ef0731f441f79e9a$var$TextNode("\u203e")
        ]);
        operator.setAttribute("stretchy", "true");
        var node = new $ef0731f441f79e9a$var$MathNode("mover", [
            $ef0731f441f79e9a$var$buildGroup(group.body, options),
            operator
        ]);
        node.setAttribute("accent", "true");
        return node;
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "phantom",
    names: [
        "\\phantom"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler: (_ref, args)=>{
        var { parser: parser } = _ref;
        var body = args[0];
        return {
            type: "phantom",
            mode: parser.mode,
            body: $ef0731f441f79e9a$var$ordargument(body)
        };
    },
    htmlBuilder: (group, options)=>{
        var elements = $ef0731f441f79e9a$var$buildExpression$1(group.body, options.withPhantom(), false);
        // \phantom isn't supposed to affect the elements it contains.
        // See "color" for more details.
        return $ef0731f441f79e9a$var$makeFragment(elements);
    },
    mathmlBuilder: (group, options)=>{
        var inner = $ef0731f441f79e9a$var$buildExpression(group.body, options);
        return new $ef0731f441f79e9a$var$MathNode("mphantom", inner);
    }
});
$ef0731f441f79e9a$export$1c70906d0a09453f("\\hphantom", "\\smash{\\phantom{#1}}");
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "vphantom",
    names: [
        "\\vphantom"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler: (_ref2, args)=>{
        var { parser: parser } = _ref2;
        var body = args[0];
        return {
            type: "vphantom",
            mode: parser.mode,
            body: body
        };
    },
    htmlBuilder: (group, options)=>{
        var inner = $ef0731f441f79e9a$var$makeSpan([
            "inner"
        ], [
            $ef0731f441f79e9a$var$buildGroup$1(group.body, options.withPhantom())
        ]);
        var fix = $ef0731f441f79e9a$var$makeSpan([
            "fix"
        ], []);
        return $ef0731f441f79e9a$var$makeSpan([
            "mord",
            "rlap"
        ], [
            inner,
            fix
        ], options);
    },
    mathmlBuilder: (group, options)=>{
        var inner = $ef0731f441f79e9a$var$buildExpression($ef0731f441f79e9a$var$ordargument(group.body), options);
        var phantom = new $ef0731f441f79e9a$var$MathNode("mphantom", inner);
        var node = new $ef0731f441f79e9a$var$MathNode("mpadded", [
            phantom
        ]);
        node.setAttribute("width", "0px");
        return node;
    }
});
// Box manipulation
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "raisebox",
    names: [
        "\\raisebox"
    ],
    props: {
        numArgs: 2,
        argTypes: [
            "size",
            "hbox"
        ],
        allowedInText: true
    },
    handler (_ref, args) {
        var { parser: parser } = _ref;
        var amount = $ef0731f441f79e9a$var$assertNodeType(args[0], "size").value;
        var body = args[1];
        return {
            type: "raisebox",
            mode: parser.mode,
            dy: amount,
            body: body
        };
    },
    htmlBuilder (group, options) {
        var body = $ef0731f441f79e9a$var$buildGroup$1(group.body, options);
        var dy = $ef0731f441f79e9a$var$calculateSize(group.dy, options);
        return $ef0731f441f79e9a$var$makeVList({
            positionType: "shift",
            positionData: -dy,
            children: [
                {
                    type: "elem",
                    elem: body
                }
            ]
        });
    },
    mathmlBuilder (group, options) {
        var node = new $ef0731f441f79e9a$var$MathNode("mpadded", [
            $ef0731f441f79e9a$var$buildGroup(group.body, options)
        ]);
        var dy = group.dy.number + group.dy.unit;
        node.setAttribute("voffset", dy);
        return node;
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "internal",
    names: [
        "\\relax"
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        allowedInArgument: true
    },
    handler (_ref) {
        var { parser: parser } = _ref;
        return {
            type: "internal",
            mode: parser.mode
        };
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "rule",
    names: [
        "\\rule"
    ],
    props: {
        numArgs: 2,
        numOptionalArgs: 1,
        allowedInText: true,
        allowedInMath: true,
        argTypes: [
            "size",
            "size",
            "size"
        ]
    },
    handler (_ref, args, optArgs) {
        var { parser: parser } = _ref;
        var shift = optArgs[0];
        var width = $ef0731f441f79e9a$var$assertNodeType(args[0], "size");
        var height = $ef0731f441f79e9a$var$assertNodeType(args[1], "size");
        return {
            type: "rule",
            mode: parser.mode,
            shift: shift && $ef0731f441f79e9a$var$assertNodeType(shift, "size").value,
            width: width.value,
            height: height.value
        };
    },
    htmlBuilder (group, options) {
        // Make an empty span for the rule
        var rule = $ef0731f441f79e9a$var$makeSpan([
            "mord",
            "rule"
        ], [], options);
        // Calculate the shift, width, and height of the rule, and account for units
        var width = $ef0731f441f79e9a$var$calculateSize(group.width, options);
        var height = $ef0731f441f79e9a$var$calculateSize(group.height, options);
        var shift = group.shift ? $ef0731f441f79e9a$var$calculateSize(group.shift, options) : 0;
        // Style the rule to the right size
        rule.style.borderRightWidth = $ef0731f441f79e9a$var$makeEm(width);
        rule.style.borderTopWidth = $ef0731f441f79e9a$var$makeEm(height);
        rule.style.bottom = $ef0731f441f79e9a$var$makeEm(shift);
        // Record the height and width
        rule.width = width;
        rule.height = height + shift;
        rule.depth = -shift;
        // Font size is the number large enough that the browser will
        // reserve at least `absHeight` space above the baseline.
        // The 1.125 factor was empirically determined
        rule.maxFontSize = height * 1.125 * options.sizeMultiplier;
        return rule;
    },
    mathmlBuilder (group, options) {
        var width = $ef0731f441f79e9a$var$calculateSize(group.width, options);
        var height = $ef0731f441f79e9a$var$calculateSize(group.height, options);
        var shift = group.shift ? $ef0731f441f79e9a$var$calculateSize(group.shift, options) : 0;
        var color = options.color && options.getColor() || "black";
        var rule = new $ef0731f441f79e9a$var$MathNode("mspace");
        rule.setAttribute("mathbackground", color);
        rule.setAttribute("width", $ef0731f441f79e9a$var$makeEm(width));
        rule.setAttribute("height", $ef0731f441f79e9a$var$makeEm(height));
        var wrapper = new $ef0731f441f79e9a$var$MathNode("mpadded", [
            rule
        ]);
        if (shift >= 0) wrapper.setAttribute("height", $ef0731f441f79e9a$var$makeEm(shift));
        else {
            wrapper.setAttribute("height", $ef0731f441f79e9a$var$makeEm(shift));
            wrapper.setAttribute("depth", $ef0731f441f79e9a$var$makeEm(-shift));
        }
        wrapper.setAttribute("voffset", $ef0731f441f79e9a$var$makeEm(shift));
        return wrapper;
    }
});
function $ef0731f441f79e9a$var$sizingGroup(value, options, baseOptions) {
    var inner = $ef0731f441f79e9a$var$buildExpression$1(value, options, false);
    var multiplier = options.sizeMultiplier / baseOptions.sizeMultiplier;
    // Add size-resetting classes to the inner list and set maxFontSize
    // manually. Handle nested size changes.
    for(var i = 0; i < inner.length; i++){
        var pos = inner[i].classes.indexOf("sizing");
        if (pos < 0) Array.prototype.push.apply(inner[i].classes, options.sizingClasses(baseOptions));
        else if (inner[i].classes[pos + 1] === "reset-size" + options.size) // This is a nested size change: e.g., inner[i] is the "b" in
        // `\Huge a \small b`. Override the old size (the `reset-` class)
        // but not the new size.
        inner[i].classes[pos + 1] = "reset-size" + baseOptions.size;
        inner[i].height *= multiplier;
        inner[i].depth *= multiplier;
    }
    return $ef0731f441f79e9a$var$makeFragment(inner);
}
var $ef0731f441f79e9a$var$sizeFuncs = [
    "\\tiny",
    "\\sixptsize",
    "\\scriptsize",
    "\\footnotesize",
    "\\small",
    "\\normalsize",
    "\\large",
    "\\Large",
    "\\LARGE",
    "\\huge",
    "\\Huge"
];
var $ef0731f441f79e9a$var$htmlBuilder = (group, options)=>{
    // Handle sizing operators like \Huge. Real TeX doesn't actually allow
    // these functions inside of math expressions, so we do some special
    // handling.
    var newOptions = options.havingSize(group.size);
    return $ef0731f441f79e9a$var$sizingGroup(group.body, newOptions, options);
};
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "sizing",
    names: $ef0731f441f79e9a$var$sizeFuncs,
    props: {
        numArgs: 0,
        allowedInText: true
    },
    handler: (_ref, args)=>{
        var { breakOnTokenText: breakOnTokenText, funcName: funcName, parser: parser } = _ref;
        var body = parser.parseExpression(false, breakOnTokenText);
        return {
            type: "sizing",
            mode: parser.mode,
            // Figure out what size to use based on the list of functions above
            size: $ef0731f441f79e9a$var$sizeFuncs.indexOf(funcName) + 1,
            body: body
        };
    },
    htmlBuilder: $ef0731f441f79e9a$var$htmlBuilder,
    mathmlBuilder: (group, options)=>{
        var newOptions = options.havingSize(group.size);
        var inner = $ef0731f441f79e9a$var$buildExpression(group.body, newOptions);
        var node = new $ef0731f441f79e9a$var$MathNode("mstyle", inner);
        // TODO(emily): This doesn't produce the correct size for nested size
        // changes, because we don't keep state of what style we're currently
        // in, so we can't reset the size to normal before changing it.  Now
        // that we're passing an options parameter we should be able to fix
        // this.
        node.setAttribute("mathsize", $ef0731f441f79e9a$var$makeEm(newOptions.sizeMultiplier));
        return node;
    }
});
// smash, with optional [tb], as in AMS
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "smash",
    names: [
        "\\smash"
    ],
    props: {
        numArgs: 1,
        numOptionalArgs: 1,
        allowedInText: true
    },
    handler: (_ref, args, optArgs)=>{
        var { parser: parser } = _ref;
        var smashHeight = false;
        var smashDepth = false;
        var tbArg = optArgs[0] && $ef0731f441f79e9a$var$assertNodeType(optArgs[0], "ordgroup");
        if (tbArg) {
            // Optional [tb] argument is engaged.
            // ref: amsmath: \renewcommand{\smash}[1][tb]{%
            //               def\mb@t{\ht}\def\mb@b{\dp}\def\mb@tb{\ht\z@\z@\dp}%
            var letter;
            for(var i = 0; i < tbArg.body.length; ++i){
                var node = tbArg.body[i];
                letter = $ef0731f441f79e9a$var$assertSymbolNodeType(node).text;
                if (letter === "t") smashHeight = true;
                else if (letter === "b") smashDepth = true;
                else {
                    smashHeight = false;
                    smashDepth = false;
                    break;
                }
            }
        } else {
            smashHeight = true;
            smashDepth = true;
        }
        var body = args[0];
        return {
            type: "smash",
            mode: parser.mode,
            body: body,
            smashHeight: smashHeight,
            smashDepth: smashDepth
        };
    },
    htmlBuilder: (group, options)=>{
        var node = $ef0731f441f79e9a$var$makeSpan([], [
            $ef0731f441f79e9a$var$buildGroup$1(group.body, options)
        ]);
        if (!group.smashHeight && !group.smashDepth) return node;
        if (group.smashHeight) node.height = 0;
        if (group.smashDepth) node.depth = 0;
        if (group.smashHeight && group.smashDepth) // Symmetric \smash can stay in inline layout.
        return $ef0731f441f79e9a$var$makeSpan([
            "mord",
            "smash"
        ], [
            node
        ], options);
        // In order to influence makeVList for asymmetric smashing, we have to
        // reset the children.
        if (node.children) for(var i = 0; i < node.children.length; i++){
            if (group.smashHeight) node.children[i].height = 0;
            if (group.smashDepth) node.children[i].depth = 0;
        }
        // At this point, we've reset the TeX-like height and depth values.
        // But the span still has an HTML line height.
        // makeVList applies "display: table-cell", which prevents the browser
        // from acting on that line height. So we'll call makeVList now.
        var smashedNode = $ef0731f441f79e9a$var$makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: node
                }
            ]
        });
        // For spacing, TeX treats \smash as a math group (same spacing as ord).
        return $ef0731f441f79e9a$var$makeSpan([
            "mord"
        ], [
            smashedNode
        ], options);
    },
    mathmlBuilder: (group, options)=>{
        var node = new $ef0731f441f79e9a$var$MathNode("mpadded", [
            $ef0731f441f79e9a$var$buildGroup(group.body, options)
        ]);
        if (group.smashHeight) node.setAttribute("height", "0px");
        if (group.smashDepth) node.setAttribute("depth", "0px");
        return node;
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "sqrt",
    names: [
        "\\sqrt"
    ],
    props: {
        numArgs: 1,
        numOptionalArgs: 1
    },
    handler (_ref, args, optArgs) {
        var { parser: parser } = _ref;
        var index = optArgs[0];
        var body = args[0];
        return {
            type: "sqrt",
            mode: parser.mode,
            body: body,
            index: index
        };
    },
    htmlBuilder (group, options) {
        // Square roots are handled in the TeXbook pg. 443, Rule 11.
        // First, we do the same steps as in overline to build the inner group
        // and line
        var inner = $ef0731f441f79e9a$var$buildGroup$1(group.body, options.havingCrampedStyle());
        if (inner.height === 0) // Render a small surd.
        inner.height = options.fontMetrics().xHeight;
        // Some groups can return document fragments.  Handle those by wrapping
        // them in a span.
        inner = $ef0731f441f79e9a$var$wrapFragment(inner, options);
        // Calculate the minimum size for the \surd delimiter
        var metrics = options.fontMetrics();
        var theta = metrics.defaultRuleThickness;
        var phi = theta;
        if (options.style.id < $ef0731f441f79e9a$var$Style$1.TEXT.id) phi = options.fontMetrics().xHeight;
        // Calculate the clearance between the body and line
        var lineClearance = theta + phi / 4;
        var minDelimiterHeight = inner.height + inner.depth + lineClearance + theta;
        // Create a sqrt SVG of the required minimum size
        var { span: img, ruleWidth: ruleWidth, advanceWidth: advanceWidth } = $ef0731f441f79e9a$var$makeSqrtImage(minDelimiterHeight, options);
        var delimDepth = img.height - ruleWidth;
        // Adjust the clearance based on the delimiter size
        if (delimDepth > inner.height + inner.depth + lineClearance) lineClearance = (lineClearance + delimDepth - inner.height - inner.depth) / 2;
        // Shift the sqrt image
        var imgShift = img.height - inner.height - lineClearance - ruleWidth;
        inner.style.paddingLeft = $ef0731f441f79e9a$var$makeEm(advanceWidth);
        // Overlay the image and the argument.
        var body = $ef0731f441f79e9a$var$makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: inner,
                    wrapperClasses: [
                        "svg-align"
                    ]
                },
                {
                    type: "kern",
                    size: -(inner.height + imgShift)
                },
                {
                    type: "elem",
                    elem: img
                },
                {
                    type: "kern",
                    size: ruleWidth
                }
            ]
        });
        if (!group.index) return $ef0731f441f79e9a$var$makeSpan([
            "mord",
            "sqrt"
        ], [
            body
        ], options);
        else {
            // Handle the optional root index
            // The index is always in scriptscript style
            var newOptions = options.havingStyle($ef0731f441f79e9a$var$Style$1.SCRIPTSCRIPT);
            var rootm = $ef0731f441f79e9a$var$buildGroup$1(group.index, newOptions, options);
            // The amount the index is shifted by. This is taken from the TeX
            // source, in the definition of `\r@@t`.
            var toShift = 0.6 * (body.height - body.depth);
            // Build a VList with the superscript shifted up correctly
            var rootVList = $ef0731f441f79e9a$var$makeVList({
                positionType: "shift",
                positionData: -toShift,
                children: [
                    {
                        type: "elem",
                        elem: rootm
                    }
                ]
            });
            // Add a class surrounding it so we can add on the appropriate
            // kerning
            var rootVListWrap = $ef0731f441f79e9a$var$makeSpan([
                "root"
            ], [
                rootVList
            ]);
            return $ef0731f441f79e9a$var$makeSpan([
                "mord",
                "sqrt"
            ], [
                rootVListWrap,
                body
            ], options);
        }
    },
    mathmlBuilder (group, options) {
        var { body: body, index: index } = group;
        return index ? new $ef0731f441f79e9a$var$MathNode("mroot", [
            $ef0731f441f79e9a$var$buildGroup(body, options),
            $ef0731f441f79e9a$var$buildGroup(index, options)
        ]) : new $ef0731f441f79e9a$var$MathNode("msqrt", [
            $ef0731f441f79e9a$var$buildGroup(body, options)
        ]);
    }
});
var $ef0731f441f79e9a$var$styleMap = {
    "display": $ef0731f441f79e9a$var$Style$1.DISPLAY,
    "text": $ef0731f441f79e9a$var$Style$1.TEXT,
    "script": $ef0731f441f79e9a$var$Style$1.SCRIPT,
    "scriptscript": $ef0731f441f79e9a$var$Style$1.SCRIPTSCRIPT
};
function $ef0731f441f79e9a$var$isStyleStr(s) {
    return s in $ef0731f441f79e9a$var$styleMap;
}
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "styling",
    names: [
        "\\displaystyle",
        "\\textstyle",
        "\\scriptstyle",
        "\\scriptscriptstyle"
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        primitive: true
    },
    handler (_ref, args) {
        var { breakOnTokenText: breakOnTokenText, funcName: funcName, parser: parser } = _ref;
        // parse out the implicit body
        var body = parser.parseExpression(true, breakOnTokenText);
        // TODO: Refactor to avoid duplicating styleMap in multiple places (e.g.
        // here and in buildHTML and de-dupe the enumeration of all the styles).
        var style = funcName.slice(1, funcName.length - 5);
        if (!$ef0731f441f79e9a$var$isStyleStr(style)) throw new Error("Unknown style: " + style);
        return {
            type: "styling",
            mode: parser.mode,
            style: // Figure out what style to use by pulling out the style from
            // the function name
            style,
            body: body
        };
    },
    htmlBuilder (group, options) {
        // Style changes are handled in the TeXbook on pg. 442, Rule 3.
        var newStyle = $ef0731f441f79e9a$var$styleMap[group.style];
        var newOptions = options.havingStyle(newStyle);
        if (group.resetFont) newOptions = newOptions.withFont('');
        return $ef0731f441f79e9a$var$sizingGroup(group.body, newOptions, options);
    },
    mathmlBuilder (group, options) {
        // Figure out what style we're changing to.
        var newStyle = $ef0731f441f79e9a$var$styleMap[group.style];
        var newOptions = options.havingStyle(newStyle);
        if (group.resetFont) newOptions = newOptions.withFont('');
        var inner = $ef0731f441f79e9a$var$buildExpression(group.body, newOptions);
        var node = new $ef0731f441f79e9a$var$MathNode("mstyle", inner);
        var styleAttributes = {
            "display": [
                "0",
                "true"
            ],
            "text": [
                "0",
                "false"
            ],
            "script": [
                "1",
                "false"
            ],
            "scriptscript": [
                "2",
                "false"
            ]
        };
        var attr = styleAttributes[group.style];
        node.setAttribute("scriptlevel", attr[0]);
        node.setAttribute("displaystyle", attr[1]);
        return node;
    }
});
/**
 * Sometimes, groups perform special rules when they have superscripts or
 * subscripts attached to them. This function lets the `supsub` group know that
 * Sometimes, groups perform special rules when they have superscripts or
 * its inner element should handle the superscripts and subscripts instead of
 * handling them itself.
 */ var $ef0731f441f79e9a$var$htmlBuilderDelegate = function htmlBuilderDelegate(group, options) {
    var base = group.base;
    if (!base) return null;
    else if (base.type === "op") {
        // Operators handle supsubs differently when they have limits
        // (e.g. `\displaystyle\sum_2^3`)
        var delegate = base.limits && (options.style.size === $ef0731f441f79e9a$var$Style$1.DISPLAY.size || base.alwaysHandleSupSub);
        return delegate ? $ef0731f441f79e9a$var$htmlBuilder$2 : null;
    } else if (base.type === "operatorname") {
        var _delegate = base.alwaysHandleSupSub && (options.style.size === $ef0731f441f79e9a$var$Style$1.DISPLAY.size || base.limits);
        return _delegate ? $ef0731f441f79e9a$var$htmlBuilder$1 : null;
    } else if (base.type === "accent") return $ef0731f441f79e9a$var$isCharacterBox(base.base) ? $ef0731f441f79e9a$var$htmlBuilder$a : null;
    else if (base.type === "horizBrace") {
        var isSup = !group.sub;
        return isSup === base.isOver ? $ef0731f441f79e9a$var$htmlBuilder$3 : null;
    } else return null;
};
// Super scripts and subscripts, whose precise placement can depend on other
// functions that precede them.
$ef0731f441f79e9a$var$defineFunctionBuilders({
    type: "supsub",
    htmlBuilder (group, options) {
        // Superscript and subscripts are handled in the TeXbook on page
        // 445-446, rules 18(a-f).
        // Here is where we defer to the inner group if it should handle
        // superscripts and subscripts itself.
        var builderDelegate = $ef0731f441f79e9a$var$htmlBuilderDelegate(group, options);
        if (builderDelegate) return builderDelegate(group, options);
        var { base: valueBase, sup: valueSup, sub: valueSub } = group;
        var base = $ef0731f441f79e9a$var$buildGroup$1(valueBase, options);
        var supm;
        var subm;
        var metrics = options.fontMetrics();
        // Rule 18a
        var supShift = 0;
        var subShift = 0;
        var isCharBox = valueBase && $ef0731f441f79e9a$var$isCharacterBox(valueBase);
        if (valueSup) {
            var newOptions = options.havingStyle(options.style.sup());
            supm = $ef0731f441f79e9a$var$buildGroup$1(valueSup, newOptions, options);
            if (!isCharBox) supShift = base.height - newOptions.fontMetrics().supDrop * newOptions.sizeMultiplier / options.sizeMultiplier;
        }
        if (valueSub) {
            var _newOptions = options.havingStyle(options.style.sub());
            subm = $ef0731f441f79e9a$var$buildGroup$1(valueSub, _newOptions, options);
            if (!isCharBox) subShift = base.depth + _newOptions.fontMetrics().subDrop * _newOptions.sizeMultiplier / options.sizeMultiplier;
        }
        // Rule 18c
        var minSupShift;
        if (options.style === $ef0731f441f79e9a$var$Style$1.DISPLAY) minSupShift = metrics.sup1;
        else if (options.style.cramped) minSupShift = metrics.sup3;
        else minSupShift = metrics.sup2;
        // scriptspace is a font-size-independent size, so scale it
        // appropriately for use as the marginRight.
        var multiplier = options.sizeMultiplier;
        var marginRight = $ef0731f441f79e9a$var$makeEm(0.5 / metrics.ptPerEm / multiplier);
        var marginLeft = null;
        if (subm) {
            // Subscripts shouldn't be shifted by the base's italic correction.
            // Account for that by shifting the subscript back the appropriate
            // amount. Note we only do this when the base is a single symbol.
            var isOiint = group.base && group.base.type === "op" && group.base.name && (group.base.name === "\\oiint" || group.base.name === "\\oiiint");
            if (base instanceof $ef0731f441f79e9a$var$SymbolNode || isOiint) {
                var _base$italic;
                // SymbolNode has .italic natively; for \oiint/\oiiint the
                // op builder stores .italic on the wrapping Span.
                marginLeft = $ef0731f441f79e9a$var$makeEm(-((_base$italic = base.italic) != null ? _base$italic : 0));
            }
        }
        var supsub;
        if (supm && subm) {
            supShift = Math.max(supShift, minSupShift, supm.depth + 0.25 * metrics.xHeight);
            subShift = Math.max(subShift, metrics.sub2);
            var ruleWidth = metrics.defaultRuleThickness;
            // Rule 18e
            var maxWidth = 4 * ruleWidth;
            if (supShift - supm.depth - (subm.height - subShift) < maxWidth) {
                subShift = maxWidth - (supShift - supm.depth) + subm.height;
                var psi = 0.8 * metrics.xHeight - (supShift - supm.depth);
                if (psi > 0) {
                    supShift += psi;
                    subShift -= psi;
                }
            }
            var vlistElem = [
                {
                    type: "elem",
                    elem: subm,
                    shift: subShift,
                    marginRight: marginRight,
                    marginLeft: marginLeft
                },
                {
                    type: "elem",
                    elem: supm,
                    shift: -supShift,
                    marginRight: marginRight
                }
            ];
            supsub = $ef0731f441f79e9a$var$makeVList({
                positionType: "individualShift",
                children: vlistElem
            });
        } else if (subm) {
            // Rule 18b
            subShift = Math.max(subShift, metrics.sub1, subm.height - 0.8 * metrics.xHeight);
            var _vlistElem = [
                {
                    type: "elem",
                    elem: subm,
                    marginLeft: marginLeft,
                    marginRight: marginRight
                }
            ];
            supsub = $ef0731f441f79e9a$var$makeVList({
                positionType: "shift",
                positionData: subShift,
                children: _vlistElem
            });
        } else if (supm) {
            // Rule 18c, d
            supShift = Math.max(supShift, minSupShift, supm.depth + 0.25 * metrics.xHeight);
            supsub = $ef0731f441f79e9a$var$makeVList({
                positionType: "shift",
                positionData: -supShift,
                children: [
                    {
                        type: "elem",
                        elem: supm,
                        marginRight: marginRight
                    }
                ]
            });
        } else throw new Error("supsub must have either sup or sub.");
        // Wrap the supsub vlist in a span.msupsub to reset text-align.
        var mclass = $ef0731f441f79e9a$var$getTypeOfDomTree(base, "right") || "mord";
        return $ef0731f441f79e9a$var$makeSpan([
            mclass
        ], [
            base,
            $ef0731f441f79e9a$var$makeSpan([
                "msupsub"
            ], [
                supsub
            ])
        ], options);
    },
    mathmlBuilder (group, options) {
        // Is the inner group a relevant horizontal brace?
        var isBrace = false;
        var isOver;
        var isSup;
        if (group.base && group.base.type === "horizBrace") {
            isSup = !!group.sup;
            if (isSup === group.base.isOver) {
                isBrace = true;
                isOver = group.base.isOver;
            }
        }
        if (group.base && (group.base.type === "op" || group.base.type === "operatorname")) group.base.parentIsSupSub = true;
        var children = [
            $ef0731f441f79e9a$var$buildGroup(group.base, options)
        ];
        if (group.sub) children.push($ef0731f441f79e9a$var$buildGroup(group.sub, options));
        if (group.sup) children.push($ef0731f441f79e9a$var$buildGroup(group.sup, options));
        var nodeType;
        if (isBrace) nodeType = isOver ? "mover" : "munder";
        else if (!group.sub) {
            var base = group.base;
            if (base && base.type === "op" && base.limits && (options.style === $ef0731f441f79e9a$var$Style$1.DISPLAY || base.alwaysHandleSupSub)) nodeType = "mover";
            else if (base && base.type === "operatorname" && base.alwaysHandleSupSub && (base.limits || options.style === $ef0731f441f79e9a$var$Style$1.DISPLAY)) nodeType = "mover";
            else nodeType = "msup";
        } else if (!group.sup) {
            var _base = group.base;
            if (_base && _base.type === "op" && _base.limits && (options.style === $ef0731f441f79e9a$var$Style$1.DISPLAY || _base.alwaysHandleSupSub)) nodeType = "munder";
            else if (_base && _base.type === "operatorname" && _base.alwaysHandleSupSub && (_base.limits || options.style === $ef0731f441f79e9a$var$Style$1.DISPLAY)) nodeType = "munder";
            else nodeType = "msub";
        } else {
            var _base2 = group.base;
            if (_base2 && _base2.type === "op" && _base2.limits && options.style === $ef0731f441f79e9a$var$Style$1.DISPLAY) nodeType = "munderover";
            else if (_base2 && _base2.type === "operatorname" && _base2.alwaysHandleSupSub && (options.style === $ef0731f441f79e9a$var$Style$1.DISPLAY || _base2.limits)) nodeType = "munderover";
            else nodeType = "msubsup";
        }
        return new $ef0731f441f79e9a$var$MathNode(nodeType, children);
    }
});
// Operator ParseNodes created in Parser.js from symbol Groups in src/symbols.js.
$ef0731f441f79e9a$var$defineFunctionBuilders({
    type: "atom",
    htmlBuilder (group, options) {
        return $ef0731f441f79e9a$var$mathsym(group.text, group.mode, options, [
            "m" + group.family
        ]);
    },
    mathmlBuilder (group, options) {
        var node = new $ef0731f441f79e9a$var$MathNode("mo", [
            $ef0731f441f79e9a$var$makeText(group.text, group.mode)
        ]);
        if (group.family === "bin") {
            var variant = $ef0731f441f79e9a$var$getVariant(group, options);
            if (variant === "bold-italic") node.setAttribute("mathvariant", variant);
        } else if (group.family === "punct") node.setAttribute("separator", "true");
        else if (group.family === "open" || group.family === "close") // Delims built here should not stretch vertically.
        // See delimsizing.js for stretchy delims.
        node.setAttribute("stretchy", "false");
        return node;
    }
});
// "mathord" and "textord" ParseNodes created in Parser.js from symbol Groups in
// src/symbols.js.
var $ef0731f441f79e9a$var$defaultVariant = {
    "mi": "italic",
    "mn": "normal",
    "mtext": "normal"
};
$ef0731f441f79e9a$var$defineFunctionBuilders({
    type: "mathord",
    htmlBuilder (group, options) {
        return $ef0731f441f79e9a$var$makeOrd(group, options, "mathord");
    },
    mathmlBuilder (group, options) {
        var node = new $ef0731f441f79e9a$var$MathNode("mi", [
            $ef0731f441f79e9a$var$makeText(group.text, group.mode, options)
        ]);
        var variant = $ef0731f441f79e9a$var$getVariant(group, options) || "italic";
        if (variant !== $ef0731f441f79e9a$var$defaultVariant[node.type]) node.setAttribute("mathvariant", variant);
        return node;
    }
});
$ef0731f441f79e9a$var$defineFunctionBuilders({
    type: "textord",
    htmlBuilder (group, options) {
        return $ef0731f441f79e9a$var$makeOrd(group, options, "textord");
    },
    mathmlBuilder (group, options) {
        var text = $ef0731f441f79e9a$var$makeText(group.text, group.mode, options);
        var variant = $ef0731f441f79e9a$var$getVariant(group, options) || "normal";
        var node;
        if (group.mode === 'text') node = new $ef0731f441f79e9a$var$MathNode("mtext", [
            text
        ]);
        else if (/[0-9]/.test(group.text)) node = new $ef0731f441f79e9a$var$MathNode("mn", [
            text
        ]);
        else if (group.text === "\\prime") node = new $ef0731f441f79e9a$var$MathNode("mo", [
            text
        ]);
        else node = new $ef0731f441f79e9a$var$MathNode("mi", [
            text
        ]);
        if (variant !== $ef0731f441f79e9a$var$defaultVariant[node.type]) node.setAttribute("mathvariant", variant);
        return node;
    }
});
// A map of CSS-based spacing functions to their CSS class.
var $ef0731f441f79e9a$var$cssSpace = {
    "\\nobreak": "nobreak",
    "\\allowbreak": "allowbreak"
};
// A lookup table to determine whether a spacing function/symbol should be
// treated like a regular space character.  If a symbol or command is a key
// in this table, then it should be a regular space character.  Furthermore,
// the associated value may have a `className` specifying an extra CSS class
// to add to the created `span`.
var $ef0731f441f79e9a$var$regularSpace = {
    " ": {},
    "\\ ": {},
    "~": {
        className: "nobreak"
    },
    "\\space": {},
    "\\nobreakspace": {
        className: "nobreak"
    }
};
// ParseNode<"spacing"> created in Parser.js from the "spacing" symbol Groups in
// src/symbols.js.
$ef0731f441f79e9a$var$defineFunctionBuilders({
    type: "spacing",
    htmlBuilder (group, options) {
        if ($ef0731f441f79e9a$var$regularSpace.hasOwnProperty(group.text)) {
            var className = $ef0731f441f79e9a$var$regularSpace[group.text].className || "";
            // Spaces are generated by adding an actual space. Each of these
            // things has an entry in the symbols table, so these will be turned
            // into appropriate outputs.
            if (group.mode === "text") {
                var ord = $ef0731f441f79e9a$var$makeOrd(group, options, "textord");
                ord.classes.push(className);
                return ord;
            } else return $ef0731f441f79e9a$var$makeSpan([
                "mspace",
                className
            ], [
                $ef0731f441f79e9a$var$mathsym(group.text, group.mode, options)
            ], options);
        } else if ($ef0731f441f79e9a$var$cssSpace.hasOwnProperty(group.text)) // Spaces based on just a CSS class.
        return $ef0731f441f79e9a$var$makeSpan([
            "mspace",
            $ef0731f441f79e9a$var$cssSpace[group.text]
        ], [], options);
        else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Unknown type of space \"" + group.text + "\"");
    },
    mathmlBuilder (group, options) {
        var node;
        if ($ef0731f441f79e9a$var$regularSpace.hasOwnProperty(group.text)) node = new $ef0731f441f79e9a$var$MathNode("mtext", [
            new $ef0731f441f79e9a$var$TextNode("\u00a0")
        ]);
        else if ($ef0731f441f79e9a$var$cssSpace.hasOwnProperty(group.text)) // CSS-based MathML spaces (\nobreak, \allowbreak) are ignored
        return new $ef0731f441f79e9a$var$MathNode("mspace");
        else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Unknown type of space \"" + group.text + "\"");
        return node;
    }
});
var $ef0731f441f79e9a$var$pad = ()=>{
    var padNode = new $ef0731f441f79e9a$var$MathNode("mtd", []);
    padNode.setAttribute("width", "50%");
    return padNode;
};
$ef0731f441f79e9a$var$defineFunctionBuilders({
    type: "tag",
    mathmlBuilder (group, options) {
        var table = new $ef0731f441f79e9a$var$MathNode("mtable", [
            new $ef0731f441f79e9a$var$MathNode("mtr", [
                $ef0731f441f79e9a$var$pad(),
                new $ef0731f441f79e9a$var$MathNode("mtd", [
                    $ef0731f441f79e9a$var$buildExpressionRow(group.body, options)
                ]),
                $ef0731f441f79e9a$var$pad(),
                new $ef0731f441f79e9a$var$MathNode("mtd", [
                    $ef0731f441f79e9a$var$buildExpressionRow(group.tag, options)
                ])
            ])
        ]);
        table.setAttribute("width", "100%");
        return table;
    // TODO: Left-aligned tags.
    // Currently, the group and options passed here do not contain
    // enough info to set tag alignment. `leqno` is in Settings but it is
    // not passed to Options. On the HTML side, leqno is
    // set by a CSS class applied in buildTree.js. That would have worked
    // in MathML if browsers supported <mlabeledtr>. Since they don't, we
    // need to rewrite the way this function is called.
    }
});
// Non-mathy text, possibly in a font
var $ef0731f441f79e9a$var$textFontFamilies = {
    "\\text": undefined,
    "\\textrm": "textrm",
    "\\textsf": "textsf",
    "\\texttt": "texttt",
    "\\textnormal": "textrm"
};
var $ef0731f441f79e9a$var$textFontWeights = {
    "\\textbf": "textbf",
    "\\textmd": "textmd"
};
var $ef0731f441f79e9a$var$textFontShapes = {
    "\\textit": "textit",
    "\\textup": "textup"
};
var $ef0731f441f79e9a$var$optionsWithFont = (group, options)=>{
    var font = group.font;
    // Checks if the argument is a font family or a font style.
    if (!font) return options;
    else if ($ef0731f441f79e9a$var$textFontFamilies[font]) return options.withTextFontFamily($ef0731f441f79e9a$var$textFontFamilies[font]);
    else if ($ef0731f441f79e9a$var$textFontWeights[font]) return options.withTextFontWeight($ef0731f441f79e9a$var$textFontWeights[font]);
    else if (font === "\\emph") return options.fontShape === "textit" ? options.withTextFontShape("textup") : options.withTextFontShape("textit");
    return options.withTextFontShape($ef0731f441f79e9a$var$textFontShapes[font]);
};
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "text",
    names: [
        // Font families
        "\\text",
        "\\textrm",
        "\\textsf",
        "\\texttt",
        "\\textnormal",
        // Font weights
        "\\textbf",
        "\\textmd",
        // Font Shapes
        "\\textit",
        "\\textup",
        "\\emph"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "text"
        ],
        allowedInArgument: true,
        allowedInText: true
    },
    handler (_ref, args) {
        var { parser: parser, funcName: funcName } = _ref;
        var body = args[0];
        return {
            type: "text",
            mode: parser.mode,
            body: $ef0731f441f79e9a$var$ordargument(body),
            font: funcName
        };
    },
    htmlBuilder (group, options) {
        var newOptions = $ef0731f441f79e9a$var$optionsWithFont(group, options);
        var inner = $ef0731f441f79e9a$var$buildExpression$1(group.body, newOptions, true);
        return $ef0731f441f79e9a$var$makeSpan([
            "mord",
            "text"
        ], inner, newOptions);
    },
    mathmlBuilder (group, options) {
        var newOptions = $ef0731f441f79e9a$var$optionsWithFont(group, options);
        return $ef0731f441f79e9a$var$buildExpressionRow(group.body, newOptions);
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "underline",
    names: [
        "\\underline"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler (_ref, args) {
        var { parser: parser } = _ref;
        return {
            type: "underline",
            mode: parser.mode,
            body: args[0]
        };
    },
    htmlBuilder (group, options) {
        // Underlines are handled in the TeXbook pg 443, Rule 10.
        // Build the inner group.
        var innerGroup = $ef0731f441f79e9a$var$buildGroup$1(group.body, options);
        // Create the line to go below the body
        var line = $ef0731f441f79e9a$var$makeLineSpan("underline-line", options);
        // Generate the vlist, with the appropriate kerns
        var defaultRuleThickness = options.fontMetrics().defaultRuleThickness;
        var vlist = $ef0731f441f79e9a$var$makeVList({
            positionType: "top",
            positionData: innerGroup.height,
            children: [
                {
                    type: "kern",
                    size: defaultRuleThickness
                },
                {
                    type: "elem",
                    elem: line
                },
                {
                    type: "kern",
                    size: 3 * defaultRuleThickness
                },
                {
                    type: "elem",
                    elem: innerGroup
                }
            ]
        });
        return $ef0731f441f79e9a$var$makeSpan([
            "mord",
            "underline"
        ], [
            vlist
        ], options);
    },
    mathmlBuilder (group, options) {
        var operator = new $ef0731f441f79e9a$var$MathNode("mo", [
            new $ef0731f441f79e9a$var$TextNode("\u203e")
        ]);
        operator.setAttribute("stretchy", "true");
        var node = new $ef0731f441f79e9a$var$MathNode("munder", [
            $ef0731f441f79e9a$var$buildGroup(group.body, options),
            operator
        ]);
        node.setAttribute("accentunder", "true");
        return node;
    }
});
// \vcenter:  Vertically center the argument group on the math axis.
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "vcenter",
    names: [
        "\\vcenter"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "original"
        ],
        // In LaTeX, \vcenter can act only on a box.
        allowedInText: false
    },
    handler (_ref, args) {
        var { parser: parser } = _ref;
        return {
            type: "vcenter",
            mode: parser.mode,
            body: args[0]
        };
    },
    htmlBuilder (group, options) {
        var body = $ef0731f441f79e9a$var$buildGroup$1(group.body, options);
        var axisHeight = options.fontMetrics().axisHeight;
        var dy = 0.5 * (body.height - axisHeight - (body.depth + axisHeight));
        return $ef0731f441f79e9a$var$makeVList({
            positionType: "shift",
            positionData: dy,
            children: [
                {
                    type: "elem",
                    elem: body
                }
            ]
        });
    },
    mathmlBuilder (group, options) {
        // There is no way to do this in MathML.
        // Write a class as a breadcrumb in case some post-processor wants
        // to perform a vcenter adjustment.
        // Wrap in mrow to ensure valid MathML when placed inside mo (e.g., \mathrel)
        var mpadded = new $ef0731f441f79e9a$var$MathNode("mpadded", [
            $ef0731f441f79e9a$var$buildGroup(group.body, options)
        ], [
            "vcenter"
        ]);
        return new $ef0731f441f79e9a$var$MathNode("mrow", [
            mpadded
        ]);
    }
});
$ef0731f441f79e9a$export$6eeef399b524690e({
    type: "verb",
    names: [
        "\\verb"
    ],
    props: {
        numArgs: 0,
        allowedInText: true
    },
    handler (context, args, optArgs) {
        // \verb and \verb* are dealt with directly in Parser.js.
        // If we end up here, it's because of a failure to match the two delimiters
        // in the regex in Lexer.js.  LaTeX raises the following error when \verb is
        // terminated by end of line (or file).
        throw new $ef0731f441f79e9a$export$f9c837a54db411d("\\verb ended by end of line instead of matching delimiter");
    },
    htmlBuilder (group, options) {
        var text = $ef0731f441f79e9a$var$makeVerb(group);
        var body = [];
        // \verb enters text mode and therefore is sized like \textstyle
        var newOptions = options.havingStyle(options.style.text());
        for(var i = 0; i < text.length; i++){
            var c = text[i];
            if (c === '~') c = '\\textasciitilde';
            body.push($ef0731f441f79e9a$var$makeSymbol(c, "Typewriter-Regular", group.mode, newOptions, [
                "mord",
                "texttt"
            ]));
        }
        return $ef0731f441f79e9a$var$makeSpan([
            "mord",
            "text"
        ].concat(newOptions.sizingClasses(options)), $ef0731f441f79e9a$var$tryCombineChars(body), newOptions);
    },
    mathmlBuilder (group, options) {
        var text = new $ef0731f441f79e9a$var$TextNode($ef0731f441f79e9a$var$makeVerb(group));
        var node = new $ef0731f441f79e9a$var$MathNode("mtext", [
            text
        ]);
        node.setAttribute("mathvariant", "monospace");
        return node;
    }
});
/**
 * Converts verb group into body string.
 *
 * \verb* replaces each space with an open box \u2423
 * \verb replaces each space with a no-break space \xA0
 */ var $ef0731f441f79e9a$var$makeVerb = (group)=>group.body.replace(/ /g, group.star ? '\u2423' : '\xA0');
/** Include this to ensure that all functions are defined. */ var $ef0731f441f79e9a$var$functions = $ef0731f441f79e9a$var$_functions;
/**
 * The Lexer class handles tokenizing the input in various ways. Since our
 * parser expects us to be able to backtrack, the lexer allows lexing from any
 * given starting point.
 *
 * Its main exposed function is the `lex` function, which takes a position to
 * lex from and a type of token to lex. It defers to the appropriate `_innerLex`
 * function.
 *
 * The various `_innerLex` functions perform the actual lexing of different
 * kinds.
 */ /* The following tokenRegex
 * - matches typical whitespace (but not NBSP etc.) using its first group
 * - does not match any control character \x00-\x1f except whitespace
 * - does not match a bare backslash
 * - matches any ASCII character except those just mentioned
 * - does not match the BMP private use area \uE000-\uF8FF
 * - does not match bare surrogate code units
 * - matches any BMP character except for those just described
 * - matches any valid Unicode surrogate pair
 * - matches a backslash followed by one or more whitespace characters
 * - matches a backslash followed by one or more letters then whitespace
 * - matches a backslash followed by any BMP character
 * Capturing groups:
 *   [1] regular whitespace
 *   [2] backslash followed by whitespace
 *   [3] anything else, which may include:
 *     [4] left character of \verb*
 *     [5] left character of \verb
 *     [6] backslash followed by word, excluding any trailing whitespace
 * Just because the Lexer matches something doesn't mean it's valid input:
 * If there is no matching function or symbol definition, the Parser will
 * still reject the input.
 */ var $ef0731f441f79e9a$var$spaceRegexString = "[ \r\n\t]";
var $ef0731f441f79e9a$var$controlWordRegexString = "\\\\[a-zA-Z@]+";
var $ef0731f441f79e9a$var$controlSymbolRegexString = "\\\\[^\uD800-\uDFFF]";
var $ef0731f441f79e9a$var$controlWordWhitespaceRegexString = "(" + $ef0731f441f79e9a$var$controlWordRegexString + ")" + $ef0731f441f79e9a$var$spaceRegexString + "*";
var $ef0731f441f79e9a$var$controlSpaceRegexString = "\\\\(\n|[ \r\t]+\n?)[ \r\t]*";
var $ef0731f441f79e9a$var$combiningDiacriticalMarkString = "[\u0300-\u036f]";
var $ef0731f441f79e9a$var$combiningDiacriticalMarksEndRegex = new RegExp($ef0731f441f79e9a$var$combiningDiacriticalMarkString + "+$");
var $ef0731f441f79e9a$var$tokenRegexString = "(" + $ef0731f441f79e9a$var$spaceRegexString + "+)|" + ($ef0731f441f79e9a$var$controlSpaceRegexString + "|") + // \whitespace
"([!-\\[\\]-\u2027\u202A-\uD7FF\uF900-\uFFFF]" + ($ef0731f441f79e9a$var$combiningDiacriticalMarkString + "*") + // ...plus accents
"|[\uD800-\uDBFF][\uDC00-\uDFFF]" + ($ef0731f441f79e9a$var$combiningDiacriticalMarkString + "*") + // ...plus accents
"|\\\\verb\\*([^]).*?\\4" + // \verb*
"|\\\\verb([^*a-zA-Z]).*?\\5" + ("|" + $ef0731f441f79e9a$var$controlWordWhitespaceRegexString) + ("|" + $ef0731f441f79e9a$var$controlSymbolRegexString + ")"); // \\, \', etc.
/** Main Lexer class */ class $ef0731f441f79e9a$var$Lexer {
    constructor(input, settings){
        this.input = void 0;
        this.settings = void 0;
        this.tokenRegex = void 0;
        // Category codes. The lexer only supports comment characters (14) for now.
        // MacroExpander additionally distinguishes active (13).
        this.catcodes = void 0;
        // Separate accents from characters
        this.input = input;
        this.settings = settings;
        this.tokenRegex = new RegExp($ef0731f441f79e9a$var$tokenRegexString, 'g');
        this.catcodes = {
            "%": 14,
            // comment character
            "~": 13 // active character
        };
    }
    setCatcode(char, code) {
        this.catcodes[char] = code;
    }
    /**
   * This function lexes a single token.
   */ lex() {
        var input = this.input;
        var pos = this.tokenRegex.lastIndex;
        if (pos === input.length) return new $ef0731f441f79e9a$var$Token("EOF", new $ef0731f441f79e9a$var$SourceLocation(this, pos, pos));
        var match = this.tokenRegex.exec(input);
        if (match === null || match.index !== pos) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Unexpected character: '" + input[pos] + "'", new $ef0731f441f79e9a$var$Token(input[pos], new $ef0731f441f79e9a$var$SourceLocation(this, pos, pos + 1)));
        var text = match[6] || match[3] || (match[2] ? "\\ " : " ");
        if (this.catcodes[text] === 14) {
            // comment character
            var nlIndex = input.indexOf('\n', this.tokenRegex.lastIndex);
            if (nlIndex === -1) {
                this.tokenRegex.lastIndex = input.length; // EOF
                this.settings.reportNonstrict("commentAtEnd", "% comment has no terminating newline; LaTeX would fail because of commenting the end of math mode (e.g. $)");
            } else this.tokenRegex.lastIndex = nlIndex + 1;
            return this.lex();
        }
        return new $ef0731f441f79e9a$var$Token(text, new $ef0731f441f79e9a$var$SourceLocation(this, pos, this.tokenRegex.lastIndex));
    }
}
/**
 * A `Namespace` refers to a space of nameable things like macros or lengths,
 * which can be `set` either globally or local to a nested group, using an
 * undo stack similar to how TeX implements this functionality.
 * Performance-wise, `get` and local `set` take constant time, while global
 * `set` takes time proportional to the depth of group nesting.
 */ class $ef0731f441f79e9a$var$Namespace {
    /**
   * Both arguments are optional.  The first argument is an object of
   * built-in mappings which never change.  The second argument is an object
   * of initial (global-level) mappings, which will constantly change
   * according to any global/top-level `set`s done.
   */ constructor(builtins, globalMacros){
        if (builtins === void 0) builtins = {};
        if (globalMacros === void 0) globalMacros = {};
        this.current = void 0;
        this.builtins = void 0;
        this.undefStack = void 0;
        this.current = globalMacros;
        this.builtins = builtins;
        this.undefStack = [];
    }
    /**
   * Start a new nested group, affecting future local `set`s.
   */ beginGroup() {
        this.undefStack.push({});
    }
    /**
   * End current nested group, restoring values before the group began.
   */ endGroup() {
        if (this.undefStack.length === 0) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Unbalanced namespace destruction: attempt to pop global namespace; please report this as a bug");
        var undefs = this.undefStack.pop();
        for(var undef in undefs)if (undefs.hasOwnProperty(undef)) {
            if (undefs[undef] == null) delete this.current[undef];
            else this.current[undef] = undefs[undef];
        }
    }
    /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */ endGroups() {
        while(this.undefStack.length > 0)this.endGroup();
    }
    /**
   * Detect whether `name` has a definition.  Equivalent to
   * `get(name) != null`.
   */ has(name) {
        return this.current.hasOwnProperty(name) || this.builtins.hasOwnProperty(name);
    }
    /**
   * Get the current value of a name, or `undefined` if there is no value.
   *
   * Note: Do not use `if (namespace.get(...))` to detect whether a macro
   * is defined, as the definition may be the empty string which evaluates
   * to `false` in JavaScript.  Use `if (namespace.get(...) != null)` or
   * `if (namespace.has(...))`.
   */ get(name) {
        if (this.current.hasOwnProperty(name)) return this.current[name];
        else return this.builtins[name];
    }
    /**
   * Set the current value of a name, and optionally set it globally too.
   * Local set() sets the current value and (when appropriate) adds an undo
   * operation to the undo stack.  Global set() may change the undo
   * operation at every level, so takes time linear in their number.
   * A value of undefined means to delete existing definitions.
   */ set(name, value, global) {
        if (global === void 0) global = false;
        if (global) {
            // Global set is equivalent to setting in all groups.  Simulate this
            // by destroying any undos currently scheduled for this name,
            // and adding an undo with the *new* value (in case it later gets
            // locally reset within this environment).
            for(var i = 0; i < this.undefStack.length; i++)delete this.undefStack[i][name];
            if (this.undefStack.length > 0) this.undefStack[this.undefStack.length - 1][name] = value;
        } else {
            // Undo this set at end of this group (possibly to `undefined`),
            // unless an undo is already in place, in which case that older
            // value is the correct one.
            var top = this.undefStack[this.undefStack.length - 1];
            if (top && !top.hasOwnProperty(name)) top[name] = this.current[name];
        }
        if (value == null) delete this.current[name];
        else this.current[name] = value;
    }
}
/**
 * Predefined macros for KaTeX.
 * This can be used to define some commands in terms of others.
 */ var $ef0731f441f79e9a$var$macros = $ef0731f441f79e9a$var$_macros;
//////////////////////////////////////////////////////////////////////
// macro tools
$ef0731f441f79e9a$export$1c70906d0a09453f("\\noexpand", function(context) {
    // The expansion is the token itself; but that token is interpreted
    // as if its meaning were ‘\relax’ if it is a control sequence that
    // would ordinarily be expanded by TeX’s expansion rules.
    var t = context.popToken();
    if (context.isExpandable(t.text)) {
        t.noexpand = true;
        t.treatAsRelax = true;
    }
    return {
        tokens: [
            t
        ],
        numArgs: 0
    };
});
$ef0731f441f79e9a$export$1c70906d0a09453f("\\expandafter", function(context) {
    // TeX first reads the token that comes immediately after \expandafter,
    // without expanding it; let’s call this token t. Then TeX reads the
    // token that comes after t (and possibly more tokens, if that token
    // has an argument), replacing it by its expansion. Finally TeX puts
    // t back in front of that expansion.
    var t = context.popToken();
    context.expandOnce(true); // expand only an expandable token
    return {
        tokens: [
            t
        ],
        numArgs: 0
    };
});
// LaTeX's \@firstoftwo{#1}{#2} expands to #1, skipping #2
// TeX source: \long\def\@firstoftwo#1#2{#1}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\@firstoftwo", function(context) {
    var args = context.consumeArgs(2);
    return {
        tokens: args[0],
        numArgs: 0
    };
});
// LaTeX's \@secondoftwo{#1}{#2} expands to #2, skipping #1
// TeX source: \long\def\@secondoftwo#1#2{#2}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\@secondoftwo", function(context) {
    var args = context.consumeArgs(2);
    return {
        tokens: args[1],
        numArgs: 0
    };
});
// LaTeX's \@ifnextchar{#1}{#2}{#3} looks ahead to the next (unexpanded)
// symbol that isn't a space, consuming any spaces but not consuming the
// first nonspace character.  If that nonspace character matches #1, then
// the macro expands to #2; otherwise, it expands to #3.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\@ifnextchar", function(context) {
    var args = context.consumeArgs(3); // symbol, if, else
    context.consumeSpaces();
    var nextToken = context.future();
    if (args[0].length === 1 && args[0][0].text === nextToken.text) return {
        tokens: args[1],
        numArgs: 0
    };
    else return {
        tokens: args[2],
        numArgs: 0
    };
});
// LaTeX's \@ifstar{#1}{#2} looks ahead to the next (unexpanded) symbol.
// If it is `*`, then it consumes the symbol, and the macro expands to #1;
// otherwise, the macro expands to #2 (without consuming the symbol).
// TeX source: \def\@ifstar#1{\@ifnextchar *{\@firstoftwo{#1}}}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\@ifstar", "\\@ifnextchar *{\\@firstoftwo{#1}}");
// LaTeX's \TextOrMath{#1}{#2} expands to #1 in text mode, #2 in math mode
$ef0731f441f79e9a$export$1c70906d0a09453f("\\TextOrMath", function(context) {
    var args = context.consumeArgs(2);
    if (context.mode === 'text') return {
        tokens: args[0],
        numArgs: 0
    };
    else return {
        tokens: args[1],
        numArgs: 0
    };
});
// Lookup table for parsing numbers in base 8 through 16
var $ef0731f441f79e9a$var$digitToNumber = {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    "a": 10,
    "A": 10,
    "b": 11,
    "B": 11,
    "c": 12,
    "C": 12,
    "d": 13,
    "D": 13,
    "e": 14,
    "E": 14,
    "f": 15,
    "F": 15
};
// TeX \char makes a literal character (catcode 12) using the following forms:
// (see The TeXBook, p. 43)
//   \char123  -- decimal
//   \char'123 -- octal
//   \char"123 -- hex
//   \char`x   -- character that can be written (i.e. isn't active)
//   \char`\x  -- character that cannot be written (e.g. %)
// These all refer to characters from the font, so we turn them into special
// calls to a function \@char dealt with in the Parser.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\char", function(context) {
    var token = context.popToken();
    var base;
    var number = 0;
    if (token.text === "'") {
        base = 8;
        token = context.popToken();
    } else if (token.text === '"') {
        base = 16;
        token = context.popToken();
    } else if (token.text === "`") {
        token = context.popToken();
        if (token.text[0] === "\\") number = token.text.charCodeAt(1);
        else if (token.text === "EOF") throw new $ef0731f441f79e9a$export$f9c837a54db411d("\\char` missing argument");
        else number = token.text.charCodeAt(0);
    } else base = 10;
    if (base) {
        // Parse a number in the given base, starting with first `token`.
        number = $ef0731f441f79e9a$var$digitToNumber[token.text];
        if (number == null || number >= base) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid base-" + base + " digit " + token.text);
        var digit;
        while((digit = $ef0731f441f79e9a$var$digitToNumber[context.future().text]) != null && digit < base){
            number *= base;
            number += digit;
            context.popToken();
        }
    }
    return "\\@char{" + number + "}";
});
// \newcommand{\macro}[args]{definition}
// \renewcommand{\macro}[args]{definition}
// TODO: Optional arguments: \newcommand{\macro}[args][default]{definition}
var $ef0731f441f79e9a$var$newcommand = (context, existsOK, nonexistsOK, skipIfExists)=>{
    var arg = context.consumeArg().tokens;
    if (arg.length !== 1) throw new $ef0731f441f79e9a$export$f9c837a54db411d("\\newcommand's first argument must be a macro name");
    var name = arg[0].text;
    var exists = context.isDefined(name);
    if (exists && !existsOK) throw new $ef0731f441f79e9a$export$f9c837a54db411d("\\newcommand{" + name + "} attempting to redefine " + (name + "; use \\renewcommand"));
    if (!exists && !nonexistsOK) throw new $ef0731f441f79e9a$export$f9c837a54db411d("\\renewcommand{" + name + "} when command " + name + " " + "does not yet exist; use \\newcommand");
    var numArgs = 0;
    arg = context.consumeArg().tokens;
    if (arg.length === 1 && arg[0].text === "[") {
        var argText = '';
        var token = context.expandNextToken();
        while(token.text !== "]" && token.text !== "EOF"){
            // TODO: Should properly expand arg, e.g., ignore {}s
            argText += token.text;
            token = context.expandNextToken();
        }
        if (!argText.match(/^\s*[0-9]+\s*$/)) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid number of arguments: " + argText);
        numArgs = parseInt(argText);
        arg = context.consumeArg().tokens;
    }
    if (!(exists && skipIfExists)) // Final arg is the expansion of the macro
    context.macros.set(name, {
        tokens: arg,
        numArgs: numArgs
    });
    return '';
};
$ef0731f441f79e9a$export$1c70906d0a09453f("\\newcommand", (context)=>$ef0731f441f79e9a$var$newcommand(context, false, true, false));
$ef0731f441f79e9a$export$1c70906d0a09453f("\\renewcommand", (context)=>$ef0731f441f79e9a$var$newcommand(context, true, false, false));
$ef0731f441f79e9a$export$1c70906d0a09453f("\\providecommand", (context)=>$ef0731f441f79e9a$var$newcommand(context, true, true, true));
// terminal (console) tools
$ef0731f441f79e9a$export$1c70906d0a09453f("\\message", (context)=>{
    var arg = context.consumeArgs(1)[0];
    // eslint-disable-next-line no-console
    console.log(arg.reverse().map((token)=>token.text).join(""));
    return '';
});
$ef0731f441f79e9a$export$1c70906d0a09453f("\\errmessage", (context)=>{
    var arg = context.consumeArgs(1)[0];
    // eslint-disable-next-line no-console
    console.error(arg.reverse().map((token)=>token.text).join(""));
    return '';
});
$ef0731f441f79e9a$export$1c70906d0a09453f("\\show", (context)=>{
    var tok = context.popToken();
    var name = tok.text;
    // eslint-disable-next-line no-console
    console.log(tok, context.macros.get(name), $ef0731f441f79e9a$var$functions[name], $ef0731f441f79e9a$var$symbols.math[name], $ef0731f441f79e9a$var$symbols.text[name]);
    return '';
});
//////////////////////////////////////////////////////////////////////
// Grouping
// \let\bgroup={ \let\egroup=}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\bgroup", "{");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\egroup", "}");
// Symbols from latex.ltx:
// \def~{\nobreakspace{}}
// \def\lq{`}
// \def\rq{'}
// \def \aa {\r a}
// \def \AA {\r A}
$ef0731f441f79e9a$export$1c70906d0a09453f("~", "\\nobreakspace");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\lq", "`");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\rq", "'");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\aa", "\\r a");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\AA", "\\r A");
// Copyright (C) and registered (R) symbols. Use raw symbol in MathML.
// \DeclareTextCommandDefault{\textcopyright}{\textcircled{c}}
// \DeclareTextCommandDefault{\textregistered}{\textcircled{%
//      \check@mathfonts\fontsize\sf@size\z@\math@fontsfalse\selectfont R}}
// \DeclareRobustCommand{\copyright}{%
//    \ifmmode{\nfss@text{\textcopyright}}\else\textcopyright\fi}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\textcopyright", "\\html@mathml{\\textcircled{c}}{\\char`\xa9}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\copyright", "\\TextOrMath{\\textcopyright}{\\text{\\textcopyright}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\textregistered", "\\html@mathml{\\textcircled{\\scriptsize R}}{\\char`\xae}");
// Characters omitted from Unicode range 1D400–1D7FF
$ef0731f441f79e9a$export$1c70906d0a09453f("\u212C", "\\mathscr{B}"); // script
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2130", "\\mathscr{E}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2131", "\\mathscr{F}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u210B", "\\mathscr{H}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2110", "\\mathscr{I}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2112", "\\mathscr{L}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2133", "\\mathscr{M}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u211B", "\\mathscr{R}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u212D", "\\mathfrak{C}"); // Fraktur
$ef0731f441f79e9a$export$1c70906d0a09453f("\u210C", "\\mathfrak{H}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2128", "\\mathfrak{Z}");
// Define \Bbbk with a macro that works in both HTML and MathML.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Bbbk", "\\Bbb{k}");
// \llap and \rlap render their contents in text mode
$ef0731f441f79e9a$export$1c70906d0a09453f("\\llap", "\\mathllap{\\textrm{#1}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\rlap", "\\mathrlap{\\textrm{#1}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\clap", "\\mathclap{\\textrm{#1}}");
// \mathstrut from the TeXbook, p 360
$ef0731f441f79e9a$export$1c70906d0a09453f("\\mathstrut", "\\vphantom{(}");
// \underbar from TeXbook p 353
$ef0731f441f79e9a$export$1c70906d0a09453f("\\underbar", "\\underline{\\text{#1}}");
// \not is defined by base/fontmath.ltx via
// \DeclareMathSymbol{\not}{\mathrel}{symbols}{"36}
// It's thus treated like a \mathrel, but defined by a symbol that has zero
// width but extends to the right.  We use \rlap to get that spacing.
// For MathML we write U+0338 here. buildMathML.js will then do the overlay.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\not", '\\html@mathml{\\mathrel{\\mathrlap\\@not}\\nobreak}{\\char"338}');
// Negated symbols from base/fontmath.ltx:
// \def\neq{\not=} \let\ne=\neq
// \DeclareRobustCommand
//   \notin{\mathrel{\m@th\mathpalette\c@ncel\in}}
// \def\c@ncel#1#2{\m@th\ooalign{$\hfil#1\mkern1mu/\hfil$\crcr$#1#2$}}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\neq", "\\html@mathml{\\mathrel{\\not=}}{\\mathrel{\\char`\u2260}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\ne", "\\neq");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2260", "\\neq");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\notin", "\\html@mathml{\\mathrel{{\\in}\\mathllap{/\\mskip1mu}}}{\\mathrel{\\char`\u2209}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2209", "\\notin");
// Unicode stacked relations
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2258", "\\html@mathml{\\mathrel{=\\kern{-1em}\\raisebox{0.4em}{$\\scriptsize\\frown$}}}{\\mathrel{\\char`\u2258}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2259", "\\html@mathml{\\stackrel{\\tiny\\wedge}{=}}{\\mathrel{\\char`\u2258}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u225A", "\\html@mathml{\\stackrel{\\tiny\\vee}{=}}{\\mathrel{\\char`\u225A}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u225B", "\\html@mathml{\\stackrel{\\scriptsize\\star}{=}}{\\mathrel{\\char`\u225B}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u225D", "\\html@mathml{\\stackrel{\\tiny\\mathrm{def}}{=}}{\\mathrel{\\char`\u225D}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u225E", "\\html@mathml{\\stackrel{\\tiny\\mathrm{m}}{=}}{\\mathrel{\\char`\u225E}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u225F", "\\html@mathml{\\stackrel{\\tiny?}{=}}{\\mathrel{\\char`\u225F}}");
// Misc Unicode
$ef0731f441f79e9a$export$1c70906d0a09453f("\u27C2", "\\perp");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u203C", "\\mathclose{!\\mkern-0.8mu!}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u220C", "\\notni");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u231C", "\\ulcorner");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u231D", "\\urcorner");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u231E", "\\llcorner");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u231F", "\\lrcorner");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u00A9", "\\copyright");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u00AE", "\\textregistered");
// The KaTeX fonts have corners at codepoints that don't match Unicode.
// For MathML purposes, use the Unicode code point.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\ulcorner", "\\html@mathml{\\@ulcorner}{\\mathop{\\char\"231c}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\urcorner", "\\html@mathml{\\@urcorner}{\\mathop{\\char\"231d}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\llcorner", "\\html@mathml{\\@llcorner}{\\mathop{\\char\"231e}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\lrcorner", "\\html@mathml{\\@lrcorner}{\\mathop{\\char\"231f}}");
//////////////////////////////////////////////////////////////////////
// LaTeX_2ε
// \vdots{\vbox{\baselineskip4\p@  \lineskiplimit\z@
// \kern6\p@\hbox{.}\hbox{.}\hbox{.}}}
// We'll call \varvdots, which gets a glyph from symbols.js.
// The zero-width rule gets us an equivalent to the vertical 6pt kern.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\vdots", "{\\varvdots\\rule{0pt}{15pt}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u22ee", "\\vdots");
//////////////////////////////////////////////////////////////////////
// amsmath.sty
// http://mirrors.concertpass.com/tex-archive/macros/latex/required/amsmath/amsmath.pdf
// Italic Greek capital letters.  AMS defines these with \DeclareMathSymbol,
// but they are equivalent to \mathit{\Letter}.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varGamma", "\\mathit{\\Gamma}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varDelta", "\\mathit{\\Delta}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varTheta", "\\mathit{\\Theta}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varLambda", "\\mathit{\\Lambda}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varXi", "\\mathit{\\Xi}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varPi", "\\mathit{\\Pi}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varSigma", "\\mathit{\\Sigma}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varUpsilon", "\\mathit{\\Upsilon}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varPhi", "\\mathit{\\Phi}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varPsi", "\\mathit{\\Psi}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varOmega", "\\mathit{\\Omega}");
//\newcommand{\substack}[1]{\subarray{c}#1\endsubarray}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\substack", "\\begin{subarray}{c}#1\\end{subarray}");
// \renewcommand{\colon}{\nobreak\mskip2mu\mathpunct{}\nonscript
// \mkern-\thinmuskip{:}\mskip6muplus1mu\relax}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\colon", "\\nobreak\\mskip2mu\\mathpunct{}\\mathchoice{\\mkern-3mu}{\\mkern-3mu}{}{}{:}\\mskip6mu\\relax");
// \newcommand{\boxed}[1]{\fbox{\m@th$\displaystyle#1$}}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\boxed", "\\fbox{$\\displaystyle{#1}$}");
// \def\iff{\DOTSB\;\Longleftrightarrow\;}
// \def\implies{\DOTSB\;\Longrightarrow\;}
// \def\impliedby{\DOTSB\;\Longleftarrow\;}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\iff", "\\DOTSB\\;\\Longleftrightarrow\\;");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\implies", "\\DOTSB\\;\\Longrightarrow\\;");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\impliedby", "\\DOTSB\\;\\Longleftarrow\\;");
// \def\dddot#1{{\mathop{#1}\limits^{\vbox to-1.4\ex@{\kern-\tw@\ex@
//  \hbox{\normalfont ...}\vss}}}}
// We use \overset which avoids the vertical shift of \mathop.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\dddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ...}}{#1}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\ddddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ....}}{#1}}");
// AMSMath's automatic \dots, based on \mdots@@ macro.
var $ef0731f441f79e9a$var$dotsByToken = {
    ',': '\\dotsc',
    '\\not': '\\dotsb',
    // \keybin@ checks for the following:
    '+': '\\dotsb',
    '=': '\\dotsb',
    '<': '\\dotsb',
    '>': '\\dotsb',
    '-': '\\dotsb',
    '*': '\\dotsb',
    ':': '\\dotsb',
    // Symbols whose definition starts with \DOTSB:
    '\\DOTSB': '\\dotsb',
    '\\coprod': '\\dotsb',
    '\\bigvee': '\\dotsb',
    '\\bigwedge': '\\dotsb',
    '\\biguplus': '\\dotsb',
    '\\bigcap': '\\dotsb',
    '\\bigcup': '\\dotsb',
    '\\prod': '\\dotsb',
    '\\sum': '\\dotsb',
    '\\bigotimes': '\\dotsb',
    '\\bigoplus': '\\dotsb',
    '\\bigodot': '\\dotsb',
    '\\bigsqcup': '\\dotsb',
    '\\And': '\\dotsb',
    '\\longrightarrow': '\\dotsb',
    '\\Longrightarrow': '\\dotsb',
    '\\longleftarrow': '\\dotsb',
    '\\Longleftarrow': '\\dotsb',
    '\\longleftrightarrow': '\\dotsb',
    '\\Longleftrightarrow': '\\dotsb',
    '\\mapsto': '\\dotsb',
    '\\longmapsto': '\\dotsb',
    '\\hookrightarrow': '\\dotsb',
    '\\doteq': '\\dotsb',
    // Symbols whose definition starts with \mathbin:
    '\\mathbin': '\\dotsb',
    // Symbols whose definition starts with \mathrel:
    '\\mathrel': '\\dotsb',
    '\\relbar': '\\dotsb',
    '\\Relbar': '\\dotsb',
    '\\xrightarrow': '\\dotsb',
    '\\xleftarrow': '\\dotsb',
    // Symbols whose definition starts with \DOTSI:
    '\\DOTSI': '\\dotsi',
    '\\int': '\\dotsi',
    '\\oint': '\\dotsi',
    '\\iint': '\\dotsi',
    '\\iiint': '\\dotsi',
    '\\iiiint': '\\dotsi',
    '\\idotsint': '\\dotsi',
    // Symbols whose definition starts with \DOTSX:
    '\\DOTSX': '\\dotsx'
};
var $ef0731f441f79e9a$var$dotsbGroups = new Set([
    'bin',
    'rel'
]);
$ef0731f441f79e9a$export$1c70906d0a09453f("\\dots", function(context) {
    // TODO: If used in text mode, should expand to \textellipsis.
    // However, in KaTeX, \textellipsis and \ldots behave the same
    // (in text mode), and it's unlikely we'd see any of the math commands
    // that affect the behavior of \dots when in text mode.  So fine for now
    // (until we support \ifmmode ... \else ... \fi).
    var thedots = '\\dotso';
    var next = context.expandAfterFuture().text;
    if (next in $ef0731f441f79e9a$var$dotsByToken) thedots = $ef0731f441f79e9a$var$dotsByToken[next];
    else if (next.slice(0, 4) === '\\not') thedots = '\\dotsb';
    else if (next in $ef0731f441f79e9a$var$symbols.math) {
        if ($ef0731f441f79e9a$var$dotsbGroups.has($ef0731f441f79e9a$var$symbols.math[next].group)) thedots = '\\dotsb';
    }
    return thedots;
});
var $ef0731f441f79e9a$var$spaceAfterDots = {
    // \rightdelim@ checks for the following:
    ')': true,
    ']': true,
    '\\rbrack': true,
    '\\}': true,
    '\\rbrace': true,
    '\\rangle': true,
    '\\rceil': true,
    '\\rfloor': true,
    '\\rgroup': true,
    '\\rmoustache': true,
    '\\right': true,
    '\\bigr': true,
    '\\biggr': true,
    '\\Bigr': true,
    '\\Biggr': true,
    // \extra@ also tests for the following:
    '$': true,
    // \extrap@ checks for the following:
    ';': true,
    '.': true,
    ',': true
};
$ef0731f441f79e9a$export$1c70906d0a09453f("\\dotso", function(context) {
    var next = context.future().text;
    if (next in $ef0731f441f79e9a$var$spaceAfterDots) return "\\ldots\\,";
    else return "\\ldots";
});
$ef0731f441f79e9a$export$1c70906d0a09453f("\\dotsc", function(context) {
    var next = context.future().text;
    // \dotsc uses \extra@ but not \extrap@, instead specially checking for
    // ';' and '.', but doesn't check for ','.
    if (next in $ef0731f441f79e9a$var$spaceAfterDots && next !== ',') return "\\ldots\\,";
    else return "\\ldots";
});
$ef0731f441f79e9a$export$1c70906d0a09453f("\\cdots", function(context) {
    var next = context.future().text;
    if (next in $ef0731f441f79e9a$var$spaceAfterDots) return "\\@cdots\\,";
    else return "\\@cdots";
});
$ef0731f441f79e9a$export$1c70906d0a09453f("\\dotsb", "\\cdots");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\dotsm", "\\cdots");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\dotsi", "\\!\\cdots");
// amsmath doesn't actually define \dotsx, but \dots followed by a macro
// starting with \DOTSX implies \dotso, and then \extra@ detects this case
// and forces the added `\,`.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\dotsx", "\\ldots\\,");
// \let\DOTSI\relax
// \let\DOTSB\relax
// \let\DOTSX\relax
$ef0731f441f79e9a$export$1c70906d0a09453f("\\DOTSI", "\\relax");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\DOTSB", "\\relax");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\DOTSX", "\\relax");
// Spacing, based on amsmath.sty's override of LaTeX defaults
// \DeclareRobustCommand{\tmspace}[3]{%
//   \ifmmode\mskip#1#2\else\kern#1#3\fi\relax}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\tmspace", "\\TextOrMath{\\kern#1#3}{\\mskip#1#2}\\relax");
// \renewcommand{\,}{\tmspace+\thinmuskip{.1667em}}
// TODO: math mode should use \thinmuskip
$ef0731f441f79e9a$export$1c70906d0a09453f("\\,", "\\tmspace+{3mu}{.1667em}");
// \let\thinspace\,
$ef0731f441f79e9a$export$1c70906d0a09453f("\\thinspace", "\\,");
// \def\>{\mskip\medmuskip}
// \renewcommand{\:}{\tmspace+\medmuskip{.2222em}}
// TODO: \> and math mode of \: should use \medmuskip = 4mu plus 2mu minus 4mu
$ef0731f441f79e9a$export$1c70906d0a09453f("\\>", "\\mskip{4mu}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\:", "\\tmspace+{4mu}{.2222em}");
// \let\medspace\:
$ef0731f441f79e9a$export$1c70906d0a09453f("\\medspace", "\\:");
// \renewcommand{\;}{\tmspace+\thickmuskip{.2777em}}
// TODO: math mode should use \thickmuskip = 5mu plus 5mu
$ef0731f441f79e9a$export$1c70906d0a09453f("\\;", "\\tmspace+{5mu}{.2777em}");
// \let\thickspace\;
$ef0731f441f79e9a$export$1c70906d0a09453f("\\thickspace", "\\;");
// \renewcommand{\!}{\tmspace-\thinmuskip{.1667em}}
// TODO: math mode should use \thinmuskip
$ef0731f441f79e9a$export$1c70906d0a09453f("\\!", "\\tmspace-{3mu}{.1667em}");
// \let\negthinspace\!
$ef0731f441f79e9a$export$1c70906d0a09453f("\\negthinspace", "\\!");
// \newcommand{\negmedspace}{\tmspace-\medmuskip{.2222em}}
// TODO: math mode should use \medmuskip
$ef0731f441f79e9a$export$1c70906d0a09453f("\\negmedspace", "\\tmspace-{4mu}{.2222em}");
// \newcommand{\negthickspace}{\tmspace-\thickmuskip{.2777em}}
// TODO: math mode should use \thickmuskip
$ef0731f441f79e9a$export$1c70906d0a09453f("\\negthickspace", "\\tmspace-{5mu}{.277em}");
// \def\enspace{\kern.5em }
$ef0731f441f79e9a$export$1c70906d0a09453f("\\enspace", "\\kern.5em ");
// \def\enskip{\hskip.5em\relax}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\enskip", "\\hskip.5em\\relax");
// \def\quad{\hskip1em\relax}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\quad", "\\hskip1em\\relax");
// \def\qquad{\hskip2em\relax}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\qquad", "\\hskip2em\\relax");
// \tag@in@display form of \tag
$ef0731f441f79e9a$export$1c70906d0a09453f("\\tag", "\\@ifstar\\tag@literal\\tag@paren");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\tag@paren", "\\tag@literal{({#1})}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\tag@literal", (context)=>{
    if (context.macros.get("\\df@tag")) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Multiple \\tag");
    return "\\gdef\\df@tag{\\text{#1}}";
});
// \renewcommand{\bmod}{\nonscript\mskip-\medmuskip\mkern5mu\mathbin
//   {\operator@font mod}\penalty900
//   \mkern5mu\nonscript\mskip-\medmuskip}
// \newcommand{\pod}[1]{\allowbreak
//   \if@display\mkern18mu\else\mkern8mu\fi(#1)}
// \renewcommand{\pmod}[1]{\pod{{\operator@font mod}\mkern6mu#1}}
// \newcommand{\mod}[1]{\allowbreak\if@display\mkern18mu
//   \else\mkern12mu\fi{\operator@font mod}\,\,#1}
// TODO: math mode should use \medmuskip = 4mu plus 2mu minus 4mu
$ef0731f441f79e9a$export$1c70906d0a09453f("\\bmod", "\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}\\mathbin{\\rm mod}\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\pod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern8mu}{\\mkern8mu}{\\mkern8mu}(#1)");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\pmod", "\\pod{{\\rm mod}\\mkern6mu#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\mod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern12mu}{\\mkern12mu}{\\mkern12mu}{\\rm mod}\\,\\,#1");
//////////////////////////////////////////////////////////////////////
// LaTeX source2e
// \expandafter\let\expandafter\@normalcr
//     \csname\expandafter\@gobble\string\\ \endcsname
// \DeclareRobustCommand\newline{\@normalcr\relax}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\newline", "\\\\\\relax");
// \def\TeX{T\kern-.1667em\lower.5ex\hbox{E}\kern-.125emX\@}
// TODO: Doesn't normally work in math mode because \@ fails.  KaTeX doesn't
// support \@ yet, so that's omitted, and we add \text so that the result
// doesn't look funny in math mode.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\TeX", "\\textrm{\\html@mathml{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}{TeX}}");
// \DeclareRobustCommand{\LaTeX}{L\kern-.36em%
//         {\sbox\z@ T%
//          \vbox to\ht\z@{\hbox{\check@mathfonts
//                               \fontsize\sf@size\z@
//                               \math@fontsfalse\selectfont
//                               A}%
//                         \vss}%
//         }%
//         \kern-.15em%
//         \TeX}
// This code aligns the top of the A with the T (from the perspective of TeX's
// boxes, though visually the A appears to extend above slightly).
// We compute the corresponding \raisebox when A is rendered in \normalsize
// \scriptstyle, which has a scale factor of 0.7 (see Options.js).
var $ef0731f441f79e9a$var$latexRaiseA = $ef0731f441f79e9a$var$makeEm($ef0731f441f79e9a$var$fontMetricsData['Main-Regular']["T".charCodeAt(0)][1] - 0.7 * $ef0731f441f79e9a$var$fontMetricsData['Main-Regular']["A".charCodeAt(0)][1]);
$ef0731f441f79e9a$export$1c70906d0a09453f("\\LaTeX", "\\textrm{\\html@mathml{" + ("L\\kern-.36em\\raisebox{" + $ef0731f441f79e9a$var$latexRaiseA + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{LaTeX}}");
// New KaTeX logo based on tweaking LaTeX logo
$ef0731f441f79e9a$export$1c70906d0a09453f("\\KaTeX", "\\textrm{\\html@mathml{" + ("K\\kern-.17em\\raisebox{" + $ef0731f441f79e9a$var$latexRaiseA + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{KaTeX}}");
// \DeclareRobustCommand\hspace{\@ifstar\@hspacer\@hspace}
// \def\@hspace#1{\hskip  #1\relax}
// \def\@hspacer#1{\vrule \@width\z@\nobreak
//                 \hskip #1\hskip \z@skip}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\hspace", "\\@ifstar\\@hspacer\\@hspace");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\@hspace", "\\hskip #1\\relax");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\@hspacer", "\\rule{0pt}{0pt}\\hskip #1\\relax");
//////////////////////////////////////////////////////////////////////
// mathtools.sty
//\providecommand\ordinarycolon{:}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\ordinarycolon", ":");
//\def\vcentcolon{\mathrel{\mathop\ordinarycolon}}
//TODO(edemaine): Not yet centered. Fix via \raisebox or #726
$ef0731f441f79e9a$export$1c70906d0a09453f("\\vcentcolon", "\\mathrel{\\mathop\\ordinarycolon}");
// \providecommand*\dblcolon{\vcentcolon\mathrel{\mkern-.9mu}\vcentcolon}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\dblcolon", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon}}{\\mathop{\\char"2237}}');
// \providecommand*\coloneqq{\vcentcolon\mathrel{\mkern-1.2mu}=}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\coloneqq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2254}}'); // ≔
// \providecommand*\Coloneqq{\dblcolon\mathrel{\mkern-1.2mu}=}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Coloneqq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2237\\char"3d}}');
// \providecommand*\coloneq{\vcentcolon\mathrel{\mkern-1.2mu}\mathrel{-}}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\coloneq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"3a\\char"2212}}');
// \providecommand*\Coloneq{\dblcolon\mathrel{\mkern-1.2mu}\mathrel{-}}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Coloneq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"2237\\char"2212}}');
// \providecommand*\eqqcolon{=\mathrel{\mkern-1.2mu}\vcentcolon}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2255}}'); // ≕
// \providecommand*\Eqqcolon{=\mathrel{\mkern-1.2mu}\dblcolon}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"3d\\char"2237}}');
// \providecommand*\eqcolon{\mathrel{-}\mathrel{\mkern-1.2mu}\vcentcolon}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2239}}');
// \providecommand*\Eqcolon{\mathrel{-}\mathrel{\mkern-1.2mu}\dblcolon}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"2212\\char"2237}}');
// \providecommand*\colonapprox{\vcentcolon\mathrel{\mkern-1.2mu}\approx}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\colonapprox", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"3a\\char"2248}}');
// \providecommand*\Colonapprox{\dblcolon\mathrel{\mkern-1.2mu}\approx}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Colonapprox", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"2237\\char"2248}}');
// \providecommand*\colonsim{\vcentcolon\mathrel{\mkern-1.2mu}\sim}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\colonsim", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"3a\\char"223c}}');
// \providecommand*\Colonsim{\dblcolon\mathrel{\mkern-1.2mu}\sim}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Colonsim", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"2237\\char"223c}}');
// Some Unicode characters are implemented with macros to mathtools functions.
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2237", "\\dblcolon"); // ::
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2239", "\\eqcolon"); // -:
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2254", "\\coloneqq"); // :=
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2255", "\\eqqcolon"); // =:
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2A74", "\\Coloneqq"); // ::=
//////////////////////////////////////////////////////////////////////
// colonequals.sty
// Alternate names for mathtools's macros:
$ef0731f441f79e9a$export$1c70906d0a09453f("\\ratio", "\\vcentcolon");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\coloncolon", "\\dblcolon");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\colonequals", "\\coloneqq");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\coloncolonequals", "\\Coloneqq");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\equalscolon", "\\eqqcolon");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\equalscoloncolon", "\\Eqqcolon");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\colonminus", "\\coloneq");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\coloncolonminus", "\\Coloneq");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\minuscolon", "\\eqcolon");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\minuscoloncolon", "\\Eqcolon");
// \colonapprox name is same in mathtools and colonequals.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\coloncolonapprox", "\\Colonapprox");
// \colonsim name is same in mathtools and colonequals.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\coloncolonsim", "\\Colonsim");
// Additional macros, implemented by analogy with mathtools definitions:
$ef0731f441f79e9a$export$1c70906d0a09453f("\\simcolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\simcoloncolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\approxcolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\approxcoloncolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon}");
// Present in newtxmath, pxfonts and txfonts
$ef0731f441f79e9a$export$1c70906d0a09453f("\\notni", "\\html@mathml{\\not\\ni}{\\mathrel{\\char`\u220C}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\limsup", "\\DOTSB\\operatorname*{lim\\,sup}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\liminf", "\\DOTSB\\operatorname*{lim\\,inf}");
//////////////////////////////////////////////////////////////////////
// From amsopn.sty
$ef0731f441f79e9a$export$1c70906d0a09453f("\\injlim", "\\DOTSB\\operatorname*{inj\\,lim}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\projlim", "\\DOTSB\\operatorname*{proj\\,lim}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varlimsup", "\\DOTSB\\operatorname*{\\overline{lim}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varliminf", "\\DOTSB\\operatorname*{\\underline{lim}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varinjlim", "\\DOTSB\\operatorname*{\\underrightarrow{lim}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varprojlim", "\\DOTSB\\operatorname*{\\underleftarrow{lim}}");
//////////////////////////////////////////////////////////////////////
// MathML alternates for KaTeX glyphs in the Unicode private area
$ef0731f441f79e9a$export$1c70906d0a09453f("\\gvertneqq", "\\html@mathml{\\@gvertneqq}{\u2269}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\lvertneqq", "\\html@mathml{\\@lvertneqq}{\u2268}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\ngeqq", "\\html@mathml{\\@ngeqq}{\u2271}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\ngeqslant", "\\html@mathml{\\@ngeqslant}{\u2271}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\nleqq", "\\html@mathml{\\@nleqq}{\u2270}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\nleqslant", "\\html@mathml{\\@nleqslant}{\u2270}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\nshortmid", "\\html@mathml{\\@nshortmid}{\u2224}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\nshortparallel", "\\html@mathml{\\@nshortparallel}{\u2226}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\nsubseteqq", "\\html@mathml{\\@nsubseteqq}{\u2288}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\nsupseteqq", "\\html@mathml{\\@nsupseteqq}{\u2289}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varsubsetneq", "\\html@mathml{\\@varsubsetneq}{\u228A}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varsubsetneqq", "\\html@mathml{\\@varsubsetneqq}{\u2ACB}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varsupsetneq", "\\html@mathml{\\@varsupsetneq}{\u228B}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\varsupsetneqq", "\\html@mathml{\\@varsupsetneqq}{\u2ACC}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\imath", "\\html@mathml{\\@imath}{\u0131}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\jmath", "\\html@mathml{\\@jmath}{\u0237}");
//////////////////////////////////////////////////////////////////////
// stmaryrd and semantic
// The stmaryrd and semantic packages render the next four items by calling a
// glyph. Those glyphs do not exist in the KaTeX fonts. Hence the macros.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\llbracket", "\\html@mathml{\\mathopen{[\\mkern-3.2mu[}}{\\mathopen{\\char`\u27E6}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\rrbracket", "\\html@mathml{\\mathclose{]\\mkern-3.2mu]}}{\\mathclose{\\char`\u27E7}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u27e6", "\\llbracket"); // blackboard bold [
$ef0731f441f79e9a$export$1c70906d0a09453f("\u27e7", "\\rrbracket"); // blackboard bold ]
$ef0731f441f79e9a$export$1c70906d0a09453f("\\lBrace", "\\html@mathml{\\mathopen{\\{\\mkern-3.2mu[}}{\\mathopen{\\char`\u2983}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\rBrace", "\\html@mathml{\\mathclose{]\\mkern-3.2mu\\}}}{\\mathclose{\\char`\u2984}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2983", "\\lBrace"); // blackboard bold {
$ef0731f441f79e9a$export$1c70906d0a09453f("\u2984", "\\rBrace"); // blackboard bold }
// TODO: Create variable sized versions of the last two items. I believe that
// will require new font glyphs.
// The stmaryrd function `\minuso` provides a "Plimsoll" symbol that
// superimposes the characters \circ and \mathminus. Used in chemistry.
$ef0731f441f79e9a$export$1c70906d0a09453f("\\minuso", "\\mathbin{\\html@mathml{{\\mathrlap{\\mathchoice{\\kern{0.145em}}{\\kern{0.145em}}{\\kern{0.1015em}}{\\kern{0.0725em}}\\circ}{-}}}{\\char`\u29B5}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\u29B5", "\\minuso");
//////////////////////////////////////////////////////////////////////
// texvc.sty
// The texvc package contains macros available in mediawiki pages.
// We omit the functions deprecated at
// https://en.wikipedia.org/wiki/Help:Displaying_a_formula#Deprecated_syntax
// We also omit texvc's \O, which conflicts with \text{\O}
$ef0731f441f79e9a$export$1c70906d0a09453f("\\darr", "\\downarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\dArr", "\\Downarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Darr", "\\Downarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\lang", "\\langle");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\rang", "\\rangle");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\uarr", "\\uparrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\uArr", "\\Uparrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Uarr", "\\Uparrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\N", "\\mathbb{N}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\R", "\\mathbb{R}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Z", "\\mathbb{Z}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\alef", "\\aleph");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\alefsym", "\\aleph");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Alpha", "\\mathrm{A}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Beta", "\\mathrm{B}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\bull", "\\bullet");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Chi", "\\mathrm{X}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\clubs", "\\clubsuit");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\cnums", "\\mathbb{C}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Complex", "\\mathbb{C}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Dagger", "\\ddagger");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\diamonds", "\\diamondsuit");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\empty", "\\emptyset");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Epsilon", "\\mathrm{E}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Eta", "\\mathrm{H}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\exist", "\\exists");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\harr", "\\leftrightarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\hArr", "\\Leftrightarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Harr", "\\Leftrightarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\hearts", "\\heartsuit");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\image", "\\Im");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\infin", "\\infty");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Iota", "\\mathrm{I}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\isin", "\\in");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Kappa", "\\mathrm{K}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\larr", "\\leftarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\lArr", "\\Leftarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Larr", "\\Leftarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\lrarr", "\\leftrightarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\lrArr", "\\Leftrightarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Lrarr", "\\Leftrightarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Mu", "\\mathrm{M}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\natnums", "\\mathbb{N}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Nu", "\\mathrm{N}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Omicron", "\\mathrm{O}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\plusmn", "\\pm");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\rarr", "\\rightarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\rArr", "\\Rightarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Rarr", "\\Rightarrow");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\real", "\\Re");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\reals", "\\mathbb{R}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Reals", "\\mathbb{R}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Rho", "\\mathrm{P}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\sdot", "\\cdot");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\sect", "\\S");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\spades", "\\spadesuit");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\sub", "\\subset");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\sube", "\\subseteq");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\supe", "\\supseteq");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Tau", "\\mathrm{T}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\thetasym", "\\vartheta");
// TODO: defineMacro("\\varcoppa", "\\\mbox{\\coppa}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\weierp", "\\wp");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Zeta", "\\mathrm{Z}");
//////////////////////////////////////////////////////////////////////
// statmath.sty
// https://ctan.math.illinois.edu/macros/latex/contrib/statmath/statmath.pdf
$ef0731f441f79e9a$export$1c70906d0a09453f("\\argmin", "\\DOTSB\\operatorname*{arg\\,min}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\argmax", "\\DOTSB\\operatorname*{arg\\,max}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\plim", "\\DOTSB\\mathop{\\operatorname{plim}}\\limits");
//////////////////////////////////////////////////////////////////////
// braket.sty
// http://ctan.math.washington.edu/tex-archive/macros/latex/contrib/braket/braket.pdf
$ef0731f441f79e9a$export$1c70906d0a09453f("\\bra", "\\mathinner{\\langle{#1}|}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\ket", "\\mathinner{|{#1}\\rangle}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\braket", "\\mathinner{\\langle{#1}\\rangle}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Bra", "\\left\\langle#1\\right|");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Ket", "\\left|#1\\right\\rangle");
var $ef0731f441f79e9a$var$braketHelper = (one)=>(context)=>{
        var left = context.consumeArg().tokens;
        var middle = context.consumeArg().tokens;
        var middleDouble = context.consumeArg().tokens;
        var right = context.consumeArg().tokens;
        var oldMiddle = context.macros.get("|");
        var oldMiddleDouble = context.macros.get("\\|");
        context.macros.beginGroup();
        var midMacro = (double)=>(context)=>{
                if (one) {
                    // Only modify the first instance of | or \|
                    context.macros.set("|", oldMiddle);
                    if (middleDouble.length) context.macros.set("\\|", oldMiddleDouble);
                }
                var doubled = double;
                if (!double && middleDouble.length) {
                    // Mimic \@ifnextchar
                    var nextToken = context.future();
                    if (nextToken.text === "|") {
                        context.popToken();
                        doubled = true;
                    }
                }
                return {
                    tokens: doubled ? middleDouble : middle,
                    numArgs: 0
                };
            };
        context.macros.set("|", midMacro(false));
        if (middleDouble.length) context.macros.set("\\|", midMacro(true));
        var arg = context.consumeArg().tokens;
        var expanded = context.expandTokens([
            ...right,
            ...arg,
            ...left // reversed
        ]);
        context.macros.endGroup();
        return {
            tokens: expanded.reverse(),
            numArgs: 0
        };
    };
$ef0731f441f79e9a$export$1c70906d0a09453f("\\bra@ket", $ef0731f441f79e9a$var$braketHelper(false));
$ef0731f441f79e9a$export$1c70906d0a09453f("\\bra@set", $ef0731f441f79e9a$var$braketHelper(true));
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Braket", "\\bra@ket{\\left\\langle}{\\,\\middle\\vert\\,}{\\,\\middle\\vert\\,}{\\right\\rangle}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\Set", "\\bra@set{\\left\\{\\:}{\\;\\middle\\vert\\;}{\\;\\middle\\Vert\\;}{\\:\\right\\}}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\set", "\\bra@set{\\{\\,}{\\mid}{}{\\,\\}}");
// has no support for special || or \|
//////////////////////////////////////////////////////////////////////
// actuarialangle.dtx
$ef0731f441f79e9a$export$1c70906d0a09453f("\\angln", "{\\angl n}");
// Custom Khan Academy colors, should be moved to an optional package
$ef0731f441f79e9a$export$1c70906d0a09453f("\\blue", "\\textcolor{##6495ed}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\orange", "\\textcolor{##ffa500}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\pink", "\\textcolor{##ff00af}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\red", "\\textcolor{##df0030}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\green", "\\textcolor{##28ae7b}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\gray", "\\textcolor{gray}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\purple", "\\textcolor{##9d38bd}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\blueA", "\\textcolor{##ccfaff}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\blueB", "\\textcolor{##80f6ff}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\blueC", "\\textcolor{##63d9ea}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\blueD", "\\textcolor{##11accd}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\blueE", "\\textcolor{##0c7f99}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\tealA", "\\textcolor{##94fff5}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\tealB", "\\textcolor{##26edd5}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\tealC", "\\textcolor{##01d1c1}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\tealD", "\\textcolor{##01a995}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\tealE", "\\textcolor{##208170}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\greenA", "\\textcolor{##b6ffb0}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\greenB", "\\textcolor{##8af281}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\greenC", "\\textcolor{##74cf70}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\greenD", "\\textcolor{##1fab54}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\greenE", "\\textcolor{##0d923f}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\goldA", "\\textcolor{##ffd0a9}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\goldB", "\\textcolor{##ffbb71}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\goldC", "\\textcolor{##ff9c39}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\goldD", "\\textcolor{##e07d10}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\goldE", "\\textcolor{##a75a05}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\redA", "\\textcolor{##fca9a9}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\redB", "\\textcolor{##ff8482}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\redC", "\\textcolor{##f9685d}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\redD", "\\textcolor{##e84d39}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\redE", "\\textcolor{##bc2612}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\maroonA", "\\textcolor{##ffbde0}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\maroonB", "\\textcolor{##ff92c6}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\maroonC", "\\textcolor{##ed5fa6}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\maroonD", "\\textcolor{##ca337c}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\maroonE", "\\textcolor{##9e034e}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\purpleA", "\\textcolor{##ddd7ff}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\purpleB", "\\textcolor{##c6b9fc}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\purpleC", "\\textcolor{##aa87ff}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\purpleD", "\\textcolor{##7854ab}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\purpleE", "\\textcolor{##543b78}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\mintA", "\\textcolor{##f5f9e8}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\mintB", "\\textcolor{##edf2df}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\mintC", "\\textcolor{##e0e5cc}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\grayA", "\\textcolor{##f6f7f7}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\grayB", "\\textcolor{##f0f1f2}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\grayC", "\\textcolor{##e3e5e6}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\grayD", "\\textcolor{##d6d8da}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\grayE", "\\textcolor{##babec2}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\grayF", "\\textcolor{##888d93}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\grayG", "\\textcolor{##626569}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\grayH", "\\textcolor{##3b3e40}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\grayI", "\\textcolor{##21242c}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\kaBlue", "\\textcolor{##314453}{#1}");
$ef0731f441f79e9a$export$1c70906d0a09453f("\\kaGreen", "\\textcolor{##71B307}{#1}");
/**
 * This file contains the “gullet” where macros are expanded
 * until only non-macro tokens remain.
 */ // List of commands that act like macros but aren't defined as a macro,
// function, or symbol.  Used in `isDefined`.
var $ef0731f441f79e9a$var$implicitCommands = {
    "^": true,
    // Parser.js
    "_": true,
    // Parser.js
    "\\limits": true,
    // Parser.js
    "\\nolimits": true // Parser.js
};
class $ef0731f441f79e9a$var$MacroExpander {
    constructor(input, settings, mode){
        this.settings = void 0;
        this.expansionCount = void 0;
        this.lexer = void 0;
        this.macros = void 0;
        this.stack = void 0;
        this.mode = void 0;
        this.settings = settings;
        this.expansionCount = 0;
        this.feed(input);
        // Make new global namespace
        this.macros = new $ef0731f441f79e9a$var$Namespace($ef0731f441f79e9a$var$macros, settings.macros);
        this.mode = mode;
        this.stack = []; // contains tokens in REVERSE order
    }
    /**
   * Feed a new input string to the same MacroExpander
   * (with existing macros etc.).
   */ feed(input) {
        this.lexer = new $ef0731f441f79e9a$var$Lexer(input, this.settings);
    }
    /**
   * Switches between "text" and "math" modes.
   */ switchMode(newMode) {
        this.mode = newMode;
    }
    /**
   * Start a new group nesting within all namespaces.
   */ beginGroup() {
        this.macros.beginGroup();
    }
    /**
   * End current group nesting within all namespaces.
   */ endGroup() {
        this.macros.endGroup();
    }
    /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */ endGroups() {
        this.macros.endGroups();
    }
    /**
   * Returns the topmost token on the stack, without expanding it.
   * Similar in behavior to TeX's `\futurelet`.
   */ future() {
        if (this.stack.length === 0) this.pushToken(this.lexer.lex());
        return this.stack[this.stack.length - 1];
    }
    /**
   * Remove and return the next unexpanded token.
   */ popToken() {
        this.future(); // ensure non-empty stack
        return this.stack.pop();
    }
    /**
   * Add a given token to the token stack.  In particular, this get be used
   * to put back a token returned from one of the other methods.
   */ pushToken(token) {
        this.stack.push(token);
    }
    /**
   * Append an array of tokens to the token stack.
   */ pushTokens(tokens) {
        this.stack.push(...tokens);
    }
    /**
   * Find an macro argument without expanding tokens and append the array of
   * tokens to the token stack. Uses Token as a container for the result.
   */ scanArgument(isOptional) {
        var start;
        var end;
        var tokens;
        if (isOptional) {
            this.consumeSpaces(); // \@ifnextchar gobbles any space following it
            if (this.future().text !== "[") return null;
            start = this.popToken(); // don't include [ in tokens
            ({ tokens: tokens, end: end } = this.consumeArg([
                "]"
            ]));
        } else ({ tokens: tokens, start: start, end: end } = this.consumeArg());
        // indicate the end of an argument
        this.pushToken(new $ef0731f441f79e9a$var$Token("EOF", end.loc));
        this.pushTokens(tokens);
        return new $ef0731f441f79e9a$var$Token("", $ef0731f441f79e9a$var$SourceLocation.range(start, end));
    }
    /**
   * Consume all following space tokens, without expansion.
   */ consumeSpaces() {
        for(;;){
            var token = this.future();
            if (token.text === " ") this.stack.pop();
            else break;
        }
    }
    /**
   * Consume an argument from the token stream, and return the resulting array
   * of tokens and start/end token.
   */ consumeArg(delims) {
        // The argument for a delimited parameter is the shortest (possibly
        // empty) sequence of tokens with properly nested {...} groups that is
        // followed ... by this particular list of non-parameter tokens.
        // The argument for an undelimited parameter is the next nonblank
        // token, unless that token is ‘{’, when the argument will be the
        // entire {...} group that follows.
        var tokens = [];
        var isDelimited = delims && delims.length > 0;
        if (!isDelimited) // Ignore spaces between arguments.  As the TeXbook says:
        // "After you have said ‘\def\row#1#2{...}’, you are allowed to
        //  put spaces between the arguments (e.g., ‘\row x n’), because
        //  TeX doesn’t use single spaces as undelimited arguments."
        this.consumeSpaces();
        var start = this.future();
        var tok;
        var depth = 0;
        var match = 0;
        do {
            tok = this.popToken();
            tokens.push(tok);
            if (tok.text === "{") ++depth;
            else if (tok.text === "}") {
                --depth;
                if (depth === -1) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Extra }", tok);
            } else if (tok.text === "EOF") throw new $ef0731f441f79e9a$export$f9c837a54db411d("Unexpected end of input in a macro argument, expected '" + (delims && isDelimited ? delims[match] : "}") + "'", tok);
            if (delims && isDelimited) {
                if ((depth === 0 || depth === 1 && delims[match] === "{") && tok.text === delims[match]) {
                    ++match;
                    if (match === delims.length) {
                        // don't include delims in tokens
                        tokens.splice(-match, match);
                        break;
                    }
                } else match = 0;
            }
        }while (depth !== 0 || isDelimited);
        // If the argument found ... has the form ‘{<nested tokens>}’,
        // ... the outermost braces enclosing the argument are removed
        if (start.text === "{" && tokens[tokens.length - 1].text === "}") {
            tokens.pop();
            tokens.shift();
        }
        tokens.reverse(); // to fit in with stack order
        return {
            tokens: tokens,
            start: start,
            end: tok
        };
    }
    /**
   * Consume the specified number of (delimited) arguments from the token
   * stream and return the resulting array of arguments.
   */ consumeArgs(numArgs, delimiters) {
        if (delimiters) {
            if (delimiters.length !== numArgs + 1) throw new $ef0731f441f79e9a$export$f9c837a54db411d("The length of delimiters doesn't match the number of args!");
            var delims = delimiters[0];
            for(var i = 0; i < delims.length; i++){
                var tok = this.popToken();
                if (delims[i] !== tok.text) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Use of the macro doesn't match its definition", tok);
            }
        }
        var args = [];
        for(var _i = 0; _i < numArgs; _i++)args.push(this.consumeArg(delimiters && delimiters[_i + 1]).tokens);
        return args;
    }
    /**
   * Increment `expansionCount` by the specified amount.
   * Throw an error if it exceeds `maxExpand`.
   */ countExpansion(amount) {
        this.expansionCount += amount;
        if (this.expansionCount > this.settings.maxExpand) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Too many expansions: infinite loop or need to increase maxExpand setting");
    }
    /**
   * Expand the next token only once if possible.
   *
   * If the token is expanded, the resulting tokens will be pushed onto
   * the stack in reverse order, and the number of such tokens will be
   * returned.  This number might be zero or positive.
   *
   * If not, the return value is `false`, and the next token remains at the
   * top of the stack.
   *
   * In either case, the next token will be on the top of the stack,
   * or the stack will be empty (in case of empty expansion
   * and no other tokens).
   *
   * Used to implement `expandAfterFuture` and `expandNextToken`.
   *
   * If expandableOnly, only expandable tokens are expanded and
   * an undefined control sequence results in an error.
   */ expandOnce(expandableOnly) {
        var topToken = this.popToken();
        var name = topToken.text;
        var expansion = !topToken.noexpand ? this._getExpansion(name) : null;
        if (expansion == null || expandableOnly && expansion.unexpandable) {
            if (expandableOnly && expansion == null && name[0] === "\\" && !this.isDefined(name)) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Undefined control sequence: " + name);
            this.pushToken(topToken);
            return false;
        }
        this.countExpansion(1);
        var tokens = expansion.tokens;
        var args = this.consumeArgs(expansion.numArgs, expansion.delimiters);
        if (expansion.numArgs) {
            // paste arguments in place of the placeholders
            tokens = tokens.slice(); // make a shallow copy
            for(var i = tokens.length - 1; i >= 0; --i){
                var tok = tokens[i];
                if (tok.text === "#") {
                    if (i === 0) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Incomplete placeholder at end of macro body", tok);
                    tok = tokens[--i]; // next token on stack
                    if (tok.text === "#") // ## → #
                    tokens.splice(i + 1, 1); // drop first #
                    else if (/^[1-9]$/.test(tok.text)) // replace the placeholder with the indicated argument
                    tokens.splice(i, 2, ...args[+tok.text - 1]);
                    else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Not a valid argument number", tok);
                }
            }
        }
        // Concatenate expansion onto top of stack.
        this.pushTokens(tokens);
        return tokens.length;
    }
    /**
   * Expand the next token only once (if possible), and return the resulting
   * top token on the stack (without removing anything from the stack).
   * Similar in behavior to TeX's `\expandafter\futurelet`.
   * Equivalent to expandOnce() followed by future().
   */ expandAfterFuture() {
        this.expandOnce();
        return this.future();
    }
    /**
   * Recursively expand first token, then return first non-expandable token.
   */ expandNextToken() {
        for(;;)if (this.expandOnce() === false) {
            // fully expanded
            var token = this.stack.pop();
            // the token after \noexpand is interpreted as if its meaning
            // were ‘\relax’
            if (token.treatAsRelax) token.text = "\\relax";
            return token;
        }
    }
    /**
   * Fully expand the given macro name and return the resulting list of
   * tokens, or return `undefined` if no such macro is defined.
   */ expandMacro(name) {
        return this.macros.has(name) ? this.expandTokens([
            new $ef0731f441f79e9a$var$Token(name)
        ]) : undefined;
    }
    /**
   * Fully expand the given token stream and return the resulting list of
   * tokens.  Note that the input tokens are in reverse order, but the
   * output tokens are in forward order.
   */ expandTokens(tokens) {
        var output = [];
        var oldStackLength = this.stack.length;
        this.pushTokens(tokens);
        while(this.stack.length > oldStackLength)// Expand only expandable tokens
        if (this.expandOnce(true) === false) {
            // fully expanded
            var token = this.stack.pop();
            if (token.treatAsRelax) {
                // the expansion of \noexpand is the token itself
                token.noexpand = false;
                token.treatAsRelax = false;
            }
            output.push(token);
        }
        // Count all of these tokens as additional expansions, to prevent
        // exponential blowup from linearly many \edef's.
        this.countExpansion(output.length);
        return output;
    }
    /**
   * Fully expand the given macro name and return the result as a string,
   * or return `undefined` if no such macro is defined.
   */ expandMacroAsText(name) {
        var tokens = this.expandMacro(name);
        if (tokens) return tokens.map((token)=>token.text).join("");
        else return tokens;
    }
    /**
   * Returns the expanded macro as a reversed array of tokens and a macro
   * argument count.  Or returns `null` if no such macro.
   */ _getExpansion(name) {
        var definition = this.macros.get(name);
        if (definition == null) // mainly checking for undefined here
        return definition;
        // If a single character has an associated catcode other than 13
        // (active character), then don't expand it.
        if (name.length === 1) {
            var catcode = this.lexer.catcodes[name];
            if (catcode != null && catcode !== 13) return;
        }
        var expansion = typeof definition === "function" ? definition(this) : definition;
        if (typeof expansion === "string") {
            var numArgs = 0;
            if (expansion.includes("#")) {
                var stripped = expansion.replace(/##/g, "");
                while(stripped.includes("#" + (numArgs + 1)))++numArgs;
            }
            var bodyLexer = new $ef0731f441f79e9a$var$Lexer(expansion, this.settings);
            var tokens = [];
            var tok = bodyLexer.lex();
            while(tok.text !== "EOF"){
                tokens.push(tok);
                tok = bodyLexer.lex();
            }
            tokens.reverse(); // to fit in with stack using push and pop
            var expanded = {
                tokens: tokens,
                numArgs: numArgs
            };
            return expanded;
        }
        return expansion;
    }
    /**
   * Determine whether a command is currently "defined" (has some
   * functionality), meaning that it's a macro (in the current group),
   * a function, a symbol, or one of the special commands listed in
   * `implicitCommands`.
   */ isDefined(name) {
        return this.macros.has(name) || $ef0731f441f79e9a$var$functions.hasOwnProperty(name) || $ef0731f441f79e9a$var$symbols.math.hasOwnProperty(name) || $ef0731f441f79e9a$var$symbols.text.hasOwnProperty(name) || $ef0731f441f79e9a$var$implicitCommands.hasOwnProperty(name);
    }
    /**
   * Determine whether a command is expandable.
   */ isExpandable(name) {
        var macro = this.macros.get(name);
        return macro != null ? typeof macro === "string" || typeof macro === "function" || !macro.unexpandable : $ef0731f441f79e9a$var$functions.hasOwnProperty(name) && !$ef0731f441f79e9a$var$functions[name].primitive;
    }
}
// Helpers for Parser.js handling of Unicode (sub|super)script characters.
var $ef0731f441f79e9a$var$unicodeSubRegEx = /^[₊₋₌₍₎₀₁₂₃₄₅₆₇₈₉ₐₑₕᵢⱼₖₗₘₙₒₚᵣₛₜᵤᵥₓᵦᵧᵨᵩᵪ]/;
var $ef0731f441f79e9a$var$uSubsAndSups = Object.freeze({
    "\u208A": '+',
    "\u208B": '-',
    "\u208C": '=',
    "\u208D": '(',
    "\u208E": ')',
    "\u2080": '0',
    "\u2081": '1',
    "\u2082": '2',
    "\u2083": '3',
    "\u2084": '4',
    "\u2085": '5',
    "\u2086": '6',
    "\u2087": '7',
    "\u2088": '8',
    "\u2089": '9',
    '\u2090': 'a',
    '\u2091': 'e',
    '\u2095': 'h',
    '\u1D62': 'i',
    '\u2C7C': 'j',
    '\u2096': 'k',
    '\u2097': 'l',
    '\u2098': 'm',
    '\u2099': 'n',
    '\u2092': 'o',
    '\u209A': 'p',
    '\u1D63': 'r',
    '\u209B': 's',
    '\u209C': 't',
    '\u1D64': 'u',
    '\u1D65': 'v',
    '\u2093': 'x',
    '\u1D66': "\u03B2",
    '\u1D67': "\u03B3",
    '\u1D68': "\u03C1",
    '\u1D69': '\u03d5',
    '\u1D6A': "\u03C7",
    "\u207A": '+',
    "\u207B": '-',
    "\u207C": '=',
    "\u207D": '(',
    "\u207E": ')',
    "\u2070": '0',
    "\xb9": '1',
    "\xb2": '2',
    "\xb3": '3',
    "\u2074": '4',
    "\u2075": '5',
    "\u2076": '6',
    "\u2077": '7',
    "\u2078": '8',
    "\u2079": '9',
    '\u1D2C': 'A',
    '\u1D2E': 'B',
    '\u1D30': 'D',
    '\u1D31': 'E',
    '\u1D33': 'G',
    '\u1D34': 'H',
    '\u1D35': 'I',
    '\u1D36': 'J',
    '\u1D37': 'K',
    '\u1D38': 'L',
    '\u1D39': 'M',
    '\u1D3A': 'N',
    '\u1D3C': 'O',
    '\u1D3E': 'P',
    '\u1D3F': 'R',
    '\u1D40': 'T',
    '\u1D41': 'U',
    '\u2C7D': 'V',
    '\u1D42': 'W',
    '\u1D43': 'a',
    '\u1D47': 'b',
    '\u1D9C': 'c',
    '\u1D48': 'd',
    '\u1D49': 'e',
    '\u1DA0': 'f',
    '\u1D4D': 'g',
    '\u02B0': 'h',
    '\u2071': 'i',
    '\u02B2': 'j',
    '\u1D4F': 'k',
    '\u02E1': 'l',
    '\u1D50': 'm',
    '\u207F': 'n',
    '\u1D52': 'o',
    '\u1D56': 'p',
    '\u02B3': 'r',
    '\u02E2': 's',
    '\u1D57': 't',
    '\u1D58': 'u',
    '\u1D5B': 'v',
    '\u02B7': 'w',
    '\u02E3': 'x',
    '\u02B8': 'y',
    '\u1DBB': 'z',
    '\u1D5D': "\u03B2",
    '\u1D5E': "\u03B3",
    '\u1D5F': "\u03B4",
    '\u1D60': '\u03d5',
    '\u1D61': "\u03C7",
    '\u1DBF': "\u03B8"
});
/* eslint no-constant-condition:0 */ // Pre-evaluate both modules as unicodeSymbols require String.normalize()
var $ef0731f441f79e9a$var$unicodeAccents = {
    "\u0301": {
        "text": "\\'",
        "math": "\\acute"
    },
    "\u0300": {
        "text": "\\`",
        "math": "\\grave"
    },
    "\u0308": {
        "text": "\\\"",
        "math": "\\ddot"
    },
    "\u0303": {
        "text": "\\~",
        "math": "\\tilde"
    },
    "\u0304": {
        "text": "\\=",
        "math": "\\bar"
    },
    "\u0306": {
        "text": "\\u",
        "math": "\\breve"
    },
    "\u030C": {
        "text": "\\v",
        "math": "\\check"
    },
    "\u0302": {
        "text": "\\^",
        "math": "\\hat"
    },
    "\u0307": {
        "text": "\\.",
        "math": "\\dot"
    },
    "\u030A": {
        "text": "\\r",
        "math": "\\mathring"
    },
    "\u030B": {
        "text": "\\H"
    },
    "\u0327": {
        "text": "\\c"
    }
};
var $ef0731f441f79e9a$var$unicodeSymbols = {
    "\xe1": "a\u0301",
    "\xe0": "a\u0300",
    "\xe4": "a\u0308",
    "\u01DF": "a\u0308\u0304",
    "\xe3": "a\u0303",
    "\u0101": "a\u0304",
    "\u0103": "a\u0306",
    "\u1EAF": "a\u0306\u0301",
    "\u1EB1": "a\u0306\u0300",
    "\u1EB5": "a\u0306\u0303",
    "\u01CE": "a\u030C",
    "\xe2": "a\u0302",
    "\u1EA5": "a\u0302\u0301",
    "\u1EA7": "a\u0302\u0300",
    "\u1EAB": "a\u0302\u0303",
    "\u0227": "a\u0307",
    "\u01E1": "a\u0307\u0304",
    "\xe5": "a\u030A",
    "\u01FB": "a\u030A\u0301",
    "\u1E03": "b\u0307",
    "\u0107": "c\u0301",
    "\u1E09": "c\u0327\u0301",
    "\u010D": "c\u030C",
    "\u0109": "c\u0302",
    "\u010B": "c\u0307",
    "\xe7": "c\u0327",
    "\u010F": "d\u030C",
    "\u1E0B": "d\u0307",
    "\u1E11": "d\u0327",
    "\xe9": "e\u0301",
    "\xe8": "e\u0300",
    "\xeb": "e\u0308",
    "\u1EBD": "e\u0303",
    "\u0113": "e\u0304",
    "\u1E17": "e\u0304\u0301",
    "\u1E15": "e\u0304\u0300",
    "\u0115": "e\u0306",
    "\u1E1D": "e\u0327\u0306",
    "\u011B": "e\u030C",
    "\xea": "e\u0302",
    "\u1EBF": "e\u0302\u0301",
    "\u1EC1": "e\u0302\u0300",
    "\u1EC5": "e\u0302\u0303",
    "\u0117": "e\u0307",
    "\u0229": "e\u0327",
    "\u1E1F": "f\u0307",
    "\u01F5": "g\u0301",
    "\u1E21": "g\u0304",
    "\u011F": "g\u0306",
    "\u01E7": "g\u030C",
    "\u011D": "g\u0302",
    "\u0121": "g\u0307",
    "\u0123": "g\u0327",
    "\u1E27": "h\u0308",
    "\u021F": "h\u030C",
    "\u0125": "h\u0302",
    "\u1E23": "h\u0307",
    "\u1E29": "h\u0327",
    "\xed": "i\u0301",
    "\xec": "i\u0300",
    "\xef": "i\u0308",
    "\u1E2F": "i\u0308\u0301",
    "\u0129": "i\u0303",
    "\u012B": "i\u0304",
    "\u012D": "i\u0306",
    "\u01D0": "i\u030C",
    "\xee": "i\u0302",
    "\u01F0": "j\u030C",
    "\u0135": "j\u0302",
    "\u1E31": "k\u0301",
    "\u01E9": "k\u030C",
    "\u0137": "k\u0327",
    "\u013A": "l\u0301",
    "\u013E": "l\u030C",
    "\u013C": "l\u0327",
    "\u1E3F": "m\u0301",
    "\u1E41": "m\u0307",
    "\u0144": "n\u0301",
    "\u01F9": "n\u0300",
    "\xf1": "n\u0303",
    "\u0148": "n\u030C",
    "\u1E45": "n\u0307",
    "\u0146": "n\u0327",
    "\xf3": "o\u0301",
    "\xf2": "o\u0300",
    "\xf6": "o\u0308",
    "\u022B": "o\u0308\u0304",
    "\xf5": "o\u0303",
    "\u1E4D": "o\u0303\u0301",
    "\u1E4F": "o\u0303\u0308",
    "\u022D": "o\u0303\u0304",
    "\u014D": "o\u0304",
    "\u1E53": "o\u0304\u0301",
    "\u1E51": "o\u0304\u0300",
    "\u014F": "o\u0306",
    "\u01D2": "o\u030C",
    "\xf4": "o\u0302",
    "\u1ED1": "o\u0302\u0301",
    "\u1ED3": "o\u0302\u0300",
    "\u1ED7": "o\u0302\u0303",
    "\u022F": "o\u0307",
    "\u0231": "o\u0307\u0304",
    "\u0151": "o\u030B",
    "\u1E55": "p\u0301",
    "\u1E57": "p\u0307",
    "\u0155": "r\u0301",
    "\u0159": "r\u030C",
    "\u1E59": "r\u0307",
    "\u0157": "r\u0327",
    "\u015B": "s\u0301",
    "\u1E65": "s\u0301\u0307",
    "\u0161": "s\u030C",
    "\u1E67": "s\u030C\u0307",
    "\u015D": "s\u0302",
    "\u1E61": "s\u0307",
    "\u015F": "s\u0327",
    "\u1E97": "t\u0308",
    "\u0165": "t\u030C",
    "\u1E6B": "t\u0307",
    "\u0163": "t\u0327",
    "\xfa": "u\u0301",
    "\xf9": "u\u0300",
    "\xfc": "u\u0308",
    "\u01D8": "u\u0308\u0301",
    "\u01DC": "u\u0308\u0300",
    "\u01D6": "u\u0308\u0304",
    "\u01DA": "u\u0308\u030C",
    "\u0169": "u\u0303",
    "\u1E79": "u\u0303\u0301",
    "\u016B": "u\u0304",
    "\u1E7B": "u\u0304\u0308",
    "\u016D": "u\u0306",
    "\u01D4": "u\u030C",
    "\xfb": "u\u0302",
    "\u016F": "u\u030A",
    "\u0171": "u\u030B",
    "\u1E7D": "v\u0303",
    "\u1E83": "w\u0301",
    "\u1E81": "w\u0300",
    "\u1E85": "w\u0308",
    "\u0175": "w\u0302",
    "\u1E87": "w\u0307",
    "\u1E98": "w\u030A",
    "\u1E8D": "x\u0308",
    "\u1E8B": "x\u0307",
    "\xfd": "y\u0301",
    "\u1EF3": "y\u0300",
    "\xff": "y\u0308",
    "\u1EF9": "y\u0303",
    "\u0233": "y\u0304",
    "\u0177": "y\u0302",
    "\u1E8F": "y\u0307",
    "\u1E99": "y\u030A",
    "\u017A": "z\u0301",
    "\u017E": "z\u030C",
    "\u1E91": "z\u0302",
    "\u017C": "z\u0307",
    "\xc1": "A\u0301",
    "\xc0": "A\u0300",
    "\xc4": "A\u0308",
    "\u01DE": "A\u0308\u0304",
    "\xc3": "A\u0303",
    "\u0100": "A\u0304",
    "\u0102": "A\u0306",
    "\u1EAE": "A\u0306\u0301",
    "\u1EB0": "A\u0306\u0300",
    "\u1EB4": "A\u0306\u0303",
    "\u01CD": "A\u030C",
    "\xc2": "A\u0302",
    "\u1EA4": "A\u0302\u0301",
    "\u1EA6": "A\u0302\u0300",
    "\u1EAA": "A\u0302\u0303",
    "\u0226": "A\u0307",
    "\u01E0": "A\u0307\u0304",
    "\xc5": "A\u030A",
    "\u01FA": "A\u030A\u0301",
    "\u1E02": "B\u0307",
    "\u0106": "C\u0301",
    "\u1E08": "C\u0327\u0301",
    "\u010C": "C\u030C",
    "\u0108": "C\u0302",
    "\u010A": "C\u0307",
    "\xc7": "C\u0327",
    "\u010E": "D\u030C",
    "\u1E0A": "D\u0307",
    "\u1E10": "D\u0327",
    "\xc9": "E\u0301",
    "\xc8": "E\u0300",
    "\xcb": "E\u0308",
    "\u1EBC": "E\u0303",
    "\u0112": "E\u0304",
    "\u1E16": "E\u0304\u0301",
    "\u1E14": "E\u0304\u0300",
    "\u0114": "E\u0306",
    "\u1E1C": "E\u0327\u0306",
    "\u011A": "E\u030C",
    "\xca": "E\u0302",
    "\u1EBE": "E\u0302\u0301",
    "\u1EC0": "E\u0302\u0300",
    "\u1EC4": "E\u0302\u0303",
    "\u0116": "E\u0307",
    "\u0228": "E\u0327",
    "\u1E1E": "F\u0307",
    "\u01F4": "G\u0301",
    "\u1E20": "G\u0304",
    "\u011E": "G\u0306",
    "\u01E6": "G\u030C",
    "\u011C": "G\u0302",
    "\u0120": "G\u0307",
    "\u0122": "G\u0327",
    "\u1E26": "H\u0308",
    "\u021E": "H\u030C",
    "\u0124": "H\u0302",
    "\u1E22": "H\u0307",
    "\u1E28": "H\u0327",
    "\xcd": "I\u0301",
    "\xcc": "I\u0300",
    "\xcf": "I\u0308",
    "\u1E2E": "I\u0308\u0301",
    "\u0128": "I\u0303",
    "\u012A": "I\u0304",
    "\u012C": "I\u0306",
    "\u01CF": "I\u030C",
    "\xce": "I\u0302",
    "\u0130": "I\u0307",
    "\u0134": "J\u0302",
    "\u1E30": "K\u0301",
    "\u01E8": "K\u030C",
    "\u0136": "K\u0327",
    "\u0139": "L\u0301",
    "\u013D": "L\u030C",
    "\u013B": "L\u0327",
    "\u1E3E": "M\u0301",
    "\u1E40": "M\u0307",
    "\u0143": "N\u0301",
    "\u01F8": "N\u0300",
    "\xd1": "N\u0303",
    "\u0147": "N\u030C",
    "\u1E44": "N\u0307",
    "\u0145": "N\u0327",
    "\xd3": "O\u0301",
    "\xd2": "O\u0300",
    "\xd6": "O\u0308",
    "\u022A": "O\u0308\u0304",
    "\xd5": "O\u0303",
    "\u1E4C": "O\u0303\u0301",
    "\u1E4E": "O\u0303\u0308",
    "\u022C": "O\u0303\u0304",
    "\u014C": "O\u0304",
    "\u1E52": "O\u0304\u0301",
    "\u1E50": "O\u0304\u0300",
    "\u014E": "O\u0306",
    "\u01D1": "O\u030C",
    "\xd4": "O\u0302",
    "\u1ED0": "O\u0302\u0301",
    "\u1ED2": "O\u0302\u0300",
    "\u1ED6": "O\u0302\u0303",
    "\u022E": "O\u0307",
    "\u0230": "O\u0307\u0304",
    "\u0150": "O\u030B",
    "\u1E54": "P\u0301",
    "\u1E56": "P\u0307",
    "\u0154": "R\u0301",
    "\u0158": "R\u030C",
    "\u1E58": "R\u0307",
    "\u0156": "R\u0327",
    "\u015A": "S\u0301",
    "\u1E64": "S\u0301\u0307",
    "\u0160": "S\u030C",
    "\u1E66": "S\u030C\u0307",
    "\u015C": "S\u0302",
    "\u1E60": "S\u0307",
    "\u015E": "S\u0327",
    "\u0164": "T\u030C",
    "\u1E6A": "T\u0307",
    "\u0162": "T\u0327",
    "\xda": "U\u0301",
    "\xd9": "U\u0300",
    "\xdc": "U\u0308",
    "\u01D7": "U\u0308\u0301",
    "\u01DB": "U\u0308\u0300",
    "\u01D5": "U\u0308\u0304",
    "\u01D9": "U\u0308\u030C",
    "\u0168": "U\u0303",
    "\u1E78": "U\u0303\u0301",
    "\u016A": "U\u0304",
    "\u1E7A": "U\u0304\u0308",
    "\u016C": "U\u0306",
    "\u01D3": "U\u030C",
    "\xdb": "U\u0302",
    "\u016E": "U\u030A",
    "\u0170": "U\u030B",
    "\u1E7C": "V\u0303",
    "\u1E82": "W\u0301",
    "\u1E80": "W\u0300",
    "\u1E84": "W\u0308",
    "\u0174": "W\u0302",
    "\u1E86": "W\u0307",
    "\u1E8C": "X\u0308",
    "\u1E8A": "X\u0307",
    "\xdd": "Y\u0301",
    "\u1EF2": "Y\u0300",
    "\u0178": "Y\u0308",
    "\u1EF8": "Y\u0303",
    "\u0232": "Y\u0304",
    "\u0176": "Y\u0302",
    "\u1E8E": "Y\u0307",
    "\u0179": "Z\u0301",
    "\u017D": "Z\u030C",
    "\u1E90": "Z\u0302",
    "\u017B": "Z\u0307",
    "\u03AC": "\u03B1\u0301",
    "\u1F70": "\u03B1\u0300",
    "\u1FB1": "\u03B1\u0304",
    "\u1FB0": "\u03B1\u0306",
    "\u03AD": "\u03B5\u0301",
    "\u1F72": "\u03B5\u0300",
    "\u03AE": "\u03B7\u0301",
    "\u1F74": "\u03B7\u0300",
    "\u03AF": "\u03B9\u0301",
    "\u1F76": "\u03B9\u0300",
    "\u03CA": "\u03B9\u0308",
    "\u0390": "\u03B9\u0308\u0301",
    "\u1FD2": "\u03B9\u0308\u0300",
    "\u1FD1": "\u03B9\u0304",
    "\u1FD0": "\u03B9\u0306",
    "\u03CC": "\u03BF\u0301",
    "\u1F78": "\u03BF\u0300",
    "\u03CD": "\u03C5\u0301",
    "\u1F7A": "\u03C5\u0300",
    "\u03CB": "\u03C5\u0308",
    "\u03B0": "\u03C5\u0308\u0301",
    "\u1FE2": "\u03C5\u0308\u0300",
    "\u1FE1": "\u03C5\u0304",
    "\u1FE0": "\u03C5\u0306",
    "\u03CE": "\u03C9\u0301",
    "\u1F7C": "\u03C9\u0300",
    "\u038E": "\u03A5\u0301",
    "\u1FEA": "\u03A5\u0300",
    "\u03AB": "\u03A5\u0308",
    "\u1FE9": "\u03A5\u0304",
    "\u1FE8": "\u03A5\u0306",
    "\u038F": "\u03A9\u0301",
    "\u1FFA": "\u03A9\u0300"
};
/**
 * This file contains the parser used to parse out a TeX expression from the
 * input. Since TeX isn't context-free, standard parsers don't work particularly
 * well.
 *
 * The strategy of this parser is as such:
 *
 * The main functions (the `.parse...` ones) take a position in the current
 * parse string to parse tokens from. The lexer (found in Lexer.js, stored at
 * this.gullet.lexer) also supports pulling out tokens at arbitrary places. When
 * individual tokens are needed at a position, the lexer is called to pull out a
 * token, which is then used.
 *
 * The parser has a property called "mode" indicating the mode that
 * the parser is currently in. Currently it has to be one of "math" or
 * "text", which denotes whether the current environment is a math-y
 * one or a text-y one (e.g. inside \text). Currently, this serves to
 * limit the functions which can be used in text mode.
 *
 * The main functions then return an object which contains the useful data that
 * was parsed at its given point, and a new position at the end of the parsed
 * data. The main functions can call each other and continue the parsing by
 * using the returned position as a new starting point.
 *
 * There are also extra `.handle...` functions, which pull out some reused
 * functionality into self-contained functions.
 *
 * The functions return ParseNodes.
 */ class $ef0731f441f79e9a$var$Parser {
    constructor(input, settings){
        this.mode = void 0;
        this.gullet = void 0;
        this.settings = void 0;
        this.leftrightDepth = void 0;
        this.nextToken = void 0;
        // Start in math mode
        this.mode = "math";
        // Create a new macro expander (gullet) and (indirectly via that) also a
        // new lexer (mouth) for this parser (stomach, in the language of TeX)
        this.gullet = new $ef0731f441f79e9a$var$MacroExpander(input, settings, this.mode);
        // Store the settings for use in parsing
        this.settings = settings;
        // Count leftright depth (for \middle errors)
        this.leftrightDepth = 0;
        this.nextToken = null;
    }
    /**
   * Checks a result to make sure it has the right type, and throws an
   * appropriate error otherwise.
   */ expect(text, consume) {
        if (consume === void 0) consume = true;
        if (this.fetch().text !== text) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Expected '" + text + "', got '" + this.fetch().text + "'", this.fetch());
        if (consume) this.consume();
    }
    /**
   * Discards the current lookahead token, considering it consumed.
   */ consume() {
        this.nextToken = null;
    }
    /**
   * Return the current lookahead token, or if there isn't one (at the
   * beginning, or if the previous lookahead token was consume()d),
   * fetch the next token as the new lookahead token and return it.
   */ fetch() {
        if (this.nextToken == null) this.nextToken = this.gullet.expandNextToken();
        return this.nextToken;
    }
    /**
   * Switches between "text" and "math" modes.
   */ switchMode(newMode) {
        this.mode = newMode;
        this.gullet.switchMode(newMode);
    }
    /**
   * Main parsing function, which parses an entire input.
   */ parse() {
        if (!this.settings.globalGroup) // Create a group namespace for the math expression.
        // (LaTeX creates a new group for every $...$, $$...$$, \[...\].)
        this.gullet.beginGroup();
        // Use old \color behavior (same as LaTeX's \textcolor) if requested.
        // We do this within the group for the math expression, so it doesn't
        // pollute settings.macros.
        if (this.settings.colorIsTextColor) this.gullet.macros.set("\\color", "\\textcolor");
        try {
            // Try to parse the input
            var parse = this.parseExpression(false);
            // If we succeeded, make sure there's an EOF at the end
            this.expect("EOF");
            // End the group namespace for the expression
            if (!this.settings.globalGroup) this.gullet.endGroup();
            return parse;
        // Close any leftover groups in case of a parse error.
        } finally{
            this.gullet.endGroups();
        }
    }
    /**
   * Fully parse a separate sequence of tokens as a separate job.
   * Tokens should be specified in reverse order, as in a MacroDefinition.
   */ subparse(tokens) {
        // Save the next token from the current job.
        var oldToken = this.nextToken;
        this.consume();
        // Run the new job, terminating it with an excess '}'
        this.gullet.pushToken(new $ef0731f441f79e9a$var$Token("}"));
        this.gullet.pushTokens(tokens);
        var parse = this.parseExpression(false);
        this.expect("}");
        // Restore the next token from the current job.
        this.nextToken = oldToken;
        return parse;
    }
    /**
   * Parses an "expression", which is a list of atoms.
   *
   * `breakOnInfix`: Should the parsing stop when we hit infix nodes? This
   *                 happens when functions have higher precedence than infix
   *                 nodes in implicit parses.
   *
   * `breakOnTokenText`: The text of the token that the expression should end
   *                     with, or `null` if something else should end the
   *                     expression.
   */ parseExpression(breakOnInfix, breakOnTokenText) {
        var body = [];
        // Keep adding atoms to the body until we can't parse any more atoms (either
        // we reached the end, a }, or a \right)
        while(true){
            // Ignore spaces in math mode
            if (this.mode === "math") this.consumeSpaces();
            var lex = this.fetch();
            if ($ef0731f441f79e9a$var$Parser.endOfExpression.has(lex.text)) break;
            if (breakOnTokenText && lex.text === breakOnTokenText) break;
            if (breakOnInfix && $ef0731f441f79e9a$var$functions[lex.text] && $ef0731f441f79e9a$var$functions[lex.text].infix) break;
            var atom = this.parseAtom(breakOnTokenText);
            if (!atom) break;
            else if (atom.type === "internal") continue;
            body.push(atom);
        }
        if (this.mode === "text") this.formLigatures(body);
        return this.handleInfixNodes(body);
    }
    /**
   * Rewrites infix operators such as \over with corresponding commands such
   * as \frac.
   *
   * There can only be one infix operator per group.  If there's more than one
   * then the expression is ambiguous.  This can be resolved by adding {}.
   */ handleInfixNodes(body) {
        var overIndex = -1;
        var funcName;
        for(var i = 0; i < body.length; i++){
            var node = body[i];
            if (node.type === "infix") {
                if (overIndex !== -1) throw new $ef0731f441f79e9a$export$f9c837a54db411d("only one infix operator per group", node.token);
                overIndex = i;
                funcName = node.replaceWith;
            }
        }
        if (overIndex !== -1 && funcName) {
            var numerNode;
            var denomNode;
            var numerBody = body.slice(0, overIndex);
            var denomBody = body.slice(overIndex + 1);
            if (numerBody.length === 1 && numerBody[0].type === "ordgroup") numerNode = numerBody[0];
            else numerNode = {
                type: "ordgroup",
                mode: this.mode,
                body: numerBody
            };
            if (denomBody.length === 1 && denomBody[0].type === "ordgroup") denomNode = denomBody[0];
            else denomNode = {
                type: "ordgroup",
                mode: this.mode,
                body: denomBody
            };
            var _node;
            if (funcName === "\\\\abovefrac") _node = this.callFunction(funcName, [
                numerNode,
                body[overIndex],
                denomNode
            ], []);
            else _node = this.callFunction(funcName, [
                numerNode,
                denomNode
            ], []);
            return [
                _node
            ];
        } else return body;
    }
    /**
   * Handle a subscript or superscript with nice errors.
   */ handleSupSubscript(name) {
        var symbolToken = this.fetch();
        var symbol = symbolToken.text;
        this.consume();
        this.consumeSpaces(); // ignore spaces before sup/subscript argument
        // Skip over allowed internal nodes such as \relax
        var group;
        do {
            var _group;
            group = this.parseGroup(name);
        }while (((_group = group) == null ? void 0 : _group.type) === "internal");
        if (!group) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Expected group after '" + symbol + "'", symbolToken);
        return group;
    }
    /**
   * Converts the textual input of an unsupported command into a text node
   * contained within a color node whose color is determined by errorColor
   */ formatUnsupportedCmd(text) {
        var textordArray = [];
        for(var i = 0; i < text.length; i++)textordArray.push({
            type: "textord",
            mode: "text",
            text: text[i]
        });
        var textNode = {
            type: "text",
            mode: this.mode,
            body: textordArray
        };
        var colorNode = {
            type: "color",
            mode: this.mode,
            color: this.settings.errorColor,
            body: [
                textNode
            ]
        };
        return colorNode;
    }
    /**
   * Parses a group with optional super/subscripts.
   */ parseAtom(breakOnTokenText) {
        // The body of an atom is an implicit group, so that things like
        // \left(x\right)^2 work correctly.
        var base = this.parseGroup("atom", breakOnTokenText);
        // Internal nodes (e.g. \relax) cannot support super/subscripts.
        // Instead we will pick up super/subscripts with blank base next round.
        if ((base == null ? void 0 : base.type) === "internal") return base;
        // In text mode, we don't have superscripts or subscripts
        if (this.mode === "text") return base;
        // Note that base may be empty (i.e. null) at this point.
        var superscript;
        var subscript;
        while(true){
            // Guaranteed in math mode, so eat any spaces first.
            this.consumeSpaces();
            // Lex the first token
            var lex = this.fetch();
            if (lex.text === "\\limits" || lex.text === "\\nolimits") {
                // We got a limit control
                if (base && base.type === "op") {
                    var limits = lex.text === "\\limits";
                    base.limits = limits;
                    base.alwaysHandleSupSub = true;
                } else if (base && base.type === "operatorname") {
                    if (base.alwaysHandleSupSub) base.limits = lex.text === "\\limits";
                } else throw new $ef0731f441f79e9a$export$f9c837a54db411d("Limit controls must follow a math operator", lex);
                this.consume();
            } else if (lex.text === "^") {
                // We got a superscript start
                if (superscript) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Double superscript", lex);
                superscript = this.handleSupSubscript("superscript");
            } else if (lex.text === "_") {
                // We got a subscript start
                if (subscript) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Double subscript", lex);
                subscript = this.handleSupSubscript("subscript");
            } else if (lex.text === "'") {
                // We got a prime
                if (superscript) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Double superscript", lex);
                var prime = {
                    type: "textord",
                    mode: this.mode,
                    text: "\\prime"
                };
                // Many primes can be grouped together, so we handle this here
                var primes = [
                    prime
                ];
                this.consume();
                // Keep lexing tokens until we get something that's not a prime
                while(this.fetch().text === "'"){
                    // For each one, add another prime to the list
                    primes.push(prime);
                    this.consume();
                }
                // If there's a superscript following the primes, combine that
                // superscript in with the primes.
                if (this.fetch().text === "^") primes.push(this.handleSupSubscript("superscript"));
                // Put everything into an ordgroup as the superscript
                superscript = {
                    type: "ordgroup",
                    mode: this.mode,
                    body: primes
                };
            } else if ($ef0731f441f79e9a$var$uSubsAndSups[lex.text]) {
                // A Unicode subscript or superscript character.
                // We treat these similarly to the unicode-math package.
                // So we render a string of Unicode (sub|super)scripts the
                // same as a (sub|super)script of regular characters.
                var isSub = $ef0731f441f79e9a$var$unicodeSubRegEx.test(lex.text);
                var subsupTokens = [];
                subsupTokens.push(new $ef0731f441f79e9a$var$Token($ef0731f441f79e9a$var$uSubsAndSups[lex.text]));
                this.consume();
                // Continue fetching tokens to fill out the string.
                while(true){
                    var token = this.fetch().text;
                    if (!$ef0731f441f79e9a$var$uSubsAndSups[token]) break;
                    if ($ef0731f441f79e9a$var$unicodeSubRegEx.test(token) !== isSub) break;
                    subsupTokens.unshift(new $ef0731f441f79e9a$var$Token($ef0731f441f79e9a$var$uSubsAndSups[token]));
                    this.consume();
                }
                // Now create a (sub|super)script.
                var body = this.subparse(subsupTokens);
                if (isSub) subscript = {
                    type: "ordgroup",
                    mode: "math",
                    body: body
                };
                else superscript = {
                    type: "ordgroup",
                    mode: "math",
                    body: body
                };
            } else break;
        }
        // Base must be set if superscript or subscript are set per logic above,
        // but need to check here for type check to pass.
        if (superscript || subscript) // If we got either a superscript or subscript, create a supsub
        return {
            type: "supsub",
            mode: this.mode,
            base: base,
            sup: superscript,
            sub: subscript
        };
        else // Otherwise return the original body
        return base;
    }
    /**
   * Parses an entire function, including its base and all of its arguments.
   */ parseFunction(breakOnTokenText, name) {
        var token = this.fetch();
        var func = token.text;
        var funcData = $ef0731f441f79e9a$var$functions[func];
        if (!funcData) return null;
        this.consume(); // consume command token
        if (name && name !== "atom" && !funcData.allowedInArgument) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Got function '" + func + "' with no arguments" + (name ? " as " + name : ""), token);
        else if (this.mode === "text" && !funcData.allowedInText) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Can't use function '" + func + "' in text mode", token);
        else if (this.mode === "math" && funcData.allowedInMath === false) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Can't use function '" + func + "' in math mode", token);
        var { args: args, optArgs: optArgs } = this.parseArguments(func, funcData);
        return this.callFunction(func, args, optArgs, token, breakOnTokenText);
    }
    /**
   * Call a function handler with a suitable context and arguments.
   */ callFunction(name, args, optArgs, token, breakOnTokenText) {
        var context = {
            funcName: name,
            parser: this,
            token: token,
            breakOnTokenText: breakOnTokenText
        };
        var func = $ef0731f441f79e9a$var$functions[name];
        if (func && func.handler) return func.handler(context, args, optArgs);
        else throw new $ef0731f441f79e9a$export$f9c837a54db411d("No function handler for " + name);
    }
    /**
   * Parses the arguments of a function or environment
   */ parseArguments(func, // Should look like "\name" or "\begin{name}".
    funcData) {
        var totalArgs = funcData.numArgs + funcData.numOptionalArgs;
        if (totalArgs === 0) return {
            args: [],
            optArgs: []
        };
        var args = [];
        var optArgs = [];
        for(var i = 0; i < totalArgs; i++){
            var argType = funcData.argTypes && funcData.argTypes[i];
            var isOptional = i < funcData.numOptionalArgs;
            if ("primitive" in funcData && funcData.primitive && argType == null || // \sqrt expands into primitive if optional argument doesn't exist
            funcData.type === "sqrt" && i === 1 && optArgs[0] == null) argType = "primitive";
            var arg = this.parseGroupOfType("argument to '" + func + "'", argType, isOptional);
            if (isOptional) optArgs.push(arg);
            else if (arg != null) args.push(arg);
            else // should be unreachable
            throw new $ef0731f441f79e9a$export$f9c837a54db411d("Null argument, please report this as a bug");
        }
        return {
            args: args,
            optArgs: optArgs
        };
    }
    /**
   * Parses a group when the mode is changing.
   */ parseGroupOfType(name, type, optional) {
        switch(type){
            case "color":
                return this.parseColorGroup(optional);
            case "size":
                return this.parseSizeGroup(optional);
            case "url":
                return this.parseUrlGroup(optional);
            case "math":
            case "text":
                return this.parseArgumentGroup(optional, type);
            case "hbox":
                // hbox argument type wraps the argument in the equivalent of
                // \hbox, which is like \text but switching to \textstyle size
                // and resetting math font.
                var group = this.parseArgumentGroup(optional, "text");
                return group != null ? {
                    type: "styling",
                    mode: group.mode,
                    body: [
                        group
                    ],
                    style: "text",
                    // simulate \textstyle
                    resetFont: true
                } : null;
            case "raw":
                var token = this.parseStringGroup("raw", optional);
                return token != null ? {
                    type: "raw",
                    mode: "text",
                    string: token.text
                } : null;
            case "primitive":
                if (optional) throw new $ef0731f441f79e9a$export$f9c837a54db411d("A primitive argument cannot be optional");
                var _group2 = this.parseGroup(name);
                if (_group2 == null) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Expected group as " + name, this.fetch());
                return _group2;
            case "original":
            case null:
            case undefined:
                return this.parseArgumentGroup(optional);
            default:
                throw new $ef0731f441f79e9a$export$f9c837a54db411d("Unknown group type as " + name, this.fetch());
        }
    }
    /**
   * Discard any space tokens, fetching the next non-space token.
   */ consumeSpaces() {
        while(this.fetch().text === " ")this.consume();
    }
    /**
   * Parses a group, essentially returning the string formed by the
   * brace-enclosed tokens plus some position information.
   */ parseStringGroup(modeName, // Used to describe the mode in error messages.
    optional) {
        var argToken = this.gullet.scanArgument(optional);
        if (argToken == null) return null;
        var str = "";
        var nextToken;
        while((nextToken = this.fetch()).text !== "EOF"){
            str += nextToken.text;
            this.consume();
        }
        this.consume(); // consume the end of the argument
        argToken.text = str;
        return argToken;
    }
    /**
   * Parses a regex-delimited group: the largest sequence of tokens
   * whose concatenated strings match `regex`. Returns the string
   * formed by the tokens plus some position information.
   */ parseRegexGroup(regex, modeName) {
        var firstToken = this.fetch();
        var lastToken = firstToken;
        var str = "";
        var nextToken;
        while((nextToken = this.fetch()).text !== "EOF" && regex.test(str + nextToken.text)){
            lastToken = nextToken;
            str += lastToken.text;
            this.consume();
        }
        if (str === "") throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid " + modeName + ": '" + firstToken.text + "'", firstToken);
        return firstToken.range(lastToken, str);
    }
    /**
   * Parses a color description.
   */ parseColorGroup(optional) {
        var res = this.parseStringGroup("color", optional);
        if (res == null) return null;
        var match = /^(#[a-f0-9]{3,4}|#[a-f0-9]{6}|#[a-f0-9]{8}|[a-f0-9]{6}|[a-z]+)$/i.exec(res.text);
        if (!match) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid color: '" + res.text + "'", res);
        var color = match[0];
        if (/^[0-9a-f]{6}$/i.test(color)) // We allow a 6-digit HTML color spec without a leading "#".
        // This follows the xcolor package's HTML color model.
        // Predefined color names are all missed by this RegEx pattern.
        color = "#" + color;
        return {
            type: "color-token",
            mode: this.mode,
            color: color
        };
    }
    /**
   * Parses a size specification, consisting of magnitude and unit.
   */ parseSizeGroup(optional) {
        var res;
        var isBlank = false;
        // don't expand before parseStringGroup
        this.gullet.consumeSpaces();
        if (!optional && this.gullet.future().text !== "{") res = this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/, "size");
        else res = this.parseStringGroup("size", optional);
        if (!res) return null;
        if (!optional && res.text.length === 0) {
            // Because we've tested for what is !optional, this block won't
            // affect \kern, \hspace, etc. It will capture the mandatory arguments
            // to \genfrac and \above.
            res.text = "0pt"; // Enable \above{}
            isBlank = true; // This is here specifically for \genfrac
        }
        var match = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(res.text);
        if (!match) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid size: '" + res.text + "'", res);
        var data = {
            number: +(match[1] + match[2]),
            // sign + magnitude, cast to number
            unit: match[3]
        };
        if (!$ef0731f441f79e9a$var$validUnit(data)) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Invalid unit: '" + data.unit + "'", res);
        return {
            type: "size",
            mode: this.mode,
            value: data,
            isBlank: isBlank
        };
    }
    /**
   * Parses an URL, checking escaped letters and allowed protocols,
   * and setting the catcode of % as an active character (as in \hyperref).
   */ parseUrlGroup(optional) {
        this.gullet.lexer.setCatcode("%", 13); // active character
        this.gullet.lexer.setCatcode("~", 12); // other character
        var res = this.parseStringGroup("url", optional);
        this.gullet.lexer.setCatcode("%", 14); // comment character
        this.gullet.lexer.setCatcode("~", 13); // active character
        if (res == null) return null;
        // hyperref package allows backslashes alone in href, but doesn't
        // generate valid links in such cases; we interpret this as
        // "undefined" behaviour, and keep them as-is. Some browser will
        // replace backslashes with forward slashes.
        var url = res.text.replace(/\\([#$%&~_^{}])/g, '$1');
        return {
            type: "url",
            mode: this.mode,
            url: url
        };
    }
    /**
   * Parses an argument with the mode specified.
   */ parseArgumentGroup(optional, mode) {
        var argToken = this.gullet.scanArgument(optional);
        if (argToken == null) return null;
        var outerMode = this.mode;
        if (mode) // Switch to specified mode
        this.switchMode(mode);
        this.gullet.beginGroup();
        var expression = this.parseExpression(false, "EOF");
        // TODO: find an alternative way to denote the end
        this.expect("EOF"); // expect the end of the argument
        this.gullet.endGroup();
        var result = {
            type: "ordgroup",
            mode: this.mode,
            loc: argToken.loc,
            body: expression
        };
        if (mode) // Switch mode back
        this.switchMode(outerMode);
        return result;
    }
    /**
   * Parses an ordinary group, which is either a single nucleus (like "x")
   * or an expression in braces (like "{x+y}") or an implicit group, a group
   * that starts at the current position, and ends right before a higher explicit
   * group ends, or at EOF.
   */ parseGroup(name, // For error reporting.
    breakOnTokenText) {
        var firstToken = this.fetch();
        var text = firstToken.text;
        var result;
        // Try to parse an open brace or \begingroup
        if (text === "{" || text === "\\begingroup") {
            this.consume();
            var groupEnd = text === "{" ? "}" : "\\endgroup";
            this.gullet.beginGroup();
            // If we get a brace, parse an expression
            var expression = this.parseExpression(false, groupEnd);
            var lastToken = this.fetch();
            this.expect(groupEnd); // Check that we got a matching closing brace
            this.gullet.endGroup();
            result = {
                type: "ordgroup",
                mode: this.mode,
                loc: $ef0731f441f79e9a$var$SourceLocation.range(firstToken, lastToken),
                body: expression,
                // A group formed by \begingroup...\endgroup is a semi-simple group
                // which doesn't affect spacing in math mode, i.e., is transparent.
                // https://tex.stackexchange.com/questions/1930/when-should-one-
                // use-begingroup-instead-of-bgroup
                semisimple: text === "\\begingroup" || undefined
            };
        } else {
            // If there exists a function with this name, parse the function.
            // Otherwise, just return a nucleus
            result = this.parseFunction(breakOnTokenText, name) || this.parseSymbol();
            if (result == null && text[0] === "\\" && !$ef0731f441f79e9a$var$implicitCommands.hasOwnProperty(text)) {
                if (this.settings.throwOnError) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Undefined control sequence: " + text, firstToken);
                result = this.formatUnsupportedCmd(text);
                this.consume();
            }
        }
        return result;
    }
    /**
   * Form ligature-like combinations of characters for text mode.
   * This includes inputs like "--", "---", "``" and "''".
   * The result will simply replace multiple textord nodes with a single
   * character in each value by a single textord node having multiple
   * characters in its value.  The representation is still ASCII source.
   * The group will be modified in place.
   */ formLigatures(group) {
        var n = group.length - 1;
        for(var i = 0; i < n; ++i){
            var a = group[i];
            if (a.type !== "textord") continue;
            var v = a.text;
            var next = group[i + 1];
            if (!next || next.type !== "textord") continue;
            if (v === "-" && next.text === "-") {
                var afterNext = group[i + 2];
                if (i + 1 < n && afterNext && afterNext.type === "textord" && afterNext.text === "-") {
                    group.splice(i, 3, {
                        type: "textord",
                        mode: "text",
                        loc: $ef0731f441f79e9a$var$SourceLocation.range(a, afterNext),
                        text: "---"
                    });
                    n -= 2;
                } else {
                    group.splice(i, 2, {
                        type: "textord",
                        mode: "text",
                        loc: $ef0731f441f79e9a$var$SourceLocation.range(a, next),
                        text: "--"
                    });
                    n -= 1;
                }
            }
            if ((v === "'" || v === "`") && next.text === v) {
                group.splice(i, 2, {
                    type: "textord",
                    mode: "text",
                    loc: $ef0731f441f79e9a$var$SourceLocation.range(a, next),
                    text: v + v
                });
                n -= 1;
            }
        }
    }
    /**
   * Parse a single symbol out of the string. Here, we handle single character
   * symbols and special functions like \verb.
   */ parseSymbol() {
        var nucleus = this.fetch();
        var text = nucleus.text;
        if (/^\\verb[^a-zA-Z]/.test(text)) {
            this.consume();
            var arg = text.slice(5);
            var star = arg.charAt(0) === "*";
            if (star) arg = arg.slice(1);
            // Lexer's tokenRegex is constructed to always have matching
            // first/last characters.
            if (arg.length < 2 || arg.charAt(0) !== arg.slice(-1)) throw new $ef0731f441f79e9a$export$f9c837a54db411d("\\verb assertion failed --\n                    please report what input caused this bug");
            arg = arg.slice(1, -1); // remove first and last char
            return {
                type: "verb",
                mode: "text",
                body: arg,
                star: star
            };
        }
        // At this point, we should have a symbol, possibly with accents.
        // First expand any accented base symbol according to unicodeSymbols.
        if ($ef0731f441f79e9a$var$unicodeSymbols.hasOwnProperty(text[0]) && !$ef0731f441f79e9a$var$symbols[this.mode][text[0]]) {
            // This behavior is not strict (XeTeX-compatible) in math mode.
            if (this.settings.strict && this.mode === "math") this.settings.reportNonstrict("unicodeTextInMathMode", "Accented Unicode text character \"" + text[0] + "\" used in " + "math mode", nucleus);
            text = $ef0731f441f79e9a$var$unicodeSymbols[text[0]] + text.slice(1);
        }
        // Strip off any combining characters
        var match = $ef0731f441f79e9a$var$combiningDiacriticalMarksEndRegex.exec(text);
        if (match) {
            text = text.substring(0, match.index);
            if (text === 'i') text = '\u0131'; // dotless i, in math and text mode
            else if (text === 'j') text = '\u0237'; // dotless j, in math and text mode
        }
        // Recognize base symbol
        var symbol;
        if ($ef0731f441f79e9a$var$symbols[this.mode][text]) {
            if (this.settings.strict && this.mode === 'math' && $ef0731f441f79e9a$var$extraLatin.includes(text)) this.settings.reportNonstrict("unicodeTextInMathMode", "Latin-1/Unicode text character \"" + text[0] + "\" used in " + "math mode", nucleus);
            var group = $ef0731f441f79e9a$var$symbols[this.mode][text].group;
            var loc = $ef0731f441f79e9a$var$SourceLocation.range(nucleus);
            var s;
            if ($ef0731f441f79e9a$var$isAtom(group)) s = {
                type: "atom",
                mode: this.mode,
                family: group,
                loc: loc,
                text: text
            };
            else s = {
                type: group,
                mode: this.mode,
                loc: loc,
                text: text
            };
            symbol = s;
        } else if (text.charCodeAt(0) >= 0x80) {
            // no symbol for e.g. ^
            if (this.settings.strict) {
                if (!$ef0731f441f79e9a$var$supportedCodepoint(text.charCodeAt(0))) this.settings.reportNonstrict("unknownSymbol", "Unrecognized Unicode character \"" + text[0] + "\"" + (" (" + text.charCodeAt(0) + ")"), nucleus);
                else if (this.mode === "math") this.settings.reportNonstrict("unicodeTextInMathMode", "Unicode text character \"" + text[0] + "\" used in math mode", nucleus);
            }
            // All nonmathematical Unicode characters are rendered as if they
            // are in text mode (wrapped in \text) because that's what it
            // takes to render them in LaTeX.  Setting `mode: this.mode` is
            // another natural choice (the user requested math mode), but
            // this makes it more difficult for getCharacterMetrics() to
            // distinguish Unicode characters without metrics and those for
            // which we want to simulate the letter M.
            symbol = {
                type: "textord",
                mode: "text",
                loc: $ef0731f441f79e9a$var$SourceLocation.range(nucleus),
                text: text
            };
        } else return null; // EOF, ^, _, {, }, etc.
        this.consume();
        // Transform combining characters into accents
        if (match) for(var i = 0; i < match[0].length; i++){
            var accent = match[0][i];
            if (!$ef0731f441f79e9a$var$unicodeAccents[accent]) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Unknown accent ' " + accent + "'", nucleus);
            var command = $ef0731f441f79e9a$var$unicodeAccents[accent][this.mode] || $ef0731f441f79e9a$var$unicodeAccents[accent].text;
            if (!command) throw new $ef0731f441f79e9a$export$f9c837a54db411d("Accent " + accent + " unsupported in " + this.mode + " mode", nucleus);
            symbol = {
                type: "accent",
                mode: this.mode,
                loc: $ef0731f441f79e9a$var$SourceLocation.range(nucleus),
                label: command,
                isStretchy: false,
                isShifty: true,
                base: symbol
            };
        }
        return symbol;
    }
}
$ef0731f441f79e9a$var$Parser.endOfExpression = new Set([
    "}",
    "\\endgroup",
    "\\end",
    "\\right",
    "&"
]);
/**
 * Provides a single function for parsing an expression using a Parser
 * TODO(emily): Remove this
 */ /**
 * Parses an expression using a Parser, then returns the parsed result.
 */ var $ef0731f441f79e9a$var$parseTree = function parseTree(toParse, settings) {
    if (!(typeof toParse === 'string' || toParse instanceof String)) throw new TypeError('KaTeX can only parse string typed expression');
    var parser = new $ef0731f441f79e9a$var$Parser(toParse, settings);
    // Blank out any \df@tag to avoid spurious "Duplicate \tag" errors
    delete parser.gullet.macros.current["\\df@tag"];
    var tree = parser.parse();
    // Prevent a color definition from persisting between calls to katex.render().
    delete parser.gullet.macros.current["\\current@color"];
    delete parser.gullet.macros.current["\\color"];
    // If the input used \tag, it will set the \df@tag macro to the tag.
    // In this case, we separately parse the tag and wrap the tree.
    if (parser.gullet.macros.get("\\df@tag")) {
        if (!settings.displayMode) throw new $ef0731f441f79e9a$export$f9c837a54db411d("\\tag works only in display equations");
        tree = [
            {
                type: "tag",
                mode: "text",
                body: tree,
                tag: parser.subparse([
                    new $ef0731f441f79e9a$var$Token("\\df@tag")
                ])
            }
        ];
    }
    return tree;
};
/* eslint no-console:0 */ /**
 * Parse and build an expression, and place that expression in the DOM node
 * given.
 */ var $ef0731f441f79e9a$export$b3890eb0ae9dca99 = function render(expression, baseNode, options) {
    baseNode.textContent = "";
    var node = $ef0731f441f79e9a$export$2caff1a8d8325985(expression, options).toNode();
    baseNode.appendChild(node);
};
// KaTeX's styles don't work properly in quirks mode. Print out an error, and
// disable rendering.
if (typeof document !== "undefined") {
    if (document.compatMode !== "CSS1Compat") {
        typeof console !== "undefined" && console.warn("Warning: KaTeX doesn't work in quirks mode. Make sure your website has a suitable doctype.");
        $ef0731f441f79e9a$export$b3890eb0ae9dca99 = function render() {
            throw new $ef0731f441f79e9a$export$f9c837a54db411d("KaTeX doesn't work in quirks mode.");
        };
    }
}
/**
 * Parse and build an expression, and return the markup for that.
 */ var $ef0731f441f79e9a$export$80e7718417253a51 = function renderToString(expression, options) {
    var markup = $ef0731f441f79e9a$export$2caff1a8d8325985(expression, options).toMarkup();
    return markup;
};
/**
 * Parse an expression and return the parse tree.
 */ var $ef0731f441f79e9a$export$d973fba02d4a7b14 = function generateParseTree(expression, options) {
    var settings = new $ef0731f441f79e9a$var$Settings(options);
    return $ef0731f441f79e9a$var$parseTree(expression, settings);
};
/**
 * If the given error is a KaTeX ParseError and options.throwOnError is false,
 * renders the invalid LaTeX as a span with hover title giving the KaTeX
 * error message.  Otherwise, simply throws the error.
 */ var $ef0731f441f79e9a$var$renderError = function renderError(error, expression, options) {
    if (options.throwOnError || !(error instanceof $ef0731f441f79e9a$export$f9c837a54db411d)) throw error;
    var node = $ef0731f441f79e9a$var$makeSpan([
        "katex-error"
    ], [
        new $ef0731f441f79e9a$var$SymbolNode(expression)
    ]);
    node.setAttribute("title", error.toString());
    node.setAttribute("style", "color:" + options.errorColor);
    return node;
};
/**
 * Generates and returns the katex build tree. This is used for advanced
 * use cases (like rendering to custom output).
 */ var $ef0731f441f79e9a$export$2caff1a8d8325985 = function renderToDomTree(expression, options) {
    var settings = new $ef0731f441f79e9a$var$Settings(options);
    try {
        var tree = $ef0731f441f79e9a$var$parseTree(expression, settings);
        return $ef0731f441f79e9a$var$buildTree(tree, expression, settings);
    } catch (error) {
        return $ef0731f441f79e9a$var$renderError(error, expression, settings);
    }
};
/**
 * Generates and returns the katex build tree, with just HTML (no MathML).
 * This is used for advanced use cases (like rendering to custom output).
 */ var $ef0731f441f79e9a$export$857cd40d8368e9fd = function renderToHTMLTree(expression, options) {
    var settings = new $ef0731f441f79e9a$var$Settings(options);
    try {
        var tree = $ef0731f441f79e9a$var$parseTree(expression, settings);
        return $ef0731f441f79e9a$var$buildHTMLTree(tree, expression, settings);
    } catch (error) {
        return $ef0731f441f79e9a$var$renderError(error, expression, settings);
    }
};
var $ef0731f441f79e9a$export$83d89fbfd8236492 = "0.16.47";
var $ef0731f441f79e9a$export$71f6208c52b6f635 = {
    Span: $ef0731f441f79e9a$var$Span,
    Anchor: $ef0731f441f79e9a$var$Anchor,
    SymbolNode: $ef0731f441f79e9a$var$SymbolNode,
    SvgNode: $ef0731f441f79e9a$var$SvgNode,
    PathNode: $ef0731f441f79e9a$var$PathNode,
    LineNode: $ef0731f441f79e9a$var$LineNode
};
// CJS exports and ESM default export
var $ef0731f441f79e9a$export$2e2bcd8739ae039 = {
    version: /**
   * Current KaTeX version
   */ $ef0731f441f79e9a$export$83d89fbfd8236492,
    render: /**
   * Renders the given LaTeX into an HTML+MathML combination, and adds
   * it as a child to the specified DOM node.
   */ $ef0731f441f79e9a$export$b3890eb0ae9dca99,
    renderToString: /**
   * Renders the given LaTeX into an HTML+MathML combination string,
   * for sending to the client.
   */ $ef0731f441f79e9a$export$80e7718417253a51,
    ParseError: /**
   * KaTeX error, usually during parsing.
   */ $ef0731f441f79e9a$export$f9c837a54db411d,
    SETTINGS_SCHEMA: /**
   * The schema of Settings
   */ $ef0731f441f79e9a$export$52389b8e2e8ab6f0,
    /**
   * Parses the given LaTeX into KaTeX's internal parse tree structure,
   * without rendering to HTML or MathML.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */ __parse: $ef0731f441f79e9a$export$d973fba02d4a7b14,
    /**
   * Renders the given LaTeX into an HTML+MathML internal DOM tree
   * representation, without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */ __renderToDomTree: $ef0731f441f79e9a$export$2caff1a8d8325985,
    /**
   * Renders the given LaTeX into an HTML internal DOM tree representation,
   * without MathML and without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */ __renderToHTMLTree: $ef0731f441f79e9a$export$857cd40d8368e9fd,
    /**
   * extends internal font metrics object with a new object
   * each key in the new object represents a font name
  */ __setFontMetrics: $ef0731f441f79e9a$export$48cd0bdd7709b195,
    /**
   * adds a new symbol to builtin symbols table
   */ __defineSymbol: $ef0731f441f79e9a$export$4de7425e0ddfa6f7,
    /**
   * adds a new function to builtin function list,
   * which directly produce parse tree elements
   * and have their own html/mathml builders
   */ __defineFunction: $ef0731f441f79e9a$export$6eeef399b524690e,
    /**
   * adds a new macro to builtin macro list
   */ __defineMacro: $ef0731f441f79e9a$export$1c70906d0a09453f,
    __domTree: /**
   * Expose the dom tree node types, which can be useful for type checking nodes.
   *
   * NOTE: These methods are not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */ $ef0731f441f79e9a$export$71f6208c52b6f635
};


const $21c70723b1e34f55$var$inlineRule = /^(\${1,2})(?!\$)((?:\\.|[^\\\n])*?(?:\\.|[^\\\n\$]))\1(?=[\s?!\.,:？！。，：]|$)/;
const $21c70723b1e34f55$var$inlineRuleNonStandard = /^(\${1,2})(?!\$)((?:\\.|[^\\\n])*?(?:\\.|[^\\\n\$]))\1/; // Non-standard, even if there are no spaces before and after $ or $$, try to parse
const $21c70723b1e34f55$var$blockRule = /^(\${1,2})\n((?:\\[^]|[^\\])+?)\n\1(?:\n|$)/;
function $21c70723b1e34f55$export$2e2bcd8739ae039(options = {}) {
    return {
        extensions: [
            $21c70723b1e34f55$var$inlineKatex(options, $21c70723b1e34f55$var$createRenderer(options, false)),
            $21c70723b1e34f55$var$blockKatex(options, $21c70723b1e34f55$var$createRenderer(options, true))
        ]
    };
}
function $21c70723b1e34f55$var$createRenderer(options, newlineAfter) {
    return (token)=>(0, $ef0731f441f79e9a$export$2e2bcd8739ae039).renderToString(token.text, {
            ...options,
            displayMode: token.displayMode
        }) + (newlineAfter ? '\n' : '');
}
function $21c70723b1e34f55$var$inlineKatex(options, renderer) {
    const nonStandard = options && options.nonStandard;
    const ruleReg = nonStandard ? $21c70723b1e34f55$var$inlineRuleNonStandard : $21c70723b1e34f55$var$inlineRule;
    return {
        name: 'inlineKatex',
        level: 'inline',
        start (src) {
            let index;
            let indexSrc = src;
            while(indexSrc){
                index = indexSrc.indexOf('$');
                if (index === -1) return;
                const f = nonStandard ? index > -1 : index === 0 || indexSrc.charAt(index - 1) === ' ';
                if (f) {
                    const possibleKatex = indexSrc.substring(index);
                    if (possibleKatex.match(ruleReg)) return index;
                }
                indexSrc = indexSrc.substring(index + 1).replace(/^\$+/, '');
            }
        },
        tokenizer (src, tokens) {
            const match = src.match(ruleReg);
            if (match) return {
                type: 'inlineKatex',
                raw: match[0],
                text: match[2].trim(),
                displayMode: match[1].length === 2
            };
        },
        renderer: renderer
    };
}
function $21c70723b1e34f55$var$blockKatex(options, renderer) {
    return {
        name: 'blockKatex',
        level: 'block',
        tokenizer (src, tokens) {
            const match = src.match($21c70723b1e34f55$var$blockRule);
            if (match) return {
                type: 'blockKatex',
                raw: match[0],
                text: match[2].trim(),
                displayMode: match[1].length === 2
            };
        },
        renderer: renderer
    };
}


/*! @license DOMPurify 3.4.14 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.14/LICENSE */ function $3498e5411d24543d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3498e5411d24543d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $3498e5411d24543d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3498e5411d24543d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3498e5411d24543d$var$_slicedToArray(r, e) {
    return $3498e5411d24543d$var$_arrayWithHoles(r) || $3498e5411d24543d$var$_iterableToArrayLimit(r, e) || $3498e5411d24543d$var$_unsupportedIterableToArray(r, e) || $3498e5411d24543d$var$_nonIterableRest();
}
function $3498e5411d24543d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3498e5411d24543d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3498e5411d24543d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
const $3498e5411d24543d$var$entries = Object.entries, $3498e5411d24543d$var$setPrototypeOf = Object.setPrototypeOf, $3498e5411d24543d$var$isFrozen = Object.isFrozen, $3498e5411d24543d$var$getPrototypeOf = Object.getPrototypeOf, $3498e5411d24543d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
let $3498e5411d24543d$var$freeze = Object.freeze, $3498e5411d24543d$var$seal = Object.seal, $3498e5411d24543d$var$create = Object.create; // eslint-disable-line import/no-mutable-exports
let $3498e5411d24543d$var$_ref = typeof Reflect !== 'undefined' && Reflect, $3498e5411d24543d$var$apply = $3498e5411d24543d$var$_ref.apply, $3498e5411d24543d$var$construct = $3498e5411d24543d$var$_ref.construct;
if (!$3498e5411d24543d$var$freeze) $3498e5411d24543d$var$freeze = function freeze(x) {
    return x;
};
if (!$3498e5411d24543d$var$seal) $3498e5411d24543d$var$seal = function seal(x) {
    return x;
};
if (!$3498e5411d24543d$var$apply) $3498e5411d24543d$var$apply = function apply(func, thisArg) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return func.apply(thisArg, args);
};
if (!$3498e5411d24543d$var$construct) $3498e5411d24543d$var$construct = function construct(Func) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return new Func(...args);
};
const $3498e5411d24543d$var$arrayForEach = $3498e5411d24543d$var$unapply(Array.prototype.forEach);
const $3498e5411d24543d$var$arrayLastIndexOf = $3498e5411d24543d$var$unapply(Array.prototype.lastIndexOf);
const $3498e5411d24543d$var$arrayPop = $3498e5411d24543d$var$unapply(Array.prototype.pop);
const $3498e5411d24543d$var$arrayPush = $3498e5411d24543d$var$unapply(Array.prototype.push);
const $3498e5411d24543d$var$arraySplice = $3498e5411d24543d$var$unapply(Array.prototype.splice);
const $3498e5411d24543d$var$arrayIsArray = Array.isArray;
const $3498e5411d24543d$var$stringToLowerCase = $3498e5411d24543d$var$unapply(String.prototype.toLowerCase);
const $3498e5411d24543d$var$stringToString = $3498e5411d24543d$var$unapply(String.prototype.toString);
const $3498e5411d24543d$var$stringMatch = $3498e5411d24543d$var$unapply(String.prototype.match);
const $3498e5411d24543d$var$stringReplace = $3498e5411d24543d$var$unapply(String.prototype.replace);
const $3498e5411d24543d$var$stringIndexOf = $3498e5411d24543d$var$unapply(String.prototype.indexOf);
const $3498e5411d24543d$var$stringTrim = $3498e5411d24543d$var$unapply(String.prototype.trim);
const $3498e5411d24543d$var$numberToString = $3498e5411d24543d$var$unapply(Number.prototype.toString);
const $3498e5411d24543d$var$booleanToString = $3498e5411d24543d$var$unapply(Boolean.prototype.toString);
const $3498e5411d24543d$var$bigintToString = typeof BigInt === 'undefined' ? null : $3498e5411d24543d$var$unapply(BigInt.prototype.toString);
const $3498e5411d24543d$var$symbolToString = typeof Symbol === 'undefined' ? null : $3498e5411d24543d$var$unapply(Symbol.prototype.toString);
const $3498e5411d24543d$var$objectHasOwnProperty = $3498e5411d24543d$var$unapply(Object.prototype.hasOwnProperty);
const $3498e5411d24543d$var$objectToString = $3498e5411d24543d$var$unapply(Object.prototype.toString);
const $3498e5411d24543d$var$regExpTest = $3498e5411d24543d$var$unapply(RegExp.prototype.test);
const $3498e5411d24543d$var$typeErrorCreate = $3498e5411d24543d$var$unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */ function $3498e5411d24543d$var$unapply(func) {
    return function(thisArg) {
        if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return $3498e5411d24543d$var$apply(func, thisArg, args);
    };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */ function $3498e5411d24543d$var$unconstruct(Func) {
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $3498e5411d24543d$var$construct(Func, args);
    };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */ function $3498e5411d24543d$var$addToSet(set, array) {
    let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $3498e5411d24543d$var$stringToLowerCase;
    if ($3498e5411d24543d$var$setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    $3498e5411d24543d$var$setPrototypeOf(set, null);
    if (!$3498e5411d24543d$var$arrayIsArray(array)) return set;
    let l = array.length;
    while(l--){
        let element = array[l];
        if (typeof element === 'string') {
            const lcElement = transformCaseFunc(element);
            if (lcElement !== element) {
                // Config presets (e.g. tags.js, attrs.js) are immutable.
                if (!$3498e5411d24543d$var$isFrozen(array)) array[l] = lcElement;
                element = lcElement;
            }
        }
        set[element] = true;
    }
    return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */ function $3498e5411d24543d$var$cleanArray(array) {
    for(let index = 0; index < array.length; index++){
        const isPropertyExist = $3498e5411d24543d$var$objectHasOwnProperty(array, index);
        if (!isPropertyExist) array[index] = null;
    }
    return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */ function $3498e5411d24543d$var$clone(object) {
    const newObject = $3498e5411d24543d$var$create(null);
    for (const _ref2 of $3498e5411d24543d$var$entries(object)){
        var _ref3 = $3498e5411d24543d$var$_slicedToArray(_ref2, 2);
        const property = _ref3[0];
        const value = _ref3[1];
        const isPropertyExist = $3498e5411d24543d$var$objectHasOwnProperty(object, property);
        if (isPropertyExist) {
            if ($3498e5411d24543d$var$arrayIsArray(value)) newObject[property] = $3498e5411d24543d$var$cleanArray(value);
            else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = $3498e5411d24543d$var$clone(value);
            else newObject[property] = value;
        }
    }
    return newObject;
}
/**
 * Convert non-node values into strings without depending on direct property access.
 *
 * @param value - The value to stringify.
 * @returns A string representation of the provided value.
 */ function $3498e5411d24543d$var$stringifyValue(value) {
    switch(typeof value){
        case 'string':
            return value;
        case 'number':
            return $3498e5411d24543d$var$numberToString(value);
        case 'boolean':
            return $3498e5411d24543d$var$booleanToString(value);
        case 'bigint':
            return $3498e5411d24543d$var$bigintToString ? $3498e5411d24543d$var$bigintToString(value) : '0';
        case 'symbol':
            return $3498e5411d24543d$var$symbolToString ? $3498e5411d24543d$var$symbolToString(value) : 'Symbol()';
        case 'undefined':
            return $3498e5411d24543d$var$objectToString(value);
        case 'function':
        case 'object':
            {
                if (value === null) return $3498e5411d24543d$var$objectToString(value);
                const valueAsRecord = value;
                const valueToString = $3498e5411d24543d$var$lookupGetter(valueAsRecord, 'toString');
                if (typeof valueToString === 'function') {
                    const stringified = valueToString(valueAsRecord);
                    return typeof stringified === 'string' ? stringified : $3498e5411d24543d$var$objectToString(stringified);
                }
                return $3498e5411d24543d$var$objectToString(value);
            }
        default:
            return $3498e5411d24543d$var$objectToString(value);
    }
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */ function $3498e5411d24543d$var$lookupGetter(object, prop) {
    while(object !== null){
        const desc = $3498e5411d24543d$var$getOwnPropertyDescriptor(object, prop);
        if (desc) {
            if (desc.get) return $3498e5411d24543d$var$unapply(desc.get);
            if (typeof desc.value === 'function') return $3498e5411d24543d$var$unapply(desc.value);
        }
        object = $3498e5411d24543d$var$getPrototypeOf(object);
    }
    function fallbackValue() {
        return null;
    }
    return fallbackValue;
}
function $3498e5411d24543d$var$isRegex(value) {
    try {
        $3498e5411d24543d$var$regExpTest(value, '');
        return true;
    } catch (_unused) {
        return false;
    }
}
const $3498e5411d24543d$var$html$1 = $3498e5411d24543d$var$freeze([
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'bdi',
    'bdo',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'content',
    'data',
    'datalist',
    'dd',
    'decorator',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meter',
    'nav',
    'nobr',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'search',
    'section',
    'select',
    'shadow',
    'slot',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr'
]);
const $3498e5411d24543d$var$svg$1 = $3498e5411d24543d$var$freeze([
    'svg',
    'a',
    'altglyph',
    'altglyphdef',
    'altglyphitem',
    'animatecolor',
    'animatemotion',
    'animatetransform',
    'circle',
    'clippath',
    'defs',
    'desc',
    'ellipse',
    'enterkeyhint',
    'exportparts',
    'filter',
    'font',
    'g',
    'glyph',
    'glyphref',
    'hkern',
    'image',
    'inputmode',
    'line',
    'lineargradient',
    'marker',
    'mask',
    'metadata',
    'mpath',
    'part',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialgradient',
    'rect',
    'stop',
    'style',
    'switch',
    'symbol',
    'text',
    'textpath',
    'title',
    'tref',
    'tspan',
    'view',
    'vkern'
]);
const $3498e5411d24543d$var$svgFilters = $3498e5411d24543d$var$freeze([
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence'
]);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const $3498e5411d24543d$var$svgDisallowed = $3498e5411d24543d$var$freeze([
    'animate',
    'color-profile',
    'cursor',
    'discard',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-src',
    'font-face-uri',
    'foreignobject',
    'hatch',
    'hatchpath',
    'mesh',
    'meshgradient',
    'meshpatch',
    'meshrow',
    'missing-glyph',
    'script',
    'set',
    'solidcolor',
    'unknown',
    'use'
]);
const $3498e5411d24543d$var$mathMl$1 = $3498e5411d24543d$var$freeze([
    'math',
    'menclose',
    'merror',
    'mfenced',
    'mfrac',
    'mglyph',
    'mi',
    'mlabeledtr',
    'mmultiscripts',
    'mn',
    'mo',
    'mover',
    'mpadded',
    'mphantom',
    'mroot',
    'mrow',
    'ms',
    'mspace',
    'msqrt',
    'mstyle',
    'msub',
    'msup',
    'msubsup',
    'mtable',
    'mtd',
    'mtext',
    'mtr',
    'munder',
    'munderover',
    'mprescripts'
]);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const $3498e5411d24543d$var$mathMlDisallowed = $3498e5411d24543d$var$freeze([
    'maction',
    'maligngroup',
    'malignmark',
    'mlongdiv',
    'mscarries',
    'mscarry',
    'msgroup',
    'mstack',
    'msline',
    'msrow',
    'semantics',
    'annotation',
    'annotation-xml',
    'mprescripts',
    'none'
]);
const $3498e5411d24543d$var$text = $3498e5411d24543d$var$freeze([
    '#text'
]);
const $3498e5411d24543d$var$html = $3498e5411d24543d$var$freeze([
    'accept',
    'action',
    'align',
    'alt',
    'autocapitalize',
    'autocomplete',
    'autopictureinpicture',
    'autoplay',
    'background',
    'bgcolor',
    'border',
    'capture',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'clear',
    'color',
    'cols',
    'colspan',
    'command',
    'commandfor',
    'controls',
    'controlslist',
    'coords',
    'crossorigin',
    'datetime',
    'decoding',
    'default',
    'dir',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'download',
    'draggable',
    'enctype',
    'enterkeyhint',
    'exportparts',
    'face',
    'for',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'id',
    'inert',
    'inputmode',
    'integrity',
    'ismap',
    'kind',
    'label',
    'lang',
    'list',
    'loading',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'minlength',
    'multiple',
    'muted',
    'name',
    'nonce',
    'noshade',
    'novalidate',
    'nowrap',
    'open',
    'optimum',
    'part',
    'pattern',
    'placeholder',
    'playsinline',
    'popover',
    'popovertarget',
    'popovertargetaction',
    'poster',
    'preload',
    'pubdate',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'rev',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'spellcheck',
    'scope',
    'selected',
    'shape',
    'size',
    'sizes',
    'slot',
    'span',
    'srclang',
    'start',
    'src',
    'srcset',
    'step',
    'style',
    'summary',
    'tabindex',
    'title',
    'translate',
    'type',
    'usemap',
    'valign',
    'value',
    'width',
    'wrap',
    'xmlns'
]);
const $3498e5411d24543d$var$svg = $3498e5411d24543d$var$freeze([
    'accent-height',
    'accumulate',
    'additive',
    'alignment-baseline',
    'amplitude',
    'ascent',
    'attributename',
    'attributetype',
    'azimuth',
    'basefrequency',
    'baseline-shift',
    'begin',
    'bias',
    'by',
    'class',
    'clip',
    'clippathunits',
    'clip-path',
    'clip-rule',
    'color',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'cx',
    'cy',
    'd',
    'dx',
    'dy',
    'diffuseconstant',
    'direction',
    'display',
    'divisor',
    'dominant-baseline',
    'dur',
    'edgemode',
    'elevation',
    'end',
    'exponent',
    'fill',
    'fill-opacity',
    'fill-rule',
    'filter',
    'filterunits',
    'flood-color',
    'flood-opacity',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-weight',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyph-name',
    'glyphref',
    'gradientunits',
    'gradienttransform',
    'height',
    'href',
    'id',
    'image-rendering',
    'in',
    'in2',
    'intercept',
    'k',
    'k1',
    'k2',
    'k3',
    'k4',
    'kerning',
    'keypoints',
    'keysplines',
    'keytimes',
    'lang',
    'lengthadjust',
    'letter-spacing',
    'kernelmatrix',
    'kernelunitlength',
    'lighting-color',
    'local',
    'marker-end',
    'marker-mid',
    'marker-start',
    'markerheight',
    'markerunits',
    'markerwidth',
    'maskcontentunits',
    'maskunits',
    'max',
    'mask',
    'mask-type',
    'media',
    'method',
    'mode',
    'min',
    'name',
    'numoctaves',
    'offset',
    'operator',
    'opacity',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'paint-order',
    'path',
    'pathlength',
    'patterncontentunits',
    'patterntransform',
    'patternunits',
    'pointer-events',
    'points',
    'preservealpha',
    'preserveaspectratio',
    'primitiveunits',
    'r',
    'rx',
    'ry',
    'radius',
    'refx',
    'refy',
    'repeatcount',
    'repeatdur',
    'restart',
    'result',
    'rotate',
    'scale',
    'seed',
    'shape-rendering',
    'slope',
    'specularconstant',
    'specularexponent',
    'spreadmethod',
    'startoffset',
    'stddeviation',
    'stitchtiles',
    'stop-color',
    'stop-opacity',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke',
    'stroke-width',
    'style',
    'surfacescale',
    'systemlanguage',
    'tabindex',
    'tablevalues',
    'targetx',
    'targety',
    'transform',
    'transform-origin',
    'text-anchor',
    'text-decoration',
    'text-orientation',
    'text-rendering',
    'textlength',
    'type',
    'u1',
    'u2',
    'unicode',
    'values',
    'vector-effect',
    'viewbox',
    'visibility',
    'version',
    'vert-adv-y',
    'vert-origin-x',
    'vert-origin-y',
    'width',
    'word-spacing',
    'wrap',
    'writing-mode',
    'xchannelselector',
    'ychannelselector',
    'x',
    'x1',
    'x2',
    'xmlns',
    'y',
    'y1',
    'y2',
    'z',
    'zoomandpan'
]);
const $3498e5411d24543d$var$mathMl = $3498e5411d24543d$var$freeze([
    'accent',
    'accentunder',
    'align',
    'bevelled',
    'close',
    'columnalign',
    'columnlines',
    'columnspacing',
    'columnspan',
    'denomalign',
    'depth',
    'dir',
    'display',
    'displaystyle',
    'encoding',
    'fence',
    'frame',
    'height',
    'href',
    'id',
    'largeop',
    'length',
    'linethickness',
    'lquote',
    'lspace',
    'mathbackground',
    'mathcolor',
    'mathsize',
    'mathvariant',
    'maxsize',
    'minsize',
    'movablelimits',
    'notation',
    'numalign',
    'open',
    'rowalign',
    'rowlines',
    'rowspacing',
    'rowspan',
    'rspace',
    'rquote',
    'scriptlevel',
    'scriptminsize',
    'scriptsizemultiplier',
    'selection',
    'separator',
    'separators',
    'stretchy',
    'subscriptshift',
    'supscriptshift',
    'symmetric',
    'voffset',
    'width',
    'xmlns'
]);
const $3498e5411d24543d$var$xml = $3498e5411d24543d$var$freeze([
    'xlink:href',
    'xml:id',
    'xlink:title',
    'xml:space',
    'xmlns:xlink'
]);
const $3498e5411d24543d$var$MUSTACHE_EXPR = $3498e5411d24543d$var$seal(/{{[\w\W]*|^[\w\W]*}}/g);
const $3498e5411d24543d$var$ERB_EXPR = $3498e5411d24543d$var$seal(/<%[\w\W]*|^[\w\W]*%>/g);
const $3498e5411d24543d$var$TMPLIT_EXPR = $3498e5411d24543d$var$seal(/\${[\w\W]*/g);
const $3498e5411d24543d$var$DATA_ATTR = $3498e5411d24543d$var$seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
const $3498e5411d24543d$var$ARIA_ATTR = $3498e5411d24543d$var$seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const $3498e5411d24543d$var$IS_ALLOWED_URI = $3498e5411d24543d$var$seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const $3498e5411d24543d$var$IS_SCRIPT_OR_DATA = $3498e5411d24543d$var$seal(/^(?:\w+script|data):/i);
const $3498e5411d24543d$var$ATTR_WHITESPACE = $3498e5411d24543d$var$seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const $3498e5411d24543d$var$DOCTYPE_NAME = $3498e5411d24543d$var$seal(/^html$/i);
const $3498e5411d24543d$var$CUSTOM_ELEMENT = $3498e5411d24543d$var$seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
// Markup-significant character probes used by _sanitizeElements.
// Shared module-level instances are safe despite the sticky /g flags:
// unapply() resets lastIndex for RegExp receivers before every call.
const $3498e5411d24543d$var$ELEMENT_MARKUP_PROBE = $3498e5411d24543d$var$seal(/<[/\w!]/g);
const $3498e5411d24543d$var$COMMENT_MARKUP_PROBE = $3498e5411d24543d$var$seal(/<[/\w]/g);
const $3498e5411d24543d$var$FALLBACK_TAG_CLOSE = $3498e5411d24543d$var$seal(/<\/no(script|embed|frames)/i);
const $3498e5411d24543d$var$SELF_CLOSING_TAG = $3498e5411d24543d$var$seal(/\/>/i);
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const $3498e5411d24543d$var$NODE_TYPE = {
    element: 1,
    attribute: 2,
    text: 3,
    cdataSection: 4,
    entityReference: 5,
    // Deprecated
    entityNode: 6,
    // Deprecated
    processingInstruction: 7,
    comment: 8,
    document: 9,
    documentType: 10,
    documentFragment: 11,
    notation: 12 // Deprecated
};
/* HTML-namespace elements whose child text nodes are serialized *literally*
   (unescaped) by the HTML fragment-serialization algorithm. Two reparse-mXSS
   shapes ride on that literal serialization:
     (a) an element child - a tree the HTML parser can never build, but the DOM
         API and an XML/XHTML parse can - after which a `</tag>`-bearing text
         sibling breaks the element open on reparse; and
     (b) text-only content that already carries the element's OWN end tag, e.g.
         `<style>...</style><img onerror=x>` built as a node, which the literal
         serializer emits verbatim for the HTML parser to re-open.
   Shape (a) is handled by the firstElementChild branch in _isUnsafeNode; shape
   (b) by the LITERAL_TEXT_CLOSE probe. Both read textContent (the raw-serialized
   form for these elements) rather than innerHTML, because an XML/XHTML working
   document serializes innerHTML with `<` escaped, which silently blinds the
   innerHTML-based probes (rule 1's second probe and FALLBACK_TAG_CLOSE) there.
   `script` is never allow-listed, but is kept here so the guard matches the
   serializer's own literal-text list exactly. */ const $3498e5411d24543d$var$LITERAL_TEXT_ELEMENT_NAMES = [
    'style',
    'script',
    'xmp',
    'iframe',
    'noembed',
    'noframes',
    'plaintext',
    'noscript'
];
const $3498e5411d24543d$var$LITERAL_TEXT_ELEMENTS = $3498e5411d24543d$var$freeze($3498e5411d24543d$var$addToSet({}, $3498e5411d24543d$var$LITERAL_TEXT_ELEMENT_NAMES));
/* Per-element end-tag matcher. On an HTML reparse the ONLY token that
   terminates a literal-text element's raw content is its own end tag; a foreign
   literal-text close (e.g. `</xmp>` sitting inside `<style>`) does not break
   out, so matching is per-element, not a shared alternation. The lookahead
   requires an HTML tag-name terminator (whitespace, `/` or `>`) so a longer
   name such as `</styles` is not mistaken for `</style`. */ const $3498e5411d24543d$var$LITERAL_TEXT_CLOSE = function() {
    const map = {};
    $3498e5411d24543d$var$arrayForEach($3498e5411d24543d$var$LITERAL_TEXT_ELEMENT_NAMES, (name)=>{
        map[name] = $3498e5411d24543d$var$seal(new RegExp('</' + name + '(?=[\\t\\n\\f\\r />])', 'i'));
    });
    return $3498e5411d24543d$var$freeze(map);
}();
const $3498e5411d24543d$var$getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */ const $3498e5411d24543d$var$_createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    let suffix = null;
    const ATTR_NAME = 'data-tt-policy-suffix';
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
    const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
        return trustedTypes.createPolicy(policyName, {
            createHTML (html) {
                return html;
            },
            createScriptURL (scriptUrl) {
                return scriptUrl;
            }
        });
    } catch (_) {
        // Policy creation failed (most likely another DOMPurify script has
        // already run). Skip creating the policy, as this will only cause errors
        // if TT are enforced.
        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
        return null;
    }
};
const $3498e5411d24543d$var$_createHooksMap = function _createHooksMap() {
    return {
        afterSanitizeAttributes: [],
        afterSanitizeElements: [],
        afterSanitizeShadowDOM: [],
        beforeSanitizeAttributes: [],
        beforeSanitizeElements: [],
        beforeSanitizeShadowDOM: [],
        uponSanitizeAttribute: [],
        uponSanitizeElement: [],
        uponSanitizeShadowNode: []
    };
};
/**
 * Resolve a set-valued configuration option: a fresh set built from
 * cfg[key] when it is an own array property (seeded with a clone of
 * options.base when given, case-normalized via options.transform),
 * the fallback set otherwise.
 *
 * @param cfg the cloned, prototype-free configuration object
 * @param key the configuration property to read
 * @param fallback the set to use when the option is absent or not an array
 * @param options transform and optional base set to merge into
 * @returns the resolved set
 */ const $3498e5411d24543d$var$_resolveSetOption = function _resolveSetOption(cfg, key, fallback, options) {
    return $3498e5411d24543d$var$objectHasOwnProperty(cfg, key) && $3498e5411d24543d$var$arrayIsArray(cfg[key]) ? $3498e5411d24543d$var$addToSet(options.base ? $3498e5411d24543d$var$clone(options.base) : {}, cfg[key], options.transform) : fallback;
};
/**
 * Resolve an object-valued configuration option: a prototype-free clone
 * of cfg[key] when it is an own, truthy object property, else a fresh
 * fallback built by makeFallback (fresh on every parse, so a previous
 * parse can never leak state into the next one).
 *
 * @param cfg the cloned, prototype-free configuration object
 * @param key the configuration property to read
 * @param makeFallback builds the fallback value when the option is absent
 * @returns the resolved object
 */ const $3498e5411d24543d$var$_resolveObjectOption = function _resolveObjectOption(cfg, key, makeFallback) {
    const value = $3498e5411d24543d$var$objectHasOwnProperty(cfg, key) ? cfg[key] : undefined;
    return value && typeof value === 'object' ? $3498e5411d24543d$var$clone(value) : makeFallback();
};
function $3498e5411d24543d$var$createDOMPurify() {
    let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $3498e5411d24543d$var$getGlobal();
    const DOMPurify = (root)=>$3498e5411d24543d$var$createDOMPurify(root);
    DOMPurify.version = '3.4.14';
    DOMPurify.removed = [];
    if (!window1 || !window1.document || window1.document.nodeType !== $3498e5411d24543d$var$NODE_TYPE.document || !window1.Element) {
        // Not running in a browser, provide a factory function
        // so that you can pass your own Window
        DOMPurify.isSupported = false;
        return DOMPurify;
    }
    let document = window1.document;
    const originalDocument = document;
    const currentScript = originalDocument.currentScript;
    window1.DocumentFragment;
    const HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap;
    _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap;
    window1.HTMLFormElement;
    const DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
    const ElementPrototype = Element.prototype;
    const cloneNode = $3498e5411d24543d$var$lookupGetter(ElementPrototype, 'cloneNode');
    const remove = $3498e5411d24543d$var$lookupGetter(ElementPrototype, 'remove');
    const getNextSibling = $3498e5411d24543d$var$lookupGetter(ElementPrototype, 'nextSibling');
    const getChildNodes = $3498e5411d24543d$var$lookupGetter(ElementPrototype, 'childNodes');
    const getParentNode = $3498e5411d24543d$var$lookupGetter(ElementPrototype, 'parentNode');
    const getShadowRoot = $3498e5411d24543d$var$lookupGetter(ElementPrototype, 'shadowRoot');
    const getAttributes = $3498e5411d24543d$var$lookupGetter(ElementPrototype, 'attributes');
    const getNodeType = Node && Node.prototype ? $3498e5411d24543d$var$lookupGetter(Node.prototype, 'nodeType') : null;
    const getNodeName = Node && Node.prototype ? $3498e5411d24543d$var$lookupGetter(Node.prototype, 'nodeName') : null;
    const getOwnerDocument = Node && Node.prototype ? $3498e5411d24543d$var$lookupGetter(Node.prototype, 'ownerDocument') : null;
    /* Clobber-safe nodeType / nodeName reads through the cached Node.prototype
     getters, with a direct-property fallback for environments that lack
     Node.prototype. Sites that need a different fallback (e.g. _isClobbered
     returns early on a null name) intentionally keep their own reads. */ const _readNodeType = function _readNodeType(node) {
        return getNodeType ? getNodeType(node) : node.nodeType;
    };
    const _readNodeName = function _readNodeName(node) {
        return getNodeName ? getNodeName(node) : node.nodeName;
    };
    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
        const template = document.createElement('template');
        if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
    }
    let trustedTypesPolicy;
    let emptyHTML = '';
    // The instance's own internal Trusted Types policy. Unlike a caller-supplied
    // `TRUSTED_TYPES_POLICY`, this is created at most once — Trusted Types throws
    // on duplicate policy names — and is the only policy allowed to persist
    // across configurations and survive `clearConfig()`.
    let defaultTrustedTypesPolicy;
    let defaultTrustedTypesPolicyResolved = false;
    // Tracks whether we are already inside a call to the configured Trusted Types
    // policy (`createHTML` or `createScriptURL`). If a supplied policy callback
    // itself calls `DOMPurify.sanitize` (the cause of #1422), `sanitize` would
    // re-enter the policy and recurse until the stack overflows. We detect that
    // re-entry and throw a clear, actionable error instead. The guard is shared
    // across both callbacks, because either one re-entering `sanitize` triggers
    // the same unbounded recursion.
    let IN_TRUSTED_TYPES_POLICY = 0;
    const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy() {
        if (IN_TRUSTED_TYPES_POLICY > 0) throw $3498e5411d24543d$var$typeErrorCreate('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
    };
    const _createTrustedHTML = function _createTrustedHTML(html) {
        _assertNotInTrustedTypesPolicy();
        IN_TRUSTED_TYPES_POLICY++;
        try {
            return trustedTypesPolicy.createHTML(html);
        } finally{
            IN_TRUSTED_TYPES_POLICY--;
        }
    };
    const _createTrustedScriptURL = function _createTrustedScriptURL(scriptUrl) {
        _assertNotInTrustedTypesPolicy();
        IN_TRUSTED_TYPES_POLICY++;
        try {
            return trustedTypesPolicy.createScriptURL(scriptUrl);
        } finally{
            IN_TRUSTED_TYPES_POLICY--;
        }
    };
    // Lazily resolve (and cache) the instance's internal default policy.
    // Resolution is attempted at most once: a successful `createPolicy` cannot be
    // repeated (Trusted Types throws on duplicate names), and a failed or
    // unsupported attempt must not be retried on every parse.
    const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy() {
        if (!defaultTrustedTypesPolicyResolved) {
            defaultTrustedTypesPolicy = $3498e5411d24543d$var$_createTrustedTypesPolicy(trustedTypes, currentScript);
            defaultTrustedTypesPolicyResolved = true;
        }
        return defaultTrustedTypesPolicy;
    };
    const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
    const importNode = originalDocument.importNode;
    let hooks = $3498e5411d24543d$var$_createHooksMap();
    /**
   * Expose whether this browser supports running the full DOMPurify.
   */ DOMPurify.isSupported = typeof $3498e5411d24543d$var$entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
    const MUSTACHE_EXPR$1 = $3498e5411d24543d$var$MUSTACHE_EXPR, ERB_EXPR$1 = $3498e5411d24543d$var$ERB_EXPR, TMPLIT_EXPR$1 = $3498e5411d24543d$var$TMPLIT_EXPR, DATA_ATTR$1 = $3498e5411d24543d$var$DATA_ATTR, ARIA_ATTR$1 = $3498e5411d24543d$var$ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = $3498e5411d24543d$var$IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = $3498e5411d24543d$var$ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = $3498e5411d24543d$var$CUSTOM_ELEMENT;
    let IS_ALLOWED_URI$1 = $3498e5411d24543d$var$IS_ALLOWED_URI;
    /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */ /* allowed element names */ let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = $3498e5411d24543d$var$addToSet({}, [
        ...$3498e5411d24543d$var$html$1,
        ...$3498e5411d24543d$var$svg$1,
        ...$3498e5411d24543d$var$svgFilters,
        ...$3498e5411d24543d$var$mathMl$1,
        ...$3498e5411d24543d$var$text
    ]);
    /* Allowed attribute names */ let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = $3498e5411d24543d$var$addToSet({}, [
        ...$3498e5411d24543d$var$html,
        ...$3498e5411d24543d$var$svg,
        ...$3498e5411d24543d$var$mathMl,
        ...$3498e5411d24543d$var$xml
    ]);
    /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */ let CUSTOM_ELEMENT_HANDLING = Object.seal($3498e5411d24543d$var$create(null, {
        tagNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        allowCustomizedBuiltInElements: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: false
        }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
    /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal($3498e5411d24543d$var$create(null, {
        tagCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        }
    }));
    /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */ let SAFE_FOR_TEMPLATES = false;
    /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */ let SAFE_FOR_XML = true;
    /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
    /* Pristine allowlist bindings captured at setConfig() time. On the
   * persistent-config path sanitize() restores the sets from these before
   * the per-walk hook clone-guard, so a hook's in-call widening cannot
   * carry across calls. Null until setConfig() is called; reset by
   * clearConfig(). */ let SET_CONFIG_ALLOWED_TAGS = null;
    let SET_CONFIG_ALLOWED_ATTR = null;
    /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */ let RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */ let SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */ let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */ let KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = $3498e5411d24543d$var$addToSet({}, [
        'annotation-xml',
        'audio',
        'colgroup',
        'desc',
        'foreignobject',
        'head',
        'iframe',
        'math',
        'mi',
        'mn',
        'mo',
        'ms',
        'mtext',
        'noembed',
        'noframes',
        'noscript',
        'plaintext',
        'script',
        // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
        // the UA (customizable <select>) — including any on* handlers — and the
        // engine re-mirrors synchronously whenever a removal changes which
        // option/selectedcontent is current, even inside DOMPurify's inert
        // DOMParser document. Hoisting its children on removal re-inserts a fresh
        // mirror target ahead of the walk, which the engine refills, looping
        // forever (DoS) and amplifying output. Dropping its content on removal
        // (rather than hoisting) breaks that cascade; the content is a duplicate
        // of the option, which is sanitized on its own. See campaign-3 F1/F6.
        'selectedcontent',
        'style',
        'svg',
        'template',
        'thead',
        'title',
        'video',
        'xmp'
    ]);
    /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = $3498e5411d24543d$var$addToSet({}, [
        'audio',
        'video',
        'img',
        'source',
        'image',
        'track'
    ]);
    /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = $3498e5411d24543d$var$addToSet({}, [
        'alt',
        'class',
        'for',
        'id',
        'label',
        'name',
        'pattern',
        'placeholder',
        'role',
        'summary',
        'title',
        'value',
        'style',
        'xmlns'
    ]);
    const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = $3498e5411d24543d$var$addToSet({}, [
        MATHML_NAMESPACE,
        SVG_NAMESPACE,
        HTML_NAMESPACE
    ], $3498e5411d24543d$var$stringToString);
    const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = $3498e5411d24543d$var$freeze([
        'mi',
        'mo',
        'mn',
        'ms',
        'mtext'
    ]);
    let MATHML_TEXT_INTEGRATION_POINTS = $3498e5411d24543d$var$addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
    const DEFAULT_HTML_INTEGRATION_POINTS = $3498e5411d24543d$var$freeze([
        'annotation-xml'
    ]);
    let HTML_INTEGRATION_POINTS = $3498e5411d24543d$var$addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    const COMMON_SVG_AND_HTML_ELEMENTS = $3498e5411d24543d$var$addToSet({}, [
        'title',
        'style',
        'font',
        'a',
        'script'
    ]);
    /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
    const SUPPORTED_PARSER_MEDIA_TYPES = [
        'application/xhtml+xml',
        'text/html'
    ];
    const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    let transformCaseFunc = null;
    /* Keep a reference to config to pass to hooks */ let CONFIG = null;
    /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
    const isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */ // eslint-disable-next-line complexity
    const _parseConfig = function _parseConfig() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (CONFIG && CONFIG === cfg) return;
        /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
        /* Shield configuration object from prototype pollution */ cfg = $3498e5411d24543d$var$clone(cfg);
        PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
        SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
        // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? $3498e5411d24543d$var$stringToString : $3498e5411d24543d$var$stringToLowerCase;
        /* Set configuration parameters */ ALLOWED_TAGS = $3498e5411d24543d$var$_resolveSetOption(cfg, 'ALLOWED_TAGS', DEFAULT_ALLOWED_TAGS, {
            transform: transformCaseFunc
        });
        ALLOWED_ATTR = $3498e5411d24543d$var$_resolveSetOption(cfg, 'ALLOWED_ATTR', DEFAULT_ALLOWED_ATTR, {
            transform: transformCaseFunc
        });
        ALLOWED_NAMESPACES = $3498e5411d24543d$var$_resolveSetOption(cfg, 'ALLOWED_NAMESPACES', DEFAULT_ALLOWED_NAMESPACES, {
            transform: $3498e5411d24543d$var$stringToString
        });
        URI_SAFE_ATTRIBUTES = $3498e5411d24543d$var$_resolveSetOption(cfg, 'ADD_URI_SAFE_ATTR', DEFAULT_URI_SAFE_ATTRIBUTES, {
            transform: transformCaseFunc,
            base: DEFAULT_URI_SAFE_ATTRIBUTES
        });
        DATA_URI_TAGS = $3498e5411d24543d$var$_resolveSetOption(cfg, 'ADD_DATA_URI_TAGS', DEFAULT_DATA_URI_TAGS, {
            transform: transformCaseFunc,
            base: DEFAULT_DATA_URI_TAGS
        });
        FORBID_CONTENTS = $3498e5411d24543d$var$_resolveSetOption(cfg, 'FORBID_CONTENTS', DEFAULT_FORBID_CONTENTS, {
            transform: transformCaseFunc
        });
        FORBID_TAGS = $3498e5411d24543d$var$_resolveSetOption(cfg, 'FORBID_TAGS', $3498e5411d24543d$var$clone({}), {
            transform: transformCaseFunc
        });
        FORBID_ATTR = $3498e5411d24543d$var$_resolveSetOption(cfg, 'FORBID_ATTR', $3498e5411d24543d$var$clone({}), {
            transform: transformCaseFunc
        });
        USE_PROFILES = $3498e5411d24543d$var$objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? $3498e5411d24543d$var$clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
        RETURN_DOM = cfg.RETURN_DOM || false; // Default false
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
        FORCE_BODY = cfg.FORCE_BODY || false; // Default false
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
        IN_PLACE = cfg.IN_PLACE || false; // Default false
        IS_ALLOWED_URI$1 = $3498e5411d24543d$var$isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : $3498e5411d24543d$var$IS_ALLOWED_URI; // Default regexp
        NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
        MATHML_TEXT_INTEGRATION_POINTS = $3498e5411d24543d$var$_resolveObjectOption(cfg, 'MATHML_TEXT_INTEGRATION_POINTS', ()=>$3498e5411d24543d$var$addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS) // Default built-in map
        );
        HTML_INTEGRATION_POINTS = $3498e5411d24543d$var$_resolveObjectOption(cfg, 'HTML_INTEGRATION_POINTS', ()=>$3498e5411d24543d$var$addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS) // Default built-in map
        );
        const customElementHandling = $3498e5411d24543d$var$_resolveObjectOption(cfg, 'CUSTOM_ELEMENT_HANDLING', ()=>$3498e5411d24543d$var$create(null));
        CUSTOM_ELEMENT_HANDLING = $3498e5411d24543d$var$create(null);
        if ($3498e5411d24543d$var$objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
        if ($3498e5411d24543d$var$objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
        if ($3498e5411d24543d$var$objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
        $3498e5411d24543d$var$seal(CUSTOM_ELEMENT_HANDLING);
        if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
        if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
        /* Parse profile info */ if (USE_PROFILES) {
            ALLOWED_TAGS = $3498e5411d24543d$var$addToSet({}, $3498e5411d24543d$var$text);
            ALLOWED_ATTR = $3498e5411d24543d$var$create(null);
            if (USE_PROFILES.html === true) {
                $3498e5411d24543d$var$addToSet(ALLOWED_TAGS, $3498e5411d24543d$var$html$1);
                $3498e5411d24543d$var$addToSet(ALLOWED_ATTR, $3498e5411d24543d$var$html);
            }
            if (USE_PROFILES.svg === true) {
                $3498e5411d24543d$var$addToSet(ALLOWED_TAGS, $3498e5411d24543d$var$svg$1);
                $3498e5411d24543d$var$addToSet(ALLOWED_ATTR, $3498e5411d24543d$var$svg);
                $3498e5411d24543d$var$addToSet(ALLOWED_ATTR, $3498e5411d24543d$var$xml);
            }
            if (USE_PROFILES.svgFilters === true) {
                $3498e5411d24543d$var$addToSet(ALLOWED_TAGS, $3498e5411d24543d$var$svgFilters);
                $3498e5411d24543d$var$addToSet(ALLOWED_ATTR, $3498e5411d24543d$var$svg);
                $3498e5411d24543d$var$addToSet(ALLOWED_ATTR, $3498e5411d24543d$var$xml);
            }
            if (USE_PROFILES.mathMl === true) {
                $3498e5411d24543d$var$addToSet(ALLOWED_TAGS, $3498e5411d24543d$var$mathMl$1);
                $3498e5411d24543d$var$addToSet(ALLOWED_ATTR, $3498e5411d24543d$var$mathMl);
                $3498e5411d24543d$var$addToSet(ALLOWED_ATTR, $3498e5411d24543d$var$xml);
            }
        }
        /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
     * leaking across calls when switching from function to array config */ EXTRA_ELEMENT_HANDLING.tagCheck = null;
        EXTRA_ELEMENT_HANDLING.attributeCheck = null;
        /* Merge configuration parameters */ if ($3498e5411d24543d$var$objectHasOwnProperty(cfg, 'ADD_TAGS')) {
            if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
            else if ($3498e5411d24543d$var$arrayIsArray(cfg.ADD_TAGS)) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = $3498e5411d24543d$var$clone(ALLOWED_TAGS);
                $3498e5411d24543d$var$addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
        }
        if ($3498e5411d24543d$var$objectHasOwnProperty(cfg, 'ADD_ATTR')) {
            if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
            else if ($3498e5411d24543d$var$arrayIsArray(cfg.ADD_ATTR)) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = $3498e5411d24543d$var$clone(ALLOWED_ATTR);
                $3498e5411d24543d$var$addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
        }
        if ($3498e5411d24543d$var$objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && $3498e5411d24543d$var$arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $3498e5411d24543d$var$clone(FORBID_CONTENTS);
            $3498e5411d24543d$var$addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
        }
        /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
        /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) $3498e5411d24543d$var$addToSet(ALLOWED_TAGS, [
            'html',
            'head',
            'body'
        ]);
        /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
            $3498e5411d24543d$var$addToSet(ALLOWED_TAGS, [
                'tbody'
            ]);
            delete FORBID_TAGS.tbody;
        }
        // Re-derive the active Trusted Types policy from this configuration on
        // every parse. The active policy must never be sticky closure state that
        // outlives the config that set it: a caller-supplied policy left in place
        // after `clearConfig()` — or after a later call that supplied none, or
        // `TRUSTED_TYPES_POLICY: null` — could sign a subsequent "default"
        // `RETURN_TRUSTED_TYPE` result with a foreign, possibly unsafe policy.
        // See GHSA-vxr8-fq34-vvx9.
        if (cfg.TRUSTED_TYPES_POLICY) {
            if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw $3498e5411d24543d$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
            if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw $3498e5411d24543d$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
            // A caller-supplied policy applies to this configuration only.
            const previousTrustedTypesPolicy = trustedTypesPolicy;
            trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
            // Sign local variables required by `sanitize`. If the supplied policy's
            // `createHTML` is circular (i.e. it calls `DOMPurify.sanitize`), this
            // throws via the re-entrancy guard. Restore the previous policy first so
            // the instance is not left in a poisoned state. See #1422.
            try {
                emptyHTML = _createTrustedHTML('');
            } catch (error) {
                trustedTypesPolicy = previousTrustedTypesPolicy;
                throw error;
            }
        } else if (cfg.TRUSTED_TYPES_POLICY === null) {
            // Explicit opt-out for this call: perform no Trusted Types signing and
            // create nothing (so a strict `trusted-types` CSP that disallows a
            // `dompurify` policy can still call `sanitize` from inside its own
            // policy — see #1422). Resetting to `undefined` rather than a sticky
            // `null` also drops any previously retained caller policy, so it cannot
            // resurface on a later call, while still allowing the next config-less
            // call to restore the internal default policy. See GHSA-vxr8-fq34-vvx9.
            trustedTypesPolicy = undefined;
            emptyHTML = '';
        } else {
            // No policy supplied: keep the currently active policy if one is set — a
            // previously supplied policy is intentionally sticky across config-less
            // calls — otherwise fall back to the instance's own internal policy,
            // created at most once. (A policy supplied for a *single* call still
            // lingers by design; what must not linger is a policy whose configuration
            // has been torn down via `clearConfig()`, which restores the default.)
            if (trustedTypesPolicy === undefined) trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
            // Sign internal variables only when a policy is active. A falsy policy
            // (Trusted Types unsupported, creation failed, or an explicit opt-out)
            // leaves `emptyHTML` as a plain string, so we never call `.createHTML` on
            // a non-policy and throw. See #1422.
            if (trustedTypesPolicy && typeof emptyHTML === 'string') emptyHTML = _createTrustedHTML('');
        }
        // Prevent further manipulation of configuration.
        // Not available in IE8, Safari 5, etc.
        if ($3498e5411d24543d$var$freeze) $3498e5411d24543d$var$freeze(cfg);
        CONFIG = cfg;
    };
    /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */ const ALL_SVG_TAGS = $3498e5411d24543d$var$addToSet({}, [
        ...$3498e5411d24543d$var$svg$1,
        ...$3498e5411d24543d$var$svgFilters,
        ...$3498e5411d24543d$var$svgDisallowed
    ]);
    const ALL_MATHML_TAGS = $3498e5411d24543d$var$addToSet({}, [
        ...$3498e5411d24543d$var$mathMl$1,
        ...$3498e5411d24543d$var$mathMlDisallowed
    ]);
    /**
   * Namespace rules for an element in the SVG namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */ const _checkSvgNamespace = function _checkSvgNamespace(tagName, parent, parentTagName) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
        // The only way to switch from MathML to SVG is via <svg>
        // if the parent is either <annotation-xml> or a MathML
        // text integration point.
        if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
    };
    /**
   * Namespace rules for an element in the MathML namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */ const _checkMathMlNamespace = function _checkMathMlNamespace(tagName, parent, parentTagName) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
    };
    /**
   * Namespace rules for an element in the HTML namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */ const _checkHtmlNamespace = function _checkHtmlNamespace(tagName, parent, parentTagName) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    };
    /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */ const _checkValidNamespace = function _checkValidNamespace(element) {
        let parent = getParentNode(element);
        // In JSDOM, if we're inside shadow DOM, then parentNode
        // can be null. We just simulate parent in this case.
        if (!parent || !parent.tagName) parent = {
            namespaceURI: NAMESPACE,
            tagName: 'template'
        };
        const tagName = $3498e5411d24543d$var$stringToLowerCase(element.tagName);
        const parentTagName = $3498e5411d24543d$var$stringToLowerCase(parent.tagName);
        if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
        if (element.namespaceURI === SVG_NAMESPACE) return _checkSvgNamespace(tagName, parent, parentTagName);
        if (element.namespaceURI === MATHML_NAMESPACE) return _checkMathMlNamespace(tagName, parent, parentTagName);
        if (element.namespaceURI === HTML_NAMESPACE) return _checkHtmlNamespace(tagName, parent, parentTagName);
        // For XHTML and XML documents that support custom namespaces
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
        // The code should never reach this place (this means
        // that the element somehow got namespace that is not
        // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
        // Return false just in case.
        return false;
    };
    /**
   * _forceRemove
   *
   * @param node a DOM node
   */ const _forceRemove = function _forceRemove(node) {
        $3498e5411d24543d$var$arrayPush(DOMPurify.removed, {
            element: node
        });
        try {
            // eslint-disable-next-line unicorn/prefer-dom-node-remove
            getParentNode(node).removeChild(node);
        } catch (_) {
            /* The normal detach failed — this is reached for a parentless node
         (getParentNode() is null, so .removeChild throws). Element.prototype
         .remove() is itself a spec no-op on a parentless node, so a recorded
         "removal" would otherwise hand the caller back an intact,
         payload-bearing node (e.g. a detached IN_PLACE root the mXSS canary or
         the style-with-element-child rule decided to kill). Fail closed by
         throwing — exactly as a clobbered root does at the IN_PLACE entry —
         rather than trying to "neutralize" the node via its own methods.
         Neutralizing would mean calling getAttributeNames()/removeAttribute()
         on the node, both of which a <form> root can clobber via a named child
         (and _isClobbered does not even probe getAttributeNames), so the
         neutralize step could itself be silently defeated, leaving the payload
         intact. A throw touches only the cached, clobber-safe remove() and
         getParentNode(). Generalizes GHSA-r47g-fvhr-h676 (clobbered-form root)
         to every root-kill reason. REPORT-3.
                This lives inside the catch, so it never fires for a normally-removed
         in-tree node: those have a parent, removeChild() succeeds, and the
         catch is not entered. Only a kept (parentless) root reaches here. */ remove(node);
            if (!getParentNode(node)) throw $3498e5411d24543d$var$typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
        }
    };
    /**
   * _stripAttributeNode
   *
   * Remove a single Attr node case/namespace-exactly on an attribute-teardown
   * path. Name-based removeAttribute() ASCII-lowercases its lookup key for an
   * HTML element in an HTML document and so silently misses a case-preserved
   * handler (e.g. `ONERROR` off an XML/XHTML import) - the same defect
   * _removeAttribute() was fixed for, which a name-based call would reintroduce
   * on these IN_PLACE teardown paths. Unlike _removeAttribute this does not
   * record into DOMPurify.removed: the neutralize passes intentionally do not
   * book-keep. A clobbered/detached node falls back to best-effort name-based
   * removal.
   *
   * @param element the element to strip the attribute from
   * @param attribute the Attr node to remove
   * @param name the attribute's name, for the fallback path
   */ const _stripAttributeNode = function _stripAttributeNode(element, attribute, name) {
        try {
            element.removeAttributeNode(attribute);
        } catch (_) {
            try {
                element.removeAttribute(name);
            } catch (_) {}
        }
    };
    /**
   * _neutralizeRoot
   *
   * Fail-closed teardown of an in-place root after the sanitize walk aborts
   * (campaign-3 F2). An internal throw mid-walk — e.g. a page-registered
   * custom element's reaction detaches a node so `_forceRemove`'s deliberate
   * parentless guard throws, or any other re-entrant engine mutation — would
   * otherwise leave the caller's *live* tree half-sanitized, with everything
   * after the abort point still carrying its handlers. There is no safe way
   * to resume the walk (the tree mutated under us), so we strip the root bare:
   * remove every child and every attribute, then let the caller's catch see
   * the original error. Clobber-safe (cached `remove`/`childNodes`/`attributes`
   * getters; the root was already clobber-pre-flighted at the IN_PLACE entry).
   *
   * @param root the in-place root to empty
   */ const _neutralizeRoot = function _neutralizeRoot(root) {
        /* Strip every disallowed attribute (on* handlers included) off the whole
       subtree BEFORE detaching anything. Detaching first would hand back
       handler-bearing originals (e.g. an already-loading `<img onerror>`)
       whose queued resource event still fires in page scope after we throw.
       Clobber-safe reads; a doomed clobbered node's own attributes are
       irrelevant while its non-clobbered descendants are reached and scrubbed. */ _neutralizeSubtree(root);
        const childNodes = getChildNodes(root);
        if (childNodes) {
            const snapshot = [];
            $3498e5411d24543d$var$arrayForEach(childNodes, (child)=>{
                $3498e5411d24543d$var$arrayPush(snapshot, child);
            });
            $3498e5411d24543d$var$arrayForEach(snapshot, (child)=>{
                try {
                    remove(child);
                } catch (_) {
                /* Best-effort teardown; a still-attached child is handled below */ }
            });
        }
        const attributes = getAttributes(root);
        if (attributes) for(let i = attributes.length - 1; i >= 0; --i){
            const attribute = attributes[i];
            const name = attribute && attribute.name;
            if (typeof name === 'string') _stripAttributeNode(root, attribute, name);
        }
    };
    /**
   * _removeAttribute
   *
   * Name-based getAttributeNode()/removeAttribute() ASCII-lowercase their
   * lookup key for HTML elements in an HTML document, so they silently miss an
   * attribute whose stored qualified name still contains uppercase ASCII
   * letters. That happens when the node came from a case-preserving source
   * (an XML/XHTML document imported via importNode(), or createAttributeNS()),
   * where e.g. `ONERROR` survives the walk: the policy check lowercases to
   * `onerror` and rejects it, but `removeAttribute('ONERROR')` looks up
   * `onerror` and finds nothing. Remove the exact Attr node instead, which is
   * case- and namespace-exact, and fall back to name-based removal only when
   * the caller could not supply the node.
   *
   * @param name an Attribute name
   * @param element a DOM node
   * @param attr the exact Attr node to remove, when the caller has it
   */ const _removeAttribute = function _removeAttribute(name, element, attr) {
        if (!attr) try {
            attr = element.getAttributeNode(name);
        } catch (_) {
            attr = null;
        }
        $3498e5411d24543d$var$arrayPush(DOMPurify.removed, {
            attribute: attr || null,
            from: element
        });
        try {
            if (attr) element.removeAttributeNode(attr);
            else element.removeAttribute(name);
        } catch (_) {
            /* Clobbered or already-detached node - best-effort fall back to a
         name-based removal so the "is" handling below still runs. */ try {
                element.removeAttribute(name);
            } catch (_) {}
        }
        // We void attribute values for unremovable "is" attributes
        if (name === 'is') {
            if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                _forceRemove(element);
            } catch (_) {}
            else try {
                element.setAttribute(name, '');
            } catch (_) {}
        }
    };
    /**
   * _stripDisallowedAttributes
   *
   * Removes every attribute the active configuration does not allow from a
   * single element, using the same allowlist as the main attribute pass (so
   * `on*` handlers go, but no `/^on/` blocklist is introduced). Used only to
   * neutralise nodes that are being discarded from an in-place tree.
   *
   * @param element the element to strip
   */ const _stripDisallowedAttributes = function _stripDisallowedAttributes(element) {
        const attributes = getAttributes(element);
        if (!attributes) return;
        for(let i = attributes.length - 1; i >= 0; --i){
            const attribute = attributes[i];
            const name = attribute && attribute.name;
            if (typeof name !== 'string' || ALLOWED_ATTR[transformCaseFunc(name)]) continue;
            _stripAttributeNode(element, attribute, name);
        }
    };
    /**
   * _neutralizeSubtree
   *
   * Completes the audit-5 F1 fix across every removal path. The KEEP_CONTENT
   * move-hoist neutralises only disallowed-tag removals; clobber, mXSS-canary,
   * namespace, comment, processing-instruction and KEEP_CONTENT:false removals
   * all drop their subtree wholesale via `_forceRemove`. On the IN_PLACE path
   * those dropped nodes are detached from the caller's LIVE tree but a
   * handler-bearing original among them (an `<img onerror>`/`<video>` that was
   * loading) keeps its queued resource event, which fires in page scope after
   * sanitize returns. This walks a removed subtree and strips every attribute
   * the active configuration does not allow — so `on*` handlers are cancelled
   * through the SAME allowlist that governs kept nodes, not a separate `/^on/`
   * blocklist. Run synchronously before sanitize returns, i.e. before any
   * queued event can fire. Hook-free by design: these nodes leave the output,
   * so firing attribute hooks for them would be surprising. Clobber-safe reads;
   * a doomed clobbered node may shadow `removeAttribute` (its own attributes are
   * irrelevant — it is discarded — while its non-clobbered descendants, e.g.
   * the `<img>`, are reached and scrubbed).
   *
   * @param root the root of a removed subtree to neutralise
   */ const _neutralizeSubtree = function _neutralizeSubtree(root) {
        const stack = [
            root
        ];
        while(stack.length > 0){
            const node = stack.pop();
            const nodeType = _readNodeType(node);
            if (nodeType === $3498e5411d24543d$var$NODE_TYPE.element) _stripDisallowedAttributes(node);
            const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
        }
    };
    /**
   * _neutralizePatchLinkage
   *
   * IN_PLACE entry pre-pass (declarative-partial-updates / streaming
   * hardening, https://github.com/WICG/declarative-partial-updates).
   *
   * The main walk strips patch linkage (`for`/`patchsrc`) and removes range
   * markers (PIs / markup comments) node-by-node, in document order, AS it
   * reaches each node. On a live in-place root that leaves a window: from the
   * moment the root is connected until the walk arrives at a given node, that
   * node's linkage is live. A patch applied on connection/stream can fire as
   * a microtask during the walk and inject or teleport an unsanitized DOM
   * range into a region the iterator has already passed and will not revisit,
   * so the post-return "tree is sanitized" contract is violated. Sweep the
   * whole tree once up front and sever every linkage before the walk begins,
   * closing that window.
   *
   * This CANNOT undo a patch that already fired before sanitize ran — that is
   * the irreducible "do not IN_PLACE a live-connected attacker tree" caveat —
   * but it closes everything from sanitize-start onward. Gated on SAFE_FOR_XML
   * to group with the rest of the declarative-partial-updates handling and
   * stay overridable, consistent with the codebase.
   *
   * Clobber-safe traversal (cached childNodes getter); per-node try/catch so a
   * clobbered root cannot defeat the sweep of its non-clobbered descendants.
   *
   * NOTE (pending real-Chrome confirmation, see test/declarative-patch-probe
   * .html Q1): this mirrors the existing policy of keeping `for` on
   * <label>/<output>. If the shipping feature can drive a patch through a
   * surviving `for`-on-label/output + `id` pair, this pre-pass and the
   * attribute check at _isBasicCustomElement's caller must additionally drop
   * that pair on the IN_PLACE path. Left as-is until the taxonomy is verified.
   *
   * @param root the in-place root to sweep
   */ /**
   * Central policy for declarative-partial-updates patch-linkage attributes,
   * shared by the _neutralizePatchLinkage pre-pass and _isValidAttribute so
   * the two sites cannot drift: `patchsrc` always links, `for` links
   * everywhere except on <label>/<output>, and the whole policy is gated on
   * SAFE_FOR_XML (see the rationale block in _isValidAttribute).
   *
   * @param lcName the transformCaseFunc'd attribute name
   * @param lcTag the transformCaseFunc'd tag name of the carrying element
   * @return true if the attribute is patch linkage and must be dropped
   */ const _isPatchLinkageAttribute = function _isPatchLinkageAttribute(lcName, lcTag) {
        if (!SAFE_FOR_XML) return false;
        if (lcName === 'patchsrc') return true;
        return lcName === 'for' && lcTag !== 'label' && lcTag !== 'output';
    };
    const _neutralizePatchLinkage = function _neutralizePatchLinkage(root) {
        if (!SAFE_FOR_XML) return;
        const stack = [
            root
        ];
        while(stack.length > 0){
            const node = stack.pop();
            const nodeType = _readNodeType(node);
            /* Remove range markers (the target side of a patch linkage): every
         processing instruction, and any markup-bearing comment. */ if (nodeType === $3498e5411d24543d$var$NODE_TYPE.processingInstruction || nodeType === $3498e5411d24543d$var$NODE_TYPE.comment && $3498e5411d24543d$var$regExpTest($3498e5411d24543d$var$COMMENT_MARKUP_PROBE, node.data)) {
                try {
                    remove(node);
                } catch (_) {
                /* Best-effort */ }
                continue;
            }
            /* Strip patch-source attributes (the source side) off elements. */ if (nodeType === $3498e5411d24543d$var$NODE_TYPE.element) {
                const element = node;
                const lcTag = transformCaseFunc(_readNodeName(node));
                try {
                    if (element.hasAttribute && element.hasAttribute('patchsrc')) element.removeAttribute('patchsrc');
                    if (element.hasAttribute && element.hasAttribute('for') && _isPatchLinkageAttribute('for', lcTag)) element.removeAttribute('for');
                } catch (_) {
                /* Clobbered removeAttribute/hasAttribute on a doomed node — ignore */ }
            }
            const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
        }
    };
    /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */ const _initDocument = function _initDocument(dirty) {
        /* Create a HTML document */ let doc = null;
        let leadingWhitespace = null;
        if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
        else {
            /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = $3498e5411d24543d$var$stringMatch(dirty, /^[\r\n\t ]+/);
            leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
        const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
        /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */ if (NAMESPACE === HTML_NAMESPACE) try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
        /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
            doc = implementation.createDocument(NAMESPACE, 'template', null);
            try {
                doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
            } catch (_) {
            // Syntax error if dirtyPayload is invalid xml
            }
        }
        const body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
        return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */ const _createNodeIterator = function _createNodeIterator(root) {
        /* Read ownerDocument through the cached Node.prototype getter, never the
       direct property. HTMLFormElement has [LegacyOverrideBuiltIns], so a
       clobbering child (<input name="ownerDocument"> or a form-associated
       external input) shadows the prototype getter and makes a direct read
       return that <input>. createNodeIterator.call(<input>, ...) then throws
       "Illegal invocation", and on the IN_PLACE path that throw lands before
       the walk's fail-closed barrier - leaving the caller's live tree, with
       any already-armed handler in it, un-neutralized. The cached getter
       returns the real Document regardless of the clobber. */ const doc = getOwnerDocument ? getOwnerDocument(root) : root.ownerDocument;
        return createNodeIterator.call(doc || root, root, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
    };
    /**
   * Replace template expression syntax (mustache, ERB, template
   * literal) with a space; shared by all SAFE_FOR_TEMPLATES scrub
   * sites. Order matters: mustache, then ERB, then template literal.
   *
   * @param value the string to scrub
   * @returns the scrubbed string
   */ const _stripTemplateExpressions = function _stripTemplateExpressions(value) {
        value = $3498e5411d24543d$var$stringReplace(value, MUSTACHE_EXPR$1, ' ');
        value = $3498e5411d24543d$var$stringReplace(value, ERB_EXPR$1, ' ');
        value = $3498e5411d24543d$var$stringReplace(value, TMPLIT_EXPR$1, ' ');
        return value;
    };
    /**
   * Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
   * character data of an element subtree. Used as the final safety net for
   * SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
   * which only form after text-node normalization (e.g. fragments split across
   * stripped elements) cannot survive into a template-evaluating framework.
   *
   * Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
   * in place rather than round-tripping through innerHTML. This preserves
   * descendant node references (important for IN_PLACE callers), avoids a
   * serialize/reparse cycle, and reads literal character data — which means
   * `<%...%>` in text content matches the ERB regex against its real bytes
   * instead of the HTML-entity-escaped form innerHTML would produce.
   *
   * Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
   * attributes is performed during the per-node `_sanitizeAttributes` pass.
   *
   * @param node The root element whose character data should be scrubbed.
   */ const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
        var _node$querySelectorAl;
        node.normalize();
        /* Clobber-safe ownerDocument read, same reasoning as _createNodeIterator:
       under SAFE_FOR_TEMPLATES this runs on the live IN_PLACE root, which may
       carry a form-named-getter override of ownerDocument. */ const doc = getOwnerDocument ? getOwnerDocument(node) : node.ownerDocument;
        const walker = createNodeIterator.call(doc || node, node, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
        let currentNode = walker.nextNode();
        while(currentNode){
            currentNode.data = _stripTemplateExpressions(currentNode.data);
            currentNode = walker.nextNode();
        }
        // NodeIterator does not descend into <template>.content per the DOM spec,
        // so we must explicitly recurse into each template's content fragment,
        // mirroring the approach used by _sanitizeShadowDOM.
        const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, 'template');
        if (templates) $3498e5411d24543d$var$arrayForEach(templates, (tmpl)=>{
            if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
        });
    };
    /**
   * _isClobbered
   *
   * Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
   * interface with [LegacyOverrideBuiltIns]; a descendant element with a
   * `name` attribute matching a prototype property shadows that property
   * on direct reads. We use this check at the IN_PLACE entry-point and
   * during attribute sanitization to refuse clobbered forms.
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */ const _isClobbered = function _isClobbered(element) {
        // Realm-independent tag-name probe. If we can't determine the tag
        // name at all, we can't reason about clobbering — return false
        // (the caller's other defences still apply).
        const realTagName = getNodeName ? getNodeName(element) : null;
        if (typeof realTagName !== 'string') return false;
        if (transformCaseFunc(realTagName) !== 'form') return false;
        return typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || // Realm-safe NamedNodeMap detection: equality against the cached
        // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
        // makes the direct read diverge from the cached read; a clean form
        // (same-realm OR foreign-realm) has both reads pointing at the same
        // canonical NamedNodeMap.
        element.attributes !== getAttributes(element) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function' || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
        // returns the integer 1 for any Element regardless of realm; direct
        // read on a clobbered form (e.g. <input name="nodeType">) returns
        // the named child element. Cheap addition — nodeType is read from
        // an internal slot, no serialization cost — and removes a residual
        // clobbering surface used by several mXSS / PI / comment branches
        // in _sanitizeElements that compare currentNode.nodeType directly.
        element.nodeType !== getNodeType(element) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
        // "childNodes" shadows the prototype getter. Direct reads of
        // form.childNodes from a clobbered form return the named child
        // instead of the real NodeList, so any walk that reads it directly
        // skips the form's real children. Compare the direct read to the
        // cached Node.prototype getter — when the form's named-property
        // getter intercepts the read, the two values differ and we flag
        // the form. This catches every clobbering child type (input,
        // select, etc.) regardless of whether the named child happens to
        // carry a numeric .length, which a typeof-based probe would miss
        // (e.g. HTMLSelectElement.length is a defined unsigned-long).
        element.childNodes !== getChildNodes(element);
    };
    /**
   * Checks whether the given value is a DocumentFragment from any realm.
   *
   * The realm-independent replacement reads `nodeType` through the cached
   * Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
   * constant (11). nodeType is a numeric value resolved from the node's
   * internal slot, identical across realms for the same kind of node.
   *
   * @param value object to check
   * @return true if value is a DocumentFragment-shaped node from any realm
   */ const _isDocumentFragment = function _isDocumentFragment(value) {
        if (!getNodeType || typeof value !== 'object' || value === null) return false;
        try {
            return getNodeType(value) === $3498e5411d24543d$var$NODE_TYPE.documentFragment;
        } catch (_) {
            return false;
        }
    };
    /**
   * Checks whether the given object is a DOM node, including nodes that
   * originate from a different window/realm (e.g. an iframe's
   * contentDocument). The previous `value instanceof Node` check was
   * realm-bound: nodes from a different window failed it, causing
   * sanitize() to silently stringify them and reset IN_PLACE to false,
   * returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
   *
   * @param value object to check whether it's a DOM node
   * @return true if value is a DOM node from any realm
   */ const _isNode = function _isNode(value) {
        if (!getNodeType || typeof value !== 'object' || value === null) return false;
        try {
            return typeof getNodeType(value) === 'number';
        } catch (_) {
            return false;
        }
    };
    function _executeHooks(hooks, currentNode, data) {
        if (hooks.length === 0) return;
        $3498e5411d24543d$var$arrayForEach(hooks, (hook)=>{
            hook.call(DOMPurify, currentNode, data, CONFIG);
        });
    }
    /**
   * Structural-threat checks that condemn a node regardless of the
   * allowlists: mXSS via namespace confusion, risky CSS construction,
   * processing instructions, markup-bearing comments. Pure predicate;
   * the caller removes. Check order is load-bearing.
   *
   * @param currentNode the node to inspect
   * @param tagName the node's transformCaseFunc'd tag name
   * @return true if the node must be removed
   */ const _isUnsafeNode = function _isUnsafeNode(currentNode, tagName) {
        /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && $3498e5411d24543d$var$regExpTest($3498e5411d24543d$var$ELEMENT_MARKUP_PROBE, currentNode.textContent) && $3498e5411d24543d$var$regExpTest($3498e5411d24543d$var$ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) return true;
        /* Remove rawtext/literal-text elements whose literal serialization
       re-opens markup on an HTML reparse - shapes (a) and (b) documented at
       LITERAL_TEXT_ELEMENTS. Both are invisible to rule 1 above (which
       self-disables once there is an element child, and whose second probe
       reads the innerHTML an XML/XHTML document serializes escaped), which
       is why both probes here read textContent instead. Previously only
       `style`-with-element-child was covered; every element in
       LITERAL_TEXT_ELEMENTS shares this literal serialization and is
       equally affected. */ if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && $3498e5411d24543d$var$LITERAL_TEXT_ELEMENTS[tagName] && (_isNode(currentNode.firstElementChild) || typeof currentNode.textContent === 'string' && $3498e5411d24543d$var$regExpTest($3498e5411d24543d$var$LITERAL_TEXT_CLOSE[tagName], currentNode.textContent))) return true;
        /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === $3498e5411d24543d$var$NODE_TYPE.processingInstruction) return true;
        /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === $3498e5411d24543d$var$NODE_TYPE.comment && $3498e5411d24543d$var$regExpTest($3498e5411d24543d$var$COMMENT_MARKUP_PROBE, currentNode.data)) return true;
        return false;
    };
    /**
   * Evaluate a CUSTOM_ELEMENT_HANDLING check (a RegExp or a predicate
   * function, per the validation in _parseConfig) against a name.
   * Additional arguments are forwarded to predicate functions - the
   * attributeNameCheck predicate receives the tag name as its second
   * argument. A null/absent check never matches.
   *
   * @param check the configured tagNameCheck / attributeNameCheck value
   * @param name the name to test
   * @param args extra arguments forwarded to a predicate function
   * @return true if the check matches the name
   */ const _matchesNameCheck = function _matchesNameCheck(check, name) {
        if (check instanceof RegExp) return $3498e5411d24543d$var$regExpTest(check, name);
        if (check instanceof Function) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return Boolean(check(name, ...args));
        }
        return false;
    };
    /**
   * Handle a node whose tag is forbidden or not allowlisted: keep
   * allowed custom elements (false return exits _sanitizeElements
   * early - the namespace and fallback-tag removal checks are
   * intentionally skipped for kept custom elements), else hoist
   * content per KEEP_CONTENT and remove.
   *
   * A kept custom element is the ONLY case in which this function
   * returns false, so the caller uses that return value to run the
   * afterSanitizeElements hook on the kept element and keep the
   * element-hook lifecycle consistent with normal allowlisted
   * elements (GHSA-c2j3-45gr-mqc4).
   *
   * @param currentNode the disallowed node
   * @param tagName the node's transformCaseFunc'd tag name
   * @return true if the node was removed, false if kept
   */ const _sanitizeDisallowedNode = function _sanitizeDisallowedNode(currentNode, tagName, root) {
        /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
        /* Keep content except for bad-listed elements.
         Use the cached prototype getters exclusively — the previous code
         had `|| currentNode.parentNode` / `|| currentNode.childNodes`
         fallbacks, but the cached getters always return the canonical
         value (or null for a real parent-less node), so the fallback
         path was dead in safe cases and a clobbering surface in unsafe
         ones. Falsy cached results stay falsy; the `if (childNodes &&
         parentNode)` check already gates correctly. */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
            const parentNode = getParentNode(currentNode);
            const childNodes = getChildNodes(currentNode);
            if (childNodes && parentNode) {
                const childCount = childNodes.length;
                /* Hoist by moving each child up one level rather than deep-cloning
             it. Moving transfers every descendant exactly once, so a chain of
             nested disallowed elements costs O(n) instead of the O(n^2) that
             re-cloning the shrinking subtree at each level produced; it also
             empties the removed original, so `DOMPurify.removed` no longer
             pins whole subtrees. Moving preserves the in-place guarantee too:
             an original carrying already-queued resource events (`<img
             onerror>`, `<video>`/`<audio>` error, lazy/`onload`, …) is
             relocated and sanitised rather than left detached but still armed.
                      The sole case that must clone is removing the walk root itself.
             The result is serialised from the root's subtree, so a restrictive
             ALLOWED_TAGS that strips the root (`body` on the string path) must
             leave the content inside it, which only cloning does. In IN_PLACE
             the root is pre-validated as an allowed tag and so is never removed
             here, so that path always takes the move branch.
                      `childNodes` is live; a tail-to-head walk keeps `childNodes[i]`
             valid whether we move (drops the trailing entry) or clone (leaves
             the list intact). */ for(let i = childCount - 1; i >= 0; --i){
                    const hoisted = currentNode === root ? cloneNode(childNodes[i], true) : childNodes[i];
                    parentNode.insertBefore(hoisted, getNextSibling(currentNode));
                }
            }
        }
        _forceRemove(currentNode);
        return true;
    };
    /**
   * Fork a hook-mutable allowlist off its shared binding the first time a
   * (possibly lazily-installed) uponSanitize* hook is about to see it, so the
   * hook cannot widen the per-instance default or the setConfig binding by
   * reference and leak past the call. Returns the set unchanged once it is
   * already call-local, so repeated calls across elements are idempotent.
   *
   * @param hookList the uponSanitize* hook array for this event
   * @param set the current ALLOWED_TAGS / ALLOWED_ATTR binding
   * @param defaultSet the per-instance DEFAULT_ALLOWED_* constant
   * @param setConfigSet the captured setConfig() binding, or null
   * @return a call-local clone if a hook is present and set is still shared,
   *   else set unchanged
   */ const _forkSharedAllowlist = function _forkSharedAllowlist(hookList, set, defaultSet, setConfigSet) {
        if (hookList.length === 0) return set;
        return set === defaultSet || set === setConfigSet ? $3498e5411d24543d$var$clone(set) : set;
    };
    /**
   * Shared guard for a node that a hook has detached from the walk tree,
   * used after each element-hook site in _sanitizeElements. Detaching is a
   * long-standing user pattern (issue #469; draw.io-style foreignObject
   * filtering). Per the cached, unclobberable parentNode getter the node is
   * genuinely out of the tree, so it can reach neither the serialized
   * output nor an IN_PLACE live tree; treat it as removed and stop
   * processing it. Without this guard, the unsafe-node / namespace checks
   * would call _forceRemove on a parentless node and hit the REPORT-3
   * fail-closed throw — which exists for nodes DOMPurify wants gone but
   * *cannot* detach (clobbered / parentless roots), the opposite of a node
   * that is already safely gone. The walk root is exempt: a detached
   * IN_PLACE root is legitimate input and must still be fully sanitized,
   * and a kill-decision on it must keep hitting the REPORT-3 throw.
   *
   * Nodes detached by hooks stay the hook's responsibility for placement:
   * they are not recorded in DOMPurify.removed, so the post-walk IN_PLACE
   * pass (which iterates DOMPurify.removed) does not reach them. But a
   * hook-detached subtree can still hold a queued resource-event handler -
   * e.g. an <img onload> that began loading when the caller built the live
   * tree - which fires in page scope after sanitize returns even though the
   * handler never reached the returned tree. That is the audit-5 F1 hazard,
   * and the documented node.remove() hook pattern walks straight into it.
   * So on the IN_PLACE path we neutralize the detached subtree inline,
   * stripping its non-allow-listed attributes before returning, exactly as
   * the post-walk pass does for _forceRemove'd subtrees.
   *
   * @param currentNode the node a hook may have detached
   * @param root the current walk root
   * @return true if the node is detached and now handled, false otherwise
   */ const _handleHookDetachedNode = function _handleHookDetachedNode(currentNode, root) {
        if (currentNode === root || getParentNode(currentNode) !== null) return false;
        if (IN_PLACE) _neutralizeSubtree(currentNode);
        return true;
    };
    /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */ const _sanitizeElements = function _sanitizeElements(currentNode, root) {
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
        /* A hook may have detached the node - treat it as removed (see
       _handleHookDetachedNode for the full rationale). */ if (_handleHookDetachedNode(currentNode, root)) return true;
        /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Now let's check the element's type and name */ const tagName = transformCaseFunc(_readNodeName(currentNode));
        /* Close the pre-walk clone-guard's timing gap: an uponSanitizeElement
       hook may have been installed after that guard sampled the hook arrays
       (e.g. lazily from beforeSanitizeElements), leaving ALLOWED_TAGS still
       aliasing a shared binding that a widening hook would mutate by
       reference. Fork it before exposing it to the hook. */ ALLOWED_TAGS = _forkSharedAllowlist(hooks.uponSanitizeElement, ALLOWED_TAGS, DEFAULT_ALLOWED_TAGS, SET_CONFIG_ALLOWED_TAGS);
        /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
            tagName: tagName,
            allowedTags: ALLOWED_TAGS
        });
        /* The uponSanitizeElement hook may have detached the node, exactly as
       above (see _handleHookDetachedNode for the full rationale). */ if (_handleHookDetachedNode(currentNode, root)) return true;
        /* Remove mXSS vectors, processing instructions and risky comments */ if (_isUnsafeNode(currentNode, tagName)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove element if anything forbids its presence */ if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
            const removed = _sanitizeDisallowedNode(currentNode, tagName, root);
            /* A false return means the node is a custom element kept via
         CUSTOM_ELEMENT_HANDLING - the only keep path through
         _sanitizeDisallowedNode. Run afterSanitizeElements on it so the
         element-hook lifecycle matches normal allowlisted elements: a
         security policy applied in this hook (e.g. stripping an attribute
         from every surviving element) must not silently skip kept custom
         elements (GHSA-c2j3-45gr-mqc4). This mirrors the normal-element
         tail below - the hook runs, then the walker's subsequent
         _sanitizeAttributes pass sanitizes the element's attributes. The
         deliberately skipped namespace and fallback-tag removal checks stay
         skipped; they are removal decisions, not the hook contract. */ if (removed === false) _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return removed;
        }
        /* Check whether element has a valid namespace.
       Realm-safe check (GHSA-hpcv-96wg-7vj8): use the cached Node.prototype
       nodeType getter rather than `instanceof Element`, which is realm-
       bound and short-circuits to false for any node minted in a different
       realm — letting a foreign-realm element with a forbidden namespace
       slip past the namespace check entirely. */ const nt = _readNodeType(currentNode);
        if (nt === $3498e5411d24543d$var$NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && $3498e5411d24543d$var$regExpTest($3498e5411d24543d$var$FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === $3498e5411d24543d$var$NODE_TYPE.text) {
            /* Get the element's text content */ const content = _stripTemplateExpressions(currentNode.textContent);
            if (currentNode.textContent !== content) {
                $3498e5411d24543d$var$arrayPush(DOMPurify.removed, {
                    element: currentNode.cloneNode()
                });
                currentNode.textContent = content;
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
        return false;
    };
    /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */ // eslint-disable-next-line complexity
    const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
        /* Reject declarative-partial-updates patch-linkage attributes
       (https://github.com/WICG/declarative-partial-updates).
            Empirical note (Chrome 150, verified — see
       test/declarative-patch-probe-v3.html): expansion is NOT applied after
       sanitization. For the string path it fires during sanitize()'s own
       parse, so the walk sees and sanitizes the fully materialized expanded
       tree — teleports into MathML/SVG integration points included; a
       weaponized `<template for>`->`<img onerror>` comes back with the handler
       stripped. For the IN_PLACE path it fires on connection, before the walk.
       Either way DOMPurify is NOT blind to the patch.
            This removal is therefore defense-in-depth rather than the sole barrier:
       it prevents live linkage from surviving into the OUTPUT and re-expanding
       in the caller's context, and keeps behaviour deterministic if a future
       engine defers expansion. `for` is legitimate only on <label>/<output>;
       anywhere else (notably <template for>) it links the element to a patch
       target and teleports or removes an arbitrary DOM range by id/marker name.
       `patchsrc` fetches remote markup and is treated as a script-loading
       mechanism (CSP). Gated on SAFE_FOR_XML so the removal groups with the
       other structural-threat checks and stays overridable, consistent with
       the rest of the codebase. PI range markers are already removed by
       _isUnsafeNode. */ if (_isPatchLinkageAttribute(lcName, lcTag)) return false;
        /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
        const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
        /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && $3498e5411d24543d$var$regExpTest(DATA_ATTR$1, lcName)) return true;
        /* Allow valid aria-* attributes, the value is always URI safe */ if (ALLOW_ARIA_ATTR && $3498e5411d24543d$var$regExpTest(ARIA_ATTR$1, lcName)) return true;
        /* A name outside the allowlist is acceptable on custom-element terms
       only. The value checks below are intentionally skipped in that case:
       if the user supplied a tagNameCheck we also allow derived custom
       elements using the same test, and attributes passing the configured
       attributeNameCheck are allowed as custom elements define these at
       their own discretion. */ if (!nameIsPermitted) return(// Condition a) covers a basically valid custom element tag name whose
        // tag passes the configured tagNameCheck and whose attribute name
        // passes the configured attributeNameCheck ...
        _isBasicCustomElement(lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName, lcTag) || // Condition b) covers an `is` attribute whose value passes the
        // configured tagNameCheck while customized built-in elements are
        // allowed.
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value));
        /* Check value is safe. First, is attr inert? If so, is safe */ if (URI_SAFE_ATTRIBUTES[lcName]) return true;
        /* Check no script, data or unknown possibly unsafe URI
        unless we know URI values are safe for that attribute */ if ($3498e5411d24543d$var$regExpTest(IS_ALLOWED_URI$1, $3498e5411d24543d$var$stringReplace(value, ATTR_WHITESPACE$1, ''))) return true;
        /* Keep image data URIs alive if src/xlink:href is allowed */ /* Further prevent gadget XSS for dynamically built script tags */ if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && $3498e5411d24543d$var$stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) return true;
        /* Allow unknown protocols: This provides support for links that
        are handled by protocol handlers which may be unknown ahead of
        time, e.g. fb:, spotify: */ if (ALLOW_UNKNOWN_PROTOCOLS && !$3498e5411d24543d$var$regExpTest(IS_SCRIPT_OR_DATA$1, $3498e5411d24543d$var$stringReplace(value, ATTR_WHITESPACE$1, ''))) return true;
        /* Only an empty (binary) value remains safe at this point;
       anything else is presumed unsafe, do not add it back */ return !value;
    };
    /* Names the HTML spec reserves from valid-custom-element-name; these must
   * never be treated as basic custom elements even when a permissive
   * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */ const RESERVED_CUSTOM_ELEMENT_NAMES = $3498e5411d24543d$var$addToSet({}, [
        'annotation-xml',
        'color-profile',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'missing-glyph'
    ]);
    /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
        return !RESERVED_CUSTOM_ELEMENT_NAMES[$3498e5411d24543d$var$stringToLowerCase(tagName)] && $3498e5411d24543d$var$regExpTest(CUSTOM_ELEMENT$1, tagName);
    };
    /**
   * Wrap an attribute value in the matching Trusted Types object when
   * the active policy requires it. Namespaced attributes pass through
   * unchanged (no TT support yet, see
   * https://bugs.chromium.org/p/chromium/issues/detail?id=1305293).
   *
   * @param lcTag lowercase tag name of the containing element
   * @param lcName lowercase attribute name
   * @param namespaceURI the attribute's namespace, if any
   * @param value the attribute value to wrap
   * @return the value, wrapped when Trusted Types demand it
   */ const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value) {
        if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function' && !namespaceURI) switch(trustedTypes.getAttributeType(lcTag, lcName)){
            case 'TrustedHTML':
                return _createTrustedHTML(value);
            case 'TrustedScriptURL':
                return _createTrustedScriptURL(value);
        }
        return value;
    };
    /**
   * Write a modified attribute value back onto the element. On
   * success, re-probe for clobbering introduced by the new value and
   * remove the element when found; otherwise pop the removal entry
   * recorded by the earlier _removeAttribute (long-standing pairing
   * with the SANITIZE_NAMED_PROPS path - do not "fix" casually). On
   * failure, remove the attribute instead.
   *
   * @param currentNode the element carrying the attribute
   * @param name the attribute name as present on the element
   * @param namespaceURI the attribute's namespace, if any
   * @param value the new attribute value
   */ const _setAttributeValue = function _setAttributeValue(currentNode, name, namespaceURI, value) {
        try {
            if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
            else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
            if (_isClobbered(currentNode)) _forceRemove(currentNode);
            else $3498e5411d24543d$var$arrayPop(DOMPurify.removed);
        } catch (_) {
            _removeAttribute(name, currentNode);
        }
    };
    /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
        const attributes = currentNode.attributes;
        /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
        /* Same lazy-install guard as uponSanitizeElement (see there): fork the
       attribute allowlist off its shared binding before a hook can see it. */ ALLOWED_ATTR = _forkSharedAllowlist(hooks.uponSanitizeAttribute, ALLOWED_ATTR, DEFAULT_ALLOWED_ATTR, SET_CONFIG_ALLOWED_ATTR);
        const hookEvent = {
            attrName: '',
            attrValue: '',
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR,
            forceKeepAttr: undefined
        };
        let l = attributes.length;
        const lcTag = transformCaseFunc(currentNode.nodeName);
        /* Go backwards over all attributes; safely remove bad ones */ while(l--){
            const attr = attributes[l];
            const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
            const lcName = transformCaseFunc(name);
            const initValue = attrValue;
            let value = name === 'value' ? initValue : $3498e5411d24543d$var$stringTrim(initValue);
            /* Execute a hook if present */ hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
            _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
            value = hookEvent.attrValue;
            /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && $3498e5411d24543d$var$stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                // Remove the attribute with this value
                _removeAttribute(name, currentNode, attr);
                // Prefix the value and later re-create the attribute with the sanitized value
                value = SANITIZE_NAMED_PROPS_PREFIX + value;
            }
            // Else: already prefixed, leave the attribute alone — the prefix is
            // itself the clobbering protection, and re-applying it is incorrect.
            /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && $3498e5411d24543d$var$regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                _removeAttribute(name, currentNode, attr);
                continue;
            }
            /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && $3498e5411d24543d$var$stringMatch(value, 'href')) {
                _removeAttribute(name, currentNode, attr);
                continue;
            }
            /* Did the hooks force-keep the attribute? */ if (hookEvent.forceKeepAttr) continue;
            /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                _removeAttribute(name, currentNode, attr);
                continue;
            }
            /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && $3498e5411d24543d$var$regExpTest($3498e5411d24543d$var$SELF_CLOSING_TAG, value)) {
                _removeAttribute(name, currentNode, attr);
                continue;
            }
            /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) value = _stripTemplateExpressions(value);
            /* Is `value` valid for this attribute? */ if (!_isValidAttribute(lcTag, lcName, value)) {
                _removeAttribute(name, currentNode, attr);
                continue;
            }
            /* Handle attributes that require Trusted Types */ value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
            /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) _setAttributeValue(currentNode, name, namespaceURI, value);
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
    };
    /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
        let shadowNode = null;
        const shadowIterator = _createNodeIterator(fragment);
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
        while(shadowNode = shadowIterator.nextNode()){
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
            /* Sanitize tags and elements */ _sanitizeElements(shadowNode, fragment);
            /* Check attributes next */ _sanitizeAttributes(shadowNode);
            /* Deep shadow DOM detected.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): use nodeType against the
         DOCUMENT_FRAGMENT_NODE constant rather than instanceof, so we
         recurse into <template>.content from foreign realms too. */ if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
            /* An element iterated here may itself host an attached
         shadow root. The default NodeIterator does not enter shadow
         trees, so a shadow root nested inside template.content was
         previously reached by no walk at all (the pre-pass at
         _sanitizeAttachedShadowRoots descends via childNodes, which
         doesn't enter template.content; the template-content recursion
         above iterates the content but never inspected shadowRoot).
         Walk it explicitly. The nodeType guard avoids reading
         shadowRoot off text / comment / CDATA / PI nodes that the
         iterator also surfaces. */ if (_readNodeType(shadowNode) === $3498e5411d24543d$var$NODE_TYPE.element) {
                const innerSr = getShadowRoot(shadowNode);
                if (_isDocumentFragment(innerSr)) {
                    _sanitizeAttachedShadowRoots(innerSr);
                    _sanitizeShadowDOM2(innerSr);
                }
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
    };
    /**
   * _sanitizeAttachedShadowRoots
   *
   * Walks `root` and feeds every attached shadow root we encounter into
   * the existing _sanitizeShadowDOM pipeline. The default node iterator
   * does not descend into shadow trees, so nodes inside an attached
   * shadow root would otherwise be skipped entirely.
   *
   * Two real input paths put attached shadow roots in front of us:
   *   1. IN_PLACE on a DOM node that already has shadow roots attached.
   *   2. DOM-node input where importNode(dirty, true) deep-clones the
   *      shadow root because it was created with `clonable: true`.
   *
   * This pass runs once, up front, so the main iteration loop (and the
   * existing _sanitizeShadowDOM template-content recursion) stay
   * untouched — string-input paths are not affected.
   *
   * @param root the subtree root to walk for attached shadow roots
   */ const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots(root) {
        /* Iterative (explicit stack) rather than per-child recursion. DOM APIs
       impose no depth cap, so an attacker-shaped tree (JSON/CRDT/editor data
       built straight into the DOM — the IN_PLACE surface) deeper than the JS
       call-stack budget would otherwise overflow native recursion here and
       throw at the IN_PLACE entry pre-pass, before a single node is
       sanitized, leaving the caller's live tree untouched (fail-open). See
       campaign-3 F4. A heap stack keeps depth off the call stack.
            Each work item is either a node to descend into, or a deferred
       `_sanitizeShadowDOM` for an already-walked shadow root. The deferred
       form preserves the original post-order discipline: a shadow root's
       nested shadow roots are discovered before the outer shadow is
       sanitized (which may remove hosts). Pushes are in reverse of the
       desired processing order (LIFO): template content, then children, then
       the shadow-sanitize, then the shadow walk — so the order matches the
       previous recursion exactly. */ const stack = [
            {
                node: root,
                shadow: null
            }
        ];
        while(stack.length > 0){
            const item = stack.pop();
            /* Deferred shadow-DOM sanitisation: runs after its subtree was walked. */ if (item.shadow) {
                _sanitizeShadowDOM2(item.shadow);
                continue;
            }
            const node = item.node;
            const nodeType = _readNodeType(node);
            const isElement = nodeType === $3498e5411d24543d$var$NODE_TYPE.element;
            /* (pushed last → processed first) Children, snapshotted in reverse so
         the first child is processed first. Snapshotting matters because a
         hook may detach siblings mid-walk. */ const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push({
                node: childNodes[i],
                shadow: null
            });
            /* (pushed before children → processed after them, matching the old
         "template content last" order) When the node is a <template>,
         descend into its content. */ if (isElement) {
                const rootName = getNodeName ? getNodeName(node) : null;
                if (typeof rootName === 'string' && transformCaseFunc(rootName) === 'template') {
                    const content = node.content;
                    if (_isDocumentFragment(content)) stack.push({
                        node: content,
                        shadow: null
                    });
                }
            }
            /* Shadow root (processed first): walk its subtree, then sanitise it.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
         rather than `instanceof DocumentFragment`, which is realm-bound and
         silently skipped foreign-realm shadow roots (e.g.
         iframe.contentDocument attachShadow). */ if (isElement) {
                const sr = getShadowRoot(node);
                if (_isDocumentFragment(sr)) /* Push the deferred sanitise first so it pops after the shadow
             walk we push next, i.e. nested shadow roots are discovered
             before this one is sanitised. */ stack.push({
                    node: null,
                    shadow: sr
                }, {
                    node: sr,
                    shadow: null
                });
            }
        }
    };
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function(dirty) {
        let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let body = null;
        let importedNode = null;
        let currentNode = null;
        let returnNode = null;
        /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) dirty = '<!-->';
        /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
            dirty = $3498e5411d24543d$var$stringifyValue(dirty);
            if (typeof dirty !== 'string') throw $3498e5411d24543d$var$typeErrorCreate('dirty is not a string, aborting');
        }
        /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
        /* Assign config vars */ if (SET_CONFIG) {
            /* Persistent setConfig() path: _parseConfig is skipped, so the sets are
       * not re-derived per call. Restore them from the pristine bindings
       * captured at setConfig() time so a previous call's hook clone (mutated
       * below) does not carry over. */ ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
            ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
        } else _parseConfig(cfg);
        /* Clone the hook-mutable allowlists before the walk whenever an
     * uponSanitize* hook is registered. The hook event exposes ALLOWED_TAGS
     * and ALLOWED_ATTR by reference (as allowedTags / allowedAttributes), so
     * a hook that widens them would otherwise mutate the shared set
     * permanently: across later calls and across every element. Cloning per
     * walk keeps documented in-call widening working while scoping it to the
     * call. A single guard for both config paths - the per-call path rebinds
     * the sets in _parseConfig each call, the persistent path restores them
     * from the captured bindings just above - so the two cannot diverge. */ if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) ALLOWED_TAGS = $3498e5411d24543d$var$clone(ALLOWED_TAGS);
        if (hooks.uponSanitizeAttribute.length > 0) ALLOWED_ATTR = $3498e5411d24543d$var$clone(ALLOWED_ATTR);
        /* Clean up removed elements */ DOMPurify.removed = [];
        /* Resolve IN_PLACE for this call without mutating persistent config.
       Writing the IN_PLACE closure variable here leaks under setConfig(),
       where _parseConfig is skipped on later calls: a single string call would
       disable in-place mode for every subsequent node call, returning a
       sanitized copy while leaving the caller's node — which in-place callers
       keep using and whose return value they ignore — unsanitized. REPORT-2. */ const inPlace = IN_PLACE && typeof dirty !== 'string' && _isNode(dirty);
        if (inPlace) {
            /* Declarative-partial-updates / streaming pre-pass: sever every patch
         linkage across the live tree BEFORE the walk, so no patch can fire
         mid-walk and inject into an already-processed region. Runs first, so
         it also covers the forbidden/clobbered roots that throw below. */ _neutralizePatchLinkage(dirty);
            /* Do some early pre-sanitization to avoid unsafe root nodes.
         Read nodeName through the cached prototype getter — a clobbering
         child named "nodeName" on the form root would otherwise shadow
         the property and let this check skip the root-allowlist
         validation entirely. */ const nn = _readNodeName(dirty);
            if (typeof nn === 'string') {
                const tagName = transformCaseFunc(nn);
                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                    /* Fail closed on a live root: neutralize handlers/children before
             throwing, exactly as the mid-walk abort path does. */ _neutralizeRoot(dirty);
                    throw $3498e5411d24543d$var$typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            }
            /* Pre-flight the root through _isClobbered. The iterator-driven
         removal path can not detach a parent-less root: _forceRemove
         falls through to Element.prototype.remove(), which per spec
         is a no-op on a node with no parent. A clobbered root would
         then survive the main loop with its attributes uninspected,
         because _sanitizeAttributes early-returns on _isClobbered. The
         result would be an attacker-controlled form, complete with any
         event-handler attributes the caller passed in, handed back to
         the application unsanitized. Refuse to sanitize such a root
         the same way we refuse a forbidden tag. GHSA-r47g-fvhr-h676. */ if (_isClobbered(dirty)) {
                /* Fail closed on a live clobbered root before throwing.
           _neutralizeRoot's reads are clobber-safe (cached getters); the
           form's non-clobbered descendants, e.g. an armed <img>, are scrubbed. */ _neutralizeRoot(dirty);
                throw $3498e5411d24543d$var$typeErrorCreate('root node is clobbered and cannot be sanitized in-place');
            }
            /* Sanitize attached shadow roots before the main iterator runs.
         The iterator does not descend into shadow trees. Same fail-closed
         barrier as the main walk (campaign-3 F2): a custom-element reaction
         inside a shadow root could abort this pre-pass before the walk runs,
         which would otherwise leave the entire live tree unsanitized. */ try {
                _sanitizeAttachedShadowRoots(dirty);
            } catch (error) {
                _neutralizeRoot(dirty);
                throw error;
            }
        } else if (_isNode(dirty)) {
            /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */ body = _initDocument('<!---->');
            importedNode = body.ownerDocument.importNode(dirty, true);
            if (importedNode.nodeType === $3498e5411d24543d$var$NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
            else if (importedNode.nodeName === 'HTML') body = importedNode;
            else // eslint-disable-next-line unicorn/prefer-dom-node-append
            body.appendChild(importedNode);
            /* Clonable shadow roots are deep-cloned by importNode(); sanitize
         them before the main iterator runs, since the iterator does not
         descend into shadow trees. The walk routes every read through a
         cached prototype getter so clobbering descendants on a form root
         cannot hide a shadow host from this pass. */ _sanitizeAttachedShadowRoots(importedNode);
        } else {
            /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
            dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
            /* Initialize the document to work on */ body = _initDocument(dirty);
            /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
        /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
        /* Get node iterator */ const walkRoot = inPlace ? dirty : body;
        /* Now start iterating over the created document.
       The walk runs inside an exception barrier (campaign-3 F2): a re-entrant
       engine/custom-element mutation can detach a node mid-walk so
       `_forceRemove`'s parentless guard throws, aborting the loop. Without the
       barrier the caller's in-place tree would be left half-sanitized with the
       unvisited tail still armed. _createNodeIterator itself is inside the
       barrier too: constructing the iterator dereferences the root's document,
       and any failure there (e.g. an exotic/clobbered root) must still fail
       closed rather than skip the neutralize. On any throw we fail closed -
       strip the in-place root bare - then rethrow so the existing throw
       contract is preserved. (String/DOM-copy paths never return the partial
       body, so the propagating throw is already fail-closed there.) */ try {
            const nodeIterator = _createNodeIterator(walkRoot);
            while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode, walkRoot);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
           instead of instanceof, so foreign-realm <template>.content is
           walked correctly. */ if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
            }
        } catch (error) {
            if (inPlace) {
                _neutralizeRoot(dirty);
                /* Nodes _forceRemove'd earlier in the aborted walk are already
           detached from the root, so _neutralizeRoot's subtree pass does not
           reach them. Defuse them too, mirroring the success-path loop below. */ $3498e5411d24543d$var$arrayForEach(DOMPurify.removed, (entry)=>{
                    if (entry.element) _neutralizeSubtree(entry.element);
                });
            }
            throw error;
        }
        /* If we sanitized `dirty` in-place, return it. */ if (inPlace) {
            /* Fail-closed completion of the audit-5 F1 fix: every node removed from
         the caller's live tree is detached but may still hold a queued
         resource-event handler that fires in page scope after we return. The
         move-hoist covers only disallowed-tag KEEP_CONTENT removals; strip the
         non-allow-listed attributes off every other removed subtree (clobber,
         mXSS, namespace, comments, KEEP_CONTENT:false, …) so those handlers are
         cancelled before any event can fire. Runs synchronously, pre-return. */ $3498e5411d24543d$var$arrayForEach(DOMPurify.removed, (entry)=>{
                if (entry.element) _neutralizeSubtree(entry.element);
            });
            if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
            return dirty;
        }
        /* Return sanitized string or DOM */ if (RETURN_DOM) {
            if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
            if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);
                while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                returnNode.appendChild(body.firstChild);
            } else returnNode = body;
            if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */ returnNode = importNode.call(originalDocument, returnNode, true);
            return returnNode;
        }
        let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && $3498e5411d24543d$var$regExpTest($3498e5411d24543d$var$DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
        /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) serializedHTML = _stripTemplateExpressions(serializedHTML);
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
    };
    DOMPurify.setConfig = function() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _parseConfig(cfg);
        SET_CONFIG = true;
        SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
        SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
    };
    DOMPurify.clearConfig = function() {
        CONFIG = null;
        SET_CONFIG = false;
        SET_CONFIG_ALLOWED_TAGS = null;
        SET_CONFIG_ALLOWED_ATTR = null;
        // Drop any caller-supplied Trusted Types policy so it cannot poison later
        // `RETURN_TRUSTED_TYPE` output. The internal default policy (cached, and
        // never recreated — Trusted Types throws on duplicate names) is restored by
        // the next `_parseConfig`. See GHSA-vxr8-fq34-vvx9.
        trustedTypesPolicy = defaultTrustedTypesPolicy;
        emptyHTML = '';
    };
    DOMPurify.isValidAttribute = function(tag, attr, value) {
        /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
        const lcTag = transformCaseFunc(tag);
        const lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
    };
    DOMPurify.addHook = function(entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') return;
        /* Reject unknown entry points. Without this, a non-hook key (e.g.
     * '__proto__') indexes off the prototype chain rather than a real
     * hook array, and arrayPush then writes to Object.prototype. Guard
     * with an own-property check against the known hook names. */ if (!$3498e5411d24543d$var$objectHasOwnProperty(hooks, entryPoint)) return;
        $3498e5411d24543d$var$arrayPush(hooks[entryPoint], hookFunction);
    };
    DOMPurify.removeHook = function(entryPoint, hookFunction) {
        if (!$3498e5411d24543d$var$objectHasOwnProperty(hooks, entryPoint)) return undefined;
        if (hookFunction !== undefined) {
            const index = $3498e5411d24543d$var$arrayLastIndexOf(hooks[entryPoint], hookFunction);
            return index === -1 ? undefined : $3498e5411d24543d$var$arraySplice(hooks[entryPoint], index, 1)[0];
        }
        return $3498e5411d24543d$var$arrayPop(hooks[entryPoint]);
    };
    DOMPurify.removeHooks = function(entryPoint) {
        if (!$3498e5411d24543d$var$objectHasOwnProperty(hooks, entryPoint)) return;
        hooks[entryPoint] = [];
    };
    DOMPurify.removeAllHooks = function() {
        hooks = $3498e5411d24543d$var$_createHooksMap();
    };
    return DOMPurify;
}
var $3498e5411d24543d$export$2e2bcd8739ae039 = $3498e5411d24543d$var$createDOMPurify();


// Register languages
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('javascript', (0, $676f4a3d145a5354$export$2e2bcd8739ae039));
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('js', (0, $676f4a3d145a5354$export$2e2bcd8739ae039));
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('python', (0, $75477c3004b71dea$export$2e2bcd8739ae039));
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('c', (0, $104ad11152cd56ac$export$2e2bcd8739ae039));
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('cpp', (0, $c63eafa0a78a3ade$export$2e2bcd8739ae039));
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('c++', (0, $c63eafa0a78a3ade$export$2e2bcd8739ae039));
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('java', (0, $c7926bfa1a55c2ec$export$2e2bcd8739ae039));
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('sql', (0, $1b0c8cb9d63197fa$export$2e2bcd8739ae039));
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('bash', (0, $3fae064f625e78b6$export$2e2bcd8739ae039));
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('sh', (0, $3fae064f625e78b6$export$2e2bcd8739ae039));
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('json', (0, $34512cd73918b228$export$2e2bcd8739ae039));
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('xml', (0, $f619f7324f198cc1$export$2e2bcd8739ae039));
(0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).registerLanguage('html', (0, $f619f7324f198cc1$export$2e2bcd8739ae039));
/**
 * Configure marked with custom options for rendering quiz content
 */ let $ed816e5bec69091b$var$isConfigured = false;
function $ed816e5bec69091b$export$9a15aa55166d053a() {
    if ($ed816e5bec69091b$var$isConfigured) return; // Only configure once
    (0, $42cbc74a64ab0a8d$export$db8f131360c543a5).setOptions({
        breaks: true,
        gfm: true
    });
    // Syntax highlighting via highlight.js
    (0, $42cbc74a64ab0a8d$export$db8f131360c543a5).use((0, $36d15394720e552f$export$546acb8157a2ef40)({
        langPrefix: 'hljs language-',
        highlight (code, lang) {
            try {
                if (lang && (0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).getLanguage(lang)) return (0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).highlight(code, {
                    language: lang
                }).value;
            } catch (e) {
                console.warn('Highlight.js error for language:', lang, e);
            }
            // Fallback to auto-detect or plaintext
            try {
                return (0, $48b9e1a9b2627eb4$export$2e2bcd8739ae039).highlightAuto(code).value;
            } catch (e) {
                console.warn('Highlight.js auto-detect error:', e);
                return $ed816e5bec69091b$export$4cf11838cdc2a8a8(code); // Escape raw code to prevent HTML injection
            }
        }
    }));
    // Math formulas via KaTeX
    (0, $42cbc74a64ab0a8d$export$db8f131360c543a5).use((0, $21c70723b1e34f55$export$2e2bcd8739ae039)({
    }));
    $ed816e5bec69091b$var$isConfigured = true;
}
function $ed816e5bec69091b$export$bd27f0c8b4b4eabc(markdown) {
    $ed816e5bec69091b$export$9a15aa55166d053a();
    const rendered = (0, $42cbc74a64ab0a8d$export$db8f131360c543a5).parse(markdown);
    return (0, $3498e5411d24543d$export$2e2bcd8739ae039).sanitize(rendered, {
        USE_PROFILES: {
            html: true
        },
        FORBID_TAGS: [
            'style',
            'iframe',
            'object',
            'embed',
            'form',
            'input',
            'button'
        ]
    });
}
function $ed816e5bec69091b$export$4cf11838cdc2a8a8(text) {
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, (m)=>map[m]);
}


var $858de0de62ae226f$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mb-2><small class=text-muted>`), $858de0de62ae226f$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=answers-list>`), $858de0de62ae226f$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="mt-3 alert alert-info py-2"><small><strong>Correct answer<!>:</strong> `), $858de0de62ae226f$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="quiz-question-preview card"><div class=card-body><div class="question-content mb-4">`), $858de0de62ae226f$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div style="opacity:0.25;transition:width 0.6s ease-in-out;z-index:0">`), $858de0de62ae226f$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<input type=checkbox class="form-check-input me-3"style=pointer-events:none>`), $858de0de62ae226f$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-success">\u{2713}`), $858de0de62ae226f$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="ms-2 d-flex align-items-center gap-2"><span class="badge bg-dark"> (<!>%)`), $858de0de62ae226f$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div style="transition:all 0.2s;overflow:hidden;min-height:60px"><div class="d-flex align-items-center position-relative"style=z-index:1><div class="flex-fill answer-text">`), $858de0de62ae226f$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<input type=radio class="form-check-input me-3"style=pointer-events:none>`);
function $858de0de62ae226f$export$2e2bcd8739ae039(props) {
    const [selectedAnswers, setSelectedAnswers] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)([]);
    // When initialAnswers changes (e.g., when question changes), update selection
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        if (props.initialAnswers) setSelectedAnswers(props.initialAnswers);
        else setSelectedAnswers([]);
    });
    const handleAnswerClick = (answer)=>{
        if (props.readonly) return;
        let newSelection;
        if (props.question.isMultipleChoice) {
            // Toggle answer in selection
            if (selectedAnswers().includes(answer)) newSelection = selectedAnswers().filter((a)=>a !== answer);
            else newSelection = [
                ...selectedAnswers(),
                answer
            ];
        } else // Single choice: replace selection
        newSelection = [
            answer
        ];
        setSelectedAnswers(newSelection);
        props.onSelect?.(newSelection);
    };
    const isAnswerSelected = (answer)=>{
        return selectedAnswers().includes(answer);
    };
    const getAnswerStats = (answer, index)=>{
        if (!props.results || !props.results.answerStats) return null;
        // Prioritize index-based match since answer text might have formatting differences
        if (props.results.answerStats[index]) return props.results.answerStats[index];
        // Fallback: try to find by exact match
        return props.results.answerStats.find((stat)=>stat.answer === answer) || null;
    };
    return (()=>{
        var _el$ = $858de0de62ae226f$var$_tmpl$4(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return !props.hideChoices;
            },
            get children () {
                return [
                    (()=>{
                        var _el$4 = $858de0de62ae226f$var$_tmpl$(), _el$5 = _el$4.firstChild;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return props.question.isMultipleChoice;
                            },
                            fallback: "Select one answer:",
                            children: "Select all correct answers:"
                        }));
                        return _el$4;
                    })(),
                    (()=>{
                        var _el$6 = $858de0de62ae226f$var$_tmpl$2();
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                            get each () {
                                return props.question.choices;
                            },
                            children: (answer, index)=>{
                                const stats = getAnswerStats(answer, index());
                                const hasResults = !!stats;
                                const isCorrect = stats?.isCorrect || false;
                                return (()=>{
                                    var _el$12 = $858de0de62ae226f$var$_tmpl$9(), _el$14 = _el$12.firstChild, _el$16 = _el$14.firstChild;
                                    _el$12.$$click = ()=>handleAnswerClick(answer);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$12, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        when: hasResults,
                                        get children () {
                                            var _el$13 = $858de0de62ae226f$var$_tmpl$5();
                                            (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$13, `position-absolute top-0 start-0 h-100 ${isCorrect ? 'bg-success' : 'bg-info'}`);
                                            (0, $8863cd8fe199f948$export$314dade334ae905d)((_$p)=>(0, $6258376c5c54faa9$export$36a7c0615a5a1a31)(_el$13, "width", `${stats.percentage}%`));
                                            return _el$13;
                                        }
                                    }), _el$14);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$14, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        get when () {
                                            return props.question.isMultipleChoice;
                                        },
                                        get fallback () {
                                            return (()=>{
                                                var _el$23 = $858de0de62ae226f$var$_tmpl$0();
                                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$23.disabled = props.readonly);
                                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$23.checked = isAnswerSelected(answer));
                                                return _el$23;
                                            })();
                                        },
                                        get children () {
                                            var _el$15 = $858de0de62ae226f$var$_tmpl$6();
                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$15.disabled = props.readonly);
                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$15.checked = isAnswerSelected(answer));
                                            return _el$15;
                                        }
                                    }), _el$16);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$14, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        when: hasResults,
                                        get children () {
                                            var _el$17 = $858de0de62ae226f$var$_tmpl$8(), _el$19 = _el$17.firstChild, _el$20 = _el$19.firstChild, _el$22 = _el$20.nextSibling, _el$21 = _el$22.nextSibling;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$17, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                when: isCorrect,
                                                get children () {
                                                    return $858de0de62ae226f$var$_tmpl$7();
                                                }
                                            }), _el$19);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$19, ()=>stats.count, _el$20);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$19, ()=>stats.percentage.toFixed(1), _el$22);
                                            return _el$17;
                                        }
                                    }), null);
                                    (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                        var _v$ = `answer-option position-relative p-3 mb-2 border rounded ${isAnswerSelected(answer) ? 'border-primary bg-primary bg-opacity-10' : 'border-secondary'} ${props.readonly ? '' : 'cursor-pointer'} ${hasResults && isCorrect ? 'border-success border-2' : ''}`, _v$2 = props.readonly ? 'default' : 'pointer', _v$3 = (0, $ed816e5bec69091b$export$bd27f0c8b4b4eabc)(answer);
                                        _v$ !== _p$.e && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$12, _p$.e = _v$);
                                        _v$2 !== _p$.t && (0, $6258376c5c54faa9$export$36a7c0615a5a1a31)(_el$12, "cursor", _p$.t = _v$2);
                                        _v$3 !== _p$.a && (_el$16.innerHTML = _p$.a = _v$3);
                                        return _p$;
                                    }, {
                                        e: undefined,
                                        t: undefined,
                                        a: undefined
                                    });
                                    return _el$12;
                                })();
                            }
                        }));
                        return _el$6;
                    })()
                ];
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!(!props.hideCorrectAnswers && props.question.correctAnswers))() && props.question.correctAnswers.length > 0;
            },
            get children () {
                var _el$7 = $858de0de62ae226f$var$_tmpl$3(), _el$8 = _el$7.firstChild, _el$9 = _el$8.firstChild, _el$0 = _el$9.firstChild, _el$10 = _el$0.nextSibling, _el$1 = _el$10.nextSibling, _el$11 = _el$9.nextSibling;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, ()=>props.question.correctAnswers.length > 1 && 's', _el$10);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, ()=>props.question.correctAnswers.join(', '), null);
                return _el$7;
            }
        }), null);
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$3.innerHTML = (0, $ed816e5bec69091b$export$bd27f0c8b4b4eabc)(props.question.content));
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);


/**
 * Represents a single quiz question parsed from markdown
 */ function $8b7b1beba5db91de$export$acf1f5b553ed51f0(markdown) {
    const errors = [];
    const questions = [];
    // Split by --- separator
    const rawQuestions = markdown.split(/\n---\n/).map((q)=>q.trim()).filter((q)=>q.length > 0);
    for(let i = 0; i < rawQuestions.length; i++){
        const rawQuestion = rawQuestions[i];
        const questionNum = i + 1;
        // Check for :choice: or :choices:
        const singleChoiceMatch = rawQuestion.match(/:choice:\s*\n((?:^[-X]\s+.+$\n?)+)/im);
        const multipleChoiceMatch = rawQuestion.match(/:choices:\s*\n((?:^[-X]\s+.+$\n?)+)/im);
        if (!singleChoiceMatch && !multipleChoiceMatch) {
            errors.push(`Question ${questionNum}: No answer choices found. Use :choice: or :choices: followed by answer options starting with - or X`);
            continue;
        }
        let choices = [];
        let correctAnswers = [];
        let isMultipleChoice = false;
        let content = rawQuestion;
        const processChoices = (choiceBlock)=>{
            const allChoices = [];
            const correct = [];
            choiceBlock.split('\n').map((line)=>line.trim()).filter((line)=>line.startsWith('-') || line.startsWith('X')).forEach((line)=>{
                const isCorrect = line.startsWith('X');
                const answerText = line.substring(1).trim();
                if (answerText.length > 0) {
                    allChoices.push(answerText);
                    if (isCorrect) correct.push(answerText);
                }
            });
            return {
                choices: allChoices,
                correctAnswers: correct
            };
        };
        if (singleChoiceMatch) {
            // Single choice question
            const choiceBlock = singleChoiceMatch[1];
            const processed = processChoices(choiceBlock);
            choices = processed.choices;
            correctAnswers = processed.correctAnswers;
            if (choices.length === 0) {
                errors.push(`Question ${questionNum}: No valid answer choices found after :choice:`);
                continue;
            }
            if (correctAnswers.length === 0) {
                errors.push(`Question ${questionNum}: No correct answer marked. Use X instead of - to mark the correct answer.`);
                continue;
            }
            if (correctAnswers.length > 1) errors.push(`Question ${questionNum}: Single choice question (:choice:) has multiple correct answers. Consider using :choices: instead.`);
            // Remove the answer section from content
            content = rawQuestion.substring(0, singleChoiceMatch.index).trim();
            isMultipleChoice = false;
        } else if (multipleChoiceMatch) {
            // Multiple choice question
            const choiceBlock = multipleChoiceMatch[1];
            const processed = processChoices(choiceBlock);
            choices = processed.choices;
            correctAnswers = processed.correctAnswers;
            if (choices.length === 0) {
                errors.push(`Question ${questionNum}: No valid answer choices found after :choices:`);
                continue;
            }
            if (correctAnswers.length === 0) {
                errors.push(`Question ${questionNum}: No correct answers marked. Use X instead of - to mark correct answers.`);
                continue;
            }
            // Remove the answer section from content
            content = rawQuestion.substring(0, multipleChoiceMatch.index).trim();
            isMultipleChoice = true;
        }
        questions.push({
            content: content,
            choices: choices,
            correctAnswers: correctAnswers,
            isMultipleChoice: isMultipleChoice
        });
    }
    return {
        questions: questions,
        errors: errors
    };
}


const $734c914869f04fc9$export$89a9a6948996654a = {
    cas: true,
    named: true,
    anonymous: false
};
const $734c914869f04fc9$export$44eb2560dd649001 = {
    mode: 'exact',
    wrongAnswerPenalty: 1
};
function $734c914869f04fc9$export$bb282440ab7ecafa(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return {
        ...$734c914869f04fc9$export$44eb2560dd649001
    };
    const scoring = value;
    return {
        mode: scoring.mode === 'partial' ? 'partial' : 'exact',
        wrongAnswerPenalty: typeof scoring.wrongAnswerPenalty === 'number' && Number.isFinite(scoring.wrongAnswerPenalty) && scoring.wrongAnswerPenalty >= 0 && scoring.wrongAnswerPenalty <= 10 ? scoring.wrongAnswerPenalty : $734c914869f04fc9$export$44eb2560dd649001.wrongAnswerPenalty
    };
}
function $734c914869f04fc9$export$14da9673b84f761d(joinMethods) {
    const normalized = {
        cas: !!joinMethods?.cas,
        named: !!joinMethods?.named,
        anonymous: !!joinMethods?.anonymous
    };
    if (!normalized.cas && !normalized.named && !normalized.anonymous) return {
        ...$734c914869f04fc9$export$89a9a6948996654a
    };
    return normalized;
}
function $734c914869f04fc9$export$e3cc2112e8007770(settingsRaw) {
    if (!settingsRaw) return {};
    try {
        const parsed = JSON.parse(settingsRaw);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
    } catch (_err) {
    // Ignore invalid JSON and fall back to defaults.
    }
    return {};
}
function $734c914869f04fc9$export$8c0f7a88c8b78eb(settingsRaw) {
    const settings = $734c914869f04fc9$export$e3cc2112e8007770(settingsRaw);
    return $734c914869f04fc9$export$14da9673b84f761d(settings.joinMethods || null);
}
function $734c914869f04fc9$export$b742a24107bc7d81(settingsRaw) {
    return $734c914869f04fc9$export$bb282440ab7ecafa($734c914869f04fc9$export$e3cc2112e8007770(settingsRaw).multipleChoiceScoring);
}
function $734c914869f04fc9$export$beec0b6187654157(settingsRaw, scoring) {
    return JSON.stringify({
        ...$734c914869f04fc9$export$e3cc2112e8007770(settingsRaw),
        multipleChoiceScoring: $734c914869f04fc9$export$bb282440ab7ecafa(scoring)
    });
}
function $734c914869f04fc9$export$15d2e42834e9b3b4(settingsRaw, joinMethods) {
    const settings = $734c914869f04fc9$export$e3cc2112e8007770(settingsRaw);
    const nextSettings = {
        ...settings,
        joinMethods: $734c914869f04fc9$export$14da9673b84f761d(joinMethods)
    };
    return JSON.stringify(nextSettings);
}
function $734c914869f04fc9$export$99797ea9b35f18f(joinMethods) {
    return [
        joinMethods.cas,
        joinMethods.named,
        joinMethods.anonymous
    ].filter(Boolean).length;
}
function $734c914869f04fc9$export$2abacbf02732f0b7(authType) {
    if (authType === 'cas') return 'cas';
    if (authType === 'external') return 'named';
    if (authType === 'anonymous') return 'anonymous';
    return null;
}


var $14ab4fb326ec5110$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-danger">Quiz not found. <a href=/manage-quizzes>Return to quiz list`), $14ab4fb326ec5110$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="d-flex justify-content-between align-items-center mb-3"><h2>Edit Quiz</h2><div><button type=button class="btn btn-secondary me-2">Cancel</button><button type=button class="btn btn-primary">`), $14ab4fb326ec5110$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="text-danger mt-1">`), $14ab4fb326ec5110$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="mt-2 ms-4"style=max-width:22rem><label class=form-label for=wrong-answer-penalty>Penalty per wrong choice</label><input id=wrong-answer-penalty class=form-control type=number min=0 max=10 step=any><small class="form-text text-muted">Each correct choice gives 1 share; each wrong choice subtracts this many shares. Divide by the number of correct choices and limit the result to 0\u{2013}1 point. A penalty of 0 ignores wrong choices; 1 cancels one correct choice.`), $14ab4fb326ec5110$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info"style=font-size:13px><strong>Quiz Markdown Syntax:</strong><hr><p class=mb-2><strong>Separate questions:</strong> Use <code>---</code> on its own line</p><p class=mb-2><strong>Single choice:</strong></p><pre class=mb-2 style=font-size:12px;background:#fff;padding:8px>\n# Question Title\n\nSome other text here.\n\n:choice:\n- Wrong answer\nX Correct answer\n- Another wrong answer</pre><p class=mb-2><strong>Multiple choice:</strong></p><pre class=mb-2 style=font-size:12px;background:#fff;padding:8px>\n# Question Title\n\n:choices:\n- Wrong answer\nX Correct answer 1\nX Correct answer 2\n- Wrong answer</pre><p class=mb-2><strong>Formatting:</strong></p><ul class=mb-2 style=font-size:12px><li>Use <code>X</code> for correct answers, <code>-</code> for wrong ones</li><li>Use <strong>**bold**</strong>, <em>*italic*</em>, and other markdown in questions</li><li>Add code blocks with triple backticks: <code>\`\`\`python</code></li><li>Add math formulas: <code>$x^2$</code> (inline) or <code>$$x^2$$</code> (display)`), $14ab4fb326ec5110$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-warning mt-3"><strong>Parser Warnings:</strong><ul class="mb-0 mt-2">`), $14ab4fb326ec5110$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<form><div class=mb-3><label class=form-label>Title</label><input type=text class=form-control required></div><div class=mb-3><label class=form-label>Quiz Code</label><input type=text class=form-control pattern=[A-Z0-9]\{4,10} title="4-10 uppercase letters or numbers"required><small class="form-text text-muted">Students will use this code to join the quiz. State is automatically updated when you show/hide questions.</small></div><div class=mb-3><label class=form-label>Allowed Join Methods</label><div class=form-check><input class=form-check-input type=checkbox id=join-method-cas><label class=form-check-label for=join-method-cas>CAS login</label></div><div class=form-check><input class=form-check-input type=checkbox id=join-method-named><label class=form-check-label for=join-method-named>Student with name</label></div><div class=form-check><input class=form-check-input type=checkbox id=join-method-anonymous><label class=form-check-label for=join-method-anonymous>Anonymous student (random name)</label></div><small class="form-text text-muted">Students joining via <code>/q/&lt;code&gt;</code> will only see these login methods.</small></div><fieldset class=mb-3><legend class="form-label fs-6">Multiple-choice scoring</legend><div class=form-check><input class=form-check-input type=radio name=multiple-choice-scoring id=scoring-exact><label class=form-check-label for=scoring-exact>Exact match: 1 point only when the selected choices match the correct answers</label></div><div class=form-check><input class=form-check-input type=radio name=multiple-choice-scoring id=scoring-partial><label class=form-check-label for=scoring-partial>Partial credit</label></div><small class="form-text text-muted">Single-choice questions always use exact scoring. Existing quizzes use exact scoring until changed here.</small></fieldset><div class="row mb-3"><div class=col-md-6><div class="d-flex justify-content-between align-items-center mb-2"><label class="form-label mb-0">Markdown Content</label><button type=button class="btn btn-sm btn-outline-info"></button></div><textarea class="form-control font-monospace"rows=20 required style=font-size:14px></textarea><small class="form-text text-muted">Write your quiz questions and answers in Markdown format</small></div><div class=col-md-6><label class=form-label>Preview</label><div class="border rounded p-3"style=min-height:400px;background-color:#f8f9fa></div></div></div><div class=mb-3><div class=form-check><input class=form-check-input type=checkbox id=hideQuestionsFromStudents><label class=form-check-label for=hideQuestionsFromStudents>Hide questions from students</label></div><small class="form-text text-muted">If enabled, students won't see the questions on their page. They will see them only on the public display (teacher's slides).`), $14ab4fb326ec5110$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>`), $14ab4fb326ec5110$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="text-muted text-center mt-5"><p>Position your cursor in the markdown editor to preview a question</p><small>Questions are separated by ---`), $14ab4fb326ec5110$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li>`);
function $14ab4fb326ec5110$export$2e2bcd8739ae039() {
    const params = (0, $68cd7f618e77dd88$export$99eaa27ddbbb95ef)();
    const navigate = (0, $68cd7f618e77dd88$export$9770f232ac06a008)();
    const [quizStore, , quizActions] = (0, $69ccc3a2d8e0157f$export$3467042c26dd6dce)();
    const [title, setTitle] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)('');
    const [quizId, setQuizId] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)('');
    const [markdown, setMarkdown] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)('');
    const [settingsRaw, setSettingsRaw] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [joinMethods, setJoinMethods] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)({
        ...(0, $734c914869f04fc9$export$89a9a6948996654a)
    });
    const [multipleChoiceScoring, setMultipleChoiceScoring] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)({
        ...(0, $734c914869f04fc9$export$44eb2560dd649001)
    });
    const [penaltyInput, setPenaltyInput] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)('1');
    const [hideQuestionsFromStudents, setHideQuestionsFromStudents] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [loading, setLoading] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [notFound, setNotFound] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [cursorPosition, setCursorPosition] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(0);
    const [showHelp, setShowHelp] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [joinMethodsError, setJoinMethodsError] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [scoringError, setScoringError] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    let textareaRef;
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        const id = parseInt(params.id ?? '');
        const quiz = quizStore.quizzes.find((q)=>q.id === id);
        if (quiz) {
            setTitle(quiz.title);
            setQuizId(quiz.quizId);
            setMarkdown(quiz.markdown);
            setSettingsRaw(quiz.settings || null);
            setJoinMethods((0, $734c914869f04fc9$export$8c0f7a88c8b78eb)(quiz.settings));
            const scoring = (0, $734c914869f04fc9$export$b742a24107bc7d81)(quiz.settings);
            setMultipleChoiceScoring(scoring);
            setPenaltyInput(String(scoring.wrongAnswerPenalty));
            setJoinMethodsError(null);
            setScoringError(null);
            setHideQuestionsFromStudents(quiz.hideQuestionsFromStudents || false);
            setNotFound(false);
        } else setNotFound(true);
    });
    const toggleJoinMethod = (method)=>{
        const current = joinMethods();
        const next = {
            ...current,
            [method]: !current[method]
        };
        if ((0, $734c914869f04fc9$export$99797ea9b35f18f)(next) === 0) {
            setJoinMethodsError('At least one join method must remain enabled.');
            return;
        }
        setJoinMethods(next);
        setJoinMethodsError(null);
    };
    const handleSave = async ()=>{
        if ((0, $734c914869f04fc9$export$99797ea9b35f18f)(joinMethods()) === 0) {
            setJoinMethodsError('At least one join method must be enabled.');
            return;
        }
        const penalty = Number(penaltyInput());
        if (multipleChoiceScoring().mode === 'partial' && (!penaltyInput().trim() || !Number.isFinite(penalty) || penalty < 0 || penalty > 10)) {
            setScoringError('Enter a penalty between 0 and 10.');
            return;
        }
        setLoading(true);
        const id = parseInt(params.id ?? '');
        const scoring = multipleChoiceScoring();
        try {
            await quizActions.updateQuiz(id, {
                title: title(),
                quizId: quizId(),
                markdown: markdown(),
                settings: (0, $734c914869f04fc9$export$beec0b6187654157)((0, $734c914869f04fc9$export$15d2e42834e9b3b4)(settingsRaw(), joinMethods()), {
                    ...scoring,
                    wrongAnswerPenalty: scoring.mode === 'partial' ? penalty : scoring.wrongAnswerPenalty
                }),
                hideQuestionsFromStudents: hideQuestionsFromStudents()
            });
            navigate('/manage-quizzes');
        } catch (error) {
            alert('Error saving quiz: ' + (error.message || 'Unknown error'));
        } finally{
            setLoading(false);
        }
    };
    const handleCancel = ()=>{
        navigate('/manage-quizzes');
    };
    // Parse markdown and find current question based on cursor position
    const parsedQuiz = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>(0, $8b7b1beba5db91de$export$acf1f5b553ed51f0)(markdown()));
    const currentQuestionIndex = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const text = markdown();
        const cursor = cursorPosition();
        // Find which question block the cursor is in by counting --- separators
        const beforeCursor = text.substring(0, cursor);
        const separatorCount = (beforeCursor.match(/\n---\n/g) || []).length;
        return separatorCount;
    });
    const currentQuestion = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const questions = parsedQuiz().questions;
        const index = currentQuestionIndex();
        return questions[index] || null;
    });
    const handleTextareaInput = (e)=>{
        setMarkdown(e.currentTarget.value);
        setCursorPosition(e.currentTarget.selectionStart);
    };
    const handleTextareaClick = (e)=>{
        setCursorPosition(e.currentTarget.selectionStart);
    };
    const handleTextareaKeyUp = (e)=>{
        setCursorPosition(e.currentTarget.selectionStart);
    };
    return (()=>{
        var _el$ = $14ab4fb326ec5110$var$_tmpl$8();
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return notFound();
            },
            get children () {
                return $14ab4fb326ec5110$var$_tmpl$();
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return !notFound();
            },
            get children () {
                return [
                    (()=>{
                        var _el$3 = $14ab4fb326ec5110$var$_tmpl$2(), _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$5.firstChild, _el$7 = _el$6.nextSibling;
                        _el$6.$$click = handleCancel;
                        _el$7.$$click = handleSave;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, ()=>loading() ? 'Saving...' : 'Save');
                        (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                            var _v$ = loading(), _v$2 = loading();
                            _v$ !== _p$.e && (_el$6.disabled = _p$.e = _v$);
                            _v$2 !== _p$.t && (_el$7.disabled = _p$.t = _v$2);
                            return _p$;
                        }, {
                            e: undefined,
                            t: undefined
                        });
                        return _el$3;
                    })(),
                    (()=>{
                        var _el$8 = $14ab4fb326ec5110$var$_tmpl$7(), _el$9 = _el$8.firstChild, _el$0 = _el$9.firstChild, _el$1 = _el$0.nextSibling, _el$10 = _el$9.nextSibling, _el$11 = _el$10.firstChild, _el$12 = _el$11.nextSibling, _el$13 = _el$10.nextSibling, _el$14 = _el$13.firstChild, _el$15 = _el$14.nextSibling, _el$16 = _el$15.firstChild, _el$17 = _el$15.nextSibling, _el$18 = _el$17.firstChild, _el$19 = _el$17.nextSibling, _el$20 = _el$19.firstChild, _el$22 = _el$19.nextSibling, _el$23 = _el$13.nextSibling, _el$24 = _el$23.firstChild, _el$25 = _el$24.nextSibling, _el$26 = _el$25.firstChild, _el$27 = _el$25.nextSibling, _el$28 = _el$27.firstChild, _el$33 = _el$27.nextSibling, _el$34 = _el$23.nextSibling, _el$35 = _el$34.firstChild, _el$36 = _el$35.firstChild, _el$37 = _el$36.firstChild, _el$38 = _el$37.nextSibling, _el$49 = _el$36.nextSibling, _el$50 = _el$35.nextSibling, _el$51 = _el$50.firstChild, _el$52 = _el$51.nextSibling, _el$56 = _el$34.nextSibling, _el$57 = _el$56.firstChild, _el$58 = _el$57.firstChild;
                        _el$8.addEventListener("submit", (e)=>{
                            e.preventDefault();
                            handleSave();
                        });
                        _el$1.$$input = (e)=>setTitle(e.currentTarget.value);
                        _el$12.$$input = (e)=>setQuizId(e.currentTarget.value.toUpperCase());
                        _el$16.addEventListener("change", ()=>toggleJoinMethod('cas'));
                        _el$18.addEventListener("change", ()=>toggleJoinMethod('named'));
                        _el$20.addEventListener("change", ()=>toggleJoinMethod('anonymous'));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return joinMethodsError();
                            },
                            get children () {
                                var _el$21 = $14ab4fb326ec5110$var$_tmpl$3();
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$21, joinMethodsError);
                                return _el$21;
                            }
                        }), _el$22);
                        _el$26.addEventListener("change", ()=>setMultipleChoiceScoring({
                                ...multipleChoiceScoring(),
                                mode: 'exact'
                            }));
                        _el$28.addEventListener("change", ()=>setMultipleChoiceScoring({
                                ...multipleChoiceScoring(),
                                mode: 'partial'
                            }));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$23, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return multipleChoiceScoring().mode === 'partial';
                            },
                            get children () {
                                var _el$29 = $14ab4fb326ec5110$var$_tmpl$4(), _el$30 = _el$29.firstChild, _el$31 = _el$30.nextSibling;
                                _el$31.$$input = (e)=>{
                                    setPenaltyInput(e.currentTarget.value);
                                    setScoringError(null);
                                };
                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$31.value = penaltyInput());
                                return _el$29;
                            }
                        }), _el$33);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$23, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return scoringError();
                            },
                            get children () {
                                var _el$32 = $14ab4fb326ec5110$var$_tmpl$3();
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, scoringError);
                                return _el$32;
                            }
                        }), _el$33);
                        _el$38.$$click = ()=>setShowHelp(!showHelp());
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$38, ()=>showHelp() ? 'Hide Help' : 'Show Help');
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$35, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return showHelp();
                            },
                            get children () {
                                var _el$39 = $14ab4fb326ec5110$var$_tmpl$5(), _el$40 = _el$39.firstChild, _el$41 = _el$40.nextSibling, _el$42 = _el$41.nextSibling, _el$43 = _el$42.nextSibling, _el$44 = _el$43.nextSibling, _el$45 = _el$44.nextSibling, _el$46 = _el$45.nextSibling, _el$47 = _el$46.nextSibling, _el$48 = _el$47.nextSibling;
                                return _el$39;
                            }
                        }), _el$49);
                        _el$49.$$keyup = handleTextareaKeyUp;
                        _el$49.$$click = handleTextareaClick;
                        _el$49.$$input = handleTextareaInput;
                        var _ref$ = textareaRef;
                        typeof _ref$ === "function" ? (0, $6258376c5c54faa9$export$1f96ae73734a86cc)(_ref$, _el$49) : textareaRef = _el$49;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$52, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return currentQuestion();
                            },
                            get fallback () {
                                return $14ab4fb326ec5110$var$_tmpl$9();
                            },
                            get children () {
                                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $858de0de62ae226f$export$2e2bcd8739ae039), {
                                    get question () {
                                        return currentQuestion();
                                    },
                                    readonly: false,
                                    onSelect: (answers)=>console.log('Preview selected:', answers)
                                });
                            }
                        }), null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$52, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return parsedQuiz().errors.length > 0;
                            },
                            get children () {
                                var _el$53 = $14ab4fb326ec5110$var$_tmpl$6(), _el$54 = _el$53.firstChild, _el$55 = _el$54.nextSibling;
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$55, ()=>parsedQuiz().errors.map((error)=>(()=>{
                                            var _el$60 = $14ab4fb326ec5110$var$_tmpl$0();
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$60, error);
                                            return _el$60;
                                        })()));
                                return _el$53;
                            }
                        }), null);
                        _el$58.addEventListener("change", (e)=>setHideQuestionsFromStudents(e.currentTarget.checked));
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$1.value = title());
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$12.value = quizId());
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$16.checked = joinMethods().cas);
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$18.checked = joinMethods().named);
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$20.checked = joinMethods().anonymous);
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$26.checked = multipleChoiceScoring().mode === 'exact');
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$28.checked = multipleChoiceScoring().mode === 'partial');
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$49.value = markdown());
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$58.checked = hideQuestionsFromStudents());
                        return _el$8;
                    })()
                ];
            }
        }), null);
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click",
    "input",
    "keyup"
]);












var $f41bbde7b79f6121$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=container style=max-width:480px><h2 class=mb-3>Join a Quiz</h2><form class="card p-3"><label class=form-label>Enter quiz code</label><input type=text class=form-control placeholder="e.g. ABC123"pattern=[A-Z0-9]\{4,10} required><button type=submit class="btn btn-primary mt-3">Join`);
function $f41bbde7b79f6121$export$2e2bcd8739ae039() {
    const [code, setCode] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)('');
    const navigate = (0, $68cd7f618e77dd88$export$9770f232ac06a008)();
    const submit = (e)=>{
        e.preventDefault();
        const value = code().trim().toUpperCase();
        if (!value) return;
        navigate(`/q/${value}`);
    };
    return (()=>{
        var _el$ = $f41bbde7b79f6121$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling;
        _el$3.addEventListener("submit", submit);
        _el$5.$$input = (e)=>setCode(e.currentTarget.value.toUpperCase());
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$5.value = code());
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "input"
]);










var $81207ff53b06874f$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-info">Saving...`), $81207ff53b06874f$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div role=progressbar aria-label="Time elapsed"aria-valuemin=0 aria-valuemax=100 style="position:absolute;left:0;bottom:0;width:100%;height:4px;transform-origin:left center;transition:transform 50ms linear;will-change:transform">`), $81207ff53b06874f$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=student-quiz-header style="background-color:#f8f9fa;border-bottom:1px solid #dee2e6;padding:0.75rem 1rem;display:flex;align-items:center;gap:1rem;position:sticky;top:0;z-index:1000"><button class="btn btn-sm btn-outline-secondary"title="Go back to home">\u{2190} Back</button><h5 class="mb-0 flex-grow-1">`), $81207ff53b06874f$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info"><p class=mb-0>Question visible on teacher's display`), $81207ff53b06874f$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="container py-3">`), $81207ff53b06874f$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-danger">Quiz code not found.`), $81207ff53b06874f$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="text-muted mb-3">`), $81207ff53b06874f$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-warning">`), $81207ff53b06874f$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="card p-3"style=max-width:560px><h5 class=mb-2>Join Quiz `), $81207ff53b06874f$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p class=mb-2>Choose how you want to join:`), $81207ff53b06874f$var$_tmpl$1 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button class="btn btn-primary"type=button>Sign in with CAS`), $81207ff53b06874f$var$_tmpl$10 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button class="btn btn-secondary"type=button>Continue with your name`), $81207ff53b06874f$var$_tmpl$11 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button class="btn btn-outline-secondary"type=button>Continue anonymously`), $81207ff53b06874f$var$_tmpl$12 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="d-flex flex-wrap gap-2">`), $81207ff53b06874f$var$_tmpl$13 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="form-text mt-2">Connecting anonymously...`), $81207ff53b06874f$var$_tmpl$14 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button class="btn btn-primary"type=button>Use CAS`), $81207ff53b06874f$var$_tmpl$15 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button class="btn btn-secondary"type=button>Use Student Name`), $81207ff53b06874f$var$_tmpl$16 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button class="btn btn-outline-secondary"type=button>Use Anonymous Login`), $81207ff53b06874f$var$_tmpl$17 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="card p-3"style=max-width:560px><h5 class=mb-2>Cannot Join This Quiz</h5><div class="alert alert-warning mb-2"></div><p class=mb-2>Choose an allowed login method:</p><div class="d-flex flex-wrap gap-2">`), $81207ff53b06874f$var$_tmpl$18 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info">The next question will appear here.`), $81207ff53b06874f$var$_tmpl$19 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-warning">Waiting for question details...`);
function $81207ff53b06874f$export$2e2bcd8739ae039() {
    const params = (0, $68cd7f618e77dd88$export$99eaa27ddbbb95ef)();
    const navigate = (0, $68cd7f618e77dd88$export$9770f232ac06a008)();
    const [userStore, _setUserStore, userActions] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)() || (()=>{
        throw new Error('UserContext not found');
    })();
    const quizCode = ()=>(params.code ?? '').toUpperCase();
    const [state, setState] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [quizTitle, setQuizTitle] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)('');
    const [notFound, setNotFound] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [joinMethods, setJoinMethods] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [joinMethodError, setJoinMethodError] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [isLoadingJoinMethods, setIsLoadingJoinMethods] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(true);
    const [didTryAutoAnonymous, setDidTryAutoAnonymous] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    // Store answers per question index.
    const [answersMap, setAnswersMap] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)({});
    const [isSaving, setIsSaving] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [now, setNow] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(Date.now());
    const timerProgress = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const currentState = state();
        const startedAt = currentState?.phaseStartedAt;
        const endsAt = currentState?.phaseEndsAt;
        if (!startedAt || !endsAt || endsAt <= startedAt) return null;
        const estimatedServerNow = currentState.serverNow && currentState.receivedAt ? currentState.serverNow + (now() - currentState.receivedAt) : now();
        const visualEndsAt = Math.max(startedAt, endsAt - 1000);
        if (visualEndsAt === startedAt) return 100;
        return Math.min(100, Math.max(0, (estimatedServerNow - startedAt) / (visualEndsAt - startedAt) * 100));
    });
    const canJoinWithCAS = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>!!joinMethods()?.cas);
    const canJoinWithNamed = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>!!joinMethods()?.named);
    const canJoinWithAnonymous = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>!!joinMethods()?.anonymous);
    const onlyAnonymousJoin = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>canJoinWithAnonymous() && !canJoinWithCAS() && !canJoinWithNamed());
    // Get current question's saved answers.
    const currentAnswers = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const currentState = state();
        if (!currentState || currentState.questionIndex === null) return [];
        return answersMap()[currentState.questionIndex] || [];
    });
    const handleAnswerSelect = (answers)=>{
        if (!userStore.isAuthenticated) return;
        const currentState = state();
        if (!currentState || currentState.questionIndex === null) return;
        // Update local answers map.
        setAnswersMap((prev)=>({
                ...prev,
                [currentState.questionIndex]: answers
            }));
        // Auto-submit to server.
        setIsSaving(true);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('student-submit-answer', {
            quizCode: quizCode(),
            questionIndex: currentState.questionIndex,
            selectedAnswers: answers
        });
        // Visual feedback that we are saving.
        setTimeout(()=>setIsSaving(false), 500);
    };
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        const code = quizCode();
        setNotFound(false);
        setState(null);
        setJoinMethodError(null);
        setJoinMethods(null);
        setIsLoadingJoinMethods(true);
        setDidTryAutoAnonymous(false);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('quiz-get-join-options', {
            quizCode: code
        });
    });
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        if (userStore.isAuthenticated) {
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('student-join-quiz', {
                quizCode: quizCode()
            });
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('student-get-answers', {
                quizCode: quizCode()
            });
        }
    });
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        if (!userStore.isAuthenticated && !userStore.isAuthenticating && onlyAnonymousJoin() && !didTryAutoAnonymous()) {
            setDidTryAutoAnonymous(true);
            userActions.submitAnonymousLogin();
        }
    });
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        const clock = window.setInterval(()=>setNow(Date.now()), 50);
        const handleQuizNotFound = (data)=>{
            if (data.quizCode === quizCode()) {
                setNotFound(true);
                setIsLoadingJoinMethods(false);
            }
        };
        const handleQuizJoinOptions = (data)=>{
            if (data.quizCode === quizCode()) {
                setQuizTitle(data.quizTitle);
                setJoinMethods(data.joinMethods);
                setIsLoadingJoinMethods(false);
            }
        };
        const handleAuthMethodNotAllowed = (data)=>{
            if (data.quizCode === quizCode()) {
                setJoinMethods(data.joinMethods);
                setJoinMethodError(data.message || 'Your login method is not allowed for this quiz.');
                setState(null);
            }
        };
        const handleLiveQuizState = (s)=>{
            if (s.quizCode === quizCode()) {
                setState({
                    ...s,
                    receivedAt: Date.now()
                });
                setQuizTitle(s.quizTitle);
            }
        };
        const handleLiveQuizUpdate = (s)=>{
            if (s.quizCode === quizCode()) setState({
                ...s,
                receivedAt: Date.now()
            });
        };
        const handleStudentAnswersData = (data)=>{
            if (data.quizCode === quizCode()) setAnswersMap(data.answers);
        };
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('quiz-not-found', handleQuizNotFound);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('quiz-join-options', handleQuizJoinOptions);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('quiz-auth-method-not-allowed', handleAuthMethodNotAllowed);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('live-quiz-state', handleLiveQuizState);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('live-quiz-update', handleLiveQuizUpdate);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('student-answers-data', handleStudentAnswersData);
        (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>{
            window.clearInterval(clock);
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('quiz-not-found', handleQuizNotFound);
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('quiz-join-options', handleQuizJoinOptions);
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('quiz-auth-method-not-allowed', handleAuthMethodNotAllowed);
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('live-quiz-state', handleLiveQuizState);
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('live-quiz-update', handleLiveQuizUpdate);
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('student-answers-data', handleStudentAnswersData);
        });
    });
    return [
        (()=>{
            var _el$ = $81207ff53b06874f$var$_tmpl$3(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling;
            _el$2.$$click = ()=>navigate('/');
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$3, ()=>state()?.quizTitle || quizTitle() || 'Loading quiz...');
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                get when () {
                    return isSaving();
                },
                get children () {
                    return $81207ff53b06874f$var$_tmpl$();
                }
            }), null);
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                get when () {
                    return timerProgress() !== null;
                },
                get children () {
                    var _el$5 = $81207ff53b06874f$var$_tmpl$2();
                    (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                        var _v$ = Math.round(timerProgress()), _v$2 = state()?.status === 'active' ? '#198754' : '#0d6efd', _v$3 = `scaleX(${timerProgress() / 100})`;
                        _v$ !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$5, "aria-valuenow", _p$.e = _v$);
                        _v$2 !== _p$.t && (0, $6258376c5c54faa9$export$36a7c0615a5a1a31)(_el$5, "background-color", _p$.t = _v$2);
                        _v$3 !== _p$.a && (0, $6258376c5c54faa9$export$36a7c0615a5a1a31)(_el$5, "transform", _p$.a = _v$3);
                        return _p$;
                    }, {
                        e: undefined,
                        t: undefined,
                        a: undefined
                    });
                    return _el$5;
                }
            }), null);
            (0, $8863cd8fe199f948$export$314dade334ae905d)((_$p)=>(0, $6258376c5c54faa9$export$1d567c320f4763bc)(_el$, {
                    ...state()?.status === 'stopped' && {
                        "color": "#969696ff"
                    }
                }, _$p));
            return _el$;
        })(),
        (()=>{
            var _el$6 = $81207ff53b06874f$var$_tmpl$5();
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                get when () {
                    return !notFound();
                },
                get fallback () {
                    return $81207ff53b06874f$var$_tmpl$6();
                },
                get children () {
                    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return userStore.isAuthenticated;
                        },
                        get fallback () {
                            return (()=>{
                                var _el$9 = $81207ff53b06874f$var$_tmpl$9(), _el$0 = _el$9.firstChild, _el$1 = _el$0.firstChild;
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$0, quizCode, null);
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                    get when () {
                                        return quizTitle();
                                    },
                                    get children () {
                                        var _el$10 = $81207ff53b06874f$var$_tmpl$7();
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, quizTitle);
                                        return _el$10;
                                    }
                                }), null);
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                    get when () {
                                        return !isLoadingJoinMethods();
                                    },
                                    get fallback () {
                                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $b1a355c10f370609$export$3b0d6d7590275603), {});
                                    },
                                    get children () {
                                        return [
                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                get when () {
                                                    return joinMethodError();
                                                },
                                                get children () {
                                                    var _el$11 = $81207ff53b06874f$var$_tmpl$8();
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$11, joinMethodError);
                                                    return _el$11;
                                                }
                                            }),
                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                get when () {
                                                    return userStore.isAuthenticating;
                                                },
                                                get fallback () {
                                                    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                        get when () {
                                                            return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>userStore.authStage === 'enter-external-name')() && canJoinWithNamed();
                                                        },
                                                        get fallback () {
                                                            return [
                                                                $81207ff53b06874f$var$_tmpl$0(),
                                                                (()=>{
                                                                    var _el$13 = $81207ff53b06874f$var$_tmpl$12();
                                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                                        get when () {
                                                                            return canJoinWithCAS();
                                                                        },
                                                                        get children () {
                                                                            var _el$14 = $81207ff53b06874f$var$_tmpl$1();
                                                                            _el$14.$$click = ()=>userActions.chooseCAS();
                                                                            return _el$14;
                                                                        }
                                                                    }), null);
                                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                                        get when () {
                                                                            return canJoinWithNamed();
                                                                        },
                                                                        get children () {
                                                                            var _el$15 = $81207ff53b06874f$var$_tmpl$10();
                                                                            _el$15.$$click = ()=>userActions.chooseExternal();
                                                                            return _el$15;
                                                                        }
                                                                    }), null);
                                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                                        get when () {
                                                                            return canJoinWithAnonymous();
                                                                        },
                                                                        get children () {
                                                                            var _el$16 = $81207ff53b06874f$var$_tmpl$11();
                                                                            _el$16.$$click = ()=>userActions.submitAnonymousLogin();
                                                                            return _el$16;
                                                                        }
                                                                    }), null);
                                                                    return _el$13;
                                                                })(),
                                                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                                    get when () {
                                                                        return onlyAnonymousJoin();
                                                                    },
                                                                    get children () {
                                                                        return $81207ff53b06874f$var$_tmpl$13();
                                                                    }
                                                                })
                                                            ];
                                                        },
                                                        get children () {
                                                            return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $c21c9bfd7d6ea3c3$export$2e2bcd8739ae039), {
                                                                get allowCASFallback () {
                                                                    return canJoinWithCAS();
                                                                }
                                                            });
                                                        }
                                                    });
                                                },
                                                get children () {
                                                    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $b1a355c10f370609$export$3b0d6d7590275603), {});
                                                }
                                            })
                                        ];
                                    }
                                }), null);
                                return _el$9;
                            })();
                        },
                        get children () {
                            return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                get when () {
                                    return !joinMethodError();
                                },
                                get fallback () {
                                    return (()=>{
                                        var _el$18 = $81207ff53b06874f$var$_tmpl$17(), _el$19 = _el$18.firstChild, _el$20 = _el$19.nextSibling, _el$21 = _el$20.nextSibling, _el$22 = _el$21.nextSibling;
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, joinMethodError);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$22, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                            get when () {
                                                return canJoinWithCAS();
                                            },
                                            get children () {
                                                var _el$23 = $81207ff53b06874f$var$_tmpl$14();
                                                _el$23.$$click = ()=>userActions.chooseCAS();
                                                return _el$23;
                                            }
                                        }), null);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$22, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                            get when () {
                                                return canJoinWithNamed();
                                            },
                                            get children () {
                                                var _el$24 = $81207ff53b06874f$var$_tmpl$15();
                                                _el$24.$$click = ()=>userActions.chooseExternal();
                                                return _el$24;
                                            }
                                        }), null);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$22, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                            get when () {
                                                return canJoinWithAnonymous();
                                            },
                                            get children () {
                                                var _el$25 = $81207ff53b06874f$var$_tmpl$16();
                                                _el$25.$$click = ()=>userActions.submitAnonymousLogin();
                                                return _el$25;
                                            }
                                        }), null);
                                        return _el$18;
                                    })();
                                },
                                get children () {
                                    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        get when () {
                                            return state();
                                        },
                                        get children () {
                                            return [
                                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return state().hideQuestionsFromStudents;
                                                    },
                                                    get children () {
                                                        return $81207ff53b06874f$var$_tmpl$4();
                                                    }
                                                }),
                                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return state().status !== 'hidden';
                                                    },
                                                    get fallback () {
                                                        return $81207ff53b06874f$var$_tmpl$18();
                                                    },
                                                    get children () {
                                                        return [
                                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                                get when () {
                                                                    return !state().hideQuestionsFromStudents;
                                                                },
                                                                get children () {
                                                                    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                                        get when () {
                                                                            return state().question;
                                                                        },
                                                                        get fallback () {
                                                                            return $81207ff53b06874f$var$_tmpl$19();
                                                                        },
                                                                        get children () {
                                                                            return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $858de0de62ae226f$export$2e2bcd8739ae039), {
                                                                                get question () {
                                                                                    return state().question;
                                                                                },
                                                                                get readonly () {
                                                                                    return state().status !== 'active';
                                                                                },
                                                                                onSelect: handleAnswerSelect,
                                                                                hideCorrectAnswers: true,
                                                                                get initialAnswers () {
                                                                                    return currentAnswers();
                                                                                },
                                                                                get hideChoices () {
                                                                                    return state().status === 'shown';
                                                                                }
                                                                            });
                                                                        }
                                                                    });
                                                                }
                                                            }),
                                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                                get when () {
                                                                    return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!state().hideQuestionsFromStudents)() && state().question;
                                                                },
                                                                get children () {
                                                                    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $858de0de62ae226f$export$2e2bcd8739ae039), {
                                                                        get question () {
                                                                            return {
                                                                                ...state().question,
                                                                                content: ''
                                                                            };
                                                                        },
                                                                        get readonly () {
                                                                            return state().status !== 'active';
                                                                        },
                                                                        onSelect: handleAnswerSelect,
                                                                        hideCorrectAnswers: true,
                                                                        get initialAnswers () {
                                                                            return currentAnswers();
                                                                        },
                                                                        get hideChoices () {
                                                                            return state().status === 'shown';
                                                                        }
                                                                    });
                                                                }
                                                            })
                                                        ];
                                                    }
                                                })
                                            ];
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            }));
            return _el$6;
        })()
    ];
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);










var $eb9a6e963e43a40d$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-danger alert-dismissible"><strong>Error:</strong> <button type=button class=btn-close></button><div class=mt-3><a href=/manage-quizzes class="btn btn-primary">Return to Quiz List`), $eb9a6e963e43a40d$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-secondary me-2">Status: `), $eb9a6e963e43a40d$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-info me-2">Question #`), $eb9a6e963e43a40d$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-primary me-2"> s`), $eb9a6e963e43a40d$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="d-flex justify-content-between align-items-center mb-3"><h2>Live Control: </h2><div>`), $eb9a6e963e43a40d$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="row g-3 mb-3"><div class=col-md-6><div class="card border-primary h-100 shadow-sm"><div class="card-body d-flex flex-column justify-content-between"><div><div class="d-flex justify-content-between align-items-center mb-1"><strong class=text-primary>Student Link (give to students)</strong><span class="badge bg-primary font-monospace fs-6"></span></div><div class=mb-2><a target=_blank rel="noopener noreferrer"class="font-monospace small text-break"></a></div><div class="small text-muted">Share this link with students to join and answer questions.</div></div><div class="mt-3 d-flex gap-2"><button type=button></button><a target=_blank rel="noopener noreferrer"class="btn btn-sm btn-outline-primary">Open</a></div></div></div></div><div class=col-md-6><div class="card border-info h-100 shadow-sm"><div class="card-body d-flex flex-column justify-content-between"><div><div class="d-flex justify-content-between align-items-center mb-1"><strong>Public View URL</strong><span class="badge bg-secondary font-monospace">Slides / Projector</span></div><div class=mb-2><a target=_blank rel="noopener noreferrer"class="font-monospace small text-break"></a></div><div class="small text-muted">This URL can be embedded in presentation slides as an iframe.</div></div><div class="mt-3 d-flex gap-2"><button type=button></button><a target=_blank rel="noopener noreferrer"class="btn btn-sm btn-outline-secondary">Open`), $eb9a6e963e43a40d$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<ul class="list-group mb-3">`), $eb9a6e963e43a40d$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="card card-body p-2 mb-3"><div class="small fw-semibold mb-2">Timers for this live session</div><div class="row g-2"><div class=col-6><label class="form-label small mb-1"for=live-question-seconds>Question</label><div class="input-group input-group-sm"><input id=live-question-seconds type=number inputmode=numeric class=form-control min=1 max=3600 placeholder=Manual><span class=input-group-text>s</span></div></div><div class=col-6><label class="form-label small mb-1"for=live-answer-seconds>Answers</label><div class="input-group input-group-sm"><input id=live-answer-seconds type=number inputmode=numeric class=form-control min=1 max=3600 placeholder=Manual><span class=input-group-text>s</span></div></div></div><div class="form-text mt-1">Empty means manual. Changes apply to the next action.`), $eb9a6e963e43a40d$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button class="btn btn-primary btn-lg">Show Question`), $eb9a6e963e43a40d$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="d-flex flex-column gap-2 mb-3">`), $eb9a6e963e43a40d$var$_tmpl$1 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mt-4><h6>Currently Shown to Students`), $eb9a6e963e43a40d$var$_tmpl$10 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=row><div class=col-md-4><h5 class=mb-3>Questions</h5></div><div class=col-md-8><h5 class=mb-3>Preview`), $eb9a6e963e43a40d$var$_tmpl$11 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="container-fluid py-3">`), $eb9a6e963e43a40d$var$_tmpl$12 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="container-fluid py-3"><div class="alert alert-info"><div class="spinner-border spinner-border-sm me-2"role=status><span class=visually-hidden>Loading...`), $eb9a6e963e43a40d$var$_tmpl$13 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info">`), $eb9a6e963e43a40d$var$_tmpl$14 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>Parsing quiz...`), $eb9a6e963e43a40d$var$_tmpl$15 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-info">Shown`), $eb9a6e963e43a40d$var$_tmpl$16 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-success">Active`), $eb9a6e963e43a40d$var$_tmpl$17 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-warning text-dark">Stopped`), $eb9a6e963e43a40d$var$_tmpl$18 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li style=cursor:pointer><div class="d-flex align-items-center gap-2"><span>#</span></div><span class="small text-muted">`), $eb9a6e963e43a40d$var$_tmpl$19 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button class="btn btn-primary">Show choices`), $eb9a6e963e43a40d$var$_tmpl$20 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="d-grid gap-2"role=group><button class="btn btn-outline-warning">Stop Answers</button><button></button><button class="btn btn-outline-secondary">Hide Question`), $eb9a6e963e43a40d$var$_tmpl$21 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info">Select a question to preview.`);
function $eb9a6e963e43a40d$export$2e2bcd8739ae039() {
    const params = (0, $68cd7f618e77dd88$export$99eaa27ddbbb95ef)();
    const [quizStore] = (0, $69ccc3a2d8e0157f$export$3467042c26dd6dce)();
    const [userStore] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)() || (()=>{
        throw new Error('UserContext not found');
    })();
    const quiz = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>quizStore.quizzes.find((q)=>q.id === Number(params.id)));
    const [parsed, setParsed] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [selectedIndex, setSelectedIndex] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [liveState, setLiveState] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [showingResults, setShowingResults] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [error, setError] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [now, setNow] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(Date.now());
    const [questionSeconds, setQuestionSeconds] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [answerSeconds, setAnswerSeconds] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [studentCopied, setStudentCopied] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [publicCopied, setPublicCopied] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const secondsLeft = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const currentState = liveState();
        if (!currentState?.phaseEndsAt) return null;
        const estimatedServerNow = currentState.serverNow && currentState.receivedAt ? currentState.serverNow + (now() - currentState.receivedAt) : now();
        return Math.max(0, Math.ceil((currentState.phaseEndsAt - estimatedServerNow) / 1000));
    });
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        const clock = window.setInterval(()=>setNow(Date.now()), 250);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('live-quiz-state', (s)=>{
            if (quiz() && s.quizCode === quiz().quizId) setLiveState({
                ...s,
                receivedAt: Date.now()
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('live-quiz-update', (s)=>{
            if (quiz() && s.quizCode === quiz().quizId) setLiveState({
                ...s,
                receivedAt: Date.now()
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('public-clear-results', ()=>setShowingResults(false));
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('public-question-results', ()=>setShowingResults(true));
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('quiz-not-available', (data)=>{
            setError(data.message);
        });
        (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>window.clearInterval(clock));
    });
    // Join only after authenticated & quizzes list loaded
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        if (userStore.isAuthenticated && userStore.role === 'admin' && quizStore.quizzes.length > 0) {
            if (quiz()) {
                (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('admin-live-join', {
                    quizId: quiz().id
                });
                const p = (0, $8b7b1beba5db91de$export$acf1f5b553ed51f0)(quiz().markdown);
                setParsed(p);
            }
        }
    });
    const doAction = (action)=>{
        if (!quiz()) return;
        const timers = {
            questionSeconds: questionSeconds(),
            answerSeconds: answerSeconds()
        };
        if (action === 'show') (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('admin-live-action', {
            quizId: quiz().id,
            action: 'show',
            questionIndex: selectedIndex(),
            timers: timers
        });
        else (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('admin-live-action', {
            quizId: quiz().id,
            action: action,
            questionIndex: liveState()?.questionIndex ?? selectedIndex(),
            timers: timers
        });
    };
    const showResults = ()=>{
        if (!quiz()) return;
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('admin-show-results', {
            quizId: quiz().id
        });
        setShowingResults(true);
    };
    const hideResults = ()=>{
        if (!quiz()) return;
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('admin-hide-results', {
            quizId: quiz().id
        });
        setShowingResults(false);
    };
    const toggleResults = ()=>{
        if (showingResults()) hideResults();
        else showResults();
    };
    const studentUrl = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        if (!quiz()) return '';
        const baseUrl = window.location.origin;
        return `${baseUrl}/q/${quiz().quizId}`;
    });
    const publicUrl = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        if (!quiz()) return '';
        const baseUrl = window.location.origin;
        return `${baseUrl}/public/${quiz().quizId}`;
    });
    const copyStudentUrl = ()=>{
        const url = studentUrl();
        if (!url) return;
        navigator.clipboard.writeText(url).then(()=>{
            setStudentCopied(true);
            setTimeout(()=>setStudentCopied(false), 2000);
        }).catch(()=>{
            alert('Student URL: ' + url);
        });
    };
    const copyPublicUrl = ()=>{
        const url = publicUrl();
        if (!url) return;
        navigator.clipboard.writeText(url).then(()=>{
            setPublicCopied(true);
            setTimeout(()=>setPublicCopied(false), 2000);
        }).catch(()=>{
            alert('Public URL: ' + url);
        });
    };
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
        get when () {
            return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!userStore.isAuthenticated)() && userStore.role === 'admin';
        },
        get fallback () {
            return (()=>{
                var _el$58 = $eb9a6e963e43a40d$var$_tmpl$12(), _el$59 = _el$58.firstChild, _el$60 = _el$59.firstChild;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$59, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return userStore.isAuthenticating;
                    },
                    children: "Authenticating..."
                }), null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$59, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!!userStore.isAuthenticated)() && !userStore.isAuthenticating;
                    },
                    children: "You must be logged in to access this page."
                }), null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$59, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!userStore.isAuthenticated)() && userStore.role !== 'admin';
                    },
                    children: "You must be an admin to access this page."
                }), null);
                return _el$58;
            })();
        },
        get children () {
            var _el$ = $eb9a6e963e43a40d$var$_tmpl$11();
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                get when () {
                    return error();
                },
                get children () {
                    var _el$2 = $eb9a6e963e43a40d$var$_tmpl$(), _el$3 = _el$2.firstChild, _el$4 = _el$3.nextSibling, _el$5 = _el$4.nextSibling;
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, error, _el$5);
                    _el$5.$$click = ()=>setError(null);
                    return _el$2;
                }
            }), null);
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                get when () {
                    return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!!error())() && quiz();
                },
                get fallback () {
                    return (()=>{
                        var _el$61 = $eb9a6e963e43a40d$var$_tmpl$13();
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$61, ()=>!quiz() ? 'Loading quizzes...' : 'Joining live session...');
                        return _el$61;
                    })();
                },
                get children () {
                    return [
                        (()=>{
                            var _el$6 = $eb9a6e963e43a40d$var$_tmpl$5(), _el$7 = _el$6.firstChild, _el$8 = _el$7.firstChild, _el$9 = _el$7.nextSibling;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, ()=>quiz().title, null);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                get when () {
                                    return liveState();
                                },
                                get children () {
                                    return [
                                        (()=>{
                                            var _el$0 = $eb9a6e963e43a40d$var$_tmpl$2(), _el$1 = _el$0.firstChild;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$0, ()=>liveState().status, null);
                                            return _el$0;
                                        })(),
                                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                            get when () {
                                                return liveState().questionIndex != null;
                                            },
                                            get children () {
                                                var _el$10 = $eb9a6e963e43a40d$var$_tmpl$3(), _el$11 = _el$10.firstChild;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, ()=>liveState().questionIndex + 1, null);
                                                return _el$10;
                                            }
                                        }),
                                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                            get when () {
                                                return secondsLeft() !== null;
                                            },
                                            get children () {
                                                var _el$12 = $eb9a6e963e43a40d$var$_tmpl$4(), _el$13 = _el$12.firstChild;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$12, secondsLeft, _el$13);
                                                return _el$12;
                                            }
                                        })
                                    ];
                                }
                            }));
                            return _el$6;
                        })(),
                        (()=>{
                            var _el$14 = $eb9a6e963e43a40d$var$_tmpl$6(), _el$15 = _el$14.firstChild, _el$16 = _el$15.firstChild, _el$17 = _el$16.firstChild, _el$18 = _el$17.firstChild, _el$19 = _el$18.firstChild, _el$20 = _el$19.firstChild, _el$21 = _el$20.nextSibling, _el$22 = _el$19.nextSibling, _el$23 = _el$22.firstChild, _el$24 = _el$18.nextSibling, _el$25 = _el$24.firstChild, _el$26 = _el$25.nextSibling, _el$27 = _el$15.nextSibling, _el$28 = _el$27.firstChild, _el$29 = _el$28.firstChild, _el$30 = _el$29.firstChild, _el$31 = _el$30.firstChild, _el$32 = _el$31.nextSibling, _el$33 = _el$32.firstChild, _el$34 = _el$30.nextSibling, _el$35 = _el$34.firstChild, _el$36 = _el$35.nextSibling;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$21, ()=>quiz().quizId);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$23, studentUrl);
                            _el$25.$$click = copyStudentUrl;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$25, ()=>studentCopied() ? "\u2713 Copied" : 'Copy Student Link');
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$33, publicUrl);
                            _el$35.$$click = copyPublicUrl;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$35, ()=>publicCopied() ? "\u2713 Copied" : 'Copy Public URL');
                            (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                var _v$ = studentUrl(), _v$2 = `btn btn-sm ${studentCopied() ? 'btn-success' : 'btn-primary'}`, _v$3 = studentUrl(), _v$4 = publicUrl(), _v$5 = `btn btn-sm ${publicCopied() ? 'btn-success' : 'btn-outline-secondary'}`, _v$6 = publicUrl();
                                _v$ !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$23, "href", _p$.e = _v$);
                                _v$2 !== _p$.t && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$25, _p$.t = _v$2);
                                _v$3 !== _p$.a && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$26, "href", _p$.a = _v$3);
                                _v$4 !== _p$.o && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$33, "href", _p$.o = _v$4);
                                _v$5 !== _p$.i && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$35, _p$.i = _v$5);
                                _v$6 !== _p$.n && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$36, "href", _p$.n = _v$6);
                                return _p$;
                            }, {
                                e: undefined,
                                t: undefined,
                                a: undefined,
                                o: undefined,
                                i: undefined,
                                n: undefined
                            });
                            return _el$14;
                        })(),
                        (()=>{
                            var _el$37 = $eb9a6e963e43a40d$var$_tmpl$10(), _el$38 = _el$37.firstChild, _el$39 = _el$38.firstChild, _el$54 = _el$38.nextSibling, _el$55 = _el$54.firstChild;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$38, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                get when () {
                                    return parsed();
                                },
                                get fallback () {
                                    return $eb9a6e963e43a40d$var$_tmpl$14();
                                },
                                get children () {
                                    return [
                                        (()=>{
                                            var _el$40 = $eb9a6e963e43a40d$var$_tmpl$7();
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$40, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                                get each () {
                                                    return parsed().questions;
                                                },
                                                children: (q, i)=>{
                                                    const isCurrent = ()=>liveState() && liveState().questionIndex === i();
                                                    return (()=>{
                                                        var _el$63 = $eb9a6e963e43a40d$var$_tmpl$18(), _el$64 = _el$63.firstChild, _el$65 = _el$64.firstChild, _el$66 = _el$65.firstChild, _el$70 = _el$64.nextSibling;
                                                        _el$63.$$click = ()=>setSelectedIndex(i());
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$65, ()=>i() + 1, null);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$64, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                            get when () {
                                                                return isCurrent();
                                                            },
                                                            get children () {
                                                                return $eb9a6e963e43a40d$var$_tmpl$15();
                                                            }
                                                        }), null);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$64, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                            get when () {
                                                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!isCurrent())() && liveState().status === 'active';
                                                            },
                                                            get children () {
                                                                return $eb9a6e963e43a40d$var$_tmpl$16();
                                                            }
                                                        }), null);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$64, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                            get when () {
                                                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!isCurrent())() && liveState().status === 'stopped';
                                                            },
                                                            get children () {
                                                                return $eb9a6e963e43a40d$var$_tmpl$17();
                                                            }
                                                        }), null);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$70, ()=>q.isMultipleChoice ? 'Multiple' : 'Single');
                                                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$63, `list-group-item d-flex justify-content-between align-items-center ${selectedIndex() === i() ? 'active' : ''}`));
                                                        return _el$63;
                                                    })();
                                                }
                                            }));
                                            return _el$40;
                                        })(),
                                        (()=>{
                                            var _el$41 = $eb9a6e963e43a40d$var$_tmpl$8(), _el$42 = _el$41.firstChild, _el$43 = _el$42.nextSibling, _el$44 = _el$43.firstChild, _el$45 = _el$44.firstChild, _el$46 = _el$45.nextSibling, _el$47 = _el$46.firstChild, _el$48 = _el$44.nextSibling, _el$49 = _el$48.firstChild, _el$50 = _el$49.nextSibling, _el$51 = _el$50.firstChild;
                                            _el$47.$$input = (e)=>setQuestionSeconds(e.currentTarget.value === '' ? null : Number(e.currentTarget.value));
                                            _el$51.$$input = (e)=>setAnswerSeconds(e.currentTarget.value === '' ? null : Number(e.currentTarget.value));
                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$47.value = questionSeconds() ?? '');
                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$51.value = answerSeconds() ?? '');
                                            return _el$41;
                                        })(),
                                        (()=>{
                                            var _el$52 = $eb9a6e963e43a40d$var$_tmpl$0();
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$52, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                get when () {
                                                    return !liveState() || liveState().status === 'hidden';
                                                },
                                                get fallback () {
                                                    return (()=>{
                                                        var _el$71 = $eb9a6e963e43a40d$var$_tmpl$20(), _el$73 = _el$71.firstChild, _el$74 = _el$73.nextSibling, _el$75 = _el$74.nextSibling;
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$71, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                            get when () {
                                                                return liveState().status === 'shown';
                                                            },
                                                            get children () {
                                                                var _el$72 = $eb9a6e963e43a40d$var$_tmpl$19();
                                                                _el$72.$$click = ()=>doAction('activate');
                                                                return _el$72;
                                                            }
                                                        }), _el$73);
                                                        _el$73.$$click = ()=>doAction('stop');
                                                        _el$74.$$click = toggleResults;
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$74, ()=>showingResults() ? "\u2713 Results Shown" : 'Show Results');
                                                        _el$75.$$click = ()=>doAction('hide');
                                                        (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                                            var _v$7 = !liveState() || liveState().status !== 'active', _v$8 = `btn ${showingResults() ? 'btn-success' : 'btn-outline-success'}`, _v$9 = !liveState() || liveState().questionIndex === null;
                                                            _v$7 !== _p$.e && (_el$73.disabled = _p$.e = _v$7);
                                                            _v$8 !== _p$.t && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$74, _p$.t = _v$8);
                                                            _v$9 !== _p$.a && (_el$74.disabled = _p$.a = _v$9);
                                                            return _p$;
                                                        }, {
                                                            e: undefined,
                                                            t: undefined,
                                                            a: undefined
                                                        });
                                                        return _el$71;
                                                    })();
                                                },
                                                get children () {
                                                    var _el$53 = $eb9a6e963e43a40d$var$_tmpl$9();
                                                    _el$53.$$click = ()=>doAction('show');
                                                    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$53.disabled = selectedIndex() == null);
                                                    return _el$53;
                                                }
                                            }));
                                            return _el$52;
                                        })()
                                    ];
                                }
                            }), null);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$54, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                get when () {
                                    return selectedIndex() != null;
                                },
                                get fallback () {
                                    return $eb9a6e963e43a40d$var$_tmpl$21();
                                },
                                get children () {
                                    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $858de0de62ae226f$export$2e2bcd8739ae039), {
                                        get question () {
                                            return parsed().questions[selectedIndex()];
                                        },
                                        readonly: true
                                    });
                                }
                            }), null);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$54, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                get when () {
                                    return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!(liveState() && liveState().question))() && liveState().questionIndex != null;
                                },
                                get children () {
                                    var _el$56 = $eb9a6e963e43a40d$var$_tmpl$1(), _el$57 = _el$56.firstChild;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$56, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $858de0de62ae226f$export$2e2bcd8739ae039), {
                                        get question () {
                                            return liveState().question;
                                        },
                                        get readonly () {
                                            return liveState().status !== 'active';
                                        }
                                    }), null);
                                    return _el$56;
                                }
                            }), null);
                            return _el$37;
                        })()
                    ];
                }
            }), null);
            return _el$;
        }
    });
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click",
    "input"
]);







var $b070646f54dce84e$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="card border-primary shadow-sm mb-3"role=timer><div class="card-body text-center py-2"><div class="text-muted small text-uppercase fw-semibold"></div><div class="display-4 fw-bold font-monospace"aria-live=off></div></div><div class="progress rounded-0"role=progressbar aria-label="Time remaining"aria-valuemin=0 aria-valuemax=100 style=height:8px><div class=progress-bar>`), $b070646f54dce84e$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-success ms-2">Results loaded (<!> answers)`), $b070646f54dce84e$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="mt-3 text-center"><span class="badge bg-secondary">Status: `), $b070646f54dce84e$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="container py-3">`), $b070646f54dce84e$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-danger">Quiz code not found.`), $b070646f54dce84e$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info text-center">Waiting for the next question...`), $b070646f54dce84e$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-warning">Loading question...`);
function $b070646f54dce84e$export$2e2bcd8739ae039() {
    const params = (0, $68cd7f618e77dd88$export$99eaa27ddbbb95ef)();
    const quizCode = ()=>(params.code ?? '').toUpperCase();
    const [state, setState] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [results, setResults] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [notFound, setNotFound] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [now, setNow] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(Date.now());
    const timer = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const current = state();
        const startedAt = current?.phaseStartedAt;
        const endsAt = current?.phaseEndsAt;
        if (!current || current.status !== 'shown' && current.status !== 'active' || !startedAt || !endsAt || endsAt <= startedAt) return null;
        const serverNow = current.serverNow && current.receivedAt ? current.serverNow + (now() - current.receivedAt) : now();
        const secondsLeft = Math.max(0, Math.ceil((endsAt - serverNow) / 1000));
        const percentLeft = Math.max(0, Math.min(100, (endsAt - serverNow) / (endsAt - startedAt) * 100));
        return {
            secondsLeft: secondsLeft,
            percentLeft: percentLeft
        };
    });
    const formattedTime = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const seconds = timer()?.secondsLeft;
        if (seconds === undefined) return '';
        return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
    });
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        // Create socket connection without authentication
        const newSocket = (0, $523eaa49d3f99bf8$export$841407ceb083bd74)(window.location.origin, {
            autoConnect: false
        });
        const clock = window.setInterval(()=>setNow(Date.now()), 250);
        // Rejoin after reconnecting because Socket.IO rooms belong to the connection.
        newSocket.on('connect', ()=>newSocket.emit('public-join-quiz', {
                quizCode: quizCode()
            }));
        newSocket.on('quiz-not-found', (data)=>{
            if (data.quizCode === quizCode()) setNotFound(true);
        });
        const handleLiveState = (s)=>{
            if (s.quizCode === quizCode()) {
                setResults((current)=>current?.questionIndex === s.questionIndex && s.status !== 'hidden' ? current : null);
                setState({
                    ...s,
                    receivedAt: Date.now()
                });
                setNotFound(false);
            }
        };
        newSocket.on('live-quiz-state', handleLiveState);
        newSocket.on('live-quiz-update', handleLiveState);
        // Listen for results broadcast
        newSocket.on('public-question-results', (data)=>{
            setResults(data);
        });
        // Clear results when question changes
        newSocket.on('public-clear-results', ()=>{
            setResults(null);
        });
        newSocket.connect();
        (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>{
            window.clearInterval(clock);
            newSocket.disconnect();
        });
    });
    return (()=>{
        var _el$ = $b070646f54dce84e$var$_tmpl$4();
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return !notFound();
            },
            get fallback () {
                return $b070646f54dce84e$var$_tmpl$5();
            },
            get children () {
                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return state();
                    },
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return state().status !== 'hidden';
                            },
                            get fallback () {
                                return $b070646f54dce84e$var$_tmpl$6();
                            },
                            get children () {
                                return [
                                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        get when () {
                                            return timer();
                                        },
                                        get children () {
                                            var _el$2 = $b070646f54dce84e$var$_tmpl$(), _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$3.nextSibling, _el$7 = _el$6.firstChild;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$4, ()=>state().status === 'shown' ? 'Choices appear in' : 'Answers close in');
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, formattedTime);
                                            (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                                var _v$ = state().status === 'shown' ? 'Time until choices appear' : 'Time to answer', _v$2 = Math.round(timer().percentLeft), _v$3 = !!(state().status === 'active'), _v$4 = `${timer().percentLeft}%`;
                                                _v$ !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$2, "aria-label", _p$.e = _v$);
                                                _v$2 !== _p$.t && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$6, "aria-valuenow", _p$.t = _v$2);
                                                _v$3 !== _p$.a && _el$7.classList.toggle("bg-success", _p$.a = _v$3);
                                                _v$4 !== _p$.o && (0, $6258376c5c54faa9$export$36a7c0615a5a1a31)(_el$7, "width", _p$.o = _v$4);
                                                return _p$;
                                            }, {
                                                e: undefined,
                                                t: undefined,
                                                a: undefined,
                                                o: undefined
                                            });
                                            return _el$2;
                                        }
                                    }),
                                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        get when () {
                                            return state().question;
                                        },
                                        get fallback () {
                                            return $b070646f54dce84e$var$_tmpl$7();
                                        },
                                        get children () {
                                            return [
                                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return !results();
                                                    },
                                                    get fallback () {
                                                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $858de0de62ae226f$export$2e2bcd8739ae039), {
                                                            get question () {
                                                                return state().question;
                                                            },
                                                            readonly: true,
                                                            hideCorrectAnswers: false,
                                                            get results () {
                                                                return results();
                                                            }
                                                        });
                                                    },
                                                    get children () {
                                                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $858de0de62ae226f$export$2e2bcd8739ae039), {
                                                            get question () {
                                                                return state().question;
                                                            },
                                                            readonly: true,
                                                            hideCorrectAnswers: true,
                                                            get hideChoices () {
                                                                return state().status === 'shown';
                                                            }
                                                        });
                                                    }
                                                }),
                                                (()=>{
                                                    var _el$8 = $b070646f54dce84e$var$_tmpl$3(), _el$9 = _el$8.firstChild, _el$0 = _el$9.firstChild;
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, ()=>state().status, null);
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                        get when () {
                                                            return results();
                                                        },
                                                        get children () {
                                                            var _el$1 = $b070646f54dce84e$var$_tmpl$2(), _el$10 = _el$1.firstChild, _el$12 = _el$10.nextSibling, _el$11 = _el$12.nextSibling;
                                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$1, ()=>results().totalAnswers, _el$12);
                                                            return _el$1;
                                                        }
                                                    }), null);
                                                    return _el$8;
                                                })()
                                            ];
                                        }
                                    })
                                ];
                            }
                        });
                    }
                });
            }
        }));
        return _el$;
    })();
}


var $5a283b6fa3b36b50$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>Unauthorized`), $5a283b6fa3b36b50$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<footer class=footer style=display:none><div class=container><span class=text-muted><a href=http://bramas.fr>bramas.fr</a></span> | <span class=text-muted><a href=#>Se d\xe9connecter`);
function $5a283b6fa3b36b50$var$AdminUsersGuard() {
    const [userStore] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
        get when () {
            return userStore.role === 'admin';
        },
        get fallback () {
            return $5a283b6fa3b36b50$var$_tmpl$();
        },
        get children () {
            return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $dd67cc782607ead6$export$2e2bcd8739ae039), {});
        }
    });
}
function $5a283b6fa3b36b50$var$AdminQuizzesGuard() {
    const [userStore] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
        get when () {
            return userStore.role === 'admin';
        },
        get fallback () {
            return $5a283b6fa3b36b50$var$_tmpl$();
        },
        get children () {
            return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $0fa86f4b51f343a5$export$2e2bcd8739ae039), {});
        }
    });
}
function $5a283b6fa3b36b50$var$QuizEditorGuard() {
    const [userStore] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
        get when () {
            return userStore.role === 'admin';
        },
        get fallback () {
            return $5a283b6fa3b36b50$var$_tmpl$();
        },
        get children () {
            return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $14ab4fb326ec5110$export$2e2bcd8739ae039), {});
        }
    });
}
const $5a283b6fa3b36b50$var$app = document.getElementById('app');
if ($5a283b6fa3b36b50$var$app) (0, $6258376c5c54faa9$export$b3890eb0ae9dca99)(()=>[
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $c3b276e29c1ce2f2$export$2e7f18b06f26b111), {
            get children () {
                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $059fd204a72364ff$export$66cafb854a568b29), {
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $69ccc3a2d8e0157f$export$bacd9ee556842089), {
                            get children () {
                                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$55185c17a0fcbe46), {
                                    root: (0, $b7c5bf68baf10222$export$2e2bcd8739ae039),
                                    get children () {
                                        return [
                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$e7b0ac011bb776c6), {
                                                path: "/",
                                                component: (0, $c76c7b1e9b0586b2$export$2e2bcd8739ae039)
                                            }),
                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$e7b0ac011bb776c6), {
                                                path: "/user-settings",
                                                component: (0, $5de580f0a4763066$export$2e2bcd8739ae039)
                                            }),
                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$e7b0ac011bb776c6), {
                                                path: "/manage-users",
                                                component: ()=>(0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($5a283b6fa3b36b50$var$AdminUsersGuard, {})
                                            }),
                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$e7b0ac011bb776c6), {
                                                path: "/manage-quizzes",
                                                component: ()=>(0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($5a283b6fa3b36b50$var$AdminQuizzesGuard, {})
                                            }),
                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$e7b0ac011bb776c6), {
                                                path: "/quiz/:id/edit",
                                                component: ()=>(0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($5a283b6fa3b36b50$var$QuizEditorGuard, {})
                                            }),
                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$e7b0ac011bb776c6), {
                                                path: "/join",
                                                component: (0, $f41bbde7b79f6121$export$2e2bcd8739ae039)
                                            }),
                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$e7b0ac011bb776c6), {
                                                path: "/q/:code",
                                                component: (0, $81207ff53b06874f$export$2e2bcd8739ae039)
                                            }),
                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$e7b0ac011bb776c6), {
                                                path: "/admin/live/:id",
                                                component: (0, $eb9a6e963e43a40d$export$2e2bcd8739ae039)
                                            }),
                                            (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $68cd7f618e77dd88$export$e7b0ac011bb776c6), {
                                                path: "/public/:code",
                                                component: (0, $b070646f54dce84e$export$2e2bcd8739ae039)
                                            })
                                        ];
                                    }
                                });
                            }
                        });
                    }
                });
            }
        }),
        (()=>{
            var _el$4 = $5a283b6fa3b36b50$var$_tmpl$2(), _el$5 = _el$4.firstChild, _el$6 = _el$5.firstChild, _el$7 = _el$6.nextSibling, _el$8 = _el$7.nextSibling, _el$9 = _el$8.firstChild;
            _el$9.$$click = ()=>{};
            return _el$4;
        })()
    ], $5a283b6fa3b36b50$var$app);
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);


//# sourceMappingURL=client.6157a105.js.map
